define('common-modules/behaviors/templates/char-countdown.tpl.html', [], function () {
    return '<div class="adb-js-maxlength-count"><%-count%></div>\n\n';
});
define('common-modules/behaviors/char-countdown', ['common-modules/behaviors/templates/char-countdown.tpl.html'], function (template) {
    'use strict';
    var CharCountdown = Marionette.Behavior.extend({
        template: _.template(template),
        initialize: function (options) {
            this.count = options.count;
        },
        defaults: { count: '0' },
        onRender: function () {
            this._renderCounter();
        },
        _renderCounter: function () {
            this.unbindEvents();
            this.getContainer().addClass('adb-js-maxlength adb-js-maxlength-textarea');
            this.getContainer().append(this.template(this.options));
            this.bindEvents();
        },
        _getElement: function (opt, defaultValue) {
            var elem;
            if (_.isFunction(opt)) {
                elem = opt.apply(this.view);
            } else if (opt) {
                elem = this.$(opt);
            } else {
                elem = defaultValue;
            }
            return elem;
        },
        bindEvents: function () {
            var totalCount = parseInt(this.count, 10);
            var containerElem = this.getContainer();
            var inputElem = this.getInput();
            var counterElem = this.getCounter();
            function onChangeInputElem() {
                counterElem.text(totalCount - inputElem.val().length);
            }
            function onFocusInputElem() {
                containerElem.addClass('adb-is-focused');
                counterElem.addClass('adb-is-active');
            }
            function onBlurInputElem() {
                containerElem.removeClass('adb-is-focused');
                counterElem.removeClass('adb-is-active');
            }
            this.getInput().on('input', onChangeInputElem);
            this.getInput().on('focus', onFocusInputElem);
            this.getInput().on('blur', onBlurInputElem);
            onChangeInputElem();
        },
        unbindEvents: function () {
            this.getInput().off('input');
            this.getInput().off('focus');
            this.getInput().off('blur');
        },
        getContainer: function () {
            return this._getElement(this.options.container, this.$el);
        },
        getInput: function () {
            return this._getElement(this.options.input, this.$('textarea'));
        },
        getCounter: function () {
            return this.getContainer().find('.adb-js-maxlength-count');
        }
    });
    return CharCountdown;
});
define('common-modules/behaviors/templates/complex-tooltip.tpl.html', [], function () {
    return '<div class="adb-complex_tooltip adb-js-dialog" data-placement="<%- placement %>">\n\t<div class="adb-complex_tooltip--content complex-tooltip-container"><%= template %></div>\n</div>\n';
});
define('common-modules/utils/tooltip-util', [], function () {
    'use strict';
    var PLACEMENTS = {
            TOP: 'top',
            TOP_LEFT: 'top-left',
            TOP_RIGHT: 'top-right',
            BOTTOM: 'bottom',
            BOTTOM_LEFT: 'bottom-left',
            BOTTOM_RIGHT: 'bottom-right',
            LEFT: 'left',
            LEFT_TOP: 'left-top',
            LEFT_BOTTOM: 'left-bottom',
            RIGHT: 'right',
            RIGHT_TOP: 'right-top',
            RIGHT_BOTTOM: 'right-bottom',
            DYNAMIC_TOP_DOWN: 'dynamic-top-down'
        }, DYNAMIC_PLACEMENTS = { TOP_DOWN: 'top-down' }, MARGIN_SIZE = 14;
    return {
        calculateTopPosition: function (placement, $container, $tooltip) {
            var containerTop = $container.offset().top;
            switch (placement) {
            case PLACEMENTS.TOP:
            case PLACEMENTS.TOP_LEFT:
            case PLACEMENTS.TOP_RIGHT:
                return containerTop - ($tooltip.outerHeight() + MARGIN_SIZE);
            case PLACEMENTS.BOTTOM:
            case PLACEMENTS.BOTTOM_LEFT:
            case PLACEMENTS.BOTTOM_RIGHT:
                return containerTop + ($container.outerHeight() + MARGIN_SIZE);
            case PLACEMENTS.LEFT:
            case PLACEMENTS.RIGHT:
                return containerTop + ($container.outerHeight() / 2 - $tooltip.outerHeight() / 2);
            case PLACEMENTS.LEFT_TOP:
            case PLACEMENTS.RIGHT_TOP:
                return containerTop;
            case PLACEMENTS.LEFT_BOTTOM:
            case PLACEMENTS.RIGHT_BOTTOM:
                return containerTop + ($container.outerHeight() - $tooltip.outerHeight());
            default:
                return containerTop;
            }
        },
        calculateTriggerLeft: function ($container) {
            return $container.offset().left;
        },
        calculateLeftPosition: function (placement, $container, $tooltip) {
            var triggerLeft = this.calculateTriggerLeft($container);
            switch (placement) {
            case PLACEMENTS.LEFT:
            case PLACEMENTS.LEFT_BOTTOM:
            case PLACEMENTS.LEFT_TOP:
                return triggerLeft - ($tooltip.outerWidth() + MARGIN_SIZE);
            case PLACEMENTS.RIGHT:
            case PLACEMENTS.RIGHT_BOTTOM:
            case PLACEMENTS.RIGHT_TOP:
                return triggerLeft + ($container.outerWidth() + MARGIN_SIZE);
            case PLACEMENTS.TOP:
            case PLACEMENTS.BOTTOM:
                return triggerLeft - ($tooltip.outerWidth() / 2 - $container.outerWidth() / 2);
            case PLACEMENTS.TOP_LEFT:
            case PLACEMENTS.BOTTOM_LEFT:
                return triggerLeft;
            case PLACEMENTS.TOP_RIGHT:
            case PLACEMENTS.BOTTOM_RIGHT:
                return triggerLeft + ($container.outerWidth() - $tooltip.outerWidth());
            default:
                return triggerLeft;
            }
        },
        calculateDynamicPlacement: function (dynamicPlacement, $container, $tooltip) {
            switch (dynamicPlacement) {
            case DYNAMIC_PLACEMENTS.TOP_DOWN:
                return this.calculatePlacementTopOrDown($container, $tooltip);
            default:
                return this.calculatePlacementTopOrDown($container, $tooltip);
            }
        },
        calculatePlacementTopOrDown: function ($container, $tooltip) {
            var maxTooltipHeight = $tooltip.height(), tooltipBottom = $container.offset().top + maxTooltipHeight + 100, fold = $(window).scrollTop() + $(window).height();
            return tooltipBottom >= fold ? PLACEMENTS.TOP : PLACEMENTS.BOTTOM;
        },
        PLACEMENTS: PLACEMENTS,
        DYNAMIC_PLACEMENTS: DYNAMIC_PLACEMENTS,
        MARGIN_SIZE: MARGIN_SIZE,
        EVENTS: {
            HOVER: 'mouseenter mouseleave',
            CLICK: 'click'
        }
    };
});
define('common-modules/behaviors/complex-tooltip', [
    'common-modules/behaviors/templates/complex-tooltip.tpl.html',
    'common-modules/utils/tooltip-util'
], function (template, TooltipUtil) {
    'use strict';
    var ComplexTooltip = Marionette.Behavior.extend({
        template: _.template(template),
        initialize: function () {
            this.cid = _.uniqueId('behavior');
            this._bodyContainer = _.memoize(this._bodyContainer);
        },
        defaults: function () {
            return {
                placement: TooltipUtil.PLACEMENTS.TOP,
                container: null,
                template: _.template(''),
                serializeData: null,
                event: this.constructor.EVENTS.HOVER,
                allowShow: function () {
                    return true;
                },
                autoWidth: false,
                scrollable: false,
                onToggle: null
            };
        },
        _isClickEvent: function () {
            return this.options.event === this.constructor.EVENTS.CLICK;
        },
        _bodyContainer: function () {
            var container = $('<div class="adb-styled"></div>');
            $('body').append(container);
            return container;
        },
        _disableTooltipScrolling: function () {
            this.getTooltip().removeClass('adb-is-scrollable');
        },
        updatePosition: function () {
            var placement = this.options.placement, $container = this.getContainer(), $tooltip = this.getTooltip(), top;
            this._disableTooltipScrolling();
            if (this.options.scrollable && this._isContentTallerThanViewportThreshold()) {
                top = '';
                this.getTooltip().addClass('adb-is-scrollable');
            } else {
                top = TooltipUtil.calculateTopPosition(placement, $container, $tooltip);
            }
            this.getTooltip().css({
                top: top,
                left: TooltipUtil.calculateLeftPosition(placement, $container, $tooltip)
            });
        },
        updateDynamicPlacement: function () {
            if (this.options.dynamicPlacement) {
                var dynamicPlacement = this.options.dynamicPlacement, $container = this.getContainer(), $tooltip = this.getTooltip();
                this.options.placement = TooltipUtil.calculateDynamicPlacement(dynamicPlacement, $container, $tooltip);
                this.renderTooltip();
            }
        },
        toggle: function (e) {
            this._toggle(e);
        },
        toggleWithoutEvent: function () {
            if (this.options.allowShow.call(this.view, null)) {
                this[this.isShown() ? 'hide' : 'show']();
            } else {
                this.hide();
            }
        },
        _toggle: function (e) {
            if (this.options.onToggle && this.options.onToggle.call(this, e) === false) {
                return;
            }
            e.preventDefault();
            if (this.options.allowShow.call(this.view, e)) {
                this[this.isShown() ? 'hide' : 'show']();
            } else {
                this.hide();
            }
        },
        show: function () {
            this.updateDynamicPlacement();
            this.updatePosition();
            this.getTooltip().addClass('adb-is-active').show();
            if (this._isClickEvent()) {
                _.defer(_.bind(function () {
                    $(document).one('click.' + this.cid, _(this.hide).bind(this));
                }, this));
                this.getContainer().addClass('adb-is-active');
            }
        },
        hide: function () {
            this.getTooltip().removeClass('adb-is-active').hide();
            if (this._isClickEvent()) {
                this.getContainer().removeClass('adb-is-active');
            }
        },
        isShown: function () {
            return this.getTooltip().is(':visible');
        },
        getContainer: function () {
            return this.options.container ? this.$(this.options.container) : $(this.$el);
        },
        getTooltip: function () {
            return this.$tooltip;
        },
        removeTooltip: function () {
            var $tooltip = this.getTooltip();
            if ($tooltip) {
                $tooltip.remove();
            }
        },
        bindEvents: function () {
            var container = this.getContainer();
            _.each(this.options.event.split(' '), _.bind(function (event) {
                container.on(event + '.' + this.cid, _(this.toggle).bind(this));
            }, this));
            this.getTooltip().on('click', '[data-dismiss="dialog"], .adb-close', _(this.hide).bind(this));
            if (this._isClickEvent()) {
                $(window).on('resize.' + this.cid, _(this.updatePosition).bind(this));
            }
        },
        unbindEvents: function () {
            _.each(this.options.event.split(' '), _.bind(function (event) {
                this.getContainer().off(event + '.' + this.cid);
            }, this));
            if (this.getTooltip()) {
                this.getTooltip().off('click');
            }
            $(window).off('resize.' + this.cid);
            $(document).off('click.' + this.cid);
        },
        serializeData: function () {
            if (this.options.serializeData) {
                return this.options.serializeData.call(this.view);
            }
            return this.view.serializeData();
        },
        onRender: function () {
            this.renderTooltip();
        },
        onShow: function () {
            this.renderTooltip();
        },
        onHide: function () {
            this.hide();
        },
        onToggle: function () {
            this._toggle(null);
        },
        renderTooltip: function () {
            this.removeTooltip();
            this.unbindEvents();
            this.$tooltip = $(this.template({
                placement: this.options.placement,
                template: _.isString(this.options.template) ? this.options.template : this.options.template(this.serializeData())
            }));
            if (this.options.autoWidth) {
                this.getTooltip().css({ width: 'auto' });
            }
            this._bodyContainer().append(this.$tooltip);
            this.bindEvents();
        },
        onBeforeClose: function () {
            this.removeTooltip();
            this.unbindEvents();
            this._bodyContainer().remove();
        },
        _isContentTallerThanViewportThreshold: function () {
            var viewportHeight = $(window).height(), contentHeight = this.getTooltip().innerHeight();
            return contentHeight / viewportHeight > this.constructor.VIEWPORT_THRESHOLD;
        }
    }, {
        EVENTS: TooltipUtil.EVENTS,
        PLACEMENTS: TooltipUtil.PLACEMENTS,
        VIEWPORT_THRESHOLD: 0.7
    });
    return ComplexTooltip;
});
define('common-modules/behaviors/infinite-scroll', [], function () {
    'use strict';
    return Marionette.Behavior.extend({
        events: { scroll: 'onScroll' },
        onScroll: function () {
            var el = this.$el;
            if (el.scrollTop() + el.innerHeight() >= el[0].scrollHeight) {
                this.view.collection.page += 1;
                this.view.collection.fetchCurrentPage();
            }
        }
    });
});
define('common-modules/containers/views/alert', [], function () {
    'use strict';
    var TextView = Marionette.ItemView.extend({
        tagName: 'p',
        template: _.template('<%=content%>'),
        serializeData: function () {
            return { content: this.options.content };
        }
    });
    var ENTER = 13;
    return Marionette.Layout.extend({
        regions: {
            contentRegion: '.js-content',
            menuRegion: '.js-menu'
        },
        template: _.template('<div class="<%-divClass%>">' + '<h3 class="alert-title"><%=title%></h3>' + '<div class="js-content"></div>' + '<a class="adb-<%-global%>_alert--close adb-js-alert--close alert-close" title="<%-close%>" tabindex="0" role="button"></a>' + '</div>' + '<div class="js-menu adb-<%- global %>_alert--buttons"></div>'),
        elClassName: function (global, type) {
            var classes = 'adb-' + global + '_alert';
            if (type) {
                classes += ' adb-' + global + '_alert__' + type;
            }
            return classes;
        },
        events: {
            'click a': 'onActionClick',
            'click button': 'onActionClick',
            'click .adb-js-alert--close': 'close',
            'keydown .adb-js-alert--close': 'closeViaKeyboard'
        },
        ui: {
            title: '.alert-title',
            menu: '.js-menu',
            closeButton: '.alert-close'
        },
        initialize: function (options) {
            this.type = options.type || '';
            this.title = options.title;
            this.content = options.content;
            this.global = !!options.global;
            this.actionRequired = !!options.actionRequired;
            this.toolbarView = options.toolbarView;
        },
        onRender: function () {
            this.$el.addClass(this._getElClass());
            this.$('a:not(".adb-js-alert--close")').addClass(this.global ? 'adb-global_alert--link' : 'adb-local_alert--link');
            if (!this.title) {
                this.ui.title.remove();
            }
            if (!this.toolbarView) {
                this.ui.menu.remove();
            }
            if (this.actionRequired) {
                this.ui.closeButton.remove();
            }
            if (this.content instanceof Marionette.View) {
                this.contentRegion.show(this.content);
            } else {
                this.contentRegion.show(new TextView({ content: this.content }));
            }
            if (this.toolbarView) {
                this.menuRegion.show(this.toolbarView);
                this.listenToOnce(this.toolbarView, 'close', this.close);
            }
        },
        _getElClass: function () {
            var baseClass = this.global ? 'global' : 'local';
            return this.elClassName(baseClass, this.type);
        },
        onActionClick: function (e) {
            var event = $(e.currentTarget).data('event');
            if (event) {
                this.trigger(event);
                return false;
            }
        },
        closeViaKeyboard: function (e) {
            if (e.keyCode === ENTER) {
                e.preventDefault();
                this.close();
            }
        },
        serializeData: function () {
            return {
                content: this.content,
                divClass: this.global ? 'adb-global_alert--content adb-layout-default' : 'adb-local_alert--content',
                global: this.global ? 'global' : 'local',
                close: l('close'),
                title: this.title
            };
        }
    });
});
define('common-modules/containers/models/alert', [], function () {
    'use strict';
    return Backbone.Model.extend({
        update: function (type, content, title) {
            return this.set({
                type: type,
                content: content,
                title: title
            });
        }
    });
});
define('common-modules/behaviors/alert', [
    'common-modules/containers/views/alert',
    'common-modules/containers/models/alert'
], function (Alert, AlertModel) {
    'use strict';
    return Marionette.Behavior.extend({
        defaults: {
            alertModel: 'alertModel',
            alertRegion: 'alertRegion',
            createModel: false,
            bindModel: false
        },
        initialize: function () {
            if (this.options.bindModel) {
                var model;
                if (this.options.createModel) {
                    model = this.view[this.options.alertModel] = new AlertModel();
                } else {
                    model = this.view.options[this.options.alertModel];
                }
                this.listenTo(model, 'change', this.onRenderAlert);
            }
        },
        onRender: function () {
            this.onRenderAlert();
        },
        onRenderAlert: function () {
            var model = this.view[this.options.alertModel].toJSON();
            if (_.isEmpty(model.title) && _.isEmpty(model.content) && _.isEmpty(model.buttons)) {
                this.view[this.options.alertRegion].close();
                return;
            }
            this.view[this.options.alertRegion].show(new Alert(this.view[this.options.alertModel].toJSON()));
        }
    });
});
define('common-modules/behaviors/loading', [], function () {
    'use strict';
    var Loading = Marionette.Behavior.extend({
        template: '<div class="loading-overlay-container"><span class="adb-loading loading-overlay"></span></div>',
        initialize: function () {
            this._getFullPageContainer = _.memoize(this._getFullPageContainer);
            this.bindCustomModels();
        },
        defaults: function () {
            return {
                bind: null,
                bindModel: false,
                bindCollection: false,
                size: this.constructor.SIZE.SMALL,
                container: null,
                toggleContainer: false,
                fullPage: false
            };
        },
        _getCustomModelNames: function () {
            var modelNames = this.options.bind || [];
            modelNames = _.isArray(modelNames) ? modelNames : [modelNames];
            if (this.options.bindModel) {
                modelNames.push('model');
            }
            if (this.options.bindCollection) {
                modelNames.push('collection');
            }
            return modelNames;
        },
        toggleCustomModelsEvents: function (bind) {
            var modelNames = this._getCustomModelNames();
            var method = bind ? 'bindEntityEvents' : 'unbindEntityEvents';
            _(modelNames).each(function (modelName) {
                Marionette[method](this, this.view.options[modelName], this.syncBindings);
            }, this);
        },
        bindCustomModels: function () {
            this.syncedModelsMap = {};
            _(this._getCustomModelNames()).each(function (modelName) {
                this.syncedModelsMap[this.view.options[modelName]._listenerId] = true;
            }, this);
            this.toggleCustomModelsEvents(true);
        },
        unbindCustomModels: function () {
            this.toggleCustomModelsEvents(false);
        },
        syncBindings: {
            request: 'onModelRequest',
            sync: 'onModelSync',
            error: 'onModelSync',
            destroy: 'onModelDestroy'
        },
        onModelRequest: function (model) {
            this.syncedModelsMap[model._listenerId] = false;
            this.onShowLoading();
        },
        onModelSync: function (model) {
            this.syncedModelsMap[model._listenerId] = true;
            this.maybeHideLoading();
        },
        onModelDestroy: function (model) {
            delete this.syncedModelsMap[model._listenerId];
            this.maybeHideLoading();
        },
        maybeHideLoading: function () {
            if (_.every(this.syncedModelsMap)) {
                this.onHideLoading();
            }
        },
        onShowLoading: function () {
            if (this.isShown && this.options.fullPage !== true) {
                this.removeLoadingElement();
            }
            this.isShown = true;
            if (this.stackLoader())
                return;
            var container = this.getContainer();
            container.append(this.template);
            this.renderSize();
            this.relativizeElement();
            if (this.options.fullPage)
                this.fixLoader();
            if (this.options.toggleContainer)
                container.show();
        },
        stackLoader: function () {
            return this.options.fullPage ? this.constructor.fullPageInstances++ > 0 : false;
        },
        unstackLoader: function () {
            return this.options.fullPage ? this.constructor.fullPageInstances-- === 1 : true;
        },
        fixLoader: function () {
            this.getContainer().children('.loading-overlay-container').css('position', 'fixed');
        },
        onShow: function () {
            if (this.isShown)
                this.relativizeElement();
        },
        renderSize: function () {
            this.getContainer().children('.loading-overlay-container').css('font-size', this.options.size);
        },
        relativizeElement: function () {
            this.getContainer().css('position', 'relative');
        },
        removeLoadingElement: function () {
            this.getContainer().children('.loading-overlay-container').remove();
        },
        getContainer: function () {
            if (this.options.fullPage) {
                return this._getFullPageContainer();
            }
            return this.options.container ? this.$(this.options.container) : this.$el;
        },
        onHideLoading: function () {
            this.isShown = false;
            if (!this.unstackLoader())
                return;
            this.removeLoadingElement();
            if (this.options.toggleContainer)
                this.getContainer().hide();
        },
        onBeforeClose: function () {
            if (this.options.fullPage) {
                this.getContainer().remove();
            }
            this.unbindCustomModels();
        },
        _getFullPageContainer: function () {
            return $('<div class="adb-styled"></div>').appendTo('body');
        }
    }, {
        SIZE: {
            SMALL: '12px',
            MEDIUM: '24px',
            LARGE: '48px'
        },
        fullPageInstances: 0
    });
    return Loading;
});
define('common-modules/behaviors/templates/simple-tooltip.tpl.html', [], function () {
    return '<div class="adb-tooltip adb-tooltip__<%- placement %>">\n\t<div class="adb-tooltip__<%- placement %>--arrow"></div>\n\t<div class="adb-tooltip__<%- placement %>--content content"></div>\n</div>';
});
define('noconflict-bootstrap-tooltip', ['common-thirdparty/bootstrap-tooltip'], function () {
    var BootstrapTooltips = $.fn.tooltip.noConflict();
    var NoConflictTooltips = function (element, options) {
        this.init('bstooltip', element, options);
    };
    NoConflictTooltips.prototype = _.extend({ constructor: NoConflictTooltips }, BootstrapTooltips.Constructor.prototype);
    $.fn.bstooltip = function (option) {
        return this.each(function () {
            var $this = $(this), data = $this.data('bstooltip'), options = typeof option == 'object' && option;
            if (!data)
                $this.data('bstooltip', data = new NoConflictTooltips(this, options));
            if (typeof option == 'string')
                data[option]();
        });
    };
    $.fn.bstooltip.defaults = BootstrapTooltips.defaults;
});
define('common-modules/behaviors/simple-tooltip', [
    'common-modules/behaviors/templates/simple-tooltip.tpl.html',
    'noconflict-bootstrap-tooltip'
], function (template) {
    'use strict';
    var SimpleTooltip = Marionette.Behavior.extend({
        template: _.template(template),
        initialize: function () {
            this._bodyContainer = _.memoize(this._bodyContainer);
        },
        defaults: function () {
            return {
                container: null,
                placement: this.constructor.PLACEMENTS.TOP,
                message: '',
                isDisabled: false,
                autoWidth: false
            };
        },
        onTooltipEnable: function () {
            this.renderTooltip();
        },
        onTooltipDisable: function () {
            this.destroyTooltip();
        },
        onRender: function () {
            if (this.options.isDisabled === true || _.isFunction(this.options.isDisabled) && this.options.isDisabled.call(this.view)) {
                return;
            }
            this.renderTooltip();
        },
        onShow: function () {
            if (this.options.manualTrigger) {
                this.setupManualTrigger();
            }
        },
        _bodyContainer: function () {
            var container = $('<div class="adb-styled"></div>');
            $('body').append(container);
            return container;
        },
        getTrigger: function () {
            return this.options.manualTrigger ? 'manual' : 'hover focus';
        },
        renderTooltip: function () {
            this.getContainer().bstooltip({
                title: _.isFunction(this.options.message) ? this.options.message.call(this.view) : this.options.message,
                container: this._bodyContainer(),
                placement: this.options.placement,
                template: this.template(this.options),
                trigger: this.getTrigger()
            });
            if (this.options.autoWidth) {
                this.getTooltip().css({ width: 'auto' });
            }
        },
        getContainer: function () {
            var container;
            if (_.isFunction(this.options.container)) {
                container = this.options.container.apply(this.view);
            } else if (this.options.container) {
                container = this.$(this.options.container);
            } else {
                container = this.$el;
            }
            return container;
        },
        onBeforeClose: function () {
            this.destroyTooltip();
            this._bodyContainer().remove();
        },
        setupManualTrigger: function () {
            var $tooltip = this.getContainer();
            this.$(this.options.manualTrigger).mouseenter(function () {
                $tooltip.bstooltip('show');
            }).mouseleave(function () {
                $tooltip.bstooltip('hide');
            });
        },
        destroyTooltip: function () {
            var container = this.getContainer();
            if (container) {
                container.bstooltip('destroy');
            }
            this.$(this.options.manualTrigger).unbind();
        }
    }, {
        PLACEMENTS: {
            TOP: 'top',
            BOTTOM: 'bottom',
            LEFT: 'left',
            RIGHT: 'right'
        }
    });
    return SimpleTooltip;
});
define('common-modules/behaviors/sized', [], function () {
    'use strict';
    return Marionette.Behavior.extend({
        defaults: {
            target: null,
            getSize: function () {
                return this.size;
            }
        },
        onRender: function () {
            var size = this.options.getSize.call(this.view);
            var target = this.options.target ? this.$(this.options.target) : this.$el;
            target.addClass(this.options.prefix + size);
        }
    }, { SIZE: { SMALL: 'small' } });
});
define('common-modules/buttons/views/button-spacer', [], function () {
    'use strict';
    return Marionette.ItemView.extend({
        className: 'adb-button__spacer',
        template: _.template('')
    });
});
define('common-modules/buttons/button', ['common-modules/behaviors/simple-tooltip'], function (SimpleTooltip) {
    'use strict';
    var BUTTON_VARIATION_PREFIX = 'adb-button__';
    var ICON_TEMPLATE = '<i class="adb-icon__<%- icon %>"></i>';
    return Marionette.ItemView.extend({
        tagName: function () {
            if (this.options.href || this.model && this.model.get('href')) {
                return 'a';
            }
            return 'button';
        },
        buttonClass: 'adb-button',
        template: _.template('<span><%=label%></span><span class="adb-loading adb-is-hidden"></span>'),
        events: { click: 'onClick' },
        attributes: function () {
            return _.extend({ type: 'button' }, this.options.buttonAttributes || {});
        },
        modelEvents: { change: 'onModelChange' },
        ui: { loadingIndicator: '.adb-loading' },
        behaviors: function () {
            if (this.options.tooltipOptions) {
                return [_.defaults(this.options.tooltipOptions, { behaviorClass: SimpleTooltip })];
            }
        },
        initialize: function (options) {
            this.options = options || {};
            this.setup(options);
        },
        setup: function (options) {
            options = options || {};
            this.model = this.model || new Backbone.Model();
            this.href = options.href || this.model.get('href');
            this.target = options.target || this.model.get('target') || '_self';
            this.title = options.title || this.model.get('title');
            this.ariaLabel = options.title || this.model.get('title') || this.model.get('value');
            var icon = this.options.icon || this.model.get('icon'), isEndIcon = this.options.isEndIcon || this.model.get('isEndIcon'), label = this.options.label || this.model.get('label') || '';
            if (icon) {
                var formattedIcon = _.template(ICON_TEMPLATE)({ icon: icon }), parts = isEndIcon ? [
                        label,
                        formattedIcon
                    ] : [
                        formattedIcon,
                        label
                    ];
                this.label = parts.join(' ');
            } else {
                this.label = label;
            }
            this.type = this.options.type || this.model.get('type');
            this.shape = this.options.shape || this.model.get('shape');
            this.size = this.options.size || this.model.get('size');
            this.buttonClasses = this.options.buttonClasses || this.model.get('buttonClasses');
            this.isDisabled = this.options.isDisabled || this.model.get('isDisabled') || false;
            this.fullWidth = this.options.fullWidth;
        },
        onRender: function () {
            this.$el.addClass(_.compact([
                this.buttonClass,
                this.baseClass,
                this.buttonClasses,
                this.type && BUTTON_VARIATION_PREFIX + this.type,
                this.size && BUTTON_VARIATION_PREFIX + this.size,
                this.shape && BUTTON_VARIATION_PREFIX + this.shape + (this.size === this.constructor.SIZES.SMALL ? '_small' : ''),
                this.fullWidth ? BUTTON_VARIATION_PREFIX + 'full_width' : ''
            ]).join(' '));
            if (this.isDisabled) {
                this.disable();
            }
            if (this.href) {
                this.setLink();
            }
            if (this.title) {
                this.$el.attr('title', this.title);
            }
            if (this.ariaLabel) {
                this.$el.attr('aria-label', this.ariaLabel);
            }
        },
        serializeData: function () {
            return { label: this.label };
        },
        enable: function () {
            this.toggleEnabled(true);
        },
        disable: function () {
            this.toggleEnabled(false);
        },
        toggleEnabled: function (enable) {
            this.$el.toggleClass('adb-is-disabled', !enable);
            this.isDisabled = !enable;
        },
        onClick: function () {
            if (this.isDisabled) {
                return;
            }
            this.trigger('click');
        },
        onModelChange: function () {
            this.setup();
            this.render();
        },
        setLink: function () {
            this.$el.attr('href', this.href);
            this.$el.attr('target', this.target);
        },
        setLoading: function (isLoading) {
            this.$el.prop('disabled', isLoading);
            this.$el.toggleClass('adb-is-loading', isLoading);
            this.ui.loadingIndicator.toggleClass('adb-is-hidden', !isLoading);
        }
    }, {
        TYPES: {
            PRIMARY: 'primary',
            SECONDARY: 'secondary',
            EMPHASIS: 'emphasis',
            NEUTRAL: 'neutral',
            INSET: 'inset',
            INSET_DARK: 'inset_dark',
            SECRET: 'secret',
            DANGER: 'danger',
            SPACER: 'spacer'
        },
        SHAPES: { SQUARE: 'square' },
        SIZES: {
            SMALL: 'small',
            MEDIUM: 'medium',
            LARGE: 'large',
            X_LARGE: 'xlarge'
        }
    });
});
define('common-modules/buttons/button-toolbar', [
    'common-modules/buttons/button',
    'common-modules/buttons/views/button-spacer'
], function (Button, ButtonSpacer) {
    'use strict';
    return Marionette.CollectionView.extend({
        tagName: 'menu',
        className: 'adb-toolbar',
        itemView: Button,
        itemViewClass: 'adb-toolbar--item',
        itemViewOptions: function (model) {
            return {
                buttonClasses: [
                    model.get('buttonClasses') || '',
                    this.itemViewClass
                ].join(' '),
                size: model.get('size') || this.isSmall && 'small' || this.size,
                type: model.get('type') || this.type,
                shape: model.get('shape') || this.shape,
                buttonAttributes: model.get('buttonAttributes') || {},
                isDisabled: model.get('isDisabled') || this.isDisabled,
                isEndIcon: model.get('isEndIcon'),
                fullWidth: model.get('fullWidth'),
                tooltipOptions: model.get('tooltipOptions')
            };
        },
        itemEvents: { click: 'onButtonClick' },
        events: {
            'disable:buttons': 'onDisableButtons',
            'enable:buttons': 'onEnableButtons'
        },
        initialize: function (options) {
            options = options || {};
            this.isSmall = !!options.isSmall;
            this.preventBreak = !!options.preventBreak;
            this.size = options.size;
            this.shape = options.shape;
            this.type = options.type;
            this.polar = options.polar;
            this.isDisabled = options.isDisabled;
            Marionette.bindEntityEvents(this, this, this.events);
        },
        disable: function (value) {
            this.toggleEnabled(value, false);
        },
        enable: function (value) {
            this.toggleEnabled(value, true);
        },
        toggleEnabled: function (value, enabled) {
            var button = this.findChild(value);
            if (button) {
                button.toggleEnabled(enabled);
            }
        },
        getItemView: function (model) {
            switch (model.get('type')) {
            case this.constructor.TYPES.SPACER:
                return ButtonSpacer;
            default:
                return Button;
            }
        },
        hasSpacer: function () {
            return _.some(this.collection.map(function (button) {
                return button.get('type') === this.constructor.TYPES.SPACER;
            }.bind(this)));
        },
        onRender: function () {
            if (this.hasSpacer()) {
                this.$el.addClass('adb-toolbar__flex');
            }
            if (this.isSmall) {
                this.$el.addClass('adb-toolbar__small');
            }
            if (this.polar) {
                this.$el.addClass('adb-toolbar__polar');
                this.$('.adb-toolbar--item:not(:last-child)').after(' ');
            }
            if (this.preventBreak) {
                this.$el.css('white-space', 'nowrap');
            }
        },
        onButtonClick: function (event, itemView) {
            var value = itemView.model.get('value');
            if (value) {
                this.trigger('click', value);
                this.trigger('click:' + value, itemView);
            }
        },
        onDisableButtons: function () {
            this.children.invoke('disable');
        },
        onEnableButtons: function () {
            this.children.invoke('enable');
        },
        toggleHidden: function (value) {
            var button = this.findChild(value);
            if (button) {
                button.$el.addClass('adb-is-hidden');
            }
        },
        toggleVisible: function (value) {
            var button = this.findChild(value);
            if (button) {
                button.$el.removeClass('adb-is-hidden');
            }
        },
        findChild: function (value) {
            return _.find(this.children._views, function (child) {
                return child.model.get('value') === value;
            });
        }
    }, {
        TYPES: Button.TYPES,
        SIZES: Button.SIZES,
        create: function (buttons, options) {
            buttons = buttons || [];
            options = options || {};
            return new this(_.extend({}, options, { collection: new Backbone.Collection(buttons) }));
        }
    });
});
define('common-modules/buttons/toggle-button', ['common-modules/buttons/button'], function (Button) {
    'use strict';
    return Button.extend({
        baseClass: 'adb-button adb-toggle_buttons--button',
        activeClass: 'active',
        triggers: {},
        events: { click: 'onClick' },
        initialize: function (options) {
            this.constructor.__super__.initialize.apply(this, arguments);
            this.sticky = options.sticky !== false;
        },
        onClick: function () {
            if (this.isDisabled)
                return;
            this.toggleState(true);
        },
        toggleState: function (active, options) {
            options = options || {};
            if (active && !options.silent)
                this.trigger('click');
            if (this.sticky) {
                this.$el.toggleClass(this.activeClass, !!active);
            }
        }
    });
});
define('common-modules/buttons/toggle-toolbar', [
    'common-modules/buttons/toggle-button',
    'common-modules/buttons/button-toolbar'
], function (ToggleButton, Toolbar) {
    'use strict';
    return Toolbar.extend({
        className: 'adb-toggle_buttons',
        itemViewClass: '',
        itemViewOptions: function () {
            var baseOptions = this.constructor.__super__.itemViewOptions.apply(this, arguments);
            return _.extend(baseOptions, { sticky: this.sticky });
        },
        initialize: function (options) {
            Toolbar.prototype.initialize.call(this, options);
            this.value = options.value;
            this.innerToolbar = options.innerToolbar;
            this.sticky = options.sticky !== false;
        },
        getItemView: function () {
            return ToggleButton;
        },
        onRender: function () {
            Toolbar.prototype.onRender.call(this);
            if (this.innerToolbar)
                this.$el.addClass(Toolbar.prototype.itemViewClass);
            if (!_.isUndefined(this.value))
                this.selectByValue(this.value);
        },
        onButtonClick: function (event, itemView, options) {
            this.selectButton(itemView, options);
            if (this.innerToolbar) {
                this.trigger('inner:click', itemView.model.get('value'), itemView);
            } else {
                Toolbar.prototype.onButtonClick.apply(this, arguments);
            }
        },
        selectButton: function (button) {
            _.chain(this.children._views).without(button).invoke('toggleState');
            button.toggleState(true, { silent: true });
        },
        selectFirst: function () {
            this.selectButton(this.children.first());
        },
        selectByValue: function (value) {
            var button = this.children.find(function (btn) {
                return btn.model.get('value') === value;
            });
            if (!button) {
                throw new Error(value + ' value not found on any models');
            }
            this.selectButton(button);
        }
    }, {
        TYPE: 'ToggleToolbar',
        Inner: function (options) {
            options = options || {};
            return new this(_.extend(options, { innerToolbar: true }));
        }
    });
});
define('common-modules/buttons/combined-toolbar', [
    'common-modules/buttons/button-toolbar',
    'common-modules/buttons/toggle-toolbar',
    'common-modules/buttons/button'
], function (Toolbar, ToggleToolbar, Button) {
    'use strict';
    return Toolbar.extend({
        buildItemView: function (item, ItemViewType, itemViewOptions) {
            var view, options;
            if (item.get('toolbarType') === ToggleToolbar.TYPE) {
                options = _.extend(item.pick('collection', 'value', 'shape', 'size', 'type', 'sticky'), itemViewOptions);
                view = ToggleToolbar.Inner(options);
                this.listenTo(view, 'inner:click', _.bind(this.bubbleInnerClick, this));
            } else {
                options = _.extend({ model: item }, itemViewOptions);
                return new Button(options);
            }
            return view;
        },
        onButtonClick: function (event, itemView) {
            if (itemView instanceof Button)
                Toolbar.prototype.onButtonClick.apply(this, arguments);
        },
        bubbleInnerClick: function (value, itemView) {
            if (value) {
                this.trigger('click', value);
                this.trigger('click:' + value, itemView);
            }
        }
    });
});
define('common-modules/navigations/views/base-navigation', [], function () {
    'use strict';
    var SPACE = 32;
    var RETURN = 13;
    var BaseNavItem = Marionette.ItemView.extend({
        tagName: 'li',
        template: _.template('<%-label%>'),
        events: { keydown: 'selectViaKeyboard' },
        triggers: {
            click: {
                event: 'select',
                preventDefault: false
            }
        },
        modelEvents: {
            select: 'renderSelection',
            'select:view': 'selectView'
        },
        onRender: function () {
            this.$el.addClass(this.model.get('linkClasses'));
            this.addHref();
        },
        addHref: function () {
            var url = this.model.get('url');
            if (url) {
                this.getAnchor().attr('href', url);
                this.addTarget();
            }
        },
        addTarget: function () {
            var target = this.getTarget();
            if (target) {
                this.getAnchor().attr('target', target);
            }
        },
        getTarget: function () {
            return this.model.get('target');
        },
        getAnchor: function () {
            return this.$('> a');
        },
        getLink: function () {
            return this.$el;
        },
        selectViaKeyboard: function (e) {
            if (e.keyCode === SPACE || e.keyCode === RETURN) {
                e.preventDefault();
                this.trigger('select', {});
            }
        },
        renderSelection: function (isSelected, activeClass) {
            if (isSelected) {
                this.getLink().addClass(activeClass);
            } else {
                this.getLink().removeClass(activeClass);
            }
        },
        selectView: function (options) {
            options = options || {};
            this.trigger('select', options);
        }
    });
    var BaseNavigation = Marionette.CompositeView.extend({
        tagName: 'nav',
        template: _.template('<ul></ul>'),
        itemView: BaseNavItem,
        itemViewContainer: 'ul',
        activeClass: 'active',
        itemEvents: { select: 'selectNavItem' },
        clearSelection: function () {
            this.collection.invoke('trigger', 'select', false, this.activeClass);
        },
        selectNavItem: function (event, itemView, options) {
            if (!itemView)
                return;
            options = options || {};
            var isInactive = !itemView.getLink().hasClass(this.activeClass) && !_.isNull(this.activeClass);
            var changeOnActive = options.changeOnActive;
            if (isInactive || changeOnActive) {
                this.clearSelection();
                itemView.model.trigger('select', true, this.activeClass);
                if (!options.silent) {
                    this.trigger('change', itemView.model);
                }
            }
        },
        selectModel: function (model) {
            var itemView = this.children.findByModel(model);
            if (!itemView)
                throw new Error('Model is not in collection');
            this.selectNavItem(null, itemView);
        },
        selectFirst: function (options) {
            this.selectNavItem(null, this.children.first(), options);
        },
        selectByValue: function (value, options) {
            var itemView = this.children.find(function (view) {
                return view.model.get('value') === value;
            });
            if (!itemView) {
                throw new Error(value + ' value not found on any models');
            }
            this.selectNavItem(null, itemView, options);
        }
    });
    return {
        BaseNavigation: BaseNavigation,
        BaseNavItem: BaseNavItem
    };
});
define('common-modules/navigations/templates/vertical/icon.tpl.html', [], function () {
    return '<span class="adb-link__nav--icon adb-icon__<%-icon%> <%-styleClass%>"></span>\n';
});
define('common-modules/navigations/templates/vertical/count.tpl.html', [], function () {
    return '<span class="adb-stack--affix adb-link__nav--affix adb-count"><%-count%></span>\n';
});
define('common-modules/navigations/templates/vertical/thumb.tpl.html', [], function () {
    return '<span class="adb-link__nav--thumb adb-thumb"><img class="adb-thumb-img" src="<%-thumb%>" /></span>\n';
});
define('common-modules/navigations/views/vertical-navigation-item', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/templates/vertical/icon.tpl.html',
    'common-modules/navigations/templates/vertical/count.tpl.html',
    'common-modules/navigations/templates/vertical/thumb.tpl.html'
], function (Base, iconTemplate, countTemplate, thumbTemplate) {
    'use strict';
    return Base.BaseNavItem.extend({
        className: 'adb-stack--item',
        template: _.template('<a class="adb-link__nav adb-stack--item_content"><%-label%></a>'),
        iconTemplate: _.template(iconTemplate),
        countTemplate: _.template(countTemplate),
        thumbTemplate: _.template(thumbTemplate),
        getLink: function () {
            return this.$('> a');
        },
        getAnchor: function () {
            return this.getLink();
        },
        onRender: function () {
            Base.BaseNavItem.prototype.onRender.apply(this, arguments);
            var icon = this.model.get('icon');
            var count = this.model.get('count');
            var thumb = this.model.get('thumb');
            if (icon) {
                this.getLink().prepend(this.iconTemplate({
                    icon: icon,
                    styleClass: ''
                }));
            }
            if (thumb) {
                this.getLink().prepend(this.thumbTemplate({ thumb: thumb }));
            }
            if (!_.isUndefined(count)) {
                this.getLink().append(this.countTemplate({ count: count }));
            }
        },
        focus: function () {
            this.getLink().focus();
        },
        hasFocus: function () {
            return this.getLink().is(':focus');
        }
    });
});
define('common-modules/navigations/views/vertical-navigation', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/views/vertical-navigation-item'
], function (Base, VerticalItem) {
    'use strict';
    return Base.BaseNavigation.extend({
        tagName: 'div',
        className: 'adb-container',
        template: _.template('<nav class="adb-stack"><ul></ul></nav>'),
        itemView: VerticalItem,
        itemViewContainer: 'ul',
        activeClass: 'adb-is-selected',
        initialize: function (options) {
            Base.BaseNavigation.prototype.initialize.apply(this, arguments);
            this.isSmall = !!options.isSmall;
            this.maxHeight = options.maxHeight || this.maxHeight;
            this.maxWidth = options.maxWidth;
        },
        onRender: function () {
            if (this.isSmall) {
                this.$(this.itemViewContainer).addClass('adb-stack__small');
            }
            this.composeFixedHeight();
            this.composeFixedWidth();
        },
        composeFixedHeight: function () {
            if (this.maxHeight) {
                this.$el.css({
                    maxHeight: this.maxHeight,
                    overflowY: 'auto'
                });
            }
        },
        composeFixedWidth: function () {
            if (this.maxWidth) {
                this.$el.css({ maxWidth: this.maxWidth });
            }
        }
    });
});
define('common-modules/navigations/views/dropdown-navigation-item', ['common-modules/navigations/views/vertical-navigation-item'], function (VerticalItem) {
    'use strict';
    return VerticalItem.extend({ template: _.template('<a class="adb-link__nav adb-link__option adb-stack--item_content" href="javascript:;"><%-label%></a>') });
});
define('common-modules/navigations/views/dropdown-navigation', [
    'common-modules/navigations/views/vertical-navigation',
    'common-modules/navigations/views/dropdown-navigation-item'
], function (VerticalNavigation, VerticalNavigationItem) {
    'use strict';
    var _super = VerticalNavigation.prototype;
    return VerticalNavigation.extend({
        className: 'adb-container adb-context_menu--menu',
        itemView: VerticalNavigationItem,
        itemViewContainer: 'ul',
        maxHeight: '40vh',
        template: _.template('<ul class="adb-stack"></ul>'),
        initialize: function (options) {
            _super.initialize.apply(this, arguments);
            if (options.keyboardControl !== false) {
                this.registerKeyHandler();
            }
        },
        onClose: function () {
            if (_super.onClose) {
                _super.onClose.apply(this, arguments);
            }
            this.unregisterKeyHandler();
        },
        registerKeyHandler: function () {
            $(document).on('keydown.' + this.cid, _.bind(this.handleKey, this));
        },
        handleKey: function (e) {
            if (this.isActive() && (e.keyCode === 38 || e.keyCode === 40)) {
                this.switchFocus(e.keyCode === 40);
                e.preventDefault();
                return false;
            }
        },
        switchFocus: function (down) {
            var focusIndex = this.children.toArray().indexOf(this.children.find(function (child) {
                return child.hasFocus && child.hasFocus();
            }));
            if (down) {
                focusIndex++;
            } else {
                focusIndex--;
            }
            focusIndex = Math.min(Math.max(focusIndex, 0), this.children.length - 1);
            this.children.findByIndex(focusIndex).focus();
        },
        isActive: function () {
            return !!this.$el.parents('.adb-context_menu.adb-is-active').length;
        },
        unregisterKeyHandler: function () {
            $(document).off('keydown.' + this.cid);
        },
        selectNavItem: function (event, itemView) {
            this.trigger('change', itemView.model);
        }
    });
});
define('common-modules/buttons/dropdown-button', ['common-modules/navigations/views/dropdown-navigation'], function (DropdownNavigation) {
    'use strict';
    var ICON_TEMPLATE = '<i class="adb-icon__<%- icon %>"></i> ';
    var ENTER = 13;
    var SPACE = 32;
    return Marionette.Layout.extend({
        tagName: 'menu',
        className: 'adb-context_menu',
        template: _.template('<a class="adb-button adb-button__medium adb-button__neutral js-menu-trigger" tabindex="0"><%=icon%><%-label%></a><div class="js-dropdown-container"></div>'),
        ui: { trigger: '.js-menu-trigger' },
        regions: { menuContainer: '.js-dropdown-container' },
        events: {
            'click @ui.trigger': 'onTriggerClick',
            'keydown @ui.trigger': 'onKeyDown'
        },
        initialize: function (options) {
            this.placement = options.placement || this.constructor.PLACEMENTS.BOTTOM_LEFT;
            this.isSmall = !!options.isSmall;
            this.isSquare = !!options.isSquare;
            this.isSecret = !!options.isSecret;
            this.isFixed = !!options.isFixed;
            this.showTrigger = _.isBoolean(options.showTrigger) ? options.showTrigger : true;
            this.icon = options.icon;
            this.label = options.label || '';
            this.cid = _.uniqueId();
            this.dropdownOptions = options.dropdownOptions;
            this.isDisabled = !!options.isDisabled;
            if (this.isFixed) {
                this.maybeUpdateDropdownPosition = _.throttle(_.bind(this.maybeUpdateDropdownPosition, this), 25);
                $(window).on('scroll.' + this.cid, _.bind(this.maybeUpdateDropdownPosition, this)).on('resize.' + this.cid, _.bind(this.maybeUpdateDropdownPosition, this));
            }
            this.listenTo(this, 'dropdown:close', this.closeDropdown);
        },
        onRender: function () {
            this.$el.attr('data-placement', this.placement);
            this.styleSize();
            if (this.isSecret) {
                this.ui.trigger.addClass('adb-button__secret');
            }
            if (this.showTrigger) {
                this.ui.trigger.addClass('adb-context_menu--trigger');
            }
            if (this.isDisabled) {
                this.ui.trigger.addClass('adb-is-disabled').removeClass('js-menu-trigger');
            } else {
                this.renderDropdown();
            }
        },
        renderDropdown: function () {
            var dropdown = this.dropdown = new DropdownNavigation(_.extend({
                collection: this.collection,
                isSmall: this.isSmall
            }, this.dropdownOptions));
            this.listenTo(dropdown, 'change', this.closeDropdown);
            this.menuContainer.show(dropdown);
        },
        getDropdown: function () {
            return this.dropdown;
        },
        isTopPlacement: function () {
            var PLACEMENTS = this.constructor.PLACEMENTS;
            return _([
                PLACEMENTS.TOP_LEFT,
                PLACEMENTS.TOP_RIGHT
            ]).contains(this.placement);
        },
        styleSize: function () {
            var buttonStyle = [];
            if (this.isSquare) {
                buttonStyle.push('square');
            }
            if (this.isSmall) {
                buttonStyle.push('small');
                this.$el.addClass('adb-context_menu__small');
                this.ui.trigger.removeClass('adb-button__medium');
            }
            if (buttonStyle.length) {
                this.ui.trigger.addClass('adb-button__' + buttonStyle.join('_'));
            }
        },
        onTriggerClick: function () {
            this.toggleDropdown();
        },
        onKeyDown: function (e) {
            if (e.keyCode === ENTER || e.keyCode === SPACE) {
                e.preventDefault();
                this.toggleDropdown();
            }
        },
        toggleDropdown: function () {
            if (this.isFixed) {
                this.updateDropdownPosition();
            }
            this.ui.trigger.toggleClass('adb-is-active');
            this.$el.toggleClass('adb-is-active');
            this.handleOutsideClick();
        },
        handleOutsideClick: function () {
            if (this.$el.hasClass('adb-is-active')) {
                $('html').on('click.' + this.cid, _.bind(this.closeDropdown, this));
            }
        },
        maybeUpdateDropdownPosition: function () {
            if (!this.$el.hasClass('adb-is-active')) {
                return;
            }
            this.updateDropdownPosition();
        },
        updateDropdownPosition: function () {
            var $el = this.dropdown.$el;
            $el.css({
                top: '',
                left: '',
                right: '',
                bottom: '',
                position: ''
            });
            var position = this.calculatePositionForPlacement();
            var attributes = {
                top: position.top,
                left: position.left,
                right: 'auto',
                position: 'fixed'
            };
            if (this.isTopPlacement()) {
                attributes.bottom = 'auto';
            }
            $el.css(attributes);
        },
        calculatePositionForPlacement: function () {
            var $dropdown = this.dropdown.$el, $button = this.ui.trigger;
            return {
                top: this.calculateTopForPlacement($button, $dropdown),
                left: this.calculateLeftForPlacement($button, $dropdown)
            };
        },
        calculateTopForPlacement: function ($button, $dropdown) {
            var rect = $button[0].getBoundingClientRect(), PLACEMENTS = this.constructor.PLACEMENTS;
            switch (this.placement) {
            case PLACEMENTS.BOTTOM_LEFT:
            case PLACEMENTS.BOTTOM_RIGHT:
                return rect.bottom;
            case PLACEMENTS.TOP_LEFT:
            case PLACEMENTS.TOP_RIGHT:
                return rect.top - $dropdown.outerHeight() - parseInt($dropdown.css('margin-bottom'), 10);
            default:
                throw new Error('Invalid placement');
            }
        },
        calculateLeftForPlacement: function ($button, $dropdown) {
            var rect = $button[0].getBoundingClientRect(), PLACEMENTS = this.constructor.PLACEMENTS;
            switch (this.placement) {
            case PLACEMENTS.BOTTOM_LEFT:
            case PLACEMENTS.TOP_LEFT:
                return rect.left;
            case PLACEMENTS.BOTTOM_RIGHT:
            case PLACEMENTS.TOP_RIGHT:
                return rect.right - $dropdown.outerWidth();
            default:
                throw new Error('Invalid placement');
            }
        },
        closeDropdown: function (model) {
            if (model instanceof $.Event && this.$el.has(model.target).length) {
                return;
            }
            if (model instanceof Backbone.Model) {
                this.trigger('change', model);
            }
            this.ui.trigger.removeClass('adb-is-active');
            this.$el.removeClass('adb-is-active');
            $('html').off('click.' + this.cid);
        },
        serializeData: function () {
            return {
                label: this.label,
                icon: this.icon ? _.template(ICON_TEMPLATE)({ icon: this.icon }) : ''
            };
        },
        onClose: function () {
            $('html').off('click.' + this.cid);
            $(window).off('scroll.' + this.cid).off('resize.' + this.cid);
        }
    }, {
        PLACEMENTS: {
            TOP_LEFT: 'top left',
            TOP_RIGHT: 'top right',
            BOTTOM_LEFT: 'left',
            BOTTOM_RIGHT: 'right'
        }
    });
});
define('common-modules/buttons/pager-toolbar', ['common-modules/buttons/button-toolbar'], function (Toolbar) {
    'use strict';
    return Toolbar.extend({
        className: 'adb-pager',
        navItems: [
            {
                label: l('Previous'),
                icon: 'arrow_left',
                value: 'previous',
                buttonClasses: 'adb-pager--item'
            },
            {
                label: l('Next'),
                icon: 'arrow_right',
                isEndIcon: true,
                value: 'next',
                buttonClasses: 'adb-pager--item'
            }
        ],
        initialize: function () {
            this.collection = new Backbone.Collection(this.navItems);
            Toolbar.prototype.initialize.apply(this, arguments);
        },
        render: function () {
            Toolbar.prototype.render.apply(this, arguments);
            this.$('.adb-pager--item:not(:last-child)').after(' ');
            return this;
        }
    });
});
define('common-modules/buttons/templates/tag.tpl.html', [], function () {
    return '<<%- tagType %> class="adb-tag--<%- type %>"><%- label %></<%- tagType %>>\n<a class="adb-tag--remove js-tag-remove" title="<%-removeTitle%>"></a>\n';
});
define('common-modules/buttons/tag', ['common-modules/buttons/templates/tag.tpl.html'], function (template) {
    'use strict';
    return Marionette.ItemView.extend({
        tagName: function () {
            return this.options.link ? 'a' : 'span';
        },
        className: 'adb-tag',
        template: _.template(template),
        triggers: {
            'click @ui.removeLink': 'remove',
            click: 'click'
        },
        ui: { removeLink: '.js-tag-remove' },
        initialize: function (options) {
            options = options || {};
            this.labelField = options.labelField;
            this.link = !!options.link;
            this.showRemoveLink = options.showRemoveLink !== false && !this.link;
            this.type = options.type || this.constructor.TYPE.TEXT;
        },
        onRender: function () {
            if (!this.showRemoveLink) {
                this.ui.removeLink.remove();
            }
        },
        serializeData: function () {
            return _.extend(this.model.toJSON(), {
                removeTitle: l('Remove'),
                label: this.model.get(this.labelField),
                type: this.type.value,
                tagType: this.type.tagName
            });
        }
    }, {
        TYPE: {
            CODE: {
                value: 'code',
                tagName: 'code'
            },
            TEXT: {
                value: 'text',
                tagName: 'span'
            }
        }
    });
});
define('common-modules/buttons/tags', ['common-modules/buttons/tag'], function (Tag) {
    'use strict';
    return Marionette.CollectionView.extend({
        className: 'adb-tags',
        itemView: Tag,
        itemEvents: {
            remove: 'removeTag',
            click: 'onClick'
        },
        initialize: function (options) {
            options = options || {};
            this.labelField = options.labelField || 'label';
            this.showRemoveLink = options.showRemoveLink !== false;
            this.type = options.type;
            this.link = !!options.link;
        },
        itemViewOptions: function () {
            return {
                labelField: this.labelField,
                showRemoveLink: this.showRemoveLink,
                type: this.type,
                link: this.link
            };
        },
        removeTag: function (event, itemView) {
            this.collection.remove(itemView.model);
        },
        onClick: function (event, itemView) {
            this.trigger('click', itemView.model, itemView);
        }
    }, { TYPE: Tag.TYPE });
});
define('common-modules/buttons/tooltip-trigger', [
    'common-modules/utils/tooltip-util',
    'common-modules/behaviors/complex-tooltip',
    'common-modules/behaviors/simple-tooltip'
], function (TooltipUtil, ComplexTooltip, SimpleTooltip) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template(''),
        behaviors: function () {
            var result = {};
            if (this.options.tooltipType === this.constructor.TYPE.SIMPLETOOLTIPTYPE) {
                result.behaviorClass = SimpleTooltip;
                result.message = this.options.tooltipText;
            } else {
                result.behaviorClass = ComplexTooltip;
                result.template = _.template('<%= tooltipText %>');
            }
            if (this.options.tooltipPlacement) {
                result.placement = this.options.tooltipPlacement;
            }
            if (this.options.tooltipEvent) {
                result.event = this.options.tooltipEvent;
            }
            return { Tooltip: result };
        },
        initialize: function (options) {
            options = options || {};
            this.tooltipText = options.tooltipText || '';
            this.tooltipType = options.tooltipType || this.constructor.TYPE.COMPLEXTOOLTIPTYPE;
        },
        serializeData: function () {
            return { tooltipText: this.tooltipText };
        }
    }, {
        PLACEMENTS: TooltipUtil.PLACEMENTS,
        TYPE: {
            COMPLEXTOOLTIPTYPE: 'ComplexTooltip',
            SIMPLETOOLTIPTYPE: 'SimpleTooltip'
        },
        EVENTS: TooltipUtil.EVENTS
    });
});
define('common-modules/containers/models/comments', [], function () {
    'use strict';
    var Comment = Backbone.Model.extend({
        initialize: function () {
            var children = this.get('children') || [];
            this.children = new Comments(children);
        },
        getTitle: function () {
            return this.get('title');
        },
        setTitle: function (title) {
            this.set('title', title);
        },
        getComment: function () {
            return this.get('comment');
        },
        setComment: function (comment) {
            this.set('comment', comment);
        },
        getAuthor: function () {
            return this.get('author');
        },
        getAuthorId: function () {
            return this.get('author').uuid;
        },
        getAuthorImageUrl: function () {
            return this.get('authorImageUrl');
        },
        getDate: function () {
            return this.get('date');
        },
        getReplyCount: function () {
            return this.get('commentCount');
        },
        getRating: function () {
            return this.get('rating');
        },
        setRating: function (rating) {
            this.set('rating', rating);
        },
        isEditable: function () {
            return this.get('editable');
        },
        getReplies: function () {
            return this.children;
        },
        getReplyModel: function () {
            return Comment;
        },
        getReplyOptions: function () {
            return {};
        },
        getTags: function () {
            return this.get('tags');
        }
    });
    var Comments = Backbone.Collection.extend({
        model: Comment,
        fetch: function () {
        }
    });
    return {
        Comments: Comments,
        Comment: Comment
    };
});
define('common-modules/containers/views/collapser', [], function () {
    'use strict';
    var SIZE = {
        XLARGE: 'h1',
        LARGE: 'h2',
        MEDIUM: 'h3',
        SMALL: 'h4',
        XSMALL: 'h5'
    };
    return Marionette.Layout.extend({
        className: 'adb-accordion--item',
        template: _.template('<div class="adb-accordion--trigger"><<%=size%>><%=header%></<%=size%>></div><div class="adb-accordion--target collapse"></div>'),
        regions: { content: '.adb-accordion--target' },
        ui: {
            header: '.adb-accordion--trigger',
            content: '.adb-accordion--target'
        },
        events: { 'click @ui.header': 'toggle' },
        initialize: function (options) {
            this.header = options.header || this.model.get('header');
            this.view = options.view || this.model.get('view');
            this.size = options.size || SIZE.MEDIUM;
            this.lock = options.lock || !!this.model.get('lock');
        },
        onRender: function () {
            this.renderView();
            if (this.lock) {
                this.lockCollapser();
            }
        },
        renderView: function () {
            this.content.show(this.view);
        },
        lockCollapser: function () {
            this.$el.addClass('adb-is-disabled');
        },
        isOpen: function () {
            return this.ui.header.hasClass('open');
        },
        show: function () {
            if (this.lock) {
                return;
            }
            this.ui.header.addClass('open');
            this.ui.content.addClass('active');
            this.trigger('open');
        },
        hide: function () {
            this.ui.header.removeClass('open');
            this.ui.content.removeClass('active');
        },
        toggle: function () {
            if (this.isOpen()) {
                this.hide();
            } else {
                this.show();
            }
        },
        serializeData: function () {
            return {
                header: this.header,
                size: this.size
            };
        }
    }, { SIZE: SIZE });
});
define('common-modules/containers/views/accordion', ['common-modules/containers/views/collapser'], function (Collapser) {
    'use strict';
    return Marionette.CollectionView.extend({
        className: 'adb-accordion',
        itemView: Collapser,
        itemEvents: { open: 'onChildOpen' },
        itemViewOptions: function () {
            return { size: this.size };
        },
        initialize: function (options) {
            this.exclusive = !!options.exclusive;
            this.size = options.size;
        },
        onChildOpen: function (event, itemView) {
            if (this.exclusive) {
                _(this.children.without(itemView)).invoke('hide');
            }
        }
    }, { SIZE: Collapser.SIZE });
});
define('common-modules/containers/templates/advanced-container.tpl.html', [], function () {
    return '<div class="adb-advanced-container_header">\n\t<div class="adb-advanced-container_header-left">\n\t\t<span class="js-header-view"></span>\n\t\t<div class="js-help-tooltip adb-container_header--title adb-container_header--item"></div>\n\t</div>\n\t<div class="js-header-actions"></div>\n</div>\n<div class="js-content"></div>\n';
});
define('common-modules/forms/templates/help-tooltip.tpl.html', [], function () {
    return '<i class=\'adb-icon__question\'></i>\n';
});
define('common-modules/forms/views/help-tooltip', [
    'common-modules/behaviors/complex-tooltip',
    'common-modules/forms/templates/help-tooltip.tpl.html'
], function (ComplexTooltip, template) {
    'use strict';
    return Marionette.ItemView.extend({
        tagName: 'a',
        className: 'adb-tooltip_trigger',
        template: _.template(template),
        behaviors: {
            ComplexTooltip: {
                behaviorClass: ComplexTooltip,
                template: _.template('<p><%= help %></p>'),
                serializeData: function () {
                    return { help: this.options.help };
                },
                event: ComplexTooltip.EVENTS.HOVER
            }
        }
    });
});
define('common-modules/containers/views/advanced-container', [
    'common-modules/containers/templates/advanced-container.tpl.html',
    'common-modules/forms/views/help-tooltip'
], function (containerTemplate, HelpTooltip) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'adb-advanced-container',
        attributes: function () {
            return {
                class: _.join([
                    this.className,
                    this.customClassName || ''
                ], ' ')
            };
        },
        template: _.template(containerTemplate),
        regions: {
            headerView: '.js-header-view',
            headerActions: '.js-header-actions',
            content: '.js-content'
        },
        initialize: function () {
            if (this.helpText) {
                this.listenTo(this, 'show', this.showHelpTooltip);
                this.listenTo(this, 'before:close', this.hideHelpTooltip);
            }
        },
        hideHelpTooltip: function () {
            if (this.helpTooltip) {
                this.helpTooltip.close();
            }
        },
        showHelpTooltip: function () {
            this.hideHelpTooltip();
            this.helpTooltip = new HelpTooltip({ help: this.helpText });
            this.$('.js-help-tooltip').append(this.helpTooltip.render().el);
        }
    });
});
define('common-modules/containers/templates/bundle-slider-content.tpl.html', [], function () {
    return '<p aria-hidden="true" role="presentation">\n\t<a class="adb-id_group adb-id_group__bundle js-listApps <%- listClass %>" href="<%- bundleUrl %>"></a>\n</p>\n<h3 data-truncate="line"><a href="<%- bundleUrl %>"><%- title %></a></h3>\n<p class="adb-slider--item_content" title="<%- description %>"><%- abbreviatedDescription %></p>\n<p class="adb-slider--item_content adb-subtitle" data-truncate="line"><%- priceText %></p>\n';
});
define('common-modules/containers/templates/bundle-slider-content-tooltip.tpl.html', [], function () {
    return '<h3><%- title %></h3>\n<p><%- abbreviatedDescription %></p>\n<p class="adb-rating"></p>\n<p class="adb-subtitle"><%- priceText %></p>\n';
});
define('common-modules/containers/views/logo', [], function () {
    'use strict';
    return Marionette.ItemView.extend({
        getTemplate: function () {
            if (this.useBackgroundImage && this.url) {
                return _.template('');
            } else if (this.url) {
                if (this.lazy) {
                    return _.template('<img data-lazy="<%- url %>" alt class="adb-id--img">');
                }
                return _.template('<img src="<%- url %>" alt class="adb-id--img">');
            } else if (this.fallback) {
                return _.template('<i role="presentation" class="adb-id--placeholder adb-icon__' + this.fallback + '"></i>');
            }
            return _.template('<img src="<%- url %>" alt class="adb-id--img">');
        },
        className: function () {
            var classes = ['adb-id'];
            if (!this.isAvatar()) {
                classes.push('adb-id__logo');
            }
            if (!this.isFluid()) {
                classes.push('adb-id__' + this.form, 'adb-id__' + this.form + '_' + this.size);
            }
            if (this.isLinked()) {
                classes.push('adb-id__linked');
            }
            if (this.isGrouped()) {
                classes.push('adb-id_group--item');
            }
            return classes.join(' ');
        },
        defaults: function () {
            return {
                size: this.constructor.SIZES.MEDIUM,
                form: this.constructor.FORMS.SQUARE,
                linked: false,
                grouped: false,
                avatar: false,
                url: undefined,
                useBackgroundImage: false,
                lazy: false
            };
        },
        initialize: function (options) {
            _.extend(this, _.defaults(options || {}, this.defaults()));
        },
        onRender: function () {
            this.$el.prop('class', this.className());
            if (this.useBackgroundImage && this.url) {
                this.$el.css('background-image', 'url(' + this.url + ')');
            }
        },
        serializeData: function () {
            return {
                url: this.url,
                title: this.options.title
            };
        },
        isFluid: function () {
            return this.size === this.constructor.SIZES.FLUID;
        },
        isLinked: function () {
            return !!this.linked;
        },
        isGrouped: function () {
            return !!this.grouped;
        },
        isAvatar: function () {
            return !!this.avatar;
        }
    }, {
        FORMS: {
            SQUARE: 'sq',
            HORIZONTAL: 'hz'
        },
        SIZES: {
            X_SMALL: 'xsmall',
            SMALL: 'small',
            MEDIUM: 'medium',
            LARGE: 'large',
            X_LARGE: 'xlarge',
            FLUID: 'fluid'
        },
        FALLBACK: {
            STAR: 'star',
            USER: 'user',
            ADD: 'add',
            COMPANY: 'company'
        }
    });
});
define('string-utils', [], function () {
    'use strict';
    return {
        abbreviate: function (text, maxWidth, replacementStr) {
            if (!replacementStr) {
                replacementStr = '...';
            }
            var replacementLength = replacementStr.length;
            if (text && text.length > maxWidth) {
                text = text.substr(0, maxWidth - replacementLength);
                text = text + replacementStr;
            }
            return text;
        },
        titleize: function (text) {
            return text.toLowerCase().replace(/(?:^|\s|-)\S/g, function (c) {
                return c.toUpperCase();
            });
        },
        stripHtml: function (text) {
            if (text) {
                text = text.replace(/\n\s*\n/g, ' ');
                text = text.replace(/(<br\s*\/?>)+/gi, ' ');
                text = text.replace(/<(?:.|\n)*?>/gm, '');
            }
            return text.trim();
        },
        insertAtIndex: function (text, index, toInsert) {
            var pre = text.slice(0, index);
            var post = text.slice(index);
            return [
                pre,
                toInsert,
                post
            ].join('');
        }
    };
});
define('common-modules/containers/views/bundle-slider-content', [
    'common-modules/containers/templates/bundle-slider-content.tpl.html',
    'common-modules/containers/templates/bundle-slider-content-tooltip.tpl.html',
    'common-modules/behaviors/complex-tooltip',
    'common-modules/containers/views/logo',
    'common-modules/utils/tooltip-util',
    'string-utils'
], function (Template, TooltipTemplate, ComplexTooltip, Logo, TooltipUtil, stringUtils) {
    'use strict';
    return Marionette.CompositeView.extend({
        className: 'adb-slider--item',
        template: _.template(Template),
        itemViewContainer: '.js-listApps',
        itemView: Logo,
        itemViewOptions: function (model) {
            return {
                grouped: true,
                url: model.get('logoUrl'),
                fallback: Logo.FALLBACK.STAR,
                lazy: this.lazyLoadImages
            };
        },
        maxIncludedAppsCount: 4,
        behaviors: {
            ComplexTooltip: {
                behaviorClass: ComplexTooltip,
                template: _.template(TooltipTemplate),
                serializeData: function () {
                    return _.extend(this.model.toJSON(), { abbreviatedDescription: stringUtils.abbreviate(this.model.get('description'), 150) });
                },
                dynamicPlacement: TooltipUtil.DYNAMIC_PLACEMENTS.TOP_DOWN,
                container: '.js-listApps'
            }
        },
        initialize: function (options) {
            this.collection = new Backbone.Collection(_.first(this.model.get('apps'), this.maxIncludedAppsCount));
            this.lazyLoadImages = options.lazyLoadImages;
        },
        serializeData: function () {
            return _.extend(this.model.toJSON(), {
                listClass: this.collection.size() > 3 ? 'adb-id_group__overlapping' : '',
                abbreviatedDescription: stringUtils.abbreviate(this.model.get('description'), 100)
            });
        }
    });
});
define('common-modules/containers/templates/bundle-slider.tpl.html', [], function () {
    return '<div class="adb-header">\n\t<h2 class="adb-header--item"><%- headerText %></h2>\n\t<menu class="adb-header--item adb-toolbar__small">\n\t\t<a class="adb-button adb-button__neutral adb-button__small adb-toolbar--item" href="<%- viewAllUrl %>"><%- l(\'View.All\') %></a>\n\t\t<menu class="adb-toggle_buttons adb-toolbar--item">\n\t\t\t<button aria-label="<%- l(\'prev\') %>" class="adb-toggle_buttons--button adb-button__square_small adb-js-slider-prev" type="button">\n\t\t\t\t<i class="adb-icon__arrow_left"></i>\n\t\t\t</button><button aria-label="<%- l(\'next\') %>" class="adb-toggle_buttons--button adb-button__square_small adb-js-slider-next" type="button">\n\t\t\t\t<i class="adb-icon__arrow_right"></i>\n\t\t\t</button>\n\t\t</menu>\n\t</menu>\n</div>\n<div class="adb-slider adb-slider__id_group adb-js-slider "></div>\n';
});
(function () {
    var root = this;
    var previousUnderscore = root._;
    var breaker = {};
    var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
    var push = ArrayProto.push, slice = ArrayProto.slice, concat = ArrayProto.concat, toString = ObjProto.toString, hasOwnProperty = ObjProto.hasOwnProperty;
    var nativeForEach = ArrayProto.forEach, nativeMap = ArrayProto.map, nativeReduce = ArrayProto.reduce, nativeReduceRight = ArrayProto.reduceRight, nativeFilter = ArrayProto.filter, nativeEvery = ArrayProto.every, nativeSome = ArrayProto.some, nativeIndexOf = ArrayProto.indexOf, nativeLastIndexOf = ArrayProto.lastIndexOf, nativeIsArray = Array.isArray, nativeKeys = Object.keys, nativeBind = FuncProto.bind;
    var _ = function (obj) {
        if (obj instanceof _)
            return obj;
        if (!(this instanceof _))
            return new _(obj);
        this._wrapped = obj;
    };
    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = _;
        }
        exports._ = _;
    } else {
        root._ = _;
    }
    _.VERSION = '1.6.0';
    var each = _.each = _.forEach = function (obj, iterator, context) {
        if (obj == null)
            return obj;
        if (nativeForEach && obj.forEach === nativeForEach) {
            obj.forEach(iterator, context);
        } else if (obj.length === +obj.length) {
            for (var i = 0, length = obj.length; i < length; i++) {
                if (iterator.call(context, obj[i], i, obj) === breaker)
                    return;
            }
        } else {
            var keys = _.keys(obj);
            for (var i = 0, length = keys.length; i < length; i++) {
                if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker)
                    return;
            }
        }
        return obj;
    };
    _.map = _.collect = function (obj, iterator, context) {
        var results = [];
        if (obj == null)
            return results;
        if (nativeMap && obj.map === nativeMap)
            return obj.map(iterator, context);
        each(obj, function (value, index, list) {
            results.push(iterator.call(context, value, index, list));
        });
        return results;
    };
    var reduceError = 'Reduce of empty array with no initial value';
    _.reduce = _.foldl = _.inject = function (obj, iterator, memo, context) {
        var initial = arguments.length > 2;
        if (obj == null)
            obj = [];
        if (nativeReduce && obj.reduce === nativeReduce) {
            if (context)
                iterator = _.bind(iterator, context);
            return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
        }
        each(obj, function (value, index, list) {
            if (!initial) {
                memo = value;
                initial = true;
            } else {
                memo = iterator.call(context, memo, value, index, list);
            }
        });
        if (!initial)
            throw new TypeError(reduceError);
        return memo;
    };
    _.reduceRight = _.foldr = function (obj, iterator, memo, context) {
        var initial = arguments.length > 2;
        if (obj == null)
            obj = [];
        if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
            if (context)
                iterator = _.bind(iterator, context);
            return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
        }
        var length = obj.length;
        if (length !== +length) {
            var keys = _.keys(obj);
            length = keys.length;
        }
        each(obj, function (value, index, list) {
            index = keys ? keys[--length] : --length;
            if (!initial) {
                memo = obj[index];
                initial = true;
            } else {
                memo = iterator.call(context, memo, obj[index], index, list);
            }
        });
        if (!initial)
            throw new TypeError(reduceError);
        return memo;
    };
    _.find = _.detect = function (obj, predicate, context) {
        var result;
        any(obj, function (value, index, list) {
            if (predicate.call(context, value, index, list)) {
                result = value;
                return true;
            }
        });
        return result;
    };
    _.filter = _.select = function (obj, predicate, context) {
        var results = [];
        if (obj == null)
            return results;
        if (nativeFilter && obj.filter === nativeFilter)
            return obj.filter(predicate, context);
        each(obj, function (value, index, list) {
            if (predicate.call(context, value, index, list))
                results.push(value);
        });
        return results;
    };
    _.reject = function (obj, predicate, context) {
        return _.filter(obj, function (value, index, list) {
            return !predicate.call(context, value, index, list);
        }, context);
    };
    _.every = _.all = function (obj, predicate, context) {
        predicate || (predicate = _.identity);
        var result = true;
        if (obj == null)
            return result;
        if (nativeEvery && obj.every === nativeEvery)
            return obj.every(predicate, context);
        each(obj, function (value, index, list) {
            if (!(result = result && predicate.call(context, value, index, list)))
                return breaker;
        });
        return !!result;
    };
    var any = _.some = _.any = function (obj, predicate, context) {
        predicate || (predicate = _.identity);
        var result = false;
        if (obj == null)
            return result;
        if (nativeSome && obj.some === nativeSome)
            return obj.some(predicate, context);
        each(obj, function (value, index, list) {
            if (result || (result = predicate.call(context, value, index, list)))
                return breaker;
        });
        return !!result;
    };
    _.contains = _.include = function (obj, target) {
        if (obj == null)
            return false;
        if (nativeIndexOf && obj.indexOf === nativeIndexOf)
            return obj.indexOf(target) != -1;
        return any(obj, function (value) {
            return value === target;
        });
    };
    _.invoke = function (obj, method) {
        var args = slice.call(arguments, 2);
        var isFunc = _.isFunction(method);
        return _.map(obj, function (value) {
            return (isFunc ? method : value[method]).apply(value, args);
        });
    };
    _.pluck = function (obj, key) {
        return _.map(obj, _.property(key));
    };
    _.where = function (obj, attrs) {
        return _.filter(obj, _.matches(attrs));
    };
    _.findWhere = function (obj, attrs) {
        return _.find(obj, _.matches(attrs));
    };
    _.max = function (obj, iterator, context) {
        if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
            return Math.max.apply(Math, obj);
        }
        var result = -Infinity, lastComputed = -Infinity;
        each(obj, function (value, index, list) {
            var computed = iterator ? iterator.call(context, value, index, list) : value;
            if (computed > lastComputed) {
                result = value;
                lastComputed = computed;
            }
        });
        return result;
    };
    _.min = function (obj, iterator, context) {
        if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
            return Math.min.apply(Math, obj);
        }
        var result = Infinity, lastComputed = Infinity;
        each(obj, function (value, index, list) {
            var computed = iterator ? iterator.call(context, value, index, list) : value;
            if (computed < lastComputed) {
                result = value;
                lastComputed = computed;
            }
        });
        return result;
    };
    _.shuffle = function (obj) {
        var rand;
        var index = 0;
        var shuffled = [];
        each(obj, function (value) {
            rand = _.random(index++);
            shuffled[index - 1] = shuffled[rand];
            shuffled[rand] = value;
        });
        return shuffled;
    };
    _.sample = function (obj, n, guard) {
        if (n == null || guard) {
            if (obj.length !== +obj.length)
                obj = _.values(obj);
            return obj[_.random(obj.length - 1)];
        }
        return _.shuffle(obj).slice(0, Math.max(0, n));
    };
    var lookupIterator = function (value) {
        if (value == null)
            return _.identity;
        if (_.isFunction(value))
            return value;
        return _.property(value);
    };
    _.sortBy = function (obj, iterator, context) {
        iterator = lookupIterator(iterator);
        return _.pluck(_.map(obj, function (value, index, list) {
            return {
                value: value,
                index: index,
                criteria: iterator.call(context, value, index, list)
            };
        }).sort(function (left, right) {
            var a = left.criteria;
            var b = right.criteria;
            if (a !== b) {
                if (a > b || a === void 0)
                    return 1;
                if (a < b || b === void 0)
                    return -1;
            }
            return left.index - right.index;
        }), 'value');
    };
    var group = function (behavior) {
        return function (obj, iterator, context) {
            var result = {};
            iterator = lookupIterator(iterator);
            each(obj, function (value, index) {
                var key = iterator.call(context, value, index, obj);
                behavior(result, key, value);
            });
            return result;
        };
    };
    _.groupBy = group(function (result, key, value) {
        _.has(result, key) ? result[key].push(value) : result[key] = [value];
    });
    _.indexBy = group(function (result, key, value) {
        result[key] = value;
    });
    _.countBy = group(function (result, key) {
        _.has(result, key) ? result[key]++ : result[key] = 1;
    });
    _.sortedIndex = function (array, obj, iterator, context) {
        iterator = lookupIterator(iterator);
        var value = iterator.call(context, obj);
        var low = 0, high = array.length;
        while (low < high) {
            var mid = low + high >>> 1;
            iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
        }
        return low;
    };
    _.toArray = function (obj) {
        if (!obj)
            return [];
        if (_.isArray(obj))
            return slice.call(obj);
        if (obj.length === +obj.length)
            return _.map(obj, _.identity);
        return _.values(obj);
    };
    _.size = function (obj) {
        if (obj == null)
            return 0;
        return obj.length === +obj.length ? obj.length : _.keys(obj).length;
    };
    _.first = _.head = _.take = function (array, n, guard) {
        if (array == null)
            return void 0;
        if (n == null || guard)
            return array[0];
        if (n < 0)
            return [];
        return slice.call(array, 0, n);
    };
    _.initial = function (array, n, guard) {
        return slice.call(array, 0, array.length - (n == null || guard ? 1 : n));
    };
    _.last = function (array, n, guard) {
        if (array == null)
            return void 0;
        if (n == null || guard)
            return array[array.length - 1];
        return slice.call(array, Math.max(array.length - n, 0));
    };
    _.rest = _.tail = _.drop = function (array, n, guard) {
        return slice.call(array, n == null || guard ? 1 : n);
    };
    _.compact = function (array) {
        return _.filter(array, _.identity);
    };
    var flatten = function (input, shallow, output) {
        if (shallow && _.every(input, _.isArray)) {
            return concat.apply(output, input);
        }
        each(input, function (value) {
            if (_.isArray(value) || _.isArguments(value)) {
                shallow ? push.apply(output, value) : flatten(value, shallow, output);
            } else {
                output.push(value);
            }
        });
        return output;
    };
    _.flatten = function (array, shallow) {
        return flatten(array, shallow, []);
    };
    _.without = function (array) {
        return _.difference(array, slice.call(arguments, 1));
    };
    _.partition = function (array, predicate) {
        var pass = [], fail = [];
        each(array, function (elem) {
            (predicate(elem) ? pass : fail).push(elem);
        });
        return [
            pass,
            fail
        ];
    };
    _.uniq = _.unique = function (array, isSorted, iterator, context) {
        if (_.isFunction(isSorted)) {
            context = iterator;
            iterator = isSorted;
            isSorted = false;
        }
        var initial = iterator ? _.map(array, iterator, context) : array;
        var results = [];
        var seen = [];
        each(initial, function (value, index) {
            if (isSorted ? !index || seen[seen.length - 1] !== value : !_.contains(seen, value)) {
                seen.push(value);
                results.push(array[index]);
            }
        });
        return results;
    };
    _.union = function () {
        return _.uniq(_.flatten(arguments, true));
    };
    _.intersection = function (array) {
        var rest = slice.call(arguments, 1);
        return _.filter(_.uniq(array), function (item) {
            return _.every(rest, function (other) {
                return _.contains(other, item);
            });
        });
    };
    _.difference = function (array) {
        var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
        return _.filter(array, function (value) {
            return !_.contains(rest, value);
        });
    };
    _.zip = function () {
        var length = _.max(_.pluck(arguments, 'length').concat(0));
        var results = new Array(length);
        for (var i = 0; i < length; i++) {
            results[i] = _.pluck(arguments, '' + i);
        }
        return results;
    };
    _.object = function (list, values) {
        if (list == null)
            return {};
        var result = {};
        for (var i = 0, length = list.length; i < length; i++) {
            if (values) {
                result[list[i]] = values[i];
            } else {
                result[list[i][0]] = list[i][1];
            }
        }
        return result;
    };
    _.indexOf = function (array, item, isSorted) {
        if (array == null)
            return -1;
        var i = 0, length = array.length;
        if (isSorted) {
            if (typeof isSorted == 'number') {
                i = isSorted < 0 ? Math.max(0, length + isSorted) : isSorted;
            } else {
                i = _.sortedIndex(array, item);
                return array[i] === item ? i : -1;
            }
        }
        if (nativeIndexOf && array.indexOf === nativeIndexOf)
            return array.indexOf(item, isSorted);
        for (; i < length; i++)
            if (array[i] === item)
                return i;
        return -1;
    };
    _.lastIndexOf = function (array, item, from) {
        if (array == null)
            return -1;
        var hasIndex = from != null;
        if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
            return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
        }
        var i = hasIndex ? from : array.length;
        while (i--)
            if (array[i] === item)
                return i;
        return -1;
    };
    _.range = function (start, stop, step) {
        if (arguments.length <= 1) {
            stop = start || 0;
            start = 0;
        }
        step = arguments[2] || 1;
        var length = Math.max(Math.ceil((stop - start) / step), 0);
        var idx = 0;
        var range = new Array(length);
        while (idx < length) {
            range[idx++] = start;
            start += step;
        }
        return range;
    };
    var ctor = function () {
    };
    _.bind = function (func, context) {
        var args, bound;
        if (nativeBind && func.bind === nativeBind)
            return nativeBind.apply(func, slice.call(arguments, 1));
        if (!_.isFunction(func))
            throw new TypeError();
        args = slice.call(arguments, 2);
        return bound = function () {
            if (!(this instanceof bound))
                return func.apply(context, args.concat(slice.call(arguments)));
            ctor.prototype = func.prototype;
            var self = new ctor();
            ctor.prototype = null;
            var result = func.apply(self, args.concat(slice.call(arguments)));
            if (Object(result) === result)
                return result;
            return self;
        };
    };
    _.partial = function (func) {
        var boundArgs = slice.call(arguments, 1);
        return function () {
            var position = 0;
            var args = boundArgs.slice();
            for (var i = 0, length = args.length; i < length; i++) {
                if (args[i] === _)
                    args[i] = arguments[position++];
            }
            while (position < arguments.length)
                args.push(arguments[position++]);
            return func.apply(this, args);
        };
    };
    _.bindAll = function (obj) {
        var funcs = slice.call(arguments, 1);
        if (funcs.length === 0)
            throw new Error('bindAll must be passed function names');
        each(funcs, function (f) {
            obj[f] = _.bind(obj[f], obj);
        });
        return obj;
    };
    _.memoize = function (func, hasher) {
        var memo = {};
        hasher || (hasher = _.identity);
        return function () {
            var key = hasher.apply(this, arguments);
            return _.has(memo, key) ? memo[key] : memo[key] = func.apply(this, arguments);
        };
    };
    _.delay = function (func, wait) {
        var args = slice.call(arguments, 2);
        return setTimeout(function () {
            return func.apply(null, args);
        }, wait);
    };
    _.defer = function (func) {
        return _.delay.apply(_, [
            func,
            1
        ].concat(slice.call(arguments, 1)));
    };
    _.throttle = function (func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        options || (options = {});
        var later = function () {
            previous = options.leading === false ? 0 : _.now();
            timeout = null;
            result = func.apply(context, args);
            context = args = null;
        };
        return function () {
            var now = _.now();
            if (!previous && options.leading === false)
                previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0) {
                clearTimeout(timeout);
                timeout = null;
                previous = now;
                result = func.apply(context, args);
                context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };
    _.debounce = function (func, wait, immediate) {
        var timeout, args, context, timestamp, result;
        var later = function () {
            var last = _.now() - timestamp;
            if (last < wait) {
                timeout = setTimeout(later, wait - last);
            } else {
                timeout = null;
                if (!immediate) {
                    result = func.apply(context, args);
                    context = args = null;
                }
            }
        };
        return function () {
            context = this;
            args = arguments;
            timestamp = _.now();
            var callNow = immediate && !timeout;
            if (!timeout) {
                timeout = setTimeout(later, wait);
            }
            if (callNow) {
                result = func.apply(context, args);
                context = args = null;
            }
            return result;
        };
    };
    _.once = function (func) {
        var ran = false, memo;
        return function () {
            if (ran)
                return memo;
            ran = true;
            memo = func.apply(this, arguments);
            func = null;
            return memo;
        };
    };
    _.wrap = function (func, wrapper) {
        return _.partial(wrapper, func);
    };
    _.compose = function () {
        var funcs = arguments;
        return function () {
            var args = arguments;
            for (var i = funcs.length - 1; i >= 0; i--) {
                args = [funcs[i].apply(this, args)];
            }
            return args[0];
        };
    };
    _.after = function (times, func) {
        return function () {
            if (--times < 1) {
                return func.apply(this, arguments);
            }
        };
    };
    _.keys = function (obj) {
        if (!_.isObject(obj))
            return [];
        if (nativeKeys)
            return nativeKeys(obj);
        var keys = [];
        for (var key in obj)
            if (_.has(obj, key))
                keys.push(key);
        return keys;
    };
    _.values = function (obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var values = new Array(length);
        for (var i = 0; i < length; i++) {
            values[i] = obj[keys[i]];
        }
        return values;
    };
    _.pairs = function (obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var pairs = new Array(length);
        for (var i = 0; i < length; i++) {
            pairs[i] = [
                keys[i],
                obj[keys[i]]
            ];
        }
        return pairs;
    };
    _.invert = function (obj) {
        var result = {};
        var keys = _.keys(obj);
        for (var i = 0, length = keys.length; i < length; i++) {
            result[obj[keys[i]]] = keys[i];
        }
        return result;
    };
    _.functions = _.methods = function (obj) {
        var names = [];
        for (var key in obj) {
            if (_.isFunction(obj[key]))
                names.push(key);
        }
        return names.sort();
    };
    _.extend = function (obj) {
        each(slice.call(arguments, 1), function (source) {
            if (source) {
                for (var prop in source) {
                    obj[prop] = source[prop];
                }
            }
        });
        return obj;
    };
    _.pick = function (obj) {
        var copy = {};
        var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
        each(keys, function (key) {
            if (key in obj)
                copy[key] = obj[key];
        });
        return copy;
    };
    _.omit = function (obj) {
        var copy = {};
        var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
        for (var key in obj) {
            if (!_.contains(keys, key))
                copy[key] = obj[key];
        }
        return copy;
    };
    _.defaults = function (obj) {
        each(slice.call(arguments, 1), function (source) {
            if (source) {
                for (var prop in source) {
                    if (obj[prop] === void 0)
                        obj[prop] = source[prop];
                }
            }
        });
        return obj;
    };
    _.clone = function (obj) {
        if (!_.isObject(obj))
            return obj;
        return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
    };
    _.tap = function (obj, interceptor) {
        interceptor(obj);
        return obj;
    };
    var eq = function (a, b, aStack, bStack) {
        if (a === b)
            return a !== 0 || 1 / a == 1 / b;
        if (a == null || b == null)
            return a === b;
        if (a instanceof _)
            a = a._wrapped;
        if (b instanceof _)
            b = b._wrapped;
        var className = toString.call(a);
        if (className != toString.call(b))
            return false;
        switch (className) {
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return a != +a ? b != +b : a == 0 ? 1 / a == 1 / b : a == +b;
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
        }
        if (typeof a != 'object' || typeof b != 'object')
            return false;
        var length = aStack.length;
        while (length--) {
            if (aStack[length] == a)
                return bStack[length] == b;
        }
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && ('constructor' in a && 'constructor' in b)) {
            return false;
        }
        aStack.push(a);
        bStack.push(b);
        var size = 0, result = true;
        if (className == '[object Array]') {
            size = a.length;
            result = size == b.length;
            if (result) {
                while (size--) {
                    if (!(result = eq(a[size], b[size], aStack, bStack)))
                        break;
                }
            }
        } else {
            for (var key in a) {
                if (_.has(a, key)) {
                    size++;
                    if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack)))
                        break;
                }
            }
            if (result) {
                for (key in b) {
                    if (_.has(b, key) && !size--)
                        break;
                }
                result = !size;
            }
        }
        aStack.pop();
        bStack.pop();
        return result;
    };
    _.isEqual = function (a, b) {
        return eq(a, b, [], []);
    };
    _.isEmpty = function (obj) {
        if (obj == null)
            return true;
        if (_.isArray(obj) || _.isString(obj))
            return obj.length === 0;
        for (var key in obj)
            if (_.has(obj, key))
                return false;
        return true;
    };
    _.isElement = function (obj) {
        return !!(obj && obj.nodeType === 1);
    };
    _.isArray = nativeIsArray || function (obj) {
        return toString.call(obj) == '[object Array]';
    };
    _.isObject = function (obj) {
        return obj === Object(obj);
    };
    each([
        'Arguments',
        'Function',
        'String',
        'Number',
        'Date',
        'RegExp'
    ], function (name) {
        _['is' + name] = function (obj) {
            return toString.call(obj) == '[object ' + name + ']';
        };
    });
    if (!_.isArguments(arguments)) {
        _.isArguments = function (obj) {
            return !!(obj && _.has(obj, 'callee'));
        };
    }
    if (typeof /./ !== 'function') {
        _.isFunction = function (obj) {
            return typeof obj === 'function';
        };
    }
    _.isFinite = function (obj) {
        return isFinite(obj) && !isNaN(parseFloat(obj));
    };
    _.isNaN = function (obj) {
        return _.isNumber(obj) && obj != +obj;
    };
    _.isBoolean = function (obj) {
        return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
    };
    _.isNull = function (obj) {
        return obj === null;
    };
    _.isUndefined = function (obj) {
        return obj === void 0;
    };
    _.has = function (obj, key) {
        return hasOwnProperty.call(obj, key);
    };
    _.noConflict = function () {
        root._ = previousUnderscore;
        return this;
    };
    _.identity = function (value) {
        return value;
    };
    _.constant = function (value) {
        return function () {
            return value;
        };
    };
    _.property = function (key) {
        return function (obj) {
            return obj[key];
        };
    };
    _.matches = function (attrs) {
        return function (obj) {
            if (obj === attrs)
                return true;
            for (var key in attrs) {
                if (attrs[key] !== obj[key])
                    return false;
            }
            return true;
        };
    };
    _.times = function (n, iterator, context) {
        var accum = Array(Math.max(0, n));
        for (var i = 0; i < n; i++)
            accum[i] = iterator.call(context, i);
        return accum;
    };
    _.random = function (min, max) {
        if (max == null) {
            max = min;
            min = 0;
        }
        return min + Math.floor(Math.random() * (max - min + 1));
    };
    _.now = Date.now || function () {
        return new Date().getTime();
    };
    var entityMap = {
        escape: {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            '\'': '&#x27;'
        }
    };
    entityMap.unescape = _.invert(entityMap.escape);
    var entityRegexes = {
        escape: new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
        unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
    };
    _.each([
        'escape',
        'unescape'
    ], function (method) {
        _[method] = function (string) {
            if (string == null)
                return '';
            return ('' + string).replace(entityRegexes[method], function (match) {
                return entityMap[method][match];
            });
        };
    });
    _.result = function (object, property) {
        if (object == null)
            return void 0;
        var value = object[property];
        return _.isFunction(value) ? value.call(object) : value;
    };
    _.mixin = function (obj) {
        each(_.functions(obj), function (name) {
            var func = _[name] = obj[name];
            _.prototype[name] = function () {
                var args = [this._wrapped];
                push.apply(args, arguments);
                return result.call(this, func.apply(_, args));
            };
        });
    };
    var idCounter = 0;
    _.uniqueId = function (prefix) {
        var id = ++idCounter + '';
        return prefix ? prefix + id : id;
    };
    _.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
    };
    var noMatch = /(.)^/;
    var escapes = {
        '\'': '\'',
        '\\': '\\',
        '\r': 'r',
        '\n': 'n',
        '\t': 't',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;
    _.template = function (text, data, settings) {
        var render;
        settings = _.defaults({}, settings, _.templateSettings);
        var matcher = new RegExp([
            (settings.escape || noMatch).source,
            (settings.interpolate || noMatch).source,
            (settings.evaluate || noMatch).source
        ].join('|') + '|$', 'g');
        var index = 0;
        var source = '__p+=\'';
        text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
            source += text.slice(index, offset).replace(escaper, function (match) {
                return '\\' + escapes[match];
            });
            if (escape) {
                source += '\'+\n((__t=(' + escape + '))==null?\'\':_.escape(__t))+\n\'';
            }
            if (interpolate) {
                source += '\'+\n((__t=(' + interpolate + '))==null?\'\':__t)+\n\'';
            }
            if (evaluate) {
                source += '\';\n' + evaluate + '\n__p+=\'';
            }
            index = offset + match.length;
            return match;
        });
        source += '\';\n';
        if (!settings.variable)
            source = 'with(obj||{}){\n' + source + '}\n';
        source = 'var __t,__p=\'\',__j=Array.prototype.join,' + 'print=function(){__p+=__j.call(arguments,\'\');};\n' + source + 'return __p;\n';
        try {
            render = new Function(settings.variable || 'obj', '_', source);
        } catch (e) {
            e.source = source;
            throw e;
        }
        if (data)
            return render(data, _);
        var template = function (data) {
            return render.call(this, data, _);
        };
        template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';
        return template;
    };
    _.chain = function (obj) {
        return _(obj).chain();
    };
    var result = function (obj) {
        return this._chain ? _(obj).chain() : obj;
    };
    _.mixin(_);
    each([
        'pop',
        'push',
        'reverse',
        'shift',
        'sort',
        'splice',
        'unshift'
    ], function (name) {
        var method = ArrayProto[name];
        _.prototype[name] = function () {
            var obj = this._wrapped;
            method.apply(obj, arguments);
            if ((name == 'shift' || name == 'splice') && obj.length === 0)
                delete obj[0];
            return result.call(this, obj);
        };
    });
    each([
        'concat',
        'join',
        'slice'
    ], function (name) {
        var method = ArrayProto[name];
        _.prototype[name] = function () {
            return result.call(this, method.apply(this._wrapped, arguments));
        };
    });
    _.extend(_.prototype, {
        chain: function () {
            this._chain = true;
            return this;
        },
        value: function () {
            return this._wrapped;
        }
    });
    if (typeof define === 'function' && define.amd) {
        define('underscore', [], function () {
            return _;
        });
    }
}.call(this));
define('object-utils', ['underscore'], function (_) {
    'use strict';
    var slice = Array.prototype.slice;
    return {
        resolveObject: function (object) {
            var args = slice.call(arguments, 1);
            return _(object).reduce(function (memo, value, key, obj) {
                var isFunc = _.isFunction(value);
                memo[key] = isFunc ? obj[key].apply(obj, args) : value;
                return memo;
            }, {});
        },
        containsAll: function (obj, target) {
            if (!obj)
                return false;
            if (obj.length !== +obj.length)
                obj = _.values(obj);
            return _.intersection(obj, target).length === target.length;
        },
        containsAny: function (obj, target) {
            if (!obj)
                return false;
            if (obj.length !== +obj.length)
                obj = _.values(obj);
            return _.some(obj, function (item) {
                return _(target).contains(item);
            });
        },
        serializeDefaults: function (model, keys) {
            var props = _(keys).reduce(function (memo, key) {
                memo[key] = model.get(key) || '';
                return memo;
            }, {});
            return _.extend(model.toJSON(), props);
        },
        constants: function (array) {
            return _.object(array, array);
        },
        toCollection: function (array) {
            return array instanceof Backbone.Collection ? array : new Backbone.Collection(array);
        },
        deepClone: function (obj) {
            var copy;
            if (_.isNull(obj) || _.isUndefined(obj) || typeof obj !== 'object') {
                return obj;
            }
            if (obj instanceof Date) {
                copy = new Date();
                copy.setTime(obj.getTime());
                return copy;
            }
            if (obj instanceof Array) {
                copy = [];
                for (var i = 0, len = obj.length; i < len; i++) {
                    copy[i] = this.deepClone(obj[i]);
                }
                return copy;
            }
            if (obj instanceof Object) {
                copy = {};
                for (var attr in obj) {
                    if (obj.hasOwnProperty(attr))
                        copy[attr] = this.deepClone(obj[attr]);
                }
                return copy;
            }
            throw new Error('Unable to copy obj! Its type isn\'t supported.');
        },
        mergeOptions: function (target, options, optionNames) {
            options = _.pick.apply(_, [options || {}].concat(optionNames));
            if (target.defaults) {
                options = _.defaults(options, target.defaults);
            }
            _.extend(target, options);
        },
        deepExtend: function (target) {
            _.each(slice.call(arguments, 1), function (source) {
                if (source) {
                    for (var prop in source) {
                        if (source.hasOwnProperty(prop)) {
                            if (this.isStrictlyObject(target[prop]) && this.isStrictlyObject(source[prop])) {
                                this.deepExtend(target[prop], source[prop]);
                            } else {
                                target[prop] = source[prop];
                            }
                        }
                    }
                }
            }, this);
            return target;
        },
        isStrictlyObject: function (src) {
            return !_.isArray(src) && _.isObject(src);
        },
        result: function (object, property) {
            if (!object)
                return;
            var args = slice.call(arguments, 2);
            return _.isFunction(object[property]) ? object[property].apply(object, args) : object[property];
        }
    };
});
define('common-modules/containers/templates/feature-slider.tpl.html', [], function () {
    return '<div class="adb-header">\n\t<h2 class="adb-header--item"><%- headerText %></h2>\n\t<menu class="adb-header--item adb-toolbar__small">\n\t\t<% if(viewAllUrl) { %>\n\t\t\t<a class="adb-button adb-button__neutral adb-button__small adb-toolbar--item" href="<%- viewAllUrl %>"><%- viewAllText %></a>\n\t\t<% } %>\n\t\t<menu class="adb-toggle_buttons adb-toolbar--item">\n\t\t\t<button aria-label="<%- l(\'prev\') %>" class="adb-toggle_buttons--button adb-button__square_small adb-js-slider-prev" type="button">\n\t\t\t\t<i class="adb-icon__arrow_left"></i>\n\t\t\t</button><button aria-label="<%- l(\'next\') %>" class="adb-toggle_buttons--button adb-button__square_small adb-js-slider-next" type="button">\n\t\t\t\t<i class="adb-icon__arrow_right"></i>\n\t\t\t</button>\n\t\t</menu>\n\t</menu>\n</div>\n<div class="adb-slider adb-js-slider"></div>\n';
});
define('common-modules/containers/views/slider-page', [], function () {
    'use strict';
    return Marionette.CollectionView.extend({ className: 'adb-slider--page js-slider--page' });
});
define('common-modules/containers/views/slider-v2', ['common-modules/containers/views/slider-page'], function (SliderPage) {
    'use strict';
    return Marionette.ItemView.extend({
        className: 'adb-slider--items js-slider--items',
        ANIMATION_TRANSITION_SPEED: 350,
        REPONSIVE_BREAKPOINT: 1280,
        initialize: function (options) {
            this.sliderItemView = options.itemView;
            this.slidesToShow = options.slidesToShow || 6;
            this.pageSize = $(window).width() > this.REPONSIVE_BREAKPOINT ? this.slidesToShow : this.slidesToShow - 1;
            this.currentPage = 1;
            this.currentSliderHeight = 0;
            this.calculateTotalPages();
            this.throttleMethods();
            $(window).on('resize.' + this.cid, this.handleWindowResize.bind(this));
            this.sliderPageViews = [];
        },
        render: function () {
            var noOfAppsRendered = 0;
            var pageNumber = 1;
            while (noOfAppsRendered < this.collection.length && pageNumber <= 2) {
                var collection = new Backbone.Collection(this.collection.slice(noOfAppsRendered, noOfAppsRendered + this.pageSize));
                var sliderPage = new SliderPage({
                    collection: collection,
                    itemView: this.sliderItemView
                });
                sliderPage.render();
                if (pageNumber === 1) {
                    sliderPage.$el.addClass('js-slider--page-active');
                } else {
                    sliderPage.$el.addClass('js-slider--page-next');
                }
                this.$el.append(sliderPage.$el);
                this.sliderPageViews.push(sliderPage);
                noOfAppsRendered = noOfAppsRendered + this.pageSize;
                pageNumber += 1;
            }
            this.$el.find('.merchandising-badges img').on('load', this.adjustHeight.bind(this));
        },
        reRender: function () {
            this.currentPage = 1;
            this.$el.empty();
            this.render();
            this.triggerMethod('show');
            this.trigger('check:buttons');
        },
        onShow: function () {
            this.setPageWidth();
            this.adjustHeight();
            this.$el.find('.js-slider--page-next').css({ left: this.pageWidth + 'px' });
        },
        setPageWidth: function () {
            var containerWidth = this.$el.width() || 0;
            var itemMargin = this.$el.find('.js-slider--item:last-child').css('margin-left') || 0;
            this.pageWidth = containerWidth + parseInt(itemMargin, 10);
        },
        adjustHeight: function () {
            var pageHeight = Math.max(this.$el.find('.js-slider--page-active').outerHeight() || 0, this.$el.find('.js-slider--page-next').outerHeight() || 0);
            if (pageHeight > this.currentSliderHeight) {
                this.$el.height(pageHeight);
                this.currentSliderHeight = pageHeight;
            }
        },
        isPrevEnabled: function () {
            return this.currentPage > 1;
        },
        isNextEnabled: function () {
            return this.currentPage < this.totalPages;
        },
        throttleMethods: function () {
            this.next = _.throttle(this.next.bind(this), this.ANIMATION_TRANSITION_SPEED, {
                leading: true,
                trailing: false
            });
            this.previous = _.throttle(this.previous.bind(this), this.ANIMATION_TRANSITION_SPEED, {
                leading: true,
                trailing: false
            });
        },
        calculateTotalPages: function () {
            this.totalPages = Math.ceil(this.collection.length / this.pageSize);
        },
        previous: function () {
            var activePage = this.$el.find('.js-slider--page-active');
            var nextPage = this.$el.find('.js-slider--page-next');
            var previousPage = this.$el.find('.js-slider--page-prev');
            activePage.animate({ left: this.pageWidth + 'px' }, {
                duration: this.ANIMATION_TRANSITION_SPEED,
                easing: 'linear',
                queue: false
            });
            previousPage.animate({ left: '0px' }, {
                duration: this.ANIMATION_TRANSITION_SPEED,
                easing: 'linear',
                queue: false
            });
            activePage.toggleClass('js-slider--page-active js-slider--page-next');
            previousPage.toggleClass('js-slider--page-prev js-slider--page-active');
            this.currentPage -= 1;
            this.prependPage();
            nextPage.remove();
            this.adjustHeight();
        },
        next: function () {
            var activePage = this.$el.find('.js-slider--page-active');
            var prevPage = this.$el.find('.js-slider--page-prev');
            var nextPage = this.$el.find('.js-slider--page-next');
            activePage.animate({ left: '-' + this.pageWidth + 'px' }, {
                duration: this.ANIMATION_TRANSITION_SPEED,
                easing: 'linear',
                queue: false
            });
            nextPage.animate({ left: '0px' }, {
                duration: this.ANIMATION_TRANSITION_SPEED,
                easing: 'linear',
                queue: false
            });
            activePage.toggleClass('js-slider--page-active js-slider--page-prev');
            nextPage.toggleClass('js-slider--page-next js-slider--page-active');
            if (this.currentPage === this.totalPages - 2 && _.isFunction(this.collection.fetchNextBatchApps)) {
                this.collection.fetchNextBatchApps().done(function () {
                    this.calculateTotalPages();
                    this.trigger('check:buttons');
                }.bind(this));
            }
            this.currentPage += 1;
            this.appendPage();
            prevPage.remove();
            this.adjustHeight();
        },
        appendPage: function () {
            var nextPageApps = this.collection.slice(this.currentPage * this.pageSize, (this.currentPage + 1) * this.pageSize);
            if (!nextPageApps || !nextPageApps.length) {
                return;
            }
            var collection = new Backbone.Collection(nextPageApps);
            var sliderPage = new SliderPage({
                collection: collection,
                itemView: this.sliderItemView
            });
            sliderPage.render();
            sliderPage.$el.css({ left: this.pageWidth + 'px' });
            sliderPage.$el.addClass('js-slider--page-next');
            this.$el.append(sliderPage.$el);
            this.sliderPageViews.push(sliderPage);
        },
        prependPage: function () {
            var previousPageApps = this.collection.slice((this.currentPage - 2) * this.pageSize, (this.currentPage - 1) * this.pageSize);
            if (!previousPageApps || !previousPageApps.length) {
                return;
            }
            var collection = new Backbone.Collection(previousPageApps);
            var sliderPage = new SliderPage({
                collection: collection,
                itemView: this.sliderItemView
            });
            sliderPage.render();
            sliderPage.$el.css({ left: -this.pageWidth + 'px' });
            sliderPage.$el.addClass('js-slider--page-prev');
            this.$el.prepend(sliderPage.$el);
            this.sliderPageViews.push(sliderPage);
        },
        handleWindowResize: function () {
            var width = $(window).width();
            if (width <= this.REPONSIVE_BREAKPOINT && this.pageSize !== this.slidesToShow - 1) {
                this.pageSize = this.slidesToShow - 1;
                this.reRender();
            } else if (width > this.REPONSIVE_BREAKPOINT && this.pageSize !== this.slidesToShow) {
                this.pageSize = this.slidesToShow;
                this.reRender();
            }
        },
        onBeforeClose: function () {
            $(window).off('resize.' + this.cid);
        },
        onClose: function () {
            this.sliderPageViews.forEach(function (view) {
                view.close();
            });
        }
    });
});
define('common-modules/containers/templates/feature-slider-app-content.tpl.html', [], function () {
    return '<p aria-hidden="true" role="presentation" class="js-logo-container"></p>\n<h3>\n\t<a data-truncate="line" href="<%- appUrl %>"><%- title %></a>\n</h3>\n<p class="adb-slider--item_content adb-slider--item_content--headline"><%- abbreviatedheadlineText %></p>\n<p class="adb-slider--item_content adb-subtitle js-price" data-truncate="line"><%- priceText %></p>\n<div class="js-rating"></div>\n<div class="js-merchandising-badges"></div>\n';
});
define('common-modules/containers/templates/feature-slider-app-content-tooltip.tpl.html', [], function () {
    return '<h3><%- title %></h3>\n<p><%- abbreviatedDescription %></p>\n<p class="adb-rating js-rating"></p>\n<p class="adb-subtitle js-price"><%- priceText %></p>\n';
});
define('common-modules/status/views/rating', [], function () {
    'use strict';
    var Star = Marionette.ItemView.extend({
        template: _.template(''),
        tagName: 'i',
        className: 'adb-rating--icon',
        fullClass: 'adb-rating--icon__positive',
        emptyClass: 'adb-rating--icon__unrated',
        events: {
            mouseover: 'hoverIn',
            mouseout: 'hoverOut',
            click: 'click'
        },
        onRender: function () {
            this.reset();
        },
        reset: function () {
            var isFull = !!this.model.get('isFull');
            this.toggleClass(isFull);
        },
        toggleClass: function (isFull) {
            this.$el.toggleClass(this.fullClass, isFull).toggleClass(this.emptyClass, !isFull);
        },
        getValue: function () {
            return this.model.get('rating');
        },
        hoverIn: function () {
            this.trigger('hoverIn');
        },
        hoverOut: function () {
            this.trigger('hoverOut');
        },
        click: function () {
            this.trigger('selected');
        }
    });
    return Marionette.CollectionView.extend({
        itemView: Star,
        className: 'adb-rating',
        itemEvents: {
            hoverIn: 'onHover',
            hoverOut: 'onHoverReset',
            selected: 'onSelected'
        },
        initialize: function (options) {
            options = options || {};
            this.maxRating = options.maxRating || this.constructor.MAX_RATING;
            var rating = this.rating = options.rating;
            this.editable = options.editable;
            if (!_.isNumber(rating))
                throw new Error('Rating is required');
            if (rating < 0 || rating > this.maxRating)
                throw new Error('Rating should be between 0 and ' + this.maxRating);
            this.collection = this.createCollection();
        },
        createCollection: function () {
            var rating = this.rating, range = _.range(0, this.maxRating);
            var models = _(range).map(function (number) {
                return new Backbone.Model({
                    isFull: number < rating,
                    rating: number + 1
                });
            });
            return new Backbone.Collection(models);
        },
        updateCollection: function () {
            var rating = this.rating;
            _.each(this.collection.models, function (model) {
                var isFull = model.get('rating') <= rating;
                model.set('isFull', isFull);
            });
            this.reset();
        },
        getValue: function () {
            return this.rating;
        },
        setValue: function (value) {
            this.rating = value;
            this.trigger('selected', this.rating);
            this.updateCollection();
        },
        reset: function () {
            _.each(this.children._views, function (view) {
                view.reset();
            });
            this.trigger('change', this.rating);
        },
        onHover: function (events, view) {
            if (this.editable) {
                var hoverRating = view.getValue();
                _.each(this.children._views, function (childView) {
                    var isFull = childView.getValue() <= hoverRating;
                    childView.toggleClass(isFull);
                });
                this.trigger('change', hoverRating);
            }
        },
        onHoverReset: function () {
            if (this.editable) {
                this.reset();
            }
        },
        onSelected: function (events, view) {
            if (this.editable) {
                this.setValue(view.getValue());
                this.trigger('selected', this.rating);
            }
        }
    }, { MAX_RATING: 5 });
});
define('common-modules/containers/views/feature-slider-app-content-tooltip', [
    'common-modules/behaviors/complex-tooltip',
    'common-modules/status/views/rating'
], function (ComplexTooltip, Rating) {
    'use strict';
    return ComplexTooltip.extend({
        renderTooltip: function () {
            ComplexTooltip.prototype.renderTooltip.apply(this, arguments);
            if (this.rating) {
                this.rating.remove();
            }
            if (this.serializeData().rating) {
                this.renderRating();
            }
            this.renderPricing();
        },
        renderRating: function () {
            this.rating = new Rating({ rating: this.serializeData().rating });
            this.getTooltip().find('.js-rating').append(this.rating.render().el);
        },
        renderPricing: function () {
            this.getTooltip().find('.js-price').toggleClass('adb-is-hidden', !!this.serializeData().hidePricings);
        },
        onBeforeClose: function () {
            ComplexTooltip.prototype.onBeforeClose.apply(this, arguments);
            if (this.rating)
                this.rating.remove();
        }
    });
});
define('common-modules/icons/views/tag-icons', [], function () {
    'use strict';
    var Icon = Marionette.ItemView.extend({
        tagName: 'img',
        template: _.template(''),
        attributes: function () {
            return { src: this.model.get('icon') };
        }
    });
    return Marionette.CollectionView.extend({
        template: _.template(''),
        itemView: Icon
    });
});
define('common-modules/ui/ribbon', ['object-utils'], function (ObjectUtils) {
    'use strict';
    return Backbone.View.extend({
        className: 'adb-ribbon',
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'ribbonColor',
                'ribbonTextColor',
                'ribbonText'
            ]);
        },
        render: function () {
            this.$el.css({
                'background-color': this.ribbonColor,
                color: this.ribbonTextColor
            });
            this.$el.text(this.ribbonText);
            return this;
        }
    });
});
define('common-modules/merchandising-badges/templates/badge.tpl.html', [], function () {
    return '<img src="<%=image%>" alt="<%=name%>" />\n';
});
define('common-modules/merchandising-badges/badge', ['common-modules/merchandising-badges/templates/badge.tpl.html'], function (template) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'merchandising-badges-item',
        template: _.template(template)
    });
});
define('common-modules/merchandising-badges/badges', ['common-modules/merchandising-badges/badge'], function (MerchandisingBadge) {
    'use strict';
    return Marionette.CollectionView.extend({
        className: 'merchandising-badges',
        itemView: MerchandisingBadge
    });
});
define('common-modules/containers/views/feature-slider-app-content', [
    'common-modules/containers/templates/feature-slider-app-content.tpl.html',
    'common-modules/containers/templates/feature-slider-app-content-tooltip.tpl.html',
    'common-modules/status/views/rating',
    'common-modules/containers/views/logo',
    'common-modules/containers/views/feature-slider-app-content-tooltip',
    'common-modules/icons/views/tag-icons',
    'common-modules/ui/ribbon',
    'common-modules/utils/tooltip-util',
    'common-modules/merchandising-badges/badges',
    'string-utils'
], function (Template, TooltipTemplate, Rating, Logo, ToolTip, TagIcons, Ribbon, TooltipUtil, MerchandisingBadges, stringUtils) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'adb-slider--item js-slider--item',
        template: _.template(Template),
        regions: {
            logoRegion: '.js-logo-container',
            ratingContent: '.js-rating',
            merchandisingBadgesRegion: '.js-merchandising-badges'
        },
        behaviors: {
            ComplexTooltip: {
                behaviorClass: ToolTip,
                template: _.template(TooltipTemplate),
                serializeData: function () {
                    return _.extend(this.model.toJSON(), { abbreviatedDescription: stringUtils.abbreviate(this.model.get('description'), 150) });
                },
                dynamicPlacement: TooltipUtil.DYNAMIC_PLACEMENTS.TOP_DOWN,
                container: '.js-logo-container'
            }
        },
        logoOptions: {},
        ui: { price: '.js-price' },
        initialize: function (options) {
            this.lazyLoadImages = options.lazyLoadImages;
        },
        onRender: function () {
            this.renderLogo();
            this.renderPrice();
            if (this.model.get('rating')) {
                this.renderRating();
            }
            this.renderMerchandisingBadges();
        },
        renderPrice: function () {
            this.ui.price.toggleClass('adb-is-hidden', !!this.model.get('hidePricings'));
        },
        renderLogo: function () {
            var logo = new Logo(_.extend({}, {
                size: Logo.SIZES.LARGE,
                form: Logo.FORMS.SQUARE,
                linked: true,
                url: this.model.get('logoUrl'),
                fallback: Logo.FALLBACK.STAR,
                tagName: 'a',
                attributes: { href: this.model.get('appUrl') },
                lazy: this.lazyLoadImages
            }, _.result(this, 'logoOptions')));
            this.logoRegion.show(logo);
            if (this.model.get('productRibbon')) {
                new Ribbon({
                    ribbonColor: this.model.get('productRibbon').ribbonColor,
                    ribbonTextColor: this.model.get('productRibbon').textColor,
                    ribbonText: this.model.get('productRibbon').text
                }).render().$el.appendTo(logo.el);
            }
        },
        renderRating: function () {
            var rating = new Rating({ rating: this.model.get('rating') });
            this.ratingContent.show(rating);
        },
        renderMerchandisingBadges: function () {
            var merchandisingBadges = this.model.get('merchandisingBadges');
            if (merchandisingBadges && merchandisingBadges.length) {
                this.merchandisingBadgesRegion.show(new MerchandisingBadges({ collection: new Backbone.Collection(merchandisingBadges) }));
            }
        },
        serializeData: function () {
            return _.extend(this.model.toJSON(), { abbreviatedheadlineText: stringUtils.abbreviate(this.model.get('headlineText'), 35) });
        }
    });
});
define('common-modules/containers/views/feature-slider-v2', [
    'object-utils',
    'common-modules/containers/templates/feature-slider.tpl.html',
    'common-modules/containers/views/slider-v2',
    'common-modules/containers/views/feature-slider-app-content'
], function (ObjectUtils, template, Slider, FeatureSliderAppContent) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'adb-feature-content',
        template: _.template(template),
        sliderItemView: FeatureSliderAppContent,
        regions: { sliderContainer: '.adb-js-slider' },
        ui: {
            prevButton: '.adb-js-slider-prev',
            nextButton: '.adb-js-slider-next'
        },
        events: {
            'click @ui.prevButton': 'previous',
            'click @ui.nextButton': 'next'
        },
        defaults: { slidesToShow: 4 },
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'headerText',
                'viewAllUrl',
                'viewAllText',
                'collection',
                'slidesToShow',
                'sliderItemView'
            ]);
        },
        onRender: function () {
            this.renderSlider();
        },
        renderSlider: function () {
            this.slider = new Slider({
                collection: this.collection,
                itemView: this.sliderItemView,
                slidesToShow: this.slidesToShow
            });
            this.sliderContainer.show(this.slider);
            this.listenTo(this.slider, 'check:buttons', this.checkForButtons.bind(this));
            this.checkForButtons();
        },
        onShow: function () {
            if (this.slider) {
                this.slider.triggerMethod('show');
            }
        },
        serializeData: function () {
            return {
                headerText: this.headerText,
                viewAllUrl: this.viewAllUrl,
                viewAllText: this.viewAllText || l('View.All')
            };
        },
        previous: function () {
            this.slider.previous();
            this.checkForButtons();
        },
        next: function () {
            this.slider.next();
            this.checkForButtons();
        },
        checkForButtons: function () {
            this.toggleButton(this.ui.prevButton, this.slider.isPrevEnabled());
            this.toggleButton(this.ui.nextButton, this.slider.isNextEnabled());
        },
        toggleButton: function (button, enabled) {
            if (enabled) {
                button.removeAttr('disabled');
            } else {
                button.attr('disabled', 'disabled');
            }
        }
    });
});
define('common-modules/containers/views/bundle-slider-v2', [
    'common-modules/containers/templates/bundle-slider.tpl.html',
    'common-modules/containers/views/feature-slider-v2',
    'common-modules/containers/views/bundle-slider-content'
], function (template, FeatureSlider, BundleSliderContent) {
    'use strict';
    return FeatureSlider.extend({
        template: _.template(template),
        sliderItemView: BundleSliderContent
    });
});
define('common-modules/containers/templates/slider-dummy-view-all-url-item.tpl.html', [], function () {
    return '<div class="adb-id adb-id__logo slick-active adb-id adb-id__logo adb-id__sq adb-id__sq_large adb-id__linked">\n\t<h3><a href="<%= viewAllUrl %>"> <%= viewAllText %> </a></h3>\n</div>\n';
});
define('common-modules/containers/views/slider-dummy-view-all-url-item', ['common-modules/containers/templates/slider-dummy-view-all-url-item.tpl.html'], function (Template) {
    'use strict';
    return Marionette.ItemView.extend({
        className: 'adb-slider--item dummy--item',
        template: _.template(Template),
        initialize: function (options) {
            this.viewAllUrl = options.viewAllUrl;
            this.viewAllText = options.viewAllText;
        },
        serializeData: function () {
            return {
                viewAllUrl: this.viewAllUrl,
                viewAllText: this.viewAllText
            };
        }
    });
});
define('common-modules/containers/views/slider', [
    'common-modules/containers/views/slider-dummy-view-all-url-item',
    'common-vendor/slick-carousel/slick/slick'
], function (DummyViewAllItem) {
    'use strict';
    return Marionette.CollectionView.extend({
        className: 'adb-slider--items',
        sliderOptions: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            draggable: false,
            infinite: true,
            speed: 600,
            arrows: false
        },
        itemViewOptions: function () {
            return { lazyLoadImages: true };
        },
        initialize: function (options) {
            this.sliderOptions = $.extend({}, this.sliderOptions, options.sliderOptions);
            this.maxCount = options.maxCount;
            this.shouldAppendDummyViewAllItem = options.shouldAppendDummyViewAllItem;
            this.viewAllUrl = options.viewAllUrl;
            this.viewAllText = options.viewAllText;
        },
        onBeforeShow: function () {
            this.$el.css('width', '999999px');
        },
        onRender: function () {
            if (this.shouldAppendDummyViewAllItem && this.collection.length >= this.maxCount) {
                this.appendDummyItem();
            }
            _.defer(_.bind(this.setupSlider, this));
        },
        buildItemView: function (item, ItemViewClass, itemViewOptions) {
            var options = _.extend({ model: item }, itemViewOptions);
            if (item.get('itemView')) {
                var ItemView = item.get('itemView');
                return new ItemView(options);
            }
            return new ItemViewClass(options);
        },
        setupSlider: function () {
            this.$el.slick(this.sliderOptions);
            this.$el.css('width', null);
            this.$el.on('init', _.bind(this.triggerInitialized, this));
            this.$el.on('afterChange', _.bind(this.triggerAfterChange, this));
            this.triggerInitialized();
        },
        previous: function () {
            this.$el.slick('slickPrev');
        },
        next: function () {
            this.$el.slick('slickNext');
        },
        setSlide: function (index) {
            this.$el.slick('slickGoTo', index);
        },
        updateSliderOptions: function (options) {
            _.extend(this.sliderOptions, options);
        },
        isNextEnabled: function () {
            return this.getCurrentSlide() < this.children.length - this.getCurrentOptions('slidesToScroll');
        },
        isPrevEnabled: function () {
            return this.getCurrentSlide() !== 0;
        },
        getCurrentSlide: function () {
            return this.$el.slick('slickCurrentSlide');
        },
        getItem: function (index) {
            return this.children.findByIndex(index);
        },
        getCurrentItem: function () {
            return this.getItem(this.getCurrentSlide());
        },
        getCurrentOptions: function (option) {
            return this.$el.slick('slickGetOption', option);
        },
        triggerInitialized: function () {
            this.trigger('initialized');
        },
        triggerAfterChange: function (event, slick, currentSlide) {
            this.trigger('afterChange', currentSlide);
        },
        appendDummyItem: function () {
            var view = new DummyViewAllItem({
                viewAllUrl: this.viewAllUrl,
                viewAllText: this.viewAllText
            });
            view.render();
            this.$el.append(view.$el);
        },
        addItemView: function (item, ItemView, index) {
            if (_.isNumber(this.maxCount) && index >= this.maxCount) {
                return null;
            }
            return Marionette.CollectionView.prototype.addItemView.apply(this, arguments);
        }
    });
});
define('common-modules/containers/views/bundle-slider', [
    'common-modules/containers/templates/bundle-slider.tpl.html',
    'common-modules/containers/views/slider',
    'common-modules/containers/views/bundle-slider-content',
    'object-utils'
], function (template, Slider, BundleSliderContent, ObjectUtils) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'adb-feature-content',
        template: _.template(template),
        regions: { sliderContainer: '.adb-js-slider' },
        ui: {
            prevButton: '.adb-js-slider-prev',
            nextButton: '.adb-js-slider-next'
        },
        events: {
            'click @ui.prevButton': 'previous',
            'click @ui.nextButton': 'next'
        },
        defaults: {
            bundlesToShow: 2,
            maxCount: null
        },
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'headerText',
                'viewAllUrl',
                'bundlesToShow',
                'maxCount'
            ]);
        },
        onRender: function () {
            this.renderSlider();
        },
        renderSlider: function () {
            this.slider = new Slider({
                collection: this.collection,
                itemView: BundleSliderContent,
                maxCount: this.maxCount,
                sliderOptions: {
                    slidesToScroll: this.bundlesToShow,
                    slidesToShow: this.bundlesToShow,
                    infinite: false,
                    speed: 350,
                    lazyLoad: 'ondemand',
                    responsive: [{
                            breakpoint: 1280,
                            settings: {
                                slidesToScroll: this.bundlesToShow - 1,
                                slidesToShow: this.bundlesToShow - 1
                            }
                        }]
                }
            });
            this.sliderContainer.show(this.slider);
            this.listenTo(this.slider, 'initialized afterChange', this.checkForButtons);
        },
        previous: function () {
            this.slider.previous();
            this.checkForButtons();
        },
        next: function () {
            this.slider.next();
            this.checkForButtons();
        },
        checkForButtons: function () {
            this.toggleButton(this.ui.prevButton, this.slider.isPrevEnabled());
            this.toggleButton(this.ui.nextButton, this.slider.isNextEnabled());
        },
        toggleButton: function (button, enabled) {
            if (enabled) {
                this.enableButton(button);
            } else {
                this.disableButton(button);
            }
        },
        enableButton: function (button) {
            button.removeAttr('disabled');
        },
        disableButton: function (button) {
            button.attr('disabled', 'disabled');
        },
        serializeData: function () {
            return {
                headerText: this.headerText,
                viewAllUrl: this.viewAllUrl,
                prev: l('prev'),
                next: l('next')
            };
        }
    });
});
define('common-modules/containers/views/bundle', ['common-modules/containers/views/logo'], function (Logo) {
    'use strict';
    return Marionette.CollectionView.extend({
        className: 'adb-id_group',
        itemView: Logo,
        itemViewOptions: function (model) {
            return {
                grouped: true,
                linked: this.linked,
                size: this.size,
                form: this.form,
                fallback: this.fallback,
                url: model.get('url'),
                lazy: this.lazy
            };
        },
        initialize: function (options) {
            this.linked = !!options.linked;
            this.size = options.size;
            this.form = options.form;
            this.fallback = options.fallback;
            this.overlapping = !!options.overlapping;
            this.lazy = options.lazy;
        },
        onRender: function () {
            this.$el.toggleClass('adb-id_group__overlapping', this.overlapping);
        }
    }, {
        SIZES: Logo.SIZES,
        FORMS: Logo.FORMS,
        FALLBACK: Logo.FALLBACK
    });
});
define('common-modules/containers/templates/carousel-app-content.tpl.html', [], function () {
    return '<div class="adb-hero--item_card">\n\t<div class="adb-hero--item_image">\n\t\t<span class="helper"></span>\n\t\t<div class="adb-id">\n\t\t\t<img aria-label="<%- title %>" class="adb-id--img" alt="" src="<%- overviewImageUrl %>"/>\n\t\t</div>\n\t</div>\n\t<div class="adb-hero--item_content">\n\t\t<a class="adb-title__xxlarge" href="<%- appUrl %>"><%- title %></a>\n\t\t<p data-truncate="paragraph" title="<%- headlineText %>"><%- abbreviatedheadlineText %></p>\n\t\t<a href="<%- appUrl %>" class="adb-button adb-button__emphasis adb-button__large" type="button"><%- l(\'learn.more\') %></a>\n\t</div>\n</div>\n';
});
define('common-modules/containers/views/carousel-app-content', [
    'common-modules/containers/templates/carousel-app-content.tpl.html',
    'string-utils'
], function (Template, stringUtils) {
    'use strict';
    return Backbone.Marionette.Layout.extend({
        className: 'adb-hero--item',
        template: _.template(Template),
        serializeData: function () {
            return _.extend(this.model.toJSON(), { abbreviatedheadlineText: stringUtils.abbreviate(this.model.get('headlineText'), 90) });
        }
    });
});
define('common-modules/containers/templates/carousel.tpl.html', [], function () {
    return '<div class="adb-hero--container">\n\t<ul class="hero-carousel-nav">\n\t\t<li class="prev adb-js-slider-prev"><a></a></li>\n\t\t<li class="next adb-js-slider-next"><a></a></li>\n\t</ul>\n\t<div class="adb-hero--carousel hero-carousel-container adb-js-slider"></div>\n</div>\n';
});
define('common-modules/containers/views/carousel', [
    'common-modules/containers/templates/carousel.tpl.html',
    'common-modules/containers/views/slider',
    'common-modules/containers/views/carousel-app-content'
], function (template, Slider, CarouselAppContent) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'adb-hero',
        template: _.template(template),
        sliderItemView: CarouselAppContent,
        regions: { sliderContainer: '.adb-js-slider' },
        events: {
            'click .adb-js-slider-prev': 'previous',
            'click .adb-js-slider-next': 'next',
            'mouseenter .adb-js-slider-prev': 'onPreviousHover',
            'mouseenter .adb-js-slider-next': 'onNextHover',
            'mouseout .adb-js-slider-prev,.adb-js-slider-next': 'onHoverOut'
        },
        initialize: function (options) {
            options = options || {};
            this.autoplay = options.autoplay || false;
            this.autoplaySpeed = options.autoplaySpeed || 3000;
            this.collection = options.collection;
            this.selected = options.selected;
        },
        onRender: function () {
            this.renderSlider();
        },
        renderSlider: function () {
            this.slider = new Slider({
                collection: _.result(this, 'sliderItems'),
                itemView: _.isFunction(this.getSliderItemView) ? this.getSliderItemView() : this.sliderItemView,
                emptyView: this.emptyView,
                sliderOptions: this.getSliderOptions()
            });
            this.sliderContainer.show(this.slider);
            this.listenTo(this.slider, 'initialized afterChange', this.setActive);
            this.proxySliderMethods('getCurrentSlide', 'updateSliderOptions');
        },
        getSliderOptions: function () {
            return {
                autoplay: this.autoplay,
                autoplaySpeed: this.autoplaySpeed,
                slidesToShow: Math.max(this.collection.length - 1, 1),
                initialSlide: this.selected || 0
            };
        },
        proxySliderMethods: function () {
            _.each(arguments, function (methodName) {
                this[methodName] = _.bind(this.slider[methodName], this.slider);
            }, this);
        },
        sliderItems: function () {
            return this.collection;
        },
        previous: function () {
            this.removeAllHover();
            this.slider.previous();
            this.triggerMethod('position:change');
        },
        next: function () {
            this.removeAllHover();
            this.slider.next();
            this.triggerMethod('position:change');
        },
        setSlide: function (index) {
            this.slider.setSlide(index);
            this.triggerMethod('position:change');
        },
        onPreviousHover: function () {
            var currentSliderItem = this.slider.getCurrentItem();
            this.previousHovered = true;
            if (!!currentSliderItem) {
                this.setHover(currentSliderItem.$el.prev());
            }
        },
        onNextHover: function () {
            var currentSliderItem = this.slider.getCurrentItem();
            this.nextHovered = true;
            if (!!currentSliderItem) {
                this.setHover(currentSliderItem.$el.next());
            }
        },
        onHoverOut: function () {
            this.previousHovered = false;
            this.nextHovered = false;
            this.removeAllHover();
        },
        resetHover: function () {
            this.removeAllHover();
            if (this.previousHovered) {
                this.onPreviousHover();
            } else if (this.nextHovered) {
                this.onNextHover();
            }
        },
        setHover: function (item) {
            item.addClass('adb-is-hover');
        },
        setActive: function () {
            this.removeAllHover();
            this.removeAllActive();
            this.resetHover();
            var currentSliderItem = this.slider.getCurrentItem();
            if (currentSliderItem) {
                currentSliderItem.$el.addClass('adb-is-active');
            }
        },
        removeAllActive: function () {
            this.$el.find('.adb-is-active').removeClass('adb-is-active');
        },
        removeAllHover: function () {
            this.$el.find('.adb-is-hover').removeClass('adb-is-hover');
        }
    });
});
define('common-modules/containers/templates/container.tpl.html', [], function () {
    return '<div class="adb-basic-container_header">\n\t<h3 class="adb-container_header--title adb-container_header--item"><%- headerText %></h3>\n\t<div class="js-help-tooltip adb-container_header--title adb-container_header--item"></div>\n</div>\n<div class="adb-container_content js-content"></div>\n';
});
define('common-modules/containers/views/container', [
    'common-modules/containers/templates/container.tpl.html',
    'common-modules/forms/views/help-tooltip'
], function (containerTemplate, HelpTooltip) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'adb-basic-container',
        template: _.template(containerTemplate),
        regions: { content: '.js-content' },
        initialize: function () {
            if (this.helpText) {
                this.listenTo(this, 'show', this.showHelpTooltip);
                this.listenTo(this, 'before:close', this.hideHelpTooltip);
            }
        },
        hideHelpTooltip: function () {
            if (this.helpTooltip) {
                this.helpTooltip.close();
            }
        },
        showHelpTooltip: function () {
            this.hideHelpTooltip();
            this.helpTooltip = new HelpTooltip({ help: this.helpText });
            this.$('.js-help-tooltip').append(this.helpTooltip.render().el);
        },
        serializeData: function () {
            return { headerText: this.headerText };
        }
    });
});
define('common-modules/containers/views/description-list', [], function () {
    'use strict';
    var ListItemDd = Marionette.ItemView.extend({
        tagName: 'dd',
        template: function (attr) {
            if (attr.url) {
                return _.template('<a href="<%- url %>" target="<%- target %>" rel="noopener noreferrer"><%- value %></a>', attr);
            }
            if (attr.escape === false) {
                delete attr.escape;
                return _.template('<%= value %>', attr);
            }
            return _.template('<%- value %>', attr);
        },
        serializeData: function () {
            var target = this.model.get('openInNewTab') ? '_blank' : '_self';
            return _.extend(this.model.toJSON(), { target: target });
        }
    });
    var ListItemDt = Marionette.ItemView.extend({
        tagName: 'dt',
        template: _.template('<%- label %>:'),
        renderDD: function () {
            var className = this.model.get('className');
            this.dd = new ListItemDd({
                className: className,
                model: this.model
            });
            this.dd.render();
            return this.dd;
        },
        onClose: function () {
            this.dd.close();
        }
    });
    return Marionette.CollectionView.extend({
        tagName: 'dl',
        className: 'adb-description_list',
        itemView: ListItemDt,
        appendHtml: function (collectionView, itemView) {
            collectionView.$el.append(itemView.$el);
            collectionView.$el.append(itemView.renderDD().$el);
        }
    });
});
define('common-modules/containers/views/feature-slider', [
    'object-utils',
    'common-modules/containers/templates/feature-slider.tpl.html',
    'common-modules/containers/views/slider',
    'common-modules/containers/views/feature-slider-app-content'
], function (ObjectUtils, template, Slider, FeatureSliderAppContent) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'adb-feature-content',
        template: _.template(template),
        sliderItemView: FeatureSliderAppContent,
        regions: { sliderContainer: '.adb-js-slider' },
        ui: {
            prevButton: '.adb-js-slider-prev',
            nextButton: '.adb-js-slider-next'
        },
        events: {
            'click @ui.prevButton': 'previous',
            'click @ui.nextButton': 'next'
        },
        defaults: {
            slidesToShow: 4,
            maxCount: null
        },
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'headerText',
                'viewAllUrl',
                'viewAllText',
                'collection',
                'slidesToShow',
                'sliderItemView',
                'maxCount',
                'shouldAppendDummyViewAllItem'
            ]);
        },
        onRender: function () {
            this.renderSlider();
        },
        renderSlider: function () {
            this.slider = new Slider({
                collection: this.collection,
                itemView: this.sliderItemView,
                maxCount: this.maxCount,
                viewAllUrl: this.viewAllUrl,
                viewAllText: this.viewAllText || l('View.All'),
                shouldAppendDummyViewAllItem: this.shouldAppendDummyViewAllItem,
                sliderOptions: {
                    slidesToScroll: this.slidesToShow,
                    slidesToShow: this.slidesToShow,
                    infinite: false,
                    lazyLoad: 'ondemand',
                    speed: 350,
                    responsive: [{
                            breakpoint: 1280,
                            settings: {
                                slidesToScroll: this.slidesToShow - 1,
                                slidesToShow: this.slidesToShow - 1
                            }
                        }]
                }
            });
            this.sliderContainer.show(this.slider);
            this.listenTo(this.slider, 'initialized afterChange', this.checkForButtons);
        },
        serializeData: function () {
            return {
                headerText: this.headerText,
                viewAllUrl: this.viewAllUrl,
                viewAllText: this.viewAllText || l('View.All'),
                prev: l('prev'),
                next: l('next')
            };
        },
        previous: function () {
            this.slider.previous();
            this.checkForButtons();
        },
        next: function () {
            this.slider.next();
            this.checkForButtons();
        },
        checkForButtons: function () {
            this.toggleButton(this.ui.prevButton, this.slider.isPrevEnabled());
            this.toggleButton(this.ui.nextButton, this.slider.isNextEnabled());
        },
        toggleButton: function (button, enabled) {
            if (enabled) {
                this.enableButton(button);
            } else {
                this.disableButton(button);
            }
        },
        enableButton: function (button) {
            button.removeAttr('disabled');
        },
        disableButton: function (button) {
            button.attr('disabled', 'disabled');
        }
    });
});
define('common-modules/containers/views/flat-region', [], function () {
    'use strict';
    return Marionette.Region.extend({
        open: function (view) {
            var $target = this.$el;
            var name = $target.attr('class');
            $target.before('<!-- FlatRegion: ' + name + ' -->');
            $target.replaceWith(view.$el.contents());
        }
    });
});
define('common-modules/containers/templates/header.tpl.html', [], function () {
    return '<h1 class="adb-header--item"><%- title %></h1>\n<div class="adb-header--item js-actions-container"></div>\n';
});
define('common-modules/containers/views/header', ['common-modules/containers/templates/header.tpl.html'], function (template) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template(template),
        className: 'adb-header',
        regions: { actionsRegion: '.js-actions-container' },
        initialize: function (options) {
            this.actionsView = options.actionsView;
            this.title = options.title;
        },
        onRender: function () {
            if (this.actionsView) {
                this.actionsRegion.show(this.actionsView);
                this.actionsView.delegateEvents();
            }
        },
        serializeData: function () {
            return { title: this.title };
        }
    });
});
define('common-modules/containers/views/html-content', [], function () {
    'use strict';
    return Marionette.ItemView.extend({
        initialize: function (options) {
            options = options || {};
            this.template = function () {
                return options.html;
            };
        }
    }, {
        fromString: function (html) {
            return new this({ html: html });
        }
    });
});
define('common-modules/containers/views/inline-search-results', ['common-modules/navigations/views/dropdown-navigation'], function (DropdownNavigation) {
    'use strict';
    return DropdownNavigation.extend({
        resultItemView: DropdownNavigation.prototype.itemView.extend({
            addHref: function () {
            }
        }),
        messageItemView: DropdownNavigation.prototype.itemView.extend({
            template: _.template('<span class="adb-stack--item_content adb-no-link__option"><%-label%></span>'),
            triggers: {},
            addHref: function () {
            }
        }),
        getItemView: function (model) {
            return _.isUndefined(model.toJSON().value) ? this.messageItemView : this.resultItemView;
        }
    });
});
define('common-modules/containers/templates/placeholder.tpl.html', [], function () {
    return '\t<figure class="adb-placeholder--image"></figure>\n\t<div class="adb-placeholder--content"></div>\n\t<div class="adb-placeholder--controls"></div>\n';
});
define('common-modules/containers/views/placeholder', [
    'common-modules/containers/templates/placeholder.tpl.html',
    'common-modules/containers/views/html-content'
], function (template, HtmlContent) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template(template),
        className: 'adb-placeholder adb-js-placeholder',
        regions: {
            imageRegion: '.adb-placeholder--image',
            contentRegion: '.adb-placeholder--content',
            actionRegion: '.adb-placeholder--controls'
        },
        ui: {
            imageContainer: '.adb-placeholder--image',
            contentContainer: '.adb-placeholder--content',
            actionContainer: '.adb-placeholder--controls'
        },
        initialize: function (options) {
            options = options || {};
            this.type = options.type;
            if (_.isString(options.image)) {
                this.imageView = new HtmlContent({ html: options.image });
            } else {
                this.imageView = options.image;
            }
            if (_.isString(options.content)) {
                this.contentView = new HtmlContent({
                    tagName: 'p',
                    html: options.content
                });
            } else {
                this.contentView = options.content;
            }
            this.actionView = options.actions;
        },
        onRender: function () {
            if (this.type) {
                this.$el.addClass('adb-placeholder__' + this.type);
            }
            this._renderSection(this.imageView, this.imageRegion, this.ui.imageContainer);
            this._renderSection(this.contentView, this.contentRegion, this.ui.contentContainer);
            this._renderSection(this.actionView, this.actionRegion, this.ui.actionContainer);
        },
        _renderSection: function (view, region, container) {
            if (view) {
                region.show(view);
                view.delegateEvents();
            } else {
                container.remove();
            }
        }
    }, {
        TYPES: {
            CALLOUT: 'callout',
            CONDENSED: 'condensed'
        }
    });
});
define('backbone', [], function () {
    'use strict';
    return Backbone;
});
define('backbone-forms', [
    'jquery',
    'underscore',
    'backbone'
], function ($, _, Backbone) {
    var Form = Backbone.View.extend({
        events: {
            'submit': function (event) {
                this.trigger('submit', event);
            }
        },
        initialize: function (options) {
            var self = this;
            options = this.options = _.extend({ submitButton: false }, options);
            var schema = this.schema = function () {
                if (options.schema)
                    return _.result(options, 'schema');
                var model = options.model;
                if (model && model.schema)
                    return _.result(model, 'schema');
                if (self.schema)
                    return _.result(self, 'schema');
                return {};
            }();
            _.extend(this, _.pick(options, 'model', 'data', 'idPrefix', 'templateData'));
            var constructor = this.constructor;
            this.template = options.template || this.template || constructor.template;
            this.Fieldset = options.Fieldset || this.Fieldset || constructor.Fieldset;
            this.Field = options.Field || this.Field || constructor.Field;
            this.NestedField = options.NestedField || this.NestedField || constructor.NestedField;
            var selectedFields = this.selectedFields = options.fields || _.keys(schema);
            var fields = this.fields = {};
            _.each(selectedFields, function (key) {
                var fieldSchema = schema[key];
                fields[key] = this.createField(key, fieldSchema);
            }, this);
            var fieldsetSchema = options.fieldsets || _.result(this, 'fieldsets') || _.result(this.model, 'fieldsets') || [selectedFields], fieldsets = this.fieldsets = [];
            _.each(fieldsetSchema, function (itemSchema) {
                this.fieldsets.push(this.createFieldset(itemSchema));
            }, this);
        },
        createFieldset: function (schema) {
            var options = {
                schema: schema,
                fields: this.fields,
                legend: schema.legend || null
            };
            return new this.Fieldset(options);
        },
        createField: function (key, schema) {
            var options = {
                form: this,
                key: key,
                schema: schema,
                idPrefix: this.idPrefix
            };
            if (this.model) {
                options.model = this.model;
            } else if (this.data) {
                options.value = this.data[key];
            } else {
                options.value = null;
            }
            var field = new this.Field(options);
            this.listenTo(field.editor, 'all', this.handleEditorEvent);
            return field;
        },
        handleEditorEvent: function (event, editor) {
            var formEvent = editor.key + ':' + event;
            this.trigger.call(this, formEvent, this, editor, Array.prototype.slice.call(arguments, 2));
            switch (event) {
            case 'change':
                this.trigger('change', this);
                break;
            case 'focus':
                if (!this.hasFocus)
                    this.trigger('focus', this);
                break;
            case 'blur':
                if (this.hasFocus) {
                    var self = this;
                    setTimeout(function () {
                        var focusedField = _.find(self.fields, function (field) {
                            return field.editor.hasFocus;
                        });
                        if (!focusedField)
                            self.trigger('blur', self);
                    }, 0);
                }
                break;
            }
        },
        templateData: function () {
            var options = this.options;
            return { submitButton: options.submitButton };
        },
        render: function () {
            var self = this, fields = this.fields, $ = Backbone.$;
            var $form = $($.trim(this.template(_.result(this, 'templateData'))));
            $form.find('[data-editors]').add($form).each(function (i, el) {
                var $container = $(el), selection = $container.attr('data-editors');
                if (_.isUndefined(selection))
                    return;
                var keys = selection == '*' ? self.selectedFields || _.keys(fields) : selection.split(',');
                _.each(keys, function (key) {
                    var field = fields[key];
                    $container.append(field.editor.render().el);
                });
            });
            $form.find('[data-fields]').add($form).each(function (i, el) {
                var $container = $(el), selection = $container.attr('data-fields');
                if (_.isUndefined(selection))
                    return;
                var keys = selection == '*' ? self.selectedFields || _.keys(fields) : selection.split(',');
                _.each(keys, function (key) {
                    var field = fields[key];
                    $container.append(field.render().el);
                });
            });
            $form.find('[data-fieldsets]').add($form).each(function (i, el) {
                var $container = $(el), selection = $container.attr('data-fieldsets');
                if (_.isUndefined(selection))
                    return;
                _.each(self.fieldsets, function (fieldset) {
                    $container.append(fieldset.render().el);
                });
            });
            this.setElement($form);
            $form.addClass(this.className);
            return this;
        },
        validate: function (options) {
            var self = this, fields = this.fields, model = this.model, errors = {};
            options = options || {};
            _.each(fields, function (field) {
                var error = field.validate();
                if (error) {
                    errors[field.key] = error;
                }
            });
            if (!options.skipModelValidate && model && model.validate) {
                var modelErrors = model.validate(this.getValue());
                if (modelErrors) {
                    var isDictionary = _.isObject(modelErrors) && !_.isArray(modelErrors);
                    if (!isDictionary) {
                        errors._others = errors._others || [];
                        errors._others.push(modelErrors);
                    }
                    if (isDictionary) {
                        _.each(modelErrors, function (val, key) {
                            if (fields[key] && !errors[key]) {
                                fields[key].setError(val);
                                errors[key] = val;
                            } else {
                                errors._others = errors._others || [];
                                var tmpErr = {};
                                tmpErr[key] = val;
                                errors._others.push(tmpErr);
                            }
                        });
                    }
                }
            }
            return _.isEmpty(errors) ? null : errors;
        },
        commit: function (options) {
            options = options || {};
            var validateOptions = { skipModelValidate: !options.validate };
            var errors = this.validate(validateOptions);
            if (errors)
                return errors;
            var modelError;
            var setOptions = _.extend({
                error: function (model, e) {
                    modelError = e;
                }
            }, options);
            this.model.set(this.getValue(), setOptions);
            if (modelError)
                return modelError;
        },
        getValue: function (key) {
            if (key)
                return this.fields[key].getValue();
            var values = {};
            _.each(this.fields, function (field) {
                values[field.key] = field.getValue();
            });
            return values;
        },
        setValue: function (prop, val) {
            var data = {};
            if (typeof prop === 'string') {
                data[prop] = val;
            } else {
                data = prop;
            }
            var key;
            for (key in this.schema) {
                if (data[key] !== undefined) {
                    this.fields[key].setValue(data[key]);
                }
            }
        },
        getEditor: function (key) {
            var field = this.fields[key];
            if (!field)
                throw new Error('Field not found: ' + key);
            return field.editor;
        },
        focus: function () {
            if (this.hasFocus)
                return;
            var fieldset = this.fieldsets[0], field = fieldset.getFieldAt(0);
            if (!field)
                return;
            field.editor.focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            var focusedField = _.find(this.fields, function (field) {
                return field.editor.hasFocus;
            });
            if (focusedField)
                focusedField.editor.blur();
        },
        trigger: function (event) {
            if (event === 'focus') {
                this.hasFocus = true;
            } else if (event === 'blur') {
                this.hasFocus = false;
            }
            return Backbone.View.prototype.trigger.apply(this, arguments);
        },
        remove: function () {
            _.each(this.fieldsets, function (fieldset) {
                fieldset.remove();
            });
            _.each(this.fields, function (field) {
                field.remove();
            });
            return Backbone.View.prototype.remove.apply(this, arguments);
        }
    }, {
        template: _.template('    <form>     <div data-fieldsets></div>      <% if (submitButton) { %>        <button type="submit"><%= submitButton %></button>      <% } %>    </form>  ', null, this.templateSettings),
        templateSettings: {
            evaluate: /<%([\s\S]+?)%>/g,
            interpolate: /<%=([\s\S]+?)%>/g,
            escape: /<%-([\s\S]+?)%>/g
        },
        editors: {}
    });
    Form.validators = function () {
        var validators = {};
        validators.errMessages = {
            required: 'Required',
            regexp: 'Invalid',
            number: 'Must be a number',
            email: 'Invalid email address',
            url: 'Invalid URL',
            match: _.template('Must match field "<%= field %>"', null, Form.templateSettings)
        };
        validators.required = function (options) {
            options = _.extend({
                type: 'required',
                message: this.errMessages.required
            }, options);
            return function required(value) {
                options.value = value;
                var err = {
                    type: options.type,
                    message: _.isFunction(options.message) ? options.message(options) : options.message
                };
                if (value === null || value === undefined || value === false || value === '')
                    return err;
            };
        };
        validators.regexp = function (options) {
            if (!options.regexp)
                throw new Error('Missing required "regexp" option for "regexp" validator');
            options = _.extend({
                type: 'regexp',
                match: true,
                message: this.errMessages.regexp
            }, options);
            return function regexp(value) {
                options.value = value;
                var err = {
                    type: options.type,
                    message: _.isFunction(options.message) ? options.message(options) : options.message
                };
                if (value === null || value === undefined || value === '')
                    return;
                if ('string' === typeof options.regexp)
                    options.regexp = new RegExp(options.regexp, options.flags);
                if (options.match ? !options.regexp.test(value) : options.regexp.test(value))
                    return err;
            };
        };
        validators.number = function (options) {
            options = _.extend({
                type: 'number',
                message: this.errMessages.number,
                regexp: /^[0-9]*\.?[0-9]*?$/
            }, options);
            return validators.regexp(options);
        };
        validators.email = function (options) {
            options = _.extend({
                type: 'email',
                message: this.errMessages.email,
                regexp: /^[\w\-]{1,}([\w\-\+.]{1,1}[\w\-]{1,}){0,}[@][\w\-]{1,}([.]([\w\-]{1,})){1,3}$/
            }, options);
            return validators.regexp(options);
        };
        validators.url = function (options) {
            options = _.extend({
                type: 'url',
                message: this.errMessages.url,
                regexp: /^(http|https):\/\/(([A-Z0-9][A-Z0-9_\-]*)(\.[A-Z0-9][A-Z0-9_\-]*)+)(:(\d+))?\/?/i
            }, options);
            return validators.regexp(options);
        };
        validators.match = function (options) {
            if (!options.field)
                throw new Error('Missing required "field" options for "match" validator');
            options = _.extend({
                type: 'match',
                message: this.errMessages.match
            }, options);
            return function match(value, attrs) {
                options.value = value;
                var err = {
                    type: options.type,
                    message: _.isFunction(options.message) ? options.message(options) : options.message
                };
                if (value === null || value === undefined || value === '')
                    return;
                if (value !== attrs[options.field])
                    return err;
            };
        };
        return validators;
    }();
    Form.Fieldset = Backbone.View.extend({
        initialize: function (options) {
            options = options || {};
            var schema = this.schema = this.createSchema(options.schema);
            this.fields = _.pick(options.fields, schema.fields);
            this.template = options.template || schema.template || this.template || this.constructor.template;
        },
        createSchema: function (schema) {
            if (_.isArray(schema)) {
                schema = { fields: schema };
            }
            schema.legend = schema.legend || null;
            return schema;
        },
        getFieldAt: function (index) {
            var key = this.schema.fields[index];
            return this.fields[key];
        },
        templateData: function () {
            return this.schema;
        },
        render: function () {
            var schema = this.schema, fields = this.fields, $ = Backbone.$;
            var $fieldset = $($.trim(this.template(_.result(this, 'templateData'))));
            $fieldset.find('[data-fields]').add($fieldset).each(function (i, el) {
                var $container = $(el), selection = $container.attr('data-fields');
                if (_.isUndefined(selection))
                    return;
                _.each(fields, function (field) {
                    $container.append(field.render().el);
                });
            });
            this.setElement($fieldset);
            return this;
        },
        remove: function () {
            _.each(this.fields, function (field) {
                field.remove();
            });
            Backbone.View.prototype.remove.call(this);
        }
    }, { template: _.template('    <fieldset data-fields>      <% if (legend) { %>        <legend><%= legend %></legend>      <% } %>    </fieldset>  ', null, Form.templateSettings) });
    Form.Field = Backbone.View.extend({
        initialize: function (options) {
            options = options || {};
            _.extend(this, _.pick(options, 'form', 'key', 'model', 'value', 'idPrefix'));
            var schema = this.schema = this.createSchema(options.schema);
            this.template = options.template || schema.template || this.template || this.constructor.template;
            this.errorClassName = options.errorClassName || this.errorClassName || this.constructor.errorClassName;
            this.editor = this.createEditor();
        },
        createSchema: function (schema) {
            if (_.isString(schema))
                schema = { type: schema };
            schema = _.extend({
                type: 'Text',
                title: this.createTitle()
            }, schema);
            schema.type = _.isString(schema.type) ? Form.editors[schema.type] : schema.type;
            return schema;
        },
        createEditor: function () {
            var options = _.extend(_.pick(this, 'schema', 'form', 'key', 'model', 'value'), { id: this.createEditorId() });
            var constructorFn = this.schema.type;
            return new constructorFn(options);
        },
        createEditorId: function () {
            var prefix = this.idPrefix, id = this.key;
            id = id.replace(/\./g, '_');
            if (_.isString(prefix) || _.isNumber(prefix))
                return prefix + id;
            if (_.isNull(prefix))
                return id;
            if (this.model)
                return this.model.cid + '_' + id;
            return id;
        },
        createTitle: function () {
            var str = this.key;
            str = str.replace(/([A-Z])/g, ' $1');
            str = str.replace(/^./, function (str) {
                return str.toUpperCase();
            });
            return str;
        },
        templateData: function () {
            var schema = this.schema;
            return {
                help: schema.help || '',
                title: schema.title,
                titleHTML: schema.titleHTML,
                fieldAttrs: schema.fieldAttrs,
                editorAttrs: schema.editorAttrs,
                key: this.key,
                editorId: this.editor.id
            };
        },
        render: function () {
            var schema = this.schema, editor = this.editor, $ = Backbone.$;
            if (this.editor.noField === true) {
                return this.setElement(editor.render().el);
            }
            var $field = $($.trim(this.template(_.result(this, 'templateData'))));
            if (schema.fieldClass)
                $field.addClass(schema.fieldClass);
            if (schema.fieldAttrs)
                $field.attr(schema.fieldAttrs);
            $field.find('[data-editor]').add($field).each(function (i, el) {
                var $container = $(el), selection = $container.attr('data-editor');
                if (_.isUndefined(selection))
                    return;
                $container.append(editor.render().el);
            });
            this.setElement($field);
            return this;
        },
        disable: function () {
            if (_.isFunction(this.editor.disable)) {
                this.editor.disable();
            } else {
                $input = this.editor.$el;
                $input = $input.is('input') ? $input : $input.find('input');
                $input.attr('disabled', true);
            }
        },
        enable: function () {
            if (_.isFunction(this.editor.enable)) {
                this.editor.enable();
            } else {
                $input = this.editor.$el;
                $input = $input.is('input') ? $input : $input.find('input');
                $input.attr('disabled', false);
            }
        },
        validate: function () {
            var error = this.editor.validate();
            if (error) {
                this.setError(error.message);
            } else {
                this.clearError();
            }
            return error;
        },
        setError: function (msg) {
            if (this.editor.hasNestedForm)
                return;
            this.$el.addClass(this.errorClassName);
            this.$('[data-error]').html(msg);
        },
        clearError: function () {
            this.$el.removeClass(this.errorClassName);
            this.$('[data-error]').empty();
        },
        commit: function () {
            return this.editor.commit();
        },
        getValue: function () {
            return this.editor.getValue();
        },
        setValue: function (value) {
            this.editor.setValue(value);
        },
        focus: function () {
            this.editor.focus();
        },
        blur: function () {
            this.editor.blur();
        },
        remove: function () {
            this.editor.remove();
            Backbone.View.prototype.remove.call(this);
        }
    }, {
        template: _.template('    <div>      <label for="<%= editorId %>">        <% if (titleHTML){ %><%= titleHTML %>        <% } else { %><%- title %><% } %>      </label>      <div>        <span data-editor></span>        <div data-error></div>        <div><%= help %></div>      </div>    </div>  ', null, Form.templateSettings),
        errorClassName: 'error'
    });
    Form.NestedField = Form.Field.extend({ template: _.template('    <div>      <label for="<%= editorId %>">        <% if (titleHTML){ %><%= titleHTML %>        <% } else { %><%- title %><% } %>      </label>      <div>        <span data-editor></span>        <div class="error-text" data-error></div>        <div class="error-help"><%= help %></div>      </div>    </div>  ', null, Form.templateSettings) });
    Form.Editor = Form.editors.Base = Backbone.View.extend({
        defaultValue: null,
        hasFocus: false,
        initialize: function (options) {
            var options = options || {};
            if (options.model) {
                if (!options.key)
                    throw new Error('Missing option: \'key\'');
                this.model = options.model;
                this.value = this.model.get(options.key);
            } else if (options.value !== undefined) {
                this.value = options.value;
            }
            if (this.value === undefined)
                this.value = this.defaultValue;
            _.extend(this, _.pick(options, 'key', 'form'));
            var schema = this.schema = options.schema || {};
            this.validators = options.validators || schema.validators;
            this.$el.attr('id', this.id);
            this.$el.attr('name', this.getName());
            if (schema.editorClass)
                this.$el.addClass(schema.editorClass);
            if (schema.editorAttrs)
                this.$el.attr(schema.editorAttrs);
        },
        getName: function () {
            var key = this.key || '';
            return key.replace(/\./g, '_');
        },
        getValue: function () {
            return this.value;
        },
        setValue: function (value) {
            this.value = value;
        },
        focus: function () {
            throw new Error('Not implemented');
        },
        blur: function () {
            throw new Error('Not implemented');
        },
        commit: function (options) {
            var error = this.validate();
            if (error)
                return error;
            this.listenTo(this.model, 'invalid', function (model, e) {
                error = e;
            });
            this.model.set(this.key, this.getValue(), options);
            if (error)
                return error;
        },
        validate: function () {
            var $el = this.$el, error = null, value = this.getValue(), formValues = this.form ? this.form.getValue() : {}, validators = this.validators, getValidator = this.getValidator;
            if (validators) {
                _.every(validators, function (validator) {
                    error = getValidator(validator)(value, formValues);
                    return error ? false : true;
                });
            }
            return error;
        },
        trigger: function (event) {
            if (event === 'focus') {
                this.hasFocus = true;
            } else if (event === 'blur') {
                this.hasFocus = false;
            }
            return Backbone.View.prototype.trigger.apply(this, arguments);
        },
        getValidator: function (validator) {
            var validators = Form.validators;
            if (_.isRegExp(validator)) {
                return validators.regexp({ regexp: validator });
            }
            if (_.isString(validator)) {
                if (!validators[validator])
                    throw new Error('Validator "' + validator + '" not found');
                return validators[validator]();
            }
            if (_.isFunction(validator))
                return validator;
            if (_.isObject(validator) && validator.type) {
                var config = validator;
                return validators[config.type](config);
            }
            throw new Error('Invalid validator: ' + validator);
        }
    });
    Form.editors.Text = Form.Editor.extend({
        tagName: 'input',
        defaultValue: '',
        previousValue: '',
        events: {
            'keyup': 'determineChange',
            'keypress': function (event) {
                var self = this;
                setTimeout(function () {
                    self.determineChange();
                }, 0);
            },
            'select': function (event) {
                this.trigger('select', this);
            },
            'focus': function (event) {
                this.trigger('focus', this);
            },
            'blur': function (event) {
                this.trigger('blur', this);
            }
        },
        initialize: function (options) {
            Form.editors.Base.prototype.initialize.call(this, options);
            var schema = this.schema;
            var type = 'text';
            if (schema && schema.editorAttrs && schema.editorAttrs.type)
                type = schema.editorAttrs.type;
            if (schema && schema.dataType)
                type = schema.dataType;
            this.$el.attr('type', type);
        },
        render: function () {
            this.setValue(this.value);
            return this;
        },
        determineChange: function (event) {
            var currentValue = this.$el.val();
            var changed = currentValue !== this.previousValue;
            if (changed) {
                this.previousValue = currentValue;
                this.trigger('change', this);
            }
        },
        getValue: function () {
            return this.$el.val();
        },
        setValue: function (value) {
            this.$el.val(value);
        },
        focus: function () {
            if (this.hasFocus)
                return;
            this.$el.focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            this.$el.blur();
        },
        select: function () {
            this.$el.select();
        }
    });
    Form.editors.TextArea = Form.editors.Text.extend({
        tagName: 'textarea',
        initialize: function (options) {
            Form.editors.Base.prototype.initialize.call(this, options);
        }
    });
    Form.editors.Password = Form.editors.Text.extend({
        initialize: function (options) {
            Form.editors.Text.prototype.initialize.call(this, options);
            this.$el.attr('type', 'password');
        }
    });
    Form.editors.Number = Form.editors.Text.extend({
        defaultValue: 0,
        events: _.extend({}, Form.editors.Text.prototype.events, {
            'keypress': 'onKeyPress',
            'change': 'onKeyPress'
        }),
        initialize: function (options) {
            Form.editors.Text.prototype.initialize.call(this, options);
            var schema = this.schema;
            this.$el.attr('type', 'number');
            if (!schema || !schema.editorAttrs || !schema.editorAttrs.step) {
                this.$el.attr('step', 'any');
            }
        },
        onKeyPress: function (event) {
            var self = this, delayedDetermineChange = function () {
                    setTimeout(function () {
                        self.determineChange();
                    }, 0);
                };
            if (event.charCode === 0) {
                delayedDetermineChange();
                return;
            }
            var newVal = this.$el.val();
            if (event.charCode != undefined) {
                newVal = newVal + String.fromCharCode(event.charCode);
            }
            var numeric = /^[0-9]*\.?[0-9]*?$/.test(newVal);
            if (numeric) {
                delayedDetermineChange();
            } else {
                event.preventDefault();
            }
        },
        getValue: function () {
            var value = this.$el.val();
            return value === '' ? null : parseFloat(value, 10);
        },
        setValue: function (value) {
            value = function () {
                if (_.isNumber(value))
                    return value;
                if (_.isString(value) && value !== '')
                    return parseFloat(value, 10);
                return null;
            }();
            if (_.isNaN(value))
                value = null;
            Form.editors.Text.prototype.setValue.call(this, value);
        }
    });
    Form.editors.Hidden = Form.editors.Text.extend({
        defaultValue: '',
        noField: true,
        initialize: function (options) {
            Form.editors.Text.prototype.initialize.call(this, options);
            this.$el.attr('type', 'hidden');
        },
        focus: function () {
        },
        blur: function () {
        }
    });
    Form.editors.Checkbox = Form.editors.Base.extend({
        defaultValue: false,
        tagName: 'input',
        events: {
            'click': function (event) {
                this.trigger('change', this);
            },
            'focus': function (event) {
                this.trigger('focus', this);
            },
            'blur': function (event) {
                this.trigger('blur', this);
            }
        },
        initialize: function (options) {
            Form.editors.Base.prototype.initialize.call(this, options);
            this.$el.attr('type', 'checkbox');
        },
        render: function () {
            this.setValue(this.value);
            return this;
        },
        getValue: function () {
            return this.$el.prop('checked');
        },
        setValue: function (value) {
            if (value) {
                this.$el.prop('checked', true);
            } else {
                this.$el.prop('checked', false);
            }
        },
        focus: function () {
            if (this.hasFocus)
                return;
            this.$el.focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            this.$el.blur();
        }
    });
    Form.editors.Select = Form.editors.Base.extend({
        tagName: 'select',
        previousValue: '',
        events: {
            'keyup': 'determineChange',
            'keypress': function (event) {
                var self = this;
                setTimeout(function () {
                    self.determineChange();
                }, 0);
            },
            'change': function (event) {
                this.trigger('change', this);
            },
            'focus': function (event) {
                this.trigger('focus', this);
            },
            'blur': function (event) {
                this.trigger('blur', this);
            }
        },
        initialize: function (options) {
            Form.editors.Base.prototype.initialize.call(this, options);
            if (!this.schema || !this.schema.options)
                throw new Error('Missing required \'schema.options\'');
        },
        render: function () {
            this.setOptions(this.schema.options);
            return this;
        },
        setOptions: function (options) {
            var self = this;
            if (options instanceof Backbone.Collection) {
                var collection = options;
                if (collection.length > 0) {
                    this.renderOptions(options);
                } else {
                    collection.fetch({
                        success: function (collection) {
                            self.renderOptions(options);
                        }
                    });
                }
            } else if (_.isFunction(options)) {
                options(function (result) {
                    self.renderOptions(result);
                }, self);
            } else {
                this.renderOptions(options);
            }
        },
        renderOptions: function (options) {
            var $select = this.$el, html;
            html = this._getOptionsHtml(options);
            $select.html(html);
            this.setValue(this.value);
        },
        _getOptionsHtml: function (options) {
            var html;
            if (_.isString(options)) {
                html = options;
            } else if (_.isArray(options)) {
                html = this._arrayToHtml(options);
            } else if (options instanceof Backbone.Collection) {
                html = this._collectionToHtml(options);
            } else if (_.isFunction(options)) {
                var newOptions;
                options(function (opts) {
                    newOptions = opts;
                }, this);
                html = this._getOptionsHtml(newOptions);
            } else {
                html = this._objectToHtml(options);
            }
            return html;
        },
        determineChange: function (event) {
            var currentValue = this.getValue();
            var changed = currentValue !== this.previousValue;
            if (changed) {
                this.previousValue = currentValue;
                this.trigger('change', this);
            }
        },
        getValue: function () {
            return this.$el.val();
        },
        setValue: function (value) {
            this.$el.val(value);
        },
        focus: function () {
            if (this.hasFocus)
                return;
            this.$el.focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            this.$el.blur();
        },
        _collectionToHtml: function (collection) {
            var array = [];
            collection.each(function (model) {
                array.push({
                    val: model.id,
                    label: model.toString()
                });
            });
            var html = this._arrayToHtml(array);
            return html;
        },
        _objectToHtml: function (obj) {
            var array = [];
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    array.push({
                        val: key,
                        label: obj[key]
                    });
                }
            }
            var html = this._arrayToHtml(array);
            return html;
        },
        _arrayToHtml: function (array) {
            var html = $();
            _.each(array, function (option) {
                if (_.isObject(option)) {
                    if (option.group) {
                        var optgroup = $('<optgroup>').attr('label', option.group).html(this._getOptionsHtml(option.options));
                        html = html.add(optgroup);
                    } else {
                        var val = option.val || option.val === 0 ? option.val : '';
                        html = html.add($('<option>').val(val).text(option.label));
                    }
                } else {
                    html = html.add($('<option>').text(option));
                }
            }, this);
            return html;
        }
    });
    Form.editors.Radio = Form.editors.Select.extend({
        tagName: 'ul',
        events: {
            'change input[type=radio]': function () {
                this.trigger('change', this);
            },
            'focus input[type=radio]': function () {
                if (this.hasFocus)
                    return;
                this.trigger('focus', this);
            },
            'blur input[type=radio]': function () {
                if (!this.hasFocus)
                    return;
                var self = this;
                setTimeout(function () {
                    if (self.$('input[type=radio]:focus')[0])
                        return;
                    self.trigger('blur', self);
                }, 0);
            }
        },
        getTemplate: function () {
            return this.schema.template || this.constructor.template;
        },
        getValue: function () {
            return this.$('input[type=radio]:checked').val();
        },
        setValue: function (value) {
            this.$('input[type=radio]').val([value]);
        },
        focus: function () {
            if (this.hasFocus)
                return;
            var checked = this.$('input[type=radio]:checked');
            if (checked[0]) {
                checked.focus();
                return;
            }
            this.$('input[type=radio]').first().focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            this.$('input[type=radio]:focus').blur();
        },
        _arrayToHtml: function (array) {
            var self = this;
            var template = this.getTemplate(), name = self.getName(), id = self.id;
            var items = _.map(array, function (option, index) {
                var item = {
                    name: name,
                    id: id + '-' + index
                };
                if (_.isObject(option)) {
                    item.value = option.val || option.val === 0 ? option.val : '';
                    item.label = option.label;
                    item.labelHTML = option.labelHTML;
                } else {
                    item.value = option;
                    item.label = option;
                }
                return item;
            });
            return template({ items: items });
        }
    }, { template: _.template('    <% _.each(items, function(item) { %>      <li>        <input type="radio" name="<%= item.name %>" value="<%- item.value %>" id="<%= item.id %>" />        <label for="<%= item.id %>"><% if (item.labelHTML){ %><%= item.labelHTML %><% }else{ %><%- item.label %><% } %></label>      </li>    <% }); %>  ', null, Form.templateSettings) });
    Form.editors.Checkboxes = Form.editors.Select.extend({
        tagName: 'ul',
        groupNumber: 0,
        events: {
            'click input[type=checkbox]': function () {
                this.trigger('change', this);
            },
            'focus input[type=checkbox]': function () {
                if (this.hasFocus)
                    return;
                this.trigger('focus', this);
            },
            'blur input[type=checkbox]': function () {
                if (!this.hasFocus)
                    return;
                var self = this;
                setTimeout(function () {
                    if (self.$('input[type=checkbox]:focus')[0])
                        return;
                    self.trigger('blur', self);
                }, 0);
            }
        },
        getValue: function () {
            var values = [];
            this.$('input[type=checkbox]:checked').each(function () {
                values.push($(this).val());
            });
            return values;
        },
        setValue: function (values) {
            if (!_.isArray(values))
                values = [values];
            this.$('input[type=checkbox]').val(values);
        },
        focus: function () {
            if (this.hasFocus)
                return;
            this.$('input[type=checkbox]').first().focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            this.$('input[type=checkbox]:focus').blur();
        },
        _arrayToHtml: function (array) {
            var html = $();
            var self = this;
            _.each(array, function (option, index) {
                var itemHtml = $('<li>');
                if (_.isObject(option)) {
                    if (option.group) {
                        var originalId = self.id;
                        self.id += '-' + self.groupNumber++;
                        itemHtml = $('<fieldset class="group">').append($('<legend>').text(option.group));
                        itemHtml = itemHtml.append(self._arrayToHtml(option.options));
                        self.id = originalId;
                        close = false;
                    } else {
                        var val = option.val || option.val === 0 ? option.val : '';
                        itemHtml.append($('<input type="checkbox" name="' + self.getName() + '" id="' + self.id + '-' + index + '" />').val(val));
                        if (option.labelHTML) {
                            itemHtml.append($('<label for="' + self.id + '-' + index + '">').html(option.labelHTML));
                        } else {
                            itemHtml.append($('<label for="' + self.id + '-' + index + '">').text(option.label));
                        }
                    }
                } else {
                    itemHtml.append($('<input type="checkbox" name="' + self.getName() + '" id="' + self.id + '-' + index + '" />').val(option));
                    itemHtml.append($('<label for="' + self.id + '-' + index + '">').text(option));
                }
                html = html.add(itemHtml);
            });
            return html;
        }
    });
    Form.editors.Object = Form.editors.Base.extend({
        hasNestedForm: true,
        initialize: function (options) {
            this.value = {};
            Form.editors.Base.prototype.initialize.call(this, options);
            if (!this.form)
                throw new Error('Missing required option "form"');
            if (!this.schema.subSchema)
                throw new Error('Missing required \'schema.subSchema\' option for Object editor');
        },
        render: function () {
            var NestedForm = this.form.constructor;
            this.nestedForm = new NestedForm({
                schema: this.schema.subSchema,
                data: this.value,
                idPrefix: this.id + '_',
                Field: NestedForm.NestedField
            });
            this._observeFormEvents();
            this.$el.html(this.nestedForm.render().el);
            if (this.hasFocus)
                this.trigger('blur', this);
            return this;
        },
        getValue: function () {
            if (this.nestedForm)
                return this.nestedForm.getValue();
            return this.value;
        },
        setValue: function (value) {
            this.value = value;
            this.render();
        },
        focus: function () {
            if (this.hasFocus)
                return;
            this.nestedForm.focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            this.nestedForm.blur();
        },
        remove: function () {
            this.nestedForm.remove();
            Backbone.View.prototype.remove.call(this);
        },
        validate: function () {
            var errors = _.extend({}, Form.editors.Base.prototype.validate.call(this), this.nestedForm.validate());
            return _.isEmpty(errors) ? false : errors;
        },
        _observeFormEvents: function () {
            if (!this.nestedForm)
                return;
            this.nestedForm.on('all', function () {
                var args = _.toArray(arguments);
                args[1] = this;
                this.trigger.apply(this, args);
            }, this);
        }
    });
    Form.editors.NestedModel = Form.editors.Object.extend({
        initialize: function (options) {
            Form.editors.Base.prototype.initialize.call(this, options);
            if (!this.form)
                throw new Error('Missing required option "form"');
            if (!options.schema.model)
                throw new Error('Missing required "schema.model" option for NestedModel editor');
        },
        render: function () {
            var NestedForm = this.form.constructor;
            var data = this.value || {}, key = this.key, nestedModel = this.schema.model;
            var modelInstance = data.constructor === nestedModel ? data : new nestedModel(data);
            this.nestedForm = new NestedForm({
                model: modelInstance,
                idPrefix: this.id + '_',
                fieldTemplate: 'nestedField'
            });
            this._observeFormEvents();
            this.$el.html(this.nestedForm.render().el);
            if (this.hasFocus)
                this.trigger('blur', this);
            return this;
        },
        commit: function () {
            var error = this.nestedForm.commit();
            if (error) {
                this.$el.addClass('error');
                return error;
            }
            return Form.editors.Object.prototype.commit.call(this);
        }
    });
    Form.editors.Date = Form.editors.Base.extend({
        events: {
            'change select': function () {
                this.updateHidden();
                this.trigger('change', this);
            },
            'focus select': function () {
                if (this.hasFocus)
                    return;
                this.trigger('focus', this);
            },
            'blur select': function () {
                if (!this.hasFocus)
                    return;
                var self = this;
                setTimeout(function () {
                    if (self.$('select:focus')[0])
                        return;
                    self.trigger('blur', self);
                }, 0);
            }
        },
        initialize: function (options) {
            options = options || {};
            Form.editors.Base.prototype.initialize.call(this, options);
            var Self = Form.editors.Date, today = new Date();
            this.options = _.extend({
                monthNames: Self.monthNames,
                showMonthNames: Self.showMonthNames
            }, options);
            this.schema = _.extend({
                yearStart: today.getFullYear() - 100,
                yearEnd: today.getFullYear()
            }, options.schema || {});
            if (this.value && !_.isDate(this.value)) {
                this.value = new Date(this.value);
            }
            if (!this.value) {
                var date = new Date();
                date.setSeconds(0);
                date.setMilliseconds(0);
                this.value = date;
            }
            this.template = options.template || this.constructor.template;
        },
        render: function () {
            var options = this.options, schema = this.schema, $ = Backbone.$;
            var datesOptions = _.map(_.range(1, 32), function (date) {
                return '<option value="' + date + '">' + date + '</option>';
            });
            var monthsOptions = _.map(_.range(0, 12), function (month) {
                var value = options.showMonthNames ? options.monthNames[month] : month + 1;
                return '<option value="' + month + '">' + value + '</option>';
            });
            var yearRange = schema.yearStart < schema.yearEnd ? _.range(schema.yearStart, schema.yearEnd + 1) : _.range(schema.yearStart, schema.yearEnd - 1, -1);
            var yearsOptions = _.map(yearRange, function (year) {
                return '<option value="' + year + '">' + year + '</option>';
            });
            var $el = $($.trim(this.template({
                dates: datesOptions.join(''),
                months: monthsOptions.join(''),
                years: yearsOptions.join('')
            })));
            this.$date = $el.find('[data-type="date"]');
            this.$month = $el.find('[data-type="month"]');
            this.$year = $el.find('[data-type="year"]');
            this.$hidden = $('<input type="hidden" name="' + this.key + '" />');
            $el.append(this.$hidden);
            this.setValue(this.value);
            this.setElement($el);
            this.$el.attr('id', this.id);
            this.$el.attr('name', this.getName());
            if (this.hasFocus)
                this.trigger('blur', this);
            return this;
        },
        getValue: function () {
            var year = this.$year.val(), month = this.$month.val(), date = this.$date.val();
            if (!year || !month || !date)
                return null;
            return new Date(year, month, date);
        },
        setValue: function (date) {
            this.$date.val(date.getDate());
            this.$month.val(date.getMonth());
            this.$year.val(date.getFullYear());
            this.updateHidden();
        },
        focus: function () {
            if (this.hasFocus)
                return;
            this.$('select').first().focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            this.$('select:focus').blur();
        },
        updateHidden: function () {
            var val = this.getValue();
            if (_.isDate(val))
                val = val.toISOString();
            this.$hidden.val(val);
        }
    }, {
        template: _.template('    <div>      <select data-type="date"><%= dates %></select>      <select data-type="month"><%= months %></select>      <select data-type="year"><%= years %></select>    </div>  ', null, Form.templateSettings),
        showMonthNames: true,
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]
    });
    Form.editors.DateTime = Form.editors.Base.extend({
        events: {
            'change select': function () {
                this.updateHidden();
                this.trigger('change', this);
            },
            'focus select': function () {
                if (this.hasFocus)
                    return;
                this.trigger('focus', this);
            },
            'blur select': function () {
                if (!this.hasFocus)
                    return;
                var self = this;
                setTimeout(function () {
                    if (self.$('select:focus')[0])
                        return;
                    self.trigger('blur', self);
                }, 0);
            }
        },
        initialize: function (options) {
            options = options || {};
            Form.editors.Base.prototype.initialize.call(this, options);
            this.options = _.extend({ DateEditor: Form.editors.DateTime.DateEditor }, options);
            this.schema = _.extend({ minsInterval: 15 }, options.schema || {});
            this.dateEditor = new this.options.DateEditor(options);
            this.value = this.dateEditor.value;
            this.template = options.template || this.constructor.template;
        },
        render: function () {
            function pad(n) {
                return n < 10 ? '0' + n : n;
            }
            var schema = this.schema, $ = Backbone.$;
            var hoursOptions = _.map(_.range(0, 24), function (hour) {
                return '<option value="' + hour + '">' + pad(hour) + '</option>';
            });
            var minsOptions = _.map(_.range(0, 60, schema.minsInterval), function (min) {
                return '<option value="' + min + '">' + pad(min) + '</option>';
            });
            var $el = $($.trim(this.template({
                hours: hoursOptions.join(),
                mins: minsOptions.join()
            })));
            $el.find('[data-date]').append(this.dateEditor.render().el);
            this.$hour = $el.find('select[data-type="hour"]');
            this.$min = $el.find('select[data-type="min"]');
            this.$hidden = $el.find('input[type="hidden"]');
            this.setValue(this.value);
            this.setElement($el);
            this.$el.attr('id', this.id);
            this.$el.attr('name', this.getName());
            if (this.hasFocus)
                this.trigger('blur', this);
            return this;
        },
        getValue: function () {
            var date = this.dateEditor.getValue();
            var hour = this.$hour.val(), min = this.$min.val();
            if (!date || !hour || !min)
                return null;
            date.setHours(hour);
            date.setMinutes(min);
            return date;
        },
        setValue: function (date) {
            if (!_.isDate(date))
                date = new Date(date);
            this.dateEditor.setValue(date);
            this.$hour.val(date.getHours());
            this.$min.val(date.getMinutes());
            this.updateHidden();
        },
        focus: function () {
            if (this.hasFocus)
                return;
            this.$('select').first().focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            this.$('select:focus').blur();
        },
        updateHidden: function () {
            var val = this.getValue();
            if (_.isDate(val))
                val = val.toISOString();
            this.$hidden.val(val);
        },
        remove: function () {
            this.dateEditor.remove();
            Form.editors.Base.prototype.remove.call(this);
        }
    }, {
        template: _.template('    <div class="bbf-datetime">      <div class="bbf-date-container" data-date></div>      <select data-type="hour"><%= hours %></select>      :      <select data-type="min"><%= mins %></select>    </div>  ', null, Form.templateSettings),
        DateEditor: Form.editors.Date
    });
    Form.VERSION = '0.14.0';
    Backbone.Form = Form;
    return Form;
});
define('common-modules/forms/views/fields/nested-form', ['backbone-forms'], function (Form) {
    'use strict';
    var originalObserveFormEvents = Form.editors.Object.prototype._observeFormEvents;
    return Form.editors.Object.extend({
        render: function () {
            var NestedForm = this.form.constructor;
            this.nestedForm = new NestedForm({
                className: this.schema.showNested !== false ? 'adb-form--nested_fields' : '',
                schema: this.schema.subSchema,
                showRequired: this.options.form.options.showRequired,
                showOptional: this.options.form.options.showOptional,
                showContainer: this.schema.showContainer,
                data: this.value,
                idPrefix: this.id + '_',
                Field: NestedForm.NestedField
            });
            this._observeFormEvents();
            this.$el.html(this.nestedForm.render().el);
            if (this.hasFocus) {
                this.trigger('blur', this);
            }
            return this;
        },
        _observeFormEvents: function () {
            originalObserveFormEvents.apply(this, arguments);
            var form = this.options.form;
            this.listenTo(this.nestedForm, 'submit', _.bind(form.trigger, form, 'submit'));
        }
    });
});
define('common-modules/forms/views/fields/nested-model-form', [
    'backbone-forms',
    'common-modules/forms/views/fields/nested-form'
], function (Form, NestedForm) {
    'use strict';
    var originalInitialize = Form.editors.NestedModel.prototype.initialize;
    return NestedForm.extend({
        initialize: function (options) {
            var relations = options.model ? options.model.relations : null, SubModel = relations ? relations[options.key] : null;
            if (SubModel) {
                options.schema.model = SubModel;
            }
            originalInitialize.apply(this, arguments);
            var subModel = options.model ? options.model[options.key] : null;
            if (subModel instanceof Backbone.Model || subModel instanceof Backbone.Collection) {
                this.value = subModel;
            }
        },
        render: function () {
            var NestedFormCtor = this.form.constructor;
            var data = this.value || {}, nestedModel = this.schema.model;
            var modelInstance = data.constructor === nestedModel ? data : new nestedModel(data);
            this.nestedForm = new NestedFormCtor({
                className: this.schema.showNested !== false ? 'adb-form--nested_fields' : '',
                model: modelInstance,
                showRequired: this.options.form.options.showRequired,
                showOptional: this.options.form.options.showOptional,
                showContainer: this.schema.showContainer,
                idPrefix: this.id + '_',
                fieldTemplate: 'nestedField'
            });
            this._observeFormEvents();
            this.$el.html(this.nestedForm.render().el);
            if (this.hasFocus) {
                this.trigger('blur', this);
            }
            return this;
        },
        commit: function () {
            this.nestedForm.commit();
            return Form.editors.Object.prototype.commit.call(this);
        }
    });
});
define('common-modules/forms/views/fields/validation-messages', [], function () {
    'use strict';
    return {
        required: l('Field.Required'),
        arrayRequired: l('Field.set.required'),
        regexp: l('Invalid'),
        number: l('Must.be.a.number'),
        integer: l('Must.be.a.round.number'),
        email: l('Invalid.email.address'),
        url: l('Invalid.URL'),
        match: _.template('<%= l("Must.match.field", field) %>'),
        range: _.template('<%- l("Must.be.in.range", min, max) %>'),
        rangeMin: _.template('<%- l("Must.be.min", min) %>'),
        rangeMax: _.template('<%- l("Must.be.max", max) %>'),
        maxLength: _.template('<%- l("Must.be.at.most", max) %>'),
        maxDecimals: _.template('<%- l("Must.be.at.most.decimals", max) %>'),
        phoneNumber: l('Invalid'),
        zipCode: l('Invalid'),
        emailUsername: l('username.validation.message'),
        adminEmailUsername: l('username.validation.message.admin'),
        phone: l('Invalid.phone.number'),
        uuid: l('Invalid.uuid'),
        maxSize: _.template('<%- l("maximum.size.exceeded", maxSize) %>'),
        exactLength: _.template('<%- l("must.have.length", length) %>'),
        alphabetic: l('Must.be.alphabetic'),
        alphaNumeric: l('Must.be.alpha.numeric'),
        base64: l('Must.be.valid.base64'),
        fileRequired: l('File.required'),
        filePattern: l('File.Invalid'),
        fileSuffix: _.template('<%- l("File.must.have.suffix", allowedExtensions) %>'),
        fileSize: _.template('<%- l("File.size.must.be.in.range", min, max) %>'),
        fileSizeMin: _.template('<%- l("File.size.must.be.min", min) %>'),
        fileSizeMax: _.template('<%- l("File.size.must.be.max", max) %>'),
        hexCode: l('Invalid.Hex.Code')
    };
});
define('common-modules/forms/views/fields/validators', [], function () {
    'use strict';
    return function () {
        var validators = {
            required: function (options) {
                options = _.extend({
                    type: 'required',
                    message: this.errMessages.required
                }, options);
                return function (value) {
                    options.value = value;
                    var err = {
                        type: options.type,
                        message: _.isFunction(options.message) ? options.message(options) : options.message
                    };
                    if (value === null || value === undefined || value === '')
                        return err;
                };
            },
            trimmedRequired: function (options) {
                return this.customRequired(_.extend({}, options, { trimmed: true }));
            },
            conditionallyRequired: function (options) {
                return this.customRequired(options);
            },
            arrayRequired: function (options) {
                return this.customRequired(_.extend({}, {
                    isArray: true,
                    message: this.errMessages.arrayRequired
                }, options));
            },
            customRequired: function (options) {
                options = options || {};
                var defaultValidator = this.required(options);
                return function (value, formValues) {
                    if (options.conditionalField) {
                        var requiredWhen = _.isArray(options.requiredWhen) ? options.requiredWhen : [options.requiredWhen];
                        var actualValue = formValues[options.conditionalField];
                        if (options.conditionalFieldSubValue) {
                            actualValue = actualValue[options.conditionalFieldSubValue];
                        }
                        actualValue = _.isArray(actualValue) ? actualValue : [actualValue];
                        var isRequired = !!_.intersection(actualValue, requiredWhen).length;
                        if (!isRequired) {
                            return;
                        }
                    }
                    var processedValue = value;
                    if (options.trimmed) {
                        processedValue = $.trim(processedValue);
                    }
                    if (options.isArray) {
                        var isEmpty = _.isArray(processedValue) && !processedValue.length;
                        processedValue = isEmpty ? null : processedValue;
                    }
                    return defaultValidator(processedValue);
                };
            },
            integer: function (options) {
                options = _.extend({
                    type: 'integer',
                    message: this.errMessages.integer,
                    regexp: /^[0-9]*$/
                }, options);
                return this.regexp(options);
            },
            number: function (options) {
                options = options || {};
                options = _.extend({
                    type: 'number',
                    message: this.errMessages.number,
                    regexp: options.supportNegative ? /^-?[0-9]*\.?[0-9]*?$/ : /^[0-9]*\.?[0-9]*?$/
                }, options);
                return this.regexp(options);
            },
            maxDecimals: function (options) {
                if (!options.max) {
                    throw new Error('Max value should be defined for decimals validator');
                }
                var errMessages = this.errMessages;
                return function (value) {
                    var ruleRegExp = new RegExp('^\\d*(\\.\\d{1,' + options.max + '})?$');
                    if (!ruleRegExp.test(value)) {
                        return { message: errMessages.maxDecimals(options) };
                    }
                };
            },
            maxLength: function (options) {
                if (!options.max) {
                    throw new Error('Max value should be defined for maxLength validator');
                }
                var errMessages = this.errMessages;
                return function (value) {
                    if (!_.isString(value) || value.length <= options.max) {
                        return;
                    }
                    return {
                        type: 'range',
                        message: errMessages.maxLength(options)
                    };
                };
            },
            range: function (options) {
                var errMessages = this.errMessages;
                var hasMin = _.isNumber(options.min);
                var hasMax = _.isNumber(options.max);
                return function (value) {
                    value = +value;
                    if (_.isNull(value) || _.isUndefined(value) || value === '') {
                        return;
                    }
                    if (!_.isNumber(value)) {
                        return;
                    }
                    if (hasMin && !hasMax && value < options.min) {
                        return {
                            type: 'rangeMin',
                            message: errMessages.rangeMin(options)
                        };
                    }
                    if (!hasMin && hasMax && value > options.max) {
                        return {
                            type: 'rangeMax',
                            message: errMessages.rangeMax(options)
                        };
                    }
                    if (hasMin && hasMax && (value < options.min || value > options.max)) {
                        return {
                            type: 'range',
                            message: errMessages.range(options)
                        };
                    }
                };
            },
            email: function (options) {
                var errMessages = this.errMessages;
                var regexp = _.bind(this.regexp, this);
                return function (value) {
                    options = _.extend({
                        type: 'email',
                        message: errMessages.email,
                        regexp: /^[\w\-]{1,}([\w\-\+.]{1,1}[\w\-]{1,}){0,}[@][\w\-]{1,}([.]([\w\-]{1,})){1,}$/
                    }, options);
                    return regexp(options)(value);
                };
            },
            emailUsername: function () {
                var errMessages = this.errMessages;
                return function (value) {
                    var rule = /^[a-z0-9\!#$\-^_~'&]+(?:\.[a-z0-9\!#$\-^_~'&]+)*$/i;
                    if (!rule.test(value)) {
                        return { message: errMessages.emailUsername };
                    }
                    if (value === 'admin') {
                        return { message: errMessages.adminEmailUsername };
                    }
                };
            },
            phone: function () {
                var errMessages = this.errMessages;
                return function (value) {
                    var rule = /^\d{10,14}$/;
                    if (!rule.test(value)) {
                        return { message: errMessages.phone };
                    }
                };
            },
            uuid: function () {
                var errMessages = this.errMessages;
                return function (value) {
                    var rule = /[a-f0-9]{8}-?[a-f0-9]{4}-?[1-5][a-f0-9]{3}-?[89ab][a-f0-9]{3}-?[a-f0-9]{12}/i;
                    if (!rule.test(value)) {
                        return { message: errMessages.uuid };
                    }
                };
            },
            size: function (options) {
                var errMessages = this.errMessages;
                return function (value) {
                    if (value && value.length > options.maxSize) {
                        return { message: options.customErrorMessage ? options.customErrorMessage : errMessages.maxSize(options) };
                    }
                };
            },
            exactLength: function (options) {
                var errMessages = this.errMessages;
                return function (value) {
                    if (_.isString(value) && value.length !== options.length) {
                        return { message: errMessages.exactLength(options) };
                    }
                };
            },
            fullyQualifiedUrl: function () {
                var errMessages = this.errMessages;
                return function (value) {
                    var rule = /^https?:\/\/[^\s\$?#]+\.[^\s]{2,}$/;
                    if (!rule.test(value)) {
                        return { message: errMessages.url };
                    }
                };
            },
            alphaNumeric: function () {
                var errMessages = this.errMessages;
                return function (value) {
                    var rule = /^[a-zA-Z0-9]*$/;
                    if (!rule.test(value)) {
                        return { message: errMessages.alphaNumeric };
                    }
                };
            },
            alphabetic: function () {
                var errMessages = this.errMessages;
                return function (value) {
                    var rule = /^[a-zA-Z]*$/;
                    if (!rule.test(value)) {
                        return { message: errMessages.alphabetic };
                    }
                };
            },
            base64: function () {
                var errMessages = this.errMessages;
                return function (value) {
                    try {
                        if (btoa(atob(value)) !== value) {
                            return { message: errMessages.base64 };
                        }
                    } catch (err) {
                        return { message: errMessages.base64 };
                    }
                };
            },
            fileRequired: function (options) {
                options = options || {};
                options = _.extend({
                    fileProperty: 'file',
                    message: this.errMessages.fileRequired
                }, options);
                var defaultValidator = this.customRequired(options);
                return function (value, formValues) {
                    var processedValue = value;
                    if (value && options.fileProperty) {
                        processedValue = value[options.fileProperty];
                    }
                    return defaultValidator(processedValue, formValues);
                };
            },
            fileName: function (options) {
                options = options || {};
                var errMessages = this.errMessages;
                var regexp = _.bind(this.regexp, this);
                var escapeRegexStr = function (str) {
                    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
                };
                options = _.extend({
                    type: 'filePattern',
                    fileNameProperty: 'fileName',
                    regexp: '.*',
                    message: errMessages.filePattern
                }, options);
                return function (value) {
                    if (_.isNull(value) || _.isUndefined(value) || value === '') {
                        return;
                    }
                    var processedValue = value;
                    if (options.fileNameProperty) {
                        processedValue = processedValue[options.fileNameProperty];
                    }
                    if (options.extension) {
                        var extension = options.extension;
                        if (!_.isArray(extension)) {
                            extension = [extension];
                        }
                        options.regexp = '(?:' + extension.map(escapeRegexStr).join('|') + ')$';
                        options.message = options.message || errMessages.fileSuffix;
                        options.allowedExtensions = extension.join(', ');
                    }
                    return regexp(options)(processedValue);
                };
            },
            fileSize: function (options) {
                options = options || {};
                options = _.extend({
                    type: 'fileSize',
                    fileProperty: 'file',
                    fileSizeProperty: 'size',
                    errMessages: {
                        range: this.errMessages.fileSize,
                        rangeMin: this.errMessages.fileSizeMin,
                        rangeMax: this.errMessages.fileSizeMax
                    }
                }, options);
                if (options.errMessages) {
                    var messageTemplates = _.map(options.errMessages, function (message, key) {
                        return [
                            key,
                            !_.isFunction(message) ? _.template(message) : message
                        ];
                    });
                    options.errMessages = _.object(messageTemplates);
                }
                var validator = this.range.call(options.errMessages ? options : this, options);
                return function (value) {
                    var processedValue = value;
                    if (options.fileProperty && processedValue) {
                        processedValue = processedValue[options.fileProperty];
                    }
                    if (_.isNull(processedValue) || _.isUndefined(processedValue) || processedValue === '') {
                        return;
                    }
                    if (options.fileSizeProperty && processedValue) {
                        processedValue = processedValue[options.fileSizeProperty];
                    }
                    return validator(processedValue);
                };
            },
            hexColor: function () {
                var errMessages = this.errMessages;
                return function (value) {
                    var rule = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
                    if (!rule.test(value)) {
                        return { message: errMessages.hexCode };
                    }
                };
            }
        };
        _.each([
            'trimmedRequired',
            'conditionallyRequired',
            'arrayRequired',
            'customRequired',
            'fileRequired',
            'required'
        ], function (name) {
            validators[name].showRequired = true;
        });
        return validators;
    };
});
define('common-modules/forms/views/fields/base-subview-field', ['backbone-forms'], function (Form) {
    'use strict';
    return Form.editors.Base.extend({
        tagName: 'div',
        events: {},
        fieldEvents: {
            change: 'onFieldChange',
            focus: 'onFieldFocus',
            blur: 'onFieldBlur'
        },
        render: function () {
            var view = this.subView = this.initSubView();
            this.setElement(view.render().$el);
            this.setInitialValue(this.value);
            Marionette.bindEntityEvents(this, view, this.fieldEvents);
            this.decorateEditor();
            return this;
        },
        initSubView: function () {
            throw new Error('Method initSubView must be implemented and return a Marionette view');
        },
        setInitialValue: function (value) {
            this.setValue(value);
        },
        decorateEditor: function () {
            if (this.schema.editorAttrs)
                this.$el.attr(this.schema.editorAttrs);
            if (this.schema.editorClass)
                this.$el.addClass(this.schema.editorClass);
            this.disableIfNecessary();
        },
        disableIfNecessary: function () {
            var isDisabled = _.isFunction(this.schema.isDisabled) ? this.schema.isDisabled(this.model) : this.schema.isDisabled;
            if (isDisabled && _.isFunction(this.subView.disable)) {
                this.subView.disable();
            }
        },
        onFieldChange: function () {
            this.trigger('change', this);
        },
        onFieldFocus: function () {
            this.trigger('focus', this);
        },
        onFieldBlur: function () {
            this.trigger('blur', this);
        },
        focus: function () {
            if (this.hasFocus)
                return;
            this.$el.focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            this.$el.blur();
        },
        remove: function () {
            this.subView.close();
            Backbone.Form.editors.Base.prototype.remove.apply(this, arguments);
        },
        toCollection: function (items) {
            return items instanceof Backbone.Collection ? items.clone() : new Backbone.Collection(items);
        }
    });
});
define('common-modules/forms/views/select-input', ['common-modules/behaviors/simple-tooltip'], function (SimpleTooltip) {
    'use strict';
    var DROPDOWN_VARIATION_PREFIX = 'adb-dropdown__';
    var Option = Marionette.ItemView.extend({
        tagName: 'option',
        template: _.template('<%-label%>'),
        initialize: function (options) {
            this.labelField = options.labelField;
            this.valueField = options.valueField;
        },
        modelEvents: { change: 'render' },
        onRender: function () {
            this.$el.attr('value', this.model.get(this.valueField));
            this.$el.prop('disabled', !!this.model.get('isDisabled'));
        },
        serializeData: function () {
            return { label: this.model.get(this.labelField) };
        }
    });
    return Marionette.CompositeView.extend({
        className: 'adb-dropdown',
        template: _.template('<span class="adb-js-dropdown-placeholder"></span>' + '<select aria-label="<%- ariaLabel %>" class="adb-js-dropdown-select <%- additionalClasses %>" name="<%- name %>"></select>'),
        itemView: Option,
        itemViewContainer: 'select',
        ui: {
            selected: 'span.adb-js-dropdown-placeholder',
            select: 'select'
        },
        events: { 'change select': 'onChange' },
        collectionEvents: { sync: 'render' },
        itemViewOptions: function () {
            return {
                labelField: this.labelField,
                valueField: this.valueField
            };
        },
        behaviors: function () {
            if (this.options.tooltipOptions) {
                return [_.defaults(this.options.tooltipOptions, { behaviorClass: SimpleTooltip })];
            }
        },
        initialize: function (options) {
            this.labelField = options.labelField || 'label';
            this.ariaLabel = options.label || 'select';
            this.ariaLabelledBy = options.ariaLabelledBy || null;
            this.valueField = options.valueField || 'value';
            this.isInline = !!options.isInline;
            this.isTableContent = !!options.isTableContent;
            this.additionalClasses = options.additionalClasses || '';
            this.name = options.name || '';
            this.value = options.value;
            this.type = options.type;
            this.size = options.size || !!options.isSmall && 'small';
            this.isGroup = options.isGroup;
            this.disabled = options.disabled;
        },
        onRender: function () {
            this.$el.addClass(_.compact([
                this.type && DROPDOWN_VARIATION_PREFIX + this.type,
                this.size && DROPDOWN_VARIATION_PREFIX + this.size,
                this.isInline && 'adb-form--inline_input',
                this.isTableContent && 'adb-input_table--content'
            ]).join(' '));
            if (this.isGroup) {
                this.$el.removeClass('adb-dropdown');
            }
            if (_.isUndefined(this.value)) {
                this.renderSelected();
            } else {
                this.val(this.value);
            }
            if (this.disabled) {
                this.disable();
            }
            if (this.ariaLabelledBy) {
                this.ui.select.attr('aria-labelledby', this.ariaLabelledBy);
            }
        },
        onChange: function (event) {
            this.renderSelected();
            this.trigger('change', $(event.currentTarget).val());
        },
        renderSelected: function () {
            var selected = this.$('option:selected');
            this.ui.selected.text(selected.text());
        },
        serializeData: function () {
            return {
                name: this.name,
                ariaLabel: this.ariaLabel,
                ariaLabelledBy: this.ariaLabelledBy,
                additionalClasses: this.additionalClasses
            };
        },
        val: function (args) {
            if (!_.isUndefined(args)) {
                this.ui.select.val('' + args);
                this.renderSelected();
            }
            return this.ui.select.val();
        },
        disable: function () {
            this.$el.addClass('adb-is-disabled');
            this.ui.select.attr('disabled', true);
        }
    });
});
define('common-modules/forms/views/fields/styled-select', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/select-input'
], function (BaseField, SelectInput) {
    'use strict';
    return BaseField.extend({
        initialize: function (options) {
            BaseField.prototype.initialize.call(this, options);
            this.selectOptions = this.createOptions(_.result(this.schema, 'options'));
            this.labelField = this.schema.labelField;
            this.valueField = this.schema.valueField;
            this.initialValue = this.schema.value;
            this.name = BaseField.prototype.getName.call(this);
        },
        createOptions: function (options) {
            var collection = this.toCollection(options);
            if (this.schema.includeEmptyOption) {
                collection.unshift({
                    value: '',
                    label: _.result(this.schema, 'emptyOptionLabel') || ''
                });
            }
            return collection;
        },
        initSubView: function () {
            return new SelectInput({
                collection: this.selectOptions,
                labelField: this.labelField,
                valueField: this.valueField,
                name: this.name,
                value: this.initialValue,
                disabled: this.schema.disabled
            });
        },
        getBlankValue: function () {
            return this.selectOptions.at(0).get('value');
        },
        getValue: function () {
            return this.subView.val();
        },
        setInitialValue: function (value) {
            if (value || _.isNumber(value) || _.isBoolean(value)) {
                this.setValue(value);
            }
        },
        setValue: function (value) {
            this.subView.val(value);
        },
        focus: function () {
            if (this.hasFocus)
                return;
            this.subView.ui.select.focus();
        },
        blur: function () {
            if (!this.hasFocus)
                return;
            this.subView.ui.select.blur();
        }
    });
});
define('common-modules/forms/views/fields/boolean-styled-select', ['common-modules/forms/views/fields/styled-select'], function (StyledSelect) {
    'use strict';
    return StyledSelect.extend({
        createOptions: function () {
            var options = [
                {
                    label: this.schema.trueLabel || this.constructor.DEFAULT_TRUE_LABEL,
                    value: true
                },
                {
                    label: this.schema.falseLabel || this.constructor.DEFAULT_FALSE_LABEL,
                    value: false
                }
            ];
            return StyledSelect.prototype.createOptions.call(this, options);
        },
        getValue: function () {
            var val = this.subView.val();
            if (_.isUndefined(val) || !val.length) {
                return null;
            }
            return val === 'true';
        }
    }, {
        DEFAULT_TRUE_LABEL: l('YesNo.YES'),
        DEFAULT_FALSE_LABEL: l('YesNo.NO')
    });
});
define('common-modules/forms/views/fields/option-selector-base-field', ['common-modules/forms/views/fields/base-subview-field'], function (BaseField) {
    'use strict';
    return BaseField.extend({
        events: {
            'focus input': 'onFieldFocus',
            'blur input': 'onFieldBlur'
        },
        fieldEvents: { check: 'onFieldChange' },
        initialize: function (options) {
            BaseField.prototype.initialize.call(this, options);
            if (!this.schema || !this.schema.options) {
                throw new Error('Missing required "schema.options"');
            }
            this.selectOptions = this.toCollection(_.result(this.schema, 'options'));
            this.labelField = this.schema.labelField;
            this.valueField = this.schema.valueField;
            this.nestCaption = !!this.schema.nestCaption;
            this.removeInvisibleSelectOptions();
        },
        removeInvisibleSelectOptions: function () {
            var toRemove = [];
            this.selectOptions.each(function (model) {
                var visible = model.get('visible');
                if (_.isUndefined(visible)) {
                    return;
                }
                if (_.isFunction(visible)) {
                    visible = visible(this.model);
                }
                if (!visible) {
                    toRemove.push(model);
                }
            }, this);
            this.selectOptions.remove(toRemove);
        },
        getValue: function () {
            return this.subView ? this.subView.getChecked() : [];
        },
        getSubviewOptions: function () {
            return {
                collection: this.selectOptions,
                labelField: this.labelField,
                valueField: this.valueField || 'value',
                nestCaption: this.nestCaption
            };
        },
        setValue: function (value) {
            var model = this.subView.collection.where({ value: value });
            this.subView.check(model);
        },
        disableIfNecessary: function () {
            BaseField.prototype.disableIfNecessary.apply(this, arguments);
            var toDisable = this.subView.collection.filter(function (model) {
                var isDisabled = model.get('isDisabled');
                return _.isFunction(isDisabled) ? isDisabled(this.model) : isDisabled;
            }, this);
            this.subView.disable(toDisable);
        }
    });
});
define('common-modules/forms/templates/option-selector-base.tpl.html', [], function () {
    return '<label class="js-option-selector <%- labelClass %>" for="<%- cid %>">\n\t<span class="adb-selector--input">\n\t\t<input id="<%- cid %>" value="<%- value %>" type="<%- inputType %>" name="<%- collectionCid %>">\n\t</span>\n\t<span class="adb-selector--value js-value-selector"><%= label %></span>\n</label>\n<div class="js-caption adb-caption adb-form--caption"><%= help %></div>\n';
});
define('common-modules/forms/views/option-selector-base', [
    'common-modules/forms/templates/option-selector-base.tpl.html',
    'common-modules/forms/views/help-tooltip'
], function (template, HelpTooltip) {
    'use strict';
    var OptionSelectorItem = Marionette.ItemView.extend({
        inputType: null,
        disabledClass: 'adb-is-disabled',
        className: 'adb-selector',
        triggers: {
            'click input': {
                event: 'check',
                preventDefault: false,
                stopPropagation: false
            }
        },
        ui: {
            input: 'input',
            caption: '.js-caption',
            label: '.js-option-selector',
            value: '.js-value-selector'
        },
        template: _.template(template),
        initialize: function (options) {
            this.labelField = options.labelField || this.constructor.LABEL_FIELD;
            this.valueField = options.valueField || this.constructor.VALUE_FIELD;
            this.helpField = options.helpField || this.constructor.HELP_FIELD;
            this.attrsField = options.attrsField || this.constructor.ATTRS_FIELD;
            this.collectionCid = options.collectionCid;
            this.nestCaption = options.nestCaption;
            if (this.model.get('helpTooltip')) {
                this.listenTo(this, 'show', this.showHelpTooltip);
                this.listenTo(this, 'before:close', this.hideHelpTooltip);
            }
        },
        onRender: function () {
            this.ui.label.addClass('adb-js-' + this.inputType);
            this.ui.label.toggleClass('adb-selector-selectall', !!this.model.get('all'));
            this.renderCaption();
            var attrs = this.model.get(this.attrsField);
            if (_.isObject(attrs)) {
                this.ui.input.attr(attrs);
            }
            if (this.nestCaption) {
                this.ui.caption.appendTo(this.ui.value);
            }
            if (!this.model.get(this.helpField)) {
                this.ui.caption.remove();
            }
            if (this.model.get('helpTooltip')) {
                this.showHelpTooltip();
            }
        },
        hideHelpTooltip: function () {
            if (this.helpTooltip) {
                this.helpTooltip.close();
            }
        },
        showHelpTooltip: function () {
            this.hideHelpTooltip();
            this.helpTooltip = new HelpTooltip({ help: this.model.get('helpTooltip') });
            this.$('.js-value-selector').append(this.helpTooltip.render().el);
        },
        renderCaption: function () {
            this.ui.caption.toggle(!!this.model.get(this.helpField));
        },
        isChecked: function () {
            return this.ui.input.prop('checked');
        },
        check: function () {
            this.toggleChecked(true);
        },
        uncheck: function () {
            this.toggleChecked(false);
        },
        toggleChecked: function (checked) {
            this.ui.input.prop('checked', !!checked);
        },
        disable: function () {
            this.ui.label.addClass(this.disabledClass);
            this.ui.input.prop('disabled', true);
        },
        enable: function () {
            this.ui.label.removeClass(this.disabledClass);
            this.ui.input.prop('disabled', false);
        },
        serializeData: function () {
            var label = this.model.get(this.labelField);
            var help = this.model.get(this.helpField);
            var helpText = '';
            if (_.isFunction(help)) {
                helpText = help();
            } else if (_.isArray(help)) {
                helpText = help.join('<br>');
            } else {
                helpText = _.escape(help);
            }
            return {
                inputType: this.inputType,
                cid: this.cid,
                collectionCid: this.collectionCid,
                label: _.isFunction(label) ? label() : _.escape(label),
                value: this.model.get(this.valueField),
                help: helpText,
                labelClass: this.labelClass ? _.result(this, 'labelClass') : ''
            };
        }
    }, {
        LABEL_FIELD: 'label',
        VALUE_FIELD: 'id',
        HELP_FIELD: 'help',
        ATTRS_FIELD: 'attrs'
    });
    var OptionSelectorGroup = Marionette.CollectionView.extend({
        itemView: OptionSelectorItem,
        itemEvents: { check: 'onCheck' },
        initialize: function (options) {
            this.labelField = options.labelField || this.itemView.LABEL_FIELD;
            this.valueField = options.valueField || this.itemView.VALUE_FIELD;
            this.helpField = options.helpField || this.itemView.HELP_FIELD;
            this.nestCaption = options.nestCaption;
        },
        itemViewOptions: function () {
            return {
                collectionCid: this.cid,
                labelField: this.labelField,
                valueField: this.valueField,
                helpField: this.helpField,
                nestCaption: this.nestCaption
            };
        },
        applyMethod: function (methodName, models) {
            if (!models) {
                return;
            }
            if (!_.isArray(models)) {
                models = [models];
            }
            _(models).chain().map(function (model) {
                return this.children.findByModel(model);
            }, this).compact().invoke(methodName);
        },
        onCheck: function (eventName, itemView) {
            this.trigger('check', itemView.model, itemView.isChecked());
        },
        check: function (models) {
            return this.applyMethod('check', models);
        },
        uncheck: function (models) {
            return this.applyMethod('uncheck', models);
        },
        disable: function (models) {
            return this.applyMethod('disable', models);
        },
        enable: function (models) {
            return this.applyMethod('enable', models);
        },
        getChecked: function () {
            var checkedViews = this.children.filter(function (child) {
                return child.isChecked();
            });
            return _(checkedViews).pluck('model');
        }
    });
    return {
        OptionSelectorItem: OptionSelectorItem,
        OptionSelectorGroup: OptionSelectorGroup
    };
});
define('common-modules/forms/views/radio', ['common-modules/forms/views/option-selector-base'], function (OptionSelector) {
    'use strict';
    var RadioItem = OptionSelector.OptionSelectorItem.extend({ inputType: 'radio' });
    var RadioGroup = OptionSelector.OptionSelectorGroup.extend({
        itemView: RadioItem,
        getChecked: function () {
            var selectedChild = this.children.find(function (child) {
                return child.isChecked();
            });
            if (selectedChild)
                return selectedChild.model;
        }
    });
    return {
        RadioItem: RadioItem,
        RadioGroup: RadioGroup
    };
});
define('common-modules/forms/views/radio-bar', ['common-modules/forms/views/radio'], function (Radio) {
    'use strict';
    var RadioBarItem = Radio.RadioItem.extend({ labelClass: 'adb-selector__button adb-js-radio' });
    var RadioBarGroup = Radio.RadioGroup.extend({ itemView: RadioBarItem });
    return {
        RadioBarItem: RadioBarItem,
        RadioBarGroup: RadioBarGroup
    };
});
define('common-modules/forms/views/fields/radios-field', [
    'common-modules/forms/views/fields/option-selector-base-field',
    'common-modules/forms/views/radio',
    'common-modules/forms/views/radio-bar'
], function (OptionSelector, Radio, RadioBar) {
    'use strict';
    return OptionSelector.extend({
        initSubView: function () {
            var View = this.schema.bar ? RadioBar.RadioBarGroup : Radio.RadioGroup;
            return new View(this.getSubviewOptions());
        },
        getValue: function () {
            var checked = OptionSelector.prototype.getValue.apply(this, arguments);
            if (checked) {
                return checked.get('value');
            }
        }
    });
});
define('common-modules/forms/views/checkbox', ['common-modules/forms/views/option-selector-base'], function (OptionSelector) {
    'use strict';
    var CheckboxItem = OptionSelector.OptionSelectorItem.extend({ inputType: 'checkbox' });
    var CheckboxGroup = OptionSelector.OptionSelectorGroup.extend({
        itemView: CheckboxItem,
        initialize: function (options) {
            OptionSelector.OptionSelectorGroup.prototype.initialize.apply(this, arguments);
            this.includeSelectAll = !!options.includeSelectAll;
            if (this.includeSelectAll) {
                var item = { all: true };
                item[this.labelField] = l('Select.All');
                item[this.valueField] = -1;
                this.collection.unshift(item);
            }
        },
        onCheck: function (eventName, itemView) {
            if (this.includeSelectAll && !!itemView.model.get('all')) {
                this.onCheckAll(itemView);
                return;
            }
            OptionSelector.OptionSelectorGroup.prototype.onCheck.apply(this, arguments);
        },
        onCheckAll: function (itemView, options) {
            options = options || {};
            this.renderCheckAll(itemView.isChecked());
            if (!options.silent) {
                this.trigger('check:all', itemView.isChecked());
            }
        },
        checkAll: function () {
            if (!this.includeSelectAll) {
                return;
            }
            this.check(this.collection.findWhere({ all: true }));
            this.renderCheckAll(true);
        },
        renderCheckAll: function (checked) {
            if (!this.includeSelectAll) {
                return;
            }
            var models = this.collection.where({ all: undefined });
            this.applyMethod(checked ? 'check' : 'uncheck', models);
            this.applyMethod(checked ? 'disable' : 'enable', models);
        },
        getChecked: function () {
            var checkedViews = this.children.filter(function (child) {
                return !child.model.get('all') && child.isChecked();
            });
            return _(checkedViews).pluck('model');
        }
    });
    return {
        CheckboxItem: CheckboxItem,
        CheckboxGroup: CheckboxGroup
    };
});
define('common-modules/forms/views/checkbox-bar', ['common-modules/forms/views/checkbox'], function (Checkbox) {
    'use strict';
    var CheckboxBarItem = Checkbox.CheckboxItem.extend({ labelClass: 'adb-selector__button adb-button adb-button__neutral adb-button__medium adb-js-checkbox' });
    var CheckboxBarGroup = Checkbox.CheckboxGroup.extend({ itemView: CheckboxBarItem });
    return {
        CheckboxBarItem: CheckboxBarItem,
        CheckboxBarGroup: CheckboxBarGroup
    };
});
define('common-modules/forms/views/fields/checkboxes-field', [
    'common-modules/forms/views/fields/option-selector-base-field',
    'common-modules/forms/views/checkbox',
    'common-modules/forms/views/checkbox-bar'
], function (OptionSelector, Checkbox, CheckboxBar) {
    'use strict';
    return OptionSelector.extend({
        initSubView: function () {
            var View = this.getSubView();
            return new View(this.getSubviewOptions());
        },
        getSubView: function () {
            return this.schema.bar ? CheckboxBar.CheckboxBarGroup : Checkbox.CheckboxGroup;
        },
        getValue: function () {
            var checked = OptionSelector.prototype.getValue.apply(this, arguments);
            return _(checked).invoke('get', 'value');
        },
        setValue: function (values) {
            values = values || [];
            var contains = this.schema.contains || _.contains;
            var models = this.subView.collection.filter(function (model) {
                return contains(values, model.get('value'));
            });
            this.subView.check(models);
        }
    });
});
define('common-modules/forms/views/fields/phone-field', ['backbone-forms'], function (Form) {
    'use strict';
    return Form.editors.Text.extend({
        initialize: function (options) {
            Form.editors.Base.prototype.initialize.call(this, options);
            this.$el.attr('type', 'tel');
        },
        getValue: function () {
            var value = this.$el.val();
            return value.replace(/[^\d\+x]/g, '');
        }
    });
});
define('common-modules/forms/views/text-input', [], function () {
    'use strict';
    return Marionette.ItemView.extend({
        tagName: 'input',
        template: _.template(''),
        triggers: {
            focus: 'focus',
            blur: 'blur',
            change: 'change',
            input: 'input'
        },
        initialize: function (options) {
            this.config = { type: 'text' };
            if (this.model) {
                this.config = _.extend(this.config, this.model.toJSON());
            }
            if (options) {
                this.config = _.extend(this.config, options);
            }
            this.config = _.omit(this.config, 'className');
        },
        onRender: function () {
            this.$el.prop(this.config);
            this.$el.toggleClass('adb-text__small', !!this.config.isSmall);
        },
        val: function (args) {
            if (!_.isUndefined(args)) {
                this.$el.val(args);
            }
            return this.$el.val();
        }
    });
});
define('common-modules/utils/countries/countries', [], function () {
    'use strict';
    return [
        {
            value: 'US',
            value_iso3: 'USA',
            label: l('countries.US')
        },
        {
            value: 'CA',
            value_iso3: 'CAN',
            label: l('countries.CA')
        },
        {
            value: 'AF',
            value_iso3: 'AFG',
            label: l('countries.AF')
        },
        {
            value: 'AX',
            value_iso3: 'ALA',
            label: l('countries.AX')
        },
        {
            value: 'AL',
            value_iso3: 'ALB',
            label: l('countries.AL')
        },
        {
            value: 'DZ',
            value_iso3: 'DZA',
            label: l('countries.DZ')
        },
        {
            value: 'AS',
            value_iso3: 'ASM',
            label: l('countries.AS')
        },
        {
            value: 'AD',
            value_iso3: 'AND',
            label: l('countries.AD')
        },
        {
            value: 'AO',
            value_iso3: 'AGO',
            label: l('countries.AO')
        },
        {
            value: 'AI',
            value_iso3: 'AIA',
            label: l('countries.AI')
        },
        {
            value: 'AQ',
            value_iso3: 'ATA',
            label: l('countries.AQ')
        },
        {
            value: 'AG',
            value_iso3: 'ATG',
            label: l('countries.AG')
        },
        {
            value: 'AR',
            value_iso3: 'ARG',
            label: l('countries.AR')
        },
        {
            value: 'AM',
            value_iso3: 'ARM',
            label: l('countries.AM')
        },
        {
            value: 'AW',
            value_iso3: 'ABW',
            label: l('countries.AW')
        },
        {
            value: 'AU',
            value_iso3: 'AUS',
            label: l('countries.AU')
        },
        {
            value: 'AT',
            value_iso3: 'AUT',
            label: l('countries.AT')
        },
        {
            value: 'AZ',
            value_iso3: 'AZE',
            label: l('countries.AZ')
        },
        {
            value: 'BS',
            value_iso3: 'BHS',
            label: l('countries.BS')
        },
        {
            value: 'BH',
            value_iso3: 'BHR',
            label: l('countries.BH')
        },
        {
            value: 'BD',
            value_iso3: 'BGD',
            label: l('countries.BD')
        },
        {
            value: 'BB',
            value_iso3: 'BRB',
            label: l('countries.BB')
        },
        {
            value: 'BY',
            value_iso3: 'BLR',
            label: l('countries.BY')
        },
        {
            value: 'BE',
            value_iso3: 'BEL',
            label: l('countries.BE')
        },
        {
            value: 'BZ',
            value_iso3: 'BLZ',
            label: l('countries.BZ')
        },
        {
            value: 'BJ',
            value_iso3: 'BEN',
            label: l('countries.BJ')
        },
        {
            value: 'BM',
            value_iso3: 'BMU',
            label: l('countries.BM')
        },
        {
            value: 'BT',
            value_iso3: 'BTN',
            label: l('countries.BT')
        },
        {
            value: 'BO',
            value_iso3: 'BOL',
            label: l('countries.BO')
        },
        {
            value: 'BQ',
            value_iso3: 'BES',
            label: l('countries.BQ')
        },
        {
            value: 'BA',
            value_iso3: 'BIH',
            label: l('countries.BA')
        },
        {
            value: 'BW',
            value_iso3: 'BWA',
            label: l('countries.BW')
        },
        {
            value: 'BV',
            value_iso3: 'BVT',
            label: l('countries.BV')
        },
        {
            value: 'BR',
            value_iso3: 'BRA',
            label: l('countries.BR')
        },
        {
            value: 'IO',
            value_iso3: 'IOT',
            label: l('countries.IO')
        },
        {
            value: 'BN',
            value_iso3: 'BRN',
            label: l('countries.BN')
        },
        {
            value: 'BG',
            value_iso3: 'BGR',
            label: l('countries.BG')
        },
        {
            value: 'BF',
            value_iso3: 'BFA',
            label: l('countries.BF')
        },
        {
            value: 'BI',
            value_iso3: 'BDI',
            label: l('countries.BI')
        },
        {
            value: 'KH',
            value_iso3: 'KHM',
            label: l('countries.KH')
        },
        {
            value: 'CM',
            value_iso3: 'CMR',
            label: l('countries.CM')
        },
        {
            value: 'CV',
            value_iso3: 'CPV',
            label: l('countries.CV')
        },
        {
            value: 'KY',
            value_iso3: 'CYM',
            label: l('countries.KY')
        },
        {
            value: 'CF',
            value_iso3: 'CAF',
            label: l('countries.CF')
        },
        {
            value: 'TD',
            value_iso3: 'TCD',
            label: l('countries.TD')
        },
        {
            value: 'CL',
            value_iso3: 'CHL',
            label: l('countries.CL')
        },
        {
            value: 'CN',
            value_iso3: 'CHN',
            label: l('countries.CN')
        },
        {
            value: 'CX',
            value_iso3: 'CXR',
            label: l('countries.CX')
        },
        {
            value: 'CC',
            value_iso3: 'CCK',
            label: l('countries.CC')
        },
        {
            value: 'CO',
            value_iso3: 'COL',
            label: l('countries.CO')
        },
        {
            value: 'KM',
            value_iso3: 'COM',
            label: l('countries.KM')
        },
        {
            value: 'CG',
            value_iso3: 'COG',
            label: l('countries.CG')
        },
        {
            value: 'CD',
            value_iso3: 'COD',
            label: l('countries.CD')
        },
        {
            value: 'CK',
            value_iso3: 'COK',
            label: l('countries.CK')
        },
        {
            value: 'CR',
            value_iso3: 'CRI',
            label: l('countries.CR')
        },
        {
            value: 'CI',
            value_iso3: 'CIV',
            label: l('countries.CI')
        },
        {
            value: 'HR',
            value_iso3: 'HRV',
            label: l('countries.HR')
        },
        {
            value: 'CU',
            value_iso3: 'CUB',
            label: l('countries.CU')
        },
        {
            value: 'CW',
            value_iso3: 'CUW',
            label: l('countries.CW')
        },
        {
            value: 'CY',
            value_iso3: 'CYP',
            label: l('countries.CY')
        },
        {
            value: 'CZ',
            value_iso3: 'CZE',
            label: l('countries.CZ')
        },
        {
            value: 'DK',
            value_iso3: 'DNK',
            label: l('countries.DK')
        },
        {
            value: 'DJ',
            value_iso3: 'DJI',
            label: l('countries.DJ')
        },
        {
            value: 'DM',
            value_iso3: 'DMA',
            label: l('countries.DM')
        },
        {
            value: 'DO',
            value_iso3: 'DOM',
            label: l('countries.DO')
        },
        {
            value: 'EC',
            value_iso3: 'ECU',
            label: l('countries.EC')
        },
        {
            value: 'EG',
            value_iso3: 'EGY',
            label: l('countries.EG')
        },
        {
            value: 'SV',
            value_iso3: 'SLV',
            label: l('countries.SV')
        },
        {
            value: 'GQ',
            value_iso3: 'GNQ',
            label: l('countries.GQ')
        },
        {
            value: 'ER',
            value_iso3: 'ERI',
            label: l('countries.ER')
        },
        {
            value: 'EE',
            value_iso3: 'EST',
            label: l('countries.EE')
        },
        {
            value: 'ET',
            value_iso3: 'ETH',
            label: l('countries.ET')
        },
        {
            value: 'FK',
            value_iso3: 'FLK',
            label: l('countries.FK')
        },
        {
            value: 'FO',
            value_iso3: 'FRO',
            label: l('countries.FO')
        },
        {
            value: 'FJ',
            value_iso3: 'FJI',
            label: l('countries.FJ')
        },
        {
            value: 'FI',
            value_iso3: 'FIN',
            label: l('countries.FI')
        },
        {
            value: 'FR',
            value_iso3: 'FRA',
            label: l('countries.FR')
        },
        {
            value: 'GF',
            value_iso3: 'GUF',
            label: l('countries.GF')
        },
        {
            value: 'PF',
            value_iso3: 'PYF',
            label: l('countries.PF')
        },
        {
            value: 'TF',
            value_iso3: 'ATF',
            label: l('countries.TF')
        },
        {
            value: 'GA',
            value_iso3: 'GAB',
            label: l('countries.GA')
        },
        {
            value: 'GM',
            value_iso3: 'GMB',
            label: l('countries.GM')
        },
        {
            value: 'GE',
            value_iso3: 'GEO',
            label: l('countries.GE')
        },
        {
            value: 'DE',
            value_iso3: 'DEU',
            label: l('countries.DE')
        },
        {
            value: 'GH',
            value_iso3: 'GHA',
            label: l('countries.GH')
        },
        {
            value: 'GI',
            value_iso3: 'GIB',
            label: l('countries.GI')
        },
        {
            value: 'GR',
            value_iso3: 'GRC',
            label: l('countries.GR')
        },
        {
            value: 'GL',
            value_iso3: 'GRL',
            label: l('countries.GL')
        },
        {
            value: 'GD',
            value_iso3: 'GRD',
            label: l('countries.GD')
        },
        {
            value: 'GP',
            value_iso3: 'GLP',
            label: l('countries.GP')
        },
        {
            value: 'GU',
            value_iso3: 'GUM',
            label: l('countries.GU')
        },
        {
            value: 'GT',
            value_iso3: 'GTM',
            label: l('countries.GT')
        },
        {
            value: 'GG',
            value_iso3: 'GGY',
            label: l('countries.GG')
        },
        {
            value: 'GN',
            value_iso3: 'GIN',
            label: l('countries.GN')
        },
        {
            value: 'GW',
            value_iso3: 'GNB',
            label: l('countries.GW')
        },
        {
            value: 'GY',
            value_iso3: 'GUY',
            label: l('countries.GY')
        },
        {
            value: 'HT',
            value_iso3: 'HTI',
            label: l('countries.HT')
        },
        {
            value: 'HM',
            value_iso3: 'HMD',
            label: l('countries.HM')
        },
        {
            value: 'VA',
            value_iso3: 'VAT',
            label: l('countries.VA')
        },
        {
            value: 'HN',
            value_iso3: 'HND',
            label: l('countries.HN')
        },
        {
            value: 'HK',
            value_iso3: 'HKG',
            label: l('countries.HK')
        },
        {
            value: 'HU',
            value_iso3: 'HUN',
            label: l('countries.HU')
        },
        {
            value: 'IS',
            value_iso3: 'ISL',
            label: l('countries.IS')
        },
        {
            value: 'IN',
            value_iso3: 'IND',
            label: l('countries.IN')
        },
        {
            value: 'ID',
            value_iso3: 'IDN',
            label: l('countries.ID')
        },
        {
            value: 'IR',
            value_iso3: 'IRN',
            label: l('countries.IR')
        },
        {
            value: 'IQ',
            value_iso3: 'IRQ',
            label: l('countries.IQ')
        },
        {
            value: 'IE',
            value_iso3: 'IRL',
            label: l('countries.IE')
        },
        {
            value: 'IM',
            value_iso3: 'IMN',
            label: l('countries.IM')
        },
        {
            value: 'IL',
            value_iso3: 'ISR',
            label: l('countries.IL')
        },
        {
            value: 'IT',
            value_iso3: 'ITA',
            label: l('countries.IT')
        },
        {
            value: 'JM',
            value_iso3: 'JAM',
            label: l('countries.JM')
        },
        {
            value: 'JP',
            value_iso3: 'JPN',
            label: l('countries.JP')
        },
        {
            value: 'JE',
            value_iso3: 'JEY',
            label: l('countries.JE')
        },
        {
            value: 'JO',
            value_iso3: 'JOR',
            label: l('countries.JO')
        },
        {
            value: 'KZ',
            value_iso3: 'KAZ',
            label: l('countries.KZ')
        },
        {
            value: 'KE',
            value_iso3: 'KEN',
            label: l('countries.KE')
        },
        {
            value: 'KI',
            value_iso3: 'KIR',
            label: l('countries.KI')
        },
        {
            value: 'KP',
            value_iso3: 'PRK',
            label: l('countries.KP')
        },
        {
            value: 'KR',
            value_iso3: 'KOR',
            label: l('countries.KR')
        },
        {
            value: 'KW',
            value_iso3: 'KWT',
            label: l('countries.KW')
        },
        {
            value: 'KG',
            value_iso3: 'KGZ',
            label: l('countries.KG')
        },
        {
            value: 'LA',
            value_iso3: 'LAO',
            label: l('countries.LA')
        },
        {
            value: 'LV',
            value_iso3: 'LVA',
            label: l('countries.LV')
        },
        {
            value: 'LB',
            value_iso3: 'LBN',
            label: l('countries.LB')
        },
        {
            value: 'LS',
            value_iso3: 'LSO',
            label: l('countries.LS')
        },
        {
            value: 'LR',
            value_iso3: 'LBR',
            label: l('countries.LR')
        },
        {
            value: 'LY',
            value_iso3: 'LBY',
            label: l('countries.LY')
        },
        {
            value: 'LI',
            value_iso3: 'LIE',
            label: l('countries.LI')
        },
        {
            value: 'LT',
            value_iso3: 'LTU',
            label: l('countries.LT')
        },
        {
            value: 'LU',
            value_iso3: 'LUX',
            label: l('countries.LU')
        },
        {
            value: 'MO',
            value_iso3: 'MAC',
            label: l('countries.MO')
        },
        {
            value: 'MK',
            value_iso3: 'MKD',
            label: l('countries.MK')
        },
        {
            value: 'MG',
            value_iso3: 'MDG',
            label: l('countries.MG')
        },
        {
            value: 'MW',
            value_iso3: 'MWI',
            label: l('countries.MW')
        },
        {
            value: 'MY',
            value_iso3: 'MYS',
            label: l('countries.MY')
        },
        {
            value: 'MV',
            value_iso3: 'MDV',
            label: l('countries.MV')
        },
        {
            value: 'ML',
            value_iso3: 'MLI',
            label: l('countries.ML')
        },
        {
            value: 'MT',
            value_iso3: 'MLT',
            label: l('countries.MT')
        },
        {
            value: 'MH',
            value_iso3: 'MHL',
            label: l('countries.MH')
        },
        {
            value: 'MQ',
            value_iso3: 'MTQ',
            label: l('countries.MQ')
        },
        {
            value: 'MR',
            value_iso3: 'MRT',
            label: l('countries.MR')
        },
        {
            value: 'MU',
            value_iso3: 'MUS',
            label: l('countries.MU')
        },
        {
            value: 'YT',
            value_iso3: 'MYT',
            label: l('countries.YT')
        },
        {
            value: 'MX',
            value_iso3: 'MEX',
            label: l('countries.MX')
        },
        {
            value: 'FM',
            value_iso3: 'FSM',
            label: l('countries.FM')
        },
        {
            value: 'MD',
            value_iso3: 'MDA',
            label: l('countries.MD')
        },
        {
            value: 'MC',
            value_iso3: 'MCO',
            label: l('countries.MC')
        },
        {
            value: 'MN',
            value_iso3: 'MNG',
            label: l('countries.MN')
        },
        {
            value: 'ME',
            value_iso3: 'MNE',
            label: l('countries.ME')
        },
        {
            value: 'MS',
            value_iso3: 'MSR',
            label: l('countries.MS')
        },
        {
            value: 'MA',
            value_iso3: 'MAR',
            label: l('countries.MA')
        },
        {
            value: 'MZ',
            value_iso3: 'MOZ',
            label: l('countries.MZ')
        },
        {
            value: 'MM',
            value_iso3: 'MMR',
            label: l('countries.MM')
        },
        {
            value: 'NA',
            value_iso3: 'NAM',
            label: l('countries.NA')
        },
        {
            value: 'NR',
            value_iso3: 'NRU',
            label: l('countries.NR')
        },
        {
            value: 'NP',
            value_iso3: 'NPL',
            label: l('countries.NP')
        },
        {
            value: 'NL',
            value_iso3: 'NLD',
            label: l('countries.NL')
        },
        {
            value: 'NC',
            value_iso3: 'NCL',
            label: l('countries.NC')
        },
        {
            value: 'NZ',
            value_iso3: 'NZL',
            label: l('countries.NZ')
        },
        {
            value: 'NI',
            value_iso3: 'NIC',
            label: l('countries.NI')
        },
        {
            value: 'NE',
            value_iso3: 'NER',
            label: l('countries.NE')
        },
        {
            value: 'NG',
            value_iso3: 'NGA',
            label: l('countries.NG')
        },
        {
            value: 'NU',
            value_iso3: 'NIU',
            label: l('countries.NU')
        },
        {
            value: 'NF',
            value_iso3: 'NFK',
            label: l('countries.NF')
        },
        {
            value: 'MP',
            value_iso3: 'MNP',
            label: l('countries.MP')
        },
        {
            value: 'NO',
            value_iso3: 'NOR',
            label: l('countries.NO')
        },
        {
            value: 'OM',
            value_iso3: 'OMN',
            label: l('countries.OM')
        },
        {
            value: 'PK',
            value_iso3: 'PAK',
            label: l('countries.PK')
        },
        {
            value: 'PW',
            value_iso3: 'PLW',
            label: l('countries.PW')
        },
        {
            value: 'PS',
            value_iso3: 'PSE',
            label: l('countries.PS')
        },
        {
            value: 'PA',
            value_iso3: 'PAN',
            label: l('countries.PA')
        },
        {
            value: 'PG',
            value_iso3: 'PNG',
            label: l('countries.PG')
        },
        {
            value: 'PY',
            value_iso3: 'PRY',
            label: l('countries.PY')
        },
        {
            value: 'PE',
            value_iso3: 'PER',
            label: l('countries.PE')
        },
        {
            value: 'PH',
            value_iso3: 'PHL',
            label: l('countries.PH')
        },
        {
            value: 'PN',
            value_iso3: 'PCN',
            label: l('countries.PN')
        },
        {
            value: 'PL',
            value_iso3: 'POL',
            label: l('countries.PL')
        },
        {
            value: 'PT',
            value_iso3: 'PRT',
            label: l('countries.PT')
        },
        {
            value: 'PR',
            value_iso3: 'PRI',
            label: l('countries.PR')
        },
        {
            value: 'QA',
            value_iso3: 'QAT',
            label: l('countries.QA')
        },
        {
            value: 'RE',
            value_iso3: 'REU',
            label: l('countries.RE')
        },
        {
            value: 'RO',
            value_iso3: 'ROU',
            label: l('countries.RO')
        },
        {
            value: 'RU',
            value_iso3: 'RUS',
            label: l('countries.RU')
        },
        {
            value: 'RW',
            value_iso3: 'RWA',
            label: l('countries.RW')
        },
        {
            value: 'BL',
            value_iso3: 'BLM',
            label: l('countries.BL')
        },
        {
            value: 'SH',
            value_iso3: 'SHN',
            label: l('countries.SH')
        },
        {
            value: 'KN',
            value_iso3: 'KNA',
            label: l('countries.KN')
        },
        {
            value: 'LC',
            value_iso3: 'LCA',
            label: l('countries.LC')
        },
        {
            value: 'MF',
            value_iso3: 'MAF',
            label: l('countries.MF')
        },
        {
            value: 'PM',
            value_iso3: 'SPM',
            label: l('countries.PM')
        },
        {
            value: 'VC',
            value_iso3: 'VCT',
            label: l('countries.VC')
        },
        {
            value: 'WS',
            value_iso3: 'WSM',
            label: l('countries.WS')
        },
        {
            value: 'SM',
            value_iso3: 'SMR',
            label: l('countries.SM')
        },
        {
            value: 'ST',
            value_iso3: 'STP',
            label: l('countries.ST')
        },
        {
            value: 'SA',
            value_iso3: 'SAU',
            label: l('countries.SA')
        },
        {
            value: 'SN',
            value_iso3: 'SEN',
            label: l('countries.SN')
        },
        {
            value: 'RS',
            value_iso3: 'SRB',
            label: l('countries.RS')
        },
        {
            value: 'SC',
            value_iso3: 'SYC',
            label: l('countries.SC')
        },
        {
            value: 'SL',
            value_iso3: 'SLE',
            label: l('countries.SL')
        },
        {
            value: 'SG',
            value_iso3: 'SGP',
            label: l('countries.SG')
        },
        {
            value: 'SX',
            value_iso3: 'SXM',
            label: l('countries.SX')
        },
        {
            value: 'SK',
            value_iso3: 'SVK',
            label: l('countries.SK')
        },
        {
            value: 'SI',
            value_iso3: 'SVN',
            label: l('countries.SI')
        },
        {
            value: 'SB',
            value_iso3: 'SLB',
            label: l('countries.SB')
        },
        {
            value: 'SO',
            value_iso3: 'SOM',
            label: l('countries.SO')
        },
        {
            value: 'ZA',
            value_iso3: 'ZAF',
            label: l('countries.ZA')
        },
        {
            value: 'GS',
            value_iso3: 'SGS',
            label: l('countries.GS')
        },
        {
            value: 'SS',
            value_iso3: 'SSD',
            label: l('countries.SS')
        },
        {
            value: 'ES',
            value_iso3: 'ESP',
            label: l('countries.ES')
        },
        {
            value: 'LK',
            value_iso3: 'LKA',
            label: l('countries.LK')
        },
        {
            value: 'SD',
            value_iso3: 'SDN',
            label: l('countries.SD')
        },
        {
            value: 'SR',
            value_iso3: 'SUR',
            label: l('countries.SR')
        },
        {
            value: 'SJ',
            value_iso3: 'SJM',
            label: l('countries.SJ')
        },
        {
            value: 'SZ',
            value_iso3: 'SWZ',
            label: l('countries.SZ')
        },
        {
            value: 'SE',
            value_iso3: 'SWE',
            label: l('countries.SE')
        },
        {
            value: 'CH',
            value_iso3: 'CHE',
            label: l('countries.CH')
        },
        {
            value: 'SY',
            value_iso3: 'SYR',
            label: l('countries.SY')
        },
        {
            value: 'TW',
            value_iso3: 'TWN',
            label: l('countries.TW')
        },
        {
            value: 'TJ',
            value_iso3: 'TJK',
            label: l('countries.TJ')
        },
        {
            value: 'TZ',
            value_iso3: 'TZA',
            label: l('countries.TZ')
        },
        {
            value: 'TH',
            value_iso3: 'THA',
            label: l('countries.TH')
        },
        {
            value: 'TL',
            value_iso3: 'TLS',
            label: l('countries.TL')
        },
        {
            value: 'TG',
            value_iso3: 'TGO',
            label: l('countries.TG')
        },
        {
            value: 'TK',
            value_iso3: 'TKL',
            label: l('countries.TK')
        },
        {
            value: 'TO',
            value_iso3: 'TON',
            label: l('countries.TO')
        },
        {
            value: 'TT',
            value_iso3: 'TTO',
            label: l('countries.TT')
        },
        {
            value: 'TN',
            value_iso3: 'TUN',
            label: l('countries.TN')
        },
        {
            value: 'TR',
            value_iso3: 'TUR',
            label: l('countries.TR')
        },
        {
            value: 'TM',
            value_iso3: 'TKM',
            label: l('countries.TM')
        },
        {
            value: 'TC',
            value_iso3: 'TCA',
            label: l('countries.TC')
        },
        {
            value: 'TV',
            value_iso3: 'TUV',
            label: l('countries.TV')
        },
        {
            value: 'UG',
            value_iso3: 'UGA',
            label: l('countries.UG')
        },
        {
            value: 'UA',
            value_iso3: 'UKR',
            label: l('countries.UA')
        },
        {
            value: 'AE',
            value_iso3: 'ARE',
            label: l('countries.AE')
        },
        {
            value: 'GB',
            value_iso3: 'GBR',
            label: l('countries.GB')
        },
        {
            value: 'UM',
            value_iso3: 'UMI',
            label: l('countries.UM')
        },
        {
            value: 'UY',
            value_iso3: 'URY',
            label: l('countries.UY')
        },
        {
            value: 'UZ',
            value_iso3: 'UZB',
            label: l('countries.UZ')
        },
        {
            value: 'VU',
            value_iso3: 'VUT',
            label: l('countries.VU')
        },
        {
            value: 'VE',
            value_iso3: 'VEN',
            label: l('countries.VE')
        },
        {
            value: 'VN',
            value_iso3: 'VNM',
            label: l('countries.VN')
        },
        {
            value: 'VG',
            value_iso3: 'VGB',
            label: l('countries.VG')
        },
        {
            value: 'VI',
            value_iso3: 'VIR',
            label: l('countries.VI')
        },
        {
            value: 'WF',
            value_iso3: 'WLF',
            label: l('countries.WF')
        },
        {
            value: 'EH',
            value_iso3: 'ESH',
            label: l('countries.EH')
        },
        {
            value: 'YE',
            value_iso3: 'YEM',
            label: l('countries.YE')
        },
        {
            value: 'ZM',
            value_iso3: 'ZMB',
            label: l('countries.ZM')
        },
        {
            value: 'ZW',
            value_iso3: 'ZWE',
            label: l('countries.ZW')
        }
    ];
});
(function (f) {
    if (typeof exports === 'object' && typeof module !== 'undefined') {
        module.exports = f();
    } else if (typeof define === 'function' && define.amd) {
        define('common-vendor/google-libphonenumber/dist/browser/libphonenumber', [], f);
    } else {
        var g;
        if (typeof window !== 'undefined') {
            g = window;
        } else if (typeof global !== 'undefined') {
            g = global;
        } else if (typeof self !== 'undefined') {
            g = self;
        } else {
            g = this;
        }
        g.libphonenumber = f();
    }
}(function () {
    var define, module, exports;
    return function () {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = 'function' == typeof require && require;
                        if (!f && c)
                            return c(i, !0);
                        if (u)
                            return u(i, !0);
                        var a = new Error('Cannot find module \'' + i + '\'');
                        throw a.code = 'MODULE_NOT_FOUND', a;
                    }
                    var p = n[i] = { exports: {} };
                    e[i][0].call(p.exports, function (r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for (var u = 'function' == typeof require && require, i = 0; i < t.length; i++)
                o(t[i]);
            return o;
        }
        return r;
    }()({
        1: [
            function (require, module, exports) {
                (function (global) {
                    (function () {
                        var $jscomp = $jscomp || {};
                        $jscomp.scope = {};
                        $jscomp.createTemplateTagFirstArg = function (a) {
                            return a.raw = a;
                        };
                        $jscomp.createTemplateTagFirstArgWithRaw = function (a, b) {
                            a.raw = b;
                            return a;
                        };
                        $jscomp.checkStringArgs = function (a, b, c) {
                            if (null == a)
                                throw new TypeError('The \'this\' value for String.prototype.' + c + ' must not be null or undefined');
                            if (b instanceof RegExp)
                                throw new TypeError('First argument to String.prototype.' + c + ' must not be a regular expression');
                            return a + '';
                        };
                        $jscomp.ASSUME_ES5 = !1;
                        $jscomp.ASSUME_NO_NATIVE_MAP = !1;
                        $jscomp.ASSUME_NO_NATIVE_SET = !1;
                        $jscomp.SIMPLE_FROUND_POLYFILL = !1;
                        $jscomp.ISOLATE_POLYFILLS = !1;
                        $jscomp.FORCE_POLYFILL_PROMISE = !1;
                        $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
                        $jscomp.defineProperty = $jscomp.ASSUME_ES5 || 'function' == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
                            if (a == Array.prototype || a == Object.prototype)
                                return a;
                            a[b] = c.value;
                            return a;
                        };
                        $jscomp.getGlobal = function (a) {
                            a = [
                                'object' == typeof globalThis && globalThis,
                                a,
                                'object' == typeof window && window,
                                'object' == typeof self && self,
                                'object' == typeof global && global
                            ];
                            for (var b = 0; b < a.length; ++b) {
                                var c = a[b];
                                if (c && c.Math == Math)
                                    return c;
                            }
                            throw Error('Cannot find global object');
                        };
                        $jscomp.global = $jscomp.getGlobal(this);
                        $jscomp.IS_SYMBOL_NATIVE = 'function' === typeof Symbol && 'symbol' === typeof Symbol('x');
                        $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
                        $jscomp.polyfills = {};
                        $jscomp.propertyToPolyfillSymbol = {};
                        $jscomp.POLYFILL_PREFIX = '$jscp$';
                        var $jscomp$lookupPolyfilledValue = function (a, b) {
                            var c = $jscomp.propertyToPolyfillSymbol[b];
                            if (null == c)
                                return a[b];
                            c = a[c];
                            return void 0 !== c ? c : a[b];
                        };
                        $jscomp.polyfill = function (a, b, c, d) {
                            b && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(a, b, c, d) : $jscomp.polyfillUnisolated(a, b, c, d));
                        };
                        $jscomp.polyfillUnisolated = function (a, b, c, d) {
                            c = $jscomp.global;
                            a = a.split('.');
                            for (d = 0; d < a.length - 1; d++) {
                                var e = a[d];
                                if (!(e in c))
                                    return;
                                c = c[e];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && null != b && $jscomp.defineProperty(c, a, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            });
                        };
                        $jscomp.polyfillIsolated = function (a, b, c, d) {
                            var e = a.split('.');
                            a = 1 === e.length;
                            d = e[0];
                            d = !a && d in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
                            for (var f = 0; f < e.length - 1; f++) {
                                var g = e[f];
                                if (!(g in d))
                                    return;
                                d = d[g];
                            }
                            e = e[e.length - 1];
                            c = $jscomp.IS_SYMBOL_NATIVE && 'es6' === c ? d[e] : null;
                            b = b(c);
                            null != b && (a ? $jscomp.defineProperty($jscomp.polyfills, e, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            }) : b !== c && ($jscomp.propertyToPolyfillSymbol[e] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(e) : $jscomp.POLYFILL_PREFIX + e, e = $jscomp.propertyToPolyfillSymbol[e], $jscomp.defineProperty(d, e, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            })));
                        };
                        $jscomp.polyfill('String.prototype.endsWith', function (a) {
                            return a ? a : function (b, c) {
                                var d = $jscomp.checkStringArgs(this, b, 'endsWith');
                                b += '';
                                void 0 === c && (c = d.length);
                                c = Math.max(0, Math.min(c | 0, d.length));
                                for (var e = b.length; 0 < e && 0 < c;)
                                    if (d[--c] != b[--e])
                                        return !1;
                                return 0 >= e;
                            };
                        }, 'es6', 'es3');
                        $jscomp.findInternal = function (a, b, c) {
                            a instanceof String && (a = String(a));
                            for (var d = a.length, e = 0; e < d; e++) {
                                var f = a[e];
                                if (b.call(c, f, e, a))
                                    return {
                                        i: e,
                                        v: f
                                    };
                            }
                            return {
                                i: -1,
                                v: void 0
                            };
                        };
                        $jscomp.polyfill('String.prototype.startsWith', function (a) {
                            return a ? a : function (b, c) {
                                var d = $jscomp.checkStringArgs(this, b, 'startsWith');
                                b += '';
                                var e = d.length, f = b.length;
                                c = Math.max(0, Math.min(c | 0, d.length));
                                for (var g = 0; g < f && c < e;)
                                    if (d[c++] != b[g++])
                                        return !1;
                                return g >= f;
                            };
                        }, 'es6', 'es3');
                        $jscomp.polyfill('String.prototype.repeat', function (a) {
                            return a ? a : function (b) {
                                var c = $jscomp.checkStringArgs(this, null, 'repeat');
                                if (0 > b || 1342177279 < b)
                                    throw new RangeError('Invalid count value');
                                b |= 0;
                                for (var d = ''; b;)
                                    if (b & 1 && (d += c), b >>>= 1)
                                        c += c;
                                return d;
                            };
                        }, 'es6', 'es3');
                        $jscomp.arrayIteratorImpl = function (a) {
                            var b = 0;
                            return function () {
                                return b < a.length ? {
                                    done: !1,
                                    value: a[b++]
                                } : { done: !0 };
                            };
                        };
                        $jscomp.arrayIterator = function (a) {
                            return { next: $jscomp.arrayIteratorImpl(a) };
                        };
                        $jscomp.initSymbol = function () {
                        };
                        $jscomp.polyfill('Symbol', function (a) {
                            if (a)
                                return a;
                            var b = function (e, f) {
                                this.$jscomp$symbol$id_ = e;
                                $jscomp.defineProperty(this, 'description', {
                                    configurable: !0,
                                    writable: !0,
                                    value: f
                                });
                            };
                            b.prototype.toString = function () {
                                return this.$jscomp$symbol$id_;
                            };
                            var c = 0, d = function (e) {
                                    if (this instanceof d)
                                        throw new TypeError('Symbol is not a constructor');
                                    return new b('jscomp_symbol_' + (e || '') + '_' + c++, e);
                                };
                            return d;
                        }, 'es6', 'es3');
                        $jscomp.polyfill('Symbol.iterator', function (a) {
                            if (a)
                                return a;
                            a = Symbol('Symbol.iterator');
                            for (var b = 'Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array'.split(' '), c = 0; c < b.length; c++) {
                                var d = $jscomp.global[b[c]];
                                'function' === typeof d && 'function' != typeof d.prototype[a] && $jscomp.defineProperty(d.prototype, a, {
                                    configurable: !0,
                                    writable: !0,
                                    value: function () {
                                        return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
                                    }
                                });
                            }
                            return a;
                        }, 'es6', 'es3');
                        $jscomp.iteratorPrototype = function (a) {
                            a = { next: a };
                            a[Symbol.iterator] = function () {
                                return this;
                            };
                            return a;
                        };
                        $jscomp.iteratorFromArray = function (a, b) {
                            a instanceof String && (a += '');
                            var c = 0, d = !1, e = {
                                    next: function () {
                                        if (!d && c < a.length) {
                                            var f = c++;
                                            return {
                                                value: b(f, a[f]),
                                                done: !1
                                            };
                                        }
                                        d = !0;
                                        return {
                                            done: !0,
                                            value: void 0
                                        };
                                    }
                                };
                            e[Symbol.iterator] = function () {
                                return e;
                            };
                            return e;
                        };
                        $jscomp.polyfill('Array.prototype.keys', function (a) {
                            return a ? a : function () {
                                return $jscomp.iteratorFromArray(this, function (b) {
                                    return b;
                                });
                            };
                        }, 'es6', 'es3');
                        var COMPILED = !0, goog = goog || {};
                        goog.global = this || self;
                        goog.exportPath_ = function (a, b, c, d) {
                            a = a.split('.');
                            d = d || goog.global;
                            a[0] in d || 'undefined' == typeof d.execScript || d.execScript('var ' + a[0]);
                            for (var e; a.length && (e = a.shift());)
                                if (a.length || void 0 === b)
                                    d = d[e] && d[e] !== Object.prototype[e] ? d[e] : d[e] = {};
                                else if (!c && goog.isObject(b) && goog.isObject(d[e]))
                                    for (var f in b)
                                        b.hasOwnProperty(f) && (d[e][f] = b[f]);
                                else
                                    d[e] = b;
                        };
                        goog.define = function (a, b) {
                            if (!COMPILED) {
                                var c = goog.global.CLOSURE_UNCOMPILED_DEFINES, d = goog.global.CLOSURE_DEFINES;
                                c && void 0 === c.nodeType && Object.prototype.hasOwnProperty.call(c, a) ? b = c[a] : d && void 0 === d.nodeType && Object.prototype.hasOwnProperty.call(d, a) && (b = d[a]);
                            }
                            return b;
                        };
                        goog.FEATURESET_YEAR = 2012;
                        goog.DEBUG = !0;
                        goog.LOCALE = 'en';
                        goog.TRUSTED_SITE = !0;
                        goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
                        goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
                        goog.provide = function (a) {
                            if (goog.isInModuleLoader_())
                                throw Error('goog.provide cannot be used within a module.');
                            if (!COMPILED && goog.isProvided_(a))
                                throw Error('Namespace "' + a + '" already declared.');
                            goog.constructNamespace_(a);
                        };
                        goog.constructNamespace_ = function (a, b, c) {
                            if (!COMPILED) {
                                delete goog.implicitNamespaces_[a];
                                for (var d = a; (d = d.substring(0, d.lastIndexOf('.'))) && !goog.getObjectByName(d);)
                                    goog.implicitNamespaces_[d] = !0;
                            }
                            goog.exportPath_(a, b, c);
                        };
                        goog.getScriptNonce = function (a) {
                            if (a && a != goog.global)
                                return goog.getScriptNonce_(a.document);
                            null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
                            return goog.cspNonce_;
                        };
                        goog.NONCE_PATTERN_ = /^[\w+\/_-]+[=]{0,2}$/;
                        goog.cspNonce_ = null;
                        goog.getScriptNonce_ = function (a) {
                            return (a = a.querySelector && a.querySelector('script[nonce]')) && (a = a.nonce || a.getAttribute('nonce')) && goog.NONCE_PATTERN_.test(a) ? a : '';
                        };
                        goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
                        goog.module = function (a) {
                            if ('string' !== typeof a || !a || -1 == a.search(goog.VALID_MODULE_RE_))
                                throw Error('Invalid module identifier');
                            if (!goog.isInGoogModuleLoader_())
                                throw Error('Module ' + a + ' has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You\'re likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.');
                            if (goog.moduleLoaderState_.moduleName)
                                throw Error('goog.module may only be called once per module.');
                            goog.moduleLoaderState_.moduleName = a;
                            if (!COMPILED) {
                                if (goog.isProvided_(a))
                                    throw Error('Namespace "' + a + '" already declared.');
                                delete goog.implicitNamespaces_[a];
                            }
                        };
                        goog.module.get = function (a) {
                            return goog.module.getInternal_(a);
                        };
                        goog.module.getInternal_ = function (a) {
                            if (!COMPILED) {
                                if (a in goog.loadedModules_)
                                    return goog.loadedModules_[a].exports;
                                if (!goog.implicitNamespaces_[a])
                                    return a = goog.getObjectByName(a), null != a ? a : null;
                            }
                            return null;
                        };
                        goog.ModuleType = {
                            ES6: 'es6',
                            GOOG: 'goog'
                        };
                        goog.moduleLoaderState_ = null;
                        goog.isInModuleLoader_ = function () {
                            return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
                        };
                        goog.isInGoogModuleLoader_ = function () {
                            return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
                        };
                        goog.isInEs6ModuleLoader_ = function () {
                            if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6)
                                return !0;
                            var a = goog.global.$jscomp;
                            return a ? 'function' != typeof a.getCurrentModulePath ? !1 : !!a.getCurrentModulePath() : !1;
                        };
                        goog.module.declareLegacyNamespace = function () {
                            if (!COMPILED && !goog.isInGoogModuleLoader_())
                                throw Error('goog.module.declareLegacyNamespace must be called from within a goog.module');
                            if (!COMPILED && !goog.moduleLoaderState_.moduleName)
                                throw Error('goog.module must be called prior to goog.module.declareLegacyNamespace.');
                            goog.moduleLoaderState_.declareLegacyNamespace = !0;
                        };
                        goog.declareModuleId = function (a) {
                            if (!COMPILED) {
                                if (!goog.isInEs6ModuleLoader_())
                                    throw Error('goog.declareModuleId may only be called from within an ES6 module');
                                if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName)
                                    throw Error('goog.declareModuleId may only be called once per module.');
                                if (a in goog.loadedModules_)
                                    throw Error('Module with namespace "' + a + '" already exists.');
                            }
                            if (goog.moduleLoaderState_)
                                goog.moduleLoaderState_.moduleName = a;
                            else {
                                var b = goog.global.$jscomp;
                                if (!b || 'function' != typeof b.getCurrentModulePath)
                                    throw Error('Module with namespace "' + a + '" has been loaded incorrectly.');
                                b = b.require(b.getCurrentModulePath());
                                goog.loadedModules_[a] = {
                                    exports: b,
                                    type: goog.ModuleType.ES6,
                                    moduleId: a
                                };
                            }
                        };
                        goog.setTestOnly = function (a) {
                            if (goog.DISALLOW_TEST_ONLY_CODE)
                                throw a = a || '', Error('Importing test-only code into non-debug environment' + (a ? ': ' + a : '.'));
                        };
                        goog.forwardDeclare = function (a) {
                        };
                        COMPILED || (goog.isProvided_ = function (a) {
                            return a in goog.loadedModules_ || !goog.implicitNamespaces_[a] && null != goog.getObjectByName(a);
                        }, goog.implicitNamespaces_ = { 'goog.module': !0 });
                        goog.getObjectByName = function (a, b) {
                            a = a.split('.');
                            b = b || goog.global;
                            for (var c = 0; c < a.length; c++)
                                if (b = b[a[c]], null == b)
                                    return null;
                            return b;
                        };
                        goog.addDependency = function (a, b, c, d) {
                            !COMPILED && goog.DEPENDENCIES_ENABLED && goog.debugLoader_.addDependency(a, b, c, d);
                        };
                        goog.ENABLE_DEBUG_LOADER = !0;
                        goog.logToConsole_ = function (a) {
                            goog.global.console && goog.global.console.error(a);
                        };
                        goog.require = function (a) {
                            if (!COMPILED) {
                                goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested(a);
                                if (goog.isProvided_(a)) {
                                    if (goog.isInModuleLoader_())
                                        return goog.module.getInternal_(a);
                                } else if (goog.ENABLE_DEBUG_LOADER) {
                                    var b = goog.moduleLoaderState_;
                                    goog.moduleLoaderState_ = null;
                                    try {
                                        goog.debugLoader_.load_(a);
                                    } finally {
                                        goog.moduleLoaderState_ = b;
                                    }
                                }
                                return null;
                            }
                        };
                        goog.requireType = function (a) {
                            return {};
                        };
                        goog.basePath = '';
                        goog.nullFunction = function () {
                        };
                        goog.abstractMethod = function () {
                            throw Error('unimplemented abstract method');
                        };
                        goog.addSingletonGetter = function (a) {
                            a.instance_ = void 0;
                            a.getInstance = function () {
                                if (a.instance_)
                                    return a.instance_;
                                goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
                                return a.instance_ = new a();
                            };
                        };
                        goog.instantiatedSingletons_ = [];
                        goog.LOAD_MODULE_USING_EVAL = !0;
                        goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
                        goog.loadedModules_ = {};
                        goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
                        goog.TRANSPILE = 'detect';
                        goog.ASSUME_ES_MODULES_TRANSPILED = !1;
                        goog.TRANSPILE_TO_LANGUAGE = '';
                        goog.TRANSPILER = 'transpile.js';
                        goog.hasBadLetScoping = null;
                        goog.useSafari10Workaround = function () {
                            if (null == goog.hasBadLetScoping) {
                                try {
                                    var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
                                } catch (b) {
                                    a = !1;
                                }
                                goog.hasBadLetScoping = a;
                            }
                            return goog.hasBadLetScoping;
                        };
                        goog.workaroundSafari10EvalBug = function (a) {
                            return '(function(){' + a + '\n;})();\n';
                        };
                        goog.loadModule = function (a) {
                            var b = goog.moduleLoaderState_;
                            try {
                                goog.moduleLoaderState_ = {
                                    moduleName: '',
                                    declareLegacyNamespace: !1,
                                    type: goog.ModuleType.GOOG
                                };
                                var c = {}, d = c;
                                if ('function' === typeof a)
                                    d = a.call(void 0, d);
                                else if ('string' === typeof a)
                                    goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)), d = goog.loadModuleFromSource_.call(void 0, d, a);
                                else
                                    throw Error('Invalid module definition');
                                var e = goog.moduleLoaderState_.moduleName;
                                if ('string' === typeof e && e)
                                    goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(e, d, c !== d) : goog.SEAL_MODULE_EXPORTS && Object.seal && 'object' == typeof d && null != d && Object.seal(d), goog.loadedModules_[e] = {
                                        exports: d,
                                        type: goog.ModuleType.GOOG,
                                        moduleId: goog.moduleLoaderState_.moduleName
                                    };
                                else
                                    throw Error('Invalid module name "' + e + '"');
                            } finally {
                                goog.moduleLoaderState_ = b;
                            }
                        };
                        goog.loadModuleFromSource_ = function (a, b) {
                            eval(b);
                            return a;
                        };
                        goog.normalizePath_ = function (a) {
                            a = a.split('/');
                            for (var b = 0; b < a.length;)
                                '.' == a[b] ? a.splice(b, 1) : b && '..' == a[b] && a[b - 1] && '..' != a[b - 1] ? a.splice(--b, 2) : b++;
                            return a.join('/');
                        };
                        goog.loadFileSync_ = function (a) {
                            if (goog.global.CLOSURE_LOAD_FILE_SYNC)
                                return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
                            try {
                                var b = new goog.global.XMLHttpRequest();
                                b.open('get', a, !1);
                                b.send();
                                return 0 == b.status || 200 == b.status ? b.responseText : null;
                            } catch (c) {
                                return null;
                            }
                        };
                        goog.transpile_ = function (a, b, c) {
                            var d = goog.global.$jscomp;
                            d || (goog.global.$jscomp = d = {});
                            var e = d.transpile;
                            if (!e) {
                                var f = goog.basePath + goog.TRANSPILER, g = goog.loadFileSync_(f);
                                if (g) {
                                    (function () {
                                        (0, eval)(g + '\n//# sourceURL=' + f);
                                    }.call(goog.global));
                                    if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile)
                                        throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
                                    goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
                                    d = goog.global.$jscomp;
                                    e = d.transpile;
                                }
                            }
                            e || (e = d.transpile = function (h, k) {
                                goog.logToConsole_(k + ' requires transpilation but no transpiler was found.');
                                return h;
                            });
                            return e(a, b, c);
                        };
                        goog.typeOf = function (a) {
                            var b = typeof a;
                            return 'object' != b ? b : a ? Array.isArray(a) ? 'array' : b : 'null';
                        };
                        goog.isArrayLike = function (a) {
                            var b = goog.typeOf(a);
                            return 'array' == b || 'object' == b && 'number' == typeof a.length;
                        };
                        goog.isDateLike = function (a) {
                            return goog.isObject(a) && 'function' == typeof a.getFullYear;
                        };
                        goog.isObject = function (a) {
                            var b = typeof a;
                            return 'object' == b && null != a || 'function' == b;
                        };
                        goog.getUid = function (a) {
                            return Object.prototype.hasOwnProperty.call(a, goog.UID_PROPERTY_) && a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
                        };
                        goog.hasUid = function (a) {
                            return !!a[goog.UID_PROPERTY_];
                        };
                        goog.removeUid = function (a) {
                            null !== a && 'removeAttribute' in a && a.removeAttribute(goog.UID_PROPERTY_);
                            try {
                                delete a[goog.UID_PROPERTY_];
                            } catch (b) {
                            }
                        };
                        goog.UID_PROPERTY_ = 'closure_uid_' + (1000000000 * Math.random() >>> 0);
                        goog.uidCounter_ = 0;
                        goog.cloneObject = function (a) {
                            var b = goog.typeOf(a);
                            if ('object' == b || 'array' == b) {
                                if ('function' === typeof a.clone)
                                    return a.clone();
                                b = 'array' == b ? [] : {};
                                for (var c in a)
                                    b[c] = goog.cloneObject(a[c]);
                                return b;
                            }
                            return a;
                        };
                        goog.bindNative_ = function (a, b, c) {
                            return a.call.apply(a.bind, arguments);
                        };
                        goog.bindJs_ = function (a, b, c) {
                            if (!a)
                                throw Error();
                            if (2 < arguments.length) {
                                var d = Array.prototype.slice.call(arguments, 2);
                                return function () {
                                    var e = Array.prototype.slice.call(arguments);
                                    Array.prototype.unshift.apply(e, d);
                                    return a.apply(b, e);
                                };
                            }
                            return function () {
                                return a.apply(b, arguments);
                            };
                        };
                        goog.bind = function (a, b, c) {
                            Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf('native code') ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
                            return goog.bind.apply(null, arguments);
                        };
                        goog.partial = function (a, b) {
                            var c = Array.prototype.slice.call(arguments, 1);
                            return function () {
                                var d = c.slice();
                                d.push.apply(d, arguments);
                                return a.apply(this, d);
                            };
                        };
                        goog.mixin = function (a, b) {
                            for (var c in b)
                                a[c] = b[c];
                        };
                        goog.now = function () {
                            return Date.now();
                        };
                        goog.globalEval = function (a) {
                            (0, eval)(a);
                        };
                        goog.getCssName = function (a, b) {
                            if ('.' == String(a).charAt(0))
                                throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);
                            var c = function (e) {
                                    return goog.cssNameMapping_[e] || e;
                                }, d = function (e) {
                                    e = e.split('-');
                                    for (var f = [], g = 0; g < e.length; g++)
                                        f.push(c(e[g]));
                                    return f.join('-');
                                };
                            d = goog.cssNameMapping_ ? 'BY_WHOLE' == goog.cssNameMappingStyle_ ? c : d : function (e) {
                                return e;
                            };
                            a = b ? a + '-' + d(b) : d(a);
                            return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(a) : a;
                        };
                        goog.setCssNameMapping = function (a, b) {
                            goog.cssNameMapping_ = a;
                            goog.cssNameMappingStyle_ = b;
                        };
                        !COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
                        goog.getMsg = function (a, b, c) {
                            c && c.html && (a = a.replace(/</g, '&lt;'));
                            c && c.unescapeHtmlEntities && (a = a.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&apos;/g, '\'').replace(/&quot;/g, '"').replace(/&amp;/g, '&'));
                            b && (a = a.replace(/\{\$([^}]+)}/g, function (d, e) {
                                return null != b && e in b ? b[e] : d;
                            }));
                            return a;
                        };
                        goog.getMsgWithFallback = function (a, b) {
                            return a;
                        };
                        goog.exportSymbol = function (a, b, c) {
                            goog.exportPath_(a, b, !0, c);
                        };
                        goog.exportProperty = function (a, b, c) {
                            a[b] = c;
                        };
                        goog.inherits = function (a, b) {
                            function c() {
                            }
                            c.prototype = b.prototype;
                            a.superClass_ = b.prototype;
                            a.prototype = new c();
                            a.prototype.constructor = a;
                            a.base = function (d, e, f) {
                                for (var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++)
                                    g[h - 2] = arguments[h];
                                return b.prototype[e].apply(d, g);
                            };
                        };
                        goog.scope = function (a) {
                            if (goog.isInModuleLoader_())
                                throw Error('goog.scope is not supported within a module.');
                            a.call(goog.global);
                        };
                        COMPILED || (goog.global.COMPILED = COMPILED);
                        goog.defineClass = function (a, b) {
                            var c = b.constructor, d = b.statics;
                            c && c != Object.prototype.constructor || (c = function () {
                                throw Error('cannot instantiate an interface (no constructor defined).');
                            });
                            c = goog.defineClass.createSealingConstructor_(c, a);
                            a && goog.inherits(c, a);
                            delete b.constructor;
                            delete b.statics;
                            goog.defineClass.applyProperties_(c.prototype, b);
                            null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
                            return c;
                        };
                        goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
                        goog.defineClass.createSealingConstructor_ = function (a, b) {
                            return goog.defineClass.SEAL_CLASS_INSTANCES ? function () {
                                var c = a.apply(this, arguments) || this;
                                c[goog.UID_PROPERTY_] = c[goog.UID_PROPERTY_];
                                return c;
                            } : a;
                        };
                        goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = 'constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf'.split(' ');
                        goog.defineClass.applyProperties_ = function (a, b) {
                            for (var c in b)
                                Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
                            for (var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++)
                                c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
                        };
                        !COMPILED && goog.DEPENDENCIES_ENABLED && (goog.inHtmlDocument_ = function () {
                            var a = goog.global.document;
                            return null != a && 'write' in a;
                        }, goog.isDocumentLoading_ = function () {
                            var a = goog.global.document;
                            return a.attachEvent ? 'complete' != a.readyState : 'loading' == a.readyState;
                        }, goog.findBasePath_ = function () {
                            if (void 0 != goog.global.CLOSURE_BASE_PATH && 'string' === typeof goog.global.CLOSURE_BASE_PATH)
                                goog.basePath = goog.global.CLOSURE_BASE_PATH;
                            else if (goog.inHtmlDocument_()) {
                                var a = goog.global.document, b = a.currentScript;
                                a = b ? [b] : a.getElementsByTagName('SCRIPT');
                                for (b = a.length - 1; 0 <= b; --b) {
                                    var c = a[b].src, d = c.lastIndexOf('?');
                                    d = -1 == d ? c.length : d;
                                    if ('base.js' == c.substr(d - 7, 7)) {
                                        goog.basePath = c.substr(0, d - 7);
                                        break;
                                    }
                                }
                            }
                        }, goog.findBasePath_(), goog.Transpiler = function () {
                            this.requiresTranspilation_ = null;
                            this.transpilationTarget_ = goog.TRANSPILE_TO_LANGUAGE;
                        }, goog.Transpiler.prototype.createRequiresTranspilation_ = function () {
                            function a(g, h) {
                                e ? d[g] = !0 : h() ? (c = g, d[g] = !1) : e = d[g] = !0;
                            }
                            function b(g) {
                                try {
                                    return !!eval(g);
                                } catch (h) {
                                    return !1;
                                }
                            }
                            var c = 'es3', d = { es3: !1 }, e = !1, f = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : '';
                            a('es5', function () {
                                return b('[1,].length==1');
                            });
                            a('es6', function () {
                                return f.match(/Edge\/(\d+)(\.\d)*/i) ? !1 : b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
                            });
                            a('es7', function () {
                                return b('2 ** 2 == 4');
                            });
                            a('es8', function () {
                                return b('async () => 1, true');
                            });
                            a('es9', function () {
                                return b('({...rest} = {}), true');
                            });
                            a('es_next', function () {
                                return !1;
                            });
                            return {
                                target: c,
                                map: d
                            };
                        }, goog.Transpiler.prototype.needsTranspile = function (a, b) {
                            if ('always' == goog.TRANSPILE)
                                return !0;
                            if ('never' == goog.TRANSPILE)
                                return !1;
                            if (!this.requiresTranspilation_) {
                                var c = this.createRequiresTranspilation_();
                                this.requiresTranspilation_ = c.map;
                                this.transpilationTarget_ = this.transpilationTarget_ || c.target;
                            }
                            if (a in this.requiresTranspilation_)
                                return this.requiresTranspilation_[a] ? !0 : !goog.inHtmlDocument_() || 'es6' != b || 'noModule' in goog.global.document.createElement('script') ? !1 : !0;
                            throw Error('Unknown language mode: ' + a);
                        }, goog.Transpiler.prototype.transpile = function (a, b) {
                            return goog.transpile_(a, b, this.transpilationTarget_);
                        }, goog.transpiler_ = new goog.Transpiler(), goog.protectScriptTag_ = function (a) {
                            return a.replace(/<\/(SCRIPT)/gi, '\\x3c/$1');
                        }, goog.DebugLoader_ = function () {
                            this.dependencies_ = {};
                            this.idToPath_ = {};
                            this.written_ = {};
                            this.loadingDeps_ = [];
                            this.depsToLoad_ = [];
                            this.paused_ = !1;
                            this.factory_ = new goog.DependencyFactory(goog.transpiler_);
                            this.deferredCallbacks_ = {};
                            this.deferredQueue_ = [];
                        }, goog.DebugLoader_.prototype.bootstrap = function (a, b) {
                            function c() {
                                d && (goog.global.setTimeout(d, 0), d = null);
                            }
                            var d = b;
                            if (a.length) {
                                b = [];
                                for (var e = 0; e < a.length; e++) {
                                    var f = this.getPathFromDeps_(a[e]);
                                    if (!f)
                                        throw Error('Unregonized namespace: ' + a[e]);
                                    b.push(this.dependencies_[f]);
                                }
                                f = goog.require;
                                var g = 0;
                                for (e = 0; e < a.length; e++)
                                    f(a[e]), b[e].onLoad(function () {
                                        ++g == a.length && c();
                                    });
                            } else
                                c();
                        }, goog.DebugLoader_.prototype.loadClosureDeps = function () {
                            this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath + 'deps.js'), 'deps.js', [], [], {}, !1));
                            this.loadDeps_();
                        }, goog.DebugLoader_.prototype.requested = function (a, b) {
                            (a = this.getPathFromDeps_(a)) && (b || this.areDepsLoaded_(this.dependencies_[a].requires)) && (b = this.deferredCallbacks_[a]) && (delete this.deferredCallbacks_[a], b());
                        }, goog.DebugLoader_.prototype.setDependencyFactory = function (a) {
                            this.factory_ = a;
                        }, goog.DebugLoader_.prototype.load_ = function (a) {
                            if (this.getPathFromDeps_(a)) {
                                var b = this, c = [], d = function (e) {
                                        var f = b.getPathFromDeps_(e);
                                        if (!f)
                                            throw Error('Bad dependency path or symbol: ' + e);
                                        if (!b.written_[f]) {
                                            b.written_[f] = !0;
                                            e = b.dependencies_[f];
                                            for (f = 0; f < e.requires.length; f++)
                                                goog.isProvided_(e.requires[f]) || d(e.requires[f]);
                                            c.push(e);
                                        }
                                    };
                                d(a);
                                a = !!this.depsToLoad_.length;
                                this.depsToLoad_ = this.depsToLoad_.concat(c);
                                this.paused_ || a || this.loadDeps_();
                            } else
                                throw a = 'goog.require could not find: ' + a, goog.logToConsole_(a), Error(a);
                        }, goog.DebugLoader_.prototype.loadDeps_ = function () {
                            for (var a = this, b = this.paused_; this.depsToLoad_.length && !b;)
                                (function () {
                                    var c = !1, d = a.depsToLoad_.shift(), e = !1;
                                    a.loading_(d);
                                    var f = {
                                        pause: function () {
                                            if (c)
                                                throw Error('Cannot call pause after the call to load.');
                                            b = !0;
                                        },
                                        resume: function () {
                                            c ? a.resume_() : b = !1;
                                        },
                                        loaded: function () {
                                            if (e)
                                                throw Error('Double call to loaded.');
                                            e = !0;
                                            a.loaded_(d);
                                        },
                                        pending: function () {
                                            for (var g = [], h = 0; h < a.loadingDeps_.length; h++)
                                                g.push(a.loadingDeps_[h]);
                                            return g;
                                        },
                                        setModuleState: function (g) {
                                            goog.moduleLoaderState_ = {
                                                type: g,
                                                moduleName: '',
                                                declareLegacyNamespace: !1
                                            };
                                        },
                                        registerEs6ModuleExports: function (g, h, k) {
                                            k && (goog.loadedModules_[k] = {
                                                exports: h,
                                                type: goog.ModuleType.ES6,
                                                moduleId: k || ''
                                            });
                                        },
                                        registerGoogModuleExports: function (g, h) {
                                            goog.loadedModules_[g] = {
                                                exports: h,
                                                type: goog.ModuleType.GOOG,
                                                moduleId: g
                                            };
                                        },
                                        clearModuleState: function () {
                                            goog.moduleLoaderState_ = null;
                                        },
                                        defer: function (g) {
                                            if (c)
                                                throw Error('Cannot register with defer after the call to load.');
                                            a.defer_(d, g);
                                        },
                                        areDepsLoaded: function () {
                                            return a.areDepsLoaded_(d.requires);
                                        }
                                    };
                                    try {
                                        d.load(f);
                                    } finally {
                                        c = !0;
                                    }
                                }());
                            b && this.pause_();
                        }, goog.DebugLoader_.prototype.pause_ = function () {
                            this.paused_ = !0;
                        }, goog.DebugLoader_.prototype.resume_ = function () {
                            this.paused_ && (this.paused_ = !1, this.loadDeps_());
                        }, goog.DebugLoader_.prototype.loading_ = function (a) {
                            this.loadingDeps_.push(a);
                        }, goog.DebugLoader_.prototype.loaded_ = function (a) {
                            for (var b = 0; b < this.loadingDeps_.length; b++)
                                if (this.loadingDeps_[b] == a) {
                                    this.loadingDeps_.splice(b, 1);
                                    break;
                                }
                            for (b = 0; b < this.deferredQueue_.length; b++)
                                if (this.deferredQueue_[b] == a.path) {
                                    this.deferredQueue_.splice(b, 1);
                                    break;
                                }
                            if (this.loadingDeps_.length == this.deferredQueue_.length && !this.depsToLoad_.length)
                                for (; this.deferredQueue_.length;)
                                    this.requested(this.deferredQueue_.shift(), !0);
                            a.loaded();
                        }, goog.DebugLoader_.prototype.areDepsLoaded_ = function (a) {
                            for (var b = 0; b < a.length; b++) {
                                var c = this.getPathFromDeps_(a[b]);
                                if (!c || !(c in this.deferredCallbacks_ || goog.isProvided_(a[b])))
                                    return !1;
                            }
                            return !0;
                        }, goog.DebugLoader_.prototype.getPathFromDeps_ = function (a) {
                            return a in this.idToPath_ ? this.idToPath_[a] : a in this.dependencies_ ? a : null;
                        }, goog.DebugLoader_.prototype.defer_ = function (a, b) {
                            this.deferredCallbacks_[a.path] = b;
                            this.deferredQueue_.push(a.path);
                        }, goog.LoadController = function () {
                        }, goog.LoadController.prototype.pause = function () {
                        }, goog.LoadController.prototype.resume = function () {
                        }, goog.LoadController.prototype.loaded = function () {
                        }, goog.LoadController.prototype.pending = function () {
                        }, goog.LoadController.prototype.registerEs6ModuleExports = function (a, b, c) {
                        }, goog.LoadController.prototype.setModuleState = function (a) {
                        }, goog.LoadController.prototype.clearModuleState = function () {
                        }, goog.LoadController.prototype.defer = function (a) {
                        }, goog.LoadController.prototype.areDepsLoaded = function () {
                        }, goog.Dependency = function (a, b, c, d, e) {
                            this.path = a;
                            this.relativePath = b;
                            this.provides = c;
                            this.requires = d;
                            this.loadFlags = e;
                            this.loaded_ = !1;
                            this.loadCallbacks_ = [];
                        }, goog.Dependency.prototype.getPathName = function () {
                            var a = this.path, b = a.indexOf('://');
                            0 <= b && (a = a.substring(b + 3), b = a.indexOf('/'), 0 <= b && (a = a.substring(b + 1)));
                            return a;
                        }, goog.Dependency.prototype.onLoad = function (a) {
                            this.loaded_ ? a() : this.loadCallbacks_.push(a);
                        }, goog.Dependency.prototype.loaded = function () {
                            this.loaded_ = !0;
                            var a = this.loadCallbacks_;
                            this.loadCallbacks_ = [];
                            for (var b = 0; b < a.length; b++)
                                a[b]();
                        }, goog.Dependency.defer_ = !1, goog.Dependency.callbackMap_ = {}, goog.Dependency.registerCallback_ = function (a) {
                            var b = Math.random().toString(32);
                            goog.Dependency.callbackMap_[b] = a;
                            return b;
                        }, goog.Dependency.unregisterCallback_ = function (a) {
                            delete goog.Dependency.callbackMap_[a];
                        }, goog.Dependency.callback_ = function (a, b) {
                            if (a in goog.Dependency.callbackMap_) {
                                for (var c = goog.Dependency.callbackMap_[a], d = [], e = 1; e < arguments.length; e++)
                                    d.push(arguments[e]);
                                c.apply(void 0, d);
                            } else
                                throw Error('Callback key ' + a + ' does not exist (was base.js loaded more than once?).');
                        }, goog.Dependency.prototype.load = function (a) {
                            if (goog.global.CLOSURE_IMPORT_SCRIPT)
                                goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
                            else if (goog.inHtmlDocument_()) {
                                var b = goog.global.document;
                                if ('complete' == b.readyState && !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING) {
                                    if (/\bdeps.js$/.test(this.path)) {
                                        a.loaded();
                                        return;
                                    }
                                    throw Error('Cannot write "' + this.path + '" after document load');
                                }
                                var c = goog.getScriptNonce();
                                if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && goog.isDocumentLoading_()) {
                                    var d = function (h) {
                                        h.readyState && 'complete' != h.readyState ? h.onload = d : (goog.Dependency.unregisterCallback_(e), a.loaded());
                                    };
                                    var e = goog.Dependency.registerCallback_(d);
                                    c = c ? ' nonce="' + c + '"' : '';
                                    var f = '<script src="' + this.path + '"' + c + (goog.Dependency.defer_ ? ' defer' : '') + ' id="script-' + e + '"></script>';
                                    f += '<script' + c + '>';
                                    f = goog.Dependency.defer_ ? f + ('document.getElementById(\'script-' + e + '\').onload = function() {\n  goog.Dependency.callback_(\'' + e + '\', this);\n};\n') : f + ('goog.Dependency.callback_(\'' + e + '\', document.getElementById(\'script-' + e + '\'));');
                                    f += '</script>';
                                    b.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(f) : f);
                                } else {
                                    var g = b.createElement('script');
                                    g.defer = goog.Dependency.defer_;
                                    g.async = !1;
                                    c && (g.nonce = c);
                                    goog.DebugLoader_.IS_OLD_IE_ ? (a.pause(), g.onreadystatechange = function () {
                                        if ('loaded' == g.readyState || 'complete' == g.readyState)
                                            a.loaded(), a.resume();
                                    }) : g.onload = function () {
                                        g.onload = null;
                                        a.loaded();
                                    };
                                    g.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path) : this.path;
                                    b.head.appendChild(g);
                                }
                            } else
                                goog.logToConsole_('Cannot use default debug loader outside of HTML documents.'), 'deps.js' == this.relativePath ? (goog.logToConsole_('Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true.'), a.loaded()) : a.pause();
                        }, goog.Es6ModuleDependency = function (a, b, c, d, e) {
                            goog.Dependency.call(this, a, b, c, d, e);
                        }, goog.inherits(goog.Es6ModuleDependency, goog.Dependency), goog.Es6ModuleDependency.prototype.load = function (a) {
                            function b(l, p) {
                                var m = '', n = goog.getScriptNonce();
                                n && (m = ' nonce="' + n + '"');
                                l = p ? '<script type="module" crossorigin' + m + '>' + p + '</script>' : '<script type="module" crossorigin src="' + l + '"' + m + '></script>';
                                d.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(l) : l);
                            }
                            function c(l, p) {
                                var m = d.createElement('script');
                                m.defer = !0;
                                m.async = !1;
                                m.type = 'module';
                                m.setAttribute('crossorigin', !0);
                                var n = goog.getScriptNonce();
                                n && (m.nonce = n);
                                p ? m.text = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScript(p) : p : m.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(l) : l;
                                d.head.appendChild(m);
                            }
                            if (goog.global.CLOSURE_IMPORT_SCRIPT)
                                goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
                            else if (goog.inHtmlDocument_()) {
                                var d = goog.global.document, e = this;
                                if (goog.isDocumentLoading_()) {
                                    var f = b;
                                    goog.Dependency.defer_ = !0;
                                } else
                                    f = c;
                                var g = goog.Dependency.registerCallback_(function () {
                                    goog.Dependency.unregisterCallback_(g);
                                    a.setModuleState(goog.ModuleType.ES6);
                                });
                                f(void 0, 'goog.Dependency.callback_("' + g + '")');
                                f(this.path, void 0);
                                var h = goog.Dependency.registerCallback_(function (l) {
                                    goog.Dependency.unregisterCallback_(h);
                                    a.registerEs6ModuleExports(e.path, l, goog.moduleLoaderState_.moduleName);
                                });
                                f(void 0, 'import * as m from "' + this.path + '"; goog.Dependency.callback_("' + h + '", m)');
                                var k = goog.Dependency.registerCallback_(function () {
                                    goog.Dependency.unregisterCallback_(k);
                                    a.clearModuleState();
                                    a.loaded();
                                });
                                f(void 0, 'goog.Dependency.callback_("' + k + '")');
                            } else
                                goog.logToConsole_('Cannot use default debug loader outside of HTML documents.'), a.pause();
                        }, goog.TransformedDependency = function (a, b, c, d, e) {
                            goog.Dependency.call(this, a, b, c, d, e);
                            this.contents_ = null;
                            this.lazyFetch_ = !goog.inHtmlDocument_() || !('noModule' in goog.global.document.createElement('script'));
                        }, goog.inherits(goog.TransformedDependency, goog.Dependency), goog.TransformedDependency.prototype.load = function (a) {
                            function b() {
                                e.contents_ = goog.loadFileSync_(e.path);
                                e.contents_ && (e.contents_ = e.transform(e.contents_), e.contents_ && (e.contents_ += '\n//# sourceURL=' + e.path));
                            }
                            function c() {
                                e.lazyFetch_ && b();
                                if (e.contents_) {
                                    f && a.setModuleState(goog.ModuleType.ES6);
                                    try {
                                        var p = e.contents_;
                                        e.contents_ = null;
                                        goog.globalEval(p);
                                        if (f)
                                            var m = goog.moduleLoaderState_.moduleName;
                                    } finally {
                                        f && a.clearModuleState();
                                    }
                                    f && goog.global.$jscomp.require.ensure([e.getPathName()], function () {
                                        a.registerEs6ModuleExports(e.path, goog.global.$jscomp.require(e.getPathName()), m);
                                    });
                                    a.loaded();
                                }
                            }
                            function d() {
                                var p = goog.global.document, m = goog.Dependency.registerCallback_(function () {
                                        goog.Dependency.unregisterCallback_(m);
                                        c();
                                    }), n = goog.getScriptNonce();
                                n = '<script' + (n ? ' nonce="' + n + '"' : '') + '>' + goog.protectScriptTag_('goog.Dependency.callback_("' + m + '");') + '</script>';
                                p.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(n) : n);
                            }
                            var e = this;
                            if (goog.global.CLOSURE_IMPORT_SCRIPT)
                                b(), this.contents_ && goog.global.CLOSURE_IMPORT_SCRIPT('', this.contents_) ? (this.contents_ = null, a.loaded()) : a.pause();
                            else {
                                var f = this.loadFlags.module == goog.ModuleType.ES6;
                                this.lazyFetch_ || b();
                                var g = 1 < a.pending().length, h = g && goog.DebugLoader_.IS_OLD_IE_;
                                g = goog.Dependency.defer_ && (g || goog.isDocumentLoading_());
                                if (h || g)
                                    a.defer(function () {
                                        c();
                                    });
                                else {
                                    var k = goog.global.document;
                                    h = goog.inHtmlDocument_() && 'ActiveXObject' in goog.global;
                                    if (f && goog.inHtmlDocument_() && goog.isDocumentLoading_() && !h) {
                                        goog.Dependency.defer_ = !0;
                                        a.pause();
                                        var l = k.onreadystatechange;
                                        k.onreadystatechange = function () {
                                            'interactive' == k.readyState && (k.onreadystatechange = l, c(), a.resume());
                                            'function' === typeof l && l.apply(void 0, arguments);
                                        };
                                    } else
                                        !goog.DebugLoader_.IS_OLD_IE_ && goog.inHtmlDocument_() && goog.isDocumentLoading_() ? d() : c();
                                }
                            }
                        }, goog.TransformedDependency.prototype.transform = function (a) {
                        }, goog.TranspiledDependency = function (a, b, c, d, e, f) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                            this.transpiler = f;
                        }, goog.inherits(goog.TranspiledDependency, goog.TransformedDependency), goog.TranspiledDependency.prototype.transform = function (a) {
                            return this.transpiler.transpile(a, this.getPathName());
                        }, goog.PreTranspiledEs6ModuleDependency = function (a, b, c, d, e) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                        }, goog.inherits(goog.PreTranspiledEs6ModuleDependency, goog.TransformedDependency), goog.PreTranspiledEs6ModuleDependency.prototype.transform = function (a) {
                            return a;
                        }, goog.GoogModuleDependency = function (a, b, c, d, e, f, g) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                            this.needsTranspile_ = f;
                            this.transpiler_ = g;
                        }, goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency), goog.GoogModuleDependency.prototype.transform = function (a) {
                            this.needsTranspile_ && (a = this.transpiler_.transpile(a, this.getPathName()));
                            return goog.LOAD_MODULE_USING_EVAL && void 0 !== goog.global.JSON ? 'goog.loadModule(' + goog.global.JSON.stringify(a + '\n//# sourceURL=' + this.path + '\n') + ');' : 'goog.loadModule(function(exports) {"use strict";' + a + '\n;return exports});\n//# sourceURL=' + this.path + '\n';
                        }, goog.DebugLoader_.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.DebugLoader_.prototype.addDependency = function (a, b, c, d) {
                            b = b || [];
                            a = a.replace(/\\/g, '/');
                            var e = goog.normalizePath_(goog.basePath + a);
                            d && 'boolean' !== typeof d || (d = d ? { module: goog.ModuleType.GOOG } : {});
                            c = this.factory_.createDependency(e, a, b, c, d, goog.transpiler_.needsTranspile(d.lang || 'es3', d.module));
                            this.dependencies_[e] = c;
                            for (c = 0; c < b.length; c++)
                                this.idToPath_[b[c]] = e;
                            this.idToPath_[a] = e;
                        }, goog.DependencyFactory = function (a) {
                            this.transpiler = a;
                        }, goog.DependencyFactory.prototype.createDependency = function (a, b, c, d, e, f) {
                            return e.module == goog.ModuleType.GOOG ? new goog.GoogModuleDependency(a, b, c, d, e, f, this.transpiler) : f ? new goog.TranspiledDependency(a, b, c, d, e, this.transpiler) : e.module == goog.ModuleType.ES6 ? 'never' == goog.TRANSPILE && goog.ASSUME_ES_MODULES_TRANSPILED ? new goog.PreTranspiledEs6ModuleDependency(a, b, c, d, e) : new goog.Es6ModuleDependency(a, b, c, d, e) : new goog.Dependency(a, b, c, d, e);
                        }, goog.debugLoader_ = new goog.DebugLoader_(), goog.loadClosureDeps = function () {
                            goog.debugLoader_.loadClosureDeps();
                        }, goog.setDependencyFactory = function (a) {
                            goog.debugLoader_.setDependencyFactory(a);
                        }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + '#base') : null, goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(), goog.bootstrap = function (a, b) {
                            goog.debugLoader_.bootstrap(a, b);
                        });
                        goog.TRUSTED_TYPES_POLICY_NAME = 'goog';
                        goog.identity_ = function (a) {
                            return a;
                        };
                        goog.createTrustedTypesPolicy = function (a) {
                            var b = null, c = goog.global.trustedTypes;
                            if (!c || !c.createPolicy)
                                return b;
                            try {
                                b = c.createPolicy(a, {
                                    createHTML: goog.identity_,
                                    createScript: goog.identity_,
                                    createScriptURL: goog.identity_
                                });
                            } catch (d) {
                                goog.logToConsole_(d.message);
                            }
                            return b;
                        };
                        goog.debug = {};
                        function module$contents$goog$debug$Error_DebugError(a) {
                            if (Error.captureStackTrace)
                                Error.captureStackTrace(this, module$contents$goog$debug$Error_DebugError);
                            else {
                                var b = Error().stack;
                                b && (this.stack = b);
                            }
                            a && (this.message = String(a));
                            this.reportErrorToServer = !0;
                        }
                        goog.inherits(module$contents$goog$debug$Error_DebugError, Error);
                        module$contents$goog$debug$Error_DebugError.prototype.name = 'CustomError';
                        goog.debug.Error = module$contents$goog$debug$Error_DebugError;
                        goog.dom = {};
                        goog.dom.NodeType = {
                            ELEMENT: 1,
                            ATTRIBUTE: 2,
                            TEXT: 3,
                            CDATA_SECTION: 4,
                            ENTITY_REFERENCE: 5,
                            ENTITY: 6,
                            PROCESSING_INSTRUCTION: 7,
                            COMMENT: 8,
                            DOCUMENT: 9,
                            DOCUMENT_TYPE: 10,
                            DOCUMENT_FRAGMENT: 11,
                            NOTATION: 12
                        };
                        goog.asserts = {};
                        goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
                        goog.asserts.AssertionError = function (a, b) {
                            module$contents$goog$debug$Error_DebugError.call(this, goog.asserts.subs_(a, b));
                            this.messagePattern = a;
                        };
                        goog.inherits(goog.asserts.AssertionError, module$contents$goog$debug$Error_DebugError);
                        goog.asserts.AssertionError.prototype.name = 'AssertionError';
                        goog.asserts.DEFAULT_ERROR_HANDLER = function (a) {
                            throw a;
                        };
                        goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
                        goog.asserts.subs_ = function (a, b) {
                            a = a.split('%s');
                            for (var c = '', d = a.length - 1, e = 0; e < d; e++)
                                c += a[e] + (e < b.length ? b[e] : '%s');
                            return c + a[d];
                        };
                        goog.asserts.doAssertFailure_ = function (a, b, c, d) {
                            var e = 'Assertion failed';
                            if (c) {
                                e += ': ' + c;
                                var f = d;
                            } else
                                a && (e += ': ' + a, f = b);
                            a = new goog.asserts.AssertionError('' + e, f || []);
                            goog.asserts.errorHandler_(a);
                        };
                        goog.asserts.setErrorHandler = function (a) {
                            goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a);
                        };
                        goog.asserts.assert = function (a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !a && goog.asserts.doAssertFailure_('', null, b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertExists = function (a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && null == a && goog.asserts.doAssertFailure_('Expected to exist: %s.', [a], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.fail = function (a, b) {
                            goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError('Failure' + (a ? ': ' + a : ''), Array.prototype.slice.call(arguments, 1)));
                        };
                        goog.asserts.assertNumber = function (a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && 'number' !== typeof a && goog.asserts.doAssertFailure_('Expected number but got %s: %s.', [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertString = function (a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && 'string' !== typeof a && goog.asserts.doAssertFailure_('Expected string but got %s: %s.', [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertFunction = function (a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && 'function' !== typeof a && goog.asserts.doAssertFailure_('Expected function but got %s: %s.', [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertObject = function (a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !goog.isObject(a) && goog.asserts.doAssertFailure_('Expected object but got %s: %s.', [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertArray = function (a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !Array.isArray(a) && goog.asserts.doAssertFailure_('Expected array but got %s: %s.', [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertBoolean = function (a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && 'boolean' !== typeof a && goog.asserts.doAssertFailure_('Expected boolean but got %s: %s.', [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertElement = function (a, b, c) {
                            !goog.asserts.ENABLE_ASSERTS || goog.isObject(a) && a.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_('Expected Element but got %s: %s.', [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertInstanceof = function (a, b, c, d) {
                            !goog.asserts.ENABLE_ASSERTS || a instanceof b || goog.asserts.doAssertFailure_('Expected instanceof %s but got %s.', [
                                goog.asserts.getType_(b),
                                goog.asserts.getType_(a)
                            ], c, Array.prototype.slice.call(arguments, 3));
                            return a;
                        };
                        goog.asserts.assertFinite = function (a, b, c) {
                            !goog.asserts.ENABLE_ASSERTS || 'number' == typeof a && isFinite(a) || goog.asserts.doAssertFailure_('Expected %s to be a finite number but it is not.', [a], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertObjectPrototypeIsIntact = function () {
                            for (var a in Object.prototype)
                                goog.asserts.fail(a + ' should not be enumerable in Object.prototype.');
                        };
                        goog.asserts.getType_ = function (a) {
                            return a instanceof Function ? a.displayName || a.name || 'unknown type name' : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? 'null' : typeof a;
                        };
                        goog.array = {};
                        goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
                        var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
                        goog.array.ASSUME_NATIVE_FUNCTIONS = module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;
                        function module$contents$goog$array_peek(a) {
                            return a[a.length - 1];
                        }
                        goog.array.peek = module$contents$goog$array_peek;
                        goog.array.last = module$contents$goog$array_peek;
                        var module$contents$goog$array_indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function (a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.indexOf.call(a, b, c);
                        } : function (a, b, c) {
                            c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
                            if ('string' === typeof a)
                                return 'string' !== typeof b || 1 != b.length ? -1 : a.indexOf(b, c);
                            for (; c < a.length; c++)
                                if (c in a && a[c] === b)
                                    return c;
                            return -1;
                        };
                        goog.array.indexOf = module$contents$goog$array_indexOf;
                        var module$contents$goog$array_lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function (a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.lastIndexOf.call(a, b, null == c ? a.length - 1 : c);
                        } : function (a, b, c) {
                            c = null == c ? a.length - 1 : c;
                            0 > c && (c = Math.max(0, a.length + c));
                            if ('string' === typeof a)
                                return 'string' !== typeof b || 1 != b.length ? -1 : a.lastIndexOf(b, c);
                            for (; 0 <= c; c--)
                                if (c in a && a[c] === b)
                                    return c;
                            return -1;
                        };
                        goog.array.lastIndexOf = module$contents$goog$array_lastIndexOf;
                        var module$contents$goog$array_forEach = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function (a, b, c) {
                            goog.asserts.assert(null != a.length);
                            Array.prototype.forEach.call(a, b, c);
                        } : function (a, b, c) {
                            for (var d = a.length, e = 'string' === typeof a ? a.split('') : a, f = 0; f < d; f++)
                                f in e && b.call(c, e[f], f, a);
                        };
                        goog.array.forEach = module$contents$goog$array_forEach;
                        function module$contents$goog$array_forEachRight(a, b, c) {
                            var d = a.length, e = 'string' === typeof a ? a.split('') : a;
                            for (--d; 0 <= d; --d)
                                d in e && b.call(c, e[d], d, a);
                        }
                        goog.array.forEachRight = module$contents$goog$array_forEachRight;
                        var module$contents$goog$array_filter = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function (a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.filter.call(a, b, c);
                        } : function (a, b, c) {
                            for (var d = a.length, e = [], f = 0, g = 'string' === typeof a ? a.split('') : a, h = 0; h < d; h++)
                                if (h in g) {
                                    var k = g[h];
                                    b.call(c, k, h, a) && (e[f++] = k);
                                }
                            return e;
                        };
                        goog.array.filter = module$contents$goog$array_filter;
                        var module$contents$goog$array_map = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function (a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.map.call(a, b, c);
                        } : function (a, b, c) {
                            for (var d = a.length, e = Array(d), f = 'string' === typeof a ? a.split('') : a, g = 0; g < d; g++)
                                g in f && (e[g] = b.call(c, f[g], g, a));
                            return e;
                        };
                        goog.array.map = module$contents$goog$array_map;
                        var module$contents$goog$array_reduce = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function (a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            d && (b = goog.bind(b, d));
                            return Array.prototype.reduce.call(a, b, c);
                        } : function (a, b, c, d) {
                            var e = c;
                            module$contents$goog$array_forEach(a, function (f, g) {
                                e = b.call(d, e, f, g, a);
                            });
                            return e;
                        };
                        goog.array.reduce = module$contents$goog$array_reduce;
                        var module$contents$goog$array_reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function (a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            goog.asserts.assert(null != b);
                            d && (b = goog.bind(b, d));
                            return Array.prototype.reduceRight.call(a, b, c);
                        } : function (a, b, c, d) {
                            var e = c;
                            module$contents$goog$array_forEachRight(a, function (f, g) {
                                e = b.call(d, e, f, g, a);
                            });
                            return e;
                        };
                        goog.array.reduceRight = module$contents$goog$array_reduceRight;
                        var module$contents$goog$array_some = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function (a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.some.call(a, b, c);
                        } : function (a, b, c) {
                            for (var d = a.length, e = 'string' === typeof a ? a.split('') : a, f = 0; f < d; f++)
                                if (f in e && b.call(c, e[f], f, a))
                                    return !0;
                            return !1;
                        };
                        goog.array.some = module$contents$goog$array_some;
                        var module$contents$goog$array_every = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function (a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.every.call(a, b, c);
                        } : function (a, b, c) {
                            for (var d = a.length, e = 'string' === typeof a ? a.split('') : a, f = 0; f < d; f++)
                                if (f in e && !b.call(c, e[f], f, a))
                                    return !1;
                            return !0;
                        };
                        goog.array.every = module$contents$goog$array_every;
                        function module$contents$goog$array_count(a, b, c) {
                            var d = 0;
                            module$contents$goog$array_forEach(a, function (e, f, g) {
                                b.call(c, e, f, g) && ++d;
                            }, c);
                            return d;
                        }
                        goog.array.count = module$contents$goog$array_count;
                        function module$contents$goog$array_find(a, b, c) {
                            b = module$contents$goog$array_findIndex(a, b, c);
                            return 0 > b ? null : 'string' === typeof a ? a.charAt(b) : a[b];
                        }
                        goog.array.find = module$contents$goog$array_find;
                        function module$contents$goog$array_findIndex(a, b, c) {
                            for (var d = a.length, e = 'string' === typeof a ? a.split('') : a, f = 0; f < d; f++)
                                if (f in e && b.call(c, e[f], f, a))
                                    return f;
                            return -1;
                        }
                        goog.array.findIndex = module$contents$goog$array_findIndex;
                        function module$contents$goog$array_findRight(a, b, c) {
                            b = module$contents$goog$array_findIndexRight(a, b, c);
                            return 0 > b ? null : 'string' === typeof a ? a.charAt(b) : a[b];
                        }
                        goog.array.findRight = module$contents$goog$array_findRight;
                        function module$contents$goog$array_findIndexRight(a, b, c) {
                            var d = a.length, e = 'string' === typeof a ? a.split('') : a;
                            for (--d; 0 <= d; d--)
                                if (d in e && b.call(c, e[d], d, a))
                                    return d;
                            return -1;
                        }
                        goog.array.findIndexRight = module$contents$goog$array_findIndexRight;
                        function module$contents$goog$array_contains(a, b) {
                            return 0 <= module$contents$goog$array_indexOf(a, b);
                        }
                        goog.array.contains = module$contents$goog$array_contains;
                        function module$contents$goog$array_isEmpty(a) {
                            return 0 == a.length;
                        }
                        goog.array.isEmpty = module$contents$goog$array_isEmpty;
                        function module$contents$goog$array_clear(a) {
                            if (!Array.isArray(a))
                                for (var b = a.length - 1; 0 <= b; b--)
                                    delete a[b];
                            a.length = 0;
                        }
                        goog.array.clear = module$contents$goog$array_clear;
                        function module$contents$goog$array_insert(a, b) {
                            module$contents$goog$array_contains(a, b) || a.push(b);
                        }
                        goog.array.insert = module$contents$goog$array_insert;
                        function module$contents$goog$array_insertAt(a, b, c) {
                            module$contents$goog$array_splice(a, c, 0, b);
                        }
                        goog.array.insertAt = module$contents$goog$array_insertAt;
                        function module$contents$goog$array_insertArrayAt(a, b, c) {
                            goog.partial(module$contents$goog$array_splice, a, c, 0).apply(null, b);
                        }
                        goog.array.insertArrayAt = module$contents$goog$array_insertArrayAt;
                        function module$contents$goog$array_insertBefore(a, b, c) {
                            var d;
                            2 == arguments.length || 0 > (d = module$contents$goog$array_indexOf(a, c)) ? a.push(b) : module$contents$goog$array_insertAt(a, b, d);
                        }
                        goog.array.insertBefore = module$contents$goog$array_insertBefore;
                        function module$contents$goog$array_remove(a, b) {
                            b = module$contents$goog$array_indexOf(a, b);
                            var c;
                            (c = 0 <= b) && module$contents$goog$array_removeAt(a, b);
                            return c;
                        }
                        goog.array.remove = module$contents$goog$array_remove;
                        function module$contents$goog$array_removeLast(a, b) {
                            b = module$contents$goog$array_lastIndexOf(a, b);
                            return 0 <= b ? (module$contents$goog$array_removeAt(a, b), !0) : !1;
                        }
                        goog.array.removeLast = module$contents$goog$array_removeLast;
                        function module$contents$goog$array_removeAt(a, b) {
                            goog.asserts.assert(null != a.length);
                            return 1 == Array.prototype.splice.call(a, b, 1).length;
                        }
                        goog.array.removeAt = module$contents$goog$array_removeAt;
                        function module$contents$goog$array_removeIf(a, b, c) {
                            b = module$contents$goog$array_findIndex(a, b, c);
                            return 0 <= b ? (module$contents$goog$array_removeAt(a, b), !0) : !1;
                        }
                        goog.array.removeIf = module$contents$goog$array_removeIf;
                        function module$contents$goog$array_removeAllIf(a, b, c) {
                            var d = 0;
                            module$contents$goog$array_forEachRight(a, function (e, f) {
                                b.call(c, e, f, a) && module$contents$goog$array_removeAt(a, f) && d++;
                            });
                            return d;
                        }
                        goog.array.removeAllIf = module$contents$goog$array_removeAllIf;
                        function module$contents$goog$array_concat(a) {
                            return Array.prototype.concat.apply([], arguments);
                        }
                        goog.array.concat = module$contents$goog$array_concat;
                        function module$contents$goog$array_join(a) {
                            return Array.prototype.concat.apply([], arguments);
                        }
                        goog.array.join = module$contents$goog$array_join;
                        function module$contents$goog$array_toArray(a) {
                            var b = a.length;
                            if (0 < b) {
                                for (var c = Array(b), d = 0; d < b; d++)
                                    c[d] = a[d];
                                return c;
                            }
                            return [];
                        }
                        var module$contents$goog$array_clone = goog.array.toArray = module$contents$goog$array_toArray;
                        goog.array.clone = module$contents$goog$array_clone;
                        function module$contents$goog$array_extend(a, b) {
                            for (var c = 1; c < arguments.length; c++) {
                                var d = arguments[c];
                                if (goog.isArrayLike(d)) {
                                    var e = a.length || 0, f = d.length || 0;
                                    a.length = e + f;
                                    for (var g = 0; g < f; g++)
                                        a[e + g] = d[g];
                                } else
                                    a.push(d);
                            }
                        }
                        goog.array.extend = module$contents$goog$array_extend;
                        function module$contents$goog$array_splice(a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.splice.apply(a, module$contents$goog$array_slice(arguments, 1));
                        }
                        goog.array.splice = module$contents$goog$array_splice;
                        function module$contents$goog$array_slice(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
                        }
                        goog.array.slice = module$contents$goog$array_slice;
                        function module$contents$goog$array_removeDuplicates(a, b, c) {
                            b = b || a;
                            var d = function (k) {
                                return goog.isObject(k) ? 'o' + goog.getUid(k) : (typeof k).charAt(0) + k;
                            };
                            c = c || d;
                            d = {};
                            for (var e = 0, f = 0; f < a.length;) {
                                var g = a[f++], h = c(g);
                                Object.prototype.hasOwnProperty.call(d, h) || (d[h] = !0, b[e++] = g);
                            }
                            b.length = e;
                        }
                        goog.array.removeDuplicates = module$contents$goog$array_removeDuplicates;
                        function module$contents$goog$array_binarySearch(a, b, c) {
                            return module$contents$goog$array_binarySearch_(a, c || module$contents$goog$array_defaultCompare, !1, b);
                        }
                        goog.array.binarySearch = module$contents$goog$array_binarySearch;
                        function module$contents$goog$array_binarySelect(a, b, c) {
                            return module$contents$goog$array_binarySearch_(a, b, !0, void 0, c);
                        }
                        goog.array.binarySelect = module$contents$goog$array_binarySelect;
                        function module$contents$goog$array_binarySearch_(a, b, c, d, e) {
                            for (var f = 0, g = a.length, h; f < g;) {
                                var k = f + (g - f >>> 1);
                                var l = c ? b.call(e, a[k], k, a) : b(d, a[k]);
                                0 < l ? f = k + 1 : (g = k, h = !l);
                            }
                            return h ? f : -f - 1;
                        }
                        function module$contents$goog$array_sort(a, b) {
                            a.sort(b || module$contents$goog$array_defaultCompare);
                        }
                        goog.array.sort = module$contents$goog$array_sort;
                        function module$contents$goog$array_stableSort(a, b) {
                            for (var c = Array(a.length), d = 0; d < a.length; d++)
                                c[d] = {
                                    index: d,
                                    value: a[d]
                                };
                            var e = b || module$contents$goog$array_defaultCompare;
                            module$contents$goog$array_sort(c, function (f, g) {
                                return e(f.value, g.value) || f.index - g.index;
                            });
                            for (d = 0; d < a.length; d++)
                                a[d] = c[d].value;
                        }
                        goog.array.stableSort = module$contents$goog$array_stableSort;
                        function module$contents$goog$array_sortByKey(a, b, c) {
                            var d = c || module$contents$goog$array_defaultCompare;
                            module$contents$goog$array_sort(a, function (e, f) {
                                return d(b(e), b(f));
                            });
                        }
                        goog.array.sortByKey = module$contents$goog$array_sortByKey;
                        function module$contents$goog$array_sortObjectsByKey(a, b, c) {
                            module$contents$goog$array_sortByKey(a, function (d) {
                                return d[b];
                            }, c);
                        }
                        goog.array.sortObjectsByKey = module$contents$goog$array_sortObjectsByKey;
                        function module$contents$goog$array_isSorted(a, b, c) {
                            b = b || module$contents$goog$array_defaultCompare;
                            for (var d = 1; d < a.length; d++) {
                                var e = b(a[d - 1], a[d]);
                                if (0 < e || 0 == e && c)
                                    return !1;
                            }
                            return !0;
                        }
                        goog.array.isSorted = module$contents$goog$array_isSorted;
                        function module$contents$goog$array_equals(a, b, c) {
                            if (!goog.isArrayLike(a) || !goog.isArrayLike(b) || a.length != b.length)
                                return !1;
                            var d = a.length;
                            c = c || module$contents$goog$array_defaultCompareEquality;
                            for (var e = 0; e < d; e++)
                                if (!c(a[e], b[e]))
                                    return !1;
                            return !0;
                        }
                        goog.array.equals = module$contents$goog$array_equals;
                        function module$contents$goog$array_compare3(a, b, c) {
                            c = c || module$contents$goog$array_defaultCompare;
                            for (var d = Math.min(a.length, b.length), e = 0; e < d; e++) {
                                var f = c(a[e], b[e]);
                                if (0 != f)
                                    return f;
                            }
                            return module$contents$goog$array_defaultCompare(a.length, b.length);
                        }
                        goog.array.compare3 = module$contents$goog$array_compare3;
                        function module$contents$goog$array_defaultCompare(a, b) {
                            return a > b ? 1 : a < b ? -1 : 0;
                        }
                        goog.array.defaultCompare = module$contents$goog$array_defaultCompare;
                        function module$contents$goog$array_inverseDefaultCompare(a, b) {
                            return -module$contents$goog$array_defaultCompare(a, b);
                        }
                        goog.array.inverseDefaultCompare = module$contents$goog$array_inverseDefaultCompare;
                        function module$contents$goog$array_defaultCompareEquality(a, b) {
                            return a === b;
                        }
                        goog.array.defaultCompareEquality = module$contents$goog$array_defaultCompareEquality;
                        function module$contents$goog$array_binaryInsert(a, b, c) {
                            c = module$contents$goog$array_binarySearch(a, b, c);
                            return 0 > c ? (module$contents$goog$array_insertAt(a, b, -(c + 1)), !0) : !1;
                        }
                        goog.array.binaryInsert = module$contents$goog$array_binaryInsert;
                        function module$contents$goog$array_binaryRemove(a, b, c) {
                            b = module$contents$goog$array_binarySearch(a, b, c);
                            return 0 <= b ? module$contents$goog$array_removeAt(a, b) : !1;
                        }
                        goog.array.binaryRemove = module$contents$goog$array_binaryRemove;
                        function module$contents$goog$array_bucket(a, b, c) {
                            for (var d = {}, e = 0; e < a.length; e++) {
                                var f = a[e], g = b.call(c, f, e, a);
                                void 0 !== g && (d[g] || (d[g] = [])).push(f);
                            }
                            return d;
                        }
                        goog.array.bucket = module$contents$goog$array_bucket;
                        function module$contents$goog$array_toObject(a, b, c) {
                            var d = {};
                            module$contents$goog$array_forEach(a, function (e, f) {
                                d[b.call(c, e, f, a)] = e;
                            });
                            return d;
                        }
                        goog.array.toObject = module$contents$goog$array_toObject;
                        function module$contents$goog$array_range(a, b, c) {
                            var d = [], e = 0, f = a;
                            c = c || 1;
                            void 0 !== b && (e = a, f = b);
                            if (0 > c * (f - e))
                                return [];
                            if (0 < c)
                                for (a = e; a < f; a += c)
                                    d.push(a);
                            else
                                for (a = e; a > f; a += c)
                                    d.push(a);
                            return d;
                        }
                        goog.array.range = module$contents$goog$array_range;
                        function module$contents$goog$array_repeat(a, b) {
                            for (var c = [], d = 0; d < b; d++)
                                c[d] = a;
                            return c;
                        }
                        goog.array.repeat = module$contents$goog$array_repeat;
                        function module$contents$goog$array_flatten(a) {
                            for (var b = [], c = 0; c < arguments.length; c++) {
                                var d = arguments[c];
                                if (Array.isArray(d))
                                    for (var e = 0; e < d.length; e += 8192) {
                                        var f = module$contents$goog$array_slice(d, e, e + 8192);
                                        f = module$contents$goog$array_flatten.apply(null, f);
                                        for (var g = 0; g < f.length; g++)
                                            b.push(f[g]);
                                    }
                                else
                                    b.push(d);
                            }
                            return b;
                        }
                        goog.array.flatten = module$contents$goog$array_flatten;
                        function module$contents$goog$array_rotate(a, b) {
                            goog.asserts.assert(null != a.length);
                            a.length && (b %= a.length, 0 < b ? Array.prototype.unshift.apply(a, a.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a, a.splice(0, -b)));
                            return a;
                        }
                        goog.array.rotate = module$contents$goog$array_rotate;
                        function module$contents$goog$array_moveItem(a, b, c) {
                            goog.asserts.assert(0 <= b && b < a.length);
                            goog.asserts.assert(0 <= c && c < a.length);
                            b = Array.prototype.splice.call(a, b, 1);
                            Array.prototype.splice.call(a, c, 0, b[0]);
                        }
                        goog.array.moveItem = module$contents$goog$array_moveItem;
                        function module$contents$goog$array_zip(a) {
                            if (!arguments.length)
                                return [];
                            for (var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++)
                                arguments[d].length < c && (c = arguments[d].length);
                            for (d = 0; d < c; d++) {
                                for (var e = [], f = 0; f < arguments.length; f++)
                                    e.push(arguments[f][d]);
                                b.push(e);
                            }
                            return b;
                        }
                        goog.array.zip = module$contents$goog$array_zip;
                        function module$contents$goog$array_shuffle(a, b) {
                            b = b || Math.random;
                            for (var c = a.length - 1; 0 < c; c--) {
                                var d = Math.floor(b() * (c + 1)), e = a[c];
                                a[c] = a[d];
                                a[d] = e;
                            }
                        }
                        goog.array.shuffle = module$contents$goog$array_shuffle;
                        function module$contents$goog$array_copyByIndex(a, b) {
                            var c = [];
                            module$contents$goog$array_forEach(b, function (d) {
                                c.push(a[d]);
                            });
                            return c;
                        }
                        goog.array.copyByIndex = module$contents$goog$array_copyByIndex;
                        function module$contents$goog$array_concatMap(a, b, c) {
                            return module$contents$goog$array_concat.apply([], module$contents$goog$array_map(a, b, c));
                        }
                        goog.array.concatMap = module$contents$goog$array_concatMap;
                        goog.dom.asserts = {};
                        goog.dom.asserts.assertIsLocation = function (a) {
                            if (goog.asserts.ENABLE_ASSERTS) {
                                var b = goog.dom.asserts.getWindow_(a);
                                b && (!a || !(a instanceof b.Location) && a instanceof b.Element) && goog.asserts.fail('Argument is not a Location (or a non-Element mock); got: %s', goog.dom.asserts.debugStringForType_(a));
                            }
                            return a;
                        };
                        goog.dom.asserts.assertIsElementType_ = function (a, b) {
                            if (goog.asserts.ENABLE_ASSERTS) {
                                var c = goog.dom.asserts.getWindow_(a);
                                c && 'undefined' != typeof c[b] && (a && (a instanceof c[b] || !(a instanceof c.Location || a instanceof c.Element)) || goog.asserts.fail('Argument is not a %s (or a non-Element, non-Location mock); got: %s', b, goog.dom.asserts.debugStringForType_(a)));
                            }
                            return a;
                        };
                        goog.dom.asserts.assertIsHTMLAnchorElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLAnchorElement');
                        };
                        goog.dom.asserts.assertIsHTMLButtonElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLButtonElement');
                        };
                        goog.dom.asserts.assertIsHTMLLinkElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLLinkElement');
                        };
                        goog.dom.asserts.assertIsHTMLImageElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLImageElement');
                        };
                        goog.dom.asserts.assertIsHTMLAudioElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLAudioElement');
                        };
                        goog.dom.asserts.assertIsHTMLVideoElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLVideoElement');
                        };
                        goog.dom.asserts.assertIsHTMLInputElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLInputElement');
                        };
                        goog.dom.asserts.assertIsHTMLTextAreaElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLTextAreaElement');
                        };
                        goog.dom.asserts.assertIsHTMLCanvasElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLCanvasElement');
                        };
                        goog.dom.asserts.assertIsHTMLEmbedElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLEmbedElement');
                        };
                        goog.dom.asserts.assertIsHTMLFormElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLFormElement');
                        };
                        goog.dom.asserts.assertIsHTMLFrameElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLFrameElement');
                        };
                        goog.dom.asserts.assertIsHTMLIFrameElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLIFrameElement');
                        };
                        goog.dom.asserts.assertIsHTMLObjectElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLObjectElement');
                        };
                        goog.dom.asserts.assertIsHTMLScriptElement = function (a) {
                            return goog.dom.asserts.assertIsElementType_(a, 'HTMLScriptElement');
                        };
                        goog.dom.asserts.debugStringForType_ = function (a) {
                            if (goog.isObject(a))
                                try {
                                    return a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
                                } catch (b) {
                                    return '<object could not be stringified>';
                                }
                            else
                                return void 0 === a ? 'undefined' : null === a ? 'null' : typeof a;
                        };
                        goog.dom.asserts.getWindow_ = function (a) {
                            try {
                                var b = a && a.ownerDocument, c = b && (b.defaultView || b.parentWindow);
                                c = c || goog.global;
                                if (c.Element && c.Location)
                                    return c;
                            } catch (d) {
                            }
                            return null;
                        };
                        goog.dom.HtmlElement = function () {
                        };
                        goog.functions = {};
                        goog.functions.constant = function (a) {
                            return function () {
                                return a;
                            };
                        };
                        goog.functions.FALSE = function () {
                            return !1;
                        };
                        goog.functions.TRUE = function () {
                            return !0;
                        };
                        goog.functions.NULL = function () {
                            return null;
                        };
                        goog.functions.identity = function (a, b) {
                            return a;
                        };
                        goog.functions.error = function (a) {
                            return function () {
                                throw Error(a);
                            };
                        };
                        goog.functions.fail = function (a) {
                            return function () {
                                throw a;
                            };
                        };
                        goog.functions.lock = function (a, b) {
                            b = b || 0;
                            return function () {
                                return a.apply(this, Array.prototype.slice.call(arguments, 0, b));
                            };
                        };
                        goog.functions.nth = function (a) {
                            return function () {
                                return arguments[a];
                            };
                        };
                        goog.functions.partialRight = function (a, b) {
                            var c = Array.prototype.slice.call(arguments, 1);
                            return function () {
                                var d = this;
                                d === goog.global && (d = void 0);
                                var e = Array.prototype.slice.call(arguments);
                                e.push.apply(e, c);
                                return a.apply(d, e);
                            };
                        };
                        goog.functions.withReturnValue = function (a, b) {
                            return goog.functions.sequence(a, goog.functions.constant(b));
                        };
                        goog.functions.equalTo = function (a, b) {
                            return function (c) {
                                return b ? a == c : a === c;
                            };
                        };
                        goog.functions.compose = function (a, b) {
                            var c = arguments, d = c.length;
                            return function () {
                                var e;
                                d && (e = c[d - 1].apply(this, arguments));
                                for (var f = d - 2; 0 <= f; f--)
                                    e = c[f].call(this, e);
                                return e;
                            };
                        };
                        goog.functions.sequence = function (a) {
                            var b = arguments, c = b.length;
                            return function () {
                                for (var d, e = 0; e < c; e++)
                                    d = b[e].apply(this, arguments);
                                return d;
                            };
                        };
                        goog.functions.and = function (a) {
                            var b = arguments, c = b.length;
                            return function () {
                                for (var d = 0; d < c; d++)
                                    if (!b[d].apply(this, arguments))
                                        return !1;
                                return !0;
                            };
                        };
                        goog.functions.or = function (a) {
                            var b = arguments, c = b.length;
                            return function () {
                                for (var d = 0; d < c; d++)
                                    if (b[d].apply(this, arguments))
                                        return !0;
                                return !1;
                            };
                        };
                        goog.functions.not = function (a) {
                            return function () {
                                return !a.apply(this, arguments);
                            };
                        };
                        goog.functions.create = function (a, b) {
                            var c = function () {
                            };
                            c.prototype = a.prototype;
                            c = new c();
                            a.apply(c, Array.prototype.slice.call(arguments, 1));
                            return c;
                        };
                        goog.functions.CACHE_RETURN_VALUE = !0;
                        goog.functions.cacheReturnValue = function (a) {
                            var b = !1, c;
                            return function () {
                                if (!goog.functions.CACHE_RETURN_VALUE)
                                    return a();
                                b || (c = a(), b = !0);
                                return c;
                            };
                        };
                        goog.functions.once = function (a) {
                            var b = a;
                            return function () {
                                if (b) {
                                    var c = b;
                                    b = null;
                                    c();
                                }
                            };
                        };
                        goog.functions.debounce = function (a, b, c) {
                            var d = 0;
                            return function (e) {
                                goog.global.clearTimeout(d);
                                var f = arguments;
                                d = goog.global.setTimeout(function () {
                                    a.apply(c, f);
                                }, b);
                            };
                        };
                        goog.functions.throttle = function (a, b, c) {
                            var d = 0, e = !1, f = [], g = function () {
                                    d = 0;
                                    e && (e = !1, h());
                                }, h = function () {
                                    d = goog.global.setTimeout(g, b);
                                    a.apply(c, f);
                                };
                            return function (k) {
                                f = arguments;
                                d ? e = !0 : h();
                            };
                        };
                        goog.functions.rateLimit = function (a, b, c) {
                            var d = 0, e = function () {
                                    d = 0;
                                };
                            return function (f) {
                                d || (d = goog.global.setTimeout(e, b), a.apply(c, arguments));
                            };
                        };
                        goog.functions.isFunction = function (a) {
                            return 'function' === typeof a;
                        };
                        goog.dom.TagName = function () {
                        };
                        goog.dom.TagName.cast = function (a, b) {
                            return a;
                        };
                        goog.dom.TagName.prototype.toString = function () {
                        };
                        goog.dom.TagName.A = 'A';
                        goog.dom.TagName.ABBR = 'ABBR';
                        goog.dom.TagName.ACRONYM = 'ACRONYM';
                        goog.dom.TagName.ADDRESS = 'ADDRESS';
                        goog.dom.TagName.APPLET = 'APPLET';
                        goog.dom.TagName.AREA = 'AREA';
                        goog.dom.TagName.ARTICLE = 'ARTICLE';
                        goog.dom.TagName.ASIDE = 'ASIDE';
                        goog.dom.TagName.AUDIO = 'AUDIO';
                        goog.dom.TagName.B = 'B';
                        goog.dom.TagName.BASE = 'BASE';
                        goog.dom.TagName.BASEFONT = 'BASEFONT';
                        goog.dom.TagName.BDI = 'BDI';
                        goog.dom.TagName.BDO = 'BDO';
                        goog.dom.TagName.BIG = 'BIG';
                        goog.dom.TagName.BLOCKQUOTE = 'BLOCKQUOTE';
                        goog.dom.TagName.BODY = 'BODY';
                        goog.dom.TagName.BR = 'BR';
                        goog.dom.TagName.BUTTON = 'BUTTON';
                        goog.dom.TagName.CANVAS = 'CANVAS';
                        goog.dom.TagName.CAPTION = 'CAPTION';
                        goog.dom.TagName.CENTER = 'CENTER';
                        goog.dom.TagName.CITE = 'CITE';
                        goog.dom.TagName.CODE = 'CODE';
                        goog.dom.TagName.COL = 'COL';
                        goog.dom.TagName.COLGROUP = 'COLGROUP';
                        goog.dom.TagName.COMMAND = 'COMMAND';
                        goog.dom.TagName.DATA = 'DATA';
                        goog.dom.TagName.DATALIST = 'DATALIST';
                        goog.dom.TagName.DD = 'DD';
                        goog.dom.TagName.DEL = 'DEL';
                        goog.dom.TagName.DETAILS = 'DETAILS';
                        goog.dom.TagName.DFN = 'DFN';
                        goog.dom.TagName.DIALOG = 'DIALOG';
                        goog.dom.TagName.DIR = 'DIR';
                        goog.dom.TagName.DIV = 'DIV';
                        goog.dom.TagName.DL = 'DL';
                        goog.dom.TagName.DT = 'DT';
                        goog.dom.TagName.EM = 'EM';
                        goog.dom.TagName.EMBED = 'EMBED';
                        goog.dom.TagName.FIELDSET = 'FIELDSET';
                        goog.dom.TagName.FIGCAPTION = 'FIGCAPTION';
                        goog.dom.TagName.FIGURE = 'FIGURE';
                        goog.dom.TagName.FONT = 'FONT';
                        goog.dom.TagName.FOOTER = 'FOOTER';
                        goog.dom.TagName.FORM = 'FORM';
                        goog.dom.TagName.FRAME = 'FRAME';
                        goog.dom.TagName.FRAMESET = 'FRAMESET';
                        goog.dom.TagName.H1 = 'H1';
                        goog.dom.TagName.H2 = 'H2';
                        goog.dom.TagName.H3 = 'H3';
                        goog.dom.TagName.H4 = 'H4';
                        goog.dom.TagName.H5 = 'H5';
                        goog.dom.TagName.H6 = 'H6';
                        goog.dom.TagName.HEAD = 'HEAD';
                        goog.dom.TagName.HEADER = 'HEADER';
                        goog.dom.TagName.HGROUP = 'HGROUP';
                        goog.dom.TagName.HR = 'HR';
                        goog.dom.TagName.HTML = 'HTML';
                        goog.dom.TagName.I = 'I';
                        goog.dom.TagName.IFRAME = 'IFRAME';
                        goog.dom.TagName.IMG = 'IMG';
                        goog.dom.TagName.INPUT = 'INPUT';
                        goog.dom.TagName.INS = 'INS';
                        goog.dom.TagName.ISINDEX = 'ISINDEX';
                        goog.dom.TagName.KBD = 'KBD';
                        goog.dom.TagName.KEYGEN = 'KEYGEN';
                        goog.dom.TagName.LABEL = 'LABEL';
                        goog.dom.TagName.LEGEND = 'LEGEND';
                        goog.dom.TagName.LI = 'LI';
                        goog.dom.TagName.LINK = 'LINK';
                        goog.dom.TagName.MAIN = 'MAIN';
                        goog.dom.TagName.MAP = 'MAP';
                        goog.dom.TagName.MARK = 'MARK';
                        goog.dom.TagName.MATH = 'MATH';
                        goog.dom.TagName.MENU = 'MENU';
                        goog.dom.TagName.MENUITEM = 'MENUITEM';
                        goog.dom.TagName.META = 'META';
                        goog.dom.TagName.METER = 'METER';
                        goog.dom.TagName.NAV = 'NAV';
                        goog.dom.TagName.NOFRAMES = 'NOFRAMES';
                        goog.dom.TagName.NOSCRIPT = 'NOSCRIPT';
                        goog.dom.TagName.OBJECT = 'OBJECT';
                        goog.dom.TagName.OL = 'OL';
                        goog.dom.TagName.OPTGROUP = 'OPTGROUP';
                        goog.dom.TagName.OPTION = 'OPTION';
                        goog.dom.TagName.OUTPUT = 'OUTPUT';
                        goog.dom.TagName.P = 'P';
                        goog.dom.TagName.PARAM = 'PARAM';
                        goog.dom.TagName.PICTURE = 'PICTURE';
                        goog.dom.TagName.PRE = 'PRE';
                        goog.dom.TagName.PROGRESS = 'PROGRESS';
                        goog.dom.TagName.Q = 'Q';
                        goog.dom.TagName.RP = 'RP';
                        goog.dom.TagName.RT = 'RT';
                        goog.dom.TagName.RTC = 'RTC';
                        goog.dom.TagName.RUBY = 'RUBY';
                        goog.dom.TagName.S = 'S';
                        goog.dom.TagName.SAMP = 'SAMP';
                        goog.dom.TagName.SCRIPT = 'SCRIPT';
                        goog.dom.TagName.SECTION = 'SECTION';
                        goog.dom.TagName.SELECT = 'SELECT';
                        goog.dom.TagName.SMALL = 'SMALL';
                        goog.dom.TagName.SOURCE = 'SOURCE';
                        goog.dom.TagName.SPAN = 'SPAN';
                        goog.dom.TagName.STRIKE = 'STRIKE';
                        goog.dom.TagName.STRONG = 'STRONG';
                        goog.dom.TagName.STYLE = 'STYLE';
                        goog.dom.TagName.SUB = 'SUB';
                        goog.dom.TagName.SUMMARY = 'SUMMARY';
                        goog.dom.TagName.SUP = 'SUP';
                        goog.dom.TagName.SVG = 'SVG';
                        goog.dom.TagName.TABLE = 'TABLE';
                        goog.dom.TagName.TBODY = 'TBODY';
                        goog.dom.TagName.TD = 'TD';
                        goog.dom.TagName.TEMPLATE = 'TEMPLATE';
                        goog.dom.TagName.TEXTAREA = 'TEXTAREA';
                        goog.dom.TagName.TFOOT = 'TFOOT';
                        goog.dom.TagName.TH = 'TH';
                        goog.dom.TagName.THEAD = 'THEAD';
                        goog.dom.TagName.TIME = 'TIME';
                        goog.dom.TagName.TITLE = 'TITLE';
                        goog.dom.TagName.TR = 'TR';
                        goog.dom.TagName.TRACK = 'TRACK';
                        goog.dom.TagName.TT = 'TT';
                        goog.dom.TagName.U = 'U';
                        goog.dom.TagName.UL = 'UL';
                        goog.dom.TagName.VAR = 'VAR';
                        goog.dom.TagName.VIDEO = 'VIDEO';
                        goog.dom.TagName.WBR = 'WBR';
                        goog.object = {};
                        goog.object.forEach = function (a, b, c) {
                            for (var d in a)
                                b.call(c, a[d], d, a);
                        };
                        goog.object.filter = function (a, b, c) {
                            var d = {}, e;
                            for (e in a)
                                b.call(c, a[e], e, a) && (d[e] = a[e]);
                            return d;
                        };
                        goog.object.map = function (a, b, c) {
                            var d = {}, e;
                            for (e in a)
                                d[e] = b.call(c, a[e], e, a);
                            return d;
                        };
                        goog.object.some = function (a, b, c) {
                            for (var d in a)
                                if (b.call(c, a[d], d, a))
                                    return !0;
                            return !1;
                        };
                        goog.object.every = function (a, b, c) {
                            for (var d in a)
                                if (!b.call(c, a[d], d, a))
                                    return !1;
                            return !0;
                        };
                        goog.object.getCount = function (a) {
                            var b = 0, c;
                            for (c in a)
                                b++;
                            return b;
                        };
                        goog.object.getAnyKey = function (a) {
                            for (var b in a)
                                return b;
                        };
                        goog.object.getAnyValue = function (a) {
                            for (var b in a)
                                return a[b];
                        };
                        goog.object.contains = function (a, b) {
                            return goog.object.containsValue(a, b);
                        };
                        goog.object.getValues = function (a) {
                            var b = [], c = 0, d;
                            for (d in a)
                                b[c++] = a[d];
                            return b;
                        };
                        goog.object.getKeys = function (a) {
                            var b = [], c = 0, d;
                            for (d in a)
                                b[c++] = d;
                            return b;
                        };
                        goog.object.getValueByKeys = function (a, b) {
                            var c = goog.isArrayLike(b), d = c ? b : arguments;
                            for (c = c ? 0 : 1; c < d.length; c++) {
                                if (null == a)
                                    return;
                                a = a[d[c]];
                            }
                            return a;
                        };
                        goog.object.containsKey = function (a, b) {
                            return null !== a && b in a;
                        };
                        goog.object.containsValue = function (a, b) {
                            for (var c in a)
                                if (a[c] == b)
                                    return !0;
                            return !1;
                        };
                        goog.object.findKey = function (a, b, c) {
                            for (var d in a)
                                if (b.call(c, a[d], d, a))
                                    return d;
                        };
                        goog.object.findValue = function (a, b, c) {
                            return (b = goog.object.findKey(a, b, c)) && a[b];
                        };
                        goog.object.isEmpty = function (a) {
                            for (var b in a)
                                return !1;
                            return !0;
                        };
                        goog.object.clear = function (a) {
                            for (var b in a)
                                delete a[b];
                        };
                        goog.object.remove = function (a, b) {
                            var c;
                            (c = b in a) && delete a[b];
                            return c;
                        };
                        goog.object.add = function (a, b, c) {
                            if (null !== a && b in a)
                                throw Error('The object already contains the key "' + b + '"');
                            goog.object.set(a, b, c);
                        };
                        goog.object.get = function (a, b, c) {
                            return null !== a && b in a ? a[b] : c;
                        };
                        goog.object.set = function (a, b, c) {
                            a[b] = c;
                        };
                        goog.object.setIfUndefined = function (a, b, c) {
                            return b in a ? a[b] : a[b] = c;
                        };
                        goog.object.setWithReturnValueIfNotSet = function (a, b, c) {
                            if (b in a)
                                return a[b];
                            c = c();
                            return a[b] = c;
                        };
                        goog.object.equals = function (a, b) {
                            for (var c in a)
                                if (!(c in b) || a[c] !== b[c])
                                    return !1;
                            for (var d in b)
                                if (!(d in a))
                                    return !1;
                            return !0;
                        };
                        goog.object.clone = function (a) {
                            var b = {}, c;
                            for (c in a)
                                b[c] = a[c];
                            return b;
                        };
                        goog.object.unsafeClone = function (a) {
                            if (!a || 'object' !== typeof a)
                                return a;
                            if ('function' === typeof a.clone)
                                return a.clone();
                            var b = Array.isArray(a) ? [] : 'function' !== typeof ArrayBuffer || 'function' !== typeof ArrayBuffer.isView || !ArrayBuffer.isView(a) || a instanceof DataView ? {} : new a.constructor(a.length), c;
                            for (c in a)
                                b[c] = goog.object.unsafeClone(a[c]);
                            return b;
                        };
                        goog.object.transpose = function (a) {
                            var b = {}, c;
                            for (c in a)
                                b[a[c]] = c;
                            return b;
                        };
                        goog.object.PROTOTYPE_FIELDS_ = 'constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf'.split(' ');
                        goog.object.extend = function (a, b) {
                            for (var c, d, e = 1; e < arguments.length; e++) {
                                d = arguments[e];
                                for (c in d)
                                    a[c] = d[c];
                                for (var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++)
                                    c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
                            }
                        };
                        goog.object.create = function (a) {
                            var b = arguments.length;
                            if (1 == b && Array.isArray(arguments[0]))
                                return goog.object.create.apply(null, arguments[0]);
                            if (b % 2)
                                throw Error('Uneven number of arguments');
                            for (var c = {}, d = 0; d < b; d += 2)
                                c[arguments[d]] = arguments[d + 1];
                            return c;
                        };
                        goog.object.createSet = function (a) {
                            var b = arguments.length;
                            if (1 == b && Array.isArray(arguments[0]))
                                return goog.object.createSet.apply(null, arguments[0]);
                            for (var c = {}, d = 0; d < b; d++)
                                c[arguments[d]] = !0;
                            return c;
                        };
                        goog.object.createImmutableView = function (a) {
                            var b = a;
                            Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
                            return b;
                        };
                        goog.object.isImmutableView = function (a) {
                            return !!Object.isFrozen && Object.isFrozen(a);
                        };
                        goog.object.getAllPropertyNames = function (a, b, c) {
                            if (!a)
                                return [];
                            if (!Object.getOwnPropertyNames || !Object.getPrototypeOf)
                                return goog.object.getKeys(a);
                            for (var d = {}; a && (a !== Object.prototype || b) && (a !== Function.prototype || c);) {
                                for (var e = Object.getOwnPropertyNames(a), f = 0; f < e.length; f++)
                                    d[e[f]] = !0;
                                a = Object.getPrototypeOf(a);
                            }
                            return goog.object.getKeys(d);
                        };
                        goog.object.getSuperClass = function (a) {
                            return (a = Object.getPrototypeOf(a.prototype)) && a.constructor;
                        };
                        goog.dom.tags = {};
                        goog.dom.tags.VOID_TAGS_ = {
                            area: !0,
                            base: !0,
                            br: !0,
                            col: !0,
                            command: !0,
                            embed: !0,
                            hr: !0,
                            img: !0,
                            input: !0,
                            keygen: !0,
                            link: !0,
                            meta: !0,
                            param: !0,
                            source: !0,
                            track: !0,
                            wbr: !0
                        };
                        goog.dom.tags.isVoidTag = function (a) {
                            return !0 === goog.dom.tags.VOID_TAGS_[a];
                        };
                        goog.string = {};
                        goog.string.TypedString = function () {
                        };
                        goog.string.Const = function (a, b) {
                            this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = a === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && b || '';
                            this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
                        };
                        goog.string.Const.prototype.implementsGoogStringTypedString = !0;
                        goog.string.Const.prototype.getTypedStringValue = function () {
                            return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
                        };
                        goog.DEBUG && (goog.string.Const.prototype.toString = function () {
                            return 'Const{' + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + '}';
                        });
                        goog.string.Const.unwrap = function (a) {
                            if (a instanceof goog.string.Const && a.constructor === goog.string.Const && a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_)
                                return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
                            goog.asserts.fail('expected object of type Const, got \'' + a + '\'');
                            return 'type_error:Const';
                        };
                        goog.string.Const.from = function (a) {
                            return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, a);
                        };
                        goog.string.Const.TYPE_MARKER_ = {};
                        goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.string.Const.EMPTY = goog.string.Const.from('');
                        goog.html = {};
                        goog.html.trustedtypes = {};
                        goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse = function () {
                            if (!goog.TRUSTED_TYPES_POLICY_NAME)
                                return null;
                            void 0 === goog.html.trustedtypes.cachedPolicy_ && (goog.html.trustedtypes.cachedPolicy_ = goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + '#html'));
                            return goog.html.trustedtypes.cachedPolicy_;
                        };
                        var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeScript_SafeScript = function (a, b) {
                                this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = b === module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE ? a : '';
                                this.implementsGoogStringTypedString = !0;
                            };
                        module$contents$goog$html$SafeScript_SafeScript.fromConstant = function (a) {
                            a = goog.string.Const.unwrap(a);
                            return 0 === a.length ? module$contents$goog$html$SafeScript_SafeScript.EMPTY : module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs = function (a, b) {
                            for (var c = [], d = 1; d < arguments.length; d++)
                                c.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[d]));
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse('(' + goog.string.Const.unwrap(a) + ')(' + c.join(', ') + ');');
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromJson = function (a) {
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(a));
                        };
                        module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue = function () {
                            return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
                        };
                        module$contents$goog$html$SafeScript_SafeScript.unwrap = function (a) {
                            return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(a).toString();
                        };
                        module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript = function (a) {
                            if (a instanceof module$contents$goog$html$SafeScript_SafeScript && a.constructor === module$contents$goog$html$SafeScript_SafeScript)
                                return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;
                            (0, goog.asserts.fail)('expected object of type SafeScript, got \'' + a + '\' of type ' + goog.typeOf(a));
                            return 'type_error:SafeScript';
                        };
                        module$contents$goog$html$SafeScript_SafeScript.stringify_ = function (a) {
                            return JSON.stringify(a).replace(/</g, '\\x3c');
                        };
                        module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function (a) {
                            var b = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = b ? b.createScript(a) : a;
                            return new module$contents$goog$html$SafeScript_SafeScript(a, module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE);
                        };
                        goog.DEBUG && (module$contents$goog$html$SafeScript_SafeScript.prototype.toString = function () {
                            return 'SafeScript{' + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + '}';
                        });
                        module$contents$goog$html$SafeScript_SafeScript.EMPTY = function () {
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse('');
                        }();
                        goog.html.SafeScript = module$contents$goog$html$SafeScript_SafeScript;
                        goog.fs = {};
                        goog.fs.url = {};
                        goog.fs.url.createObjectUrl = function (a) {
                            return goog.fs.url.getUrlObject_().createObjectURL(a);
                        };
                        goog.fs.url.revokeObjectUrl = function (a) {
                            goog.fs.url.getUrlObject_().revokeObjectURL(a);
                        };
                        goog.fs.url.UrlObject_ = function () {
                        };
                        goog.fs.url.UrlObject_.prototype.createObjectURL = function (a) {
                        };
                        goog.fs.url.UrlObject_.prototype.revokeObjectURL = function (a) {
                        };
                        goog.fs.url.getUrlObject_ = function () {
                            var a = goog.fs.url.findUrlObject_();
                            if (null != a)
                                return a;
                            throw Error('This browser doesn\'t seem to support blob URLs');
                        };
                        goog.fs.url.findUrlObject_ = function () {
                            return void 0 !== goog.global.URL && void 0 !== goog.global.URL.createObjectURL ? goog.global.URL : void 0 !== goog.global.webkitURL && void 0 !== goog.global.webkitURL.createObjectURL ? goog.global.webkitURL : void 0 !== goog.global.createObjectURL ? goog.global : null;
                        };
                        goog.fs.url.browserSupportsObjectUrls = function () {
                            return null != goog.fs.url.findUrlObject_();
                        };
                        goog.fs.blob = {};
                        goog.fs.blob.getBlob = function (a) {
                            var b = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
                            if (void 0 !== b) {
                                b = new b();
                                for (var c = 0; c < arguments.length; c++)
                                    b.append(arguments[c]);
                                return b.getBlob();
                            }
                            return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments));
                        };
                        goog.fs.blob.getBlobWithProperties = function (a, b, c) {
                            var d = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
                            if (void 0 !== d) {
                                d = new d();
                                for (var e = 0; e < a.length; e++)
                                    d.append(a[e], c);
                                return d.getBlob(b);
                            }
                            if (void 0 !== goog.global.Blob)
                                return d = {}, b && (d.type = b), c && (d.endings = c), new Blob(a, d);
                            throw Error('This browser doesn\'t seem to support creating Blobs');
                        };
                        goog.i18n = {};
                        goog.i18n.bidi = {};
                        goog.i18n.bidi.FORCE_RTL = !1;
                        goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ('ar' == goog.LOCALE.substring(0, 2).toLowerCase() || 'fa' == goog.LOCALE.substring(0, 2).toLowerCase() || 'he' == goog.LOCALE.substring(0, 2).toLowerCase() || 'iw' == goog.LOCALE.substring(0, 2).toLowerCase() || 'ps' == goog.LOCALE.substring(0, 2).toLowerCase() || 'sd' == goog.LOCALE.substring(0, 2).toLowerCase() || 'ug' == goog.LOCALE.substring(0, 2).toLowerCase() || 'ur' == goog.LOCALE.substring(0, 2).toLowerCase() || 'yi' == goog.LOCALE.substring(0, 2).toLowerCase()) && (2 == goog.LOCALE.length || '-' == goog.LOCALE.substring(2, 3) || '_' == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && 'ckb' == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || '-' == goog.LOCALE.substring(3, 4) || '_' == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ('-' == goog.LOCALE.substring(2, 3) || '_' == goog.LOCALE.substring(2, 3)) && ('adlm' == goog.LOCALE.substring(3, 7).toLowerCase() || 'arab' == goog.LOCALE.substring(3, 7).toLowerCase() || 'hebr' == goog.LOCALE.substring(3, 7).toLowerCase() || 'nkoo' == goog.LOCALE.substring(3, 7).toLowerCase() || 'rohg' == goog.LOCALE.substring(3, 7).toLowerCase() || 'thaa' == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ('-' == goog.LOCALE.substring(3, 4) || '_' == goog.LOCALE.substring(3, 4)) && ('adlm' == goog.LOCALE.substring(4, 8).toLowerCase() || 'arab' == goog.LOCALE.substring(4, 8).toLowerCase() || 'hebr' == goog.LOCALE.substring(4, 8).toLowerCase() || 'nkoo' == goog.LOCALE.substring(4, 8).toLowerCase() || 'rohg' == goog.LOCALE.substring(4, 8).toLowerCase() || 'thaa' == goog.LOCALE.substring(4, 8).toLowerCase());
                        goog.i18n.bidi.Format = {
                            LRE: '\u202A',
                            RLE: '\u202B',
                            PDF: '\u202C',
                            LRM: '\u200E',
                            RLM: '\u200F'
                        };
                        goog.i18n.bidi.Dir = {
                            LTR: 1,
                            RTL: -1,
                            NEUTRAL: 0
                        };
                        goog.i18n.bidi.RIGHT = 'right';
                        goog.i18n.bidi.LEFT = 'left';
                        goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT;
                        goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT;
                        goog.i18n.bidi.toDir = function (a, b) {
                            return 'number' == typeof a ? 0 < a ? goog.i18n.bidi.Dir.LTR : 0 > a ? goog.i18n.bidi.Dir.RTL : b ? null : goog.i18n.bidi.Dir.NEUTRAL : null == a ? null : a ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
                        };
                        goog.i18n.bidi.ltrChars_ = 'A-Za-zÀ-ÖØ-öø-ʸ̀-\u0590ऀ-\u1FFF\u200EⰀ-\uD801\uD804-\uD839\uD83C-\uDBFF豈-\uFB1C︀-\uFE6F\uFEFD-\uFFFF';
                        goog.i18n.bidi.rtlChars_ = '֑-ۯۺ-ࣿ\u200F\uD802-\uD803\uD83A-\uD83Bיִ-\uFDFFﹰ-ﻼ';
                        goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g;
                        goog.i18n.bidi.stripHtmlIfNeeded_ = function (a, b) {
                            return b ? a.replace(goog.i18n.bidi.htmlSkipReg_, '') : a;
                        };
                        goog.i18n.bidi.rtlCharReg_ = new RegExp('[' + goog.i18n.bidi.rtlChars_ + ']');
                        goog.i18n.bidi.ltrCharReg_ = new RegExp('[' + goog.i18n.bidi.ltrChars_ + ']');
                        goog.i18n.bidi.hasAnyRtl = function (a, b) {
                            return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl;
                        goog.i18n.bidi.hasAnyLtr = function (a, b) {
                            return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.ltrRe_ = new RegExp('^[' + goog.i18n.bidi.ltrChars_ + ']');
                        goog.i18n.bidi.rtlRe_ = new RegExp('^[' + goog.i18n.bidi.rtlChars_ + ']');
                        goog.i18n.bidi.isRtlChar = function (a) {
                            return goog.i18n.bidi.rtlRe_.test(a);
                        };
                        goog.i18n.bidi.isLtrChar = function (a) {
                            return goog.i18n.bidi.ltrRe_.test(a);
                        };
                        goog.i18n.bidi.isNeutralChar = function (a) {
                            return !goog.i18n.bidi.isLtrChar(a) && !goog.i18n.bidi.isRtlChar(a);
                        };
                        goog.i18n.bidi.ltrDirCheckRe_ = new RegExp('^[^' + goog.i18n.bidi.rtlChars_ + ']*[' + goog.i18n.bidi.ltrChars_ + ']');
                        goog.i18n.bidi.rtlDirCheckRe_ = new RegExp('^[^' + goog.i18n.bidi.ltrChars_ + ']*[' + goog.i18n.bidi.rtlChars_ + ']');
                        goog.i18n.bidi.startsWithRtl = function (a, b) {
                            return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl;
                        goog.i18n.bidi.startsWithLtr = function (a, b) {
                            return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr;
                        goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/;
                        goog.i18n.bidi.isNeutralText = function (a, b) {
                            a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b);
                            return goog.i18n.bidi.isRequiredLtrRe_.test(a) || !goog.i18n.bidi.hasAnyLtr(a) && !goog.i18n.bidi.hasAnyRtl(a);
                        };
                        goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp('[' + goog.i18n.bidi.ltrChars_ + '][^' + goog.i18n.bidi.rtlChars_ + ']*$');
                        goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp('[' + goog.i18n.bidi.rtlChars_ + '][^' + goog.i18n.bidi.ltrChars_ + ']*$');
                        goog.i18n.bidi.endsWithLtr = function (a, b) {
                            return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr;
                        goog.i18n.bidi.endsWithRtl = function (a, b) {
                            return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl;
                        goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;
                        goog.i18n.bidi.isRtlLanguage = function (a) {
                            return goog.i18n.bidi.rtlLocalesRe_.test(a);
                        };
                        goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
                        goog.i18n.bidi.guardBracketInText = function (a, b) {
                            b = (void 0 === b ? goog.i18n.bidi.hasAnyRtl(a) : b) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM;
                            return a.replace(goog.i18n.bidi.bracketGuardTextRe_, b + '$&' + b);
                        };
                        goog.i18n.bidi.enforceRtlInHtml = function (a) {
                            return '<' == a.charAt(0) ? a.replace(/<\w+/, '$& dir=rtl') : '\n<span dir=rtl>' + a + '</span>';
                        };
                        goog.i18n.bidi.enforceRtlInText = function (a) {
                            return goog.i18n.bidi.Format.RLE + a + goog.i18n.bidi.Format.PDF;
                        };
                        goog.i18n.bidi.enforceLtrInHtml = function (a) {
                            return '<' == a.charAt(0) ? a.replace(/<\w+/, '$& dir=ltr') : '\n<span dir=ltr>' + a + '</span>';
                        };
                        goog.i18n.bidi.enforceLtrInText = function (a) {
                            return goog.i18n.bidi.Format.LRE + a + goog.i18n.bidi.Format.PDF;
                        };
                        goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;
                        goog.i18n.bidi.leftRe_ = /left/gi;
                        goog.i18n.bidi.rightRe_ = /right/gi;
                        goog.i18n.bidi.tempRe_ = /%%%%/g;
                        goog.i18n.bidi.mirrorCSS = function (a) {
                            return a.replace(goog.i18n.bidi.dimensionsRe_, ':$1 $4 $3 $2').replace(goog.i18n.bidi.leftRe_, '%%%%').replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
                        };
                        goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g;
                        goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g;
                        goog.i18n.bidi.normalizeHebrewQuote = function (a) {
                            return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, '$1\u05F4').replace(goog.i18n.bidi.singleQuoteSubstituteRe_, '$1\u05F3');
                        };
                        goog.i18n.bidi.wordSeparatorRe_ = /\s+/;
                        goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/;
                        goog.i18n.bidi.rtlDetectionThreshold_ = 0.4;
                        goog.i18n.bidi.estimateDirection = function (a, b) {
                            var c = 0, d = 0, e = !1;
                            a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b).split(goog.i18n.bidi.wordSeparatorRe_);
                            for (b = 0; b < a.length; b++) {
                                var f = a[b];
                                goog.i18n.bidi.startsWithRtl(f) ? (c++, d++) : goog.i18n.bidi.isRequiredLtrRe_.test(f) ? e = !0 : goog.i18n.bidi.hasAnyLtr(f) ? d++ : goog.i18n.bidi.hasNumeralsRe_.test(f) && (e = !0);
                            }
                            return 0 == d ? e ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : c / d > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
                        };
                        goog.i18n.bidi.detectRtlDirectionality = function (a, b) {
                            return goog.i18n.bidi.estimateDirection(a, b) == goog.i18n.bidi.Dir.RTL;
                        };
                        goog.i18n.bidi.setElementDirAndAlign = function (a, b) {
                            a && (b = goog.i18n.bidi.toDir(b)) && (a.style.textAlign = b == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, a.dir = b == goog.i18n.bidi.Dir.RTL ? 'rtl' : 'ltr');
                        };
                        goog.i18n.bidi.setElementDirByTextDirectionality = function (a, b) {
                            switch (goog.i18n.bidi.estimateDirection(b)) {
                            case goog.i18n.bidi.Dir.LTR:
                                'ltr' !== a.dir && (a.dir = 'ltr');
                                break;
                            case goog.i18n.bidi.Dir.RTL:
                                'rtl' !== a.dir && (a.dir = 'rtl');
                                break;
                            default:
                                a.removeAttribute('dir');
                            }
                        };
                        goog.i18n.bidi.DirectionalString = function () {
                        };
                        goog.html.TrustedResourceUrl = function (a, b) {
                            this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = b === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : '';
                        };
                        goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0;
                        goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function () {
                            return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
                        };
                        goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.TrustedResourceUrl.prototype.getDirection = function () {
                            return goog.i18n.bidi.Dir.LTR;
                        };
                        goog.html.TrustedResourceUrl.prototype.cloneWithParams = function (a, b) {
                            var c = goog.html.TrustedResourceUrl.unwrap(this);
                            c = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);
                            var d = c[3] || '';
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1] + goog.html.TrustedResourceUrl.stringifyParams_('?', c[2] || '', a) + goog.html.TrustedResourceUrl.stringifyParams_('#', d, b));
                        };
                        goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function () {
                            return 'TrustedResourceUrl{' + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + '}';
                        });
                        goog.html.TrustedResourceUrl.unwrap = function (a) {
                            return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString();
                        };
                        goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function (a) {
                            if (a instanceof goog.html.TrustedResourceUrl && a.constructor === goog.html.TrustedResourceUrl)
                                return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;
                            goog.asserts.fail('expected object of type TrustedResourceUrl, got \'' + a + '\' of type ' + goog.typeOf(a));
                            return 'type_error:TrustedResourceUrl';
                        };
                        goog.html.TrustedResourceUrl.format = function (a, b) {
                            var c = goog.string.Const.unwrap(a);
                            if (!goog.html.TrustedResourceUrl.BASE_URL_.test(c))
                                throw Error('Invalid TrustedResourceUrl format: ' + c);
                            a = c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function (d, e) {
                                if (!Object.prototype.hasOwnProperty.call(b, e))
                                    throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
                                d = b[e];
                                return d instanceof goog.string.Const ? goog.string.Const.unwrap(d) : encodeURIComponent(String(d));
                            });
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g;
                        goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^\/\\]|[^:\/\\%]+\/|[^:\/\\%]*[?#]|about:blank#)/i;
                        goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
                        goog.html.TrustedResourceUrl.formatWithParams = function (a, b, c, d) {
                            return goog.html.TrustedResourceUrl.format(a, b).cloneWithParams(c, d);
                        };
                        goog.html.TrustedResourceUrl.fromConstant = function (a) {
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
                        };
                        goog.html.TrustedResourceUrl.fromConstants = function (a) {
                            for (var b = '', c = 0; c < a.length; c++)
                                b += goog.string.Const.unwrap(a[c]);
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.TrustedResourceUrl.fromSafeScript = function (a) {
                            a = goog.fs.blob.getBlobWithProperties([module$contents$goog$html$SafeScript_SafeScript.unwrap(a)], 'text/javascript');
                            a = goog.fs.url.createObjectUrl(a);
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function (a) {
                            var b = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = b ? b.createScriptURL(a) : a;
                            return new goog.html.TrustedResourceUrl(a, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.TrustedResourceUrl.stringifyParams_ = function (a, b, c) {
                            if (null == c)
                                return b;
                            if ('string' === typeof c)
                                return c ? a + encodeURIComponent(c) : '';
                            for (var d in c)
                                if (Object.prototype.hasOwnProperty.call(c, d)) {
                                    var e = c[d];
                                    e = Array.isArray(e) ? e : [e];
                                    for (var f = 0; f < e.length; f++) {
                                        var g = e[f];
                                        null != g && (b || (b = a), b += (b.length > a.length ? '&' : '') + encodeURIComponent(d) + '=' + encodeURIComponent(String(g)));
                                    }
                                }
                            return b;
                        };
                        goog.string.internal = {};
                        goog.string.internal.startsWith = function (a, b) {
                            return 0 == a.lastIndexOf(b, 0);
                        };
                        goog.string.internal.endsWith = function (a, b) {
                            var c = a.length - b.length;
                            return 0 <= c && a.indexOf(b, c) == c;
                        };
                        goog.string.internal.caseInsensitiveStartsWith = function (a, b) {
                            return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(0, b.length));
                        };
                        goog.string.internal.caseInsensitiveEndsWith = function (a, b) {
                            return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(a.length - b.length, b.length));
                        };
                        goog.string.internal.caseInsensitiveEquals = function (a, b) {
                            return a.toLowerCase() == b.toLowerCase();
                        };
                        goog.string.internal.isEmptyOrWhitespace = function (a) {
                            return /^[\s\xa0]*$/.test(a);
                        };
                        goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function (a) {
                            return a.trim();
                        } : function (a) {
                            return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
                        };
                        goog.string.internal.caseInsensitiveCompare = function (a, b) {
                            a = String(a).toLowerCase();
                            b = String(b).toLowerCase();
                            return a < b ? -1 : a == b ? 0 : 1;
                        };
                        goog.string.internal.newLineToBr = function (a, b) {
                            return a.replace(/(\r\n|\r|\n)/g, b ? '<br />' : '<br>');
                        };
                        goog.string.internal.htmlEscape = function (a, b) {
                            if (b)
                                a = a.replace(goog.string.internal.AMP_RE_, '&amp;').replace(goog.string.internal.LT_RE_, '&lt;').replace(goog.string.internal.GT_RE_, '&gt;').replace(goog.string.internal.QUOT_RE_, '&quot;').replace(goog.string.internal.SINGLE_QUOTE_RE_, '&#39;').replace(goog.string.internal.NULL_RE_, '&#0;');
                            else {
                                if (!goog.string.internal.ALL_RE_.test(a))
                                    return a;
                                -1 != a.indexOf('&') && (a = a.replace(goog.string.internal.AMP_RE_, '&amp;'));
                                -1 != a.indexOf('<') && (a = a.replace(goog.string.internal.LT_RE_, '&lt;'));
                                -1 != a.indexOf('>') && (a = a.replace(goog.string.internal.GT_RE_, '&gt;'));
                                -1 != a.indexOf('"') && (a = a.replace(goog.string.internal.QUOT_RE_, '&quot;'));
                                -1 != a.indexOf('\'') && (a = a.replace(goog.string.internal.SINGLE_QUOTE_RE_, '&#39;'));
                                -1 != a.indexOf('\0') && (a = a.replace(goog.string.internal.NULL_RE_, '&#0;'));
                            }
                            return a;
                        };
                        goog.string.internal.AMP_RE_ = /&/g;
                        goog.string.internal.LT_RE_ = /</g;
                        goog.string.internal.GT_RE_ = />/g;
                        goog.string.internal.QUOT_RE_ = /"/g;
                        goog.string.internal.SINGLE_QUOTE_RE_ = /'/g;
                        goog.string.internal.NULL_RE_ = /\x00/g;
                        goog.string.internal.ALL_RE_ = /[\x00&<>"']/;
                        goog.string.internal.whitespaceEscape = function (a, b) {
                            return goog.string.internal.newLineToBr(a.replace(/  /g, ' &#160;'), b);
                        };
                        goog.string.internal.contains = function (a, b) {
                            return -1 != a.indexOf(b);
                        };
                        goog.string.internal.caseInsensitiveContains = function (a, b) {
                            return goog.string.internal.contains(a.toLowerCase(), b.toLowerCase());
                        };
                        goog.string.internal.compareVersions = function (a, b) {
                            var c = 0;
                            a = goog.string.internal.trim(String(a)).split('.');
                            b = goog.string.internal.trim(String(b)).split('.');
                            for (var d = Math.max(a.length, b.length), e = 0; 0 == c && e < d; e++) {
                                var f = a[e] || '', g = b[e] || '';
                                do {
                                    f = /(\d*)(\D*)(.*)/.exec(f) || [
                                        '',
                                        '',
                                        '',
                                        ''
                                    ];
                                    g = /(\d*)(\D*)(.*)/.exec(g) || [
                                        '',
                                        '',
                                        '',
                                        ''
                                    ];
                                    if (0 == f[0].length && 0 == g[0].length)
                                        break;
                                    c = 0 == f[1].length ? 0 : parseInt(f[1], 10);
                                    var h = 0 == g[1].length ? 0 : parseInt(g[1], 10);
                                    c = goog.string.internal.compareElements_(c, h) || goog.string.internal.compareElements_(0 == f[2].length, 0 == g[2].length) || goog.string.internal.compareElements_(f[2], g[2]);
                                    f = f[3];
                                    g = g[3];
                                } while (0 == c);
                            }
                            return c;
                        };
                        goog.string.internal.compareElements_ = function (a, b) {
                            return a < b ? -1 : a > b ? 1 : 0;
                        };
                        goog.html.SafeUrl = function (a, b) {
                            this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = b === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : '';
                        };
                        goog.html.SafeUrl.INNOCUOUS_STRING = 'about:invalid#zClosurez';
                        goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeUrl.prototype.getTypedStringValue = function () {
                            return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
                        };
                        goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.SafeUrl.prototype.getDirection = function () {
                            return goog.i18n.bidi.Dir.LTR;
                        };
                        goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function () {
                            return 'SafeUrl{' + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + '}';
                        });
                        goog.html.SafeUrl.unwrap = function (a) {
                            if (a instanceof goog.html.SafeUrl && a.constructor === goog.html.SafeUrl)
                                return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;
                            goog.asserts.fail('expected object of type SafeUrl, got \'' + a + '\' of type ' + goog.typeOf(a));
                            return 'type_error:SafeUrl';
                        };
                        goog.html.SafeUrl.fromConstant = function (a) {
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
                        };
                        goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i;
                        goog.html.SafeUrl.isSafeMimeType = function (a) {
                            return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a);
                        };
                        goog.html.SafeUrl.fromBlob = function (a) {
                            a = goog.html.SafeUrl.isSafeMimeType(a.type) ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.revokeObjectUrl = function (a) {
                            a = a.getTypedStringValue();
                            a !== goog.html.SafeUrl.INNOCUOUS_STRING && goog.fs.url.revokeObjectUrl(a);
                        };
                        goog.html.SafeUrl.fromMediaSource = function (a) {
                            goog.asserts.assert('MediaSource' in goog.global, 'No support for MediaSource');
                            a = a instanceof MediaSource ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i;
                        goog.html.SafeUrl.tryFromDataUrl = function (a) {
                            a = String(a);
                            a = a.replace(/(%0A|%0D)/g, '');
                            var b = a.match(goog.html.DATA_URL_PATTERN_);
                            return b && goog.html.SafeUrl.isSafeMimeType(b[1]) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a) : null;
                        };
                        goog.html.SafeUrl.fromDataUrl = function (a) {
                            return goog.html.SafeUrl.tryFromDataUrl(a) || goog.html.SafeUrl.INNOCUOUS_URL;
                        };
                        goog.html.SafeUrl.fromTelUrl = function (a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, 'tel:') || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;
                        goog.html.SafeUrl.fromSipUrl = function (a) {
                            goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a)) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromFacebookMessengerUrl = function (a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, 'fb-messenger://share') || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromWhatsAppUrl = function (a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, 'whatsapp://send') || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromSmsUrl = function (a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, 'sms:') && goog.html.SafeUrl.isSmsUrlBodyValid_(a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.isSmsUrlBodyValid_ = function (a) {
                            var b = a.indexOf('#');
                            0 < b && (a = a.substring(0, b));
                            b = a.match(/[?&]body=/gi);
                            if (!b)
                                return !0;
                            if (1 < b.length)
                                return !1;
                            a = a.match(/[?&]body=([^&]*)/)[1];
                            if (!a)
                                return !0;
                            try {
                                decodeURIComponent(a);
                            } catch (c) {
                                return !1;
                            }
                            return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a);
                        };
                        goog.html.SafeUrl.fromSshUrl = function (a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, 'ssh://') || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.sanitizeChromeExtensionUrl = function (a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function (a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function (a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeExtensionUrl_ = function (a, b, c) {
                            (a = a.exec(b)) ? (a = a[1], -1 == (c instanceof goog.string.Const ? [goog.string.Const.unwrap(c)] : c.map(function (d) {
                                return goog.string.Const.unwrap(d);
                            })).indexOf(a) && (b = goog.html.SafeUrl.INNOCUOUS_STRING)) : b = goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.SafeUrl.fromTrustedResourceUrl = function (a) {
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a));
                        };
                        goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:\/?#]*(?:[\/?#]|$))/i;
                        goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_;
                        goog.html.SafeUrl.trySanitize = function (a) {
                            if (a instanceof goog.html.SafeUrl)
                                return a;
                            a = 'object' == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            return goog.html.SAFE_URL_PATTERN_.test(a) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a) : goog.html.SafeUrl.tryFromDataUrl(a);
                        };
                        goog.html.SafeUrl.sanitize = function (a) {
                            return goog.html.SafeUrl.trySanitize(a) || goog.html.SafeUrl.INNOCUOUS_URL;
                        };
                        goog.html.SafeUrl.sanitizeAssertUnchanged = function (a, b) {
                            if (a instanceof goog.html.SafeUrl)
                                return a;
                            a = 'object' == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            if (b && /^data:/i.test(a) && (b = goog.html.SafeUrl.fromDataUrl(a), b.getTypedStringValue() == a))
                                return b;
                            goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a), '%s does not match the safe URL pattern', a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function (a) {
                            return new goog.html.SafeUrl(a, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeUrl.INNOCUOUS_URL = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING);
                        goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse('about:blank');
                        goog.html.SafeStyle = function (a, b) {
                            this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = b === goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : '';
                        };
                        goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeStyle.fromConstant = function (a) {
                            a = goog.string.Const.unwrap(a);
                            if (0 === a.length)
                                return goog.html.SafeStyle.EMPTY;
                            goog.asserts.assert(goog.string.internal.endsWith(a, ';'), 'Last character of style string is not \';\': ' + a);
                            goog.asserts.assert(goog.string.internal.contains(a, ':'), 'Style string must contain at least one \':\', to specify a "name: value" pair: ' + a);
                            return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeStyle.prototype.getTypedStringValue = function () {
                            return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
                        };
                        goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function () {
                            return 'SafeStyle{' + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + '}';
                        });
                        goog.html.SafeStyle.unwrap = function (a) {
                            if (a instanceof goog.html.SafeStyle && a.constructor === goog.html.SafeStyle)
                                return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;
                            goog.asserts.fail('expected object of type SafeStyle, got \'' + a + '\' of type ' + goog.typeOf(a));
                            return 'type_error:SafeStyle';
                        };
                        goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function (a) {
                            return new goog.html.SafeStyle(a, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse('');
                        goog.html.SafeStyle.INNOCUOUS_STRING = 'zClosurez';
                        goog.html.SafeStyle.create = function (a) {
                            var b = '', c;
                            for (c in a)
                                if (Object.prototype.hasOwnProperty.call(a, c)) {
                                    if (!/^[-_a-zA-Z0-9]+$/.test(c))
                                        throw Error('Name allows only [-_a-zA-Z0-9], got: ' + c);
                                    var d = a[c];
                                    null != d && (d = Array.isArray(d) ? module$contents$goog$array_map(d, goog.html.SafeStyle.sanitizePropertyValue_).join(' ') : goog.html.SafeStyle.sanitizePropertyValue_(d), b += c + ':' + d + ';');
                                }
                            return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
                        };
                        goog.html.SafeStyle.sanitizePropertyValue_ = function (a) {
                            if (a instanceof goog.html.SafeUrl)
                                return 'url("' + goog.html.SafeUrl.unwrap(a).replace(/</g, '%3c').replace(/[\\"]/g, '\\$&') + '")';
                            a = a instanceof goog.string.Const ? goog.string.Const.unwrap(a) : goog.html.SafeStyle.sanitizePropertyValueString_(String(a));
                            if (/[{;}]/.test(a))
                                throw new goog.asserts.AssertionError('Value does not allow [{;}], got: %s.', [a]);
                            return a;
                        };
                        goog.html.SafeStyle.sanitizePropertyValueString_ = function (a) {
                            var b = a.replace(goog.html.SafeStyle.FUNCTIONS_RE_, '$1').replace(goog.html.SafeStyle.FUNCTIONS_RE_, '$1').replace(goog.html.SafeStyle.URL_RE_, 'url');
                            if (goog.html.SafeStyle.VALUE_RE_.test(b)) {
                                if (goog.html.SafeStyle.COMMENT_RE_.test(a))
                                    return goog.asserts.fail('String value disallows comments, got: ' + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                                if (!goog.html.SafeStyle.hasBalancedQuotes_(a))
                                    return goog.asserts.fail('String value requires balanced quotes, got: ' + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                                if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(a))
                                    return goog.asserts.fail('String value requires balanced square brackets and one identifier per pair of brackets, got: ' + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                            } else
                                return goog.asserts.fail('String value allows only ' + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + ' and simple functions, got: ' + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                            return goog.html.SafeStyle.sanitizeUrl_(a);
                        };
                        goog.html.SafeStyle.hasBalancedQuotes_ = function (a) {
                            for (var b = !0, c = !0, d = 0; d < a.length; d++) {
                                var e = a.charAt(d);
                                '\'' == e && c ? b = !b : '"' == e && b && (c = !c);
                            }
                            return b && c;
                        };
                        goog.html.SafeStyle.hasBalancedSquareBrackets_ = function (a) {
                            for (var b = !0, c = /^[-_a-zA-Z0-9]$/, d = 0; d < a.length; d++) {
                                var e = a.charAt(d);
                                if (']' == e) {
                                    if (b)
                                        return !1;
                                    b = !0;
                                } else if ('[' == e) {
                                    if (!b)
                                        return !1;
                                    b = !1;
                                } else if (!b && !c.test(e))
                                    return !1;
                            }
                            return b;
                        };
                        goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = '[-,."\'%_!# a-zA-Z0-9\\[\\]]';
                        goog.html.SafeStyle.VALUE_RE_ = new RegExp('^' + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + '+$');
                        goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;
                        goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = 'calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?'.split(' ');
                        goog.html.SafeStyle.FUNCTIONS_RE_ = new RegExp('\\b(' + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join('|') + ')\\([-+*/0-9a-z.%\\[\\], ]+\\)', 'g');
                        goog.html.SafeStyle.COMMENT_RE_ = /\/\*/;
                        goog.html.SafeStyle.sanitizeUrl_ = function (a) {
                            return a.replace(goog.html.SafeStyle.URL_RE_, function (b, c, d, e) {
                                var f = '';
                                d = d.replace(/^(['"])(.*)\1$/, function (g, h, k) {
                                    f = h;
                                    return k;
                                });
                                b = goog.html.SafeUrl.sanitize(d).getTypedStringValue();
                                return c + f + b + f + e;
                            });
                        };
                        goog.html.SafeStyle.concat = function (a) {
                            var b = '', c = function (d) {
                                    Array.isArray(d) ? module$contents$goog$array_forEach(d, c) : b += goog.html.SafeStyle.unwrap(d);
                                };
                            module$contents$goog$array_forEach(arguments, c);
                            return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
                        };
                        var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet = function (a, b) {
                                this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = b === module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE ? a : '';
                                this.implementsGoogStringTypedString = !0;
                            };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule = function (a, b) {
                            if ((0, goog.string.internal.contains)(a, '<'))
                                throw Error('Selector does not allow \'<\', got: ' + a);
                            var c = a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, '');
                            if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c))
                                throw Error('Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: ' + a);
                            if (!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(c))
                                throw Error('() and [] in selector must be balanced, got: ' + a);
                            b instanceof goog.html.SafeStyle || (b = goog.html.SafeStyle.create(b));
                            a = a + '{' + goog.html.SafeStyle.unwrap(b).replace(/</g, '\\3C ') + '}';
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_ = function (a) {
                            for (var b = {
                                        '(': ')',
                                        '[': ']'
                                    }, c = [], d = 0; d < a.length; d++) {
                                var e = a[d];
                                if (b[e])
                                    c.push(b[e]);
                                else if (goog.object.contains(b, e) && c.pop() != e)
                                    return !1;
                            }
                            return 0 == c.length;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat = function (a) {
                            var b = '', c = function (d) {
                                    Array.isArray(d) ? module$contents$goog$array_forEach(d, c) : b += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(d);
                                };
                            module$contents$goog$array_forEach(arguments, c);
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant = function (a) {
                            a = goog.string.Const.unwrap(a);
                            if (0 === a.length)
                                return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY;
                            (0, goog.asserts.assert)(!(0, goog.string.internal.contains)(a, '<'), 'Forbidden \'<\' character in style sheet string: ' + a);
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue = function () {
                            return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap = function (a) {
                            if (a instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet && a.constructor === module$contents$goog$html$SafeStyleSheet_SafeStyleSheet)
                                return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
                            (0, goog.asserts.fail)('expected object of type SafeStyleSheet, got \'' + a + '\' of type ' + goog.typeOf(a));
                            return 'type_error:SafeStyleSheet';
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function (a) {
                            return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(a, module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE);
                        };
                        goog.DEBUG && (module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString = function () {
                            return 'SafeStyleSheet{' + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + '}';
                        });
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse('');
                        goog.html.SafeStyleSheet = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet;
                        goog.labs = {};
                        goog.labs.userAgent = {};
                        goog.labs.userAgent.util = {};
                        goog.labs.userAgent.util.getNativeUserAgentString_ = function () {
                            var a = goog.labs.userAgent.util.getNavigator_();
                            return a && (a = a.userAgent) ? a : '';
                        };
                        goog.labs.userAgent.util.getNavigator_ = function () {
                            return goog.global.navigator;
                        };
                        goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_();
                        goog.labs.userAgent.util.setUserAgent = function (a) {
                            goog.labs.userAgent.util.userAgent_ = a || goog.labs.userAgent.util.getNativeUserAgentString_();
                        };
                        goog.labs.userAgent.util.getUserAgent = function () {
                            return goog.labs.userAgent.util.userAgent_;
                        };
                        goog.labs.userAgent.util.matchUserAgent = function (a) {
                            var b = goog.labs.userAgent.util.getUserAgent();
                            return goog.string.internal.contains(b, a);
                        };
                        goog.labs.userAgent.util.matchUserAgentIgnoreCase = function (a) {
                            var b = goog.labs.userAgent.util.getUserAgent();
                            return goog.string.internal.caseInsensitiveContains(b, a);
                        };
                        goog.labs.userAgent.util.extractVersionTuples = function (a) {
                            for (var b = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, c = [], d; d = b.exec(a);)
                                c.push([
                                    d[1],
                                    d[2],
                                    d[3] || void 0
                                ]);
                            return c;
                        };
                        goog.labs.userAgent.browser = {};
                        goog.labs.userAgent.browser.matchOpera_ = function () {
                            return goog.labs.userAgent.util.matchUserAgent('Opera');
                        };
                        goog.labs.userAgent.browser.matchIE_ = function () {
                            return goog.labs.userAgent.util.matchUserAgent('Trident') || goog.labs.userAgent.util.matchUserAgent('MSIE');
                        };
                        goog.labs.userAgent.browser.matchEdgeHtml_ = function () {
                            return goog.labs.userAgent.util.matchUserAgent('Edge');
                        };
                        goog.labs.userAgent.browser.matchEdgeChromium_ = function () {
                            return goog.labs.userAgent.util.matchUserAgent('Edg/');
                        };
                        goog.labs.userAgent.browser.matchOperaChromium_ = function () {
                            return goog.labs.userAgent.util.matchUserAgent('OPR');
                        };
                        goog.labs.userAgent.browser.matchFirefox_ = function () {
                            return goog.labs.userAgent.util.matchUserAgent('Firefox') || goog.labs.userAgent.util.matchUserAgent('FxiOS');
                        };
                        goog.labs.userAgent.browser.matchSafari_ = function () {
                            return goog.labs.userAgent.util.matchUserAgent('Safari') && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent('Android'));
                        };
                        goog.labs.userAgent.browser.matchCoast_ = function () {
                            return goog.labs.userAgent.util.matchUserAgent('Coast');
                        };
                        goog.labs.userAgent.browser.matchIosWebview_ = function () {
                            return (goog.labs.userAgent.util.matchUserAgent('iPad') || goog.labs.userAgent.util.matchUserAgent('iPhone')) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent('AppleWebKit');
                        };
                        goog.labs.userAgent.browser.matchChrome_ = function () {
                            return (goog.labs.userAgent.util.matchUserAgent('Chrome') || goog.labs.userAgent.util.matchUserAgent('CriOS')) && !goog.labs.userAgent.browser.matchEdgeHtml_();
                        };
                        goog.labs.userAgent.browser.matchAndroidBrowser_ = function () {
                            return goog.labs.userAgent.util.matchUserAgent('Android') && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
                        };
                        goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_;
                        goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_;
                        goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_;
                        goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_;
                        goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_;
                        goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_;
                        goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_;
                        goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_;
                        goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_;
                        goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_;
                        goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_;
                        goog.labs.userAgent.browser.isSilk = function () {
                            return goog.labs.userAgent.util.matchUserAgent('Silk');
                        };
                        goog.labs.userAgent.browser.getVersion = function () {
                            function a(e) {
                                e = module$contents$goog$array_find(e, d);
                                return c[e] || '';
                            }
                            var b = goog.labs.userAgent.util.getUserAgent();
                            if (goog.labs.userAgent.browser.isIE())
                                return goog.labs.userAgent.browser.getIEVersion_(b);
                            b = goog.labs.userAgent.util.extractVersionTuples(b);
                            var c = {};
                            module$contents$goog$array_forEach(b, function (e) {
                                c[e[0]] = e[1];
                            });
                            var d = goog.partial(goog.object.containsKey, c);
                            return goog.labs.userAgent.browser.isOpera() ? a([
                                'Version',
                                'Opera'
                            ]) : goog.labs.userAgent.browser.isEdge() ? a(['Edge']) : goog.labs.userAgent.browser.isEdgeChromium() ? a(['Edg']) : goog.labs.userAgent.browser.isChrome() ? a([
                                'Chrome',
                                'CriOS',
                                'HeadlessChrome'
                            ]) : (b = b[2]) && b[1] || '';
                        };
                        goog.labs.userAgent.browser.isVersionOrHigher = function (a) {
                            return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), a);
                        };
                        goog.labs.userAgent.browser.getIEVersion_ = function (a) {
                            var b = /rv: *([\d\.]*)/.exec(a);
                            if (b && b[1])
                                return b[1];
                            b = '';
                            var c = /MSIE +([\d\.]+)/.exec(a);
                            if (c && c[1])
                                if (a = /Trident\/(\d.\d)/.exec(a), '7.0' == c[1])
                                    if (a && a[1])
                                        switch (a[1]) {
                                        case '4.0':
                                            b = '8.0';
                                            break;
                                        case '5.0':
                                            b = '9.0';
                                            break;
                                        case '6.0':
                                            b = '10.0';
                                            break;
                                        case '7.0':
                                            b = '11.0';
                                        }
                                    else
                                        b = '7.0';
                                else
                                    b = c[1];
                            return b;
                        };
                        goog.html.SafeHtml = function (a, b, c) {
                            this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = c === goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : '';
                            this.dir_ = b;
                        };
                        goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG;
                        goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = !0;
                        goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.SafeHtml.prototype.getDirection = function () {
                            return this.dir_;
                        };
                        goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeHtml.prototype.getTypedStringValue = function () {
                            return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
                        };
                        goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function () {
                            return 'SafeHtml{' + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + '}';
                        });
                        goog.html.SafeHtml.unwrap = function (a) {
                            return goog.html.SafeHtml.unwrapTrustedHTML(a).toString();
                        };
                        goog.html.SafeHtml.unwrapTrustedHTML = function (a) {
                            if (a instanceof goog.html.SafeHtml && a.constructor === goog.html.SafeHtml)
                                return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;
                            goog.asserts.fail('expected object of type SafeHtml, got \'' + a + '\' of type ' + goog.typeOf(a));
                            return 'type_error:SafeHtml';
                        };
                        goog.html.SafeHtml.htmlEscape = function (a) {
                            if (a instanceof goog.html.SafeHtml)
                                return a;
                            var b = 'object' == typeof a, c = null;
                            b && a.implementsGoogI18nBidiDirectionalString && (c = a.getDirection());
                            a = b && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a), c);
                        };
                        goog.html.SafeHtml.htmlEscapePreservingNewlines = function (a) {
                            if (a instanceof goog.html.SafeHtml)
                                return a;
                            a = goog.html.SafeHtml.htmlEscape(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)), a.getDirection());
                        };
                        goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function (a) {
                            if (a instanceof goog.html.SafeHtml)
                                return a;
                            a = goog.html.SafeHtml.htmlEscape(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)), a.getDirection());
                        };
                        goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape;
                        goog.html.SafeHtml.comment = function (a) {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse('<!--' + goog.string.internal.htmlEscape(a) + '-->', null);
                        };
                        goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/;
                        goog.html.SafeHtml.URL_ATTRIBUTES_ = {
                            action: !0,
                            cite: !0,
                            data: !0,
                            formaction: !0,
                            href: !0,
                            manifest: !0,
                            poster: !0,
                            src: !0
                        };
                        goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = goog.object.createSet(goog.dom.TagName.APPLET, goog.dom.TagName.BASE, goog.dom.TagName.EMBED, goog.dom.TagName.IFRAME, goog.dom.TagName.LINK, goog.dom.TagName.MATH, goog.dom.TagName.META, goog.dom.TagName.OBJECT, goog.dom.TagName.SCRIPT, goog.dom.TagName.STYLE, goog.dom.TagName.SVG, goog.dom.TagName.TEMPLATE);
                        goog.html.SafeHtml.create = function (a, b, c) {
                            goog.html.SafeHtml.verifyTagName(String(a));
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a), b, c);
                        };
                        goog.html.SafeHtml.verifyTagName = function (a) {
                            if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a))
                                throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid tag name <' + a + '>.' : '');
                            if (a.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_)
                                throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Tag name <' + a + '> is not allowed for SafeHtml.' : '');
                        };
                        goog.html.SafeHtml.createIframe = function (a, b, c, d) {
                            a && goog.html.TrustedResourceUrl.unwrap(a);
                            var e = {};
                            e.src = a || null;
                            e.srcdoc = b && goog.html.SafeHtml.unwrap(b);
                            a = goog.html.SafeHtml.combineAttributes(e, { sandbox: '' }, c);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse('iframe', a, d);
                        };
                        goog.html.SafeHtml.createSandboxIframe = function (a, b, c, d) {
                            if (!goog.html.SafeHtml.canUseSandboxIframe())
                                throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The browser does not support sandboxed iframes.' : '');
                            var e = {};
                            e.src = a ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)) : null;
                            e.srcdoc = b || null;
                            e.sandbox = '';
                            a = goog.html.SafeHtml.combineAttributes(e, {}, c);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse('iframe', a, d);
                        };
                        goog.html.SafeHtml.canUseSandboxIframe = function () {
                            return goog.global.HTMLIFrameElement && 'sandbox' in goog.global.HTMLIFrameElement.prototype;
                        };
                        goog.html.SafeHtml.createScriptSrc = function (a, b) {
                            goog.html.TrustedResourceUrl.unwrap(a);
                            a = goog.html.SafeHtml.combineAttributes({ src: a }, {}, b);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse('script', a);
                        };
                        goog.html.SafeHtml.createScript = function (a, b) {
                            for (var c in b)
                                if (Object.prototype.hasOwnProperty.call(b, c)) {
                                    var d = c.toLowerCase();
                                    if ('language' == d || 'src' == d || 'text' == d || 'type' == d)
                                        throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + d + '" attribute' : '');
                                }
                            c = '';
                            a = module$contents$goog$array_concat(a);
                            for (d = 0; d < a.length; d++)
                                c += module$contents$goog$html$SafeScript_SafeScript.unwrap(a[d]);
                            a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse('script', b, a);
                        };
                        goog.html.SafeHtml.createStyle = function (a, b) {
                            b = goog.html.SafeHtml.combineAttributes({ type: 'text/css' }, {}, b);
                            var c = '';
                            a = module$contents$goog$array_concat(a);
                            for (var d = 0; d < a.length; d++)
                                c += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(a[d]);
                            a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse('style', b, a);
                        };
                        goog.html.SafeHtml.createMetaRefresh = function (a, b) {
                            a = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));
                            (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(a, ';') && (a = '\'' + a.replace(/'/g, '%27') + '\'');
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse('meta', {
                                'http-equiv': 'refresh',
                                content: (b || 0) + '; url=' + a
                            });
                        };
                        goog.html.SafeHtml.getAttrNameAndValue_ = function (a, b, c) {
                            if (c instanceof goog.string.Const)
                                c = goog.string.Const.unwrap(c);
                            else if ('style' == b.toLowerCase())
                                if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE)
                                    c = goog.html.SafeHtml.getStyleValue_(c);
                                else
                                    throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : '');
                            else {
                                if (/^on/i.test(b))
                                    throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b + '" requires goog.string.Const value, "' + c + '" given.' : '');
                                if (b.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_)
                                    if (c instanceof goog.html.TrustedResourceUrl)
                                        c = goog.html.TrustedResourceUrl.unwrap(c);
                                    else if (c instanceof goog.html.SafeUrl)
                                        c = goog.html.SafeUrl.unwrap(c);
                                    else if ('string' === typeof c)
                                        c = goog.html.SafeUrl.sanitize(c).getTypedStringValue();
                                    else
                                        throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b + '" on tag "' + a + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + c + '" given.' : '');
                            }
                            c.implementsGoogStringTypedString && (c = c.getTypedStringValue());
                            goog.asserts.assert('string' === typeof c || 'number' === typeof c, 'String or number value expected, got ' + typeof c + ' with value: ' + c);
                            return b + '="' + goog.string.internal.htmlEscape(String(c)) + '"';
                        };
                        goog.html.SafeHtml.getStyleValue_ = function (a) {
                            if (!goog.isObject(a))
                                throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof a + ' given: ' + a : '');
                            a instanceof goog.html.SafeStyle || (a = goog.html.SafeStyle.create(a));
                            return goog.html.SafeStyle.unwrap(a);
                        };
                        goog.html.SafeHtml.createWithDir = function (a, b, c, d) {
                            b = goog.html.SafeHtml.create(b, c, d);
                            b.dir_ = a;
                            return b;
                        };
                        goog.html.SafeHtml.join = function (a, b) {
                            a = goog.html.SafeHtml.htmlEscape(a);
                            var c = a.getDirection(), d = [], e = function (f) {
                                    Array.isArray(f) ? module$contents$goog$array_forEach(f, e) : (f = goog.html.SafeHtml.htmlEscape(f), d.push(goog.html.SafeHtml.unwrap(f)), f = f.getDirection(), c == goog.i18n.bidi.Dir.NEUTRAL ? c = f : f != goog.i18n.bidi.Dir.NEUTRAL && c != f && (c = null));
                                };
                            module$contents$goog$array_forEach(b, e);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a)), c);
                        };
                        goog.html.SafeHtml.concat = function (a) {
                            return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
                        };
                        goog.html.SafeHtml.concatWithDir = function (a, b) {
                            var c = goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments, 1));
                            c.dir_ = a;
                            return c;
                        };
                        goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function (a, b) {
                            var c = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = c ? c.createHTML(a) : a;
                            return new goog.html.SafeHtml(a, b, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function (a, b, c) {
                            var d = null;
                            var e = '<' + a + goog.html.SafeHtml.stringifyAttributes(a, b);
                            null == c ? c = [] : Array.isArray(c) || (c = [c]);
                            goog.dom.tags.isVoidTag(a.toLowerCase()) ? (goog.asserts.assert(!c.length, 'Void tag <' + a + '> does not allow content.'), e += '>') : (d = goog.html.SafeHtml.concat(c), e += '>' + goog.html.SafeHtml.unwrap(d) + '</' + a + '>', d = d.getDirection());
                            (a = b && b.dir) && (d = /^(ltr|rtl|auto)$/i.test(a) ? goog.i18n.bidi.Dir.NEUTRAL : null);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e, d);
                        };
                        goog.html.SafeHtml.stringifyAttributes = function (a, b) {
                            var c = '';
                            if (b)
                                for (var d in b)
                                    if (Object.prototype.hasOwnProperty.call(b, d)) {
                                        if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d))
                                            throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + d + '".' : '');
                                        var e = b[d];
                                        null != e && (c += ' ' + goog.html.SafeHtml.getAttrNameAndValue_(a, d, e));
                                    }
                            return c;
                        };
                        goog.html.SafeHtml.combineAttributes = function (a, b, c) {
                            var d = {}, e;
                            for (e in a)
                                Object.prototype.hasOwnProperty.call(a, e) && (goog.asserts.assert(e.toLowerCase() == e, 'Must be lower case'), d[e] = a[e]);
                            for (e in b)
                                Object.prototype.hasOwnProperty.call(b, e) && (goog.asserts.assert(e.toLowerCase() == e, 'Must be lower case'), d[e] = b[e]);
                            if (c)
                                for (e in c)
                                    if (Object.prototype.hasOwnProperty.call(c, e)) {
                                        var f = e.toLowerCase();
                                        if (f in a)
                                            throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + f + '" attribute, got "' + e + '" with value "' + c[e] + '"' : '');
                                        f in b && delete d[f];
                                        d[e] = c[e];
                                    }
                            return d;
                        };
                        goog.html.SafeHtml.DOCTYPE_HTML = function () {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse('<!DOCTYPE html>', goog.i18n.bidi.Dir.NEUTRAL);
                        }();
                        goog.html.SafeHtml.EMPTY = new goog.html.SafeHtml(goog.global.trustedTypes && goog.global.trustedTypes.emptyHTML || '', goog.i18n.bidi.Dir.NEUTRAL, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
                        goog.html.SafeHtml.BR = function () {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse('<br>', goog.i18n.bidi.Dir.NEUTRAL);
                        }();
                        goog.html.uncheckedconversions = {};
                        goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function (a, b, c) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), 'must provide justification');
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), 'must provide non-empty justification');
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b, c || null);
                        };
                        goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function (a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), 'must provide justification');
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), 'must provide non-empty justification');
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function (a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), 'must provide justification');
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), 'must provide non-empty justification');
                            return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function (a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), 'must provide justification');
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), 'must provide non-empty justification');
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function (a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), 'must provide justification');
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), 'must provide non-empty justification');
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function (a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), 'must provide justification');
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), 'must provide non-empty justification');
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.dom.safe = {};
                        goog.dom.safe.InsertAdjacentHtmlPosition = {
                            AFTERBEGIN: 'afterbegin',
                            AFTEREND: 'afterend',
                            BEFOREBEGIN: 'beforebegin',
                            BEFOREEND: 'beforeend'
                        };
                        goog.dom.safe.insertAdjacentHtml = function (a, b, c) {
                            a.insertAdjacentHTML(b, goog.html.SafeHtml.unwrapTrustedHTML(c));
                        };
                        goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
                            MATH: !0,
                            SCRIPT: !0,
                            STYLE: !0,
                            SVG: !0,
                            TEMPLATE: !0
                        };
                        goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function () {
                            if (goog.DEBUG && 'undefined' === typeof document)
                                return !1;
                            var a = document.createElement('div'), b = document.createElement('div');
                            b.appendChild(document.createElement('div'));
                            a.appendChild(b);
                            if (goog.DEBUG && !a.firstChild)
                                return !1;
                            b = a.firstChild.firstChild;
                            a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);
                            return !b.parentElement;
                        });
                        goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function (a, b) {
                            if (goog.dom.safe.isInnerHtmlCleanupRecursive_())
                                for (; a.lastChild;)
                                    a.removeChild(a.lastChild);
                            a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setInnerHtml = function (a, b) {
                            if (goog.asserts.ENABLE_ASSERTS && a.tagName) {
                                var c = a.tagName.toUpperCase();
                                if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c])
                                    throw Error('goog.dom.safe.setInnerHtml cannot be used to set content of ' + a.tagName + '.');
                            }
                            goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a, b);
                        };
                        goog.dom.safe.setInnerHtmlFromConstant = function (a, b) {
                            goog.dom.safe.setInnerHtml(a, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from('Constant HTML to be immediatelly used.'), goog.string.Const.unwrap(b)));
                        };
                        goog.dom.safe.setOuterHtml = function (a, b) {
                            a.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setFormElementAction = function (a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLFormElement(a).action = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setButtonFormAction = function (a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLButtonElement(a).formAction = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setInputFormAction = function (a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLInputElement(a).formAction = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setStyle = function (a, b) {
                            a.style.cssText = goog.html.SafeStyle.unwrap(b);
                        };
                        goog.dom.safe.documentWrite = function (a, b) {
                            a.write(goog.html.SafeHtml.unwrapTrustedHTML(b));
                        };
                        goog.dom.safe.setAnchorHref = function (a, b) {
                            goog.dom.asserts.assertIsHTMLAnchorElement(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.href = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setImageSrc = function (a, b) {
                            goog.dom.asserts.assertIsHTMLImageElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:image\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setAudioSrc = function (a, b) {
                            goog.dom.asserts.assertIsHTMLAudioElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:audio\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setVideoSrc = function (a, b) {
                            goog.dom.asserts.assertIsHTMLVideoElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:video\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setEmbedSrc = function (a, b) {
                            goog.dom.asserts.assertIsHTMLEmbedElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                        };
                        goog.dom.safe.setFrameSrc = function (a, b) {
                            goog.dom.asserts.assertIsHTMLFrameElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrap(b);
                        };
                        goog.dom.safe.setIframeSrc = function (a, b) {
                            goog.dom.asserts.assertIsHTMLIFrameElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrap(b);
                        };
                        goog.dom.safe.setIframeSrcdoc = function (a, b) {
                            goog.dom.asserts.assertIsHTMLIFrameElement(a);
                            a.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setLinkHrefAndRel = function (a, b, c) {
                            goog.dom.asserts.assertIsHTMLLinkElement(a);
                            a.rel = c;
                            goog.string.internal.caseInsensitiveContains(c, 'stylesheet') ? (goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), a.href = goog.html.TrustedResourceUrl.unwrap(b)) : a.href = b instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(b) : b instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(b) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(b));
                        };
                        goog.dom.safe.setObjectData = function (a, b) {
                            goog.dom.asserts.assertIsHTMLObjectElement(a);
                            a.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                        };
                        goog.dom.safe.setScriptSrc = function (a, b) {
                            goog.dom.asserts.assertIsHTMLScriptElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                            goog.dom.safe.setNonceForScriptElement_(a);
                        };
                        goog.dom.safe.setScriptContent = function (a, b) {
                            goog.dom.asserts.assertIsHTMLScriptElement(a);
                            a.textContent = module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(b);
                            goog.dom.safe.setNonceForScriptElement_(a);
                        };
                        goog.dom.safe.setNonceForScriptElement_ = function (a) {
                            var b = goog.getScriptNonce(a.ownerDocument && a.ownerDocument.defaultView);
                            b && a.setAttribute('nonce', b);
                        };
                        goog.dom.safe.setLocationHref = function (a, b) {
                            goog.dom.asserts.assertIsLocation(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.href = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.assignLocation = function (a, b) {
                            goog.dom.asserts.assertIsLocation(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.assign(goog.html.SafeUrl.unwrap(b));
                        };
                        goog.dom.safe.replaceLocation = function (a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.replace(goog.html.SafeUrl.unwrap(b));
                        };
                        goog.dom.safe.openInWindow = function (a, b, c, d, e) {
                            a = a instanceof goog.html.SafeUrl ? a : goog.html.SafeUrl.sanitizeAssertUnchanged(a);
                            b = b || goog.global;
                            c = c instanceof goog.string.Const ? goog.string.Const.unwrap(c) : c || '';
                            return b.open(goog.html.SafeUrl.unwrap(a), c, d, e);
                        };
                        goog.dom.safe.parseFromStringHtml = function (a, b) {
                            return goog.dom.safe.parseFromString(a, b, 'text/html');
                        };
                        goog.dom.safe.parseFromString = function (a, b, c) {
                            return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b), c);
                        };
                        goog.dom.safe.createImageFromBlob = function (a) {
                            if (!/^image\/.*/g.test(a.type))
                                throw Error('goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.');
                            var b = goog.global.URL.createObjectURL(a);
                            a = new goog.global.Image();
                            a.onload = function () {
                                goog.global.URL.revokeObjectURL(b);
                            };
                            goog.dom.safe.setImageSrc(a, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from('Image blob URL.'), b));
                            return a;
                        };
                        goog.string.DETECT_DOUBLE_ESCAPING = !1;
                        goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1;
                        goog.string.Unicode = { NBSP: '\xA0' };
                        goog.string.startsWith = goog.string.internal.startsWith;
                        goog.string.endsWith = goog.string.internal.endsWith;
                        goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith;
                        goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith;
                        goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals;
                        goog.string.subs = function (a, b) {
                            for (var c = a.split('%s'), d = '', e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;)
                                d += c.shift() + e.shift();
                            return d + c.join('%s');
                        };
                        goog.string.collapseWhitespace = function (a) {
                            return a.replace(/[\s\xa0]+/g, ' ').replace(/^\s+|\s+$/g, '');
                        };
                        goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace;
                        goog.string.isEmptyString = function (a) {
                            return 0 == a.length;
                        };
                        goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
                        goog.string.isEmptyOrWhitespaceSafe = function (a) {
                            return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a));
                        };
                        goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
                        goog.string.isBreakingWhitespace = function (a) {
                            return !/[^\t\n\r ]/.test(a);
                        };
                        goog.string.isAlpha = function (a) {
                            return !/[^a-zA-Z]/.test(a);
                        };
                        goog.string.isNumeric = function (a) {
                            return !/[^0-9]/.test(a);
                        };
                        goog.string.isAlphaNumeric = function (a) {
                            return !/[^a-zA-Z0-9]/.test(a);
                        };
                        goog.string.isSpace = function (a) {
                            return ' ' == a;
                        };
                        goog.string.isUnicodeChar = function (a) {
                            return 1 == a.length && ' ' <= a && '~' >= a || '\x80' <= a && '\uFFFD' >= a;
                        };
                        goog.string.stripNewlines = function (a) {
                            return a.replace(/(\r\n|\r|\n)+/g, ' ');
                        };
                        goog.string.canonicalizeNewlines = function (a) {
                            return a.replace(/(\r\n|\r|\n)/g, '\n');
                        };
                        goog.string.normalizeWhitespace = function (a) {
                            return a.replace(/\xa0|\s/g, ' ');
                        };
                        goog.string.normalizeSpaces = function (a) {
                            return a.replace(/\xa0|[ \t]+/g, ' ');
                        };
                        goog.string.collapseBreakingSpaces = function (a) {
                            return a.replace(/[\t\r\n ]+/g, ' ').replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, '');
                        };
                        goog.string.trim = goog.string.internal.trim;
                        goog.string.trimLeft = function (a) {
                            return a.replace(/^[\s\xa0]+/, '');
                        };
                        goog.string.trimRight = function (a) {
                            return a.replace(/[\s\xa0]+$/, '');
                        };
                        goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare;
                        goog.string.numberAwareCompare_ = function (a, b, c) {
                            if (a == b)
                                return 0;
                            if (!a)
                                return -1;
                            if (!b)
                                return 1;
                            for (var d = a.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++) {
                                c = d[g];
                                var h = e[g];
                                if (c != h)
                                    return a = parseInt(c, 10), !isNaN(a) && (b = parseInt(h, 10), !isNaN(b) && a - b) ? a - b : c < h ? -1 : 1;
                            }
                            return d.length != e.length ? d.length - e.length : a < b ? -1 : 1;
                        };
                        goog.string.intAwareCompare = function (a, b) {
                            return goog.string.numberAwareCompare_(a, b, /\d+|\D+/g);
                        };
                        goog.string.floatAwareCompare = function (a, b) {
                            return goog.string.numberAwareCompare_(a, b, /\d+|\.\d+|\D+/g);
                        };
                        goog.string.numerateCompare = goog.string.floatAwareCompare;
                        goog.string.urlEncode = function (a) {
                            return encodeURIComponent(String(a));
                        };
                        goog.string.urlDecode = function (a) {
                            return decodeURIComponent(a.replace(/\+/g, ' '));
                        };
                        goog.string.newLineToBr = goog.string.internal.newLineToBr;
                        goog.string.htmlEscape = function (a, b) {
                            a = goog.string.internal.htmlEscape(a, b);
                            goog.string.DETECT_DOUBLE_ESCAPING && (a = a.replace(goog.string.E_RE_, '&#101;'));
                            return a;
                        };
                        goog.string.E_RE_ = /e/g;
                        goog.string.unescapeEntities = function (a) {
                            return goog.string.contains(a, '&') ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && 'document' in goog.global ? goog.string.unescapeEntitiesUsingDom_(a) : goog.string.unescapePureXmlEntities_(a) : a;
                        };
                        goog.string.unescapeEntitiesWithDocument = function (a, b) {
                            return goog.string.contains(a, '&') ? goog.string.unescapeEntitiesUsingDom_(a, b) : a;
                        };
                        goog.string.unescapeEntitiesUsingDom_ = function (a, b) {
                            var c = {
                                '&amp;': '&',
                                '&lt;': '<',
                                '&gt;': '>',
                                '&quot;': '"'
                            };
                            var d = b ? b.createElement('div') : goog.global.document.createElement('div');
                            return a.replace(goog.string.HTML_ENTITY_PATTERN_, function (e, f) {
                                var g = c[e];
                                if (g)
                                    return g;
                                '#' == f.charAt(0) && (f = Number('0' + f.substr(1)), isNaN(f) || (g = String.fromCharCode(f)));
                                g || (goog.dom.safe.setInnerHtml(d, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from('Single HTML entity.'), e + ' ')), g = d.firstChild.nodeValue.slice(0, -1));
                                return c[e] = g;
                            });
                        };
                        goog.string.unescapePureXmlEntities_ = function (a) {
                            return a.replace(/&([^;]+);/g, function (b, c) {
                                switch (c) {
                                case 'amp':
                                    return '&';
                                case 'lt':
                                    return '<';
                                case 'gt':
                                    return '>';
                                case 'quot':
                                    return '"';
                                default:
                                    return '#' != c.charAt(0) || (c = Number('0' + c.substr(1)), isNaN(c)) ? b : String.fromCharCode(c);
                                }
                            });
                        };
                        goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
                        goog.string.whitespaceEscape = function (a, b) {
                            return goog.string.newLineToBr(a.replace(/  /g, ' &#160;'), b);
                        };
                        goog.string.preserveSpaces = function (a) {
                            return a.replace(/(^|[\n ]) /g, '$1' + goog.string.Unicode.NBSP);
                        };
                        goog.string.stripQuotes = function (a, b) {
                            for (var c = b.length, d = 0; d < c; d++) {
                                var e = 1 == c ? b : b.charAt(d);
                                if (a.charAt(0) == e && a.charAt(a.length - 1) == e)
                                    return a.substring(1, a.length - 1);
                            }
                            return a;
                        };
                        goog.string.truncate = function (a, b, c) {
                            c && (a = goog.string.unescapeEntities(a));
                            a.length > b && (a = a.substring(0, b - 3) + '...');
                            c && (a = goog.string.htmlEscape(a));
                            return a;
                        };
                        goog.string.truncateMiddle = function (a, b, c, d) {
                            c && (a = goog.string.unescapeEntities(a));
                            if (d && a.length > b) {
                                d > b && (d = b);
                                var e = a.length - d;
                                a = a.substring(0, b - d) + '...' + a.substring(e);
                            } else
                                a.length > b && (d = Math.floor(b / 2), e = a.length - d, a = a.substring(0, d + b % 2) + '...' + a.substring(e));
                            c && (a = goog.string.htmlEscape(a));
                            return a;
                        };
                        goog.string.specialEscapeChars_ = {
                            '\0': '\\0',
                            '\b': '\\b',
                            '\f': '\\f',
                            '\n': '\\n',
                            '\r': '\\r',
                            '\t': '\\t',
                            '\x0B': '\\x0B',
                            '"': '\\"',
                            '\\': '\\\\',
                            '<': '\\u003C'
                        };
                        goog.string.jsEscapeCache_ = { '\'': '\\\'' };
                        goog.string.quote = function (a) {
                            a = String(a);
                            for (var b = ['"'], c = 0; c < a.length; c++) {
                                var d = a.charAt(c), e = d.charCodeAt(0);
                                b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
                            }
                            b.push('"');
                            return b.join('');
                        };
                        goog.string.escapeString = function (a) {
                            for (var b = [], c = 0; c < a.length; c++)
                                b[c] = goog.string.escapeChar(a.charAt(c));
                            return b.join('');
                        };
                        goog.string.escapeChar = function (a) {
                            if (a in goog.string.jsEscapeCache_)
                                return goog.string.jsEscapeCache_[a];
                            if (a in goog.string.specialEscapeChars_)
                                return goog.string.jsEscapeCache_[a] = goog.string.specialEscapeChars_[a];
                            var b = a.charCodeAt(0);
                            if (31 < b && 127 > b)
                                var c = a;
                            else {
                                if (256 > b) {
                                    if (c = '\\x', 16 > b || 256 < b)
                                        c += '0';
                                } else
                                    c = '\\u', 4096 > b && (c += '0');
                                c += b.toString(16).toUpperCase();
                            }
                            return goog.string.jsEscapeCache_[a] = c;
                        };
                        goog.string.contains = goog.string.internal.contains;
                        goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains;
                        goog.string.countOf = function (a, b) {
                            return a && b ? a.split(b).length - 1 : 0;
                        };
                        goog.string.removeAt = function (a, b, c) {
                            var d = a;
                            0 <= b && b < a.length && 0 < c && (d = a.substr(0, b) + a.substr(b + c, a.length - b - c));
                            return d;
                        };
                        goog.string.remove = function (a, b) {
                            return a.replace(b, '');
                        };
                        goog.string.removeAll = function (a, b) {
                            b = new RegExp(goog.string.regExpEscape(b), 'g');
                            return a.replace(b, '');
                        };
                        goog.string.replaceAll = function (a, b, c) {
                            b = new RegExp(goog.string.regExpEscape(b), 'g');
                            return a.replace(b, c.replace(/\$/g, '$$$$'));
                        };
                        goog.string.regExpEscape = function (a) {
                            return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').replace(/\x08/g, '\\x08');
                        };
                        goog.string.repeat = String.prototype.repeat ? function (a, b) {
                            return a.repeat(b);
                        } : function (a, b) {
                            return Array(b + 1).join(a);
                        };
                        goog.string.padNumber = function (a, b, c) {
                            a = void 0 !== c ? a.toFixed(c) : String(a);
                            c = a.indexOf('.');
                            -1 == c && (c = a.length);
                            return goog.string.repeat('0', Math.max(0, b - c)) + a;
                        };
                        goog.string.makeSafe = function (a) {
                            return null == a ? '' : String(a);
                        };
                        goog.string.buildString = function (a) {
                            return Array.prototype.join.call(arguments, '');
                        };
                        goog.string.getRandomString = function () {
                            return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
                        };
                        goog.string.compareVersions = goog.string.internal.compareVersions;
                        goog.string.hashCode = function (a) {
                            for (var b = 0, c = 0; c < a.length; ++c)
                                b = 31 * b + a.charCodeAt(c) >>> 0;
                            return b;
                        };
                        goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
                        goog.string.createUniqueString = function () {
                            return 'goog_' + goog.string.uniqueStringCounter_++;
                        };
                        goog.string.toNumber = function (a) {
                            var b = Number(a);
                            return 0 == b && goog.string.isEmptyOrWhitespace(a) ? NaN : b;
                        };
                        goog.string.isLowerCamelCase = function (a) {
                            return /^[a-z]+([A-Z][a-z]*)*$/.test(a);
                        };
                        goog.string.isUpperCamelCase = function (a) {
                            return /^([A-Z][a-z]*)+$/.test(a);
                        };
                        goog.string.toCamelCase = function (a) {
                            return String(a).replace(/\-([a-z])/g, function (b, c) {
                                return c.toUpperCase();
                            });
                        };
                        goog.string.toSelectorCase = function (a) {
                            return String(a).replace(/([A-Z])/g, '-$1').toLowerCase();
                        };
                        goog.string.toTitleCase = function (a, b) {
                            b = 'string' === typeof b ? goog.string.regExpEscape(b) : '\\s';
                            return a.replace(new RegExp('(^' + (b ? '|[' + b + ']+' : '') + ')([a-z])', 'g'), function (c, d, e) {
                                return d + e.toUpperCase();
                            });
                        };
                        goog.string.capitalize = function (a) {
                            return String(a.charAt(0)).toUpperCase() + String(a.substr(1)).toLowerCase();
                        };
                        goog.string.parseInt = function (a) {
                            isFinite(a) && (a = String(a));
                            return 'string' === typeof a ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;
                        };
                        goog.string.splitLimit = function (a, b, c) {
                            a = a.split(b);
                            for (var d = []; 0 < c && a.length;)
                                d.push(a.shift()), c--;
                            a.length && d.push(a.join(b));
                            return d;
                        };
                        goog.string.lastComponent = function (a, b) {
                            if (b)
                                'string' == typeof b && (b = [b]);
                            else
                                return a;
                            for (var c = -1, d = 0; d < b.length; d++)
                                if ('' != b[d]) {
                                    var e = a.lastIndexOf(b[d]);
                                    e > c && (c = e);
                                }
                            return -1 == c ? a : a.slice(c + 1);
                        };
                        goog.string.editDistance = function (a, b) {
                            var c = [], d = [];
                            if (a == b)
                                return 0;
                            if (!a.length || !b.length)
                                return Math.max(a.length, b.length);
                            for (var e = 0; e < b.length + 1; e++)
                                c[e] = e;
                            for (e = 0; e < a.length; e++) {
                                d[0] = e + 1;
                                for (var f = 0; f < b.length; f++)
                                    d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a[e] != b[f]));
                                for (f = 0; f < c.length; f++)
                                    c[f] = d[f];
                            }
                            return d[b.length];
                        };
                        goog.proto2 = {};
                        goog.proto2.Descriptor = function (a, b, c) {
                            this.messageType_ = a;
                            this.name_ = b.name || null;
                            this.fullName_ = b.fullName || null;
                            this.containingType_ = b.containingType;
                            this.fields_ = {};
                            for (a = 0; a < c.length; a++)
                                b = c[a], this.fields_[b.getTag()] = b;
                        };
                        goog.proto2.Descriptor.prototype.getName = function () {
                            return this.name_;
                        };
                        goog.proto2.Descriptor.prototype.getFullName = function () {
                            return this.fullName_;
                        };
                        goog.proto2.Descriptor.prototype.getContainingType = function () {
                            return this.containingType_ ? this.containingType_.getDescriptor() : null;
                        };
                        goog.proto2.Descriptor.prototype.getFields = function () {
                            var a = goog.object.getValues(this.fields_);
                            module$contents$goog$array_sort(a, function (b, c) {
                                return b.getTag() - c.getTag();
                            });
                            return a;
                        };
                        goog.proto2.Descriptor.prototype.getFieldsMap = function () {
                            return this.fields_;
                        };
                        goog.proto2.Descriptor.prototype.findFieldByName = function (a) {
                            return goog.object.findValue(this.fields_, function (b, c, d) {
                                return b.getName() == a;
                            }) || null;
                        };
                        goog.proto2.Descriptor.prototype.findFieldByTag = function (a) {
                            goog.asserts.assert(goog.string.isNumeric(a));
                            return this.fields_[parseInt(a, 10)] || null;
                        };
                        goog.proto2.Descriptor.prototype.createMessageInstance = function () {
                            return new this.messageType_();
                        };
                        goog.proto2.FieldDescriptor = function (a, b, c) {
                            this.parent_ = a;
                            goog.asserts.assert(goog.string.isNumeric(b));
                            this.tag_ = b;
                            this.name_ = c.name;
                            this.isPacked_ = !!c.packed;
                            this.isRepeated_ = !!c.repeated;
                            this.isRequired_ = !!c.required;
                            this.fieldType_ = c.fieldType;
                            this.nativeType_ = c.type;
                            this.deserializationConversionPermitted_ = !1;
                            switch (this.fieldType_) {
                            case goog.proto2.FieldDescriptor.FieldType.INT64:
                            case goog.proto2.FieldDescriptor.FieldType.UINT64:
                            case goog.proto2.FieldDescriptor.FieldType.FIXED64:
                            case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
                            case goog.proto2.FieldDescriptor.FieldType.SINT64:
                            case goog.proto2.FieldDescriptor.FieldType.FLOAT:
                            case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
                                this.deserializationConversionPermitted_ = !0;
                            }
                            this.defaultValue_ = c.defaultValue;
                        };
                        goog.proto2.FieldDescriptor.FieldType = {
                            DOUBLE: 1,
                            FLOAT: 2,
                            INT64: 3,
                            UINT64: 4,
                            INT32: 5,
                            FIXED64: 6,
                            FIXED32: 7,
                            BOOL: 8,
                            STRING: 9,
                            GROUP: 10,
                            MESSAGE: 11,
                            BYTES: 12,
                            UINT32: 13,
                            ENUM: 14,
                            SFIXED32: 15,
                            SFIXED64: 16,
                            SINT32: 17,
                            SINT64: 18
                        };
                        goog.proto2.FieldDescriptor.prototype.getTag = function () {
                            return this.tag_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getContainingType = function () {
                            return this.parent_.prototype.getDescriptor();
                        };
                        goog.proto2.FieldDescriptor.prototype.getName = function () {
                            return this.name_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getDefaultValue = function () {
                            if (void 0 === this.defaultValue_) {
                                var a = this.nativeType_;
                                if (a === Boolean)
                                    this.defaultValue_ = !1;
                                else if (a === Number)
                                    this.defaultValue_ = 0;
                                else if (a === String)
                                    this.defaultValue_ = this.deserializationConversionPermitted_ ? '0' : '';
                                else
                                    return new a();
                            }
                            return this.defaultValue_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getFieldType = function () {
                            return this.fieldType_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getNativeType = function () {
                            return this.nativeType_;
                        };
                        goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function () {
                            return this.deserializationConversionPermitted_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function () {
                            return this.nativeType_.prototype.getDescriptor();
                        };
                        goog.proto2.FieldDescriptor.prototype.isCompositeType = function () {
                            return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
                        };
                        goog.proto2.FieldDescriptor.prototype.isPacked = function () {
                            return this.isPacked_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isRepeated = function () {
                            return this.isRepeated_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isRequired = function () {
                            return this.isRequired_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isOptional = function () {
                            return !this.isRepeated_ && !this.isRequired_;
                        };
                        goog.proto2.Message = function () {
                            this.values_ = {};
                            this.fields_ = this.getDescriptor().getFieldsMap();
                            this.deserializedFields_ = this.lazyDeserializer_ = null;
                        };
                        goog.proto2.Message.FieldType = {
                            DOUBLE: 1,
                            FLOAT: 2,
                            INT64: 3,
                            UINT64: 4,
                            INT32: 5,
                            FIXED64: 6,
                            FIXED32: 7,
                            BOOL: 8,
                            STRING: 9,
                            GROUP: 10,
                            MESSAGE: 11,
                            BYTES: 12,
                            UINT32: 13,
                            ENUM: 14,
                            SFIXED32: 15,
                            SFIXED64: 16,
                            SINT32: 17,
                            SINT64: 18
                        };
                        goog.proto2.Message.prototype.initializeForLazyDeserializer = function (a, b) {
                            this.lazyDeserializer_ = a;
                            this.values_ = b;
                            this.deserializedFields_ = {};
                        };
                        goog.proto2.Message.prototype.setUnknown = function (a, b) {
                            goog.asserts.assert(!this.fields_[a], 'Field is not unknown in this message');
                            goog.asserts.assert(1 <= a, 'Tag ' + a + ' has value "' + b + '" in descriptor ' + this.getDescriptor().getName());
                            goog.asserts.assert(null !== b, 'Value cannot be null');
                            this.values_[a] = b;
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.prototype.forEachUnknown = function (a, b) {
                            b = b || this;
                            for (var c in this.values_) {
                                var d = Number(c);
                                this.fields_[d] || a.call(b, d, this.values_[c]);
                            }
                        };
                        goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod;
                        goog.proto2.Message.prototype.has = function (a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), 'The current message does not contain the given field');
                            return this.has$Value(a.getTag());
                        };
                        goog.proto2.Message.prototype.arrayOf = function (a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), 'The current message does not contain the given field');
                            return this.array$Values(a.getTag());
                        };
                        goog.proto2.Message.prototype.countOf = function (a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), 'The current message does not contain the given field');
                            return this.count$Values(a.getTag());
                        };
                        goog.proto2.Message.prototype.get = function (a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), 'The current message does not contain the given field');
                            return this.get$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.getOrDefault = function (a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), 'The current message does not contain the given field');
                            return this.get$ValueOrDefault(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.set = function (a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), 'The current message does not contain the given field');
                            this.set$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.add = function (a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), 'The current message does not contain the given field');
                            this.add$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.clear = function (a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), 'The current message does not contain the given field');
                            this.clear$Field(a.getTag());
                        };
                        goog.proto2.Message.prototype.equals = function (a) {
                            if (!a || this.constructor != a.constructor)
                                return !1;
                            for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
                                var d = b[c], e = d.getTag();
                                if (this.has$Value(e) != a.has$Value(e))
                                    return !1;
                                if (this.has$Value(e)) {
                                    var f = d.isCompositeType(), g = this.getValueForTag_(e);
                                    e = a.getValueForTag_(e);
                                    if (d.isRepeated()) {
                                        if (g.length != e.length)
                                            return !1;
                                        for (d = 0; d < g.length; d++) {
                                            var h = g[d], k = e[d];
                                            if (f ? !h.equals(k) : h != k)
                                                return !1;
                                        }
                                    } else if (f ? !g.equals(e) : g != e)
                                        return !1;
                                }
                            }
                            return !0;
                        };
                        goog.proto2.Message.prototype.copyFrom = function (a) {
                            goog.asserts.assert(this.constructor == a.constructor, 'The source message must have the same type.');
                            this != a && (this.values_ = {}, this.deserializedFields_ && (this.deserializedFields_ = {}), this.mergeFrom(a));
                        };
                        goog.proto2.Message.prototype.mergeFrom = function (a) {
                            goog.asserts.assert(this.constructor == a.constructor, 'The source message must have the same type.');
                            for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
                                var d = b[c], e = d.getTag();
                                if (a.has$Value(e)) {
                                    this.deserializedFields_ && delete this.deserializedFields_[d.getTag()];
                                    var f = d.isCompositeType();
                                    if (d.isRepeated()) {
                                        d = a.array$Values(e);
                                        for (var g = 0; g < d.length; g++)
                                            this.add$Value(e, f ? d[g].clone() : d[g]);
                                    } else
                                        d = a.getValueForTag_(e), f ? (f = this.getValueForTag_(e)) ? f.mergeFrom(d) : this.set$Value(e, d.clone()) : this.set$Value(e, d);
                                }
                            }
                        };
                        goog.proto2.Message.prototype.clone = function () {
                            var a = new this.constructor();
                            a.copyFrom(this);
                            return a;
                        };
                        goog.proto2.Message.prototype.initDefaults = function (a) {
                            for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
                                var d = b[c], e = d.getTag(), f = d.isCompositeType();
                                this.has$Value(e) || d.isRepeated() || (f ? this.values_[e] = new (d.getNativeType())() : a && (this.values_[e] = d.getDefaultValue()));
                                if (f)
                                    if (d.isRepeated())
                                        for (d = this.array$Values(e), e = 0; e < d.length; e++)
                                            d[e].initDefaults(a);
                                    else
                                        this.get$Value(e).initDefaults(a);
                            }
                        };
                        goog.proto2.Message.prototype.has$Value = function (a) {
                            return null != this.values_[a];
                        };
                        goog.proto2.Message.prototype.getValueForTag_ = function (a) {
                            var b = this.values_[a];
                            return null == b ? null : this.lazyDeserializer_ ? a in this.deserializedFields_ ? this.deserializedFields_[a] : (b = this.lazyDeserializer_.deserializeField(this, this.fields_[a], b), this.deserializedFields_[a] = b) : b;
                        };
                        goog.proto2.Message.prototype.get$Value = function (a, b) {
                            var c = this.getValueForTag_(a);
                            return this.fields_[a].isRepeated() ? (a = b || 0, goog.asserts.assert(0 <= a && a < c.length, 'Given index %s is out of bounds.  Repeated field length: %s', a, c.length), c[a]) : c;
                        };
                        goog.proto2.Message.prototype.get$ValueOrDefault = function (a, b) {
                            return this.has$Value(a) ? this.get$Value(a, b) : this.fields_[a].getDefaultValue();
                        };
                        goog.proto2.Message.prototype.array$Values = function (a) {
                            return this.getValueForTag_(a) || [];
                        };
                        goog.proto2.Message.prototype.count$Values = function (a) {
                            return this.fields_[a].isRepeated() ? this.has$Value(a) ? this.values_[a].length : 0 : this.has$Value(a) ? 1 : 0;
                        };
                        goog.proto2.Message.prototype.set$Value = function (a, b) {
                            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
                            this.values_[a] = b;
                            this.deserializedFields_ && (this.deserializedFields_[a] = b);
                        };
                        goog.proto2.Message.prototype.add$Value = function (a, b) {
                            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
                            this.values_[a] || (this.values_[a] = []);
                            this.values_[a].push(b);
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.prototype.checkFieldType_ = function (a, b) {
                            a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(b) : goog.asserts.assert(Object(b).constructor == a.getNativeType());
                        };
                        goog.proto2.Message.prototype.clear$Field = function (a) {
                            delete this.values_[a];
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.createDescriptor = function (a, b) {
                            var c = [], d = b[0], e;
                            for (e in b)
                                0 != e && c.push(new goog.proto2.FieldDescriptor(a, e, b[e]));
                            return new goog.proto2.Descriptor(a, d, c);
                        };
                        goog.proto2.Serializer = function () {
                        };
                        goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = !1;
                        goog.proto2.Serializer.prototype.serialize = goog.abstractMethod;
                        goog.proto2.Serializer.prototype.getSerializedValue = function (a, b) {
                            return a.isCompositeType() ? this.serialize(b) : 'number' !== typeof b || isFinite(b) ? b : b.toString();
                        };
                        goog.proto2.Serializer.prototype.deserialize = function (a, b) {
                            a = a.createMessageInstance();
                            this.deserializeTo(a, b);
                            goog.asserts.assert(a instanceof goog.proto2.Message);
                            return a;
                        };
                        goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod;
                        goog.proto2.Serializer.prototype.getDeserializedValue = function (a, b) {
                            if (a.isCompositeType())
                                return b instanceof goog.proto2.Message ? b : this.deserialize(a.getFieldMessageType(), b);
                            if (a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM)
                                return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && 'string' === typeof b && (a = a.getNativeType(), a.hasOwnProperty(b)) ? a[b] : 'string' === typeof b && goog.proto2.Serializer.INTEGER_REGEX.test(b) && (a = Number(b), 0 < a) ? a : b;
                            if (!a.deserializationConversionPermitted())
                                return b;
                            a = a.getNativeType();
                            if (a === String) {
                                if ('number' === typeof b)
                                    return String(b);
                            } else if (a === Number && 'string' === typeof b && ('Infinity' === b || '-Infinity' === b || 'NaN' === b || goog.proto2.Serializer.INTEGER_REGEX.test(b)))
                                return Number(b);
                            return b;
                        };
                        goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/;
                        goog.proto2.LazyDeserializer = function () {
                        };
                        goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer);
                        goog.proto2.LazyDeserializer.prototype.deserialize = function (a, b) {
                            a = a.createMessageInstance();
                            a.initializeForLazyDeserializer(this, b);
                            goog.asserts.assert(a instanceof goog.proto2.Message);
                            return a;
                        };
                        goog.proto2.LazyDeserializer.prototype.deserializeTo = function (a, b) {
                            throw Error('Unimplemented');
                        };
                        goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod;
                        goog.proto2.PbLiteSerializer = function () {
                        };
                        goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer);
                        goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = !1;
                        goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function (a) {
                            this.zeroIndexing_ = a;
                        };
                        goog.proto2.PbLiteSerializer.prototype.serialize = function (a) {
                            for (var b = a.getDescriptor().getFields(), c = [], d = this.zeroIndexing_, e = 0; e < b.length; e++) {
                                var f = b[e];
                                if (a.has(f)) {
                                    var g = f.getTag();
                                    g = d ? g - 1 : g;
                                    if (f.isRepeated()) {
                                        c[g] = [];
                                        for (var h = 0; h < a.countOf(f); h++)
                                            c[g][h] = this.getSerializedValue(f, a.get(f, h));
                                    } else
                                        c[g] = this.getSerializedValue(f, a.get(f));
                                }
                            }
                            a.forEachUnknown(function (k, l) {
                                c[d ? k - 1 : k] = l;
                            });
                            return c;
                        };
                        goog.proto2.PbLiteSerializer.prototype.deserializeField = function (a, b, c) {
                            if (null == c)
                                return c;
                            if (b.isRepeated()) {
                                a = [];
                                goog.asserts.assert(Array.isArray(c), 'Value must be array: %s', c);
                                for (var d = 0; d < c.length; d++)
                                    a[d] = this.getDeserializedValue(b, c[d]);
                                return a;
                            }
                            return this.getDeserializedValue(b, c);
                        };
                        goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function (a, b) {
                            return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? b ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
                        };
                        goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function (a, b) {
                            return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert('number' === typeof b || 'boolean' === typeof b, 'Value is expected to be a number or boolean'), !!b) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
                        };
                        goog.proto2.PbLiteSerializer.prototype.deserialize = function (a, b) {
                            var c = b;
                            if (this.zeroIndexing_) {
                                c = [];
                                for (var d in b)
                                    c[parseInt(d, 10) + 1] = b[d];
                            }
                            return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, a, c);
                        };
                        goog.string.StringBuffer = function (a, b) {
                            null != a && this.append.apply(this, arguments);
                        };
                        goog.string.StringBuffer.prototype.buffer_ = '';
                        goog.string.StringBuffer.prototype.set = function (a) {
                            this.buffer_ = '' + a;
                        };
                        goog.string.StringBuffer.prototype.append = function (a, b, c) {
                            this.buffer_ += String(a);
                            if (null != b)
                                for (var d = 1; d < arguments.length; d++)
                                    this.buffer_ += arguments[d];
                            return this;
                        };
                        goog.string.StringBuffer.prototype.clear = function () {
                            this.buffer_ = '';
                        };
                        goog.string.StringBuffer.prototype.getLength = function () {
                            return this.buffer_.length;
                        };
                        goog.string.StringBuffer.prototype.toString = function () {
                            return this.buffer_;
                        };
                        var i18n = { phonenumbers: {} };
                        i18n.phonenumbers.NumberFormat = function () {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message);
                        i18n.phonenumbers.NumberFormat.descriptor_ = null;
                        i18n.phonenumbers.NumberFormat.prototype.getPattern = function () {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function () {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setPattern = function (a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasPattern = function () {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.patternCount = function () {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearPattern = function () {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getFormat = function () {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function () {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setFormat = function (a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasFormat = function () {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.formatCount = function () {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearFormat = function () {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function (a) {
                            return this.get$Value(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function (a) {
                            return this.get$ValueOrDefault(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function (a) {
                            this.add$Value(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function () {
                            return this.array$Values(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function () {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function () {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function () {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function () {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function () {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function (a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function () {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function () {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function () {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function () {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function () {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function (a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function () {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function () {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function () {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function () {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function () {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function (a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function () {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function () {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function () {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneNumberDesc = function () {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message);
                        i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null;
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function () {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function () {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function (a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function () {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function () {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function () {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function (a) {
                            return this.get$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function (a) {
                            return this.get$ValueOrDefault(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function (a) {
                            this.add$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function () {
                            return this.array$Values(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function () {
                            return this.has$Value(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function () {
                            return this.count$Values(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function () {
                            this.clear$Field(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function (a) {
                            return this.get$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function (a) {
                            return this.get$ValueOrDefault(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function (a) {
                            this.add$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function () {
                            return this.array$Values(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function () {
                            return this.has$Value(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function () {
                            return this.count$Values(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function () {
                            this.clear$Field(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function () {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function () {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function (a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function () {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function () {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function () {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneMetadata = function () {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message);
                        i18n.phonenumbers.PhoneMetadata.descriptor_ = null;
                        i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function () {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function () {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function (a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function () {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function () {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function () {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function () {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function () {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function (a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function () {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function () {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function () {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function () {
                            return this.get$Value(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function () {
                            return this.get$ValueOrDefault(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function (a) {
                            this.set$Value(3, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function () {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function () {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function () {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function () {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function () {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function (a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function () {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function () {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function () {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function () {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function () {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function (a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function () {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function () {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function () {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function () {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function () {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function (a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function () {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function () {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function () {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function () {
                            return this.get$Value(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function () {
                            return this.get$ValueOrDefault(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function (a) {
                            this.set$Value(7, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function () {
                            return this.has$Value(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function () {
                            return this.count$Values(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function () {
                            this.clear$Field(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function () {
                            return this.get$Value(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function () {
                            return this.get$ValueOrDefault(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function (a) {
                            this.set$Value(8, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function () {
                            return this.has$Value(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function () {
                            return this.count$Values(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function () {
                            this.clear$Field(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPager = function () {
                            return this.get$Value(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function () {
                            return this.get$ValueOrDefault(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPager = function (a) {
                            this.set$Value(21, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function () {
                            return this.has$Value(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function () {
                            return this.count$Values(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function () {
                            this.clear$Field(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getUan = function () {
                            return this.get$Value(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function () {
                            return this.get$ValueOrDefault(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setUan = function (a) {
                            this.set$Value(25, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function () {
                            return this.has$Value(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function () {
                            return this.count$Values(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function () {
                            this.clear$Field(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function () {
                            return this.get$Value(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function () {
                            return this.get$ValueOrDefault(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function (a) {
                            this.set$Value(27, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function () {
                            return this.has$Value(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function () {
                            return this.count$Values(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function () {
                            this.clear$Field(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function () {
                            return this.get$Value(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function () {
                            return this.get$ValueOrDefault(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function (a) {
                            this.set$Value(28, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function () {
                            return this.has$Value(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function () {
                            return this.count$Values(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function () {
                            this.clear$Field(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getShortCode = function () {
                            return this.get$Value(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault = function () {
                            return this.get$ValueOrDefault(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setShortCode = function (a) {
                            this.set$Value(29, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode = function () {
                            return this.has$Value(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount = function () {
                            return this.count$Values(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode = function () {
                            this.clear$Field(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate = function () {
                            return this.get$Value(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault = function () {
                            return this.get$ValueOrDefault(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate = function (a) {
                            this.set$Value(30, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate = function () {
                            return this.has$Value(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount = function () {
                            return this.count$Values(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate = function () {
                            this.clear$Field(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific = function () {
                            return this.get$Value(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault = function () {
                            return this.get$ValueOrDefault(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific = function (a) {
                            this.set$Value(31, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific = function () {
                            return this.has$Value(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount = function () {
                            return this.count$Values(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific = function () {
                            this.clear$Field(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices = function () {
                            return this.get$Value(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault = function () {
                            return this.get$ValueOrDefault(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices = function (a) {
                            this.set$Value(33, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices = function () {
                            return this.has$Value(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount = function () {
                            return this.count$Values(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices = function () {
                            this.clear$Field(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function () {
                            return this.get$Value(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function () {
                            return this.get$ValueOrDefault(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function (a) {
                            this.set$Value(24, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function () {
                            return this.has$Value(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function () {
                            return this.count$Values(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function () {
                            this.clear$Field(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getId = function () {
                            return this.get$Value(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function () {
                            return this.get$ValueOrDefault(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setId = function (a) {
                            this.set$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasId = function () {
                            return this.has$Value(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.idCount = function () {
                            return this.count$Values(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearId = function () {
                            this.clear$Field(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function () {
                            return this.get$Value(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function () {
                            return this.get$ValueOrDefault(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function (a) {
                            this.set$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function () {
                            return this.has$Value(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function () {
                            return this.count$Values(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function () {
                            this.clear$Field(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function () {
                            return this.get$Value(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function () {
                            return this.get$ValueOrDefault(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function (a) {
                            this.set$Value(11, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function () {
                            return this.has$Value(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function () {
                            return this.count$Values(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function () {
                            this.clear$Field(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function () {
                            return this.get$Value(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function () {
                            return this.get$ValueOrDefault(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function (a) {
                            this.set$Value(17, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function () {
                            return this.has$Value(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function () {
                            return this.count$Values(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function () {
                            this.clear$Field(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function () {
                            return this.get$Value(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function () {
                            return this.get$ValueOrDefault(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function (a) {
                            this.set$Value(12, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function () {
                            return this.has$Value(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function () {
                            return this.count$Values(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function () {
                            this.clear$Field(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function () {
                            return this.get$Value(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function () {
                            return this.get$ValueOrDefault(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function (a) {
                            this.set$Value(13, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function () {
                            return this.has$Value(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function () {
                            return this.count$Values(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function () {
                            this.clear$Field(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function () {
                            return this.get$Value(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function () {
                            return this.get$ValueOrDefault(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function (a) {
                            this.set$Value(15, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function () {
                            return this.has$Value(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function () {
                            return this.count$Values(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function () {
                            this.clear$Field(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function () {
                            return this.get$Value(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function () {
                            return this.get$ValueOrDefault(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function (a) {
                            this.set$Value(16, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function () {
                            return this.has$Value(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function () {
                            return this.count$Values(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function () {
                            this.clear$Field(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function () {
                            return this.get$Value(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function () {
                            return this.get$ValueOrDefault(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function (a) {
                            this.set$Value(18, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function () {
                            return this.has$Value(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function () {
                            return this.count$Values(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function () {
                            this.clear$Field(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function (a) {
                            return this.get$Value(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function (a) {
                            return this.get$ValueOrDefault(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function (a) {
                            this.add$Value(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function () {
                            return this.array$Values(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function () {
                            return this.has$Value(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function () {
                            return this.count$Values(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function () {
                            this.clear$Field(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function (a) {
                            return this.get$Value(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function (a) {
                            return this.get$ValueOrDefault(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function (a) {
                            this.add$Value(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function () {
                            return this.array$Values(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function () {
                            return this.has$Value(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function () {
                            return this.count$Values(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function () {
                            this.clear$Field(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function () {
                            return this.get$Value(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function () {
                            return this.get$ValueOrDefault(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function (a) {
                            this.set$Value(22, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function () {
                            return this.has$Value(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function () {
                            return this.count$Values(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function () {
                            this.clear$Field(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function () {
                            return this.get$Value(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function () {
                            return this.get$ValueOrDefault(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function (a) {
                            this.set$Value(23, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function () {
                            return this.has$Value(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function () {
                            return this.count$Values(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function () {
                            this.clear$Field(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossible = function () {
                            return this.get$Value(26);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossibleOrDefault = function () {
                            return this.get$ValueOrDefault(26);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setLeadingZeroPossible = function (a) {
                            this.set$Value(26, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingZeroPossible = function () {
                            return this.has$Value(26);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.leadingZeroPossibleCount = function () {
                            return this.count$Values(26);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingZeroPossible = function () {
                            this.clear$Field(26);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection = function () {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message);
                        i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null;
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function (a) {
                            return this.get$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function (a) {
                            return this.get$ValueOrDefault(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function (a) {
                            this.add$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function () {
                            return this.array$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function () {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function () {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function () {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function () {
                            var a = i18n.phonenumbers.NumberFormat.descriptor_;
                            a || (i18n.phonenumbers.NumberFormat.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, {
                                0: {
                                    name: 'NumberFormat',
                                    fullName: 'i18n.phonenumbers.NumberFormat'
                                },
                                1: {
                                    name: 'pattern',
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                2: {
                                    name: 'format',
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                3: {
                                    name: 'leading_digits_pattern',
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                4: {
                                    name: 'national_prefix_formatting_rule',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                6: {
                                    name: 'national_prefix_optional_when_formatting',
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                5: {
                                    name: 'domestic_carrier_code_formatting_rule',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function () {
                            var a = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
                            a || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {
                                0: {
                                    name: 'PhoneNumberDesc',
                                    fullName: 'i18n.phonenumbers.PhoneNumberDesc'
                                },
                                2: {
                                    name: 'national_number_pattern',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                9: {
                                    name: 'possible_length',
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                10: {
                                    name: 'possible_length_local_only',
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                6: {
                                    name: 'example_number',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function () {
                            var a = i18n.phonenumbers.PhoneMetadata.descriptor_;
                            a || (i18n.phonenumbers.PhoneMetadata.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {
                                0: {
                                    name: 'PhoneMetadata',
                                    fullName: 'i18n.phonenumbers.PhoneMetadata'
                                },
                                1: {
                                    name: 'general_desc',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                2: {
                                    name: 'fixed_line',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                3: {
                                    name: 'mobile',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                4: {
                                    name: 'toll_free',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                5: {
                                    name: 'premium_rate',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                6: {
                                    name: 'shared_cost',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                7: {
                                    name: 'personal_number',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                8: {
                                    name: 'voip',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                21: {
                                    name: 'pager',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                25: {
                                    name: 'uan',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                27: {
                                    name: 'emergency',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                28: {
                                    name: 'voicemail',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                29: {
                                    name: 'short_code',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                30: {
                                    name: 'standard_rate',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                31: {
                                    name: 'carrier_specific',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                33: {
                                    name: 'sms_services',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                24: {
                                    name: 'no_international_dialling',
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                9: {
                                    name: 'id',
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                10: {
                                    name: 'country_code',
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                11: {
                                    name: 'international_prefix',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                17: {
                                    name: 'preferred_international_prefix',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                12: {
                                    name: 'national_prefix',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                13: {
                                    name: 'preferred_extn_prefix',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                15: {
                                    name: 'national_prefix_for_parsing',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                16: {
                                    name: 'national_prefix_transform_rule',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                18: {
                                    name: 'same_mobile_and_fixed_line_pattern',
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                19: {
                                    name: 'number_format',
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.NumberFormat
                                },
                                20: {
                                    name: 'intl_number_format',
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.NumberFormat
                                },
                                22: {
                                    name: 'main_country_for_code',
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                23: {
                                    name: 'leading_digits',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                26: {
                                    name: 'leading_zero_possible',
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function () {
                            var a = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
                            a || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, {
                                0: {
                                    name: 'PhoneMetadataCollection',
                                    fullName: 'i18n.phonenumbers.PhoneMetadataCollection'
                                },
                                1: {
                                    name: 'metadata',
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneMetadata
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneNumber = function () {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message);
                        i18n.phonenumbers.PhoneNumber.descriptor_ = null;
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function () {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function () {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function (a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function () {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function () {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function () {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function () {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function () {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function (a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function () {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function () {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function () {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getExtension = function () {
                            return this.get$Value(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function () {
                            return this.get$ValueOrDefault(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setExtension = function (a) {
                            this.set$Value(3, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function () {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function () {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function () {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function () {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function () {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function (a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function () {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function () {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function () {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function () {
                            return this.get$Value(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function () {
                            return this.get$ValueOrDefault(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function (a) {
                            this.set$Value(8, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function () {
                            return this.has$Value(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function () {
                            return this.count$Values(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function () {
                            this.clear$Field(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function () {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function () {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function (a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function () {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function () {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function () {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function () {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function () {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function (a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function () {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function () {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function () {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function () {
                            return this.get$Value(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function () {
                            return this.get$ValueOrDefault(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function (a) {
                            this.set$Value(7, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function () {
                            return this.has$Value(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function () {
                            return this.count$Values(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function () {
                            this.clear$Field(7);
                        };
                        i18n.phonenumbers.PhoneNumber.CountryCodeSource = {
                            UNSPECIFIED: 0,
                            FROM_NUMBER_WITH_PLUS_SIGN: 1,
                            FROM_NUMBER_WITH_IDD: 5,
                            FROM_NUMBER_WITHOUT_PLUS_SIGN: 10,
                            FROM_DEFAULT_COUNTRY: 20
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function () {
                            var a = i18n.phonenumbers.PhoneNumber.descriptor_;
                            a || (i18n.phonenumbers.PhoneNumber.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {
                                0: {
                                    name: 'PhoneNumber',
                                    fullName: 'i18n.phonenumbers.PhoneNumber'
                                },
                                1: {
                                    name: 'country_code',
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                2: {
                                    name: 'national_number',
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.UINT64,
                                    type: Number
                                },
                                3: {
                                    name: 'extension',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                4: {
                                    name: 'italian_leading_zero',
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    type: Boolean
                                },
                                8: {
                                    name: 'number_of_leading_zeros',
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    defaultValue: 1,
                                    type: Number
                                },
                                5: {
                                    name: 'raw_input',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                6: {
                                    name: 'country_code_source',
                                    fieldType: goog.proto2.Message.FieldType.ENUM,
                                    defaultValue: i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED,
                                    type: i18n.phonenumbers.PhoneNumber.CountryCodeSource
                                },
                                7: {
                                    name: 'preferred_domestic_carrier_code',
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber;
                        i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor;
                        i18n.phonenumbers.metadata = {};
                        i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {
                            1: 'US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI'.split(' '),
                            7: [
                                'RU',
                                'KZ'
                            ],
                            20: ['EG'],
                            27: ['ZA'],
                            30: ['GR'],
                            31: ['NL'],
                            32: ['BE'],
                            33: ['FR'],
                            34: ['ES'],
                            36: ['HU'],
                            39: [
                                'IT',
                                'VA'
                            ],
                            40: ['RO'],
                            41: ['CH'],
                            43: ['AT'],
                            44: [
                                'GB',
                                'GG',
                                'IM',
                                'JE'
                            ],
                            45: ['DK'],
                            46: ['SE'],
                            47: [
                                'NO',
                                'SJ'
                            ],
                            48: ['PL'],
                            49: ['DE'],
                            51: ['PE'],
                            52: ['MX'],
                            53: ['CU'],
                            54: ['AR'],
                            55: ['BR'],
                            56: ['CL'],
                            57: ['CO'],
                            58: ['VE'],
                            60: ['MY'],
                            61: [
                                'AU',
                                'CC',
                                'CX'
                            ],
                            62: ['ID'],
                            63: ['PH'],
                            64: ['NZ'],
                            65: ['SG'],
                            66: ['TH'],
                            81: ['JP'],
                            82: ['KR'],
                            84: ['VN'],
                            86: ['CN'],
                            90: ['TR'],
                            91: ['IN'],
                            92: ['PK'],
                            93: ['AF'],
                            94: ['LK'],
                            95: ['MM'],
                            98: ['IR'],
                            211: ['SS'],
                            212: [
                                'MA',
                                'EH'
                            ],
                            213: ['DZ'],
                            216: ['TN'],
                            218: ['LY'],
                            220: ['GM'],
                            221: ['SN'],
                            222: ['MR'],
                            223: ['ML'],
                            224: ['GN'],
                            225: ['CI'],
                            226: ['BF'],
                            227: ['NE'],
                            228: ['TG'],
                            229: ['BJ'],
                            230: ['MU'],
                            231: ['LR'],
                            232: ['SL'],
                            233: ['GH'],
                            234: ['NG'],
                            235: ['TD'],
                            236: ['CF'],
                            237: ['CM'],
                            238: ['CV'],
                            239: ['ST'],
                            240: ['GQ'],
                            241: ['GA'],
                            242: ['CG'],
                            243: ['CD'],
                            244: ['AO'],
                            245: ['GW'],
                            246: ['IO'],
                            247: ['AC'],
                            248: ['SC'],
                            249: ['SD'],
                            250: ['RW'],
                            251: ['ET'],
                            252: ['SO'],
                            253: ['DJ'],
                            254: ['KE'],
                            255: ['TZ'],
                            256: ['UG'],
                            257: ['BI'],
                            258: ['MZ'],
                            260: ['ZM'],
                            261: ['MG'],
                            262: [
                                'RE',
                                'YT'
                            ],
                            263: ['ZW'],
                            264: ['NA'],
                            265: ['MW'],
                            266: ['LS'],
                            267: ['BW'],
                            268: ['SZ'],
                            269: ['KM'],
                            290: [
                                'SH',
                                'TA'
                            ],
                            291: ['ER'],
                            297: ['AW'],
                            298: ['FO'],
                            299: ['GL'],
                            350: ['GI'],
                            351: ['PT'],
                            352: ['LU'],
                            353: ['IE'],
                            354: ['IS'],
                            355: ['AL'],
                            356: ['MT'],
                            357: ['CY'],
                            358: [
                                'FI',
                                'AX'
                            ],
                            359: ['BG'],
                            370: ['LT'],
                            371: ['LV'],
                            372: ['EE'],
                            373: ['MD'],
                            374: ['AM'],
                            375: ['BY'],
                            376: ['AD'],
                            377: ['MC'],
                            378: ['SM'],
                            380: ['UA'],
                            381: ['RS'],
                            382: ['ME'],
                            383: ['XK'],
                            385: ['HR'],
                            386: ['SI'],
                            387: ['BA'],
                            389: ['MK'],
                            420: ['CZ'],
                            421: ['SK'],
                            423: ['LI'],
                            500: ['FK'],
                            501: ['BZ'],
                            502: ['GT'],
                            503: ['SV'],
                            504: ['HN'],
                            505: ['NI'],
                            506: ['CR'],
                            507: ['PA'],
                            508: ['PM'],
                            509: ['HT'],
                            590: [
                                'GP',
                                'BL',
                                'MF'
                            ],
                            591: ['BO'],
                            592: ['GY'],
                            593: ['EC'],
                            594: ['GF'],
                            595: ['PY'],
                            596: ['MQ'],
                            597: ['SR'],
                            598: ['UY'],
                            599: [
                                'CW',
                                'BQ'
                            ],
                            670: ['TL'],
                            672: ['NF'],
                            673: ['BN'],
                            674: ['NR'],
                            675: ['PG'],
                            676: ['TO'],
                            677: ['SB'],
                            678: ['VU'],
                            679: ['FJ'],
                            680: ['PW'],
                            681: ['WF'],
                            682: ['CK'],
                            683: ['NU'],
                            685: ['WS'],
                            686: ['KI'],
                            687: ['NC'],
                            688: ['TV'],
                            689: ['PF'],
                            690: ['TK'],
                            691: ['FM'],
                            692: ['MH'],
                            800: ['001'],
                            808: ['001'],
                            850: ['KP'],
                            852: ['HK'],
                            853: ['MO'],
                            855: ['KH'],
                            856: ['LA'],
                            870: ['001'],
                            878: ['001'],
                            880: ['BD'],
                            881: ['001'],
                            882: ['001'],
                            883: ['001'],
                            886: ['TW'],
                            888: ['001'],
                            960: ['MV'],
                            961: ['LB'],
                            962: ['JO'],
                            963: ['SY'],
                            964: ['IQ'],
                            965: ['KW'],
                            966: ['SA'],
                            967: ['YE'],
                            968: ['OM'],
                            970: ['PS'],
                            971: ['AE'],
                            972: ['IL'],
                            973: ['BH'],
                            974: ['QA'],
                            975: ['BT'],
                            976: ['MN'],
                            977: ['NP'],
                            979: ['001'],
                            992: ['TJ'],
                            993: ['TM'],
                            994: ['AZ'],
                            995: ['GE'],
                            996: ['KG'],
                            998: ['UZ']
                        };
                        i18n.phonenumbers.metadata.countryToMetadata = {
                            AC: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[01589]\\d|[46])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '6[2-467]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '62889',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '4\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '40123',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AC',
                                247,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:0[1-9]|[1589]\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '542011',
                                    ,
                                    ,
                                    [6]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AD: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1|6\\d)\\d{7}|[135-9]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[78]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '712345',
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '690\\d{6}|[356]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '312345',
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '180[02]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '18001234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '[19]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '912345',
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AD',
                                376,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})',
                                        '$1 $2',
                                        ['[135-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['6']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1800\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AE: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[2-4679][2-8]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '22345678',
                                    ,
                                    ,
                                    [8],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '5[024-68]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '501234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '400\\d{6}|800\\d{2,9}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[02]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '900234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '700[05]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '700012345',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AE',
                                971,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2,9})',
                                        '$1 $2',
                                        ['60|8']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[236]|[479][2-8]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d)(\\d{5})',
                                        '$1 $2 $3',
                                        ['[479]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['5'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '600[25]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '600212345',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AF: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-7]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '234567890',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '7\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '701234567',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AF',
                                93,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[1-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2-7]'],
                                        '0$1'
                                    ]
                                ],
                                [[
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2-7]'],
                                        '0$1'
                                    ]],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AG: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:268|[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2684601234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2684641234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '26848[01]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2684801234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                'AG',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([457]\\d{6})$',
                                '268$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '26840[69]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2684061234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                '268',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AI: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:264|[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '264(?:292|4(?:6[12]|9[78]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2644612345',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2642351234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AI',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2457]\\d{6})$',
                                '264$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '264724\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2647241234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                '264',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AL: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ],
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '22345678',
                                    ,
                                    ,
                                    [8],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '6(?:[78][2-9]|9\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '672123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8001234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '900[1-9]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '900123',
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '808[1-9]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '808123',
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '700[2-9]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '70021234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AL',
                                355,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,4})',
                                        '$1 $2',
                                        ['80|9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['4[2-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[2358][2-5]|4'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['[23578]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['6'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AM: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[1-489]\\d|55|60|77)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '10123456',
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:33|4[1349]|55|77|88|9[13-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '77123456'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345'
                                ],
                                [
                                    ,
                                    ,
                                    '90[016]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '90012345'
                                ],
                                [
                                    ,
                                    ,
                                    '80[1-4]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80112345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|90)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '60271234'
                                ],
                                'AM',
                                374,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[89]0'],
                                        '0 $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['2|3[12]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1 $2',
                                        ['1|47'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1 $2',
                                        ['[3-9]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AO: [
                                ,
                                [
                                    ,
                                    ,
                                    '[29]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '222123456'
                                ],
                                [
                                    ,
                                    ,
                                    '9[1-49]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '923123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AO',
                                244,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[29]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AR: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '3888[013-9]\\d{5}|(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '1123456789',
                                    ,
                                    ,
                                    [10],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '93888[013-9]\\d{5}|9(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '91123456789',
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    '8001234567'
                                ],
                                [
                                    ,
                                    ,
                                    '60[04579]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '6001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AR',
                                54,
                                '00',
                                '0',
                                ,
                                ,
                                '0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?',
                                '9$1',
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})',
                                        '$1',
                                        ['0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})',
                                        '$1-$2',
                                        ['[1-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1-$2',
                                        ['[2-8]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1-$2',
                                        ['[1-8]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2})(\\d{4})',
                                        '$1 $2-$3',
                                        [
                                            '2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])',
                                            '2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)',
                                            '2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]',
                                            '2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]'
                                        ],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2-$3',
                                        ['1'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[68]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2-$3',
                                        ['[23]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{2})(\\d{4})',
                                        '$2 15-$3-$4',
                                        [
                                            '9(?:2[2-469]|3[3-578])',
                                            '9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))',
                                            '9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)',
                                            '9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]',
                                            '9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{4})(\\d{4})',
                                        '$2 15-$3-$4',
                                        ['91'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{5})',
                                        '$1-$2-$3',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})(\\d{4})',
                                        '$2 15-$3-$4',
                                        ['9'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{2})(\\d{4})',
                                        '$1 $2-$3',
                                        [
                                            '2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])',
                                            '2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)',
                                            '2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]',
                                            '2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]'
                                        ],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2-$3',
                                        ['1'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[68]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2-$3',
                                        ['[23]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{2})(\\d{4})',
                                        '$1 $2 $3-$4',
                                        [
                                            '9(?:2[2-469]|3[3-578])',
                                            '9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))',
                                            '9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)',
                                            '9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]',
                                            '9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3-$4',
                                        ['91']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{5})',
                                        '$1-$2-$3',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3-$4',
                                        ['9']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '810\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '810\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8101234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AS: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|684|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '6846(?:22|33|44|55|77|88|9[19])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6846221234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '684(?:2(?:48|5[2468]|72)|7(?:3[13]|70|82))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6847331234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AS',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([267]\\d{6})$',
                                '684$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '684',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AT: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}',
                                    ,
                                    ,
                                    ,
                                    '1234567890',
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    '6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}',
                                    ,
                                    ,
                                    ,
                                    '664123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6,10}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:0[01]|3[019])\\d{6,10}',
                                    ,
                                    ,
                                    ,
                                    '900123456',
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:10|2[018])\\d{6,10}|828\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '810123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}',
                                    ,
                                    ,
                                    ,
                                    '780123456',
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                'AT',
                                43,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3,12})',
                                        '$1 $2',
                                        ['1(?:11|[2-9])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})',
                                        '$1 $2',
                                        ['517'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,5})',
                                        '$1 $2',
                                        ['5[079]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{6})',
                                        '$1',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,10})',
                                        '$1 $2',
                                        ['(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3,9})',
                                        '$1 $2',
                                        ['[2-467]|5[2-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['5'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4,7})',
                                        '$1 $2 $3',
                                        ['5'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3,12})',
                                        '$1 $2',
                                        ['1(?:11|[2-9])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})',
                                        '$1 $2',
                                        ['517'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,5})',
                                        '$1 $2',
                                        ['5[079]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,10})',
                                        '$1 $2',
                                        ['(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3,9})',
                                        '$1 $2',
                                        ['[2-467]|5[2-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['5'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4,7})',
                                        '$1 $2 $3',
                                        ['5'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AU: [
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '212345678',
                                    ,
                                    ,
                                    [9],
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '412345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '180(?:0\\d{3}|2)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '1800123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '190[0-26]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1900123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '1300123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '147101234',
                                    ,
                                    ,
                                    [9]
                                ],
                                'AU',
                                61,
                                '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
                                '0',
                                ,
                                ,
                                '0|(183[12])',
                                ,
                                '0011',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})',
                                        '$1 $2',
                                        ['16'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        ['13']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})',
                                        '$1 $2',
                                        ['19']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        [
                                            '180',
                                            '1802'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3,4})',
                                        '$1 $2',
                                        ['19']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2,4})',
                                        '$1 $2 $3',
                                        ['16'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['14|4'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2378]'],
                                        '(0$1)',
                                        '$CC ($1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['1(?:30|[89])']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})',
                                        '$1 $2',
                                        ['16'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2,4})',
                                        '$1 $2 $3',
                                        ['16'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['14|4'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2378]'],
                                        '(0$1)',
                                        '$CC ($1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['1(?:30|[89])']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '163\\d{2,6}',
                                    ,
                                    ,
                                    ,
                                    '1631234',
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    '1[38]00\\d{6}|1(?:345[0-4]|802)\\d{3}|13\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AW: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[25-79]\\d\\d|800)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:2\\d|8[1-9])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '5212345'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '5601234'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8001234'
                                ],
                                [
                                    ,
                                    ,
                                    '900\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '9001234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:28\\d|501)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '5011234'
                                ],
                                'AW',
                                297,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[25-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AX: [
                                ,
                                [
                                    ,
                                    ,
                                    '2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '18[1-8]\\d{3,6}',
                                    ,
                                    ,
                                    ,
                                    '181234567',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4[0-8]|50)\\d{4,8}',
                                    ,
                                    ,
                                    ,
                                    '412345678',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{4,6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[67]00\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '600123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AX',
                                358,
                                '00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                '00',
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '18',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}',
                                    ,
                                    ,
                                    ,
                                    '10112345'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '365\\d{6}|(?:[124579]\\d|60|88)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:222[0-79]\\d|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}|(?:(?:1[28]|46)\\d|2(?:[045]2|1[24]|2[34]|33|6[23]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '123123456',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:36554|99[2-9]\\d\\d)\\d{4}|(?:[16]0|4[04]|5[015]|7[07])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '401234567'
                                ],
                                [
                                    ,
                                    ,
                                    '88\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '881234567'
                                ],
                                [
                                    ,
                                    ,
                                    '900200\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '900200123'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'AZ',
                                994,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        ['[1-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['90'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        [
                                            '1[28]|2|365|46',
                                            '1[28]|2|365|46',
                                            '1[28]|2|365(?:[0-46-9]|5[0-35-9])|46'
                                        ],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[13-9]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['90'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        [
                                            '1[28]|2|365|46',
                                            '1[28]|2|365|46',
                                            '1[28]|2|365(?:[0-46-9]|5[0-35-9])|46'
                                        ],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[13-9]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BA: [
                                ,
                                [
                                    ,
                                    ,
                                    '6\\d{8}|(?:[35689]\\d|49|70)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '30212345',
                                    ,
                                    ,
                                    [8],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '61123456'
                                ],
                                [
                                    ,
                                    ,
                                    '8[08]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '80123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '9[0246]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '90123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '8[12]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '82123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BA',
                                387,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})',
                                        '$1-$2',
                                        ['[2-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['6[1-3]|[7-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2-$3',
                                        ['[3-5]|6[56]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['6'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['6[1-3]|[7-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2-$3',
                                        ['[3-5]|6[56]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['6'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '70341234',
                                    ,
                                    ,
                                    [8]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BB: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:246|[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2464123456',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '246(?:2(?:[3568]\\d|4[0-57-9])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2462501234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:246976|900[2-9]\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '9002123456',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '24631\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '2463101234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                'BB',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-9]\\d{6})$',
                                '246$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '246',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2464301234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BD: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2[45]\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '27111234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '1812345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '80[03]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9604123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                'BD',
                                880,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{4,6})',
                                        '$1-$2',
                                        ['31[5-8]|[459]1'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,7})',
                                        '$1-$2',
                                        ['3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3,6})',
                                        '$1-$2',
                                        ['[13-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{7,8})',
                                        '$1-$2',
                                        ['2'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BE: [
                                ,
                                [
                                    ,
                                    ,
                                    '4\\d{8}|[1-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '12345678',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '4[5-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '470123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800[1-9]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '80012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:70(?:2[0-57]|3[0457]|44|69|7[0579])|90(?:0[0-35-8]|1[36]|2[0-3568]|3[0135689]|4[2-68]|5[1-68]|6[0-378]|7[23568]|9[34679]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '90012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '7879\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '78791234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BE',
                                32,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['(?:80|9)0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[239]|4[23]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[15-8]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['4'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '78(?:0[57]|1[0458]|2[25]|3[15-8]|48|[56]0|7[078])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '78102345',
                                    ,
                                    ,
                                    [8]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BF: [
                                ,
                                [
                                    ,
                                    ,
                                    '[025-7]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '20491234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:0[127]|5[1-8]|[67]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '70123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BF',
                                226,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[025-7]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '2123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '43[07-9]\\d{5}|(?:48|8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '48123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '90\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '90123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '700\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '70012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BG',
                                359,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{6})',
                                        '$1',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d)(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['43[1-6]|70[1-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2,3})',
                                        '$1 $2 $3',
                                        ['[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['(?:70|8)0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})',
                                        '$1 $2 $3',
                                        ['43[1-7]|7'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[48]|9[08]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['9'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d)(\\d)(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['43[1-6]|70[1-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2,3})',
                                        '$1 $2 $3',
                                        ['[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['(?:70|8)0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})',
                                        '$1 $2 $3',
                                        ['43[1-7]|7'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[48]|9[08]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['9'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BH: [
                                ,
                                [
                                    ,
                                    ,
                                    '[136-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '17001234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '36001234'
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '80123456'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:87|9[014578])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '90123456'
                                ],
                                [
                                    ,
                                    ,
                                    '84\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '84123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BH',
                                973,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[13679]|8[047]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BI: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[267]\\d|31)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '22\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '22201234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:29|31|6[1289]|7[125-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '79561234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BI',
                                257,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[2367]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BJ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[25689]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:02|1[037]|2[45]|3[68])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '20211234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:5[1-35-8]|6\\d|9[013-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '90011234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '857[58]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '85751234'
                                ],
                                'BJ',
                                229,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[25689]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '81\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '81123456'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BL: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:590|69\\d|976)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '590(?:2[7-9]|5[12]|87)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '590271234'
                                ],
                                [
                                    ,
                                    ,
                                    '69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '690001234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '976[01]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '976012345'
                                ],
                                'BL',
                                590,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BM: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:441|[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '4414123456',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '441(?:[2378]\\d|5[0-39])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '4413701234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BM',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-8]\\d{6})$',
                                '441$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '441',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BN: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-578]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '2345678'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:22[89]|[78]\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '5[34]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '5345678'
                                ],
                                'BN',
                                673,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[2-578]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BO: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[2-467]\\d\\d|8001)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '22123456',
                                    ,
                                    ,
                                    [8],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '[67]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '71234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '8001[07]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '800171234',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BO',
                                591,
                                '00(?:1\\d)?',
                                '0',
                                ,
                                ,
                                '0(1\\d)?',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{7})',
                                        '$1 $2',
                                        ['[23]|4[46]'],
                                        ,
                                        '0$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{8})',
                                        '$1',
                                        ['[67]'],
                                        ,
                                        '0$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{4})',
                                        '$1 $2 $3',
                                        ['8'],
                                        ,
                                        '0$CC $1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '8001[07]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BQ: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[34]1|7\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '7151234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '3181234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BQ',
                                599,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '[347]',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BR: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '1123456789',
                                    ,
                                    ,
                                    [10],
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '11961234567',
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '300\\d{6}|[59]00\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '300123456',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '300\\d{7}|[34]00\\d{5}|4(?:02|37)0\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '40041234',
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BR',
                                55,
                                '00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)',
                                '0',
                                ,
                                ,
                                '(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?',
                                '$2',
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3,6})',
                                        '$1',
                                        ['1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1-$2',
                                        [
                                            '300|4(?:0[02]|37)',
                                            '4(?:02|37)0|[34]00'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1-$2',
                                        [
                                            '[2-57]',
                                            '[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2,3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['(?:[358]|90)0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{4})',
                                        '$1-$2',
                                        ['9']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2-$3',
                                        ['(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]'],
                                        '($1)',
                                        '0 $CC ($1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})(\\d{4})',
                                        '$1 $2-$3',
                                        ['[16][1-9]|[2-57-9]'],
                                        '($1)',
                                        '0 $CC ($1)'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1-$2',
                                        [
                                            '300|4(?:0[02]|37)',
                                            '4(?:02|37)0|[34]00'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2,3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['(?:[358]|90)0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2-$3',
                                        ['(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]'],
                                        '($1)',
                                        '0 $CC ($1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})(\\d{4})',
                                        '$1 $2-$3',
                                        ['[16][1-9]|[2-57-9]'],
                                        '($1)',
                                        '0 $CC ($1)'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '4020\\d{4}|[34]00\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BS: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:242|[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2423456789',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2423591234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BS',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([3-8]\\d{6})$',
                                '242$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '242',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '242225\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2422250123'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BT: [
                                ,
                                [
                                    ,
                                    ,
                                    '[17]\\d{7}|[2-8]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '2345678',
                                    ,
                                    ,
                                    [7],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1[67]|77)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '17123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BT',
                                975,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})',
                                        '$1 $2',
                                        ['[2-7]']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[2-68]|7[246]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['1[67]|7']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[2-68]|7[246]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['1[67]|7']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BW: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2401234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '77200\\d{3}|(?:321|7(?:[1-6]\\d|7[013-9]|8[01]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '71123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:0800|800\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '0800012345',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '90\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '9012345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '79(?:1(?:[01]\\d|20)|2[0-2]\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '79101234',
                                    ,
                                    ,
                                    [8]
                                ],
                                'BW',
                                267,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})',
                                        '$1 $2',
                                        ['90']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[24-6]|3[15-79]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[37]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['0']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{3})',
                                        '$1 $2 $3',
                                        ['8']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BY: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '152450911',
                                    ,
                                    ,
                                    [9],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '294911911',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8011234567'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:810|902)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9021234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '249\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '249123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                'BY',
                                375,
                                '810',
                                '8',
                                ,
                                ,
                                '0|80?',
                                ,
                                '8~10',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})',
                                        '$1 $2',
                                        ['800'],
                                        '8 $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2,4})',
                                        '$1 $2 $3',
                                        ['800'],
                                        '8 $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2})(\\d{3})',
                                        '$1 $2-$3',
                                        [
                                            '1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])',
                                            '1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])'
                                        ],
                                        '8 0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2-$3-$4',
                                        ['1(?:[56]|7[467])|2[1-3]'],
                                        '8 0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2-$3-$4',
                                        ['[1-4]'],
                                        '8 0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[89]'],
                                        '8 $1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:0800\\d|[2-8])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:236|732)\\d{4}|[2-578][02]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '2221234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '6[0-35-7]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '6221234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '0800\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '08001234123',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'BZ',
                                501,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1-$2',
                                        ['[2-8]']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})(\\d{3})',
                                        '$1-$2-$3-$4',
                                        ['0']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CA: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[2-8]\\d|90)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5062345678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5062345678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '600[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '6002012345'
                                ],
                                'CA',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1',
                                ,
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CC: [
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '891621234',
                                    ,
                                    ,
                                    [9],
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '412345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '180(?:0\\d{3}|2)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '1800123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '190[0-26]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1900123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '1300123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '147101234',
                                    ,
                                    ,
                                    [9]
                                ],
                                'CC',
                                61,
                                '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
                                '0',
                                ,
                                ,
                                '0|([59]\\d{7})$',
                                '8$1',
                                '0011',
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CD: [
                                ,
                                [
                                    ,
                                    ,
                                    '[189]\\d{8}|[1-68]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '12\\d{7}|[1-6]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1234567'
                                ],
                                [
                                    ,
                                    ,
                                    '88\\d{5}|(?:8[0-2459]|9[017-9])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '991234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CD',
                                243,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['88'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})',
                                        '$1 $2',
                                        ['[1-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[89]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CF: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[27]\\d{3}|8776)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2[12]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '21612345'
                                ],
                                [
                                    ,
                                    ,
                                    '7[0257]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '70012345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '8776\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '87761234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CF',
                                236,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[278]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CG: [
                                ,
                                [
                                    ,
                                    ,
                                    '222\\d{6}|(?:0\\d|80)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '222[1-589]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '222123456'
                                ],
                                [
                                    ,
                                    ,
                                    '026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '061234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '80(?:0\\d\\d|11[0-4])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CG',
                                242,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['801']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['8']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[02]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CH: [
                                ,
                                [
                                    ,
                                    ,
                                    '8\\d{11}|[2-9]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '212345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '7[35-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '781234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '90[016]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '900123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '84[0248]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '840123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '878\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '878123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CH',
                                41,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['8[047]|90'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[2-79]|81'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4 $5',
                                        ['8'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '74[0248]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '740123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '5[18]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '581234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '860\\d{9}',
                                    ,
                                    ,
                                    ,
                                    '860123456789',
                                    ,
                                    ,
                                    [12]
                                ]
                            ],
                            CI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[02]\\d{9}|[02-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:0[023]|[15]\\d{3}|7(?:2(?:0[23]|1[2357]|[23][45]|4[3-5])|3(?:06|1[69]|[2-6]7)))|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}|2(?:1[02357]|[23][045]|4[03-5])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '21234567'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:0(?:[15]\\d\\d|7(?:[04-8][7-9]|9[78]))|[457]\\d|6[014-9]|8[4-9]|9[4-8])\\d\\d|2[0-3]80)\\d{4}|0[1-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '01234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CI',
                                225,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        [
                                            '[03-9]|2(?:[02-4]|1[023578])',
                                            '[03-9]|2(?:[02-4]|1(?:[02357]|80))'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d)(\\d{5})',
                                        '$1 $2 $3 $4',
                                        ['2']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{4})',
                                        '$1 $2 $3 $4',
                                        ['0']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CK: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-578]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2\\d|3[13-7]|4[1-5])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '21234'
                                ],
                                [
                                    ,
                                    ,
                                    '[578]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '71234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CK',
                                682,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{3})',
                                        '$1 $2',
                                        ['[2-578]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CL: [
                                ,
                                [
                                    ,
                                    ,
                                    '12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '221234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '221234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:123|8)00\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '600\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    '6001234567',
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '44\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '441234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                'CL',
                                56,
                                '(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        '(\\d{4})',
                                        '$1',
                                        ['1(?:[03-589]|21)|[29]0|78']
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{4})',
                                        '$1 $2',
                                        [
                                            '219',
                                            '2196'
                                        ],
                                        '($1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['44']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['2[1-3]'],
                                        '($1)'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['9[2-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])'],
                                        '($1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['60|8']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['60']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{5})(\\d{4})',
                                        '$1 $2',
                                        [
                                            '219',
                                            '2196'
                                        ],
                                        '($1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['44']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['2[1-3]'],
                                        '($1)'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['9[2-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])'],
                                        '($1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['60|8']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['60']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '600\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[26]\\d{8}|88\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:22|33)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '222123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:24[23]|6[5-9]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '671234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '88\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '88012345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CM',
                                237,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['88']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4 $5',
                                        ['[26]|88']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CN: [
                                ,
                                [
                                    ,
                                    ,
                                    '1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))',
                                    ,
                                    ,
                                    ,
                                    '1012345678',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|5[0-35-9]|6[25-7]|7[0-35-8]|9[0135-9])\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '13123456789',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:10|21)8|8)00\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567',
                                    ,
                                    ,
                                    [
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '16[08]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '16812345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}',
                                    ,
                                    ,
                                    ,
                                    '4001234567',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CN',
                                86,
                                '00|1(?:[12]\\d|79)\\d\\d00',
                                '0',
                                ,
                                ,
                                '0|(1(?:[12]\\d|79)\\d\\d)',
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{5,6})',
                                        '$1',
                                        ['96']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5,6})',
                                        '$1 $2',
                                        [
                                            '(?:10|2[0-57-9])[19]',
                                            '(?:10|2[0-57-9])(?:10|9[56])',
                                            '(?:10|2[0-57-9])(?:100|9[56])'
                                        ],
                                        '0$1',
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        [
                                            '[1-9]',
                                            '1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])',
                                            '1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['16[08]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5,6})',
                                        '$1 $2',
                                        [
                                            '3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]',
                                            '(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]',
                                            '85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])',
                                            '85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])'
                                        ],
                                        '0$1',
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        [
                                            '[1-9]',
                                            '1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])',
                                            '26|3(?:[0268]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9])|(?:34|85[23])[0-8]|(?:1|58)[1-9]|(?:63|95)[06-9]|(?:33|85[23]9)[0-46-9]|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])',
                                            '26|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:1|58|85[23]10)[1-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['(?:4|80)0']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '10|2(?:[02-57-9]|1[1-9])',
                                            '10|2(?:[02-57-9]|1[1-9])',
                                            '10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])'
                                        ],
                                        '0$1',
                                        '$CC $1',
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]'],
                                        '0$1',
                                        '$CC $1',
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{7,8})',
                                        '$1 $2',
                                        ['9']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['80'],
                                        '0$1',
                                        '$CC $1',
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[3-578]'],
                                        '0$1',
                                        '$CC $1',
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1[3-9]'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3 $4',
                                        ['[12]'],
                                        '0$1',
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{5,6})',
                                        '$1 $2',
                                        [
                                            '(?:10|2[0-57-9])[19]',
                                            '(?:10|2[0-57-9])(?:10|9[56])',
                                            '(?:10|2[0-57-9])(?:100|9[56])'
                                        ],
                                        '0$1',
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5,6})',
                                        '$1 $2',
                                        [
                                            '3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]',
                                            '(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]',
                                            '85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])',
                                            '85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])'
                                        ],
                                        '0$1',
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['(?:4|80)0']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '10|2(?:[02-57-9]|1[1-9])',
                                            '10|2(?:[02-57-9]|1[1-9])',
                                            '10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])'
                                        ],
                                        '0$1',
                                        '$CC $1',
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]'],
                                        '0$1',
                                        '$CC $1',
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{7,8})',
                                        '$1 $2',
                                        ['9']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['80'],
                                        '0$1',
                                        '$CC $1',
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[3-578]'],
                                        '0$1',
                                        '$CC $1',
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1[3-9]'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3 $4',
                                        ['[12]'],
                                        '0$1',
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CO: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1\\d|3)\\d{9}|[124-8]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '[124-8][2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '12345678',
                                    ,
                                    ,
                                    [8],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|3(?:24[2-6]|3(?:00|3[0-24-9]))\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '3211234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '1800\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '18001234567',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    '19(?:0[01]|4[78])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '19001234567',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CO',
                                57,
                                '00(?:4(?:[14]4|56)|[579])',
                                '0',
                                ,
                                ,
                                '0([3579]|4(?:[14]4|56))?',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{7})',
                                        '$1 $2',
                                        ['[14][2-9]|[25-8]'],
                                        '($1)',
                                        '0$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{7})',
                                        '$1 $2',
                                        ['3'],
                                        ,
                                        '0$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{7})',
                                        '$1-$2-$3',
                                        ['1'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{7})',
                                        '$1 $2',
                                        ['[14][2-9]|[25-8]'],
                                        '($1)',
                                        '0$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{7})',
                                        '$1 $2',
                                        ['3'],
                                        ,
                                        '0$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{7})',
                                        '$1 $2 $3',
                                        ['1']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CR: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '22123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '83123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '90[059]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:210[0-6]|4\\d{3}|5100)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '40001234',
                                    ,
                                    ,
                                    [8]
                                ],
                                'CR',
                                506,
                                '00',
                                ,
                                ,
                                ,
                                '(19(?:0[0-2468]|1[09]|20|66|77|99))',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[2-7]|8[3-9]'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[89]'],
                                        ,
                                        '$CC $1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CU: [
                                ,
                                [
                                    ,
                                    ,
                                    '[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        10
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '71234567',
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '5\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '51234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '807\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8071234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CU',
                                53,
                                '119',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{4,6})',
                                        '$1 $2',
                                        ['2[1-4]|[34]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{6,7})',
                                        '$1 $2',
                                        ['7'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{7})',
                                        '$1 $2',
                                        ['5'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{7})',
                                        '$1 $2',
                                        ['8'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CV: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[2-59]\\d\\d|800)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2211234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[34][36]|5[1-389]|9\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '9911234'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8001234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CV',
                                238,
                                '0',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        ['[2-589]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CW: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '94351234'
                                ],
                                [
                                    ,
                                    ,
                                    '953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '95181234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '60[0-2]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6001234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CW',
                                599,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[3467]']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['9[4-8]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '955\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '95581234',
                                    ,
                                    ,
                                    [8]
                                ],
                                1,
                                '[69]',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CX: [
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '891641234',
                                    ,
                                    ,
                                    [9],
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '412345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '180(?:0\\d{3}|2)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '1800123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '190[0-26]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1900123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '1300123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '147101234',
                                    ,
                                    ,
                                    [9]
                                ],
                                'CX',
                                61,
                                '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
                                '0',
                                ,
                                ,
                                '0|([59]\\d{7})$',
                                '8$1',
                                '0011',
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CY: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[279]\\d|[58]0)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2[2-6]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '22345678'
                                ],
                                [
                                    ,
                                    ,
                                    '9[4-79]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '96123456'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80001234'
                                ],
                                [
                                    ,
                                    ,
                                    '90[09]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '90012345'
                                ],
                                [
                                    ,
                                    ,
                                    '80[1-9]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80112345'
                                ],
                                [
                                    ,
                                    ,
                                    '700\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '70012345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'CY',
                                357,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1 $2',
                                        ['[257-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:50|77)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '77123456'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '212345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '601123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:0[05689]|76)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '900123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '8[134]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '811234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '70[01]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '700123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '9[17]0\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '910123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                'CZ',
                                420,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[2-8]|9[015-7]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['9']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['9']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:5\\d|7[2-4])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '972123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:3\\d{9}|6\\d{7,10})',
                                    ,
                                    ,
                                    ,
                                    '93123456789'
                                ]
                            ],
                            DE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ],
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '32\\d{9,11}|49[3-6]\\d{10}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}',
                                    ,
                                    ,
                                    ,
                                    '30123456',
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ],
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    '15123456789',
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7,12}',
                                    ,
                                    ,
                                    ,
                                    '8001234567890',
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:137[7-9]|900(?:[135]|9\\d))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9001234567',
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '18012345',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '700\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '70012345678',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'DE',
                                49,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,13})',
                                        '$1 $2',
                                        ['3[02]|40|[68]9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,12})',
                                        '$1 $2',
                                        [
                                            '2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1',
                                            '2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2,11})',
                                        '$1 $2',
                                        [
                                            '[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]',
                                            '[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['138'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{2,10})',
                                        '$1 $2',
                                        ['3'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5,11})',
                                        '$1 $2',
                                        ['181'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d)(\\d{4,10})',
                                        '$1 $2 $3',
                                        ['1(?:3|80)|9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{7,8})',
                                        '$1 $2',
                                        ['1[67]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{7,12})',
                                        '$1 $2',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{6})',
                                        '$1 $2',
                                        [
                                            '185',
                                            '1850',
                                            '18500'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['7'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{7})',
                                        '$1 $2',
                                        ['18[68]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{6})',
                                        '$1 $2',
                                        ['15[0568]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{7})',
                                        '$1 $2',
                                        ['15[1279]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{8})',
                                        '$1 $2',
                                        ['18'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{7,8})',
                                        '$1 $2 $3',
                                        ['1(?:6[023]|7)'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2})(\\d{7})',
                                        '$1 $2 $3',
                                        ['15[279]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{8})',
                                        '$1 $2 $3',
                                        ['15'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '16(?:4\\d{1,10}|[89]\\d{1,11})',
                                    ,
                                    ,
                                    ,
                                    '16412345',
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '18(?:1\\d{5,11}|[2-9]\\d{8})',
                                    ,
                                    ,
                                    ,
                                    '18500123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '177991234567',
                                    ,
                                    ,
                                    [
                                        12,
                                        13
                                    ]
                                ]
                            ],
                            DJ: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:2\\d|77)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:1[2-5]|7[45])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '21360003'
                                ],
                                [
                                    ,
                                    ,
                                    '77\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '77831001'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'DJ',
                                253,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[27]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            DK: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '32123456'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '32123456'
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '80123456'
                                ],
                                [
                                    ,
                                    ,
                                    '90\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '90123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'DK',
                                45,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[2-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            DM: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|767|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7674201234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7672251234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'DM',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-7]\\d{6})$',
                                '767$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '767',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            DO: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8092345678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8[024]9[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8092345678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'DO',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1',
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '8001|8[024]9',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            DZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[1-4]|[5-79]\\d|80)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '12345678'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:5(?:4[0-29]|5\\d|6[01])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '551234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '80[3-689]1\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '808123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '80[12]1\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '801123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '98[23]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '983123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                'DZ',
                                213,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[1-4]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[5-8]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            EC: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '[2-7][2-7]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '22123456',
                                    ,
                                    ,
                                    [8],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '991234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '1800\\d{7}|1[78]00\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '18001234567',
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '[2-7]890\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '28901234',
                                    ,
                                    ,
                                    [8]
                                ],
                                'EC',
                                593,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1-$2',
                                        ['[2-7]']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2-$3',
                                        ['[2-7]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['1']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[2-7]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['1']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            EE: [
                                ,
                                [
                                    ,
                                    ,
                                    '8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '3212345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:[0-35-9]\\d{6}|4(?:[0-57-9]\\d{5}|6(?:[0-24-9]\\d{4}|3(?:[0-35-9]\\d{3}|4000))))|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:23|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[24-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9]|8[2-4])\\d|7(?:[679]\\d|8[13-9]))\\d)|[349]\\d{4})\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '51234567',
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '80012345'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:40\\d\\d|900)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '9001234',
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '70[0-2]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '70012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'EE',
                                372,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        [
                                            '[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88',
                                            '[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3,4})',
                                        '$1 $2',
                                        [
                                            '[45]|8(?:00|[1-49])',
                                            '[45]|8(?:00[1-9]|[1-49])'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{4})',
                                        '$1 $2 $3',
                                        ['7']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['8']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '800[2-9]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            EG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '234567890',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1[0-25]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '1001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '900\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'EG',
                                20,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{7,8})',
                                        '$1 $2',
                                        ['[23]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6,7})',
                                        '$1 $2',
                                        ['1[35]|[4-6]|8[2468]|9[235-7]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[189]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            EH: [
                                ,
                                [
                                    ,
                                    ,
                                    '[5-8]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '528[89]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '528812345'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|6[1267]|7[0-57]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '650123456'
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '801234567'
                                ],
                                [
                                    ,
                                    ,
                                    '89\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '891234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '592(?:4[0-2]|93)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '592401234'
                                ],
                                'EH',
                                212,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '528[89]',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ER: [
                                ,
                                [
                                    ,
                                    ,
                                    '[178]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8370362',
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:17[1-3]|7\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'ER',
                                291,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[178]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ES: [
                                ,
                                [
                                    ,
                                    ,
                                    '[5-9]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '810123456'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '612345678'
                                ],
                                [
                                    ,
                                    ,
                                    '[89]00\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    '80[367]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '803123456'
                                ],
                                [
                                    ,
                                    ,
                                    '90[12]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '901123456'
                                ],
                                [
                                    ,
                                    ,
                                    '70\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '701234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'ES',
                                34,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})',
                                        '$1',
                                        ['905']
                                    ],
                                    [
                                        ,
                                        '(\\d{6})',
                                        '$1',
                                        ['[79]9']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[89]00']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[5-9]']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[89]00']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[5-9]']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '51\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '511234567'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ET: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:11|[2-59]\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[78]|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '111112345',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '9\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '911234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'ET',
                                251,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[1-59]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}',
                                    ,
                                    ,
                                    ,
                                    '131234567',
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4[0-8]|50)\\d{4,8}',
                                    ,
                                    ,
                                    ,
                                    '412345678',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{4,6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[67]00\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '600123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'FI',
                                358,
                                '00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{5})',
                                        '$1',
                                        ['75[12]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4,9})',
                                        '$1 $2',
                                        ['[2568][1-8]|3(?:0[1-9]|[1-9])|9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{6})',
                                        '$1',
                                        ['11']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,7})',
                                        '$1 $2',
                                        ['[12]00|[368]|70[07-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4,8})',
                                        '$1 $2',
                                        ['[1245]|7[135]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6,10})',
                                        '$1 $2',
                                        ['7'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{4,9})',
                                        '$1 $2',
                                        ['[2568][1-8]|3(?:0[1-9]|[1-9])|9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,7})',
                                        '$1 $2',
                                        ['[12]00|[368]|70[07-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4,8})',
                                        '$1 $2',
                                        ['[1245]|7[135]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6,10})',
                                        '$1 $2',
                                        ['7'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                1,
                                '1[03-79]|[2-9]',
                                [
                                    ,
                                    ,
                                    '20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}'
                                ],
                                [
                                    ,
                                    ,
                                    '20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}',
                                    ,
                                    ,
                                    ,
                                    '10112345'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FJ: [
                                ,
                                [
                                    ,
                                    ,
                                    '45\\d{5}|(?:0800\\d|[235-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '3212345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[279]\\d|45|5[01568]|8[034679])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7012345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '0800\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '08001234567',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'FJ',
                                679,
                                '0(?:0|52)',
                                ,
                                ,
                                ,
                                ,
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[235-9]|45']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['0']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FK: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-7]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '[2-47]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '31234'
                                ],
                                [
                                    ,
                                    ,
                                    '[56]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '51234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'FK',
                                500,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FM: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[39]\\d\\d|820)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '3201234'
                                ],
                                [
                                    ,
                                    ,
                                    '31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '3501234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'FM',
                                691,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[389]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FO: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-9]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:20|[34]\\d|8[19])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '201234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[27][1-9]|5\\d|91)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '211234'
                                ],
                                [
                                    ,
                                    ,
                                    '80[257-9]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '802123'
                                ],
                                [
                                    ,
                                    ,
                                    '90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '901123'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:6[0-36]|88)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '601234'
                                ],
                                'FO',
                                298,
                                '00',
                                ,
                                ,
                                ,
                                '(10(?:01|[12]0|88))',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{6})',
                                        '$1',
                                        ['[2-9]'],
                                        ,
                                        '$CC $1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FR: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[1-35]\\d|4[1-9])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '123456789'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7(?:00|[3-9]\\d))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '612345678'
                                ],
                                [
                                    ,
                                    ,
                                    '80[0-5]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '801234567'
                                ],
                                [
                                    ,
                                    ,
                                    '836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '891123456'
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:1[01]|2[0156]|84)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '884012345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '9\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '912345678'
                                ],
                                'FR',
                                33,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})',
                                        '$1',
                                        ['10']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})',
                                        '$1 $2',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['8'],
                                        '0 $1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4 $5',
                                        ['[1-79]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['8'],
                                        '0 $1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4 $5',
                                        ['[1-79]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '80[6-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '806123456'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GA: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[01]1\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '01441234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:0[2-7]|6[256]|7[47])\\d{6}|[2-7]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '06031234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'GA',
                                241,
                                '00',
                                ,
                                ,
                                ,
                                '0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})',
                                '$1',
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[2-7]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['11|[67]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['0']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GB: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|4(?:[0-5]\\d\\d|69[7-9])|(?:5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[02]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '1212345678',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '7400123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '80[08]\\d{7}|800\\d{6}|8001111',
                                    ,
                                    ,
                                    ,
                                    '8001234567'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d',
                                    ,
                                    ,
                                    ,
                                    '9012345678',
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '70\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '7012345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '56\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '5612345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                'GB',
                                44,
                                '00',
                                '0',
                                ' x',
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        [
                                            '800',
                                            '8001',
                                            '80011',
                                            '800111',
                                            '8001111'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        [
                                            '845',
                                            '8454',
                                            '84546',
                                            '845464'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{6})',
                                        '$1 $2',
                                        ['800'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{4,5})',
                                        '$1 $2',
                                        [
                                            '1(?:38|5[23]|69|76|94)',
                                            '1(?:(?:38|69)7|5(?:24|39)|768|946)',
                                            '1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{5,6})',
                                        '$1 $2',
                                        ['1(?:[2-69][02-9]|[78])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '[25]|7(?:0|6[02-9])',
                                            '[25]|7(?:0|6(?:[03-9]|2[356]))'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{6})',
                                        '$1 $2',
                                        ['7'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[1389]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '7640123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3[0347]|55)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '5512345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GD: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:473|[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '4732691234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '4734031234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'GD',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-9]\\d{6})$',
                                '473$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '473',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GE: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[3-57]\\d\\d|800)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '322123456',
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:0(?:0(?:0\\d|50)\\d|555[5-9])|(?:111\\d|8(?:58[89]|888))\\d|(?:2222|3333)[0-4]|52(?:00\\d|22[0-4])|75(?:00\\d|7(?:7[7-9]|8[01])))\\d{3}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '555123456'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '70[67]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '706123456'
                                ],
                                'GE',
                                995,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['70'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['32'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[57]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[348]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '70[67]\\d{6}'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GF: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[56]94|976)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[014])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '594101234'
                                ],
                                [
                                    ,
                                    ,
                                    '694(?:[0-249]\\d|3[0-48])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '694201234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '976\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '976012345'
                                ],
                                'GF',
                                594,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[569]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GG: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        10
                                    ],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '1481[25-9]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '1481256789',
                                    ,
                                    ,
                                    [10],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:(?:781|839)\\d|911[17])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7781123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '80[08]\\d{7}|800\\d{6}|8001111',
                                    ,
                                    ,
                                    ,
                                    '8001234567'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d',
                                    ,
                                    ,
                                    ,
                                    '9012345678',
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '70\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '7012345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '56\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '5612345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                'GG',
                                44,
                                '00',
                                '0',
                                ,
                                ,
                                '0|([25-9]\\d{5})$',
                                '1481$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '7640123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3[0347]|55)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '5512345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GH: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[235]\\d{3}|800)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '302345678',
                                    ,
                                    ,
                                    [9],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[0346-8]\\d|5(?:[0457]\\d|6[01]|9[1-6]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '231234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'GH',
                                233,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[237]|8[0-2]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[235]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[235]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GI: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[25]\\d\\d|606)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '21(?:6[24-7]\\d|90[0-2])\\d{3}|2(?:00|2[25])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '20012345'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:5[146-8]\\d|606)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '57123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'GI',
                                350,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['2']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GL: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:19|[2-689]\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:19|3[1-7]|6[14689]|8[14-79]|9\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '321000'
                                ],
                                [
                                    ,
                                    ,
                                    '[245]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '221234'
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '801234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '3[89]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '381234'
                                ],
                                'GL',
                                299,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        ['19|[2-689]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '5661234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[23679]\\d|5[0-389])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '3012345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'GM',
                                220,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[2-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GN: [
                                ,
                                [
                                    ,
                                    ,
                                    '722\\d{6}|(?:3|6\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '30241234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '6[0-356]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '601123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '722\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '722123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                'GN',
                                224,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['3']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[67]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GP: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:590|69\\d|976)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '590201234'
                                ],
                                [
                                    ,
                                    ,
                                    '69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '690001234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '976[01]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '976012345'
                                ],
                                'GP',
                                590,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[569]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GQ: [
                                ,
                                [
                                    ,
                                    ,
                                    '222\\d{6}|(?:3\\d|55|[89]0)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '333091234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:222|55\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '222123456'
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d[1-9]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    '90\\d[1-9]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '900123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'GQ',
                                240,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[235]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{6})',
                                        '$1 $2',
                                        ['[89]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GR: [
                                ,
                                [
                                    ,
                                    ,
                                    '5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '2123456789',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '68[57-9]\\d{7}|(?:69|94)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '6912345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    '8001234567'
                                ],
                                [
                                    ,
                                    ,
                                    '90[19]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9091234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:0[16]|12|[27]5|50)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8011234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '70\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '7012345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'GR',
                                30,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['21|7']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{6})',
                                        '$1 $2',
                                        ['2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2689]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{5})',
                                        '$1 $2 $3',
                                        ['8']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '5005000\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '5005000123',
                                    ,
                                    ,
                                    [10]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GT: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1\\d{3}|[2-7])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[267][2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '22456789',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '[3-5]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '51234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '18[01]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '18001112222',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    '19\\d{9}',
                                    ,
                                    ,
                                    ,
                                    '19001112222',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'GT',
                                502,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[2-7]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GU: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|671|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6713001234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6713001234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'GU',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([3-9]\\d{6})$',
                                '671$1',
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '671',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GW: [
                                ,
                                [
                                    ,
                                    ,
                                    '[49]\\d{8}|4\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '443\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '443201234',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:5\\d|6[569]|77)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '955012345',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '40\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '4012345',
                                    ,
                                    ,
                                    [7]
                                ],
                                'GW',
                                245,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['40']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[49]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GY: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2201234'
                                ],
                                [
                                    ,
                                    ,
                                    '6\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '6091234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:289|862)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2891234'
                                ],
                                [
                                    ,
                                    ,
                                    '9008\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '9008123'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'GY',
                                592,
                                '001',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[2-46-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            HK: [
                                ,
                                [
                                    ,
                                    ,
                                    '8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-6]|5[0-5]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '21234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:46(?:0[0-7]|1[0-6]|4[0-57-9]|5[0-8]|6[0-4])|5730|6(?:26[013-7]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|929[03-9])\\d{4}|(?:46[23]|5(?:[1-59][0-46-9]|6[0-4689]|7[0-2469])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|849|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '51234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '900(?:[0-24-9]\\d{7}|3\\d{1,4})',
                                    ,
                                    ,
                                    ,
                                    '90012345678',
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '81123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'HK',
                                852,
                                '00(?:30|5[09]|[126-9]?)',
                                ,
                                ,
                                ,
                                ,
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2,5})',
                                        '$1 $2',
                                        [
                                            '900',
                                            '9003'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[2-7]|8[1-4]|9(?:0[1-9]|[1-8])']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['8']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['9']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '71123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '30161234',
                                    ,
                                    ,
                                    [8]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            HN: [
                                ,
                                [
                                    ,
                                    ,
                                    '8\\d{10}|[237-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:2(?:0[0-39]|1[1-36]|[23]\\d|4[04-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[78]|2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:0[7-9]|16|4[03-5]|5\\d|6[014-6]|74|80)|6(?:[056]\\d|17|2[07]|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '22123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '[37-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '91234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '8002\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '80021234567',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'HN',
                                504,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1-$2',
                                        ['[237-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['8']
                                    ]
                                ],
                                [[
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1-$2',
                                        ['[237-9]']
                                    ]],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '8002\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            HR: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '12345678',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:751\\d{5}|8\\d{6,7})|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '921234567',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '80[01]\\d{4,6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '6[01459]\\d{6}|6[01]\\d{4,5}',
                                    ,
                                    ,
                                    ,
                                    '611234',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '7[45]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '74123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'HR',
                                385,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2,3})',
                                        '$1 $2 $3',
                                        ['6[01]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2,3})',
                                        '$1 $2 $3',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{3})',
                                        '$1 $2 $3',
                                        ['1'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[67]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[2-5]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['8'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '62\\d{6,7}|72\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '62123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            HT: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-489]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:2\\d|5[1-5]|81|9[149])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '22453300'
                                ],
                                [
                                    ,
                                    ,
                                    '[34]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '34101234'
                                ],
                                [
                                    ,
                                    ,
                                    '8\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '80012345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '98901234'
                                ],
                                'HT',
                                509,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2-489]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            HU: [
                                ,
                                [
                                    ,
                                    ,
                                    '[235-7]\\d{8}|[1-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '12345678',
                                    ,
                                    ,
                                    [8],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[257]0|3[01])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '201234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[48]0\\d|6802)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80123456'
                                ],
                                [
                                    ,
                                    ,
                                    '9[01]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '90123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '21\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '211234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                'HU',
                                36,
                                '00',
                                '06',
                                ,
                                ,
                                '06',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1'],
                                        '(06 $1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]'],
                                        '(06 $1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[2-9]'],
                                        '06 $1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[48]0\\d|6802)\\d{5}'
                                ],
                                [
                                    ,
                                    ,
                                    '38\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '381234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ID: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}',
                                    ,
                                    ,
                                    ,
                                    '218350123',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '8[1-35-9]\\d{7,10}',
                                    ,
                                    ,
                                    ,
                                    '812345678',
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8001234567',
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '809\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8091234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '804\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8041234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'ID',
                                62,
                                '00[89]',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['15']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5,9})',
                                        '$1 $2',
                                        ['2[124]|[36]1'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5,7})',
                                        '$1 $2',
                                        ['800'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5,8})',
                                        '$1 $2',
                                        ['[2-79]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,4})(\\d{3})',
                                        '$1-$2-$3',
                                        ['8[1-35-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{6,8})',
                                        '$1 $2',
                                        ['1'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['804'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['80'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4,5})',
                                        '$1-$2-$3',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['001']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3 $4',
                                        ['0']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['15']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5,9})',
                                        '$1 $2',
                                        ['2[124]|[36]1'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5,7})',
                                        '$1 $2',
                                        ['800'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5,8})',
                                        '$1 $2',
                                        ['[2-79]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,4})(\\d{3})',
                                        '$1-$2-$3',
                                        ['8[1-35-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{6,8})',
                                        '$1 $2',
                                        ['1'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['804'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['80'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4,5})',
                                        '$1-$2-$3',
                                        ['8'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '001803\\d{6,7}|(?:007803\\d|8071)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1500|8071\\d{3})\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '8071123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            IE: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '2212345',
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:22|[35-9]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '850123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '1800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1800123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '15(?:1[2-8]|[2-8]0|9[089])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1520123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '18[59]0\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1850123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '700\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '700123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '76\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '761234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                'IE',
                                353,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})',
                                        '$1 $2',
                                        ['2[24-9]|47|58|6[237-9]|9[35-9]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['[45]0'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3,4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[2569]|4[1-69]|7[14]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['70'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['81'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[78]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['4'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3 $4',
                                        ['8'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '18[59]0\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '818\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '818123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '8551234567',
                                    ,
                                    ,
                                    [10]
                                ]
                            ],
                            IL: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '21234567',
                                    ,
                                    ,
                                    [
                                        8,
                                        11,
                                        12
                                    ],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-9]|3[0-3]|4[34]|5[015689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '502345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:255|80[019]\\d{3})\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '1800123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1212\\d{4}|1(?:200|9(?:0[01]|19))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1919123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1700\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1700123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:380|8(?:33|55|77|81))\\d{5}|7(?:18|2[23]|3[237]|47|6[58]|7\\d|82|9[235-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '771234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                'IL',
                                972,
                                '0(?:0|1[2-9])',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})',
                                        '$1-$2',
                                        ['125']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2})(\\d{2})',
                                        '$1-$2-$3',
                                        ['121']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[2-489]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[57]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1-$2-$3',
                                        ['12']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{6})',
                                        '$1-$2',
                                        ['159']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})(\\d{3})',
                                        '$1-$2-$3-$4',
                                        ['1[7-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})',
                                        '$1-$2 $3-$4',
                                        ['15']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1700\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '1599\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1599123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '151\\d{8,9}',
                                    ,
                                    ,
                                    ,
                                    '15112340000',
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            IM: [
                                ,
                                [
                                    ,
                                    ,
                                    '1624\\d{6}|(?:[3578]\\d|90)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '1624(?:230|[5-8]\\d\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '1624756789',
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7924123456'
                                ],
                                [
                                    ,
                                    ,
                                    '808162\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8081624567'
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '9016247890'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '70\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '7012345678'
                                ],
                                [
                                    ,
                                    ,
                                    '56\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '5612345678'
                                ],
                                'IM',
                                44,
                                '00',
                                '0',
                                ,
                                ,
                                '0|([25-8]\\d{5})$',
                                '1624$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '74576|(?:16|7[56])24',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '5512345678'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            IN: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7410410123',
                                    ,
                                    ,
                                    [10],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '8123456789',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))',
                                    ,
                                    ,
                                    ,
                                    '1800123456'
                                ],
                                [
                                    ,
                                    ,
                                    '186[12]\\d{9}',
                                    ,
                                    ,
                                    ,
                                    '1861123456789',
                                    ,
                                    ,
                                    [13]
                                ],
                                [
                                    ,
                                    ,
                                    '1860\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '18603451234',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'IN',
                                91,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{7})',
                                        '$1',
                                        ['575']
                                    ],
                                    [
                                        ,
                                        '(\\d{8})',
                                        '$1',
                                        [
                                            '5(?:0|2[23]|3[03]|[67]1|88)',
                                            '5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)',
                                            '5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)'
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4,5})',
                                        '$1 $2',
                                        [
                                            '180',
                                            '1800'
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['140'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '11|2[02]|33|4[04]|79[1-7]|80[2-46]',
                                            '11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])',
                                            '11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])'
                                        ],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]',
                                            '1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]',
                                            '1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]'
                                        ],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        [
                                            '1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807',
                                            '1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]',
                                            '1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]'
                                        ],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{5})',
                                        '$1 $2',
                                        ['[6-9]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2,4})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '1(?:6|8[06])',
                                            '1(?:6|8[06]0)'
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3 $4',
                                        ['0']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['18'],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{8})',
                                        '$1',
                                        [
                                            '5(?:0|2[23]|3[03]|[67]1|88)',
                                            '5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)',
                                            '5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)'
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4,5})',
                                        '$1 $2',
                                        [
                                            '180',
                                            '1800'
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['140'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '11|2[02]|33|4[04]|79[1-7]|80[2-46]',
                                            '11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])',
                                            '11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])'
                                        ],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]',
                                            '1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]',
                                            '1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]'
                                        ],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        [
                                            '1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807',
                                            '1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]',
                                            '1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]'
                                        ],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{5})',
                                        '$1 $2',
                                        ['[6-9]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2,4})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '1(?:6|8[06])',
                                            '1(?:6|8[06]0)'
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['18'],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}'
                                ],
                                [
                                    ,
                                    ,
                                    '140\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '1409305260',
                                    ,
                                    ,
                                    [10]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            IO: [
                                ,
                                [
                                    ,
                                    ,
                                    '3\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '37\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '3709100'
                                ],
                                [
                                    ,
                                    ,
                                    '38\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '3801234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'IO',
                                246,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['3']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            IQ: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '12345678',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '7[3-9]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '7912345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'IQ',
                                964,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[2-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['7'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            IR: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        10
                                    ],
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2123456789',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '99(?:5[15]0|888|9(?:0[013]|21|77|88))\\d{5}|9(?:0(?:[1-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d|9(?:[0-2]\\d|3[01]|4[0145]|81|9[19]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9123456789',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '993[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9932123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                'IR',
                                98,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4,5})',
                                        '$1',
                                        ['96'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4,5})',
                                        '$1 $2',
                                        ['(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[1-8]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])',
                                    ,
                                    ,
                                    ,
                                    '9601',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            IS: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:38\\d|[4-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '4101234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[28]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6111234'
                                ],
                                [
                                    ,
                                    ,
                                    '80[08]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8001234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '9001234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '49[0-24-79]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '4921234',
                                    ,
                                    ,
                                    [7]
                                ],
                                'IS',
                                354,
                                '00|1(?:0(?:01|[12]0)|100)',
                                ,
                                ,
                                ,
                                ,
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[4-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['3']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '809\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8091234',
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '(?:689|8(?:7[18]|80)|95[48])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6891234',
                                    ,
                                    ,
                                    [7]
                                ]
                            ],
                            IT: [
                                ,
                                [
                                    ,
                                    ,
                                    '0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}',
                                    ,
                                    ,
                                    ,
                                    '0212345678',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '3[1-9]\\d{8}|3[2-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '3123456789',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '80(?:0\\d{3}|3)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '899123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '84(?:[08]\\d{3}|[17])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '848123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:78\\d|99)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1781234567',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '55\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '5512345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                'IT',
                                39,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4,5})',
                                        '$1',
                                        [
                                            '1(?:0|9[246])',
                                            '1(?:0|9(?:2[2-9]|[46]))'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{6})',
                                        '$1',
                                        ['1(?:1|92)']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4,6})',
                                        '$1 $2',
                                        ['0[26]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,6})',
                                        '$1 $2',
                                        [
                                            '0[13-57-9][0159]|8(?:03|4[17]|9[245])',
                                            '0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2,6})',
                                        '$1 $2',
                                        ['0(?:[13-579][2-46-8]|8[236-8])']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['894']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['0[26]|5']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['1[4679]|[38]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['0[13-57-9][0159]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{5})',
                                        '$1 $2 $3',
                                        ['0[26]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['0']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4,5})',
                                        '$1 $2 $3',
                                        ['3']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{4,6})',
                                        '$1 $2',
                                        ['0[26]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,6})',
                                        '$1 $2',
                                        [
                                            '0[13-57-9][0159]|8(?:03|4[17]|9[245])',
                                            '0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2,6})',
                                        '$1 $2',
                                        ['0(?:[13-579][2-46-8]|8[236-8])']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['894']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['0[26]|5']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['1[4679]|[38]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['0[13-57-9][0159]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{5})',
                                        '$1 $2 $3',
                                        ['0[26]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['0']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4,5})',
                                        '$1 $2 $3',
                                        ['3']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    '848\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '3[2-8]\\d{9,10}',
                                    ,
                                    ,
                                    ,
                                    '33101234501',
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            JE: [
                                ,
                                [
                                    ,
                                    ,
                                    '1534\\d{6}|(?:[3578]\\d|90)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '1534[0-24-8]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '1534456789',
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7797712345'
                                ],
                                [
                                    ,
                                    ,
                                    '80(?:07(?:35|81)|8901)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8007354567'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '9018105678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '701511\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7015115678'
                                ],
                                [
                                    ,
                                    ,
                                    '56\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '5612345678'
                                ],
                                'JE',
                                44,
                                '00',
                                '0',
                                ,
                                ,
                                '0|([0-24-8]\\d{5})$',
                                '1534$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '7640123456'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '5512345678'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            JM: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|658|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:5(?:02|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8765230123',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:658295|876(?:2(?:[14-9]\\d|2[013-9]|3[7-9])|[348]\\d\\d|5(?:0[13-9]|1[579]|[2-57-9]\\d|6[0-24-9])|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8762101234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'JM',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1',
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '658|876',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            JO: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '62001234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:[78][0-25-9]|9\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '790123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '80012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '9\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '90012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '85\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '85012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '70\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '700123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'JO',
                                962,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2356]|87'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5,6})',
                                        '$1 $2',
                                        ['[89]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{7})',
                                        '$1 $2',
                                        ['70'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['7'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '74(?:66|77)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '746612345',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:10|8\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '88101234',
                                    ,
                                    ,
                                    [8]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            JP: [
                                ,
                                [
                                    ,
                                    ,
                                    '00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '312345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '[7-9]0[1-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9012345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '00(?:(?:37|66)\\d{6,13}|(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d)|(?:120|800\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '120123456'
                                ],
                                [
                                    ,
                                    ,
                                    '990\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '990123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '60\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '601234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '50[1-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '5012345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                'JP',
                                81,
                                '010',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1-$2',
                                        [
                                            '007',
                                            '0077',
                                            '00777',
                                            '00777[01]'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1-$2-$3',
                                        ['(?:12|57|99)0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d)(\\d{4})',
                                        '$1-$2-$3',
                                        [
                                            '1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])',
                                            '1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]',
                                            '1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['60'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1-$2-$3',
                                        [
                                            '[36]|4(?:2[09]|7[01])',
                                            '[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        [
                                            '1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])',
                                            '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]',
                                            '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]',
                                            '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[14]|[289][2-9]|5[3-9]|7[2-4679]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2})(\\d{3,4})',
                                        '$1-$2-$3',
                                        ['007']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2})(\\d{4})',
                                        '$1-$2-$3',
                                        ['008']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['800'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[257-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3,4})',
                                        '$1-$2-$3',
                                        ['0']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})(\\d{4,5})',
                                        '$1-$2-$3',
                                        ['0']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{5})(\\d{5,6})',
                                        '$1-$2-$3',
                                        ['0']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{6})(\\d{6,7})',
                                        '$1-$2-$3',
                                        ['0']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1-$2-$3',
                                        ['(?:12|57|99)0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d)(\\d{4})',
                                        '$1-$2-$3',
                                        [
                                            '1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])',
                                            '1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]',
                                            '1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['60'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1-$2-$3',
                                        [
                                            '[36]|4(?:2[09]|7[01])',
                                            '[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        [
                                            '1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])',
                                            '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]',
                                            '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]',
                                            '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[14]|[289][2-9]|5[3-9]|7[2-4679]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['800'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[257-9]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '20\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '2012345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66)\\d{6,13}'
                                ],
                                [
                                    ,
                                    ,
                                    '570\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '570123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KE: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '202012345',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:0[0-6]|1[0-5]|2[014])|7\\d\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '712123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800[24-8]\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '800223456',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '900[02-9]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '900223456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'KE',
                                254,
                                '000',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{5,7})',
                                        '$1 $2',
                                        ['[24-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{6})',
                                        '$1 $2',
                                        ['[17]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[89]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KG: [
                                ,
                                [
                                    ,
                                    ,
                                    '8\\d{9}|(?:[235-8]\\d|99)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '312123456',
                                    ,
                                    ,
                                    [9],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|7(?:[07]\\d|55)|880|99[05-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '700123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'KG',
                                996,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{5})',
                                        '$1 $2',
                                        ['3(?:1[346]|[24-79])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[235-79]|88'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d)(\\d{2,3})',
                                        '$1 $2 $3 $4',
                                        ['8'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KH: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{9}|[1-9]\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})',
                                    ,
                                    ,
                                    ,
                                    '23756789',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '91234567',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1800(?:1\\d|2[019])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '1800123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '1900(?:1\\d|2[09])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '1900123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'KH',
                                855,
                                '00[14-9]',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[1-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['1']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KI: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '31234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '72001234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '30(?:0[01]\\d\\d|12(?:11|20))\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '30010000',
                                    ,
                                    ,
                                    [8]
                                ],
                                'KI',
                                686,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[3478]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7],
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    '7[4-7]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7712345',
                                    ,
                                    ,
                                    ,
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    '[34]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '3212345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '8\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8001234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'KM',
                                269,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        ['[3478]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KN: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8692361234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8697652917',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'KN',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-7]\\d{6})$',
                                '869$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '869',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KP: [
                                ,
                                [
                                    ,
                                    ,
                                    '85\\d{6}|(?:19\\d|[2-7])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '21234567',
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '19[1-3]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '1921234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'KP',
                                850,
                                '00|99',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2-7]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KR: [
                                ,
                                [
                                    ,
                                    ,
                                    '00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ],
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    '22123456',
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '1020000000',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '801234567',
                                    ,
                                    ,
                                    [
                                        9,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '60[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '602345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '50\\d{8,9}',
                                    ,
                                    ,
                                    ,
                                    '5012345678',
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '70\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '7012345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                'KR',
                                82,
                                '00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))',
                                '0',
                                ,
                                ,
                                '0(8(?:[1-46-8]|5\\d\\d))?',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{5})',
                                        '$1',
                                        [
                                            '1[016-9]1',
                                            '1[016-9]11',
                                            '1[016-9]114'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})',
                                        '$1-$2',
                                        ['(?:3[1-3]|[46][1-4]|5[1-5])1'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1-$2',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3,4})(\\d{4})',
                                        '$1-$2-$3',
                                        ['2'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['60|8'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[1346]|5[1-5]'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[57]'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        [
                                            '003',
                                            '0030'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})(\\d{4})',
                                        '$1-$2-$3',
                                        ['5'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{3,4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['0']
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3 $4',
                                        ['0']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})',
                                        '$1-$2',
                                        ['(?:3[1-3]|[46][1-4]|5[1-5])1'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1-$2',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3,4})(\\d{4})',
                                        '$1-$2-$3',
                                        ['2'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['60|8'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[1346]|5[1-5]'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[57]'],
                                        '0$1',
                                        '0$CC-$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})(\\d{4})',
                                        '$1-$2-$3',
                                        ['5'],
                                        '0$1',
                                        '0$CC-$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '15\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    '1523456789',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '15441234',
                                    ,
                                    ,
                                    [8]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KW: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:18|[2569]\\d\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '22345678',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:5(?:2(?:22|5[25])|88[58])|6(?:222|333|444|70[013-9]|888|93[039])|9(?:11[01]|3(?:00|33)|500))\\d{4}|(?:5(?:[05]\\d|1[0-7]|6[56])|6(?:0[034679]|5[015-9]|6\\d|7[67]|9[069])|9(?:0[09]|22|[4679]\\d|55|8[057-9]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '50012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '18\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '1801234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'KW',
                                965,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{3,4})',
                                        '$1 $2',
                                        ['[169]|2(?:[235]|4[1-35-9])|52']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['[25]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KY: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:345|[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '3452221234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '3453231234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:345976|900[2-9]\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '9002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'KY',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-9]\\d{6})$',
                                '345$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '345849\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '3458491234'
                                ],
                                ,
                                '345',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '33622\\d{5}|(?:7\\d|80)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7123456789',
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '7710009998'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567'
                                ],
                                [
                                    ,
                                    ,
                                    '809\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8091234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '808\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8081234567'
                                ],
                                [
                                    ,
                                    ,
                                    '751\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '7511234567'
                                ],
                                'KZ',
                                7,
                                '810',
                                '8',
                                ,
                                ,
                                '8',
                                ,
                                '8~10',
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '33|7',
                                [
                                    ,
                                    ,
                                    '751\\d{7}'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[13]|[35-7][14]|41|8[1468])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '21212862',
                                    ,
                                    ,
                                    [8],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:20(?:[239]\\d|5[24-9]|7[6-8])|302\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '2023123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'LA',
                                856,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['2[13]|3[14]|[4-8]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['30[013-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['[23]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '30[013-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '301234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LB: [
                                ,
                                [
                                    ,
                                    ,
                                    '[27-9]\\d{7}|[13-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '1123456'
                                ],
                                [
                                    ,
                                    ,
                                    '793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '71123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '9[01]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '90123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '80123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'LB',
                                961,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[27-9]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LC: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|758|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7584305678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7582845678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'LC',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-8]\\d{6})$',
                                '758$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '758',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LI: [
                                ,
                                [
                                    ,
                                    ,
                                    '90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2345678',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:6(?:4(?:79|[89]\\d)|5[0-4]\\d|6(?:0\\d|10|2[0-26-9]|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '660234567'
                                ],
                                [
                                    ,
                                    ,
                                    '80(?:02[28]|9\\d\\d)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '8002222',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '9002222',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'LI',
                                423,
                                '00',
                                '0',
                                ,
                                ,
                                '0|(1001)',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        ['[237-9]'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['69'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['6'],
                                        ,
                                        '$CC $1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '870(?:28|87)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '8702812',
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '697(?:42|56|[78]\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '697861234',
                                    ,
                                    ,
                                    [9]
                                ]
                            ],
                            LK: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '112345678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:[0-25-8]\\d|4[01])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '712345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'LK',
                                94,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['7'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[1-689]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '1973\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '197312345'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LR: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2\\d{3}|33333)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '21234567',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:330|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '770123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '332(?:02|[34]\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '332021234',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'LR',
                                231,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[4-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[3578]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LS: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[256]\\d\\d|800)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '22123456'
                                ],
                                [
                                    ,
                                    ,
                                    '[56]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '50123456'
                                ],
                                [
                                    ,
                                    ,
                                    '800[256]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '80021234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'LS',
                                266,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[2568]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LT: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[3469]\\d|52|[78]0)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3[1478]|4[124-6]|52)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '31234567'
                                ],
                                [
                                    ,
                                    ,
                                    '6\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '61234567'
                                ],
                                [
                                    ,
                                    ,
                                    '80[02]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345'
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:0[0239]|10)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '90012345'
                                ],
                                [
                                    ,
                                    ,
                                    '808\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80812345'
                                ],
                                [
                                    ,
                                    ,
                                    '70[05]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '70012345'
                                ],
                                [
                                    ,
                                    ,
                                    '[89]01\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80123456'
                                ],
                                'LT',
                                370,
                                '00',
                                '8',
                                ,
                                ,
                                '[08]',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['52[0-7]'],
                                        '(8-$1)',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[7-9]'],
                                        '8 $1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1 $2',
                                        ['37|4(?:[15]|6[1-8])'],
                                        '(8-$1)',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['[3-6]'],
                                        '(8-$1)',
                                        ,
                                        1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '70[67]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '70712345'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LU: [
                                ,
                                [
                                    ,
                                    ,
                                    '35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}',
                                    ,
                                    ,
                                    ,
                                    '27123456'
                                ],
                                [
                                    ,
                                    ,
                                    '6(?:[269][18]|5[158]|7[189]|81)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '628123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '90[015]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '90012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '801\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80112345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '20(?:1\\d{5}|[2-689]\\d{1,7})',
                                    ,
                                    ,
                                    ,
                                    '20201234',
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                'LU',
                                352,
                                '00',
                                ,
                                ,
                                ,
                                '(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})',
                                        '$1 $2',
                                        ['2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        ['2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['20[2-689]'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})',
                                        '$1 $2 $3 $4',
                                        ['2(?:[0367]|4[3-8])'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['80[01]|90[015]'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['20'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['6'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})',
                                        '$1 $2 $3 $4 $5',
                                        ['2(?:[0367]|4[3-8])'],
                                        ,
                                        '$CC $1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})',
                                        '$1 $2 $3 $4',
                                        ['[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]'],
                                        ,
                                        '$CC $1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LV: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[268]\\d|90)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '6\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '63123456'
                                ],
                                [
                                    ,
                                    ,
                                    '2\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '21234567'
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '80123456'
                                ],
                                [
                                    ,
                                    ,
                                    '90\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '90123456'
                                ],
                                [
                                    ,
                                    ,
                                    '81\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '81123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'LV',
                                371,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[269]|8[01]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LY: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-9]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '212345678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '9[1-6]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '912345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'LY',
                                218,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{7})',
                                        '$1-$2',
                                        ['[2-9]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[5-8]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '520123456'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|6[1267]|7[0-57]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '650123456'
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '801234567'
                                ],
                                [
                                    ,
                                    ,
                                    '89\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '891234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '592(?:4[0-2]|93)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '592401234'
                                ],
                                'MA',
                                212,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{5})(\\d{4})',
                                        '$1-$2',
                                        [
                                            '5(?:29|38)',
                                            '5(?:29|38)[89]',
                                            '5(?:29|38)[89]0'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['5[45]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{5})',
                                        '$1-$2',
                                        [
                                            '5(?:2[2-489]|3[5-9]|9)|892',
                                            '5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{7})',
                                        '$1-$2',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{6})',
                                        '$1-$2',
                                        ['[5-7]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MC: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[3489]|6\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:870|9[2-47-9]\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '99123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '612345678'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:800|90\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '90123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'MC',
                                377,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})',
                                        '$1 $2 $3',
                                        ['87']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['4'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[389]']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4 $5',
                                        ['6'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['4'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[389]']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4 $5',
                                        ['6'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '8[07]0\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MD: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[235-7]\\d|[89]0)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '22212345'
                                ],
                                [
                                    ,
                                    ,
                                    '562\\d{5}|(?:6\\d|7[16-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '62112345'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345'
                                ],
                                [
                                    ,
                                    ,
                                    '90[056]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '90012345'
                                ],
                                [
                                    ,
                                    ,
                                    '808\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80812345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '3[08]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '30123456'
                                ],
                                'MD',
                                373,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['[89]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['22|3'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[25-7]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '803\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80312345'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ME: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '30234567',
                                    ,
                                    ,
                                    [8],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '67622901',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '80(?:[0-2578]|9\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80080002'
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:4[1568]|5[178])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '94515151',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '78[1-49]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '78108780',
                                    ,
                                    ,
                                    [8]
                                ],
                                'ME',
                                382,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[2-9]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '77[1-9]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '77273012',
                                    ,
                                    ,
                                    [8]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MF: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:590|69\\d|976)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '590271234'
                                ],
                                [
                                    ,
                                    ,
                                    '69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '690001234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '976[01]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '976012345'
                                ],
                                'MF',
                                590,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[23]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '202123456',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '3[2-49]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '321234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '22\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '221234567'
                                ],
                                'MG',
                                261,
                                '00',
                                '0',
                                ,
                                ,
                                '0|([24-9]\\d{6})$',
                                '20$1',
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{3})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[23]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MH: [
                                ,
                                [
                                    ,
                                    ,
                                    '329\\d{4}|(?:[256]\\d|45)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:247|528|625)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2471234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:23|54)5|329|45[56])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2351234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '635\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6351234'
                                ],
                                'MH',
                                692,
                                '011',
                                '1',
                                ,
                                ,
                                '1',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1-$2',
                                        ['[2-6]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MK: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-578]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:[23]\\d|5[0-24578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '22012345',
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:3555|4(?:60\\d|747)|94(?:[01]\\d|2[0-4]))\\d{3}|7(?:[0-25-8]\\d|3[2-4]|42|9[23])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '72345678'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345'
                                ],
                                [
                                    ,
                                    ,
                                    '5[02-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '50012345'
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:0[1-9]|[1-9]\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'MK',
                                389,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[347]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d)(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[58]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ML: [
                                ,
                                [
                                    ,
                                    ,
                                    '[24-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '20212345'
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[239])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '65012345'
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '80012345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'ML',
                                223,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})',
                                        '$1',
                                        [
                                            '67[057-9]|74[045]',
                                            '67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[24-9]']
                                    ]
                                ],
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[24-9]']
                                    ]],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '80\\d{6}'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MM: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|46|6[25]|7[0-3]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|46|62|7[0-3]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[0-3])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|247[23]|3(?:20\\d|470)|4(?:2[04]\\d|47[23])|7(?:(?:3\\d|8[01459])\\d|4(?:39|60|7[013]))))\\d{4}|5(?:2(?:2\\d{5,6}|47[023]\\d{4})|(?:347[23]|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[0-2])|8(?:20\\d|47[02])|9(?:20\\d|47[01]))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:2\\d|4[1-9]|51)\\d|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '1234567',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ],
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '92123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '80080(?:[01][1-9]|2\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '8008001234',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '1333\\d{4}|[12]468\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '13331234',
                                    ,
                                    ,
                                    [8]
                                ],
                                'MM',
                                95,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['16|2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[12]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[4-7]|8[1-35]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4,6})',
                                        '$1 $2 $3',
                                        ['9(?:2[0-4]|[35-9]|4[137-9])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['92'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{5})(\\d{4})',
                                        '$1 $2 $3',
                                        ['9'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MN: [
                                ,
                                [
                                    ,
                                    ,
                                    '[12]\\d{7,9}|[57-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '53123456',
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:83[01]|920)\\d{5}|(?:5[05]|8[05689]|9[013-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '88123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '712[0-79]\\d{4}|7(?:1[013-9]|[5-8]\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '75123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                'MN',
                                976,
                                '001',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[12]1'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[57-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5,6})',
                                        '$1 $2',
                                        ['[12]2[1-3]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{5,6})',
                                        '$1 $2',
                                        [
                                            '[12](?:27|3[2-8]|4[2-68]|5[1-4689])',
                                            '[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{4,5})',
                                        '$1 $2',
                                        ['[12]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MO: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:28|[68]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '28212345'
                                ],
                                [
                                    ,
                                    ,
                                    '6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '66123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'MO',
                                853,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[268]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MP: [
                                ,
                                [
                                    ,
                                    ,
                                    '[58]\\d{9}|(?:67|90)0\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6702345678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6702345678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'MP',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-9]\\d{6})$',
                                '670$1',
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '670',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MQ: [
                                ,
                                [
                                    ,
                                    ,
                                    '69\\d{7}|(?:59|97)6\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '596(?:0[0-8]|10|2[7-9]|3[04-9]|[4-7]\\d|8[09]|9[4-9])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '596301234'
                                ],
                                [
                                    ,
                                    ,
                                    '69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '696201234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '976(?:6\\d|7[0-367])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '976612345'
                                ],
                                'MQ',
                                596,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[569]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MR: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[2-4]\\d\\d|800)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:25[08]|35\\d|45[1-7])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '35123456'
                                ],
                                [
                                    ,
                                    ,
                                    '[2-4][0-46-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '22123456'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'MR',
                                222,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[2-48]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MS: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|664|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '6644(?:1[0-3]|91)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6644912345',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '664(?:3(?:49|9[1-6])|49[2-6])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6644923456',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'MS',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([34]\\d{6})$',
                                '664$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '664',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MT: [
                                ,
                                [
                                    ,
                                    ,
                                    '3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:0(?:[19]\\d|3[1-4]|6[059])|[1-357]\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '21001234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '96961234'
                                ],
                                [
                                    ,
                                    ,
                                    '800[3467]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '80071234'
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '50037123'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '3550\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '35501234'
                                ],
                                'MT',
                                356,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[2357-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    '7117\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '71171234'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '501\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '50112345'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MU: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[2-468]|5\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '54480123'
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|5(?:2[5-9]|4[3-589]|[57]\\d|8[0-689]|9[0-8])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '52512345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '80[0-2]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8001234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '30\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '3012345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '3(?:20|9\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '3201234',
                                    ,
                                    ,
                                    [7]
                                ],
                                'MU',
                                230,
                                '0(?:0|[24-7]0|3[03])',
                                ,
                                ,
                                ,
                                ,
                                ,
                                '020',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[2-46]|8[013]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['5']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MV: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024-68]|8[024689]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6701234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '46[46]\\d{4}|(?:7\\d|9[13-9])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7712345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '900\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'MV',
                                960,
                                '0(?:0|19)',
                                ,
                                ,
                                ,
                                ,
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1-$2',
                                        ['[3467]|9[13-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[89]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '4[05]0\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '4001234',
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MW: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1[2-9]|21\\d\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '1234567'
                                ],
                                [
                                    ,
                                    ,
                                    '111\\d{6}|(?:31|77|88|99)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '991234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'MW',
                                265,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['1[2-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[137-9]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MX: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '2001234567',
                                    ,
                                    ,
                                    [10],
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '12221234567',
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|88)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '900\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '300\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '3001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '500\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '5001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'MX',
                                52,
                                '0[09]',
                                '01',
                                ,
                                ,
                                '0(?:[12]|4[45])|1',
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{5})',
                                        '$1',
                                        ['53']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['33|5[56]|81'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2-9]'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{4})(\\d{4})',
                                        '$2 $3 $4',
                                        ['1(?:33|5[56]|81)'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})(\\d{4})',
                                        '$2 $3 $4',
                                        ['1'],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['33|5[56]|81'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2-9]'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{4})(\\d{4})',
                                        '$2 $3 $4',
                                        ['1(?:33|5[56]|81)'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})(\\d{4})',
                                        '$2 $3 $4',
                                        ['1'],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MY: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{8,9}|(?:3\\d|[4-9])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '323856789',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0134]\\d|2[1-9]|5[0-6]))|(?:(?:[269]|59)\\d|[37][1-9]|4[235-9])\\d|8(?:1[23]|[236]\\d|4[06]|5[7-9]|7[016-9]|8[01]|9[0-8]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '123456789',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1[378]00\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1300123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '1600\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1600123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '1546012345',
                                    ,
                                    ,
                                    [10]
                                ],
                                'MY',
                                60,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1-$2 $3',
                                        ['[4-79]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1-$2 $3',
                                        ['1(?:[02469]|[378][1-9])|8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1-$2 $3',
                                        ['3'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{2})(\\d{4})',
                                        '$1-$2-$3-$4',
                                        ['1[36-8]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1-$2 $3',
                                        ['15'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1-$2 $3',
                                        ['1'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:2|8\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '21123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '8[2-79]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '821234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'MZ',
                                258,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['2|8[2-79]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['8']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[68]\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '61221234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:60|8[1245])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '811234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '8701\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '870123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:3\\d\\d|86)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '88612345'
                                ],
                                'NA',
                                264,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['88'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['6'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['87'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['8'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NC: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-57-9]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '201234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:5[0-4]|[79]\\d|8[0-79])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '751234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '36\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '366711'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'NC',
                                687,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})',
                                        '$1',
                                        ['5[6-8]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})',
                                        '$1.$2.$3',
                                        ['[2-57-9]']
                                    ]
                                ],
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})',
                                        '$1.$2.$3',
                                        ['[2-57-9]']
                                    ]],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[027-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '20201234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:23|7[04]|[89]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '93123456'
                                ],
                                [
                                    ,
                                    ,
                                    '08\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '08123456'
                                ],
                                [
                                    ,
                                    ,
                                    '09\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '09123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'NE',
                                227,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['08']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[089]|2[013]|7[04]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NF: [
                                ,
                                [
                                    ,
                                    ,
                                    '[13]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [6],
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '106609',
                                    ,
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:14|3[58])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '381234',
                                    ,
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'NF',
                                672,
                                '00',
                                ,
                                ,
                                ,
                                '([0-258]\\d{4})$',
                                '3$1',
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})',
                                        '$1 $2',
                                        ['1[0-3]']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{5})',
                                        '$1 $2',
                                        ['[13]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NG: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '18040123',
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:702[0-24-9]|8(?:01|19)[01])\\d{6}|(?:70[13-689]|8(?:0[2-9]|1[0-8])|9(?:0[1-9]|1[235]))\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8021234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7,11}',
                                    ,
                                    ,
                                    ,
                                    '80017591759',
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'NG',
                                234,
                                '009',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['78'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[12]|9(?:0[3-9]|[1-9])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2,3})',
                                        '$1 $2 $3',
                                        ['[3-7]|8[2-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[7-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4,5})',
                                        '$1 $2 $3',
                                        ['[78]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})(\\d{5,6})',
                                        '$1 $2 $3',
                                        ['[78]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '700\\d{7,11}',
                                    ,
                                    ,
                                    ,
                                    '7001234567',
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NI: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1800|[25-8]\\d{3})\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '21234567'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '81234567'
                                ],
                                [
                                    ,
                                    ,
                                    '1800\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '18001234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'NI',
                                505,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[125-8]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NL: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '101234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '6[1-58]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '612345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{4,7}',
                                    ,
                                    ,
                                    ,
                                    '8001234',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '90[069]\\d{4,7}',
                                    ,
                                    ,
                                    ,
                                    '9061234',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:85|91)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '851234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                'NL',
                                31,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})',
                                        '$1',
                                        ['1[238]|[34]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})',
                                        '$1 $2',
                                        ['14']
                                    ],
                                    [
                                        ,
                                        '(\\d{6})',
                                        '$1',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4,7})',
                                        '$1 $2',
                                        ['[89]0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{7})',
                                        '$1 $2',
                                        ['66'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{8})',
                                        '$1 $2',
                                        ['6'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['1[16-8]|2[259]|3[124]|4[17-9]|5[124679]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[1-57-9]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4,7})',
                                        '$1 $2',
                                        ['[89]0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{7})',
                                        '$1 $2',
                                        ['66'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{8})',
                                        '$1 $2',
                                        ['6'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['1[16-8]|2[259]|3[124]|4[17-9]|5[124679]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[1-57-9]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '66\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '662345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d',
                                    ,
                                    ,
                                    ,
                                    '14020',
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NO: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:0|[2-9]\\d{3})\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '21234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4[015-8]|59|9\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '40612345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '80[01]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '82[09]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '82012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '810(?:0[0-6]|[2-8]\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '81021234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '880\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '88012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '85[0-5]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '85012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                'NO',
                                47,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[489]|59']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[235-7]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                1,
                                '[02-689]|7[0-8]',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '02000'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '81[23]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '81212345',
                                    ,
                                    ,
                                    [8]
                                ]
                            ],
                            NP: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1\\d|9)\\d{9}|[1-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '14567890',
                                    ,
                                    ,
                                    [8],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9841234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:66001|800\\d\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '16600101234',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'NP',
                                977,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{7})',
                                        '$1-$2',
                                        ['1[2-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1-$2',
                                        ['1[01]|[2-8]|9(?:[1-579]|6[2-6])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{7})',
                                        '$1-$2',
                                        ['9']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2})(\\d{5})',
                                        '$1-$2-$3',
                                        ['1']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{7})',
                                        '$1-$2',
                                        ['1[2-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1-$2',
                                        ['1[01]|[2-8]|9(?:[1-579]|6[2-6])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{7})',
                                        '$1-$2',
                                        ['9']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NR: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:444|(?:55|8\\d)\\d|666)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '444\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '4441234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:55[3-9]|666|8\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '5551234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'NR',
                                674,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[4-68]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NU: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[47]|888\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[47]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '7012',
                                    ,
                                    ,
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    '888[4-9]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '8884012',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'NU',
                                683,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['8']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '32345678',
                                    ,
                                    ,
                                    [8],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '2[0-27-9]\\d{7,8}|21\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '211234567',
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '508\\d{6,7}|80\\d{6,8}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:11\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}',
                                    ,
                                    ,
                                    ,
                                    '900123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '70\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '701234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'NZ',
                                64,
                                '0(?:0|161)',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,8})',
                                        '$1 $2',
                                        ['8[1-579]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2,3})',
                                        '$1 $2 $3',
                                        [
                                            '50[036-8]|[89]0',
                                            '50(?:[0367]|88)|[89]0'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1-$2 $3',
                                        ['24|[346]|7[2-57-9]|9[2-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['2(?:10|74)|[59]|80'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1|2[028]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,5})',
                                        '$1 $2 $3',
                                        ['2(?:[169]|7[0-35-9])|7|86'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '[28]6\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '26123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:1[6-9]|22|3\\d|4[045]|5[459]|7[0-3579]|90)\\d{2,7}',
                                    ,
                                    ,
                                    ,
                                    '83012378'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            OM: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2[2-6]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '23123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1505|90[1-9]\\d)\\d{4}|(?:7[1289]|9[1-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '92123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '8007\\d{4,5}|(?:500|800[05])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '80071234'
                                ],
                                [
                                    ,
                                    ,
                                    '900\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '90012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'OM',
                                968,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4,6})',
                                        '$1 $2',
                                        ['[58]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1 $2',
                                        ['2']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[179]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PA: [
                                ,
                                [
                                    ,
                                    ,
                                    '8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[258]|9[139])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[026-9])|3(?:[089]\\d|1[014-7]|2[0-5]|33|4[0-79]|55|6[068]|7[03-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[6-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2001234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1[16]1|21[89]|6(?:[02-9]\\d|1[0-7])\\d|8(?:1[01]|7[23]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '61234567',
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{4}(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    '8001234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8601234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'PA',
                                507,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1-$2',
                                        ['[1-57-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1-$2',
                                        ['[68]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['8']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PE: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[14-8]|9\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '11234567',
                                    ,
                                    ,
                                    [8],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '9\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '912345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '805\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80512345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '801\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80112345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '80[24]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80212345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'PE',
                                51,
                                '19(?:1[124]|77|90)00',
                                '0',
                                ' Anexo ',
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['80'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{7})',
                                        '$1 $2',
                                        ['1'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1 $2',
                                        ['[4-8]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['9']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PF: [
                                ,
                                [
                                    ,
                                    ,
                                    '[48]\\d{7}|4\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '4(?:0[4-689]|9[4-68])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '40412345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '8[7-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '87123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '499\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '49901234',
                                    ,
                                    ,
                                    [8]
                                ],
                                'PF',
                                689,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        ['44']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[48]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '44\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '44\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '440123',
                                    ,
                                    ,
                                    [6]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PG: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:64[1-9]|7730|85[02-46-9])\\d{4}|(?:3[0-2]|4[257]|5[34]|77[0-24]|9[78])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '3123456'
                                ],
                                [
                                    ,
                                    ,
                                    '77(?:3[1-9]|[5-9]\\d)\\d{4}|(?:7[0-689]|8[18])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '70123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '180\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '1801234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:0[0-47]|7[568])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2751234',
                                    ,
                                    ,
                                    [7]
                                ],
                                'PG',
                                675,
                                '00|140[1-3]',
                                ,
                                ,
                                ,
                                ,
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['18|[2-69]|85']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[78]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '27[01]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2700123',
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PH: [
                                ,
                                [
                                    ,
                                    ,
                                    '1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|2\\d{5}(?:\\d{2})?|8[2-8]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '21234567',
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:81[37]|9(?:0[5-9]|1[0-24-9]|2[0-35-9]|[35]\\d|4[235-9]|6[0-35-8]|7[1-9]|8[189]|9[4-9]))\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9051234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '1800\\d{7,9}',
                                    ,
                                    ,
                                    ,
                                    '180012345678',
                                    ,
                                    ,
                                    [
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'PH',
                                63,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{5})',
                                        '$1 $2',
                                        ['2'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4,6})',
                                        '$1 $2',
                                        [
                                            '3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2',
                                            '3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))'
                                        ],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{4})',
                                        '$1 $2',
                                        [
                                            '346|4(?:27|9[35])|883',
                                            '3469|4(?:279|9(?:30|56))|8834'
                                        ],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[3-7]|8[2-8]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[89]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3 $4',
                                        ['1']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PK: [
                                ,
                                [
                                    ,
                                    ,
                                    '122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '2123456789',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '3012345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}(?:\\d{3})?',
                                    ,
                                    ,
                                    ,
                                    '80012345',
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '900\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '90012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '122\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '122044444',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'PK',
                                92,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2,7})',
                                        '$1 $2 $3',
                                        ['[89]0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{5})',
                                        '$1 $2',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{6,7})',
                                        '$1 $2',
                                        [
                                            '2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])',
                                            '9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]'
                                        ],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{7,8})',
                                        '$1 $2',
                                        ['(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{5})',
                                        '$1 $2',
                                        ['58'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{7})',
                                        '$1 $2',
                                        ['3'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['[24-9]'],
                                        '(0$1)'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '21111825888',
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PL: [
                                ,
                                [
                                    ,
                                    ,
                                    '6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))',
                                    ,
                                    ,
                                    ,
                                    '123456789',
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '512345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '70[01346-8]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '701234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '801\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '801234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '39\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '391234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                'PL',
                                48,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{5})',
                                        '$1',
                                        ['19']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})',
                                        '$1 $2',
                                        ['11|64']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{3})',
                                        '$1 $2 $3',
                                        [
                                            '(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1',
                                            '(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2,3})',
                                        '$1 $2 $3',
                                        ['64']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['1[2-8]|[2-7]|8[1-79]|9[145]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['8']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '64\\d{4,7}',
                                    ,
                                    ,
                                    ,
                                    '641234567',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '804\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '804123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[45]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4[1-3]|50)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '430123'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4[02-4]|5[05])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '551234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'PM',
                                508,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        ['[45]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PR: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[589]\\d\\d|787)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:787|939)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '7872345678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:787|939)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '7872345678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'PR',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1',
                                ,
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '787|939',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PS: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2489]2\\d{6}|(?:1\\d|5)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '22234567',
                                    ,
                                    ,
                                    [8],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '5[69]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '599123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '1800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1800123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '1700\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1700123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'PS',
                                970,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[2489]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['5'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['1']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PT: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[26-9]\\d|30)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '212345678'
                                ],
                                [
                                    ,
                                    ,
                                    '6[356]9230\\d{3}|(?:6[036]93|9(?:[1-36]\\d\\d|480))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '912345678'
                                ],
                                [
                                    ,
                                    ,
                                    '80[02]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '760123456'
                                ],
                                [
                                    ,
                                    ,
                                    '80(?:8\\d|9[1579])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '808123456'
                                ],
                                [
                                    ,
                                    ,
                                    '884[0-4689]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '884123456'
                                ],
                                [
                                    ,
                                    ,
                                    '30\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '301234567'
                                ],
                                'PT',
                                351,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['2[12]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[236-9]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '70(?:7\\d|8[17])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '707123456'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '600\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '600110000'
                                ]
                            ],
                            PW: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[24-8]\\d\\d|345|900)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2771234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:46[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '6201234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'PW',
                                680,
                                '01[12]',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[2-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PY: [
                                ,
                                [
                                    ,
                                    ,
                                    '59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '212345678',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '961456789',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '9800\\d{5,7}',
                                    ,
                                    ,
                                    ,
                                    '98000123456',
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '8700[0-4]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '870012345',
                                    ,
                                    ,
                                    [9]
                                ],
                                'PY',
                                595,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,6})',
                                        '$1 $2',
                                        ['[2-9]0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})',
                                        '$1 $2',
                                        ['[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4,5})',
                                        '$1 $2',
                                        ['2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]'],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['87']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{6})',
                                        '$1 $2',
                                        ['9(?:[5-79]|8[1-6])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[2-8]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['9']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '[2-9]0\\d{4,7}',
                                    ,
                                    ,
                                    ,
                                    '201234567',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            QA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:23|4[04])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '44123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:28|[35-7]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '33123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8001234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'QA',
                                974,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['2[126]|8']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[2-7]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '2(?:[12]\\d|61)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2123456',
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            RE: [
                                ,
                                [
                                    ,
                                    ,
                                    '9769\\d{5}|(?:26|[68]\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '26(?:2\\d\\d|30[0-5])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '262161234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-36]|7[0-27]|8[0-8]|9[0-479]))|9769\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '692123456'
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '801234567'
                                ],
                                [
                                    ,
                                    ,
                                    '89[1-37-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '891123456'
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:1[019]|2[0156]|84|90)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '810123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'RE',
                                262,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[2689]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                1,
                                '26[23]|69|[89]',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            RO: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '211234567'
                                ],
                                [
                                    ,
                                    ,
                                    '7[01]20\\d{5}|7(?:0[013-9]|1[01]|[2-7]\\d|8[03-8]|9[09])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '712034567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '90[0136]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '900123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '801\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '801123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'RO',
                                40,
                                '00',
                                '0',
                                ' int ',
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})',
                                        '$1 $2',
                                        [
                                            '2[3-6]',
                                            '2[3-6]\\d9'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})',
                                        '$1 $2',
                                        ['219|31'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[23]1'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[237-9]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:37\\d|80[578])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '372123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            RS: [
                                ,
                                [
                                    ,
                                    ,
                                    '38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}',
                                    ,
                                    ,
                                    ,
                                    '10234567',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '6(?:[0-689]|7\\d)\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '601234567',
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{3,9}',
                                    ,
                                    ,
                                    ,
                                    '80012345'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:78\\d|90[0169])\\d{3,7}',
                                    ,
                                    ,
                                    ,
                                    '90012345',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'RS',
                                381,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,9})',
                                        '$1 $2',
                                        ['(?:2[389]|39)0|[7-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5,10})',
                                        '$1 $2',
                                        ['[1-36]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '7[06]\\d{4,10}',
                                    ,
                                    ,
                                    ,
                                    '700123456'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            RU: [
                                ,
                                [
                                    ,
                                    ,
                                    '[347-9]\\d{9}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '3011234567',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '9\\d{9}',
                                    ,
                                    ,
                                    ,
                                    '9123456789'
                                ],
                                [
                                    ,
                                    ,
                                    '80[04]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567'
                                ],
                                [
                                    ,
                                    ,
                                    '80[39]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8091234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '808\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8081234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'RU',
                                7,
                                '810',
                                '8',
                                ,
                                ,
                                '8',
                                ,
                                '8~10',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})',
                                        '$1-$2-$3',
                                        ['[0-79]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        [
                                            '7(?:1[0-8]|2[1-9])',
                                            '7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))',
                                            '7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2'
                                        ],
                                        '8 ($1)',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d)(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        [
                                            '7(?:1[0-68]|2[1-9])',
                                            '7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))',
                                            '7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]'
                                        ],
                                        '8 ($1)',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['7'],
                                        '8 ($1)',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2-$3-$4',
                                        ['[3489]'],
                                        '8 ($1)',
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        [
                                            '7(?:1[0-8]|2[1-9])',
                                            '7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))',
                                            '7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2'
                                        ],
                                        '8 ($1)',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d)(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        [
                                            '7(?:1[0-68]|2[1-9])',
                                            '7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))',
                                            '7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]'
                                        ],
                                        '8 ($1)',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['7'],
                                        '8 ($1)',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2-$3-$4',
                                        ['[3489]'],
                                        '8 ($1)',
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                1,
                                '3[04-689]|[489]',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            RW: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:06|[27]\\d\\d|[89]00)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:06|2[23568]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '250123456'
                                ],
                                [
                                    ,
                                    ,
                                    '7[238]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '720123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '900\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '900123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'RW',
                                250,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['0']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[7-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['2']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SA: [
                                ,
                                [
                                    ,
                                    ,
                                    '92\\d{7}|(?:[15]|8\\d)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '112345678',
                                    ,
                                    ,
                                    [9],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '579[01]\\d{5}|5(?:[013-689]\\d|7[0-36-8])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '512345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '925\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '925012345',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '920\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '920012345',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'SA',
                                966,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{5})',
                                        '$1 $2',
                                        ['9']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['5'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['81'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['8']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '811\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8110123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SB: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[1-6]|[7-9]\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '40123',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7421234'
                                ],
                                [
                                    ,
                                    ,
                                    '1[38]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '18123',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '5[12]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '51123',
                                    ,
                                    ,
                                    [5]
                                ],
                                'SB',
                                677,
                                '0[01]',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{5})',
                                        '$1 $2',
                                        ['7|8[4-9]|9(?:[1-8]|9[0-8])']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SC: [
                                ,
                                [
                                    ,
                                    ,
                                    '8000\\d{3}|(?:[249]\\d|64)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '4[2-46]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '4217123'
                                ],
                                [
                                    ,
                                    ,
                                    '2[5-8]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '2510123'
                                ],
                                [
                                    ,
                                    ,
                                    '8000\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '8000000'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '971\\d{4}|(?:64|95)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '6412345'
                                ],
                                'SC',
                                248,
                                '010|0[0-2]',
                                ,
                                ,
                                ,
                                ,
                                ,
                                '00',
                                ,
                                [[
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[246]|9[57]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SD: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:5\\d|8[35-7])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '153123456'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1[0-2]|9[0-3569])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '911231234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'SD',
                                249,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[19]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SE: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '8123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '7[02369]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '701234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '20\\d{4,7}',
                                    ,
                                    ,
                                    ,
                                    '20123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}',
                                    ,
                                    ,
                                    ,
                                    '9001234567',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '77[0-7]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '771234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '75[1-8]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '751234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'SE',
                                46,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2,3})(\\d{2})',
                                        '$1-$2 $3',
                                        ['20'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1-$2',
                                        ['9(?:00|39|44)'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})',
                                        '$1-$2 $3',
                                        ['[12][136]|3[356]|4[0246]|6[03]|90[1-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2,3})(\\d{2})(\\d{2})',
                                        '$1-$2 $3 $4',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2,3})(\\d{2})',
                                        '$1-$2 $3',
                                        ['1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2,3})(\\d{3})',
                                        '$1-$2 $3',
                                        ['9(?:00|39|44)'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})',
                                        '$1-$2 $3 $4',
                                        ['1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1-$2 $3 $4',
                                        ['10|7'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})(\\d{2})',
                                        '$1-$2 $3 $4',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1-$2 $3 $4',
                                        ['[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{3})',
                                        '$1-$2 $3 $4',
                                        ['9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1-$2 $3 $4 $5',
                                        ['[26]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2,3})(\\d{2})',
                                        '$1 $2 $3',
                                        ['20']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['9(?:00|39|44)']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})',
                                        '$1 $2 $3',
                                        ['[12][136]|3[356]|4[0246]|6[03]|90[1-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{2,3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['8']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2,3})(\\d{2})',
                                        '$1 $2 $3',
                                        ['1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2,3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['9(?:00|39|44)']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['10|7']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['8']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['9']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4 $5',
                                        ['[26]']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '74[02-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '740123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '10[1-8]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '102345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '(?:25[245]|67[3-68])\\d{9}',
                                    ,
                                    ,
                                    ,
                                    '254123456789',
                                    ,
                                    ,
                                    [12]
                                ]
                            ],
                            SG: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '662[0-24-9]\\d{4}|6(?:[1-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '61234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:8(?:0(?:1\\d|2[014-9]|3[0-7])|[1-8]\\d\\d|9(?:[0-4]\\d|5[0-2]))|9[0-8]\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '81234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:18|8)00\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '18001234567',
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1900\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '19001234567',
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3[12]\\d|666)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '31234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                'SG',
                                65,
                                '0[0-3]\\d',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4,5})',
                                        '$1',
                                        [
                                            '1[013-9]|77',
                                            '1(?:[013-8]|9(?:0[1-9]|[1-9]))|77'
                                        ]
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[369]|8(?:0[1-3]|[1-9])']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['8']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})(\\d{3})',
                                        '$1 $2 $3',
                                        ['7']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[369]|8(?:0[1-3]|[1-9])']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['8']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})(\\d{3})',
                                        '$1 $2 $3',
                                        ['7']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '7000\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '70001234567',
                                    ,
                                    ,
                                    [11]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SH: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[256]\\d|8)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:[0-57-9]\\d|6[4-9])\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '22158'
                                ],
                                [
                                    ,
                                    ,
                                    '[56]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '51234',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '262\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '26212',
                                    ,
                                    ,
                                    [5]
                                ],
                                'SH',
                                290,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                1,
                                '[256]',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[1-357][2-8]|4[24-8])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '12345678',
                                    ,
                                    ,
                                    [8],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '31234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{4,6}',
                                    ,
                                    ,
                                    ,
                                    '80123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '89[1-3]\\d{2,5}|90\\d{4,6}',
                                    ,
                                    ,
                                    ,
                                    '90123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-489])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '59012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                'SI',
                                386,
                                '00|10(?:22|66|88|99)',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,6})',
                                        '$1 $2',
                                        ['8[09]|9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['59|8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[37][01]|4[0139]|51|6'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[1-57]'],
                                        '(0$1)'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SJ: [
                                ,
                                [
                                    ,
                                    ,
                                    '0\\d{4}|(?:[489]\\d|[57]9)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '79\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '79123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4[015-8]|59|9\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '41234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '80[01]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '82[09]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '82012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '810(?:0[0-6]|[2-8]\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '81021234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '880\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '88012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '85[0-5]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '85012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                'SJ',
                                47,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '79',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '02000'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '81[23]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '81212345',
                                    ,
                                    ,
                                    [8]
                                ]
                            ],
                            SK: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '221234567'
                                ],
                                [
                                    ,
                                    ,
                                    '909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '912123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:00|[78]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '900123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '8[5-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '850123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '6(?:02|5[0-4]|9[0-6])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '690123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                'SK',
                                421,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['21'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2,3})',
                                        '$1 $2 $3',
                                        [
                                            '[3-5][1-8]1',
                                            '[3-5][1-8]1[67]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})',
                                        '$1 $2',
                                        [
                                            '909',
                                            '9090'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})(\\d{2})',
                                        '$1/$2 $3 $4',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[689]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1/$2 $3 $4',
                                        ['[3-5]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{2})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['21'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2,3})',
                                        '$1 $2 $3',
                                        [
                                            '[3-5][1-8]1',
                                            '[3-5][1-8]1[67]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3})(\\d{2})',
                                        '$1/$2 $3 $4',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[689]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1/$2 $3 $4',
                                        ['[3-5]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '9090\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '9090123',
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '96\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '961234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SL: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[2378]\\d|66|99)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '22[2-4][2-9]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '22221234',
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:25|3[0-5]|66|7[3-9]|8[08]|99)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '25123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'SL',
                                232,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1 $2',
                                        ['[236-9]'],
                                        '(0$1)'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SM: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:0549|[5-7]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '0549(?:8[0157-9]|9\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '0549886377',
                                    ,
                                    ,
                                    [10],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '6[16]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '66661212',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '7[178]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '71123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '5[158]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '58001110',
                                    ,
                                    ,
                                    [8]
                                ],
                                'SM',
                                378,
                                '00',
                                ,
                                ,
                                ,
                                '([89]\\d{5})$',
                                '0549$1',
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{6})',
                                        '$1',
                                        ['[89]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[5-7]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{6})',
                                        '$1 $2',
                                        ['0']
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[5-7]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{6})',
                                        '$1 $2',
                                        ['0']
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SN: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[378]\\d{4}|93330)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '301012345'
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:[06-8]\\d|21|5[4-7]|90)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '701234567'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    '88[4689]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '884123456'
                                ],
                                [
                                    ,
                                    ,
                                    '81[02468]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '810123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '93330\\d{4}|3(?:392|9[01]\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '933301234'
                                ],
                                'SN',
                                221,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['8']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[379]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SO: [
                                ,
                                [
                                    ,
                                    ,
                                    '[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '4012345',
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '28\\d{5}|(?:6[1-9]|79)\\d{6,7}|(?:15|24|(?:3[59]|4[89]|8[08])\\d|60|7[1-8]|9(?:0\\d|[2-9]))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '71123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'SO',
                                252,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})',
                                        '$1 $2',
                                        ['8[125]']
                                    ],
                                    [
                                        ,
                                        '(\\d{6})',
                                        '$1',
                                        ['[134]']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{6})',
                                        '$1 $2',
                                        ['[15]|2[0-79]|3[0-46-8]|4[0-7]']
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{7})',
                                        '$1 $2',
                                        ['24|[67]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[3478]|64|90']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5,7})',
                                        '$1 $2',
                                        ['1|28|6[1-35-9]|9[2-9]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SR: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[2-5]|68|[78]\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '211234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:7[124-7]|8[124-9])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7412345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '56\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '561234',
                                    ,
                                    ,
                                    [6]
                                ],
                                'SR',
                                597,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})',
                                        '$1-$2-$3',
                                        ['56']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})',
                                        '$1-$2',
                                        ['[2-5]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1-$2',
                                        ['[6-8]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SS: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '1[89]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '181234567'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:12|9[12579])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '977123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'SS',
                                211,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[19]'],
                                        '0$1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ST: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:22|9\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '22\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '2221234'
                                ],
                                [
                                    ,
                                    ,
                                    '900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '9812345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'ST',
                                239,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[29]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SV: [
                                ,
                                [
                                    ,
                                    ,
                                    '[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '21234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '70123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{4}(?:\\d{4})?',
                                    ,
                                    ,
                                    ,
                                    '8001234',
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '900\\d{4}(?:\\d{4})?',
                                    ,
                                    ,
                                    ,
                                    '9001234',
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'SV',
                                503,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[89]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[267]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[89]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SX: [
                                ,
                                [
                                    ,
                                    ,
                                    '7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '7215(?:4[2-8]|8[239]|9[056])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7215425678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7215205678',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'SX',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|(5\\d{6})$',
                                '721$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '721',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SY: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-39]\\d{8}|[1-5]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '112345678',
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:22|[3-589]\\d|6[02-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '944567890',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'SY',
                                963,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[1-5]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['9'],
                                        '0$1',
                                        ,
                                        1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '0800\\d{4}|(?:[237]\\d|900)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[23][2-5]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '22171234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '7[6-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '76123456',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '0800\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '08001234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '900\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '900012345',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '70\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '70012345',
                                    ,
                                    ,
                                    [8]
                                ],
                                'SZ',
                                268,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[0237]']
                                    ],
                                    [
                                        ,
                                        '(\\d{5})(\\d{4})',
                                        '$1 $2',
                                        ['9']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0800\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TA: [
                                ,
                                [
                                    ,
                                    ,
                                    '8\\d{3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    '8\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '8999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TA',
                                290,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '8',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TC: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|649|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '649(?:266|712|9(?:4\\d|50))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6497121234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6492311234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '649(?:71[01]|966)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '6497101234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                'TC',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-479]\\d{6})$',
                                '649$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '649',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TD: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:22|[69]\\d|77)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '22(?:[37-9]0|5[0-5]|6[89])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '22501234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:6[023568]|77|9\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '63012345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TD',
                                235,
                                '00|16',
                                ,
                                ,
                                ,
                                ,
                                ,
                                '00',
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[2679]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[279]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '22212345'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:7[09]|9[0-36-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '90112345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TG',
                                228,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[279]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TH: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '21234567',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '671[0-3]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '812345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '1800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1800123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '1900\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1900123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '6[08]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '601234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                'TH',
                                66,
                                '00[1-9]',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[13-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['1']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TJ: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[02]0|11|[3-57-9]\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [
                                        3,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '372123456',
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '41[18]\\d{6}|(?:[02-4]0|11|5[05]|7[07]|8[08]|9\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '917123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TJ',
                                992,
                                '810',
                                '8',
                                ,
                                ,
                                '8',
                                ,
                                '8~10',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{6})(\\d)(\\d{2})',
                                        '$1 $2 $3',
                                        [
                                            '331',
                                            '3317'
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[34]7|91[78]'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d)(\\d{4})',
                                        '$1 $2 $3',
                                        ['3[1-5]'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[02-57-9]|11'],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TK: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-47]\\d{3,6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[2-4]|[34]\\d)\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    '3101'
                                ],
                                [
                                    ,
                                    ,
                                    '7[2-4]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    '7290'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TK',
                                690,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TL: [
                                ,
                                [
                                    ,
                                    ,
                                    '7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[1-5]|3[1-9]|4[1-4])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '2112345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '7[2-8]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '77212345',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '8012345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '90\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '9012345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '70\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7012345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TL',
                                670,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[2-489]|70']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['7']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-6]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '12345678'
                                ],
                                [
                                    ,
                                    ,
                                    '6\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '66123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TM',
                                993,
                                '810',
                                '8',
                                ,
                                ,
                                '8',
                                ,
                                '8~10',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2-$3-$4',
                                        ['12'],
                                        '(8 $1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d)(\\d{2})(\\d{2})',
                                        '$1 $2-$3-$4',
                                        ['[1-5]'],
                                        '(8 $1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1 $2',
                                        ['6'],
                                        '8 $1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TN: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-57-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '30010123'
                                ],
                                [
                                    ,
                                    ,
                                    '3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '20123456'
                                ],
                                [
                                    ,
                                    ,
                                    '8010\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '80101234'
                                ],
                                [
                                    ,
                                    ,
                                    '88\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '88123456'
                                ],
                                [
                                    ,
                                    ,
                                    '8[12]10\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '81101234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TN',
                                216,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[2-57-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TO: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '20123',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7715123',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '0800\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '0800222',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '55[04]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '5501234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TO',
                                676,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})',
                                        '$1-$2',
                                        ['[2-4]|50|6[09]|7[0-24-69]|8[05]']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3})',
                                        '$1 $2',
                                        ['0']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[5-9]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TR: [
                                ,
                                [
                                    ,
                                    ,
                                    '4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '2123456789',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '5012345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})',
                                    ,
                                    ,
                                    ,
                                    '8001234567',
                                    ,
                                    ,
                                    [
                                        10,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:8[89]8|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9001234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '592(?:21[12]|461)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '5922121234',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '850\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8500123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                'TR',
                                90,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d)(\\d{3})',
                                        '$1 $2 $3',
                                        ['444'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['512|8[01589]|90'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        [
                                            '5(?:[0-59]|61)',
                                            '5(?:[0-59]|616)',
                                            '5(?:[0-59]|6161)'
                                        ],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[24][1-8]|3[1-9]'],
                                        '(0$1)',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{6,7})',
                                        '$1 $2 $3',
                                        ['80'],
                                        '0$1',
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['512|8[01589]|90'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        [
                                            '5(?:[0-59]|61)',
                                            '5(?:[0-59]|616)',
                                            '5(?:[0-59]|6161)'
                                        ],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[24][1-8]|3[1-9]'],
                                        '(0$1)',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{6,7})',
                                        '$1 $2 $3',
                                        ['80'],
                                        '0$1',
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '512\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '5123456789',
                                    ,
                                    ,
                                    [10]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '(?:444|811\\d{3})\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '444\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '4441444',
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TT: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '868(?:2(?:0[13]|1[89]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8682211234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8682911234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TT',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-46-8]\\d{6})$',
                                '868$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '868',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '868619\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8686191234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ]
                            ],
                            TV: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:2|7\\d\\d|90)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2[02-9]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '20123',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:7[01]\\d|90)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '901234',
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'TV',
                                688,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})',
                                        '$1 $2',
                                        ['2']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})',
                                        '$1 $2',
                                        ['90']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})',
                                        '$1 $2',
                                        ['7']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TW: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '221234567',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:40001[0-2]|9[0-8]\\d{4})\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '912345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '80[0-79]\\d{6}|800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '20(?:[013-9]\\d\\d|2)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '203123456',
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '99\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '990123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '7012345678',
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                'TW',
                                886,
                                '0(?:0[25-79]|19)',
                                '0',
                                '#',
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d)(\\d{4})',
                                        '$1 $2 $3',
                                        ['202'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[258]0'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3,4})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]',
                                            '[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[49]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4,5})',
                                        '$1 $2 $3',
                                        ['7'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '50[0-46-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '500123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[26-8]\\d|41|90)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '2[2-8]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '222345678'
                                ],
                                [
                                    ,
                                    ,
                                    '77[2-9]\\d{6}|(?:6[1-9]|7[1-689])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '621234567'
                                ],
                                [
                                    ,
                                    ,
                                    '80[08]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    '90\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '900123456'
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:40|6[01])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '840123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '41\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '412345678'
                                ],
                                'TZ',
                                255,
                                '00[056]',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{2})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[89]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[24]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[67]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '(?:8(?:[04]0|6[01])|90\\d)\\d{6}'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            UA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[89]\\d{9}|[3-9]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '311234567',
                                    ,
                                    ,
                                    [9],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:50|6[36-8]|7[1-3]|9[1-9])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '501234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '800[1-8]\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    '900[239]\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '900212345'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '89[1-579]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '891234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                'UA',
                                380,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                '0~0',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        [
                                            '6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]',
                                            '6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        [
                                            '4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]',
                                            '4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{5})',
                                        '$1 $2',
                                        ['[3-6]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[89]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            UG: [
                                ,
                                [
                                    ,
                                    ,
                                    '800\\d{6}|(?:[29]0|[347]\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '20(?:(?:(?:24|81)0|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[0147]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '312345678',
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '7260\\d{5}|7(?:[0157-9]\\d|20|36|4[0-4])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '712345678'
                                ],
                                [
                                    ,
                                    ,
                                    '800[1-3]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    '90[1-3]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '901123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'UG',
                                256,
                                '00[057]',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{4})(\\d{5})',
                                        '$1 $2',
                                        [
                                            '202',
                                            '2024'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{6})',
                                        '$1 $2',
                                        ['[27-9]|4(?:6[45]|[7-9])'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{7})',
                                        '$1 $2',
                                        ['[34]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            US: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-9]\\d{9}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[02357]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '2015550123',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[02357]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '2015550123',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'US',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1',
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1-$2',
                                        ['[2-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '($1) $2-$3',
                                        ['[2-9]'],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [[
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1-$2-$3',
                                        ['[2-9]']
                                    ]],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            UY: [
                                ,
                                [
                                    ,
                                    ,
                                    '4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2\\d|4[2-7])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '21231234',
                                    ,
                                    ,
                                    [8],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '9[1-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '94231234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:4\\d{5}|80[05])\\d{4}|405\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '8001234',
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '90[0-8]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '9001234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'UY',
                                598,
                                '0(?:0|1[3-9]\\d)',
                                '0',
                                ' int. ',
                                ,
                                '0',
                                ,
                                '00',
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['405|8|90'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['9'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[24]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['4'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            UZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '55501\\d{4}|(?:33|[679]\\d|88)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '669050123'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:(?:33|88|9[0-57-9])\\d{3}|55501|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '912345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'UZ',
                                998,
                                '810',
                                '8',
                                ,
                                ,
                                '8',
                                ,
                                '8~10',
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[35-9]'],
                                        '8 $1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VA: [
                                ,
                                [
                                    ,
                                    ,
                                    '0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '06698\\d{1,6}',
                                    ,
                                    ,
                                    ,
                                    '0669812345',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '3[1-9]\\d{8}|3[2-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '3123456789',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '80(?:0\\d{3}|3)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '800123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '899123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '84(?:[08]\\d{3}|[17])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '848123456',
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:78\\d|99)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '1781234567',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '55\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '5512345678',
                                    ,
                                    ,
                                    [10]
                                ],
                                'VA',
                                39,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '06698',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '3[2-8]\\d{9,10}',
                                    ,
                                    ,
                                    ,
                                    '33101234501',
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            VC: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[58]\\d\\d|784|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7842661234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '7844301234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'VC',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-7]\\d{6})$',
                                '784$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '784',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '2121234567',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '4(?:1[24-8]|2[46])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '4121234567'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '8001234567'
                                ],
                                [
                                    ,
                                    ,
                                    '90[01]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '9001234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'VE',
                                58,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{7})',
                                        '$1-$2',
                                        ['[24-689]'],
                                        '0$1',
                                        '$CC $1'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '501\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '5010123456',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VG: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:284|[58]\\d\\d|900)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '284496[0-5]\\d{3}|284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2842291234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '284496[6-9]\\d{3}|284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|5(?:4[0-7]|68|9[69]))\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '2843001234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'VG',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-578]\\d{6})$',
                                '284$1',
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '284',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[58]\\d{9}|(?:34|90)0\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [10],
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '3406421234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '3406421234',
                                    ,
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    '8(?:00|33|44|55|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8002345678'
                                ],
                                [
                                    ,
                                    ,
                                    '900[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '9002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '5002345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'VI',
                                1,
                                '011',
                                '1',
                                ,
                                ,
                                '1|([2-9]\\d{6})$',
                                '340$1',
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '340',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VN: [
                                ,
                                [
                                    ,
                                    ,
                                    '[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-79]|9[0-4679])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '2101234567',
                                    ,
                                    ,
                                    [10]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:5(?:2[238]|59)|89[689]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '912345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '1800\\d{4,6}|12(?:0[13]|28)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '1800123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1900\\d{4,6}',
                                    ,
                                    ,
                                    ,
                                    '1900123456',
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '672\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '672012345',
                                    ,
                                    ,
                                    [9]
                                ],
                                'VN',
                                84,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[17]99'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})',
                                        '$1 $2',
                                        ['80'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4,5})',
                                        '$1 $2',
                                        ['69'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4,6})',
                                        '$1 $2',
                                        ['1'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[69]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[3578]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['2[48]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{3})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '0$1',
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})',
                                        '$1 $2',
                                        ['80'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4,6})',
                                        '$1 $2',
                                        ['1'],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                                        '$1 $2 $3 $4',
                                        ['[69]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[3578]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['2[48]'],
                                        '0$1',
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{3})',
                                        '$1 $2 $3',
                                        ['2'],
                                        '0$1',
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '[17]99\\d{4}|69\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[17]99|80\\d)\\d{4}|69\\d{5,6}',
                                    ,
                                    ,
                                    ,
                                    '1992000',
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VU: [
                                ,
                                [
                                    ,
                                    ,
                                    '[48]8\\d{3}|(?:[23]|[579]\\d\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '22123',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:5\\d|7[013-7])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '5912345',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:0[1-9]|1[01])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '9010123',
                                    ,
                                    ,
                                    [7]
                                ],
                                'VU',
                                678,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['[579]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:3[03]|900\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '30123'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            WF: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[45]0|68|72|8\\d)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:50|68|72)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '501234'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:50|68|72|8[23])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '501234'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'WF',
                                681,
                                '00',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{2})',
                                        '$1 $2 $3',
                                        ['[4-8]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '[48]0\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '401234'
                                ]
                            ],
                            WS: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '22123',
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '7212345',
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '800123',
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'WS',
                                685,
                                '0',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{5})',
                                        '$1',
                                        ['[2-5]|6[1-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,7})',
                                        '$1 $2',
                                        ['[68]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})',
                                        '$1 $2',
                                        ['7']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            XK: [
                                ,
                                [
                                    ,
                                    ,
                                    '[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2[89]|39)0\\d{6}|[23][89]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '28012345'
                                ],
                                [
                                    ,
                                    ,
                                    '4[3-9]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '43201234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '80001234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    '900\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '90001234',
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'XK',
                                383,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{5})',
                                        '$1 $2',
                                        ['[89]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[2-4]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[23]'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            YE: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1|7\\d)\\d{7}|[1-7]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '1234567',
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '7[0137]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '712345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'YE',
                                967,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['[1-6]|7[24-68]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['7'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            YT: [
                                ,
                                [
                                    ,
                                    ,
                                    '80\\d{7}|(?:26|63)9\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '269(?:0[67]|5[0-3]|6\\d|[78]0)\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '269601234'
                                ],
                                [
                                    ,
                                    ,
                                    '639(?:0[0-79]|1[019]|[267]\\d|3[09]|[45]0|9[04-79])\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '639012345'
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '801234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                'YT',
                                262,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                '269|63',
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ZA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-79]\\d{8}|8\\d{4,9}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '101234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '711234567',
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '80\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '801234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:86[2-9]|9[0-2]\\d)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '862345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '860\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '860123456',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '871234567',
                                    ,
                                    ,
                                    [9]
                                ],
                                'ZA',
                                27,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})',
                                        '$1 $2',
                                        ['8[1-4]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{2,3})',
                                        '$1 $2 $3',
                                        ['8[1-4]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['860'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[1-9]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['8'],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '861\\d{6,7}',
                                    ,
                                    ,
                                    ,
                                    '861123456',
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ZM: [
                                ,
                                [
                                    ,
                                    ,
                                    '(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '21[1-8]\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '211234567',
                                    ,
                                    ,
                                    ,
                                    [6]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:7[679]|9[5-8])\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '955123456'
                                ],
                                [
                                    ,
                                    ,
                                    '800\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '800123456'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '630\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '630012345'
                                ],
                                'ZM',
                                260,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})',
                                        '$1 $2',
                                        ['[1-9]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[28]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{7})',
                                        '$1 $2',
                                        ['[79]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[28]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{7})',
                                        '$1 $2',
                                        ['[79]'],
                                        '0$1'
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ZW: [
                                ,
                                [
                                    ,
                                    ,
                                    '2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '1312345',
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '7(?:[17]\\d|[38][1-9])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '712345678',
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    '80(?:[01]\\d|20|8[0-8])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '8001234',
                                    ,
                                    ,
                                    [7]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '86(?:1[12]|22|30|44|55|77|8[368])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '8686123456',
                                    ,
                                    ,
                                    [10]
                                ],
                                'ZW',
                                263,
                                '00',
                                '0',
                                ,
                                ,
                                '0',
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3,5})',
                                        '$1 $2',
                                        ['2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d)(\\d{3})(\\d{2,4})',
                                        '$1 $2 $3',
                                        ['[49]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})',
                                        '$1 $2',
                                        ['80'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{7})',
                                        '$1 $2',
                                        [
                                            '24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2',
                                            '2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]'
                                        ],
                                        '(0$1)'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{4})',
                                        '$1 $2 $3',
                                        ['7'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        [
                                            '2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)',
                                            '2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)'
                                        ],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{6})',
                                        '$1 $2',
                                        ['8'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,5})',
                                        '$1 $2',
                                        ['1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3})(\\d{3,4})',
                                        '$1 $2 $3',
                                        ['29[013-9]|39|54'],
                                        '0$1'
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{3,5})',
                                        '$1 $2',
                                        [
                                            '(?:25|54)8',
                                            '258|5483'
                                        ],
                                        '0$1'
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            800: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '12345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                '001',
                                800,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [[
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[1-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            808: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '12345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                '001',
                                808,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [[
                                        ,
                                        '(\\d{4})(\\d{4})',
                                        '$1 $2',
                                        ['[1-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            870: [
                                ,
                                [
                                    ,
                                    ,
                                    '7\\d{11}|[35-7]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '301234567'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                '001',
                                870,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['[35-7]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            878: [
                                ,
                                [
                                    ,
                                    ,
                                    '10\\d{10}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [12]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '10\\d{10}',
                                    ,
                                    ,
                                    ,
                                    '101234567890'
                                ],
                                '001',
                                878,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [[
                                        ,
                                        '(\\d{2})(\\d{5})(\\d{5})',
                                        '$1 $2 $3',
                                        ['1']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            881: [
                                ,
                                [
                                    ,
                                    ,
                                    '[0-36-9]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '[0-36-9]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '612345678'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                '001',
                                881,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [[
                                        ,
                                        '(\\d)(\\d{3})(\\d{5})',
                                        '$1 $2 $3',
                                        ['[0-36-9]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            882: [
                                ,
                                [
                                    ,
                                    ,
                                    '[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '3421234',
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}',
                                    ,
                                    ,
                                    ,
                                    '390123456789'
                                ],
                                '001',
                                882,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        '(\\d{2})(\\d{5})',
                                        '$1 $2',
                                        ['16|342']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{6})',
                                        '$1 $2',
                                        ['4']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{2})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[19]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{3})',
                                        '$1 $2 $3',
                                        ['3[23]']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{3,4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['1']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['34[57]']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['34']
                                    ],
                                    [
                                        ,
                                        '(\\d{2})(\\d{4,5})(\\d{5})',
                                        '$1 $2 $3',
                                        ['[1-3]']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '348[57]\\d{7}',
                                    ,
                                    ,
                                    ,
                                    '34851234567',
                                    ,
                                    ,
                                    [11]
                                ]
                            ],
                            883: [
                                ,
                                [
                                    ,
                                    ,
                                    '51\\d{7}(?:\\d{3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '51[013]0\\d{8}|5100\\d{5}',
                                    ,
                                    ,
                                    ,
                                    '510012345'
                                ],
                                '001',
                                883,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3',
                                        ['510']
                                    ],
                                    [
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{3})(\\d{3})',
                                        '$1 $2 $3 $4',
                                        ['510']
                                    ],
                                    [
                                        ,
                                        '(\\d{4})(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['5']
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            888: [
                                ,
                                [
                                    ,
                                    ,
                                    '\\d{11}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [11]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                '001',
                                888,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [[
                                        ,
                                        '(\\d{3})(\\d{3})(\\d{5})',
                                        '$1 $2 $3'
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '\\d{11}',
                                    ,
                                    ,
                                    ,
                                    '12345678901'
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            979: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1359]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [9],
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '[1359]\\d{8}',
                                    ,
                                    ,
                                    ,
                                    '123456789',
                                    ,
                                    ,
                                    ,
                                    [8]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                '001',
                                979,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [[
                                        ,
                                        '(\\d)(\\d{4})(\\d{4})',
                                        '$1 $2 $3',
                                        ['[1359]']
                                    ]],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ]
                        };
                        i18n.phonenumbers.PhoneNumberUtil = function () {
                            this.regionToMetadataMap = {};
                        };
                        goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);
                        i18n.phonenumbers.Error = {
                            INVALID_COUNTRY_CODE: 'Invalid country calling code',
                            NOT_A_NUMBER: 'The string supplied did not seem to be a phone number',
                            TOO_SHORT_AFTER_IDD: 'Phone number too short after IDD',
                            TOO_SHORT_NSN: 'The string supplied is too short to be a phone number',
                            TOO_LONG: 'The string supplied is too long to be a phone number'
                        };
                        i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1;
                        i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250;
                        i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = 'ZZ';
                        i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_ = '3';
                        i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = { 54: '9' };
                        i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [
                            52,
                            54,
                            55
                        ];
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = '+';
                        i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = '*';
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ';ext=';
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = 'tel:';
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ';phone-context=';
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ';isub=';
                        i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = {
                            0: '0',
                            1: '1',
                            2: '2',
                            3: '3',
                            4: '4',
                            5: '5',
                            6: '6',
                            7: '7',
                            8: '8',
                            9: '9',
                            '０': '0',
                            '１': '1',
                            '２': '2',
                            '３': '3',
                            '４': '4',
                            '５': '5',
                            '６': '6',
                            '７': '7',
                            '８': '8',
                            '９': '9',
                            '٠': '0',
                            '١': '1',
                            '٢': '2',
                            '٣': '3',
                            '٤': '4',
                            '٥': '5',
                            '٦': '6',
                            '٧': '7',
                            '٨': '8',
                            '٩': '9',
                            '۰': '0',
                            '۱': '1',
                            '۲': '2',
                            '۳': '3',
                            '۴': '4',
                            '۵': '5',
                            '۶': '6',
                            '۷': '7',
                            '۸': '8',
                            '۹': '9'
                        };
                        i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = {
                            0: '0',
                            1: '1',
                            2: '2',
                            3: '3',
                            4: '4',
                            5: '5',
                            6: '6',
                            7: '7',
                            8: '8',
                            9: '9',
                            '+': i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN,
                            '*': '*',
                            '#': '#'
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = {
                            A: '2',
                            B: '2',
                            C: '2',
                            D: '3',
                            E: '3',
                            F: '3',
                            G: '4',
                            H: '4',
                            I: '4',
                            J: '5',
                            K: '5',
                            L: '5',
                            M: '6',
                            N: '6',
                            O: '6',
                            P: '7',
                            Q: '7',
                            R: '7',
                            S: '7',
                            T: '8',
                            U: '8',
                            V: '8',
                            W: '9',
                            X: '9',
                            Y: '9',
                            Z: '9'
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {
                            0: '0',
                            1: '1',
                            2: '2',
                            3: '3',
                            4: '4',
                            5: '5',
                            6: '6',
                            7: '7',
                            8: '8',
                            9: '9',
                            '０': '0',
                            '１': '1',
                            '２': '2',
                            '３': '3',
                            '４': '4',
                            '５': '5',
                            '６': '6',
                            '７': '7',
                            '８': '8',
                            '９': '9',
                            '٠': '0',
                            '١': '1',
                            '٢': '2',
                            '٣': '3',
                            '٤': '4',
                            '٥': '5',
                            '٦': '6',
                            '٧': '7',
                            '٨': '8',
                            '٩': '9',
                            '۰': '0',
                            '۱': '1',
                            '۲': '2',
                            '۳': '3',
                            '۴': '4',
                            '۵': '5',
                            '۶': '6',
                            '۷': '7',
                            '۸': '8',
                            '۹': '9',
                            A: '2',
                            B: '2',
                            C: '2',
                            D: '3',
                            E: '3',
                            F: '3',
                            G: '4',
                            H: '4',
                            I: '4',
                            J: '5',
                            K: '5',
                            L: '5',
                            M: '6',
                            N: '6',
                            O: '6',
                            P: '7',
                            Q: '7',
                            R: '7',
                            S: '7',
                            T: '8',
                            U: '8',
                            V: '8',
                            W: '9',
                            X: '9',
                            Y: '9',
                            Z: '9'
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {
                            0: '0',
                            1: '1',
                            2: '2',
                            3: '3',
                            4: '4',
                            5: '5',
                            6: '6',
                            7: '7',
                            8: '8',
                            9: '9',
                            A: 'A',
                            B: 'B',
                            C: 'C',
                            D: 'D',
                            E: 'E',
                            F: 'F',
                            G: 'G',
                            H: 'H',
                            I: 'I',
                            J: 'J',
                            K: 'K',
                            L: 'L',
                            M: 'M',
                            N: 'N',
                            O: 'O',
                            P: 'P',
                            Q: 'Q',
                            R: 'R',
                            S: 'S',
                            T: 'T',
                            U: 'U',
                            V: 'V',
                            W: 'W',
                            X: 'X',
                            Y: 'Y',
                            Z: 'Z',
                            a: 'A',
                            b: 'B',
                            c: 'C',
                            d: 'D',
                            e: 'E',
                            f: 'F',
                            g: 'G',
                            h: 'H',
                            i: 'I',
                            j: 'J',
                            k: 'K',
                            l: 'L',
                            m: 'M',
                            n: 'N',
                            o: 'O',
                            p: 'P',
                            q: 'Q',
                            r: 'R',
                            s: 'S',
                            t: 'T',
                            u: 'U',
                            v: 'V',
                            w: 'W',
                            x: 'X',
                            y: 'Y',
                            z: 'Z',
                            '-': '-',
                            '\uFF0D': '-',
                            '\u2010': '-',
                            '\u2011': '-',
                            '\u2012': '-',
                            '\u2013': '-',
                            '\u2014': '-',
                            '\u2015': '-',
                            '\u2212': '-',
                            '/': '/',
                            '\uFF0F': '/',
                            ' ': ' ',
                            '\u3000': ' ',
                            '\u2060': ' ',
                            '.': '.',
                            '\uFF0E': '.'
                        };
                        i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = '-x\u2010-\u2015\u2212ー\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E';
                        i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = '0-9０-９٠-٩۰-۹';
                        i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = 'A-Za-z';
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = '+\uFF0B';
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = new RegExp('[' + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + ']+');
                        i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + ']+');
                        i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = '[' + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + ']+';
                        i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = new RegExp('([' + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + '])');
                        i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = new RegExp('[' + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + ']');
                        i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/;
                        i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = new RegExp('[^' + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + '#]+$');
                        i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/;
                        i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = '[' + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + ']{' + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + '}';
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = '[' + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + ']*(?:[' + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + ']*[' + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + ']){3,}[' + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + ']*';
                        i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = ' ext. ';
                        i18n.phonenumbers.PhoneNumberUtil.extnDigits_ = function (a) {
                            return '([' + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + ']{1,' + a + '})';
                        };
                        i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_ = function () {
                            var a = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.extnDigits_('20'), b = '[ \xA0\\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.\uFF0E]?[ \xA0\\t,-]*' + i18n.phonenumbers.PhoneNumberUtil.extnDigits_('20') + '#?', c = '[ \xA0\\t,]*(?:[xｘ#\uFF03~\uFF5E]|int|ｉｎｔ)[:\\.\uFF0E]?[ \xA0\\t,-]*' + i18n.phonenumbers.PhoneNumberUtil.extnDigits_('9') + '#?', d = '[- ]+' + i18n.phonenumbers.PhoneNumberUtil.extnDigits_('6') + '#', e = '[ \xA0\\t]*(?:,{2}|;)[:\\.\uFF0E]?[ \xA0\\t,-]*' + i18n.phonenumbers.PhoneNumberUtil.extnDigits_('15') + '#?', f = '[ \xA0\\t]*(?:,)+[:\\.\uFF0E]?[ \xA0\\t,-]*' + i18n.phonenumbers.PhoneNumberUtil.extnDigits_('9') + '#?';
                            return a + '|' + b + '|' + c + '|' + d + '|' + e + '|' + f;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = new RegExp('(?:' + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ')$', 'i');
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = new RegExp('^' + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + '$|^' + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + '(?:' + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ')?$', 'i');
                        i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/;
                        i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/;
                        i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/;
                        i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/;
                        i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/;
                        i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/;
                        i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = '001';
                        i18n.phonenumbers.PhoneNumberFormat = {
                            E164: 0,
                            INTERNATIONAL: 1,
                            NATIONAL: 2,
                            RFC3966: 3
                        };
                        i18n.phonenumbers.PhoneNumberType = {
                            FIXED_LINE: 0,
                            MOBILE: 1,
                            FIXED_LINE_OR_MOBILE: 2,
                            TOLL_FREE: 3,
                            PREMIUM_RATE: 4,
                            SHARED_COST: 5,
                            VOIP: 6,
                            PERSONAL_NUMBER: 7,
                            PAGER: 8,
                            UAN: 9,
                            VOICEMAIL: 10,
                            UNKNOWN: -1
                        };
                        i18n.phonenumbers.PhoneNumberUtil.MatchType = {
                            NOT_A_NUMBER: 0,
                            NO_MATCH: 1,
                            SHORT_NSN_MATCH: 2,
                            NSN_MATCH: 3,
                            EXACT_MATCH: 4
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ValidationResult = {
                            IS_POSSIBLE: 0,
                            IS_POSSIBLE_LOCAL_ONLY: 4,
                            INVALID_COUNTRY_CODE: 1,
                            TOO_SHORT: 2,
                            INVALID_LENGTH: 5,
                            TOO_LONG: 3
                        };
                        i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function (a) {
                            var b = a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
                            0 <= b ? (a = a.substring(b), a = a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ''), b = a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= b && (a = a.substring(0, b))) : a = '';
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function (a) {
                            return a.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalize = function (a) {
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !0) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function (a) {
                            var b = i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());
                            a.clear();
                            a.append(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function (a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function (a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function (a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !1);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function (a) {
                            var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
                            return null != b && (b.hasNationalPrefix() || a.hasItalianLeadingZero()) && this.isNumberGeographical(a) ? this.getLengthOfNationalDestinationCode(a) : 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function (a) {
                            if (a.hasExtension()) {
                                var b = a.clone();
                                b.clearExtension();
                            } else
                                b = a;
                            b = this.format(b, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);
                            0 == b[0].length && b.shift();
                            return 2 >= b.length ? 0 : this.getNumberType(a) == i18n.phonenumbers.PhoneNumberType.MOBILE && (a = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()), '' != a) ? b[2].length + a.length : b[1].length;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function (a) {
                            return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a] || '';
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function () {
                            return module$contents$goog$array_filter(Object.keys(i18n.phonenumbers.metadata.countryToMetadata), function (a) {
                                return isNaN(a);
                            });
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function () {
                            var a = module$contents$goog$array_filter(Object.keys(i18n.phonenumbers.metadata.countryToMetadata), function (b) {
                                return !isNaN(b);
                            });
                            return module$contents$goog$array_map(a, function (b) {
                                return parseInt(b, 10);
                            });
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function () {
                            var a = Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);
                            return module$contents$goog$array_join(this.getSupportedGlobalNetworkCallingCodes(), module$contents$goog$array_map(a, function (b) {
                                return parseInt(b, 10);
                            }));
                        };
                        i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function (a) {
                            return null != a && (1 != a.possibleLengthCount() || -1 != a.possibleLengthArray()[0]);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function (a) {
                            return null != a && (a.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a) || a.hasNationalNumberPattern());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function (a) {
                            var b = [];
                            goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function (c) {
                                if (c != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && c != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
                                    var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a, c);
                                    i18n.phonenumbers.PhoneNumberUtil.descHasData_(d) && b.push(c);
                                }
                            });
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function (a) {
                            return this.isValidRegionCode_(a) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)) : [];
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function (a) {
                            a = this.getMetadataForNonGeographicalRegion(a);
                            return null == a ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function (a, b, c) {
                            for (var d = new goog.string.StringBuffer(), e, f, g = a.length, h = 0; h < g; ++h)
                                e = a.charAt(h), f = b[e.toUpperCase()], null != f ? d.append(f) : c || d.append(e);
                            return d.toString();
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function (a) {
                            return 0 == a.length || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function (a) {
                            var b = this.getNumberType(a);
                            return b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || module$contents$goog$array_contains(i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_, a.getCountryCodeOrDefault()) && b == i18n.phonenumbers.PhoneNumberType.MOBILE;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function (a) {
                            return null != a && isNaN(a) && a.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function (a) {
                            return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.format = function (a, b) {
                            if (0 == a.getNationalNumber() && a.hasRawInput()) {
                                var c = a.getRawInputOrDefault();
                                if (0 < c.length)
                                    return c;
                            }
                            c = a.getCountryCodeOrDefault();
                            var d = this.getNationalSignificantNumber(a);
                            if (b == i18n.phonenumbers.PhoneNumberFormat.E164)
                                return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.E164, d, '');
                            if (!this.hasValidCountryCallingCode_(c))
                                return d;
                            var e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            a = this.maybeGetFormattedExtension_(a, e, b);
                            d = this.formatNsn_(d, e, b);
                            return this.prefixNumberWithCountryCallingCode_(c, b, d, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function (a, b, c) {
                            var d = a.getCountryCodeOrDefault(), e = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(d))
                                return e;
                            var f = this.getRegionCodeForCountryCode(d);
                            f = this.getMetadataForRegionOrCallingCode_(d, f);
                            var g = this.chooseFormattingPatternForNumber_(c, e);
                            if (null != g) {
                                c = g.clone();
                                g = g.getNationalPrefixFormattingRuleOrDefault();
                                if (0 < g.length) {
                                    var h = f.getNationalPrefixOrDefault();
                                    0 < h.length ? (g = g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_, h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, '$1'), c.setNationalPrefixFormattingRule(g)) : c.clearNationalPrefixFormattingRule();
                                }
                                e = this.formatNsnUsingPattern_(e, c, b);
                            }
                            a = this.maybeGetFormattedExtension_(a, f, b);
                            return this.prefixNumberWithCountryCallingCode_(d, b, e, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function (a, b) {
                            var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(c))
                                return d;
                            var e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            a = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            b = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b);
                            return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function (a, b) {
                            return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == b ? this.getMetadataForNonGeographicalRegion(a) : this.getMetadataForRegion(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function (a, b) {
                            return this.formatNationalNumberWithCarrierCode(a, 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? a.getPreferredDomesticCarrierCodeOrDefault() : b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function (a, b, c) {
                            var d = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(d))
                                return a.hasRawInput() ? a.getRawInputOrDefault() : '';
                            var e = '';
                            a = a.clone();
                            a.clearExtension();
                            var f = this.getRegionCodeForCountryCode(d), g = this.getNumberType(a), h = g != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                            if (b == f)
                                e = g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || g == i18n.phonenumbers.PhoneNumberType.MOBILE || g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, 'CO' == f && g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE ? e = this.formatNationalNumberWithCarrierCode(a, i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_) : 'BR' == f && e ? e = 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(a, '') : '' : d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (b = this.getMetadataForRegion(b), e = this.canBeInternationallyDialled(a) && this.testNumberLength_(this.getNationalSignificantNumber(a), b) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : e = (f == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || ('MX' == f || 'CL' == f || 'UZ' == f) && e) && this.canBeInternationallyDialled(a) ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            else if (h && this.canBeInternationallyDialled(a))
                                return c ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.E164);
                            return c ? e : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function (a, b) {
                            if (!this.isValidRegionCode_(b))
                                return this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(c))
                                return d;
                            if (c == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                                if (this.isNANPACountry(b))
                                    return c + ' ' + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            } else if (c == this.getCountryCodeForValidRegion_(b))
                                return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            var e = this.getMetadataForRegion(b), f = e.getInternationalPrefixOrDefault();
                            b = '';
                            i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, f) ? b = f : e.hasPreferredInternationalPrefix() && (b = e.getPreferredInternationalPrefixOrDefault());
                            e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            d = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            a = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            return 0 < b.length ? b + ' ' + c + ' ' + d + a : this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, d, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function (a, b) {
                            if (a.hasRawInput() && !this.hasFormattingPatternForNumber_(a))
                                return a.getRawInputOrDefault();
                            if (!a.hasCountryCodeSource())
                                return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            switch (a.getCountryCodeSource()) {
                            case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
                                b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                                break;
                            case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
                                b = this.formatOutOfCountryCallingNumber(a, b);
                                break;
                            case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
                                b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
                                break;
                            default:
                                var c = this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()), d = this.getNddPrefixForRegion(c, !0);
                                b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                                if (null != d && 0 != d.length && !this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(), d, c) && (c = this.getMetadataForRegion(c), d = this.getNationalSignificantNumber(a), c = this.chooseFormattingPatternForNumber_(c.numberFormatArray(), d), null != c)) {
                                    d = c.getNationalPrefixFormattingRuleOrDefault();
                                    var e = d.indexOf('$1');
                                    0 >= e || (d = d.substring(0, e), d = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d), 0 != d.length && (b = c.clone(), b.clearNationalPrefixFormattingRule(), b = this.formatByPattern(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [b])));
                                }
                            }
                            a = a.getRawInputOrDefault();
                            null != b && 0 < a.length && (c = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(b), d = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(a), c != d && (b = a));
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function (a, b, c) {
                            a = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
                            if (goog.string.startsWith(a, b))
                                try {
                                    return this.isValidNumber(this.parse(a.substring(b.length), c));
                                } catch (d) {
                                }
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function (a) {
                            var b = a.getCountryCodeOrDefault(), c = this.getRegionCodeForCountryCode(b);
                            b = this.getMetadataForRegionOrCallingCode_(b, c);
                            if (null == b)
                                return !1;
                            a = this.getNationalSignificantNumber(a);
                            return null != this.chooseFormattingPatternForNumber_(b.numberFormatArray(), a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function (a, b) {
                            var c = a.getRawInputOrDefault();
                            if (0 == c.length)
                                return this.formatOutOfCountryCallingNumber(a, b);
                            var d = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(d))
                                return c;
                            c = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, !0);
                            var e = this.getNationalSignificantNumber(a);
                            if (3 < e.length) {
                                var f = c.indexOf(e.substring(0, 3));
                                -1 != f && (c = c.substring(f));
                            }
                            f = this.getMetadataForRegion(b);
                            if (d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                                if (this.isNANPACountry(b))
                                    return d + ' ' + c;
                            } else if (null != f && d == this.getCountryCodeForValidRegion_(b)) {
                                d = this.chooseFormattingPatternForNumber_(f.numberFormatArray(), e);
                                if (null == d)
                                    return c;
                                d = d.clone();
                                d.setPattern('(\\d+)(.*)');
                                d.setFormat('$1$2');
                                return this.formatNsnUsingPattern_(c, d, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            }
                            b = '';
                            null != f && (b = f.getInternationalPrefixOrDefault(), b = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, b) ? b : f.getPreferredInternationalPrefixOrDefault());
                            f = this.getRegionCodeForCountryCode(d);
                            f = this.getMetadataForRegionOrCallingCode_(d, f);
                            a = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            return 0 < b.length ? b + ' ' + d + ' ' + c + a : this.prefixNumberWithCountryCallingCode_(d, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, c, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function (a) {
                            if (!a.hasNationalNumber())
                                return '';
                            var b = '' + a.getNationalNumber();
                            return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join('0') + b : b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function (a, b, c, d) {
                            switch (b) {
                            case i18n.phonenumbers.PhoneNumberFormat.E164:
                                return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + c + d;
                            case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
                                return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + ' ' + c + d;
                            case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
                                return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + '-' + c + d;
                            default:
                                return c + d;
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function (a, b, c, d) {
                            b = 0 == b.intlNumberFormatArray().length || c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? b.numberFormatArray() : b.intlNumberFormatArray();
                            b = this.chooseFormattingPatternForNumber_(b, a);
                            return null == b ? a : this.formatNsnUsingPattern_(a, b, c, d);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function (a, b) {
                            for (var c, d = a.length, e = 0; e < d; ++e) {
                                c = a[e];
                                var f = c.leadingDigitsPatternCount();
                                if (0 == f || 0 == b.search(c.getLeadingDigitsPattern(f - 1)))
                                    if (f = new RegExp(c.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, b))
                                        return c;
                            }
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function (a, b, c, d) {
                            var e = b.getFormatOrDefault(), f = new RegExp(b.getPattern()), g = b.getDomesticCarrierCodeFormattingRuleOrDefault();
                            c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != d && 0 < d.length && 0 < g.length ? (b = g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, d), e = e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b), a = a.replace(f, e)) : (b = b.getNationalPrefixFormattingRuleOrDefault(), a = c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != b && 0 < b.length ? a.replace(f, e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b)) : a.replace(f, e));
                            c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (a = a.replace(new RegExp('^' + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ''), a = a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, 'g'), '-'));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function (a) {
                            return this.getExampleNumberForType(a, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function (a, b) {
                            if (!this.isValidRegionCode_(a))
                                return null;
                            b = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a), b);
                            try {
                                if (b.hasExampleNumber())
                                    return this.parse(b.getExampleNumber(), a);
                            } catch (c) {
                            }
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function (a) {
                            var b = this.getMetadataForNonGeographicalRegion(a);
                            if (null != b && (b = module$contents$goog$array_find([
                                    b.getMobile(),
                                    b.getTollFree(),
                                    b.getSharedCost(),
                                    b.getVoip(),
                                    b.getVoicemail(),
                                    b.getUan(),
                                    b.getPremiumRate()
                                ], function (c, d) {
                                    return c.hasExampleNumber();
                                }), null != b))
                                try {
                                    return this.parse('+' + a + b.getExampleNumber(), 'ZZ');
                                } catch (c) {
                                }
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function (a, b, c) {
                            return a.hasExtension() && 0 != a.getExtension().length ? c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + a.getExtension() : b.hasPreferredExtnPrefix() ? b.getPreferredExtnPrefix() + a.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + a.getExtensionOrDefault() : '';
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function (a, b) {
                            switch (b) {
                            case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
                                return a.getPremiumRate();
                            case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
                                return a.getTollFree();
                            case i18n.phonenumbers.PhoneNumberType.MOBILE:
                                return a.getMobile();
                            case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
                            case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
                                return a.getFixedLine();
                            case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
                                return a.getSharedCost();
                            case i18n.phonenumbers.PhoneNumberType.VOIP:
                                return a.getVoip();
                            case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
                                return a.getPersonalNumber();
                            case i18n.phonenumbers.PhoneNumberType.PAGER:
                                return a.getPager();
                            case i18n.phonenumbers.PhoneNumberType.UAN:
                                return a.getUan();
                            case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
                                return a.getVoicemail();
                            default:
                                return a.getGeneralDesc();
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function (a) {
                            var b = this.getRegionCodeForNumber(a);
                            b = this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(), b);
                            if (null == b)
                                return i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                            a = this.getNationalSignificantNumber(a);
                            return this.getNumberTypeHelper_(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function (a, b) {
                            return this.isNumberMatchingDesc_(a, b.getGeneralDesc()) ? this.isNumberMatchingDesc_(a, b.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(a, b.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(a, b.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(a, b.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(a, b.getPersonalNumber()) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : this.isNumberMatchingDesc_(a, b.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(a, b.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(a, b.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(a, b.getFixedLine()) ? b.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : !b.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function (a) {
                            if (null == a)
                                return null;
                            a = a.toUpperCase();
                            var b = this.regionToMetadataMap[a];
                            if (null == b) {
                                b = new goog.proto2.PbLiteSerializer();
                                var c = i18n.phonenumbers.metadata.countryToMetadata[a];
                                if (null == c)
                                    return null;
                                b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
                                this.regionToMetadataMap[a] = b;
                            }
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function (a) {
                            return this.getMetadataForRegion('' + a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function (a, b) {
                            var c = a.length;
                            return 0 < b.possibleLengthCount() && -1 == module$contents$goog$array_indexOf(b.possibleLengthArray(), c) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function (a) {
                            var b = this.getRegionCodeForNumber(a);
                            return this.isValidNumberForRegion(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function (a, b) {
                            var c = a.getCountryCodeOrDefault(), d = this.getMetadataForRegionOrCallingCode_(c, b);
                            if (null == d || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != b && c != this.getCountryCodeForValidRegion_(b))
                                return !1;
                            a = this.getNationalSignificantNumber(a);
                            return this.getNumberTypeHelper_(a, d) != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function (a) {
                            if (null == a)
                                return null;
                            var b = a.getCountryCodeOrDefault();
                            b = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];
                            return null == b ? null : 1 == b.length ? b[0] : this.getRegionCodeForNumberFromRegionList_(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function (a, b) {
                            a = this.getNationalSignificantNumber(a);
                            for (var c, d = b.length, e = 0; e < d; e++) {
                                c = b[e];
                                var f = this.getMetadataForRegion(c);
                                if (f.hasLeadingDigits()) {
                                    if (0 == a.search(f.getLeadingDigits()))
                                        return c;
                                } else if (this.getNumberTypeHelper_(a, f) != i18n.phonenumbers.PhoneNumberType.UNKNOWN)
                                    return c;
                            }
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function (a) {
                            a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
                            return null == a ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : a[0];
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function (a) {
                            a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
                            return null == a ? [] : a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function (a) {
                            return this.isValidRegionCode_(a) ? this.getCountryCodeForValidRegion_(a) : 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function (a) {
                            var b = this.getMetadataForRegion(a);
                            if (null == b)
                                throw Error('Invalid region code: ' + a);
                            return b.getCountryCodeOrDefault();
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function (a, b) {
                            a = this.getMetadataForRegion(a);
                            if (null == a)
                                return null;
                            a = a.getNationalPrefixOrDefault();
                            if (0 == a.length)
                                return null;
                            b && (a = a.replace('~', ''));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function (a) {
                            return null != a && module$contents$goog$array_contains(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_], a.toUpperCase());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function (a) {
                            if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a))
                                return !1;
                            a = new goog.string.StringBuffer(a);
                            this.maybeStripExtension(a);
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a.toString());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function (a) {
                            a = this.isPossibleNumberWithReason(a);
                            return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function (a, b) {
                            a = this.isPossibleNumberForTypeWithReason(a, b);
                            return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function (a, b) {
                            return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function (a, b, c) {
                            var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, c), e = 0 == d.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : d.possibleLengthArray();
                            d = d.possibleLengthLocalOnlyArray();
                            if (c == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE)
                                if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.FIXED_LINE)))
                                    c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c) && (e = e.concat(0 == c.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : c.possibleLengthArray()), module$contents$goog$array_sort(e), 0 == d.length ? d = c.possibleLengthLocalOnlyArray() : (d = d.concat(c.possibleLengthLocalOnlyArray()), module$contents$goog$array_sort(d)));
                                else
                                    return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.MOBILE);
                            if (-1 == e[0])
                                return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
                            a = a.length;
                            if (-1 < module$contents$goog$array_indexOf(d, a))
                                return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                            b = e[0];
                            return b == a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : b > a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : e[e.length - 1] < a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < module$contents$goog$array_indexOf(e, a, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function (a) {
                            return this.isPossibleNumberForTypeWithReason(a, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function (a, b) {
                            var c = this.getNationalSignificantNumber(a);
                            a = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(a))
                                return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
                            var d = this.getRegionCodeForCountryCode(a);
                            a = this.getMetadataForRegionOrCallingCode_(a, d);
                            return this.testNumberLengthForType_(c, a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function (a, b) {
                            try {
                                return this.isPossibleNumber(this.parse(a, b));
                            } catch (c) {
                                return !1;
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function (a) {
                            if (this.isValidNumber(a))
                                return !0;
                            var b = a.clone(), c = a.getNationalNumberOrDefault();
                            do
                                if (c = Math.floor(c / 10), b.setNationalNumber(c), 0 == c || this.isPossibleNumberWithReason(b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT)
                                    return !1;
                            while (!this.isValidNumber(b));
                            a.setNationalNumber(c);
                            return !0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function (a, b) {
                            a = a.toString();
                            if (0 == a.length || '0' == a.charAt(0))
                                return 0;
                            for (var c, d = a.length, e = 1; e <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && e <= d; ++e)
                                if (c = parseInt(a.substring(0, e), 10), c in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap)
                                    return b.append(a.substring(e)), c;
                            return 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function (a, b, c, d, e) {
                            if (0 == a.length)
                                return 0;
                            a = new goog.string.StringBuffer(a);
                            var f;
                            null != b && (f = b.getInternationalPrefix());
                            null == f && (f = 'NonMatch');
                            f = this.maybeStripInternationalPrefixAndNormalize(a, f);
                            d && e.setCountryCodeSource(f);
                            if (f != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
                                if (a.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)
                                    throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
                                b = this.extractCountryCode(a, c);
                                if (0 != b)
                                    return e.setCountryCode(b), b;
                                throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            }
                            if (null != b) {
                                f = b.getCountryCodeOrDefault();
                                var g = '' + f, h = a.toString();
                                if (goog.string.startsWith(h, g) && (g = new goog.string.StringBuffer(h.substring(g.length)), h = b.getGeneralDesc(), h = new RegExp(h.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(g, b, null), g = g.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, a.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, g) || this.testNumberLength_(a.toString(), b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG))
                                    return c.append(g), d && e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), e.setCountryCode(f), f;
                            }
                            e.setCountryCode(0);
                            return 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function (a, b) {
                            var c = b.toString();
                            if (0 == c.search(a)) {
                                a = c.match(a)[0].length;
                                var d = c.substring(a).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
                                if (d && null != d[1] && 0 < d[1].length && '0' == i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d[1]))
                                    return !1;
                                b.clear();
                                b.append(c.substring(a));
                                return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function (a, b) {
                            var c = a.toString();
                            if (0 == c.length)
                                return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
                            if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(c))
                                return c = c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ''), a.clear(), a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
                            b = new RegExp(b);
                            i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);
                            return this.parsePrefixAsIdd_(b, a) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function (a, b, c) {
                            var d = a.toString(), e = d.length, f = b.getNationalPrefixForParsing();
                            if (0 == e || null == f || 0 == f.length)
                                return !1;
                            var g = new RegExp('^(?:' + f + ')');
                            if (e = g.exec(d)) {
                                f = new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault());
                                var h = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d), k = e.length - 1;
                                b = b.getNationalPrefixTransformRule();
                                if (null == b || 0 == b.length || null == e[k] || 0 == e[k].length) {
                                    if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d.substring(e[0].length)))
                                        return !1;
                                    null != c && 0 < k && null != e[k] && c.append(e[1]);
                                    a.set(d.substring(e[0].length));
                                } else {
                                    d = d.replace(g, b);
                                    if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d))
                                        return !1;
                                    null != c && 0 < k && c.append(e[1]);
                                    a.set(d);
                                }
                                return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function (a) {
                            var b = a.toString(), c = b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
                            if (0 <= c && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0, c)))
                                for (var d = b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), e = d.length, f = 1; f < e; ++f)
                                    if (null != d[f] && 0 < d[f].length)
                                        return a.clear(), a.append(b.substring(0, c)), d[f];
                            return '';
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function (a, b) {
                            return this.isValidRegionCode_(b) || null != a && 0 < a.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function (a, b) {
                            return this.parseHelper_(a, b, !1, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function (a, b) {
                            if (!this.isValidRegionCode_(b) && 0 < a.length && a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN)
                                throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            return this.parseHelper_(a, b, !0, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function (a, b) {
                            if (1 < a.length && '0' == a.charAt(0)) {
                                b.setItalianLeadingZero(!0);
                                for (var c = 1; c < a.length - 1 && '0' == a.charAt(c);)
                                    c++;
                                1 != c && b.setNumberOfLeadingZeros(c);
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function (a, b, c, d) {
                            if (null == a)
                                throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (a.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_)
                                throw Error(i18n.phonenumbers.Error.TOO_LONG);
                            var e = new goog.string.StringBuffer();
                            this.buildNationalNumberForParsing_(a, e);
                            if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString()))
                                throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (d && !this.checkRegionForParsing_(e.toString(), b))
                                throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            d = new i18n.phonenumbers.PhoneNumber();
                            c && d.setRawInput(a);
                            a = this.maybeStripExtension(e);
                            0 < a.length && d.setExtension(a);
                            var f = this.getMetadataForRegion(b);
                            a = new goog.string.StringBuffer();
                            var g = 0, h = e.toString();
                            try {
                                g = this.maybeExtractCountryCode(h, f, a, c, d);
                            } catch (k) {
                                if (k.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(h)) {
                                    if (h = h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ''), g = this.maybeExtractCountryCode(h, f, a, c, d), 0 == g)
                                        throw k;
                                } else
                                    throw k;
                            }
                            0 != g ? (e = this.getRegionCodeForCountryCode(g), e != b && (f = this.getMetadataForRegionOrCallingCode_(g, e))) : (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e), a.append(e.toString()), null != b ? (g = f.getCountryCodeOrDefault(), d.setCountryCode(g)) : c && d.clearCountryCodeSource());
                            if (a.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)
                                throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
                            null != f && (b = new goog.string.StringBuffer(), e = new goog.string.StringBuffer(a.toString()), this.maybeStripNationalPrefixAndCarrierCode(e, f, b), f = this.testNumberLength_(e.toString(), f), g = i18n.phonenumbers.PhoneNumberUtil.ValidationResult, f != g.TOO_SHORT && f != g.IS_POSSIBLE_LOCAL_ONLY && f != g.INVALID_LENGTH && (a = e, c && 0 < b.toString().length && d.setPreferredDomesticCarrierCode(b.toString())));
                            c = a.toString();
                            a = c.length;
                            if (a < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)
                                throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
                            if (a > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_)
                                throw Error(i18n.phonenumbers.Error.TOO_LONG);
                            i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c, d);
                            d.setNationalNumber(parseInt(c, 10));
                            return d;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function (a, b) {
                            var c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
                            if (0 <= c) {
                                var d = c + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;
                                if (a.charAt(d) == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
                                    var e = a.indexOf(';', d);
                                    0 < e ? b.append(a.substring(d, e)) : b.append(a.substring(d));
                                }
                                d = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);
                                b.append(a.substring(0 <= d ? d + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0, c));
                            } else
                                b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a));
                            a = b.toString();
                            c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);
                            0 < c && (b.clear(), b.append(a.substring(0, c)));
                        };
                        i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function (a) {
                            var b = new i18n.phonenumbers.PhoneNumber();
                            b.setCountryCode(a.getCountryCodeOrDefault());
                            b.setNationalNumber(a.getNationalNumberOrDefault());
                            0 < a.getExtensionOrDefault().length && b.setExtension(a.getExtensionOrDefault());
                            a.getItalianLeadingZero() && (b.setItalianLeadingZero(!0), b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function (a, b) {
                            if ('string' == typeof a)
                                try {
                                    var c = this.parse(a, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
                                } catch (f) {
                                    if (f.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE)
                                        return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                    if ('string' != typeof b) {
                                        var d = this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());
                                        if (d != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
                                            try {
                                                c = this.parse(a, d);
                                            } catch (g) {
                                                return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                            }
                                            var e = this.isNumberMatch(c, b);
                                            return e == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : e;
                                        }
                                    }
                                    try {
                                        c = this.parseHelper_(a, null, !1, !1);
                                    } catch (g) {
                                        return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                    }
                                }
                            else
                                c = a.clone();
                            if ('string' == typeof b)
                                try {
                                    return e = this.parse(b, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_), this.isNumberMatch(a, e);
                                } catch (f) {
                                    return f.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER : this.isNumberMatch(b, c);
                                }
                            else
                                e = b.clone();
                            a = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);
                            e = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);
                            if (a.hasExtension() && e.hasExtension() && a.getExtension() != e.getExtension())
                                return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                            b = a.getCountryCodeOrDefault();
                            c = e.getCountryCodeOrDefault();
                            if (0 != b && 0 != c)
                                return a.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : b == c && this.isNationalNumberSuffixOfTheOther_(a, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                            a.setCountryCode(0);
                            e.setCountryCode(0);
                            return a.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(a, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function (a, b) {
                            a = '' + a.getNationalNumber();
                            b = '' + b.getNationalNumber();
                            return goog.string.endsWith(a, b) || goog.string.endsWith(b, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function (a) {
                            var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
                            if (null == b)
                                return !0;
                            a = this.getNationalSignificantNumber(a);
                            return !this.isNumberMatchingDesc_(a, b.getNoInternationalDialling());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.matchesEntirely = function (a, b) {
                            return (a = 'string' == typeof a ? b.match('^(?:' + a + ')$') : b.match(a)) && a[0].length == b.length ? !0 : !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.matchesPrefix = function (a, b) {
                            return (a = 'string' == typeof a ? b.match('^(?:' + a + ')') : b.match(a)) && goog.string.startsWith(b, a[0]) ? !0 : !1;
                        };
                        i18n.phonenumbers.shortnumbermetadata = {};
                        i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap = { 0: 'AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'.split(' ') };
                        i18n.phonenumbers.shortnumbermetadata.countryToMetadata = {
                            AC: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AC',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AD: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[0268]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AD',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[0268]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[0268]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[149]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '112|445[16]|99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '445\\d',
                                    ,
                                    ,
                                    ,
                                    '4450',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            AF: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[02]|19)',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AF',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[02]|19)',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[02]|19)|40404',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            AG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176|9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ]
                            ],
                            AI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AI',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176|911',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ]
                            ],
                            AL: [
                                ,
                                [
                                    ,
                                    ,
                                    '[15]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '5\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '50000',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                ,
                                ,
                                'AL',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|2[7-9])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '123',
                                    ,
                                    ,
                                    ,
                                    '123',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '131|5\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '131',
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ]
                            ],
                            AM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[148]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[1-3]',
                                    ,
                                    ,
                                    ,
                                    '101',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[1-3]',
                                    ,
                                    ,
                                    ,
                                    '101',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1|8[1-7])\\d\\d|40404',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            AO: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[235]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[235]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[235]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AR: [
                                ,
                                [
                                    ,
                                    ,
                                    '[01389]\\d{1,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911',
                                    ,
                                    ,
                                    ,
                                    '19',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[017]|911',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911',
                                    ,
                                    ,
                                    ,
                                    '19'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '893\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '89300',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:337|893\\d)\\d',
                                    ,
                                    ,
                                    ,
                                    '3370',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            AS: [
                                ,
                                [
                                    ,
                                    ,
                                    '[49]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AS',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '40404|911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            AT: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d{3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '116\\d{3}|1(?:[12]2|33|44)',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AT',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[12]2|33|44)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '116(?:00[06]|1(?:17|23))|1(?:[12]2|33|44)',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AU: [
                                ,
                                [
                                    ,
                                    ,
                                    '[0-27]\\d{2,7}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '000|1(?:06|12|258885|55\\d)|733',
                                    ,
                                    ,
                                    ,
                                    '000',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:2(?:34|456)|9\\d{4,6})',
                                    ,
                                    ,
                                    ,
                                    '1234',
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'AU',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '000|1(?:06|12)',
                                    ,
                                    ,
                                    ,
                                    '000',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)',
                                    ,
                                    ,
                                    ,
                                    '000'
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:1[09]\\d|24733)|225|767',
                                    ,
                                    ,
                                    ,
                                    '225',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:258885|55\\d)',
                                    ,
                                    ,
                                    ,
                                    '1550',
                                    ,
                                    ,
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '19\\d{4,6}',
                                    ,
                                    ,
                                    ,
                                    '190000',
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ]
                            ],
                            AW: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '100|911',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AW',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '100|911',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:00|18|76)|91[13]',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ]
                            ],
                            AX: [
                                ,
                                [
                                    ,
                                    ,
                                    '[17]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AX',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '112|75[12]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            AZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[148]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '101',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'AZ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '101',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)|(?:404|880)0',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:404|880)\\d',
                                    ,
                                    ,
                                    ,
                                    '4040',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:404|880)\\d',
                                    ,
                                    ,
                                    ,
                                    '4040',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            BA: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:16\\d{3}|2[2-4])',
                                    ,
                                    ,
                                    ,
                                    '122',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '12[2-4]',
                                    ,
                                    ,
                                    ,
                                    '122',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    '122'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BB: [
                                ,
                                [
                                    ,
                                    ,
                                    '[2-689]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '[2359]11',
                                    ,
                                    ,
                                    ,
                                    '211'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BB',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '[2359]11',
                                    ,
                                    ,
                                    ,
                                    '211'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '[2-689]11',
                                    ,
                                    ,
                                    ,
                                    '211'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '[468]11',
                                    ,
                                    ,
                                    ,
                                    '411'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BD: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1579]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[0-26]|[19]99',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BD',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[0-2]|[19]99',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:11|2[13])|(?:501|959)\\d|786',
                                    ,
                                    ,
                                    ,
                                    '111',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '959\\d',
                                    ,
                                    ,
                                    ,
                                    '9590',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            BE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d\\d(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-25-8]|1[02]|7(?:12|77)|813)|(?:116|8)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d',
                                    ,
                                    ,
                                    ,
                                    '1204',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                ,
                                ,
                                'BE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[01]|12)',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-8]|1(?:[027]|6117)|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '[2-9]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '2000',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            BF: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BF',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BG: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d{3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6\\d{3})|50|6[06])',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|50|6[06])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6(?:000|111))|50|6[06])',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BH: [
                                ,
                                [
                                    ,
                                    ,
                                    '[0189]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '(?:0[167]|81)\\d{3}|[19]99',
                                    ,
                                    ,
                                    ,
                                    '199'
                                ],
                                [
                                    ,
                                    ,
                                    '9[148]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '91000',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                ,
                                ,
                                'BH',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '[19]99',
                                    ,
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '0[67]\\d{3}|88000|98555',
                                    ,
                                    ,
                                    ,
                                    '06000',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '88000|98555',
                                    ,
                                    ,
                                    ,
                                    '88000',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            BI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[16-9]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[237]|611',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BI',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[237]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '611|7(?:10|77)|888|900',
                                    ,
                                    ,
                                    ,
                                    '611',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:71|90)0',
                                    ,
                                    ,
                                    ,
                                    '710',
                                    ,
                                    ,
                                    [3]
                                ]
                            ],
                            BJ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[17]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[78]|7[3-5]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '117'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BJ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[78]',
                                    ,
                                    ,
                                    ,
                                    '117',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[78]|2[02-5]|60)|7[0-5]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '117'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '12[02-5]',
                                    ,
                                    ,
                                    ,
                                    '120',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BL: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '18',
                                    ,
                                    ,
                                    ,
                                    '18'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BL',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '18',
                                    ,
                                    ,
                                    ,
                                    '18'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '18',
                                    ,
                                    ,
                                    ,
                                    '18'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176|911',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ]
                            ],
                            BN: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '99[135]',
                                    ,
                                    ,
                                    ,
                                    '991'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BN',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '99[135]',
                                    ,
                                    ,
                                    ,
                                    '991'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '99[135]',
                                    ,
                                    ,
                                    ,
                                    '991'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BO: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[089]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[089]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[089]|40404',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            BQ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BQ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|76)|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ]
                            ],
                            BR: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-69]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|28|9[023])|911',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    '102|273\\d\\d|321',
                                    ,
                                    ,
                                    ,
                                    '102',
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)',
                                    ,
                                    ,
                                    ,
                                    '151',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '321'
                                ]
                            ],
                            BS: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '91[19]',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BS',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '91[19]',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '91[19]',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BT: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[023]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BT',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[023]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[0-6]|40404',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            BW: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '997',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BW',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '997',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '13123|99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '997'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '131\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '13100',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '131\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '13100',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            BY: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BY',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            BZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:0|11)',
                                    ,
                                    ,
                                    ,
                                    '90'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'BZ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:0|11)',
                                    ,
                                    ,
                                    ,
                                    '90'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:0|11)',
                                    ,
                                    ,
                                    ,
                                    '90'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d\\d(?:\\d\\d(?:\\d(?:\\d{2})?)?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|[29]11',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '112|30000\\d{3}|[1-35-9]\\d{4,5}|[2-9]11',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '[235-7]11',
                                    ,
                                    ,
                                    ,
                                    '211',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '300\\d{5}|[1-35-9]\\d{4,5}',
                                    ,
                                    ,
                                    ,
                                    '10000',
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        8
                                    ]
                                ]
                            ],
                            CC: [
                                ,
                                [
                                    ,
                                    ,
                                    '[01]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '000|112',
                                    ,
                                    ,
                                    ,
                                    '000'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CC',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '000|112',
                                    ,
                                    ,
                                    ,
                                    '000'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '000|112',
                                    ,
                                    ,
                                    ,
                                    '000'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CD: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[348]|77|88)',
                                    ,
                                    ,
                                    ,
                                    '113',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CD',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[348]|77|88)',
                                    ,
                                    ,
                                    ,
                                    '113',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[348]|23|77|88)|40404',
                                    ,
                                    ,
                                    ,
                                    '113'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            CF: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[78]|22\\d)',
                                    ,
                                    ,
                                    ,
                                    '117'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CF',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[78]|220)',
                                    ,
                                    ,
                                    ,
                                    '117'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[478]|220)',
                                    ,
                                    ,
                                    ,
                                    '114'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CG: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[178]',
                                    ,
                                    ,
                                    ,
                                    '111'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[78]',
                                    ,
                                    ,
                                    ,
                                    '117'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[126-8]',
                                    ,
                                    ,
                                    ,
                                    '111'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CH: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[278]|6\\d{3})|4[47])|5200',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:14|8[01589])\\d|543|83111',
                                    ,
                                    ,
                                    ,
                                    '543',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'CH',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[278]|44)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[45])|6(?:00|[1-46])|8(?:02|1[189]|50|7|8[08]|99))|[2-9]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:4[035]|6[1-46])|1(?:41|60)\\d',
                                    ,
                                    ,
                                    ,
                                    '140',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:200|35)',
                                    ,
                                    ,
                                    ,
                                    '535',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '[2-9]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    '200',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            CI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[01]|[78]0)',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CI',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[01]|[78]0)',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[01]|[78]0)|4443',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '444\\d',
                                    ,
                                    ,
                                    ,
                                    '4440',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '444\\d',
                                    ,
                                    ,
                                    ,
                                    '4440',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            CK: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '99[689]',
                                    ,
                                    ,
                                    ,
                                    '996'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CK',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '99[689]',
                                    ,
                                    ,
                                    ,
                                    '996'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '99[689]',
                                    ,
                                    ,
                                    ,
                                    '996'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CL: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:213|3[1-3])|434\\d|911',
                                    ,
                                    ,
                                    ,
                                    '131',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d',
                                    ,
                                    ,
                                    ,
                                    '1060',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'CL',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '13[1-3]|911',
                                    ,
                                    ,
                                    ,
                                    '131',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:200|333)\\d',
                                    ,
                                    ,
                                    ,
                                    '2000',
                                    ,
                                    ,
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d',
                                    ,
                                    ,
                                    ,
                                    '1060',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            CM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[18]\\d{1,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[37]|[37])',
                                    ,
                                    ,
                                    ,
                                    '13',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[37]|[37])',
                                    ,
                                    ,
                                    ,
                                    '13',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[37]|[37])|8711',
                                    ,
                                    ,
                                    ,
                                    '13'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '871\\d',
                                    ,
                                    ,
                                    ,
                                    '8710',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '871\\d',
                                    ,
                                    ,
                                    ,
                                    '8710',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            CN: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d(?:\\d{2,3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[09]|20)',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CN',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[09]|20)',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:00\\d\\d|1[029]|20)|95\\d{3,4}',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:00\\d\\d|12)|95\\d{3,4}',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CO: [
                                ,
                                [
                                    ,
                                    ,
                                    '[148]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[29]|23|32|56)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[29]|23|32|56)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|40404|85432',
                                    ,
                                    ,
                                    ,
                                    '106'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:40|85)4\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:40|85)4\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            CR: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1359]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:385|5(?:0[34]|51))\\d',
                                    ,
                                    ,
                                    ,
                                    '3850',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            CU: [
                                ,
                                [
                                    ,
                                    ,
                                    '[12]\\d\\d(?:\\d{3,4})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[4-7]|(?:116|204\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '104'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CU',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[4-6]',
                                    ,
                                    ,
                                    ,
                                    '104',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[4-7]|1(?:6111|8)|40)|2045252',
                                    ,
                                    ,
                                    ,
                                    '104'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CV: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '13[0-2]',
                                    ,
                                    ,
                                    ,
                                    '130'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CV',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '13[0-2]',
                                    ,
                                    ,
                                    ,
                                    '130'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '13[0-2]',
                                    ,
                                    ,
                                    ,
                                    '130'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CW: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CW',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|76)|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ]
                            ],
                            CX: [
                                ,
                                [
                                    ,
                                    ,
                                    '[01]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '000|112',
                                    ,
                                    ,
                                    ,
                                    '000'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CX',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '000|112',
                                    ,
                                    ,
                                    ,
                                    '000'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '000|112',
                                    ,
                                    ,
                                    ,
                                    '000'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CY: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d{3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6\\d{3})|99)',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CY',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|99)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6(?:000|111))|99)',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            CZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5[0568])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'CZ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|5[0568])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5[0568]|99)|1(?:16|4)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            DE: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d{3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:[02]|6\\d{3})',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'DE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[02]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:[025]|6(?:00[06]|1(?:1[167]|23)))',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            DJ: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'DJ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            DK: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:[24]|6\\d{3})',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'DK',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[24]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[2-48]|6(?:00[06]|111))|8(?:[08]1|1[0238]|28|30|5[13]))',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            DM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[39]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '333|9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '333'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'DM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '333|9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '333'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '333|9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '333'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            DO: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'DO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            DZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[17]\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[47]',
                                    ,
                                    ,
                                    ,
                                    '14',
                                    ,
                                    ,
                                    [2]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'DZ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[47]',
                                    ,
                                    ,
                                    ,
                                    '14',
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[47]|730',
                                    ,
                                    ,
                                    ,
                                    '14'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '730',
                                    ,
                                    ,
                                    ,
                                    '730',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '730',
                                    ,
                                    ,
                                    ,
                                    '730',
                                    ,
                                    ,
                                    [3]
                                ]
                            ],
                            EC: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[12]|12)|911',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'EC',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[12]|12)|911',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[12]|12)|911',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            EE: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))',
                                    ,
                                    ,
                                    ,
                                    '123',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'EE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[02]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))',
                                    ,
                                    ,
                                    ,
                                    '126',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            EG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[13]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:2[23]|80)',
                                    ,
                                    ,
                                    ,
                                    '122',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'EG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:2[23]|80)',
                                    ,
                                    ,
                                    ,
                                    '122',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:2[23]|[69]\\d{3}|80)|34400',
                                    ,
                                    ,
                                    ,
                                    '122'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '344\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '34400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '344\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '34400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            EH: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[59]|77)',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'EH',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[59]|77)',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[59]|77)',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ER: [
                                ,
                                [
                                    ,
                                    ,
                                    '[12]\\d\\d(?:\\d{3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[2-46]|(?:12[47]|20[12])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'ER',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ES: [
                                ,
                                [
                                    ,
                                    ,
                                    '[0-379]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '016',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '120'
                                ],
                                ,
                                ,
                                ,
                                'ES',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '08[58]|112',
                                    ,
                                    ,
                                    ,
                                    '085',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '010'
                                ],
                                [
                                    ,
                                    ,
                                    '0(?:[16][0-2]|80|9[12])|21\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '010',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:3[34]|77)|[12]2\\d{1,4}',
                                    ,
                                    ,
                                    ,
                                    '120'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '22000',
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            ET: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:07|11?|2|39?|9[17])',
                                    ,
                                    ,
                                    ,
                                    '91'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'ET',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11?|2|39?|9[17])',
                                    ,
                                    ,
                                    ,
                                    '91'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:07|11?|2|39?|45|9[17])',
                                    ,
                                    ,
                                    ,
                                    '91'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[17]\\d\\d(?:\\d{2,3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|6\\d{3})',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'FI',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|611[17])|75[12]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FJ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[0-579]\\d(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '91[17]',
                                    ,
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'FJ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '91[17]',
                                    ,
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75',
                                    ,
                                    ,
                                    ,
                                    '22'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            FK: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'FK',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d|999',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[39]\\d\\d(?:\\d{3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '320\\d{3}|911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'FM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '(?:32022|91)1',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:32022|91)1',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FO: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[24]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'FO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[24]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[248]|1(?:4[124]|71|8[7-9])\\d',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            FR: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-8]\\d{1,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:07|[13]3)|1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:118|[4-8]\\d)\\d{3}|36665',
                                    ,
                                    ,
                                    ,
                                    '36665',
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'FR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|[578])',
                                    ,
                                    ,
                                    ,
                                    '15',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    '10(?:[134]4|2[23]|5\\d|99)|202\\d|3(?:646|9[07]0)|634|70[06]|(?:106|61)[14]',
                                    ,
                                    ,
                                    ,
                                    '611',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d',
                                    ,
                                    ,
                                    ,
                                    '224',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '114|[3-8]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '114',
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ]
                            ],
                            GA: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '18|1(?:3\\d|73)\\d',
                                    ,
                                    ,
                                    ,
                                    '18'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:3\\d\\d|730|8)',
                                    ,
                                    ,
                                    ,
                                    '18'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:3\\d\\d|730|8)',
                                    ,
                                    ,
                                    ,
                                    '18'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GB: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-46-9]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999',
                                    ,
                                    ,
                                    ,
                                    '105'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GB',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|999',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901',
                                    ,
                                    ,
                                    ,
                                    '202',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d',
                                    ,
                                    ,
                                    ,
                                    '1250',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            GD: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GD',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176|911',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ]
                            ],
                            GE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[014]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:11|33)|11[1-3]|[01]22',
                                    ,
                                    ,
                                    ,
                                    '011',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:11|33)|11[1-3]|[01]22',
                                    ,
                                    ,
                                    ,
                                    '011',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:11|33)|11[1-3]|40404|[01]22',
                                    ,
                                    ,
                                    ,
                                    '011'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            GF: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GF',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|999',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|999',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GH: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14589]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[1-3]|999',
                                    ,
                                    ,
                                    ,
                                    '191',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GH',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[1-3]|999',
                                    ,
                                    ,
                                    ,
                                    '191',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '19[1-3]|40404|(?:54|83)00|999',
                                    ,
                                    ,
                                    ,
                                    '191'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d|(?:54|83)0\\d',
                                    ,
                                    ,
                                    ,
                                    '5400',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d|(?:54|83)0\\d',
                                    ,
                                    ,
                                    ,
                                    '5400',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            GI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[158]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '8[1-69]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '8100',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                ,
                                ,
                                'GI',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|9[09])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    '150|87\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '150',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GL: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GL',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GM: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[6-8]|[6-8])',
                                    ,
                                    ,
                                    ,
                                    '16'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[6-8]|[6-8])',
                                    ,
                                    ,
                                    ,
                                    '16'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[6-8]|[6-8])',
                                    ,
                                    ,
                                    ,
                                    '16'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GN: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GN',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '12\\d|40404',
                                    ,
                                    ,
                                    ,
                                    '120'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            GP: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GP',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GR: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d{2,3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[089]|1(?:2|6\\d{3})|66|99)',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:00|12|66|99)',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    '113\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '11300',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GT: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:10|2[03])',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GT',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:10|2[03])',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '110|40404|1(?:2|[57]\\d)\\d',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            GU: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GU',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GW: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[378]',
                                    ,
                                    ,
                                    ,
                                    '113'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GW',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[378]',
                                    ,
                                    ,
                                    ,
                                    '113'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[378]',
                                    ,
                                    ,
                                    ,
                                    '113'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            GY: [
                                ,
                                [
                                    ,
                                    ,
                                    '[019]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '91[1-3]',
                                    ,
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'GY',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '91[1-3]',
                                    ,
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]',
                                    ,
                                    ,
                                    ,
                                    '002'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '144\\d',
                                    ,
                                    ,
                                    ,
                                    '1440',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '144\\d',
                                    ,
                                    ,
                                    ,
                                    '1440',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            HK: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{2,6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|99[29]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'HK',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|99[29]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '109|1(?:08|85\\d)\\d',
                                    ,
                                    ,
                                    ,
                                    '109',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '992',
                                    ,
                                    ,
                                    ,
                                    '992',
                                    ,
                                    ,
                                    [3]
                                ]
                            ],
                            HN: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'HN',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '199|40404',
                                    ,
                                    ,
                                    ,
                                    '199'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            HR: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{1,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '93',
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '118\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '11800',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                ,
                                ,
                                'HR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|9[2-4])|9[34]',
                                    ,
                                    ,
                                    ,
                                    '93',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]',
                                    ,
                                    ,
                                    ,
                                    '93'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '139\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '13900',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '139\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '13900',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            HT: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[48]',
                                    ,
                                    ,
                                    ,
                                    '114',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'HT',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[48]',
                                    ,
                                    ,
                                    ,
                                    '114',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[48]|40404',
                                    ,
                                    ,
                                    ,
                                    '114'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            HU: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d{3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[457]|1(?:2|6\\d{3}))',
                                    ,
                                    ,
                                    ,
                                    '104'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'HU',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[457]|12)',
                                    ,
                                    ,
                                    ,
                                    '104',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[457]|1(?:2|6(?:000|1(?:11|23))))',
                                    ,
                                    ,
                                    ,
                                    '104'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ID: [
                                ,
                                [
                                    ,
                                    ,
                                    '[178]\\d\\d(?:\\d{2,3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[02389]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'ID',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[02389]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[02389]|40\\d\\d|50264)|71400|89887',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:714|898)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '71400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '714\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '71400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            IE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[159]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|6\\d{3})|999',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '5[37]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '53000',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                ,
                                ,
                                'IE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|999',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    '51\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '51000',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '51210',
                                    ,
                                    ,
                                    ,
                                    '51210',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '51210|(?:118|5[037]\\d)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '11800',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            IL: [
                                ,
                                [
                                    ,
                                    ,
                                    '[12]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-2]|12)',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'IL',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-2]|12)',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '104\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '10400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '104\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '10400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            IM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[189]\\d\\d(?:\\d{2,3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'IM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '8(?:64|98)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '86400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            IN: [
                                ,
                                [
                                    ,
                                    ,
                                    '[12578]\\d{2,8}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '11[67]\\d{4}|56161561',
                                    ,
                                    ,
                                    ,
                                    '1160000',
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'IN',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-28]|12|298)|2611',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:14(?:2[5-9]|[34]\\d)|757555)',
                                    ,
                                    ,
                                    ,
                                    '51425',
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])',
                                    ,
                                    ,
                                    ,
                                    '118',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)',
                                    ,
                                    ,
                                    ,
                                    '139',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        7,
                                        8
                                    ]
                                ]
                            ],
                            IQ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1479]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[04]|15|22)',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'IQ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[04]|15|22)',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[04]|15|22)|4432|71117|9988',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:443|711\\d|998)\\d',
                                    ,
                                    ,
                                    ,
                                    '4430',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:443|711\\d|998)\\d',
                                    ,
                                    ,
                                    ,
                                    '4430',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            IR: [
                                ,
                                [
                                    ,
                                    ,
                                    '[129]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[0-68]|2[0-59]|9[0-579])|911',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'IR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[025]|25)|911',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:5[0-469]|8[0-489])\\d',
                                    ,
                                    ,
                                    ,
                                    '1500',
                                    ,
                                    ,
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d',
                                    ,
                                    ,
                                    ,
                                    '1500',
                                    ,
                                    ,
                                    [
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '990\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '990000',
                                    ,
                                    ,
                                    [6]
                                ]
                            ],
                            IS: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|71\\d)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'IS',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '14(?:0\\d|41)',
                                    ,
                                    ,
                                    ,
                                    '1400',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:415|90\\d)',
                                    ,
                                    ,
                                    ,
                                    '1415',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            IT: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d{2,6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[2358]|6\\d{3})|87)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '1200',
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'IT',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[2358]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '43000',
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ]
                            ],
                            JE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[129]\\d\\d(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|999',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'JE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|999',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            JM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[029]|911',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'JM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[029]|911',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[029]|76)|911',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '176',
                                    ,
                                    ,
                                    ,
                                    '176'
                                ]
                            ],
                            JO: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[24]|9[127])|911',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'JO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|9[127])|911',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:09|1[0-248]|9[0-24-79])|9(?:0903|11|8788)',
                                    ,
                                    ,
                                    ,
                                    '109'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '9(?:09|87)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '90900',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:09|87)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '90900',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            JP: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[089]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'JP',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[09]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[24]|1[089]|44|89)',
                                    ,
                                    ,
                                    ,
                                    '102'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    '909\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '90900',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                ,
                                ,
                                'KE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[24]|999',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d',
                                    ,
                                    ,
                                    ,
                                    '130'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '141'
                                ]
                            ],
                            KG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[1-3]',
                                    ,
                                    ,
                                    ,
                                    '101',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'KG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[1-3]',
                                    ,
                                    ,
                                    ,
                                    '101',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '10[1-3]|4040',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d',
                                    ,
                                    ,
                                    ,
                                    '4040',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d',
                                    ,
                                    ,
                                    ,
                                    '4040',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            KH: [
                                ,
                                [
                                    ,
                                    ,
                                    '[146]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[7-9]|666',
                                    ,
                                    ,
                                    ,
                                    '117',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'KH',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[7-9]|666',
                                    ,
                                    ,
                                    ,
                                    '117',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[7-9]|40404|666',
                                    ,
                                    ,
                                    ,
                                    '117'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            KI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[179]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[2-5]|99[2-4]',
                                    ,
                                    ,
                                    ,
                                    '192',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'KI',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[2-5]|99[2-4]',
                                    ,
                                    ,
                                    ,
                                    '192',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    '103',
                                    ,
                                    ,
                                    ,
                                    '103',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KM: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'KM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KN: [
                                ,
                                [
                                    ,
                                    ,
                                    '[39]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '333|9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '333'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'KN',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '333|9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '333'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '333|9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '333'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KP: [
                                ,
                                [
                                    ,
                                    ,
                                    '[18]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[29]|819',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'KP',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[29]|819',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[29]|819',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KR: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[27-9]|28|330|82)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'KR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[29]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KW: [
                                ,
                                [
                                    ,
                                    ,
                                    '[18]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'KW',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[0-7]\\d|89887',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '898\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '89800',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KY: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'KY',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            KZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[134]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '101',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'KZ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '101',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-4]|12)|(?:3040|404)0',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:304\\d|404)\\d',
                                    ,
                                    ,
                                    ,
                                    '4040',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:304\\d|404)\\d',
                                    ,
                                    ,
                                    ,
                                    '4040',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            LA: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[015]',
                                    ,
                                    ,
                                    ,
                                    '190'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'LA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[015]',
                                    ,
                                    ,
                                    ,
                                    '190'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '19[015]',
                                    ,
                                    ,
                                    ,
                                    '190'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LB: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|40|75)|999',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'LB',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|40|75)|999',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|40|75)|999',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LC: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'LC',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LI: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[278]|44)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'LI',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[278]|44)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LK: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[02689]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'LK',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[02689]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LR: [
                                ,
                                [
                                    ,
                                    ,
                                    '[3489]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '355|911',
                                    ,
                                    ,
                                    ,
                                    '355',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'LR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '355|911',
                                    ,
                                    ,
                                    ,
                                    '355',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '355|4040|8(?:400|933)|911',
                                    ,
                                    ,
                                    ,
                                    '355'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:404|8(?:40|93))\\d',
                                    ,
                                    ,
                                    ,
                                    '4040',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:404|8(?:40|93))\\d',
                                    ,
                                    ,
                                    ,
                                    '4040',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            LS: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[257]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'LS',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[257]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[257]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LT: [
                                ,
                                [
                                    ,
                                    ,
                                    '[01]\\d(?:\\d(?:\\d{3})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d',
                                    ,
                                    ,
                                    ,
                                    '01'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'LT',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:11?|22?|33?)|1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '01',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))',
                                    ,
                                    ,
                                    ,
                                    '01'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LU: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:[23]|6\\d{3})',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'LU',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[23]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LV: [
                                ,
                                [
                                    ,
                                    ,
                                    '[018]\\d{1,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0[1-3]|11(?:[023]|6\\d{3})',
                                    ,
                                    ,
                                    ,
                                    '01',
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1180|821\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '1180',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'LV',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0[1-3]|11[023]',
                                    ,
                                    ,
                                    ,
                                    '01',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4',
                                    ,
                                    ,
                                    ,
                                    '01'
                                ],
                                [
                                    ,
                                    ,
                                    '1181',
                                    ,
                                    ,
                                    ,
                                    '1181',
                                    ,
                                    ,
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    '165\\d',
                                    ,
                                    ,
                                    ,
                                    '1650',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            LY: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[013]',
                                    ,
                                    ,
                                    ,
                                    '190'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'LY',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[013]',
                                    ,
                                    ,
                                    ,
                                    '190'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '19[013]',
                                    ,
                                    ,
                                    ,
                                    '190'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MA: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[59]|77)',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[59]|77)',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[59]|77)',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MC: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|[578])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MC',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|[578])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|41|[578])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MD: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MD',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|90[1-3]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ME: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|2[2-4])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'ME',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|2[2-4])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MF: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MF',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MG: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[78]|[78])',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[78]|[78])',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[78]|[78])',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MH: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MH',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MK: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6\\d{3})|9[2-4])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MK',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|9[2-4])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ML: [
                                ,
                                [
                                    ,
                                    ,
                                    '[136-8]\\d{1,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d',
                                    ,
                                    ,
                                    ,
                                    '15',
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)',
                                    ,
                                    ,
                                    ,
                                    '1220',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'ML',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15',
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    '37(?:433|575)|7400|8001\\d',
                                    ,
                                    ,
                                    ,
                                    '7400',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '3503\\d|(?:3[67]\\d|800)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '35030',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '7400',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            MM: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    ,
                                    '199'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    ,
                                    '199'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    ,
                                    '199'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MN: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[0-35]',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MN',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[0-35]',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '10[0-35]',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MO: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MP: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MP',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MQ: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|[578])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MQ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|[578])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|[578])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MR: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MS: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MS',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MT: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d{3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|6\\d{3})',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MT',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|6(?:000|1(?:11|23)))',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MU: [
                                ,
                                [
                                    ,
                                    ,
                                    '[189]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[45]|99[59]',
                                    ,
                                    ,
                                    ,
                                    '114',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MU',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[45]|99[59]',
                                    ,
                                    ,
                                    ,
                                    '114',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,4}|(?:8\\d\\d|99)\\d',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MV: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:02|1[89])',
                                    ,
                                    ,
                                    ,
                                    '102',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MV',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:02|1[89])',
                                    ,
                                    ,
                                    ,
                                    '102',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '1[45]1',
                                    ,
                                    ,
                                    ,
                                    '141',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MW: [
                                ,
                                [
                                    ,
                                    ,
                                    '[189]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '199|99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MW',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '199|99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '199|80400|99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '199'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '804\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '80400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '804\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '80400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            MX: [
                                ,
                                [
                                    ,
                                    ,
                                    '[0579]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:6[0568]|80)|911',
                                    ,
                                    ,
                                    ,
                                    '060',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:530\\d|776)\\d',
                                    ,
                                    ,
                                    ,
                                    '7760',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'MX',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:6[0568]|80)|911',
                                    ,
                                    ,
                                    ,
                                    '060',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '0[1-9]\\d|53053|7766|911',
                                    ,
                                    ,
                                    ,
                                    '010'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '0(?:[249]0|[35][01])',
                                    ,
                                    ,
                                    ,
                                    '020',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            MY: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1369]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|999',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MY',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|999',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    '666\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '66600',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:3[23679]\\d|666)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '32000',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            MZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[79]|9[78])',
                                    ,
                                    ,
                                    ,
                                    '117',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'MZ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[79]|9[78])',
                                    ,
                                    ,
                                    ,
                                    '117',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[02-5]\\d\\d|1[79]|9[78])',
                                    ,
                                    ,
                                    ,
                                    '117'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10111',
                                    ,
                                    ,
                                    ,
                                    '10111',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10111',
                                    ,
                                    ,
                                    ,
                                    '10111',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:10|93)111|(?:1\\d|9)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '900'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NC: [
                                ,
                                [
                                    ,
                                    ,
                                    '[135]\\d{1,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NC',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[5-8]',
                                    ,
                                    ,
                                    ,
                                    '15',
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    '5(?:67|88)',
                                    ,
                                    ,
                                    ,
                                    '567',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-3578]\\d(?:\\d(?:\\d{3})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:18|[578])|723\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:18|[578])|723141',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NF: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|55|77)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NF',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|55|77)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|55|77)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    ,
                                    '199',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '199|40700',
                                    ,
                                    ,
                                    ,
                                    '199'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '407\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40700',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '407\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40700',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            NI: [
                                ,
                                [
                                    ,
                                    ,
                                    '[12467]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[58]|2[08])|737\\d',
                                    ,
                                    ,
                                    ,
                                    '115'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NI',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[58]|2[08])',
                                    ,
                                    ,
                                    ,
                                    '115',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00',
                                    ,
                                    ,
                                    ,
                                    '115'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NL: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1349]\\d\\d(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|6\\d{3})|911',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NL',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '120\\d',
                                    ,
                                    ,
                                    ,
                                    '1200',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '[34]00\\d',
                                    ,
                                    ,
                                    ,
                                    '3000',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            NO: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:[023]|6\\d{3})',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[023]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8[5-9]\\d|90)',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NP: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-36]|12)|1(?:09|11)\\d',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NP',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '100',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NR: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[0-2]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[0-2]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[0-2]|23|92)',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NU: [
                                ,
                                [
                                    ,
                                    ,
                                    '[019]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'NU',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '01[05]|101|999',
                                    ,
                                    ,
                                    ,
                                    '010'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '010',
                                    ,
                                    ,
                                    ,
                                    '010'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            NZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '\\d{3,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '111',
                                    ,
                                    ,
                                    ,
                                    '111',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    '018',
                                    ,
                                    ,
                                    ,
                                    '018',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                ,
                                'NZ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '111',
                                    ,
                                    ,
                                    ,
                                    '111',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)',
                                    ,
                                    ,
                                    ,
                                    '018'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    '018'
                                ]
                            ],
                            OM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1444|999\\d',
                                    ,
                                    ,
                                    ,
                                    '1444'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'OM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1444|9999',
                                    ,
                                    ,
                                    ,
                                    '1444'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d',
                                    ,
                                    ,
                                    ,
                                    '1111'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '10[2-4]|911',
                                    ,
                                    ,
                                    ,
                                    '102'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PE: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:05|1[67])',
                                    ,
                                    ,
                                    ,
                                    '105'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:05|1[67])',
                                    ,
                                    ,
                                    ,
                                    '105'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:05|1[67])',
                                    ,
                                    ,
                                    ,
                                    '105'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PF: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PF',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[01]\\d{2,6}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '000|11[01]',
                                    ,
                                    ,
                                    ,
                                    '000',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '000|11[01]',
                                    ,
                                    ,
                                    ,
                                    '000',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '000|1(?:1[01]|5\\d\\d|6\\d{2,5})',
                                    ,
                                    ,
                                    ,
                                    '000'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '16\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    '1600',
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ]
                            ],
                            PH: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[27]|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PH',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[27]|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[27]|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PK: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{1,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2\\d?|5)|[56])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PK',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:22?|5)|[56])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:122|3[014]|[56])|11[2457-9]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PL: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d(?:\\d{2,3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|6\\d{3})|99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PL',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|99[7-9]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[13]\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15',
                                    ,
                                    ,
                                    [2]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15',
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]|3103',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '310\\d',
                                    ,
                                    ,
                                    ,
                                    '3100',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PR: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PS: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-2]|66)',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PS',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '10[0-2]',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-2]|44|66|99)',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PT: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[25]|1(?:16\\d\\d|5[1589]|8[279])\\d',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PT',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[25]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PW: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PW',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            PY: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '128|911',
                                    ,
                                    ,
                                    ,
                                    '128'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'PY',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '128|911',
                                    ,
                                    ,
                                    ,
                                    '128'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[1-4]\\d|911',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            QA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[129]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'QA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '999|(?:1|20|9[27]\\d)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            RE: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|[578])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'RE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|[578])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|[578])',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            RO: [
                                ,
                                [
                                    ,
                                    ,
                                    '[18]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|6\\d{3})',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:1(?:18[39]|[24])|8[48])\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '1200',
                                    ,
                                    ,
                                    [
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'RO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:1[24]|8[48])\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '1200',
                                    ,
                                    ,
                                    [4]
                                ]
                            ],
                            RS: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{1,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|9[2-4]',
                                    ,
                                    ,
                                    ,
                                    '92',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'RS',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|9[2-4]',
                                    ,
                                    ,
                                    ,
                                    '92',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[189]\\d{1,4}|9[2-4]',
                                    ,
                                    ,
                                    ,
                                    '92'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            RU: [
                                ,
                                [
                                    ,
                                    ,
                                    '[01]\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|(?:0|10)[1-3]',
                                    ,
                                    ,
                                    ,
                                    '01'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'RU',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|(?:0|10)[1-3]',
                                    ,
                                    ,
                                    ,
                                    '01'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '112|(?:0|10)[1-4]',
                                    ,
                                    ,
                                    ,
                                    '01'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            RW: [
                                ,
                                [
                                    ,
                                    ,
                                    '[14]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[1245]',
                                    ,
                                    ,
                                    ,
                                    '111'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'RW',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[12]',
                                    ,
                                    ,
                                    ,
                                    '111'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|6\\d{3})|9(?:11|37|9[7-9])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|9(?:11|9[79])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    '141\\d',
                                    ,
                                    ,
                                    ,
                                    '1410',
                                    ,
                                    ,
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:10|41)\\d|90[24679]',
                                    ,
                                    ,
                                    ,
                                    '902',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SB: [
                                ,
                                [
                                    ,
                                    ,
                                    '[127-9]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SB',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SC: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SC',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0\\d|1[027]|2[0-8]|3[13]|4[0-2]|[59][15]|6[1-9]|7[124-6]|8[158])|9(?:6\\d\\d|99)',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SD: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SD',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-37-9]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|(?:116\\d|900)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '11811[89]|72\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '72000',
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'SE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|90000',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912',
                                    ,
                                    ,
                                    ,
                                    '220',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '7\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '70000',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            SG: [
                                ,
                                [
                                    ,
                                    ,
                                    '[179]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '99[359]',
                                    ,
                                    ,
                                    ,
                                    '993',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '99[359]',
                                    ,
                                    ,
                                    ,
                                    '993',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '772\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '77200',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            SH: [
                                ,
                                [
                                    ,
                                    ,
                                    '[129]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SH',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}|26[01]\\d\\d|9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SI: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SI',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[23]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SJ: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[023]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SJ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[023]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[023]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SK: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6\\d{3})|5[058])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SK',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|5[058])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SL: [
                                ,
                                [
                                    ,
                                    ,
                                    '[069]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '(?:01|99)9',
                                    ,
                                    ,
                                    ,
                                    '019',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SL',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '(?:01|99)9',
                                    ,
                                    ,
                                    ,
                                    '019',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '(?:01|99)9|60400',
                                    ,
                                    ,
                                    ,
                                    '019'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '604\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '60400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '604\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '60400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            SM: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[358]',
                                    ,
                                    ,
                                    ,
                                    '113'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[358]',
                                    ,
                                    ,
                                    ,
                                    '113'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[358]',
                                    ,
                                    ,
                                    ,
                                    '113'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SN: [
                                ,
                                [
                                    ,
                                    ,
                                    '[12]\\d{1,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:515|[78])|2(?:00|1)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '17',
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:0[246]|[468])\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '24000',
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                'SN',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17',
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]',
                                    ,
                                    ,
                                    ,
                                    '12'
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:01|2)\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '22000',
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '1[46]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '1400',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '2[468]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '24000',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            SO: [
                                ,
                                [
                                    ,
                                    ,
                                    '[57-9]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '555|888|999',
                                    ,
                                    ,
                                    ,
                                    '555'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '555|888|999',
                                    ,
                                    ,
                                    ,
                                    '555'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '555|777|888|999',
                                    ,
                                    ,
                                    ,
                                    '555'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SR: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '115',
                                    ,
                                    ,
                                    ,
                                    '115',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '115',
                                    ,
                                    ,
                                    ,
                                    '115',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SS: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SS',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ST: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'ST',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SV: [
                                ,
                                [
                                    ,
                                    ,
                                    '[149]\\d\\d(?:\\d{2,3})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '116\\d{3}|911',
                                    ,
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SV',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '91[13]',
                                    ,
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '404\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '40400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            SX: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '919',
                                    ,
                                    ,
                                    ,
                                    '919'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SX',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '919',
                                    ,
                                    ,
                                    ,
                                    '919'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '919',
                                    ,
                                    ,
                                    ,
                                    '919'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SY: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[023]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SY',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[023]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[023]',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            SZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'SZ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TC: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TC',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TD: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TD',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[78]',
                                    ,
                                    ,
                                    ,
                                    '17'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TG: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[78]|7[127])',
                                    ,
                                    ,
                                    ,
                                    '117',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[78]|7[127])',
                                    ,
                                    ,
                                    ,
                                    '117',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:011|1[078]|7[127])',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TH: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55',
                                    ,
                                    ,
                                    ,
                                    '191'
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:113|2[23]\\d|5(?:09|56))',
                                    ,
                                    ,
                                    ,
                                    '1113',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                ,
                                ,
                                'TH',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:669|9[19])',
                                    ,
                                    ,
                                    ,
                                    '191'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d',
                                    ,
                                    ,
                                    ,
                                    '1103',
                                    ,
                                    ,
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    '114[89]',
                                    ,
                                    ,
                                    ,
                                    '1148',
                                    ,
                                    ,
                                    [4]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TJ: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TJ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TL: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[25]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TL',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[25]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[02]|1[25]|2[0138]|72|9[07])',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TM: [
                                ,
                                [
                                    ,
                                    ,
                                    '0\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0[1-49]',
                                    ,
                                    ,
                                    ,
                                    '01'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0[1-3]',
                                    ,
                                    ,
                                    ,
                                    '01'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '0[1-49]',
                                    ,
                                    ,
                                    ,
                                    '01'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TN: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[078]',
                                    ,
                                    ,
                                    ,
                                    '190'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TN',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[078]',
                                    ,
                                    ,
                                    ,
                                    '190'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '19[078]',
                                    ,
                                    ,
                                    ,
                                    '190'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TO: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|22|33|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TO',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|22|33|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|22|33|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TR: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TR',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[02]|55)',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    '(?:285|542)0',
                                    ,
                                    ,
                                    ,
                                    '2850',
                                    ,
                                    ,
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d',
                                    ,
                                    ,
                                    ,
                                    '144',
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ]
                            ],
                            TT: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '99[09]',
                                    ,
                                    ,
                                    ,
                                    '990'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TT',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '99[09]',
                                    ,
                                    ,
                                    ,
                                    '990'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '99[09]',
                                    ,
                                    ,
                                    ,
                                    '990'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TV: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TV',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d|911',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TW: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[0289]|1(?:81|92)\\d',
                                    ,
                                    ,
                                    ,
                                    '110'
                                ],
                                [
                                    ,
                                    ,
                                    '10[56]',
                                    ,
                                    ,
                                    ,
                                    '105',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                ,
                                'TW',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[029]',
                                    ,
                                    ,
                                    ,
                                    '110',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))',
                                    ,
                                    ,
                                    ,
                                    '100'
                                ],
                                [
                                    ,
                                    ,
                                    '1(?:65|9(?:1\\d|50|85|98))',
                                    ,
                                    ,
                                    ,
                                    '165'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            TZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[149]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[12]|999',
                                    ,
                                    ,
                                    ,
                                    '111',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'TZ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[12]|999',
                                    ,
                                    ,
                                    ,
                                    '111',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[128]|46400|999',
                                    ,
                                    ,
                                    ,
                                    '111'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '464\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '46400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '464\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '46400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            UA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[189]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|1(?:2|6\\d{3}))',
                                    ,
                                    ,
                                    ,
                                    '101',
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'UA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-3]|12)',
                                    ,
                                    ,
                                    ,
                                    '101',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '101'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '(?:118|[89]00)\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    '1180',
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            UG: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'UG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '999',
                                    ,
                                    ,
                                    ,
                                    '999'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            US: [
                                ,
                                [
                                    ,
                                    ,
                                    '[1-9]\\d{2,5}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|[69]11',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    '24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7',
                                    ,
                                    ,
                                    ,
                                    '24280',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                ,
                                ,
                                'US',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|911',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-9]11',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    '2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099',
                                    ,
                                    ,
                                    ,
                                    '23333',
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '336\\d\\d|[2-9]\\d{3}|[2356]11',
                                    ,
                                    ,
                                    ,
                                    '211',
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '[2-9]\\d{4,5}',
                                    ,
                                    ,
                                    ,
                                    '20000',
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            UY: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d{2,3}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '128|911',
                                    ,
                                    ,
                                    ,
                                    '128',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'UY',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '128|911',
                                    ,
                                    ,
                                    ,
                                    '128',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0[4-9]|1[2368]|2[0-3568]|787)|911',
                                    ,
                                    ,
                                    ,
                                    '104'
                                ],
                                [
                                    ,
                                    ,
                                    '178\\d',
                                    ,
                                    ,
                                    ,
                                    '1780',
                                    ,
                                    ,
                                    [4]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            UZ: [
                                ,
                                [
                                    ,
                                    ,
                                    '[04]\\d(?:\\d(?:\\d{2})?)?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:0[1-3]|[1-3]|50)',
                                    ,
                                    ,
                                    ,
                                    '01',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'UZ',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:0[1-3]|[1-3]|50)',
                                    ,
                                    ,
                                    ,
                                    '01',
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '0(?:0[1-3]|[1-3]|50)|45400',
                                    ,
                                    ,
                                    ,
                                    '01'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '454\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '45400',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '454\\d\\d',
                                    ,
                                    ,
                                    ,
                                    '45400',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            VA: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[2358]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'VA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[2358]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[2358]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VC: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'VC',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VE: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|71)|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'VE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|71)|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|71)|911',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VG: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'VG',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|99)',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VI: [
                                ,
                                [
                                    ,
                                    ,
                                    '9\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'VI',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '911',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VN: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[3-5]',
                                    ,
                                    ,
                                    ,
                                    '113'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'VN',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '11[3-5]',
                                    ,
                                    ,
                                    ,
                                    '113'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[3-5]',
                                    ,
                                    ,
                                    ,
                                    '113'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            VU: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'VU',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            WF: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [2]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'WF',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1[578]',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            WS: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|9[4-69])',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'WS',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '9(?:11|9[4-69])',
                                    ,
                                    ,
                                    ,
                                    '911'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])',
                                    ,
                                    ,
                                    ,
                                    '111'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '12[0-6]',
                                    ,
                                    ,
                                    ,
                                    '120'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            XK: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|9[2-4])',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'XK',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|9[2-4])',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|9[2-4])',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            YE: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[1459]',
                                    ,
                                    ,
                                    ,
                                    '191'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'YE',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '19[1459]',
                                    ,
                                    ,
                                    ,
                                    '191'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '19[1459]',
                                    ,
                                    ,
                                    ,
                                    '191'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            YT: [
                                ,
                                [
                                    ,
                                    ,
                                    '1\\d\\d?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|5)',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'YT',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|5)',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:12|5)',
                                    ,
                                    ,
                                    ,
                                    '15'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ZA: [
                                ,
                                [
                                    ,
                                    ,
                                    '[134]\\d{2,4}',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:01\\d\\d|12)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    '41(?:348|851)',
                                    ,
                                    ,
                                    ,
                                    '41348',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                ,
                                ,
                                'ZA',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:01(?:11|77)|12)',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '107'
                                ],
                                [
                                    ,
                                    ,
                                    '3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699',
                                    ,
                                    ,
                                    ,
                                    '30782',
                                    ,
                                    ,
                                    [5]
                                ],
                                [
                                    ,
                                    ,
                                    '111',
                                    ,
                                    ,
                                    ,
                                    '111',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '[34]\\d{4}',
                                    ,
                                    ,
                                    ,
                                    '30000',
                                    ,
                                    ,
                                    [5]
                                ]
                            ],
                            ZM: [
                                ,
                                [
                                    ,
                                    ,
                                    '[19]\\d\\d',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|99[139]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                ,
                                ,
                                'ZM',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|99[139]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '112|99[139]',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ],
                            ZW: [
                                ,
                                [
                                    ,
                                    ,
                                    '[139]\\d\\d(?:\\d{2})?',
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|9(?:5[023]|61|9[3-59])',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                [
                                    ,
                                    ,
                                    '3[013-57-9]\\d{3}',
                                    ,
                                    ,
                                    ,
                                    '30000',
                                    ,
                                    ,
                                    [5]
                                ],
                                ,
                                ,
                                ,
                                'ZW',
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    '112|99[3-59]',
                                    ,
                                    ,
                                    ,
                                    '112',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    '11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])',
                                    ,
                                    ,
                                    ,
                                    '112'
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ],
                                [
                                    ,
                                    ,
                                    '114|9(?:5[023]|6[0-25])',
                                    ,
                                    ,
                                    ,
                                    '114',
                                    ,
                                    ,
                                    [3]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [-1]
                                ]
                            ]
                        };
                        i18n.phonenumbers.ShortNumberInfo = function () {
                            this.regionToMetadataMap = {};
                        };
                        goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo);
                        i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_ = [
                            'BR',
                            'CL',
                            'NI'
                        ];
                        i18n.phonenumbers.ShortNumberInfo.ShortNumberCost = {
                            TOLL_FREE: 0,
                            STANDARD_RATE: 1,
                            PREMIUM_RATE: 2,
                            UNKNOWN_COST: 3
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_ = function (a) {
                            return (a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a]) ? a : [];
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_ = function (a, b) {
                            a = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            return module$contents$goog$array_contains(a, b);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion = function (a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b))
                                return !1;
                            b = this.getMetadataForRegion_(b);
                            if (!b)
                                return !1;
                            a = this.getNationalSignificantNumber_(a).length;
                            return module$contents$goog$array_contains(b.getGeneralDesc().possibleLengthArray(), a);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber = function (a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            a = this.getNationalSignificantNumber_(a).length;
                            for (var c = 0; c < b.length; c++) {
                                var d = this.getMetadataForRegion_(b[c]);
                                if (d && (d = d.getGeneralDesc().possibleLengthArray(), module$contents$goog$array_contains(d, a)))
                                    return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion = function (a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b))
                                return !1;
                            b = this.getMetadataForRegion_(b);
                            if (!b)
                                return !1;
                            a = this.getNationalSignificantNumber_(a);
                            var c = b.getGeneralDesc();
                            if (!this.matchesPossibleNumberAndNationalNumber_(a, c))
                                return !1;
                            b = b.getShortCode();
                            return this.matchesPossibleNumberAndNationalNumber_(a, b);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber = function (a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault()), c = this.getRegionCodeForShortNumberFromRegionList_(a, b);
                            return 1 < b.length && null != c ? !0 : this.isValidShortNumberForRegion(a, c);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion = function (a, b) {
                            var c = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;
                            if (!this.regionDialingFromMatchesNumber_(a, b))
                                return c.UNKNOWN_COST;
                            var d = this.getMetadataForRegion_(b);
                            if (!d)
                                return c.UNKNOWN_COST;
                            a = this.getNationalSignificantNumber_(a);
                            return module$contents$goog$array_contains(d.getGeneralDesc().possibleLengthArray(), a.length) ? this.matchesPossibleNumberAndNationalNumber_(a, d.getPremiumRate()) ? c.PREMIUM_RATE : this.matchesPossibleNumberAndNationalNumber_(a, d.getStandardRate()) ? c.STANDARD_RATE : this.matchesPossibleNumberAndNationalNumber_(a, d.getTollFree()) || this.isEmergencyNumber(a, b) ? c.TOLL_FREE : c.UNKNOWN_COST : c.UNKNOWN_COST;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost = function (a) {
                            var b = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, c = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            if (0 === c.length)
                                return b.UNKNOWN_COST;
                            if (1 === c.length)
                                return this.getExpectedCostForRegion(a, c[0]);
                            for (var d = b.TOLL_FREE, e = 0; e < c.length; e++) {
                                var f = this.getExpectedCostForRegion(a, c[e]);
                                switch (f) {
                                case b.PREMIUM_RATE:
                                    return b.PREMIUM_RATE;
                                case b.UNKNOWN_COST:
                                    d = b.UNKNOWN_COST;
                                    break;
                                case b.STANDARD_RATE:
                                    d !== b.UNKNOWN_COST && (d = b.STANDARD_RATE);
                                    break;
                                case b.TOLL_FREE:
                                    break;
                                default:
                                    throw Error('Unrecognized cost for region: ' + f);
                                }
                            }
                            return d;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_ = function (a, b) {
                            if (0 === b.length)
                                return null;
                            if (1 === b.length)
                                return b[0];
                            a = this.getNationalSignificantNumber_(a);
                            for (var c = 0; c < b.length; c++) {
                                var d = b[c], e = this.getMetadataForRegion_(d);
                                if (e && this.matchesPossibleNumberAndNationalNumber_(a, e.getShortCode()))
                                    return d;
                            }
                            return null;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions = function () {
                            return module$contents$goog$array_filter(Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata), function (a) {
                                return isNaN(a);
                            });
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber = function (a) {
                            a = this.getMetadataForRegion_(a);
                            if (!a)
                                return '';
                            a = a.getShortCode();
                            return a.hasExampleNumber() ? a.getExampleNumber() || '' : '';
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost = function (a, b) {
                            a = this.getMetadataForRegion_(a);
                            if (!a)
                                return '';
                            var c = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, d = null;
                            switch (b) {
                            case c.TOLL_FREE:
                                d = a.getTollFree();
                                break;
                            case c.STANDARD_RATE:
                                d = a.getStandardRate();
                                break;
                            case c.PREMIUM_RATE:
                                d = a.getPremiumRate();
                            }
                            return d && d.hasExampleNumber() ? d.getExampleNumber() || '' : '';
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber = function (a, b) {
                            return this.matchesEmergencyNumberHelper_(a, b, !0);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber = function (a, b) {
                            return this.matchesEmergencyNumberHelper_(a, b, !1);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_ = function (a) {
                            if (!a)
                                return null;
                            a = a.toUpperCase();
                            var b = this.regionToMetadataMap[a];
                            if (null == b) {
                                b = new goog.proto2.PbLiteSerializer();
                                var c = i18n.phonenumbers.shortnumbermetadata.countryToMetadata[a];
                                if (null == c)
                                    return null;
                                b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
                                this.regionToMetadataMap[a] = b;
                            }
                            return b;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_ = function (a, b, c) {
                            var d = i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a);
                            if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d))
                                return !1;
                            a = this.getMetadataForRegion_(b);
                            if (null == a || !a.hasEmergency())
                                return !1;
                            d = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d);
                            b = c && !module$contents$goog$array_contains(i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_, b);
                            c = a.getEmergency().getNationalNumberPatternOrDefault();
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(c, d) || b && i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(c, d);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific = function (a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            b = this.getRegionCodeForShortNumberFromRegionList_(a, b);
                            a = this.getNationalSignificantNumber_(a);
                            b = this.getMetadataForRegion_(b);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getCarrierSpecific());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion = function (a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b))
                                return !1;
                            a = this.getNationalSignificantNumber_(a);
                            b = this.getMetadataForRegion_(b);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getCarrierSpecific());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion = function (a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b))
                                return !1;
                            b = this.getMetadataForRegion_(b);
                            a = this.getNationalSignificantNumber_(a);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getSmsServices());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_ = function (a) {
                            if (!a.hasNationalNumber())
                                return '';
                            var b = '' + a.getNationalNumber();
                            return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join('0') + b : b;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_ = function (a, b) {
                            return 0 < b.possibleLengthArray().length && !module$contents$goog$array_contains(b.possibleLengthArray(), a.length) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a.toString());
                        };
                        i18n.phonenumbers.AsYouTypeFormatter = function (a) {
                            this.DIGIT_PLACEHOLDER_ = '\u2008';
                            this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_);
                            this.currentOutput_ = '';
                            this.formattingTemplate_ = new goog.string.StringBuffer();
                            this.currentFormattingPattern_ = '';
                            this.accruedInput_ = new goog.string.StringBuffer();
                            this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer();
                            this.ableToFormat_ = !0;
                            this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = !1;
                            this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance();
                            this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0;
                            this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer();
                            this.shouldAddSpaceAfterNationalPrefix_ = !1;
                            this.extractedNationalPrefix_ = '';
                            this.nationalNumber_ = new goog.string.StringBuffer();
                            this.possibleFormats_ = [];
                            this.defaultCountry_ = a;
                            this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = ' ';
                        i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata();
                        i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix('NA');
                        i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = new RegExp('^[' + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + ']*(\\$\\d[' + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + ']*)+$');
                        i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/;
                        i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3;
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function (a) {
                            a = this.phoneUtil_.getCountryCodeForRegion(a);
                            a = this.phoneUtil_.getRegionCodeForCountryCode(a);
                            a = this.phoneUtil_.getMetadataForRegion(a);
                            return null != a ? a : i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function () {
                            for (var a = this.possibleFormats_.length, b = 0; b < a; ++b) {
                                var c = this.possibleFormats_[b], d = c.getPatternOrDefault();
                                if (this.currentFormattingPattern_ == d)
                                    return !1;
                                if (this.createFormattingTemplate_(c))
                                    return this.currentFormattingPattern_ = d, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, !0;
                            }
                            return this.ableToFormat_ = !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function (a) {
                            for (var b = this.isCompleteNumber_ && 0 == this.extractedNationalPrefix_.length && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), c = b.length, d = 0; d < c; ++d) {
                                var e = b[d];
                                0 < this.extractedNationalPrefix_.length && this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault()) && !e.getNationalPrefixOptionalWhenFormatting() && !e.hasDomesticCarrierCodeFormattingRule() || (0 != this.extractedNationalPrefix_.length || this.isCompleteNumber_ || this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault()) || e.getNationalPrefixOptionalWhenFormatting()) && i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(e.getFormatOrDefault()) && this.possibleFormats_.push(e);
                            }
                            this.narrowDownPossibleFormats_(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function (a) {
                            for (var b = [], c = a.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, d = this.possibleFormats_.length, e = 0; e < d; ++e) {
                                var f = this.possibleFormats_[e];
                                if (0 == f.leadingDigitsPatternCount())
                                    b.push(this.possibleFormats_[e]);
                                else {
                                    var g = Math.min(c, f.leadingDigitsPatternCount() - 1);
                                    f = f.getLeadingDigitsPattern(g);
                                    0 == a.search(f) && b.push(this.possibleFormats_[e]);
                                }
                            }
                            this.possibleFormats_ = b;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function (a) {
                            var b = a.getPatternOrDefault();
                            this.formattingTemplate_.clear();
                            a = this.getFormattingTemplate_(b, a.getFormatOrDefault());
                            return 0 < a.length ? (this.formattingTemplate_.append(a), !0) : !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function (a, b) {
                            var c = '999999999999999'.match(a)[0];
                            if (c.length < this.nationalNumber_.getLength())
                                return '';
                            a = c.replace(new RegExp(a, 'g'), b);
                            return a = a.replace(/9/g, this.DIGIT_PLACEHOLDER_);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function () {
                            this.currentOutput_ = '';
                            this.accruedInput_.clear();
                            this.accruedInputWithoutFormatting_.clear();
                            this.formattingTemplate_.clear();
                            this.lastMatchPosition_ = 0;
                            this.currentFormattingPattern_ = '';
                            this.prefixBeforeNationalNumber_.clear();
                            this.extractedNationalPrefix_ = '';
                            this.nationalNumber_.clear();
                            this.ableToFormat_ = !0;
                            this.inputHasFormatting_ = !1;
                            this.originalPosition_ = this.positionToRemember_ = 0;
                            this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = !1;
                            this.possibleFormats_ = [];
                            this.shouldAddSpaceAfterNationalPrefix_ = !1;
                            this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function (a) {
                            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !1);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function (a) {
                            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !0);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function (a, b) {
                            this.accruedInput_.append(a);
                            b && (this.originalPosition_ = this.accruedInput_.getLength());
                            this.isDigitOrLeadingPlusSign_(a) ? a = this.normalizeAndAccrueDigitsAndPlusSign_(a, b) : (this.ableToFormat_ = !1, this.inputHasFormatting_ = !0);
                            if (!this.ableToFormat_) {
                                if (!this.inputHasFormatting_)
                                    if (this.attemptToExtractIdd_()) {
                                        if (this.attemptToExtractCountryCallingCode_())
                                            return this.attemptToChoosePatternWithPrefixExtracted_();
                                    } else if (this.ableToExtractLongerNdd_())
                                        return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
                                return this.accruedInput_.toString();
                            }
                            switch (this.accruedInputWithoutFormatting_.getLength()) {
                            case 0:
                            case 1:
                            case 2:
                                return this.accruedInput_.toString();
                            case 3:
                                if (this.attemptToExtractIdd_())
                                    this.isExpectingCountryCallingCode_ = !0;
                                else
                                    return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
                            default:
                                if (this.isExpectingCountryCallingCode_)
                                    return this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = !1), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString();
                                if (0 < this.possibleFormats_.length) {
                                    a = this.inputDigitHelper_(a);
                                    b = this.attemptToFormatAccruedDigits_();
                                    if (0 < b.length)
                                        return b;
                                    this.narrowDownPossibleFormats_(this.nationalNumber_.toString());
                                    return this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(a) : this.accruedInput_.toString();
                                }
                                return this.attemptToChooseFormattingPattern_();
                            }
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function () {
                            this.ableToFormat_ = !0;
                            this.isExpectingCountryCallingCode_ = !1;
                            this.possibleFormats_ = [];
                            this.lastMatchPosition_ = 0;
                            this.formattingTemplate_.clear();
                            this.currentFormattingPattern_ = '';
                            return this.attemptToChooseFormattingPattern_();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function () {
                            return this.extractedNationalPrefix_;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function () {
                            if (0 < this.extractedNationalPrefix_.length) {
                                var a = this.nationalNumber_.toString();
                                this.nationalNumber_.clear();
                                this.nationalNumber_.append(this.extractedNationalPrefix_);
                                this.nationalNumber_.append(a);
                                a = this.prefixBeforeNationalNumber_.toString();
                                var b = a.lastIndexOf(this.extractedNationalPrefix_);
                                this.prefixBeforeNationalNumber_.clear();
                                this.prefixBeforeNationalNumber_.append(a.substring(0, b));
                            }
                            return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function (a) {
                            return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a) || 1 == this.accruedInput_.getLength() && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function () {
                            for (var a = this.nationalNumber_.toString(), b = this.possibleFormats_.length, c = 0; c < b; ++c) {
                                var d = this.possibleFormats_[c], e = d.getPatternOrDefault();
                                if (new RegExp('^(?:' + e + ')$').test(a) && (this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()), d = a.replace(new RegExp(e, 'g'), d.getFormat()), d = this.appendNationalNumber_(d), i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d) == this.accruedInputWithoutFormatting_))
                                    return d;
                            }
                            return '';
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function (a) {
                            var b = this.prefixBeforeNationalNumber_.getLength();
                            return this.shouldAddSpaceAfterNationalPrefix_ && 0 < b && this.prefixBeforeNationalNumber_.toString().charAt(b - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + a : this.prefixBeforeNationalNumber_ + a;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function () {
                            if (!this.ableToFormat_)
                                return this.originalPosition_;
                            for (var a = 0, b = 0, c = this.accruedInputWithoutFormatting_.toString(), d = this.currentOutput_.toString(); a < this.positionToRemember_ && b < d.length;)
                                c.charAt(a) == d.charAt(b) && a++, b++;
                            return b;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function () {
                            var a = this.nationalNumber_.toString();
                            return a.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(a), a = this.attemptToFormatAccruedDigits_(), 0 < a.length ? a : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function () {
                            var a = this.nationalNumber_.toString(), b = a.length;
                            if (0 < b) {
                                for (var c = '', d = 0; d < b; d++)
                                    c = this.inputDigitHelper_(a.charAt(d));
                                return this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
                            }
                            return this.prefixBeforeNationalNumber_.toString();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function () {
                            if (1 != this.currentMetadata_.getCountryCode())
                                return !1;
                            var a = this.nationalNumber_.toString();
                            return '1' == a.charAt(0) && '0' != a.charAt(1) && '1' != a.charAt(1);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function () {
                            var a = this.nationalNumber_.toString(), b = 0;
                            if (this.isNanpaNumberWithNationalPrefix_())
                                b = 1, this.prefixBeforeNationalNumber_.append('1').append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = !0;
                            else if (this.currentMetadata_.hasNationalPrefixForParsing()) {
                                var c = new RegExp('^(?:' + this.currentMetadata_.getNationalPrefixForParsing() + ')');
                                c = a.match(c);
                                null != c && null != c[0] && 0 < c[0].length && (this.isCompleteNumber_ = !0, b = c[0].length, this.prefixBeforeNationalNumber_.append(a.substring(0, b)));
                            }
                            this.nationalNumber_.clear();
                            this.nationalNumber_.append(a.substring(b));
                            return a.substring(0, b);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function () {
                            var a = this.accruedInputWithoutFormatting_.toString(), b = new RegExp('^(?:\\' + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + '|' + this.currentMetadata_.getInternationalPrefix() + ')');
                            b = a.match(b);
                            return null != b && null != b[0] && 0 < b[0].length ? (this.isCompleteNumber_ = !0, b = b[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(a.substring(b)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(a.substring(0, b)), a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), !0) : !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function () {
                            if (0 == this.nationalNumber_.getLength())
                                return !1;
                            var a = new goog.string.StringBuffer(), b = this.phoneUtil_.extractCountryCode(this.nationalNumber_, a);
                            if (0 == b)
                                return !1;
                            this.nationalNumber_.clear();
                            this.nationalNumber_.append(a.toString());
                            a = this.phoneUtil_.getRegionCodeForCountryCode(b);
                            i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == a ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(b) : a != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(a));
                            this.prefixBeforeNationalNumber_.append('' + b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);
                            this.extractedNationalPrefix_ = '';
                            return !0;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function (a, b) {
                            if (a == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
                                var c = a;
                                this.accruedInputWithoutFormatting_.append(a);
                            } else
                                c = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a], this.accruedInputWithoutFormatting_.append(c), this.nationalNumber_.append(c);
                            b && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength());
                            return c;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function (a) {
                            var b = this.formattingTemplate_.toString();
                            if (0 <= b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
                                var c = b.search(this.DIGIT_PATTERN_);
                                a = b.replace(this.DIGIT_PATTERN_, a);
                                this.formattingTemplate_.clear();
                                this.formattingTemplate_.append(a);
                                this.lastMatchPosition_ = c;
                                return a.substring(0, this.lastMatchPosition_ + 1);
                            }
                            1 == this.possibleFormats_.length && (this.ableToFormat_ = !1);
                            this.currentFormattingPattern_ = '';
                            return this.accruedInput_.toString();
                        };
                        Object.defineProperty(exports, '__esModule', { value: !0 });
                        exports.default = i18n.phonenumbers;
                        module.exports = exports['default'];
                    }.call(this));
                }.call(this, typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {}));
            },
            {}
        ]
    }, {}, [1])(1);
}));
define('common-modules/forms/views/fields/phone-locale-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/text-input',
    'common-modules/forms/views/fields/validation-messages',
    'common-modules/utils/countries/countries',
    'common-vendor/google-libphonenumber/dist/browser/libphonenumber'
], function (BaseField, TextView, validationMessages, countries, phoneNumberValidator) {
    'use strict';
    return BaseField.extend({
        initialize: function (options) {
            BaseField.prototype.initialize.call(this, options);
            this.autoPrefix = this.schema.autoPrefix;
            this.phoneNumberUtil = phoneNumberValidator.PhoneNumberUtil.getInstance();
            if (this.autoPrefix) {
                this._initAutoPrefix();
            }
        },
        initSubView: function () {
            return new TextView({ name: 'phone' });
        },
        _initAutoPrefix: function () {
            var iso3DefaultCountryCode = this.getDefaultCountry() || this.constructor.DEFAULT_COUNTRY_CODE.iso3;
            var defaultCountryCode = _.findWhere(countries, { value_iso3: iso3DefaultCountryCode }).value;
            this.prefixValue = this.schema.prefix = '+' + this.phoneNumberUtil.getCountryCodeForRegion(defaultCountryCode);
            this.listenTo(this.options.form, 'country:change', function (model, value) {
                this._updatePrefix(value.getValue());
            });
        },
        getDefaultCountry: function () {
            return _.result(this.schema, 'defaultCountry');
        },
        getValue: function () {
            var prefix = this.autoPrefix ? this.prefixValue : '';
            return prefix + this.subView.val();
        },
        setValue: function (value) {
            this.subView.val(this.sanitize(value));
        },
        sanitize: function (value) {
            if (value) {
                return value.replace(/[^\d+]*/gi, '');
            }
            return value;
        },
        onFieldChange: function () {
            if (!this.autoPrefix) {
                this.subView.val(this.sanitize(this.getValue()));
            }
            this.trigger('change', this);
        },
        validate: function () {
            var errors = BaseField.prototype.validate.call(this);
            if (errors) {
                return errors;
            }
            var countryCodeField = this.schema.countryCodeValidationField, iso3CountryCodeValidation = '';
            if (countryCodeField) {
                iso3CountryCodeValidation = this.form.fields[countryCodeField].getValue();
            }
            if (iso3CountryCodeValidation === '' || this.getValue() === '') {
                return;
            }
            if (!this._validatePhoneNumber(iso3CountryCodeValidation, this.getValue())) {
                return this._getErrorMsg();
            }
        },
        _updatePrefix: function (countryCode) {
            var iso2CountryCode = _.findWhere(countries, { value_iso3: countryCode }).value;
            this.prefixValue = '+' + this.phoneNumberUtil.getCountryCodeForRegion(iso2CountryCode);
            this.$prefix.find('label').html(this.prefixValue);
        },
        _validatePhoneNumber: function (iso3CountryCodeValidation, number) {
            var countryCode = this._getCountryCode(iso3CountryCodeValidation);
            try {
                var parsedNum = this.phoneNumberUtil.parse(number, countryCode);
                return this.phoneNumberUtil.isValidNumber(parsedNum);
            } catch (err) {
                return false;
            }
        },
        _getErrorMsg: function () {
            return {
                type: 'phoneNumber',
                message: validationMessages.phoneNumber
            };
        },
        _getCountryCode: function (iso3DigitCountry) {
            return _.findWhere(countries, { value_iso3: iso3DigitCountry }).value;
        }
    }, {
        DEFAULT_COUNTRY_CODE: {
            iso3: 'USA',
            iso2: 'US'
        }
    });
});
define('moment', [], function () {
    return function (e) {
        function t(n) {
            if (a[n])
                return a[n].exports;
            var s = a[n] = {
                exports: {},
                id: n,
                loaded: !1
            };
            return e[n].call(s.exports, s, s.exports, t), s.loaded = !0, s.exports;
        }
        var a = {};
        return t.m = e, t.c = a, t.p = '', t(0);
    }([
        function (e, t, a) {
            e.exports = a(11);
        },
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        function (e, t, a) {
            var n;
            (function (e) {
                !function (t, a) {
                    e.exports = a();
                }(this, function () {
                    'use strict';
                    function t() {
                        return ss.apply(null, arguments);
                    }
                    function s(e) {
                        ss = e;
                    }
                    function r(e) {
                        return e instanceof Array || '[object Array]' === Object.prototype.toString.call(e);
                    }
                    function i(e) {
                        return null != e && '[object Object]' === Object.prototype.toString.call(e);
                    }
                    function d(e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t);
                    }
                    function _(e) {
                        if (Object.getOwnPropertyNames)
                            return 0 === Object.getOwnPropertyNames(e).length;
                        var t;
                        for (t in e)
                            if (d(e, t))
                                return !1;
                        return !0;
                    }
                    function o(e) {
                        return void 0 === e;
                    }
                    function u(e) {
                        return 'number' == typeof e || '[object Number]' === Object.prototype.toString.call(e);
                    }
                    function m(e) {
                        return e instanceof Date || '[object Date]' === Object.prototype.toString.call(e);
                    }
                    function l(e, t) {
                        var a, n = [], s = e.length;
                        for (a = 0; a < s; ++a)
                            n.push(t(e[a], a));
                        return n;
                    }
                    function h(e, t) {
                        for (var a in t)
                            d(t, a) && (e[a] = t[a]);
                        return d(t, 'toString') && (e.toString = t.toString), d(t, 'valueOf') && (e.valueOf = t.valueOf), e;
                    }
                    function c(e, t, a, n) {
                        return Ht(e, t, a, n, !0).utc();
                    }
                    function M() {
                        return {
                            empty: !1,
                            unusedTokens: [],
                            unusedInput: [],
                            overflow: -2,
                            charsLeftOver: 0,
                            nullInput: !1,
                            invalidEra: null,
                            invalidMonth: null,
                            invalidFormat: !1,
                            userInvalidated: !1,
                            iso: !1,
                            parsedDateParts: [],
                            era: null,
                            meridiem: null,
                            rfc2822: !1,
                            weekdayMismatch: !1
                        };
                    }
                    function L(e) {
                        return null == e._pf && (e._pf = M()), e._pf;
                    }
                    function Y(e) {
                        if (null == e._isValid) {
                            var t = L(e), a = rs.call(t.parsedDateParts, function (e) {
                                    return null != e;
                                }), n = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && a);
                            if (e._strict && (n = n && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour), null != Object.isFrozen && Object.isFrozen(e))
                                return n;
                            e._isValid = n;
                        }
                        return e._isValid;
                    }
                    function y(e) {
                        var t = c(NaN);
                        return null != e ? h(L(t), e) : L(t).userInvalidated = !0, t;
                    }
                    function f(e, t) {
                        var a, n, s, r = is.length;
                        if (o(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), o(t._i) || (e._i = t._i), o(t._f) || (e._f = t._f), o(t._l) || (e._l = t._l), o(t._strict) || (e._strict = t._strict), o(t._tzm) || (e._tzm = t._tzm), o(t._isUTC) || (e._isUTC = t._isUTC), o(t._offset) || (e._offset = t._offset), o(t._pf) || (e._pf = L(t)), o(t._locale) || (e._locale = t._locale), r > 0)
                            for (a = 0; a < r; a++)
                                n = is[a], s = t[n], o(s) || (e[n] = s);
                        return e;
                    }
                    function p(e) {
                        f(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), ds === !1 && (ds = !0, t.updateOffset(this), ds = !1);
                    }
                    function k(e) {
                        return e instanceof p || null != e && null != e._isAMomentObject;
                    }
                    function D(e) {
                        t.suppressDeprecationWarnings === !1 && 'undefined' != typeof console && console.warn && console.warn('Deprecation warning: ' + e);
                    }
                    function g(e, a) {
                        var n = !0;
                        return h(function () {
                            if (null != t.deprecationHandler && t.deprecationHandler(null, e), n) {
                                var s, r, i, _ = [], o = arguments.length;
                                for (r = 0; r < o; r++) {
                                    if (s = '', 'object' == typeof arguments[r]) {
                                        s += '\n[' + r + '] ';
                                        for (i in arguments[0])
                                            d(arguments[0], i) && (s += i + ': ' + arguments[0][i] + ', ');
                                        s = s.slice(0, -2);
                                    } else
                                        s = arguments[r];
                                    _.push(s);
                                }
                                D(e + '\nArguments: ' + Array.prototype.slice.call(_).join('') + '\n' + new Error().stack), n = !1;
                            }
                            return a.apply(this, arguments);
                        }, a);
                    }
                    function T(e, a) {
                        null != t.deprecationHandler && t.deprecationHandler(e, a), _s[e] || (D(a), _s[e] = !0);
                    }
                    function w(e) {
                        return 'undefined' != typeof Function && e instanceof Function || '[object Function]' === Object.prototype.toString.call(e);
                    }
                    function v(e) {
                        var t, a;
                        for (a in e)
                            d(e, a) && (t = e[a], w(t) ? this[a] = t : this['_' + a] = t);
                        this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
                    }
                    function b(e, t) {
                        var a, n = h({}, e);
                        for (a in t)
                            d(t, a) && (i(e[a]) && i(t[a]) ? (n[a] = {}, h(n[a], e[a]), h(n[a], t[a])) : null != t[a] ? n[a] = t[a] : delete n[a]);
                        for (a in e)
                            d(e, a) && !d(t, a) && i(e[a]) && (n[a] = h({}, n[a]));
                        return n;
                    }
                    function S(e) {
                        null != e && this.set(e);
                    }
                    function H(e, t, a) {
                        var n = this._calendar[e] || this._calendar.sameElse;
                        return w(n) ? n.call(t, a) : n;
                    }
                    function j(e, t, a) {
                        var n = '' + Math.abs(e), s = t - n.length, r = e >= 0;
                        return (r ? a ? '+' : '' : '-') + Math.pow(10, Math.max(0, s)).toString().substr(1) + n;
                    }
                    function x(e, t, a, n) {
                        var s = n;
                        'string' == typeof n && (s = function () {
                            return this[n]();
                        }), e && (Ms[e] = s), t && (Ms[t[0]] = function () {
                            return j(s.apply(this, arguments), t[1], t[2]);
                        }), a && (Ms[a] = function () {
                            return this.localeData().ordinal(s.apply(this, arguments), e);
                        });
                    }
                    function P(e) {
                        return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, '') : e.replace(/\\/g, '');
                    }
                    function O(e) {
                        var t, a, n = e.match(ls);
                        for (t = 0, a = n.length; t < a; t++)
                            Ms[n[t]] ? n[t] = Ms[n[t]] : n[t] = P(n[t]);
                        return function (t) {
                            var s, r = '';
                            for (s = 0; s < a; s++)
                                r += w(n[s]) ? n[s].call(t, e) : n[s];
                            return r;
                        };
                    }
                    function W(e, t) {
                        return e.isValid() ? (t = A(t, e.localeData()), cs[t] = cs[t] || O(t), cs[t](e)) : e.localeData().invalidDate();
                    }
                    function A(e, t) {
                        function a(e) {
                            return t.longDateFormat(e) || e;
                        }
                        var n = 5;
                        for (hs.lastIndex = 0; n >= 0 && hs.test(e);)
                            e = e.replace(hs, a), hs.lastIndex = 0, n -= 1;
                        return e;
                    }
                    function E(e) {
                        var t = this._longDateFormat[e], a = this._longDateFormat[e.toUpperCase()];
                        return t || !a ? t : (this._longDateFormat[e] = a.match(ls).map(function (e) {
                            return 'MMMM' === e || 'MM' === e || 'DD' === e || 'dddd' === e ? e.slice(1) : e;
                        }).join(''), this._longDateFormat[e]);
                    }
                    function F() {
                        return this._invalidDate;
                    }
                    function z(e) {
                        return this._ordinal.replace('%d', e);
                    }
                    function N(e, t, a, n) {
                        var s = this._relativeTime[a];
                        return w(s) ? s(e, t, a, n) : s.replace(/%d/i, e);
                    }
                    function J(e, t) {
                        var a = this._relativeTime[e > 0 ? 'future' : 'past'];
                        return w(a) ? a(t) : a.replace(/%s/i, t);
                    }
                    function R(e, t) {
                        var a = e.toLowerCase();
                        ks[a] = ks[a + 's'] = ks[t] = e;
                    }
                    function C(e) {
                        return 'string' == typeof e ? ks[e] || ks[e.toLowerCase()] : void 0;
                    }
                    function I(e) {
                        var t, a, n = {};
                        for (a in e)
                            d(e, a) && (t = C(a), t && (n[t] = e[a]));
                        return n;
                    }
                    function U(e, t) {
                        Ds[e] = t;
                    }
                    function G(e) {
                        var t, a = [];
                        for (t in e)
                            d(e, t) && a.push({
                                unit: t,
                                priority: Ds[t]
                            });
                        return a.sort(function (e, t) {
                            return e.priority - t.priority;
                        }), a;
                    }
                    function V(e) {
                        return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
                    }
                    function B(e) {
                        return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
                    }
                    function K(e) {
                        var t = +e, a = 0;
                        return 0 !== t && isFinite(t) && (a = B(t)), a;
                    }
                    function q(e, a) {
                        return function (n) {
                            return null != n ? ($(this, e, n), t.updateOffset(this, a), this) : Z(this, e);
                        };
                    }
                    function Z(e, t) {
                        return e.isValid() ? e._d['get' + (e._isUTC ? 'UTC' : '') + t]() : NaN;
                    }
                    function $(e, t, a) {
                        e.isValid() && !isNaN(a) && ('FullYear' === t && V(e.year()) && 1 === e.month() && 29 === e.date() ? (a = K(a), e._d['set' + (e._isUTC ? 'UTC' : '') + t](a, e.month(), _e(a, e.month()))) : e._d['set' + (e._isUTC ? 'UTC' : '') + t](a));
                    }
                    function Q(e) {
                        return e = C(e), w(this[e]) ? this[e]() : this;
                    }
                    function X(e, t) {
                        if ('object' == typeof e) {
                            e = I(e);
                            var a, n = G(e), s = n.length;
                            for (a = 0; a < s; a++)
                                this[n[a].unit](e[n[a].unit]);
                        } else if (e = C(e), w(this[e]))
                            return this[e](t);
                        return this;
                    }
                    function ee(e, t, a) {
                        us[e] = w(t) ? t : function (e, n) {
                            return e && a ? a : t;
                        };
                    }
                    function te(e, t) {
                        return d(us, e) ? us[e](t._strict, t._locale) : new RegExp(ae(e));
                    }
                    function ae(e) {
                        return ne(e.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, a, n, s) {
                            return t || a || n || s;
                        }));
                    }
                    function ne(e) {
                        return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                    }
                    function se(e, t) {
                        var a, n, s = t;
                        for ('string' == typeof e && (e = [e]), u(t) && (s = function (e, a) {
                                a[t] = K(e);
                            }), n = e.length, a = 0; a < n; a++)
                            Rs[e[a]] = s;
                    }
                    function re(e, t) {
                        se(e, function (e, a, n, s) {
                            n._w = n._w || {}, t(e, n._w, n, s);
                        });
                    }
                    function ie(e, t, a) {
                        null != t && d(Rs, e) && Rs[e](t, a._a, a, e);
                    }
                    function de(e, t) {
                        return (e % t + t) % t;
                    }
                    function _e(e, t) {
                        if (isNaN(e) || isNaN(t))
                            return NaN;
                        var a = de(t, 12);
                        return e += (t - a) / 12, 1 === a ? V(e) ? 29 : 28 : 31 - a % 7 % 2;
                    }
                    function oe(e, t) {
                        return e ? r(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Xs).test(t) ? 'format' : 'standalone'][e.month()] : r(this._months) ? this._months : this._months.standalone;
                    }
                    function ue(e, t) {
                        return e ? r(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Xs.test(t) ? 'format' : 'standalone'][e.month()] : r(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
                    }
                    function me(e, t, a) {
                        var n, s, r, i = e.toLocaleLowerCase();
                        if (!this._monthsParse)
                            for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
                                r = c([
                                    2000,
                                    n
                                ]), this._shortMonthsParse[n] = this.monthsShort(r, '').toLocaleLowerCase(), this._longMonthsParse[n] = this.months(r, '').toLocaleLowerCase();
                        return a ? 'MMM' === t ? (s = Js.call(this._shortMonthsParse, i), s !== -1 ? s : null) : (s = Js.call(this._longMonthsParse, i), s !== -1 ? s : null) : 'MMM' === t ? (s = Js.call(this._shortMonthsParse, i), s !== -1 ? s : (s = Js.call(this._longMonthsParse, i), s !== -1 ? s : null)) : (s = Js.call(this._longMonthsParse, i), s !== -1 ? s : (s = Js.call(this._shortMonthsParse, i), s !== -1 ? s : null));
                    }
                    function le(e, t, a) {
                        var n, s, r;
                        if (this._monthsParseExact)
                            return me.call(this, e, t, a);
                        for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
                            if (s = c([
                                    2000,
                                    n
                                ]), a && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp('^' + this.months(s, '').replace('.', '') + '$', 'i'), this._shortMonthsParse[n] = new RegExp('^' + this.monthsShort(s, '').replace('.', '') + '$', 'i')), a || this._monthsParse[n] || (r = '^' + this.months(s, '') + '|^' + this.monthsShort(s, ''), this._monthsParse[n] = new RegExp(r.replace('.', ''), 'i')), a && 'MMMM' === t && this._longMonthsParse[n].test(e))
                                return n;
                            if (a && 'MMM' === t && this._shortMonthsParse[n].test(e))
                                return n;
                            if (!a && this._monthsParse[n].test(e))
                                return n;
                        }
                    }
                    function he(e, t) {
                        var a;
                        if (!e.isValid())
                            return e;
                        if ('string' == typeof t)
                            if (/^\d+$/.test(t))
                                t = K(t);
                            else if (t = e.localeData().monthsParse(t), !u(t))
                                return e;
                        return a = Math.min(e.date(), _e(e.year(), t)), e._d['set' + (e._isUTC ? 'UTC' : '') + 'Month'](t, a), e;
                    }
                    function ce(e) {
                        return null != e ? (he(this, e), t.updateOffset(this, !0), this) : Z(this, 'Month');
                    }
                    function Me() {
                        return _e(this.year(), this.month());
                    }
                    function Le(e) {
                        return this._monthsParseExact ? (d(this, '_monthsRegex') || ye.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (d(this, '_monthsShortRegex') || (this._monthsShortRegex = er), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
                    }
                    function Ye(e) {
                        return this._monthsParseExact ? (d(this, '_monthsRegex') || ye.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (d(this, '_monthsRegex') || (this._monthsRegex = tr), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
                    }
                    function ye() {
                        function e(e, t) {
                            return t.length - e.length;
                        }
                        var t, a, n = [], s = [], r = [];
                        for (t = 0; t < 12; t++)
                            a = c([
                                2000,
                                t
                            ]), n.push(this.monthsShort(a, '')), s.push(this.months(a, '')), r.push(this.months(a, '')), r.push(this.monthsShort(a, ''));
                        for (n.sort(e), s.sort(e), r.sort(e), t = 0; t < 12; t++)
                            n[t] = ne(n[t]), s[t] = ne(s[t]);
                        for (t = 0; t < 24; t++)
                            r[t] = ne(r[t]);
                        this._monthsRegex = new RegExp('^(' + r.join('|') + ')', 'i'), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp('^(' + s.join('|') + ')', 'i'), this._monthsShortStrictRegex = new RegExp('^(' + n.join('|') + ')', 'i');
                    }
                    function fe(e) {
                        return V(e) ? 366 : 365;
                    }
                    function pe() {
                        return V(this.year());
                    }
                    function ke(e, t, a, n, s, r, i) {
                        var d;
                        return e < 100 && e >= 0 ? (d = new Date(e + 400, t, a, n, s, r, i), isFinite(d.getFullYear()) && d.setFullYear(e)) : d = new Date(e, t, a, n, s, r, i), d;
                    }
                    function De(e) {
                        var t, a;
                        return e < 100 && e >= 0 ? (a = Array.prototype.slice.call(arguments), a[0] = e + 400, t = new Date(Date.UTC.apply(null, a)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
                    }
                    function ge(e, t, a) {
                        var n = 7 + t - a, s = (7 + De(e, 0, n).getUTCDay() - t) % 7;
                        return -s + n - 1;
                    }
                    function Te(e, t, a, n, s) {
                        var r, i, d = (7 + a - n) % 7, _ = ge(e, n, s), o = 1 + 7 * (t - 1) + d + _;
                        return o <= 0 ? (r = e - 1, i = fe(r) + o) : o > fe(e) ? (r = e + 1, i = o - fe(e)) : (r = e, i = o), {
                            year: r,
                            dayOfYear: i
                        };
                    }
                    function we(e, t, a) {
                        var n, s, r = ge(e.year(), t, a), i = Math.floor((e.dayOfYear() - r - 1) / 7) + 1;
                        return i < 1 ? (s = e.year() - 1, n = i + ve(s, t, a)) : i > ve(e.year(), t, a) ? (n = i - ve(e.year(), t, a), s = e.year() + 1) : (s = e.year(), n = i), {
                            week: n,
                            year: s
                        };
                    }
                    function ve(e, t, a) {
                        var n = ge(e, t, a), s = ge(e + 1, t, a);
                        return (fe(e) - n + s) / 7;
                    }
                    function be(e) {
                        return we(e, this._week.dow, this._week.doy).week;
                    }
                    function Se() {
                        return this._week.dow;
                    }
                    function He() {
                        return this._week.doy;
                    }
                    function je(e) {
                        var t = this.localeData().week(this);
                        return null == e ? t : this.add(7 * (e - t), 'd');
                    }
                    function xe(e) {
                        var t = we(this, 1, 4).week;
                        return null == e ? t : this.add(7 * (e - t), 'd');
                    }
                    function Pe(e, t) {
                        return 'string' != typeof e ? e : isNaN(e) ? (e = t.weekdaysParse(e), 'number' == typeof e ? e : null) : parseInt(e, 10);
                    }
                    function Oe(e, t) {
                        return 'string' == typeof e ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
                    }
                    function We(e, t) {
                        return e.slice(t, 7).concat(e.slice(0, t));
                    }
                    function Ae(e, t) {
                        var a = r(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? 'format' : 'standalone'];
                        return e === !0 ? We(a, this._week.dow) : e ? a[e.day()] : a;
                    }
                    function Ee(e) {
                        return e === !0 ? We(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
                    }
                    function Fe(e) {
                        return e === !0 ? We(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
                    }
                    function ze(e, t, a) {
                        var n, s, r, i = e.toLocaleLowerCase();
                        if (!this._weekdaysParse)
                            for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
                                r = c([
                                    2000,
                                    1
                                ]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(r, '').toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(r, '').toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(r, '').toLocaleLowerCase();
                        return a ? 'dddd' === t ? (s = Js.call(this._weekdaysParse, i), s !== -1 ? s : null) : 'ddd' === t ? (s = Js.call(this._shortWeekdaysParse, i), s !== -1 ? s : null) : (s = Js.call(this._minWeekdaysParse, i), s !== -1 ? s : null) : 'dddd' === t ? (s = Js.call(this._weekdaysParse, i), s !== -1 ? s : (s = Js.call(this._shortWeekdaysParse, i), s !== -1 ? s : (s = Js.call(this._minWeekdaysParse, i), s !== -1 ? s : null))) : 'ddd' === t ? (s = Js.call(this._shortWeekdaysParse, i), s !== -1 ? s : (s = Js.call(this._weekdaysParse, i), s !== -1 ? s : (s = Js.call(this._minWeekdaysParse, i), s !== -1 ? s : null))) : (s = Js.call(this._minWeekdaysParse, i), s !== -1 ? s : (s = Js.call(this._weekdaysParse, i), s !== -1 ? s : (s = Js.call(this._shortWeekdaysParse, i), s !== -1 ? s : null)));
                    }
                    function Ne(e, t, a) {
                        var n, s, r;
                        if (this._weekdaysParseExact)
                            return ze.call(this, e, t, a);
                        for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
                            if (s = c([
                                    2000,
                                    1
                                ]).day(n), a && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp('^' + this.weekdays(s, '').replace('.', '\\.?') + '$', 'i'), this._shortWeekdaysParse[n] = new RegExp('^' + this.weekdaysShort(s, '').replace('.', '\\.?') + '$', 'i'), this._minWeekdaysParse[n] = new RegExp('^' + this.weekdaysMin(s, '').replace('.', '\\.?') + '$', 'i')), this._weekdaysParse[n] || (r = '^' + this.weekdays(s, '') + '|^' + this.weekdaysShort(s, '') + '|^' + this.weekdaysMin(s, ''), this._weekdaysParse[n] = new RegExp(r.replace('.', ''), 'i')), a && 'dddd' === t && this._fullWeekdaysParse[n].test(e))
                                return n;
                            if (a && 'ddd' === t && this._shortWeekdaysParse[n].test(e))
                                return n;
                            if (a && 'dd' === t && this._minWeekdaysParse[n].test(e))
                                return n;
                            if (!a && this._weekdaysParse[n].test(e))
                                return n;
                        }
                    }
                    function Je(e) {
                        if (!this.isValid())
                            return null != e ? this : NaN;
                        var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                        return null != e ? (e = Pe(e, this.localeData()), this.add(e - t, 'd')) : t;
                    }
                    function Re(e) {
                        if (!this.isValid())
                            return null != e ? this : NaN;
                        var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
                        return null == e ? t : this.add(e - t, 'd');
                    }
                    function Ce(e) {
                        if (!this.isValid())
                            return null != e ? this : NaN;
                        if (null != e) {
                            var t = Oe(e, this.localeData());
                            return this.day(this.day() % 7 ? t : t - 7);
                        }
                        return this.day() || 7;
                    }
                    function Ie(e) {
                        return this._weekdaysParseExact ? (d(this, '_weekdaysRegex') || Ve.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (d(this, '_weekdaysRegex') || (this._weekdaysRegex = dr), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
                    }
                    function Ue(e) {
                        return this._weekdaysParseExact ? (d(this, '_weekdaysRegex') || Ve.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (d(this, '_weekdaysShortRegex') || (this._weekdaysShortRegex = _r), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
                    }
                    function Ge(e) {
                        return this._weekdaysParseExact ? (d(this, '_weekdaysRegex') || Ve.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (d(this, '_weekdaysMinRegex') || (this._weekdaysMinRegex = or), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
                    }
                    function Ve() {
                        function e(e, t) {
                            return t.length - e.length;
                        }
                        var t, a, n, s, r, i = [], d = [], _ = [], o = [];
                        for (t = 0; t < 7; t++)
                            a = c([
                                2000,
                                1
                            ]).day(t), n = ne(this.weekdaysMin(a, '')), s = ne(this.weekdaysShort(a, '')), r = ne(this.weekdays(a, '')), i.push(n), d.push(s), _.push(r), o.push(n), o.push(s), o.push(r);
                        i.sort(e), d.sort(e), _.sort(e), o.sort(e), this._weekdaysRegex = new RegExp('^(' + o.join('|') + ')', 'i'), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp('^(' + _.join('|') + ')', 'i'), this._weekdaysShortStrictRegex = new RegExp('^(' + d.join('|') + ')', 'i'), this._weekdaysMinStrictRegex = new RegExp('^(' + i.join('|') + ')', 'i');
                    }
                    function Be() {
                        return this.hours() % 12 || 12;
                    }
                    function Ke() {
                        return this.hours() || 24;
                    }
                    function qe(e, t) {
                        x(e, 0, 0, function () {
                            return this.localeData().meridiem(this.hours(), this.minutes(), t);
                        });
                    }
                    function Ze(e, t) {
                        return t._meridiemParse;
                    }
                    function $e(e) {
                        return 'p' === (e + '').toLowerCase().charAt(0);
                    }
                    function Qe(e, t, a) {
                        return e > 11 ? a ? 'pm' : 'PM' : a ? 'am' : 'AM';
                    }
                    function Xe(e, t) {
                        var a, n = Math.min(e.length, t.length);
                        for (a = 0; a < n; a += 1)
                            if (e[a] !== t[a])
                                return a;
                        return n;
                    }
                    function et(e) {
                        return e ? e.toLowerCase().replace('_', '-') : e;
                    }
                    function tt(e) {
                        for (var t, a, n, s, r = 0; r < e.length;) {
                            for (s = et(e[r]).split('-'), t = s.length, a = et(e[r + 1]), a = a ? a.split('-') : null; t > 0;) {
                                if (n = nt(s.slice(0, t).join('-')))
                                    return n;
                                if (a && a.length >= t && Xe(s, a) >= t - 1)
                                    break;
                                t--;
                            }
                            r++;
                        }
                        return ur;
                    }
                    function at(e) {
                        return null != e.match('^[^/\\\\]*$');
                    }
                    function nt(t) {
                        var s, r = null;
                        if (void 0 === cr[t] && 'undefined' != typeof e && e && e.exports && at(t))
                            try {
                                r = ur._abbr, s = n, a(13)('./' + t), st(r);
                            } catch (e) {
                                cr[t] = null;
                            }
                        return cr[t];
                    }
                    function st(e, t) {
                        var a;
                        return e && (a = o(t) ? dt(e) : rt(e, t), a ? ur = a : 'undefined' != typeof console && console.warn && console.warn('Locale ' + e + ' not found. Did you forget to load it?')), ur._abbr;
                    }
                    function rt(e, t) {
                        if (null !== t) {
                            var a, n = hr;
                            if (t.abbr = e, null != cr[e])
                                T('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'), n = cr[e]._config;
                            else if (null != t.parentLocale)
                                if (null != cr[t.parentLocale])
                                    n = cr[t.parentLocale]._config;
                                else {
                                    if (a = nt(t.parentLocale), null == a)
                                        return Mr[t.parentLocale] || (Mr[t.parentLocale] = []), Mr[t.parentLocale].push({
                                            name: e,
                                            config: t
                                        }), null;
                                    n = a._config;
                                }
                            return cr[e] = new S(b(n, t)), Mr[e] && Mr[e].forEach(function (e) {
                                rt(e.name, e.config);
                            }), st(e), cr[e];
                        }
                        return delete cr[e], null;
                    }
                    function it(e, t) {
                        if (null != t) {
                            var a, n, s = hr;
                            null != cr[e] && null != cr[e].parentLocale ? cr[e].set(b(cr[e]._config, t)) : (n = nt(e), null != n && (s = n._config), t = b(s, t), null == n && (t.abbr = e), a = new S(t), a.parentLocale = cr[e], cr[e] = a), st(e);
                        } else
                            null != cr[e] && (null != cr[e].parentLocale ? (cr[e] = cr[e].parentLocale, e === st() && st(e)) : null != cr[e] && delete cr[e]);
                        return cr[e];
                    }
                    function dt(e) {
                        var t;
                        if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
                            return ur;
                        if (!r(e)) {
                            if (t = nt(e))
                                return t;
                            e = [e];
                        }
                        return tt(e);
                    }
                    function _t() {
                        return os(cr);
                    }
                    function ot(e) {
                        var t, a = e._a;
                        return a && L(e).overflow === -2 && (t = a[Is] < 0 || a[Is] > 11 ? Is : a[Us] < 1 || a[Us] > _e(a[Cs], a[Is]) ? Us : a[Gs] < 0 || a[Gs] > 24 || 24 === a[Gs] && (0 !== a[Vs] || 0 !== a[Bs] || 0 !== a[Ks]) ? Gs : a[Vs] < 0 || a[Vs] > 59 ? Vs : a[Bs] < 0 || a[Bs] > 59 ? Bs : a[Ks] < 0 || a[Ks] > 999 ? Ks : -1, L(e)._overflowDayOfYear && (t < Cs || t > Us) && (t = Us), L(e)._overflowWeeks && t === -1 && (t = qs), L(e)._overflowWeekday && t === -1 && (t = Zs), L(e).overflow = t), e;
                    }
                    function ut(e) {
                        var t, a, n, s, r, i, d = e._i, _ = Lr.exec(d) || Yr.exec(d), o = fr.length, u = pr.length;
                        if (_) {
                            for (L(e).iso = !0, t = 0, a = o; t < a; t++)
                                if (fr[t][1].exec(_[1])) {
                                    s = fr[t][0], n = fr[t][2] !== !1;
                                    break;
                                }
                            if (null == s)
                                return void (e._isValid = !1);
                            if (_[3]) {
                                for (t = 0, a = u; t < a; t++)
                                    if (pr[t][1].exec(_[3])) {
                                        r = (_[2] || ' ') + pr[t][0];
                                        break;
                                    }
                                if (null == r)
                                    return void (e._isValid = !1);
                            }
                            if (!n && null != r)
                                return void (e._isValid = !1);
                            if (_[4]) {
                                if (!yr.exec(_[4]))
                                    return void (e._isValid = !1);
                                i = 'Z';
                            }
                            e._f = s + (r || '') + (i || ''), Dt(e);
                        } else
                            e._isValid = !1;
                    }
                    function mt(e, t, a, n, s, r) {
                        var i = [
                            lt(e),
                            Qs.indexOf(t),
                            parseInt(a, 10),
                            parseInt(n, 10),
                            parseInt(s, 10)
                        ];
                        return r && i.push(parseInt(r, 10)), i;
                    }
                    function lt(e) {
                        var t = parseInt(e, 10);
                        return t <= 49 ? 2000 + t : t <= 999 ? 1900 + t : t;
                    }
                    function ht(e) {
                        return e.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
                    }
                    function ct(e, t, a) {
                        if (e) {
                            var n = rr.indexOf(e), s = new Date(t[0], t[1], t[2]).getDay();
                            if (n !== s)
                                return L(a).weekdayMismatch = !0, a._isValid = !1, !1;
                        }
                        return !0;
                    }
                    function Mt(e, t, a) {
                        if (e)
                            return gr[e];
                        if (t)
                            return 0;
                        var n = parseInt(a, 10), s = n % 100, r = (n - s) / 100;
                        return 60 * r + s;
                    }
                    function Lt(e) {
                        var t, a = Dr.exec(ht(e._i));
                        if (a) {
                            if (t = mt(a[4], a[3], a[2], a[5], a[6], a[7]), !ct(a[1], t, e))
                                return;
                            e._a = t, e._tzm = Mt(a[8], a[9], a[10]), e._d = De.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), L(e).rfc2822 = !0;
                        } else
                            e._isValid = !1;
                    }
                    function Yt(e) {
                        var a = kr.exec(e._i);
                        return null !== a ? void (e._d = new Date(+a[1])) : (ut(e), void (e._isValid === !1 && (delete e._isValid, Lt(e), e._isValid === !1 && (delete e._isValid, e._strict ? e._isValid = !1 : t.createFromInputFallback(e)))));
                    }
                    function yt(e, t, a) {
                        return null != e ? e : null != t ? t : a;
                    }
                    function ft(e) {
                        var a = new Date(t.now());
                        return e._useUTC ? [
                            a.getUTCFullYear(),
                            a.getUTCMonth(),
                            a.getUTCDate()
                        ] : [
                            a.getFullYear(),
                            a.getMonth(),
                            a.getDate()
                        ];
                    }
                    function pt(e) {
                        var t, a, n, s, r, i = [];
                        if (!e._d) {
                            for (n = ft(e), e._w && null == e._a[Us] && null == e._a[Is] && kt(e), null != e._dayOfYear && (r = yt(e._a[Cs], n[Cs]), (e._dayOfYear > fe(r) || 0 === e._dayOfYear) && (L(e)._overflowDayOfYear = !0), a = De(r, 0, e._dayOfYear), e._a[Is] = a.getUTCMonth(), e._a[Us] = a.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t)
                                e._a[t] = i[t] = n[t];
                            for (; t < 7; t++)
                                e._a[t] = i[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
                            24 === e._a[Gs] && 0 === e._a[Vs] && 0 === e._a[Bs] && 0 === e._a[Ks] && (e._nextDay = !0, e._a[Gs] = 0), e._d = (e._useUTC ? De : ke).apply(null, i), s = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Gs] = 24), e._w && 'undefined' != typeof e._w.d && e._w.d !== s && (L(e).weekdayMismatch = !0);
                        }
                    }
                    function kt(e) {
                        var t, a, n, s, r, i, d, _, o;
                        t = e._w, null != t.GG || null != t.W || null != t.E ? (r = 1, i = 4, a = yt(t.GG, e._a[Cs], we(jt(), 1, 4).year), n = yt(t.W, 1), s = yt(t.E, 1), (s < 1 || s > 7) && (_ = !0)) : (r = e._locale._week.dow, i = e._locale._week.doy, o = we(jt(), r, i), a = yt(t.gg, e._a[Cs], o.year), n = yt(t.w, o.week), null != t.d ? (s = t.d, (s < 0 || s > 6) && (_ = !0)) : null != t.e ? (s = t.e + r, (t.e < 0 || t.e > 6) && (_ = !0)) : s = r), n < 1 || n > ve(a, r, i) ? L(e)._overflowWeeks = !0 : null != _ ? L(e)._overflowWeekday = !0 : (d = Te(a, n, s, r, i), e._a[Cs] = d.year, e._dayOfYear = d.dayOfYear);
                    }
                    function Dt(e) {
                        if (e._f === t.ISO_8601)
                            return void ut(e);
                        if (e._f === t.RFC_2822)
                            return void Lt(e);
                        e._a = [], L(e).empty = !0;
                        var a, n, s, r, i, d, _, o = '' + e._i, u = o.length, m = 0;
                        for (s = A(e._f, e._locale).match(ls) || [], _ = s.length, a = 0; a < _; a++)
                            r = s[a], n = (o.match(te(r, e)) || [])[0], n && (i = o.substr(0, o.indexOf(n)), i.length > 0 && L(e).unusedInput.push(i), o = o.slice(o.indexOf(n) + n.length), m += n.length), Ms[r] ? (n ? L(e).empty = !1 : L(e).unusedTokens.push(r), ie(r, n, e)) : e._strict && !n && L(e).unusedTokens.push(r);
                        L(e).charsLeftOver = u - m, o.length > 0 && L(e).unusedInput.push(o), e._a[Gs] <= 12 && L(e).bigHour === !0 && e._a[Gs] > 0 && (L(e).bigHour = void 0), L(e).parsedDateParts = e._a.slice(0), L(e).meridiem = e._meridiem, e._a[Gs] = gt(e._locale, e._a[Gs], e._meridiem), d = L(e).era, null !== d && (e._a[Cs] = e._locale.erasConvertYear(d, e._a[Cs])), pt(e), ot(e);
                    }
                    function gt(e, t, a) {
                        var n;
                        return null == a ? t : null != e.meridiemHour ? e.meridiemHour(t, a) : null != e.isPM ? (n = e.isPM(a), n && t < 12 && (t += 12), n || 12 !== t || (t = 0), t) : t;
                    }
                    function Tt(e) {
                        var t, a, n, s, r, i, d = !1, _ = e._f.length;
                        if (0 === _)
                            return L(e).invalidFormat = !0, void (e._d = new Date(NaN));
                        for (s = 0; s < _; s++)
                            r = 0, i = !1, t = f({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[s], Dt(t), Y(t) && (i = !0), r += L(t).charsLeftOver, r += 10 * L(t).unusedTokens.length, L(t).score = r, d ? r < n && (n = r, a = t) : (null == n || r < n || i) && (n = r, a = t, i && (d = !0));
                        h(e, a || t);
                    }
                    function wt(e) {
                        if (!e._d) {
                            var t = I(e._i), a = void 0 === t.day ? t.date : t.day;
                            e._a = l([
                                t.year,
                                t.month,
                                a,
                                t.hour,
                                t.minute,
                                t.second,
                                t.millisecond
                            ], function (e) {
                                return e && parseInt(e, 10);
                            }), pt(e);
                        }
                    }
                    function vt(e) {
                        var t = new p(ot(bt(e)));
                        return t._nextDay && (t.add(1, 'd'), t._nextDay = void 0), t;
                    }
                    function bt(e) {
                        var t = e._i, a = e._f;
                        return e._locale = e._locale || dt(e._l), null === t || void 0 === a && '' === t ? y({ nullInput: !0 }) : ('string' == typeof t && (e._i = t = e._locale.preparse(t)), k(t) ? new p(ot(t)) : (m(t) ? e._d = t : r(a) ? Tt(e) : a ? Dt(e) : St(e), Y(e) || (e._d = null), e));
                    }
                    function St(e) {
                        var a = e._i;
                        o(a) ? e._d = new Date(t.now()) : m(a) ? e._d = new Date(a.valueOf()) : 'string' == typeof a ? Yt(e) : r(a) ? (e._a = l(a.slice(0), function (e) {
                            return parseInt(e, 10);
                        }), pt(e)) : i(a) ? wt(e) : u(a) ? e._d = new Date(a) : t.createFromInputFallback(e);
                    }
                    function Ht(e, t, a, n, s) {
                        var d = {};
                        return t !== !0 && t !== !1 || (n = t, t = void 0), a !== !0 && a !== !1 || (n = a, a = void 0), (i(e) && _(e) || r(e) && 0 === e.length) && (e = void 0), d._isAMomentObject = !0, d._useUTC = d._isUTC = s, d._l = a, d._i = e, d._f = t, d._strict = n, vt(d);
                    }
                    function jt(e, t, a, n) {
                        return Ht(e, t, a, n, !1);
                    }
                    function xt(e, t) {
                        var a, n;
                        if (1 === t.length && r(t[0]) && (t = t[0]), !t.length)
                            return jt();
                        for (a = t[0], n = 1; n < t.length; ++n)
                            t[n].isValid() && !t[n][e](a) || (a = t[n]);
                        return a;
                    }
                    function Pt() {
                        var e = [].slice.call(arguments, 0);
                        return xt('isBefore', e);
                    }
                    function Ot() {
                        var e = [].slice.call(arguments, 0);
                        return xt('isAfter', e);
                    }
                    function Wt(e) {
                        var t, a, n = !1, s = br.length;
                        for (t in e)
                            if (d(e, t) && (Js.call(br, t) === -1 || null != e[t] && isNaN(e[t])))
                                return !1;
                        for (a = 0; a < s; ++a)
                            if (e[br[a]]) {
                                if (n)
                                    return !1;
                                parseFloat(e[br[a]]) !== K(e[br[a]]) && (n = !0);
                            }
                        return !0;
                    }
                    function At() {
                        return this._isValid;
                    }
                    function Et() {
                        return aa(NaN);
                    }
                    function Ft(e) {
                        var t = I(e), a = t.year || 0, n = t.quarter || 0, s = t.month || 0, r = t.week || t.isoWeek || 0, i = t.day || 0, d = t.hour || 0, _ = t.minute || 0, o = t.second || 0, u = t.millisecond || 0;
                        this._isValid = Wt(t), this._milliseconds = +u + 1000 * o + 60000 * _ + 1000 * d * 60 * 60, this._days = +i + 7 * r, this._months = +s + 3 * n + 12 * a, this._data = {}, this._locale = dt(), this._bubble();
                    }
                    function zt(e) {
                        return e instanceof Ft;
                    }
                    function Nt(e) {
                        return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
                    }
                    function Jt(e, t, a) {
                        var n, s = Math.min(e.length, t.length), r = Math.abs(e.length - t.length), i = 0;
                        for (n = 0; n < s; n++)
                            (a && e[n] !== t[n] || !a && K(e[n]) !== K(t[n])) && i++;
                        return i + r;
                    }
                    function Rt(e, t) {
                        x(e, 0, 0, function () {
                            var e = this.utcOffset(), a = '+';
                            return e < 0 && (e = -e, a = '-'), a + j(~~(e / 60), 2) + t + j(~~e % 60, 2);
                        });
                    }
                    function Ct(e, t) {
                        var a, n, s, r = (t || '').match(e);
                        return null === r ? null : (a = r[r.length - 1] || [], n = (a + '').match(Sr) || [
                            '-',
                            0,
                            0
                        ], s = +(60 * n[1]) + K(n[2]), 0 === s ? 0 : '+' === n[0] ? s : -s);
                    }
                    function It(e, a) {
                        var n, s;
                        return a._isUTC ? (n = a.clone(), s = (k(e) || m(e) ? e.valueOf() : jt(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + s), t.updateOffset(n, !1), n) : jt(e).local();
                    }
                    function Ut(e) {
                        return -Math.round(e._d.getTimezoneOffset());
                    }
                    function Gt(e, a, n) {
                        var s, r = this._offset || 0;
                        if (!this.isValid())
                            return null != e ? this : NaN;
                        if (null != e) {
                            if ('string' == typeof e) {
                                if (e = Ct(Fs, e), null === e)
                                    return this;
                            } else
                                Math.abs(e) < 16 && !n && (e *= 60);
                            return !this._isUTC && a && (s = Ut(this)), this._offset = e, this._isUTC = !0, null != s && this.add(s, 'm'), r !== e && (!a || this._changeInProgress ? da(this, aa(e - r, 'm'), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, t.updateOffset(this, !0), this._changeInProgress = null)), this;
                        }
                        return this._isUTC ? r : Ut(this);
                    }
                    function Vt(e, t) {
                        return null != e ? ('string' != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
                    }
                    function Bt(e) {
                        return this.utcOffset(0, e);
                    }
                    function Kt(e) {
                        return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Ut(this), 'm')), this;
                    }
                    function qt() {
                        if (null != this._tzm)
                            this.utcOffset(this._tzm, !1, !0);
                        else if ('string' == typeof this._i) {
                            var e = Ct(Es, this._i);
                            null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
                        }
                        return this;
                    }
                    function Zt(e) {
                        return !!this.isValid() && (e = e ? jt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0);
                    }
                    function $t() {
                        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
                    }
                    function Qt() {
                        if (!o(this._isDSTShifted))
                            return this._isDSTShifted;
                        var e, t = {};
                        return f(t, this), t = bt(t), t._a ? (e = t._isUTC ? c(t._a) : jt(t._a), this._isDSTShifted = this.isValid() && Jt(t._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
                    }
                    function Xt() {
                        return !!this.isValid() && !this._isUTC;
                    }
                    function ea() {
                        return !!this.isValid() && this._isUTC;
                    }
                    function ta() {
                        return !!this.isValid() && (this._isUTC && 0 === this._offset);
                    }
                    function aa(e, t) {
                        var a, n, s, r = e, i = null;
                        return zt(e) ? r = {
                            ms: e._milliseconds,
                            d: e._days,
                            M: e._months
                        } : u(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (i = Hr.exec(e)) ? (a = '-' === i[1] ? -1 : 1, r = {
                            y: 0,
                            d: K(i[Us]) * a,
                            h: K(i[Gs]) * a,
                            m: K(i[Vs]) * a,
                            s: K(i[Bs]) * a,
                            ms: K(Nt(1000 * i[Ks])) * a
                        }) : (i = jr.exec(e)) ? (a = '-' === i[1] ? -1 : 1, r = {
                            y: na(i[2], a),
                            M: na(i[3], a),
                            w: na(i[4], a),
                            d: na(i[5], a),
                            h: na(i[6], a),
                            m: na(i[7], a),
                            s: na(i[8], a)
                        }) : null == r ? r = {} : 'object' == typeof r && ('from' in r || 'to' in r) && (s = ra(jt(r.from), jt(r.to)), r = {}, r.ms = s.milliseconds, r.M = s.months), n = new Ft(r), zt(e) && d(e, '_locale') && (n._locale = e._locale), zt(e) && d(e, '_isValid') && (n._isValid = e._isValid), n;
                    }
                    function na(e, t) {
                        var a = e && parseFloat(e.replace(',', '.'));
                        return (isNaN(a) ? 0 : a) * t;
                    }
                    function sa(e, t) {
                        var a = {};
                        return a.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(a.months, 'M').isAfter(t) && --a.months, a.milliseconds = +t - +e.clone().add(a.months, 'M'), a;
                    }
                    function ra(e, t) {
                        var a;
                        return e.isValid() && t.isValid() ? (t = It(t, e), e.isBefore(t) ? a = sa(e, t) : (a = sa(t, e), a.milliseconds = -a.milliseconds, a.months = -a.months), a) : {
                            milliseconds: 0,
                            months: 0
                        };
                    }
                    function ia(e, t) {
                        return function (a, n) {
                            var s, r;
                            return null === n || isNaN(+n) || (T(t, 'moment().' + t + '(period, number) is deprecated. Please use moment().' + t + '(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'), r = a, a = n, n = r), s = aa(a, n), da(this, s, e), this;
                        };
                    }
                    function da(e, a, n, s) {
                        var r = a._milliseconds, i = Nt(a._days), d = Nt(a._months);
                        e.isValid() && (s = null == s || s, d && he(e, Z(e, 'Month') + d * n), i && $(e, 'Date', Z(e, 'Date') + i * n), r && e._d.setTime(e._d.valueOf() + r * n), s && t.updateOffset(e, i || d));
                    }
                    function _a(e) {
                        return 'string' == typeof e || e instanceof String;
                    }
                    function oa(e) {
                        return k(e) || m(e) || _a(e) || u(e) || ma(e) || ua(e) || null === e || void 0 === e;
                    }
                    function ua(e) {
                        var t, a, n = i(e) && !_(e), s = !1, r = [
                                'years',
                                'year',
                                'y',
                                'months',
                                'month',
                                'M',
                                'days',
                                'day',
                                'd',
                                'dates',
                                'date',
                                'D',
                                'hours',
                                'hour',
                                'h',
                                'minutes',
                                'minute',
                                'm',
                                'seconds',
                                'second',
                                's',
                                'milliseconds',
                                'millisecond',
                                'ms'
                            ], o = r.length;
                        for (t = 0; t < o; t += 1)
                            a = r[t], s = s || d(e, a);
                        return n && s;
                    }
                    function ma(e) {
                        var t = r(e), a = !1;
                        return t && (a = 0 === e.filter(function (t) {
                            return !u(t) && _a(e);
                        }).length), t && a;
                    }
                    function la(e) {
                        var t, a, n = i(e) && !_(e), s = !1, r = [
                                'sameDay',
                                'nextDay',
                                'lastDay',
                                'nextWeek',
                                'lastWeek',
                                'sameElse'
                            ];
                        for (t = 0; t < r.length; t += 1)
                            a = r[t], s = s || d(e, a);
                        return n && s;
                    }
                    function ha(e, t) {
                        var a = e.diff(t, 'days', !0);
                        return a < -6 ? 'sameElse' : a < -1 ? 'lastWeek' : a < 0 ? 'lastDay' : a < 1 ? 'sameDay' : a < 2 ? 'nextDay' : a < 7 ? 'nextWeek' : 'sameElse';
                    }
                    function ca(e, a) {
                        1 === arguments.length && (arguments[0] ? oa(arguments[0]) ? (e = arguments[0], a = void 0) : la(arguments[0]) && (a = arguments[0], e = void 0) : (e = void 0, a = void 0));
                        var n = e || jt(), s = It(n, this).startOf('day'), r = t.calendarFormat(this, s) || 'sameElse', i = a && (w(a[r]) ? a[r].call(this, n) : a[r]);
                        return this.format(i || this.localeData().calendar(r, this, jt(n)));
                    }
                    function Ma() {
                        return new p(this);
                    }
                    function La(e, t) {
                        var a = k(e) ? e : jt(e);
                        return !(!this.isValid() || !a.isValid()) && (t = C(t) || 'millisecond', 'millisecond' === t ? this.valueOf() > a.valueOf() : a.valueOf() < this.clone().startOf(t).valueOf());
                    }
                    function Ya(e, t) {
                        var a = k(e) ? e : jt(e);
                        return !(!this.isValid() || !a.isValid()) && (t = C(t) || 'millisecond', 'millisecond' === t ? this.valueOf() < a.valueOf() : this.clone().endOf(t).valueOf() < a.valueOf());
                    }
                    function ya(e, t, a, n) {
                        var s = k(e) ? e : jt(e), r = k(t) ? t : jt(t);
                        return !!(this.isValid() && s.isValid() && r.isValid()) && (n = n || '()', ('(' === n[0] ? this.isAfter(s, a) : !this.isBefore(s, a)) && (')' === n[1] ? this.isBefore(r, a) : !this.isAfter(r, a)));
                    }
                    function fa(e, t) {
                        var a, n = k(e) ? e : jt(e);
                        return !(!this.isValid() || !n.isValid()) && (t = C(t) || 'millisecond', 'millisecond' === t ? this.valueOf() === n.valueOf() : (a = n.valueOf(), this.clone().startOf(t).valueOf() <= a && a <= this.clone().endOf(t).valueOf()));
                    }
                    function pa(e, t) {
                        return this.isSame(e, t) || this.isAfter(e, t);
                    }
                    function ka(e, t) {
                        return this.isSame(e, t) || this.isBefore(e, t);
                    }
                    function Da(e, t, a) {
                        var n, s, r;
                        if (!this.isValid())
                            return NaN;
                        if (n = It(e, this), !n.isValid())
                            return NaN;
                        switch (s = 60000 * (n.utcOffset() - this.utcOffset()), t = C(t)) {
                        case 'year':
                            r = ga(this, n) / 12;
                            break;
                        case 'month':
                            r = ga(this, n);
                            break;
                        case 'quarter':
                            r = ga(this, n) / 3;
                            break;
                        case 'second':
                            r = (this - n) / 1000;
                            break;
                        case 'minute':
                            r = (this - n) / 60000;
                            break;
                        case 'hour':
                            r = (this - n) / 3600000;
                            break;
                        case 'day':
                            r = (this - n - s) / 86400000;
                            break;
                        case 'week':
                            r = (this - n - s) / 604800000;
                            break;
                        default:
                            r = this - n;
                        }
                        return a ? r : B(r);
                    }
                    function ga(e, t) {
                        if (e.date() < t.date())
                            return -ga(t, e);
                        var a, n, s = 12 * (t.year() - e.year()) + (t.month() - e.month()), r = e.clone().add(s, 'months');
                        return t - r < 0 ? (a = e.clone().add(s - 1, 'months'), n = (t - r) / (r - a)) : (a = e.clone().add(s + 1, 'months'), n = (t - r) / (a - r)), -(s + n) || 0;
                    }
                    function Ta() {
                        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
                    }
                    function wa(e) {
                        if (!this.isValid())
                            return null;
                        var t = e !== !0, a = t ? this.clone().utc() : this;
                        return a.year() < 0 || a.year() > 9999 ? W(a, t ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ') : w(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1000).toISOString().replace('Z', W(a, 'Z')) : W(a, t ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
                    }
                    function va() {
                        if (!this.isValid())
                            return 'moment.invalid(/* ' + this._i + ' */)';
                        var e, t, a, n, s = 'moment', r = '';
                        return this.isLocal() || (s = 0 === this.utcOffset() ? 'moment.utc' : 'moment.parseZone', r = 'Z'), e = '[' + s + '("]', t = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY', a = '-MM-DD[T]HH:mm:ss.SSS', n = r + '[")]', this.format(e + t + a + n);
                    }
                    function ba(e) {
                        e || (e = this.isUtc() ? t.defaultFormatUtc : t.defaultFormat);
                        var a = W(this, e);
                        return this.localeData().postformat(a);
                    }
                    function Sa(e, t) {
                        return this.isValid() && (k(e) && e.isValid() || jt(e).isValid()) ? aa({
                            to: this,
                            from: e
                        }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
                    }
                    function Ha(e) {
                        return this.from(jt(), e);
                    }
                    function ja(e, t) {
                        return this.isValid() && (k(e) && e.isValid() || jt(e).isValid()) ? aa({
                            from: this,
                            to: e
                        }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
                    }
                    function xa(e) {
                        return this.to(jt(), e);
                    }
                    function Pa(e) {
                        var t;
                        return void 0 === e ? this._locale._abbr : (t = dt(e), null != t && (this._locale = t), this);
                    }
                    function Oa() {
                        return this._locale;
                    }
                    function Wa(e, t) {
                        return (e % t + t) % t;
                    }
                    function Aa(e, t, a) {
                        return e < 100 && e >= 0 ? new Date(e + 400, t, a) - Fr : new Date(e, t, a).valueOf();
                    }
                    function Ea(e, t, a) {
                        return e < 100 && e >= 0 ? Date.UTC(e + 400, t, a) - Fr : Date.UTC(e, t, a);
                    }
                    function Fa(e) {
                        var a, n;
                        if (e = C(e), void 0 === e || 'millisecond' === e || !this.isValid())
                            return this;
                        switch (n = this._isUTC ? Ea : Aa, e) {
                        case 'year':
                            a = n(this.year(), 0, 1);
                            break;
                        case 'quarter':
                            a = n(this.year(), this.month() - this.month() % 3, 1);
                            break;
                        case 'month':
                            a = n(this.year(), this.month(), 1);
                            break;
                        case 'week':
                            a = n(this.year(), this.month(), this.date() - this.weekday());
                            break;
                        case 'isoWeek':
                            a = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                            break;
                        case 'day':
                        case 'date':
                            a = n(this.year(), this.month(), this.date());
                            break;
                        case 'hour':
                            a = this._d.valueOf(), a -= Wa(a + (this._isUTC ? 0 : this.utcOffset() * Ar), Er);
                            break;
                        case 'minute':
                            a = this._d.valueOf(), a -= Wa(a, Ar);
                            break;
                        case 'second':
                            a = this._d.valueOf(), a -= Wa(a, Wr);
                        }
                        return this._d.setTime(a), t.updateOffset(this, !0), this;
                    }
                    function za(e) {
                        var a, n;
                        if (e = C(e), void 0 === e || 'millisecond' === e || !this.isValid())
                            return this;
                        switch (n = this._isUTC ? Ea : Aa, e) {
                        case 'year':
                            a = n(this.year() + 1, 0, 1) - 1;
                            break;
                        case 'quarter':
                            a = n(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                            break;
                        case 'month':
                            a = n(this.year(), this.month() + 1, 1) - 1;
                            break;
                        case 'week':
                            a = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                            break;
                        case 'isoWeek':
                            a = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                            break;
                        case 'day':
                        case 'date':
                            a = n(this.year(), this.month(), this.date() + 1) - 1;
                            break;
                        case 'hour':
                            a = this._d.valueOf(), a += Er - Wa(a + (this._isUTC ? 0 : this.utcOffset() * Ar), Er) - 1;
                            break;
                        case 'minute':
                            a = this._d.valueOf(), a += Ar - Wa(a, Ar) - 1;
                            break;
                        case 'second':
                            a = this._d.valueOf(), a += Wr - Wa(a, Wr) - 1;
                        }
                        return this._d.setTime(a), t.updateOffset(this, !0), this;
                    }
                    function Na() {
                        return this._d.valueOf() - 60000 * (this._offset || 0);
                    }
                    function Ja() {
                        return Math.floor(this.valueOf() / 1000);
                    }
                    function Ra() {
                        return new Date(this.valueOf());
                    }
                    function Ca() {
                        var e = this;
                        return [
                            e.year(),
                            e.month(),
                            e.date(),
                            e.hour(),
                            e.minute(),
                            e.second(),
                            e.millisecond()
                        ];
                    }
                    function Ia() {
                        var e = this;
                        return {
                            years: e.year(),
                            months: e.month(),
                            date: e.date(),
                            hours: e.hours(),
                            minutes: e.minutes(),
                            seconds: e.seconds(),
                            milliseconds: e.milliseconds()
                        };
                    }
                    function Ua() {
                        return this.isValid() ? this.toISOString() : null;
                    }
                    function Ga() {
                        return Y(this);
                    }
                    function Va() {
                        return h({}, L(this));
                    }
                    function Ba() {
                        return L(this).overflow;
                    }
                    function Ka() {
                        return {
                            input: this._i,
                            format: this._f,
                            locale: this._locale,
                            isUTC: this._isUTC,
                            strict: this._strict
                        };
                    }
                    function qa(e, a) {
                        var n, s, r, i = this._eras || dt('en')._eras;
                        for (n = 0, s = i.length; n < s; ++n) {
                            switch (typeof i[n].since) {
                            case 'string':
                                r = t(i[n].since).startOf('day'), i[n].since = r.valueOf();
                            }
                            switch (typeof i[n].until) {
                            case 'undefined':
                                i[n].until = +(1 / 0);
                                break;
                            case 'string':
                                r = t(i[n].until).startOf('day').valueOf(), i[n].until = r.valueOf();
                            }
                        }
                        return i;
                    }
                    function Za(e, t, a) {
                        var n, s, r, i, d, _ = this.eras();
                        for (e = e.toUpperCase(), n = 0, s = _.length; n < s; ++n)
                            if (r = _[n].name.toUpperCase(), i = _[n].abbr.toUpperCase(), d = _[n].narrow.toUpperCase(), a)
                                switch (t) {
                                case 'N':
                                case 'NN':
                                case 'NNN':
                                    if (i === e)
                                        return _[n];
                                    break;
                                case 'NNNN':
                                    if (r === e)
                                        return _[n];
                                    break;
                                case 'NNNNN':
                                    if (d === e)
                                        return _[n];
                                }
                            else if ([
                                    r,
                                    i,
                                    d
                                ].indexOf(e) >= 0)
                                return _[n];
                    }
                    function $a(e, a) {
                        var n = e.since <= e.until ? 1 : -1;
                        return void 0 === a ? t(e.since).year() : t(e.since).year() + (a - e.offset) * n;
                    }
                    function Qa() {
                        var e, t, a, n = this.localeData().eras();
                        for (e = 0, t = n.length; e < t; ++e) {
                            if (a = this.clone().startOf('day').valueOf(), n[e].since <= a && a <= n[e].until)
                                return n[e].name;
                            if (n[e].until <= a && a <= n[e].since)
                                return n[e].name;
                        }
                        return '';
                    }
                    function Xa() {
                        var e, t, a, n = this.localeData().eras();
                        for (e = 0, t = n.length; e < t; ++e) {
                            if (a = this.clone().startOf('day').valueOf(), n[e].since <= a && a <= n[e].until)
                                return n[e].narrow;
                            if (n[e].until <= a && a <= n[e].since)
                                return n[e].narrow;
                        }
                        return '';
                    }
                    function en() {
                        var e, t, a, n = this.localeData().eras();
                        for (e = 0, t = n.length; e < t; ++e) {
                            if (a = this.clone().startOf('day').valueOf(), n[e].since <= a && a <= n[e].until)
                                return n[e].abbr;
                            if (n[e].until <= a && a <= n[e].since)
                                return n[e].abbr;
                        }
                        return '';
                    }
                    function tn() {
                        var e, a, n, s, r = this.localeData().eras();
                        for (e = 0, a = r.length; e < a; ++e)
                            if (n = r[e].since <= r[e].until ? 1 : -1, s = this.clone().startOf('day').valueOf(), r[e].since <= s && s <= r[e].until || r[e].until <= s && s <= r[e].since)
                                return (this.year() - t(r[e].since).year()) * n + r[e].offset;
                        return this.year();
                    }
                    function an(e) {
                        return d(this, '_erasNameRegex') || un.call(this), e ? this._erasNameRegex : this._erasRegex;
                    }
                    function nn(e) {
                        return d(this, '_erasAbbrRegex') || un.call(this), e ? this._erasAbbrRegex : this._erasRegex;
                    }
                    function sn(e) {
                        return d(this, '_erasNarrowRegex') || un.call(this), e ? this._erasNarrowRegex : this._erasRegex;
                    }
                    function rn(e, t) {
                        return t.erasAbbrRegex(e);
                    }
                    function dn(e, t) {
                        return t.erasNameRegex(e);
                    }
                    function _n(e, t) {
                        return t.erasNarrowRegex(e);
                    }
                    function on(e, t) {
                        return t._eraYearOrdinalRegex || Ws;
                    }
                    function un() {
                        var e, t, a = [], n = [], s = [], r = [], i = this.eras();
                        for (e = 0, t = i.length; e < t; ++e)
                            n.push(ne(i[e].name)), a.push(ne(i[e].abbr)), s.push(ne(i[e].narrow)), r.push(ne(i[e].name)), r.push(ne(i[e].abbr)), r.push(ne(i[e].narrow));
                        this._erasRegex = new RegExp('^(' + r.join('|') + ')', 'i'), this._erasNameRegex = new RegExp('^(' + n.join('|') + ')', 'i'), this._erasAbbrRegex = new RegExp('^(' + a.join('|') + ')', 'i'), this._erasNarrowRegex = new RegExp('^(' + s.join('|') + ')', 'i');
                    }
                    function mn(e, t) {
                        x(0, [
                            e,
                            e.length
                        ], 0, t);
                    }
                    function ln(e) {
                        return yn.call(this, e, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
                    }
                    function hn(e) {
                        return yn.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
                    }
                    function cn() {
                        return ve(this.year(), 1, 4);
                    }
                    function Mn() {
                        return ve(this.isoWeekYear(), 1, 4);
                    }
                    function Ln() {
                        var e = this.localeData()._week;
                        return ve(this.year(), e.dow, e.doy);
                    }
                    function Yn() {
                        var e = this.localeData()._week;
                        return ve(this.weekYear(), e.dow, e.doy);
                    }
                    function yn(e, t, a, n, s) {
                        var r;
                        return null == e ? we(this, n, s).year : (r = ve(e, n, s), t > r && (t = r), fn.call(this, e, t, a, n, s));
                    }
                    function fn(e, t, a, n, s) {
                        var r = Te(e, t, a, n, s), i = De(r.year, 0, r.dayOfYear);
                        return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
                    }
                    function pn(e) {
                        return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
                    }
                    function kn(e) {
                        var t = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 86400000) + 1;
                        return null == e ? t : this.add(e - t, 'd');
                    }
                    function Dn(e, t) {
                        t[Ks] = K(1000 * ('0.' + e));
                    }
                    function gn() {
                        return this._isUTC ? 'UTC' : '';
                    }
                    function Tn() {
                        return this._isUTC ? 'Coordinated Universal Time' : '';
                    }
                    function wn(e) {
                        return jt(1000 * e);
                    }
                    function vn() {
                        return jt.apply(null, arguments).parseZone();
                    }
                    function bn(e) {
                        return e;
                    }
                    function Sn(e, t, a, n) {
                        var s = dt(), r = c().set(n, t);
                        return s[a](r, e);
                    }
                    function Hn(e, t, a) {
                        if (u(e) && (t = e, e = void 0), e = e || '', null != t)
                            return Sn(e, t, a, 'month');
                        var n, s = [];
                        for (n = 0; n < 12; n++)
                            s[n] = Sn(e, n, a, 'month');
                        return s;
                    }
                    function jn(e, t, a, n) {
                        'boolean' == typeof e ? (u(t) && (a = t, t = void 0), t = t || '') : (t = e, a = t, e = !1, u(t) && (a = t, t = void 0), t = t || '');
                        var s, r = dt(), i = e ? r._week.dow : 0, d = [];
                        if (null != a)
                            return Sn(t, (a + i) % 7, n, 'day');
                        for (s = 0; s < 7; s++)
                            d[s] = Sn(t, (s + i) % 7, n, 'day');
                        return d;
                    }
                    function xn(e, t) {
                        return Hn(e, t, 'months');
                    }
                    function Pn(e, t) {
                        return Hn(e, t, 'monthsShort');
                    }
                    function On(e, t, a) {
                        return jn(e, t, a, 'weekdays');
                    }
                    function Wn(e, t, a) {
                        return jn(e, t, a, 'weekdaysShort');
                    }
                    function An(e, t, a) {
                        return jn(e, t, a, 'weekdaysMin');
                    }
                    function En() {
                        var e = this._data;
                        return this._milliseconds = Gr(this._milliseconds), this._days = Gr(this._days), this._months = Gr(this._months), e.milliseconds = Gr(e.milliseconds), e.seconds = Gr(e.seconds), e.minutes = Gr(e.minutes), e.hours = Gr(e.hours), e.months = Gr(e.months), e.years = Gr(e.years), this;
                    }
                    function Fn(e, t, a, n) {
                        var s = aa(t, a);
                        return e._milliseconds += n * s._milliseconds, e._days += n * s._days, e._months += n * s._months, e._bubble();
                    }
                    function zn(e, t) {
                        return Fn(this, e, t, 1);
                    }
                    function Nn(e, t) {
                        return Fn(this, e, t, -1);
                    }
                    function Jn(e) {
                        return e < 0 ? Math.floor(e) : Math.ceil(e);
                    }
                    function Rn() {
                        var e, t, a, n, s, r = this._milliseconds, i = this._days, d = this._months, _ = this._data;
                        return r >= 0 && i >= 0 && d >= 0 || r <= 0 && i <= 0 && d <= 0 || (r += 86400000 * Jn(In(d) + i), i = 0, d = 0), _.milliseconds = r % 1000, e = B(r / 1000), _.seconds = e % 60, t = B(e / 60), _.minutes = t % 60, a = B(t / 60), _.hours = a % 24, i += B(a / 24), s = B(Cn(i)), d += s, i -= Jn(In(s)), n = B(d / 12), d %= 12, _.days = i, _.months = d, _.years = n, this;
                    }
                    function Cn(e) {
                        return 4800 * e / 146097;
                    }
                    function In(e) {
                        return 146097 * e / 4800;
                    }
                    function Un(e) {
                        if (!this.isValid())
                            return NaN;
                        var t, a, n = this._milliseconds;
                        if (e = C(e), 'month' === e || 'quarter' === e || 'year' === e)
                            switch (t = this._days + n / 86400000, a = this._months + Cn(t), e) {
                            case 'month':
                                return a;
                            case 'quarter':
                                return a / 3;
                            case 'year':
                                return a / 12;
                            }
                        else
                            switch (t = this._days + Math.round(In(this._months)), e) {
                            case 'week':
                                return t / 7 + n / 604800000;
                            case 'day':
                                return t + n / 86400000;
                            case 'hour':
                                return 24 * t + n / 3600000;
                            case 'minute':
                                return 1440 * t + n / 60000;
                            case 'second':
                                return 86400 * t + n / 1000;
                            case 'millisecond':
                                return Math.floor(86400000 * t) + n;
                            default:
                                throw new Error('Unknown unit ' + e);
                            }
                    }
                    function Gn() {
                        return this.isValid() ? this._milliseconds + 86400000 * this._days + this._months % 12 * 2592000000 + 31536000000 * K(this._months / 12) : NaN;
                    }
                    function Vn(e) {
                        return function () {
                            return this.as(e);
                        };
                    }
                    function Bn() {
                        return aa(this);
                    }
                    function Kn(e) {
                        return e = C(e), this.isValid() ? this[e + 's']() : NaN;
                    }
                    function qn(e) {
                        return function () {
                            return this.isValid() ? this._data[e] : NaN;
                        };
                    }
                    function Zn() {
                        return B(this.days() / 7);
                    }
                    function $n(e, t, a, n, s) {
                        return s.relativeTime(t || 1, !!a, e, n);
                    }
                    function Qn(e, t, a, n) {
                        var s = aa(e).abs(), r = _i(s.as('s')), i = _i(s.as('m')), d = _i(s.as('h')), _ = _i(s.as('d')), o = _i(s.as('M')), u = _i(s.as('w')), m = _i(s.as('y')), l = r <= a.ss && [
                                's',
                                r
                            ] || r < a.s && [
                                'ss',
                                r
                            ] || i <= 1 && ['m'] || i < a.m && [
                                'mm',
                                i
                            ] || d <= 1 && ['h'] || d < a.h && [
                                'hh',
                                d
                            ] || _ <= 1 && ['d'] || _ < a.d && [
                                'dd',
                                _
                            ];
                        return null != a.w && (l = l || u <= 1 && ['w'] || u < a.w && [
                            'ww',
                            u
                        ]), l = l || o <= 1 && ['M'] || o < a.M && [
                            'MM',
                            o
                        ] || m <= 1 && ['y'] || [
                            'yy',
                            m
                        ], l[2] = t, l[3] = +e > 0, l[4] = n, $n.apply(null, l);
                    }
                    function Xn(e) {
                        return void 0 === e ? _i : 'function' == typeof e && (_i = e, !0);
                    }
                    function es(e, t) {
                        return void 0 !== oi[e] && (void 0 === t ? oi[e] : (oi[e] = t, 's' === e && (oi.ss = t - 1), !0));
                    }
                    function ts(e, t) {
                        if (!this.isValid())
                            return this.localeData().invalidDate();
                        var a, n, s = !1, r = oi;
                        return 'object' == typeof e && (t = e, e = !1), 'boolean' == typeof e && (s = e), 'object' == typeof t && (r = Object.assign({}, oi, t), null != t.s && null == t.ss && (r.ss = t.s - 1)), a = this.localeData(), n = Qn(this, !s, r, a), s && (n = a.pastFuture(+this, n)), a.postformat(n);
                    }
                    function as(e) {
                        return (e > 0) - (e < 0) || +e;
                    }
                    function ns() {
                        if (!this.isValid())
                            return this.localeData().invalidDate();
                        var e, t, a, n, s, r, i, d, _ = ui(this._milliseconds) / 1000, o = ui(this._days), u = ui(this._months), m = this.asSeconds();
                        return m ? (e = B(_ / 60), t = B(e / 60), _ %= 60, e %= 60, a = B(u / 12), u %= 12, n = _ ? _.toFixed(3).replace(/\.?0+$/, '') : '', s = m < 0 ? '-' : '', r = as(this._months) !== as(m) ? '-' : '', i = as(this._days) !== as(m) ? '-' : '', d = as(this._milliseconds) !== as(m) ? '-' : '', s + 'P' + (a ? r + a + 'Y' : '') + (u ? r + u + 'M' : '') + (o ? i + o + 'D' : '') + (t || e || _ ? 'T' : '') + (t ? d + t + 'H' : '') + (e ? d + e + 'M' : '') + (_ ? d + n + 'S' : '')) : 'P0D';
                    }
                    var ss, rs;
                    rs = Array.prototype.some ? Array.prototype.some : function (e) {
                        var t, a = Object(this), n = a.length >>> 0;
                        for (t = 0; t < n; t++)
                            if (t in a && e.call(this, a[t], t, a))
                                return !0;
                        return !1;
                    };
                    var is = t.momentProperties = [], ds = !1, _s = {};
                    t.suppressDeprecationWarnings = !1, t.deprecationHandler = null;
                    var os;
                    os = Object.keys ? Object.keys : function (e) {
                        var t, a = [];
                        for (t in e)
                            d(e, t) && a.push(t);
                        return a;
                    };
                    var us, ms = {
                            sameDay: '[Today at] LT',
                            nextDay: '[Tomorrow at] LT',
                            nextWeek: 'dddd [at] LT',
                            lastDay: '[Yesterday at] LT',
                            lastWeek: '[Last] dddd [at] LT',
                            sameElse: 'L'
                        }, ls = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, hs = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, cs = {}, Ms = {}, Ls = {
                            LTS: 'h:mm:ss A',
                            LT: 'h:mm A',
                            L: 'MM/DD/YYYY',
                            LL: 'MMMM D, YYYY',
                            LLL: 'MMMM D, YYYY h:mm A',
                            LLLL: 'dddd, MMMM D, YYYY h:mm A'
                        }, Ys = 'Invalid date', ys = '%d', fs = /\d{1,2}/, ps = {
                            future: 'in %s',
                            past: '%s ago',
                            s: 'a few seconds',
                            ss: '%d seconds',
                            m: 'a minute',
                            mm: '%d minutes',
                            h: 'an hour',
                            hh: '%d hours',
                            d: 'a day',
                            dd: '%d days',
                            w: 'a week',
                            ww: '%d weeks',
                            M: 'a month',
                            MM: '%d months',
                            y: 'a year',
                            yy: '%d years'
                        }, ks = {}, Ds = {}, gs = /\d/, Ts = /\d\d/, ws = /\d{3}/, vs = /\d{4}/, bs = /[+-]?\d{6}/, Ss = /\d\d?/, Hs = /\d\d\d\d?/, js = /\d\d\d\d\d\d?/, xs = /\d{1,3}/, Ps = /\d{1,4}/, Os = /[+-]?\d{1,6}/, Ws = /\d+/, As = /[+-]?\d+/, Es = /Z|[+-]\d\d:?\d\d/gi, Fs = /Z|[+-]\d\d(?::?\d\d)?/gi, zs = /[+-]?\d+(\.\d{1,3})?/, Ns = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
                    us = {};
                    var Js, Rs = {}, Cs = 0, Is = 1, Us = 2, Gs = 3, Vs = 4, Bs = 5, Ks = 6, qs = 7, Zs = 8;
                    Js = Array.prototype.indexOf ? Array.prototype.indexOf : function (e) {
                        var t;
                        for (t = 0; t < this.length; ++t)
                            if (this[t] === e)
                                return t;
                        return -1;
                    }, x('M', [
                        'MM',
                        2
                    ], 'Mo', function () {
                        return this.month() + 1;
                    }), x('MMM', 0, 0, function (e) {
                        return this.localeData().monthsShort(this, e);
                    }), x('MMMM', 0, 0, function (e) {
                        return this.localeData().months(this, e);
                    }), R('month', 'M'), U('month', 8), ee('M', Ss), ee('MM', Ss, Ts), ee('MMM', function (e, t) {
                        return t.monthsShortRegex(e);
                    }), ee('MMMM', function (e, t) {
                        return t.monthsRegex(e);
                    }), se([
                        'M',
                        'MM'
                    ], function (e, t) {
                        t[Is] = K(e) - 1;
                    }), se([
                        'MMM',
                        'MMMM'
                    ], function (e, t, a, n) {
                        var s = a._locale.monthsParse(e, n, a._strict);
                        null != s ? t[Is] = s : L(a).invalidMonth = e;
                    });
                    var $s = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), Qs = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), Xs = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, er = Ns, tr = Ns;
                    x('Y', 0, 0, function () {
                        var e = this.year();
                        return e <= 9999 ? j(e, 4) : '+' + e;
                    }), x(0, [
                        'YY',
                        2
                    ], 0, function () {
                        return this.year() % 100;
                    }), x(0, [
                        'YYYY',
                        4
                    ], 0, 'year'), x(0, [
                        'YYYYY',
                        5
                    ], 0, 'year'), x(0, [
                        'YYYYYY',
                        6,
                        !0
                    ], 0, 'year'), R('year', 'y'), U('year', 1), ee('Y', As), ee('YY', Ss, Ts), ee('YYYY', Ps, vs), ee('YYYYY', Os, bs), ee('YYYYYY', Os, bs), se([
                        'YYYYY',
                        'YYYYYY'
                    ], Cs), se('YYYY', function (e, a) {
                        a[Cs] = 2 === e.length ? t.parseTwoDigitYear(e) : K(e);
                    }), se('YY', function (e, a) {
                        a[Cs] = t.parseTwoDigitYear(e);
                    }), se('Y', function (e, t) {
                        t[Cs] = parseInt(e, 10);
                    }), t.parseTwoDigitYear = function (e) {
                        return K(e) + (K(e) > 68 ? 1900 : 2000);
                    };
                    var ar = q('FullYear', !0);
                    x('w', [
                        'ww',
                        2
                    ], 'wo', 'week'), x('W', [
                        'WW',
                        2
                    ], 'Wo', 'isoWeek'), R('week', 'w'), R('isoWeek', 'W'), U('week', 5), U('isoWeek', 5), ee('w', Ss), ee('ww', Ss, Ts), ee('W', Ss), ee('WW', Ss, Ts), re([
                        'w',
                        'ww',
                        'W',
                        'WW'
                    ], function (e, t, a, n) {
                        t[n.substr(0, 1)] = K(e);
                    });
                    var nr = {
                        dow: 0,
                        doy: 6
                    };
                    x('d', 0, 'do', 'day'), x('dd', 0, 0, function (e) {
                        return this.localeData().weekdaysMin(this, e);
                    }), x('ddd', 0, 0, function (e) {
                        return this.localeData().weekdaysShort(this, e);
                    }), x('dddd', 0, 0, function (e) {
                        return this.localeData().weekdays(this, e);
                    }), x('e', 0, 0, 'weekday'), x('E', 0, 0, 'isoWeekday'), R('day', 'd'), R('weekday', 'e'), R('isoWeekday', 'E'), U('day', 11), U('weekday', 11), U('isoWeekday', 11), ee('d', Ss), ee('e', Ss), ee('E', Ss), ee('dd', function (e, t) {
                        return t.weekdaysMinRegex(e);
                    }), ee('ddd', function (e, t) {
                        return t.weekdaysShortRegex(e);
                    }), ee('dddd', function (e, t) {
                        return t.weekdaysRegex(e);
                    }), re([
                        'dd',
                        'ddd',
                        'dddd'
                    ], function (e, t, a, n) {
                        var s = a._locale.weekdaysParse(e, n, a._strict);
                        null != s ? t.d = s : L(a).invalidWeekday = e;
                    }), re([
                        'd',
                        'e',
                        'E'
                    ], function (e, t, a, n) {
                        t[n] = K(e);
                    });
                    var sr = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), rr = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), ir = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), dr = Ns, _r = Ns, or = Ns;
                    x('H', [
                        'HH',
                        2
                    ], 0, 'hour'), x('h', [
                        'hh',
                        2
                    ], 0, Be), x('k', [
                        'kk',
                        2
                    ], 0, Ke), x('hmm', 0, 0, function () {
                        return '' + Be.apply(this) + j(this.minutes(), 2);
                    }), x('hmmss', 0, 0, function () {
                        return '' + Be.apply(this) + j(this.minutes(), 2) + j(this.seconds(), 2);
                    }), x('Hmm', 0, 0, function () {
                        return '' + this.hours() + j(this.minutes(), 2);
                    }), x('Hmmss', 0, 0, function () {
                        return '' + this.hours() + j(this.minutes(), 2) + j(this.seconds(), 2);
                    }), qe('a', !0), qe('A', !1), R('hour', 'h'), U('hour', 13), ee('a', Ze), ee('A', Ze), ee('H', Ss), ee('h', Ss), ee('k', Ss), ee('HH', Ss, Ts), ee('hh', Ss, Ts), ee('kk', Ss, Ts), ee('hmm', Hs), ee('hmmss', js), ee('Hmm', Hs), ee('Hmmss', js), se([
                        'H',
                        'HH'
                    ], Gs), se([
                        'k',
                        'kk'
                    ], function (e, t, a) {
                        var n = K(e);
                        t[Gs] = 24 === n ? 0 : n;
                    }), se([
                        'a',
                        'A'
                    ], function (e, t, a) {
                        a._isPm = a._locale.isPM(e), a._meridiem = e;
                    }), se([
                        'h',
                        'hh'
                    ], function (e, t, a) {
                        t[Gs] = K(e), L(a).bigHour = !0;
                    }), se('hmm', function (e, t, a) {
                        var n = e.length - 2;
                        t[Gs] = K(e.substr(0, n)), t[Vs] = K(e.substr(n)), L(a).bigHour = !0;
                    }), se('hmmss', function (e, t, a) {
                        var n = e.length - 4, s = e.length - 2;
                        t[Gs] = K(e.substr(0, n)), t[Vs] = K(e.substr(n, 2)), t[Bs] = K(e.substr(s)), L(a).bigHour = !0;
                    }), se('Hmm', function (e, t, a) {
                        var n = e.length - 2;
                        t[Gs] = K(e.substr(0, n)), t[Vs] = K(e.substr(n));
                    }), se('Hmmss', function (e, t, a) {
                        var n = e.length - 4, s = e.length - 2;
                        t[Gs] = K(e.substr(0, n)), t[Vs] = K(e.substr(n, 2)), t[Bs] = K(e.substr(s));
                    });
                    var ur, mr = /[ap]\.?m?\.?/i, lr = q('Hours', !0), hr = {
                            calendar: ms,
                            longDateFormat: Ls,
                            invalidDate: Ys,
                            ordinal: ys,
                            dayOfMonthOrdinalParse: fs,
                            relativeTime: ps,
                            months: $s,
                            monthsShort: Qs,
                            week: nr,
                            weekdays: sr,
                            weekdaysMin: ir,
                            weekdaysShort: rr,
                            meridiemParse: mr
                        }, cr = {}, Mr = {}, Lr = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Yr = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, yr = /Z|[+-]\d\d(?::?\d\d)?/, fr = [
                            [
                                'YYYYYY-MM-DD',
                                /[+-]\d{6}-\d\d-\d\d/
                            ],
                            [
                                'YYYY-MM-DD',
                                /\d{4}-\d\d-\d\d/
                            ],
                            [
                                'GGGG-[W]WW-E',
                                /\d{4}-W\d\d-\d/
                            ],
                            [
                                'GGGG-[W]WW',
                                /\d{4}-W\d\d/,
                                !1
                            ],
                            [
                                'YYYY-DDD',
                                /\d{4}-\d{3}/
                            ],
                            [
                                'YYYY-MM',
                                /\d{4}-\d\d/,
                                !1
                            ],
                            [
                                'YYYYYYMMDD',
                                /[+-]\d{10}/
                            ],
                            [
                                'YYYYMMDD',
                                /\d{8}/
                            ],
                            [
                                'GGGG[W]WWE',
                                /\d{4}W\d{3}/
                            ],
                            [
                                'GGGG[W]WW',
                                /\d{4}W\d{2}/,
                                !1
                            ],
                            [
                                'YYYYDDD',
                                /\d{7}/
                            ],
                            [
                                'YYYYMM',
                                /\d{6}/,
                                !1
                            ],
                            [
                                'YYYY',
                                /\d{4}/,
                                !1
                            ]
                        ], pr = [
                            [
                                'HH:mm:ss.SSSS',
                                /\d\d:\d\d:\d\d\.\d+/
                            ],
                            [
                                'HH:mm:ss,SSSS',
                                /\d\d:\d\d:\d\d,\d+/
                            ],
                            [
                                'HH:mm:ss',
                                /\d\d:\d\d:\d\d/
                            ],
                            [
                                'HH:mm',
                                /\d\d:\d\d/
                            ],
                            [
                                'HHmmss.SSSS',
                                /\d\d\d\d\d\d\.\d+/
                            ],
                            [
                                'HHmmss,SSSS',
                                /\d\d\d\d\d\d,\d+/
                            ],
                            [
                                'HHmmss',
                                /\d\d\d\d\d\d/
                            ],
                            [
                                'HHmm',
                                /\d\d\d\d/
                            ],
                            [
                                'HH',
                                /\d\d/
                            ]
                        ], kr = /^\/?Date\((-?\d+)/i, Dr = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, gr = {
                            UT: 0,
                            GMT: 0,
                            EDT: -240,
                            EST: -300,
                            CDT: -300,
                            CST: -360,
                            MDT: -360,
                            MST: -420,
                            PDT: -420,
                            PST: -480
                        };
                    t.createFromInputFallback = g('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (e) {
                        e._d = new Date(e._i + (e._useUTC ? ' UTC' : ''));
                    }), t.ISO_8601 = function () {
                    }, t.RFC_2822 = function () {
                    };
                    var Tr = g('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
                            var e = jt.apply(null, arguments);
                            return this.isValid() && e.isValid() ? e < this ? this : e : y();
                        }), wr = g('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
                            var e = jt.apply(null, arguments);
                            return this.isValid() && e.isValid() ? e > this ? this : e : y();
                        }), vr = function () {
                            return Date.now ? Date.now() : +new Date();
                        }, br = [
                            'year',
                            'quarter',
                            'month',
                            'week',
                            'day',
                            'hour',
                            'minute',
                            'second',
                            'millisecond'
                        ];
                    Rt('Z', ':'), Rt('ZZ', ''), ee('Z', Fs), ee('ZZ', Fs), se([
                        'Z',
                        'ZZ'
                    ], function (e, t, a) {
                        a._useUTC = !0, a._tzm = Ct(Fs, e);
                    });
                    var Sr = /([\+\-]|\d\d)/gi;
                    t.updateOffset = function () {
                    };
                    var Hr = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, jr = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
                    aa.fn = Ft.prototype, aa.invalid = Et;
                    var xr = ia(1, 'add'), Pr = ia(-1, 'subtract');
                    t.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ', t.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
                    var Or = g('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (e) {
                            return void 0 === e ? this.localeData() : this.locale(e);
                        }), Wr = 1000, Ar = 60 * Wr, Er = 60 * Ar, Fr = 3506328 * Er;
                    x('N', 0, 0, 'eraAbbr'), x('NN', 0, 0, 'eraAbbr'), x('NNN', 0, 0, 'eraAbbr'), x('NNNN', 0, 0, 'eraName'), x('NNNNN', 0, 0, 'eraNarrow'), x('y', [
                        'y',
                        1
                    ], 'yo', 'eraYear'), x('y', [
                        'yy',
                        2
                    ], 0, 'eraYear'), x('y', [
                        'yyy',
                        3
                    ], 0, 'eraYear'), x('y', [
                        'yyyy',
                        4
                    ], 0, 'eraYear'), ee('N', rn), ee('NN', rn), ee('NNN', rn), ee('NNNN', dn), ee('NNNNN', _n), se([
                        'N',
                        'NN',
                        'NNN',
                        'NNNN',
                        'NNNNN'
                    ], function (e, t, a, n) {
                        var s = a._locale.erasParse(e, n, a._strict);
                        s ? L(a).era = s : L(a).invalidEra = e;
                    }), ee('y', Ws), ee('yy', Ws), ee('yyy', Ws), ee('yyyy', Ws), ee('yo', on), se([
                        'y',
                        'yy',
                        'yyy',
                        'yyyy'
                    ], Cs), se(['yo'], function (e, t, a, n) {
                        var s;
                        a._locale._eraYearOrdinalRegex && (s = e.match(a._locale._eraYearOrdinalRegex)), a._locale.eraYearOrdinalParse ? t[Cs] = a._locale.eraYearOrdinalParse(e, s) : t[Cs] = parseInt(e, 10);
                    }), x(0, [
                        'gg',
                        2
                    ], 0, function () {
                        return this.weekYear() % 100;
                    }), x(0, [
                        'GG',
                        2
                    ], 0, function () {
                        return this.isoWeekYear() % 100;
                    }), mn('gggg', 'weekYear'), mn('ggggg', 'weekYear'), mn('GGGG', 'isoWeekYear'), mn('GGGGG', 'isoWeekYear'), R('weekYear', 'gg'), R('isoWeekYear', 'GG'), U('weekYear', 1), U('isoWeekYear', 1), ee('G', As), ee('g', As), ee('GG', Ss, Ts), ee('gg', Ss, Ts), ee('GGGG', Ps, vs), ee('gggg', Ps, vs), ee('GGGGG', Os, bs), ee('ggggg', Os, bs), re([
                        'gggg',
                        'ggggg',
                        'GGGG',
                        'GGGGG'
                    ], function (e, t, a, n) {
                        t[n.substr(0, 2)] = K(e);
                    }), re([
                        'gg',
                        'GG'
                    ], function (e, a, n, s) {
                        a[s] = t.parseTwoDigitYear(e);
                    }), x('Q', 0, 'Qo', 'quarter'), R('quarter', 'Q'), U('quarter', 7), ee('Q', gs), se('Q', function (e, t) {
                        t[Is] = 3 * (K(e) - 1);
                    }), x('D', [
                        'DD',
                        2
                    ], 'Do', 'date'), R('date', 'D'), U('date', 9), ee('D', Ss), ee('DD', Ss, Ts), ee('Do', function (e, t) {
                        return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
                    }), se([
                        'D',
                        'DD'
                    ], Us), se('Do', function (e, t) {
                        t[Us] = K(e.match(Ss)[0]);
                    });
                    var zr = q('Date', !0);
                    x('DDD', [
                        'DDDD',
                        3
                    ], 'DDDo', 'dayOfYear'), R('dayOfYear', 'DDD'), U('dayOfYear', 4), ee('DDD', xs), ee('DDDD', ws), se([
                        'DDD',
                        'DDDD'
                    ], function (e, t, a) {
                        a._dayOfYear = K(e);
                    }), x('m', [
                        'mm',
                        2
                    ], 0, 'minute'), R('minute', 'm'), U('minute', 14), ee('m', Ss), ee('mm', Ss, Ts), se([
                        'm',
                        'mm'
                    ], Vs);
                    var Nr = q('Minutes', !1);
                    x('s', [
                        'ss',
                        2
                    ], 0, 'second'), R('second', 's'), U('second', 15), ee('s', Ss), ee('ss', Ss, Ts), se([
                        's',
                        'ss'
                    ], Bs);
                    var Jr = q('Seconds', !1);
                    x('S', 0, 0, function () {
                        return ~~(this.millisecond() / 100);
                    }), x(0, [
                        'SS',
                        2
                    ], 0, function () {
                        return ~~(this.millisecond() / 10);
                    }), x(0, [
                        'SSS',
                        3
                    ], 0, 'millisecond'), x(0, [
                        'SSSS',
                        4
                    ], 0, function () {
                        return 10 * this.millisecond();
                    }), x(0, [
                        'SSSSS',
                        5
                    ], 0, function () {
                        return 100 * this.millisecond();
                    }), x(0, [
                        'SSSSSS',
                        6
                    ], 0, function () {
                        return 1000 * this.millisecond();
                    }), x(0, [
                        'SSSSSSS',
                        7
                    ], 0, function () {
                        return 10000 * this.millisecond();
                    }), x(0, [
                        'SSSSSSSS',
                        8
                    ], 0, function () {
                        return 100000 * this.millisecond();
                    }), x(0, [
                        'SSSSSSSSS',
                        9
                    ], 0, function () {
                        return 1000000 * this.millisecond();
                    }), R('millisecond', 'ms'), U('millisecond', 16), ee('S', xs, gs), ee('SS', xs, Ts), ee('SSS', xs, ws);
                    var Rr, Cr;
                    for (Rr = 'SSSS'; Rr.length <= 9; Rr += 'S')
                        ee(Rr, Ws);
                    for (Rr = 'S'; Rr.length <= 9; Rr += 'S')
                        se(Rr, Dn);
                    Cr = q('Milliseconds', !1), x('z', 0, 0, 'zoneAbbr'), x('zz', 0, 0, 'zoneName');
                    var Ir = p.prototype;
                    Ir.add = xr, Ir.calendar = ca, Ir.clone = Ma, Ir.diff = Da, Ir.endOf = za, Ir.format = ba, Ir.from = Sa, Ir.fromNow = Ha, Ir.to = ja, Ir.toNow = xa, Ir.get = Q, Ir.invalidAt = Ba, Ir.isAfter = La, Ir.isBefore = Ya, Ir.isBetween = ya, Ir.isSame = fa, Ir.isSameOrAfter = pa, Ir.isSameOrBefore = ka, Ir.isValid = Ga, Ir.lang = Or, Ir.locale = Pa, Ir.localeData = Oa, Ir.max = wr, Ir.min = Tr, Ir.parsingFlags = Va, Ir.set = X, Ir.startOf = Fa, Ir.subtract = Pr, Ir.toArray = Ca, Ir.toObject = Ia, Ir.toDate = Ra, Ir.toISOString = wa, Ir.inspect = va, 'undefined' != typeof Symbol && null != Symbol.for && (Ir[Symbol.for('nodejs.util.inspect.custom')] = function () {
                        return 'Moment<' + this.format() + '>';
                    }), Ir.toJSON = Ua, Ir.toString = Ta, Ir.unix = Ja, Ir.valueOf = Na, Ir.creationData = Ka, Ir.eraName = Qa, Ir.eraNarrow = Xa, Ir.eraAbbr = en, Ir.eraYear = tn, Ir.year = ar, Ir.isLeapYear = pe, Ir.weekYear = ln, Ir.isoWeekYear = hn, Ir.quarter = Ir.quarters = pn, Ir.month = ce, Ir.daysInMonth = Me, Ir.week = Ir.weeks = je, Ir.isoWeek = Ir.isoWeeks = xe, Ir.weeksInYear = Ln, Ir.weeksInWeekYear = Yn, Ir.isoWeeksInYear = cn, Ir.isoWeeksInISOWeekYear = Mn, Ir.date = zr, Ir.day = Ir.days = Je, Ir.weekday = Re, Ir.isoWeekday = Ce, Ir.dayOfYear = kn, Ir.hour = Ir.hours = lr, Ir.minute = Ir.minutes = Nr, Ir.second = Ir.seconds = Jr, Ir.millisecond = Ir.milliseconds = Cr, Ir.utcOffset = Gt, Ir.utc = Bt, Ir.local = Kt, Ir.parseZone = qt, Ir.hasAlignedHourOffset = Zt, Ir.isDST = $t, Ir.isLocal = Xt, Ir.isUtcOffset = ea, Ir.isUtc = ta, Ir.isUTC = ta, Ir.zoneAbbr = gn, Ir.zoneName = Tn, Ir.dates = g('dates accessor is deprecated. Use date instead.', zr), Ir.months = g('months accessor is deprecated. Use month instead', ce), Ir.years = g('years accessor is deprecated. Use year instead', ar), Ir.zone = g('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', Vt), Ir.isDSTShifted = g('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', Qt);
                    var Ur = S.prototype;
                    Ur.calendar = H, Ur.longDateFormat = E, Ur.invalidDate = F, Ur.ordinal = z, Ur.preparse = bn, Ur.postformat = bn, Ur.relativeTime = N, Ur.pastFuture = J, Ur.set = v, Ur.eras = qa, Ur.erasParse = Za, Ur.erasConvertYear = $a, Ur.erasAbbrRegex = nn, Ur.erasNameRegex = an, Ur.erasNarrowRegex = sn, Ur.months = oe, Ur.monthsShort = ue, Ur.monthsParse = le, Ur.monthsRegex = Ye, Ur.monthsShortRegex = Le, Ur.week = be, Ur.firstDayOfYear = He, Ur.firstDayOfWeek = Se, Ur.weekdays = Ae, Ur.weekdaysMin = Fe, Ur.weekdaysShort = Ee, Ur.weekdaysParse = Ne, Ur.weekdaysRegex = Ie, Ur.weekdaysShortRegex = Ue, Ur.weekdaysMinRegex = Ge, Ur.isPM = $e, Ur.meridiem = Qe, st('en', {
                        eras: [
                            {
                                since: '0001-01-01',
                                until: +(1 / 0),
                                offset: 1,
                                name: 'Anno Domini',
                                narrow: 'AD',
                                abbr: 'AD'
                            },
                            {
                                since: '0000-12-31',
                                until: -(1 / 0),
                                offset: 1,
                                name: 'Before Christ',
                                narrow: 'BC',
                                abbr: 'BC'
                            }
                        ],
                        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                        ordinal: function (e) {
                            var t = e % 10, a = 1 === K(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                            return e + a;
                        }
                    }), t.lang = g('moment.lang is deprecated. Use moment.locale instead.', st), t.langData = g('moment.langData is deprecated. Use moment.localeData instead.', dt);
                    var Gr = Math.abs, Vr = Vn('ms'), Br = Vn('s'), Kr = Vn('m'), qr = Vn('h'), Zr = Vn('d'), $r = Vn('w'), Qr = Vn('M'), Xr = Vn('Q'), ei = Vn('y'), ti = qn('milliseconds'), ai = qn('seconds'), ni = qn('minutes'), si = qn('hours'), ri = qn('days'), ii = qn('months'), di = qn('years'), _i = Math.round, oi = {
                            ss: 44,
                            s: 45,
                            m: 45,
                            h: 22,
                            d: 26,
                            w: null,
                            M: 11
                        }, ui = Math.abs, mi = Ft.prototype;
                    return mi.isValid = At, mi.abs = En, mi.add = zn, mi.subtract = Nn, mi.as = Un, mi.asMilliseconds = Vr, mi.asSeconds = Br, mi.asMinutes = Kr, mi.asHours = qr, mi.asDays = Zr, mi.asWeeks = $r, mi.asMonths = Qr, mi.asQuarters = Xr, mi.asYears = ei, mi.valueOf = Gn, mi._bubble = Rn, mi.clone = Bn, mi.get = Kn, mi.milliseconds = ti, mi.seconds = ai, mi.minutes = ni, mi.hours = si, mi.days = ri, mi.weeks = Zn, mi.months = ii, mi.years = di, mi.humanize = ts, mi.toISOString = ns, mi.toString = ns, mi.toJSON = ns, mi.locale = Pa, mi.localeData = Oa, mi.toIsoString = g('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', ns), mi.lang = Or, x('X', 0, 0, 'unix'), x('x', 0, 0, 'valueOf'), ee('x', As), ee('X', zs), se('X', function (e, t, a) {
                        a._d = new Date(1000 * parseFloat(e));
                    }), se('x', function (e, t, a) {
                        a._d = new Date(K(e));
                    }), t.version = '2.29.4', s(jt), t.fn = Ir, t.min = Pt, t.max = Ot, t.now = vr, t.utc = c, t.unix = wn, t.months = xn, t.isDate = m, t.locale = st, t.invalid = y, t.duration = aa, t.isMoment = k, t.weekdays = On, t.parseZone = vn, t.localeData = dt, t.isDuration = zt, t.monthsShort = Pn, t.weekdaysMin = An, t.defineLocale = rt, t.updateLocale = it, t.locales = _t, t.weekdaysShort = Wn, t.normalizeUnits = C, t.relativeTimeRounding = Xn, t.relativeTimeThreshold = es, t.calendarFormat = ha, t.prototype = Ir, t.HTML5_FMT = {
                        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
                        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
                        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
                        DATE: 'YYYY-MM-DD',
                        TIME: 'HH:mm',
                        TIME_SECONDS: 'HH:mm:ss',
                        TIME_MS: 'HH:mm:ss.SSS',
                        WEEK: 'GGGG-[W]WW',
                        MONTH: 'YYYY-MM'
                    }, t;
                });
            }.call(t, a(12)(e)));
        },
        function (e, t) {
            e.exports = function (e) {
                return e.webpackPolyfill || (e.deprecate = function () {
                }, e.paths = [], e.children = [], e.webpackPolyfill = 1), e;
            };
        },
        function (e, t, a) {
            function n(e) {
                return a(s(e));
            }
            function s(e) {
                return r[e] || function () {
                    throw new Error('Cannot find module \'' + e + '\'.');
                }();
            }
            var r = {
                './af': 14,
                './af.js': 14,
                './ar': 15,
                './ar-dz': 16,
                './ar-dz.js': 16,
                './ar-kw': 17,
                './ar-kw.js': 17,
                './ar-ly': 18,
                './ar-ly.js': 18,
                './ar-ma': 19,
                './ar-ma.js': 19,
                './ar-sa': 20,
                './ar-sa.js': 20,
                './ar-tn': 21,
                './ar-tn.js': 21,
                './ar.js': 15,
                './az': 22,
                './az.js': 22,
                './be': 23,
                './be.js': 23,
                './bg': 24,
                './bg.js': 24,
                './bm': 25,
                './bm.js': 25,
                './bn': 26,
                './bn-bd': 27,
                './bn-bd.js': 27,
                './bn.js': 26,
                './bo': 28,
                './bo.js': 28,
                './br': 29,
                './br.js': 29,
                './bs': 30,
                './bs.js': 30,
                './ca': 31,
                './ca.js': 31,
                './cs': 32,
                './cs.js': 32,
                './cv': 33,
                './cv.js': 33,
                './cy': 34,
                './cy.js': 34,
                './da': 35,
                './da.js': 35,
                './de': 36,
                './de-at': 37,
                './de-at.js': 37,
                './de-ch': 38,
                './de-ch.js': 38,
                './de.js': 36,
                './dv': 39,
                './dv.js': 39,
                './el': 40,
                './el.js': 40,
                './en-au': 41,
                './en-au.js': 41,
                './en-ca': 42,
                './en-ca.js': 42,
                './en-gb': 43,
                './en-gb.js': 43,
                './en-ie': 44,
                './en-ie.js': 44,
                './en-il': 45,
                './en-il.js': 45,
                './en-in': 46,
                './en-in.js': 46,
                './en-nz': 47,
                './en-nz.js': 47,
                './en-sg': 48,
                './en-sg.js': 48,
                './eo': 49,
                './eo.js': 49,
                './es': 50,
                './es-do': 51,
                './es-do.js': 51,
                './es-mx': 52,
                './es-mx.js': 52,
                './es-us': 53,
                './es-us.js': 53,
                './es.js': 50,
                './et': 54,
                './et.js': 54,
                './eu': 55,
                './eu.js': 55,
                './fa': 56,
                './fa.js': 56,
                './fi': 57,
                './fi.js': 57,
                './fil': 58,
                './fil.js': 58,
                './fo': 59,
                './fo.js': 59,
                './fr': 60,
                './fr-ca': 61,
                './fr-ca.js': 61,
                './fr-ch': 62,
                './fr-ch.js': 62,
                './fr.js': 60,
                './fy': 63,
                './fy.js': 63,
                './ga': 64,
                './ga.js': 64,
                './gd': 65,
                './gd.js': 65,
                './gl': 66,
                './gl.js': 66,
                './gom-deva': 67,
                './gom-deva.js': 67,
                './gom-latn': 68,
                './gom-latn.js': 68,
                './gu': 69,
                './gu.js': 69,
                './he': 70,
                './he.js': 70,
                './hi': 71,
                './hi.js': 71,
                './hr': 72,
                './hr.js': 72,
                './hu': 73,
                './hu.js': 73,
                './hy-am': 74,
                './hy-am.js': 74,
                './id': 75,
                './id.js': 75,
                './is': 76,
                './is.js': 76,
                './it': 77,
                './it-ch': 78,
                './it-ch.js': 78,
                './it.js': 77,
                './ja': 79,
                './ja.js': 79,
                './jv': 80,
                './jv.js': 80,
                './ka': 81,
                './ka.js': 81,
                './kk': 82,
                './kk.js': 82,
                './km': 83,
                './km.js': 83,
                './kn': 84,
                './kn.js': 84,
                './ko': 85,
                './ko.js': 85,
                './ku': 86,
                './ku.js': 86,
                './ky': 87,
                './ky.js': 87,
                './lb': 88,
                './lb.js': 88,
                './lo': 89,
                './lo.js': 89,
                './lt': 90,
                './lt.js': 90,
                './lv': 91,
                './lv.js': 91,
                './me': 92,
                './me.js': 92,
                './mi': 93,
                './mi.js': 93,
                './mk': 94,
                './mk.js': 94,
                './ml': 95,
                './ml.js': 95,
                './mn': 96,
                './mn.js': 96,
                './mr': 97,
                './mr.js': 97,
                './ms': 98,
                './ms-my': 99,
                './ms-my.js': 99,
                './ms.js': 98,
                './mt': 100,
                './mt.js': 100,
                './my': 101,
                './my.js': 101,
                './nb': 102,
                './nb.js': 102,
                './ne': 103,
                './ne.js': 103,
                './nl': 104,
                './nl-be': 105,
                './nl-be.js': 105,
                './nl.js': 104,
                './nn': 106,
                './nn.js': 106,
                './oc-lnc': 107,
                './oc-lnc.js': 107,
                './pa-in': 108,
                './pa-in.js': 108,
                './pl': 109,
                './pl.js': 109,
                './pt': 110,
                './pt-br': 111,
                './pt-br.js': 111,
                './pt.js': 110,
                './ro': 112,
                './ro.js': 112,
                './ru': 113,
                './ru.js': 113,
                './sd': 114,
                './sd.js': 114,
                './se': 115,
                './se.js': 115,
                './si': 116,
                './si.js': 116,
                './sk': 117,
                './sk.js': 117,
                './sl': 118,
                './sl.js': 118,
                './sq': 119,
                './sq.js': 119,
                './sr': 120,
                './sr-cyrl': 121,
                './sr-cyrl.js': 121,
                './sr.js': 120,
                './ss': 122,
                './ss.js': 122,
                './sv': 123,
                './sv.js': 123,
                './sw': 124,
                './sw.js': 124,
                './ta': 125,
                './ta.js': 125,
                './te': 126,
                './te.js': 126,
                './tet': 127,
                './tet.js': 127,
                './tg': 128,
                './tg.js': 128,
                './th': 129,
                './th.js': 129,
                './tk': 130,
                './tk.js': 130,
                './tl-ph': 131,
                './tl-ph.js': 131,
                './tlh': 132,
                './tlh.js': 132,
                './tr': 133,
                './tr.js': 133,
                './tzl': 134,
                './tzl.js': 134,
                './tzm': 135,
                './tzm-latn': 136,
                './tzm-latn.js': 136,
                './tzm.js': 135,
                './ug-cn': 137,
                './ug-cn.js': 137,
                './uk': 138,
                './uk.js': 138,
                './ur': 139,
                './ur.js': 139,
                './uz': 140,
                './uz-latn': 141,
                './uz-latn.js': 141,
                './uz.js': 140,
                './vi': 142,
                './vi.js': 142,
                './x-pseudo': 143,
                './x-pseudo.js': 143,
                './yo': 144,
                './yo.js': 144,
                './zh-cn': 145,
                './zh-cn.js': 145,
                './zh-hk': 146,
                './zh-hk.js': 146,
                './zh-mo': 147,
                './zh-mo.js': 147,
                './zh-tw': 148,
                './zh-tw.js': 148
            };
            n.keys = function () {
                return Object.keys(r);
            }, n.resolve = s, e.exports = n, n.id = 13;
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('af', {
                    months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
                    monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
                    weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
                    weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
                    weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
                    meridiemParse: /vm|nm/i,
                    isPM: function (e) {
                        return /^nm$/i.test(e);
                    },
                    meridiem: function (e, t, a) {
                        return e < 12 ? a ? 'vm' : 'VM' : a ? 'nm' : 'NM';
                    },
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Vandag om] LT',
                        nextDay: '[Môre om] LT',
                        nextWeek: 'dddd [om] LT',
                        lastDay: '[Gister om] LT',
                        lastWeek: '[Laas] dddd [om] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'oor %s',
                        past: '%s gelede',
                        s: '\'n paar sekondes',
                        ss: '%d sekondes',
                        m: '\'n minuut',
                        mm: '%d minute',
                        h: '\'n uur',
                        hh: '%d ure',
                        d: '\'n dag',
                        dd: '%d dae',
                        M: '\'n maand',
                        MM: '%d maande',
                        y: '\'n jaar',
                        yy: '%d jaar'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                    ordinal: function (e) {
                        return e + (1 === e || 8 === e || e >= 20 ? 'ste' : 'de');
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '١',
                        2: '٢',
                        3: '٣',
                        4: '٤',
                        5: '٥',
                        6: '٦',
                        7: '٧',
                        8: '٨',
                        9: '٩',
                        0: '٠'
                    }, a = {
                        '١': '1',
                        '٢': '2',
                        '٣': '3',
                        '٤': '4',
                        '٥': '5',
                        '٦': '6',
                        '٧': '7',
                        '٨': '8',
                        '٩': '9',
                        '٠': '0'
                    }, n = function (e) {
                        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
                    }, s = {
                        s: [
                            'أقل من ثانية',
                            'ثانية واحدة',
                            [
                                'ثانيتان',
                                'ثانيتين'
                            ],
                            '%d ثوان',
                            '%d ثانية',
                            '%d ثانية'
                        ],
                        m: [
                            'أقل من دقيقة',
                            'دقيقة واحدة',
                            [
                                'دقيقتان',
                                'دقيقتين'
                            ],
                            '%d دقائق',
                            '%d دقيقة',
                            '%d دقيقة'
                        ],
                        h: [
                            'أقل من ساعة',
                            'ساعة واحدة',
                            [
                                'ساعتان',
                                'ساعتين'
                            ],
                            '%d ساعات',
                            '%d ساعة',
                            '%d ساعة'
                        ],
                        d: [
                            'أقل من يوم',
                            'يوم واحد',
                            [
                                'يومان',
                                'يومين'
                            ],
                            '%d أيام',
                            '%d يومًا',
                            '%d يوم'
                        ],
                        M: [
                            'أقل من شهر',
                            'شهر واحد',
                            [
                                'شهران',
                                'شهرين'
                            ],
                            '%d أشهر',
                            '%d شهرا',
                            '%d شهر'
                        ],
                        y: [
                            'أقل من عام',
                            'عام واحد',
                            [
                                'عامان',
                                'عامين'
                            ],
                            '%d أعوام',
                            '%d عامًا',
                            '%d عام'
                        ]
                    }, r = function (e) {
                        return function (t, a, r, i) {
                            var d = n(t), _ = s[e][n(t)];
                            return 2 === d && (_ = _[a ? 0 : 1]), _.replace(/%d/i, t);
                        };
                    }, i = [
                        'يناير',
                        'فبراير',
                        'مارس',
                        'أبريل',
                        'مايو',
                        'يونيو',
                        'يوليو',
                        'أغسطس',
                        'سبتمبر',
                        'أكتوبر',
                        'نوفمبر',
                        'ديسمبر'
                    ], d = e.defineLocale('ar', {
                        months: i,
                        monthsShort: i,
                        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'D/\u200FM/\u200FYYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm'
                        },
                        meridiemParse: /ص|م/,
                        isPM: function (e) {
                            return 'م' === e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'ص' : 'م';
                        },
                        calendar: {
                            sameDay: '[اليوم عند الساعة] LT',
                            nextDay: '[غدًا عند الساعة] LT',
                            nextWeek: 'dddd [عند الساعة] LT',
                            lastDay: '[أمس عند الساعة] LT',
                            lastWeek: 'dddd [عند الساعة] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'بعد %s',
                            past: 'منذ %s',
                            s: r('s'),
                            ss: r('s'),
                            m: r('m'),
                            mm: r('m'),
                            h: r('h'),
                            hh: r('h'),
                            d: r('d'),
                            dd: r('d'),
                            M: r('M'),
                            MM: r('M'),
                            y: r('y'),
                            yy: r('y')
                        },
                        preparse: function (e) {
                            return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
                                return a[e];
                            }).replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            }).replace(/,/g, '\u060C');
                        },
                        week: {
                            dow: 6,
                            doy: 12
                        }
                    });
                return d;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = function (e) {
                        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
                    }, a = {
                        s: [
                            'أقل من ثانية',
                            'ثانية واحدة',
                            [
                                'ثانيتان',
                                'ثانيتين'
                            ],
                            '%d ثوان',
                            '%d ثانية',
                            '%d ثانية'
                        ],
                        m: [
                            'أقل من دقيقة',
                            'دقيقة واحدة',
                            [
                                'دقيقتان',
                                'دقيقتين'
                            ],
                            '%d دقائق',
                            '%d دقيقة',
                            '%d دقيقة'
                        ],
                        h: [
                            'أقل من ساعة',
                            'ساعة واحدة',
                            [
                                'ساعتان',
                                'ساعتين'
                            ],
                            '%d ساعات',
                            '%d ساعة',
                            '%d ساعة'
                        ],
                        d: [
                            'أقل من يوم',
                            'يوم واحد',
                            [
                                'يومان',
                                'يومين'
                            ],
                            '%d أيام',
                            '%d يومًا',
                            '%d يوم'
                        ],
                        M: [
                            'أقل من شهر',
                            'شهر واحد',
                            [
                                'شهران',
                                'شهرين'
                            ],
                            '%d أشهر',
                            '%d شهرا',
                            '%d شهر'
                        ],
                        y: [
                            'أقل من عام',
                            'عام واحد',
                            [
                                'عامان',
                                'عامين'
                            ],
                            '%d أعوام',
                            '%d عامًا',
                            '%d عام'
                        ]
                    }, n = function (e) {
                        return function (n, s, r, i) {
                            var d = t(n), _ = a[e][t(n)];
                            return 2 === d && (_ = _[s ? 0 : 1]), _.replace(/%d/i, n);
                        };
                    }, s = [
                        'جانفي',
                        'فيفري',
                        'مارس',
                        'أفريل',
                        'ماي',
                        'جوان',
                        'جويلية',
                        'أوت',
                        'سبتمبر',
                        'أكتوبر',
                        'نوفمبر',
                        'ديسمبر'
                    ], r = e.defineLocale('ar-dz', {
                        months: s,
                        monthsShort: s,
                        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'D/\u200FM/\u200FYYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm'
                        },
                        meridiemParse: /ص|م/,
                        isPM: function (e) {
                            return 'م' === e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'ص' : 'م';
                        },
                        calendar: {
                            sameDay: '[اليوم عند الساعة] LT',
                            nextDay: '[غدًا عند الساعة] LT',
                            nextWeek: 'dddd [عند الساعة] LT',
                            lastDay: '[أمس عند الساعة] LT',
                            lastWeek: 'dddd [عند الساعة] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'بعد %s',
                            past: 'منذ %s',
                            s: n('s'),
                            ss: n('s'),
                            m: n('m'),
                            mm: n('m'),
                            h: n('h'),
                            hh: n('h'),
                            d: n('d'),
                            dd: n('d'),
                            M: n('M'),
                            MM: n('M'),
                            y: n('y'),
                            yy: n('y')
                        },
                        postformat: function (e) {
                            return e.replace(/,/g, '\u060C');
                        },
                        week: {
                            dow: 0,
                            doy: 4
                        }
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ar-kw', {
                    months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
                    monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
                    weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                    weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
                    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[اليوم على الساعة] LT',
                        nextDay: '[غدا على الساعة] LT',
                        nextWeek: 'dddd [على الساعة] LT',
                        lastDay: '[أمس على الساعة] LT',
                        lastWeek: 'dddd [على الساعة] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'في %s',
                        past: 'منذ %s',
                        s: 'ثوان',
                        ss: '%d ثانية',
                        m: 'دقيقة',
                        mm: '%d دقائق',
                        h: 'ساعة',
                        hh: '%d ساعات',
                        d: 'يوم',
                        dd: '%d أيام',
                        M: 'شهر',
                        MM: '%d أشهر',
                        y: 'سنة',
                        yy: '%d سنوات'
                    },
                    week: {
                        dow: 0,
                        doy: 12
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '1',
                        2: '2',
                        3: '3',
                        4: '4',
                        5: '5',
                        6: '6',
                        7: '7',
                        8: '8',
                        9: '9',
                        0: '0'
                    }, a = function (e) {
                        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
                    }, n = {
                        s: [
                            'أقل من ثانية',
                            'ثانية واحدة',
                            [
                                'ثانيتان',
                                'ثانيتين'
                            ],
                            '%d ثوان',
                            '%d ثانية',
                            '%d ثانية'
                        ],
                        m: [
                            'أقل من دقيقة',
                            'دقيقة واحدة',
                            [
                                'دقيقتان',
                                'دقيقتين'
                            ],
                            '%d دقائق',
                            '%d دقيقة',
                            '%d دقيقة'
                        ],
                        h: [
                            'أقل من ساعة',
                            'ساعة واحدة',
                            [
                                'ساعتان',
                                'ساعتين'
                            ],
                            '%d ساعات',
                            '%d ساعة',
                            '%d ساعة'
                        ],
                        d: [
                            'أقل من يوم',
                            'يوم واحد',
                            [
                                'يومان',
                                'يومين'
                            ],
                            '%d أيام',
                            '%d يومًا',
                            '%d يوم'
                        ],
                        M: [
                            'أقل من شهر',
                            'شهر واحد',
                            [
                                'شهران',
                                'شهرين'
                            ],
                            '%d أشهر',
                            '%d شهرا',
                            '%d شهر'
                        ],
                        y: [
                            'أقل من عام',
                            'عام واحد',
                            [
                                'عامان',
                                'عامين'
                            ],
                            '%d أعوام',
                            '%d عامًا',
                            '%d عام'
                        ]
                    }, s = function (e) {
                        return function (t, s, r, i) {
                            var d = a(t), _ = n[e][a(t)];
                            return 2 === d && (_ = _[s ? 0 : 1]), _.replace(/%d/i, t);
                        };
                    }, r = [
                        'يناير',
                        'فبراير',
                        'مارس',
                        'أبريل',
                        'مايو',
                        'يونيو',
                        'يوليو',
                        'أغسطس',
                        'سبتمبر',
                        'أكتوبر',
                        'نوفمبر',
                        'ديسمبر'
                    ], i = e.defineLocale('ar-ly', {
                        months: r,
                        monthsShort: r,
                        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'D/\u200FM/\u200FYYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm'
                        },
                        meridiemParse: /ص|م/,
                        isPM: function (e) {
                            return 'م' === e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'ص' : 'م';
                        },
                        calendar: {
                            sameDay: '[اليوم عند الساعة] LT',
                            nextDay: '[غدًا عند الساعة] LT',
                            nextWeek: 'dddd [عند الساعة] LT',
                            lastDay: '[أمس عند الساعة] LT',
                            lastWeek: 'dddd [عند الساعة] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'بعد %s',
                            past: 'منذ %s',
                            s: s('s'),
                            ss: s('s'),
                            m: s('m'),
                            mm: s('m'),
                            h: s('h'),
                            hh: s('h'),
                            d: s('d'),
                            dd: s('d'),
                            M: s('M'),
                            MM: s('M'),
                            y: s('y'),
                            yy: s('y')
                        },
                        preparse: function (e) {
                            return e.replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            }).replace(/,/g, '\u060C');
                        },
                        week: {
                            dow: 6,
                            doy: 12
                        }
                    });
                return i;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ar-ma', {
                    months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
                    monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
                    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                    weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
                    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[اليوم على الساعة] LT',
                        nextDay: '[غدا على الساعة] LT',
                        nextWeek: 'dddd [على الساعة] LT',
                        lastDay: '[أمس على الساعة] LT',
                        lastWeek: 'dddd [على الساعة] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'في %s',
                        past: 'منذ %s',
                        s: 'ثوان',
                        ss: '%d ثانية',
                        m: 'دقيقة',
                        mm: '%d دقائق',
                        h: 'ساعة',
                        hh: '%d ساعات',
                        d: 'يوم',
                        dd: '%d أيام',
                        M: 'شهر',
                        MM: '%d أشهر',
                        y: 'سنة',
                        yy: '%d سنوات'
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '١',
                        2: '٢',
                        3: '٣',
                        4: '٤',
                        5: '٥',
                        6: '٦',
                        7: '٧',
                        8: '٨',
                        9: '٩',
                        0: '٠'
                    }, a = {
                        '١': '1',
                        '٢': '2',
                        '٣': '3',
                        '٤': '4',
                        '٥': '5',
                        '٦': '6',
                        '٧': '7',
                        '٨': '8',
                        '٩': '9',
                        '٠': '0'
                    }, n = e.defineLocale('ar-sa', {
                        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
                        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
                        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm'
                        },
                        meridiemParse: /ص|م/,
                        isPM: function (e) {
                            return 'م' === e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'ص' : 'م';
                        },
                        calendar: {
                            sameDay: '[اليوم على الساعة] LT',
                            nextDay: '[غدا على الساعة] LT',
                            nextWeek: 'dddd [على الساعة] LT',
                            lastDay: '[أمس على الساعة] LT',
                            lastWeek: 'dddd [على الساعة] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'في %s',
                            past: 'منذ %s',
                            s: 'ثوان',
                            ss: '%d ثانية',
                            m: 'دقيقة',
                            mm: '%d دقائق',
                            h: 'ساعة',
                            hh: '%d ساعات',
                            d: 'يوم',
                            dd: '%d أيام',
                            M: 'شهر',
                            MM: '%d أشهر',
                            y: 'سنة',
                            yy: '%d سنوات'
                        },
                        preparse: function (e) {
                            return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
                                return a[e];
                            }).replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            }).replace(/,/g, '\u060C');
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ar-tn', {
                    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
                    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
                    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
                    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[اليوم على الساعة] LT',
                        nextDay: '[غدا على الساعة] LT',
                        nextWeek: 'dddd [على الساعة] LT',
                        lastDay: '[أمس على الساعة] LT',
                        lastWeek: 'dddd [على الساعة] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'في %s',
                        past: 'منذ %s',
                        s: 'ثوان',
                        ss: '%d ثانية',
                        m: 'دقيقة',
                        mm: '%d دقائق',
                        h: 'ساعة',
                        hh: '%d ساعات',
                        d: 'يوم',
                        dd: '%d أيام',
                        M: 'شهر',
                        MM: '%d أشهر',
                        y: 'سنة',
                        yy: '%d سنوات'
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '-inci',
                        5: '-inci',
                        8: '-inci',
                        70: '-inci',
                        80: '-inci',
                        2: '-nci',
                        7: '-nci',
                        20: '-nci',
                        50: '-nci',
                        3: '-üncü',
                        4: '-üncü',
                        100: '-üncü',
                        6: '-ncı',
                        9: '-uncu',
                        10: '-uncu',
                        30: '-uncu',
                        60: '-ıncı',
                        90: '-ıncı'
                    }, a = e.defineLocale('az', {
                        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
                        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
                        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
                        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
                        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[bugün saat] LT',
                            nextDay: '[sabah saat] LT',
                            nextWeek: '[gələn həftə] dddd [saat] LT',
                            lastDay: '[dünən] LT',
                            lastWeek: '[keçən həftə] dddd [saat] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s sonra',
                            past: '%s əvvəl',
                            s: 'bir neçə saniyə',
                            ss: '%d saniyə',
                            m: 'bir dəqiqə',
                            mm: '%d dəqiqə',
                            h: 'bir saat',
                            hh: '%d saat',
                            d: 'bir gün',
                            dd: '%d gün',
                            M: 'bir ay',
                            MM: '%d ay',
                            y: 'bir il',
                            yy: '%d il'
                        },
                        meridiemParse: /gecə|səhər|gündüz|axşam/,
                        isPM: function (e) {
                            return /^(gündüz|axşam)$/.test(e);
                        },
                        meridiem: function (e, t, a) {
                            return e < 4 ? 'gecə' : e < 12 ? 'səhər' : e < 17 ? 'gündüz' : 'axşam';
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
                        ordinal: function (e) {
                            if (0 === e)
                                return e + '-ıncı';
                            var a = e % 10, n = e % 100 - a, s = e >= 100 ? 100 : null;
                            return e + (t[a] || t[n] || t[s]);
                        },
                        week: {
                            dow: 1,
                            doy: 7
                        }
                    });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t) {
                    var a = e.split('_');
                    return t % 10 === 1 && t % 100 !== 11 ? a[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? a[1] : a[2];
                }
                function a(e, a, n) {
                    var s = {
                        ss: a ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
                        mm: a ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
                        hh: a ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
                        dd: 'дзень_дні_дзён',
                        MM: 'месяц_месяцы_месяцаў',
                        yy: 'год_гады_гадоў'
                    };
                    return 'm' === n ? a ? 'хвіліна' : 'хвіліну' : 'h' === n ? a ? 'гадзіна' : 'гадзіну' : e + ' ' + t(s[n], +e);
                }
                var n = e.defineLocale('be', {
                    months: {
                        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
                        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
                    },
                    monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
                    weekdays: {
                        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
                        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
                        isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
                    },
                    weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
                    weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY г.',
                        LLL: 'D MMMM YYYY г., HH:mm',
                        LLLL: 'dddd, D MMMM YYYY г., HH:mm'
                    },
                    calendar: {
                        sameDay: '[Сёння ў] LT',
                        nextDay: '[Заўтра ў] LT',
                        lastDay: '[Учора ў] LT',
                        nextWeek: function () {
                            return '[У] dddd [ў] LT';
                        },
                        lastWeek: function () {
                            switch (this.day()) {
                            case 0:
                            case 3:
                            case 5:
                            case 6:
                                return '[У мінулую] dddd [ў] LT';
                            case 1:
                            case 2:
                            case 4:
                                return '[У мінулы] dddd [ў] LT';
                            }
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'праз %s',
                        past: '%s таму',
                        s: 'некалькі секунд',
                        m: a,
                        mm: a,
                        h: a,
                        hh: a,
                        d: 'дзень',
                        dd: a,
                        M: 'месяц',
                        MM: a,
                        y: 'год',
                        yy: a
                    },
                    meridiemParse: /ночы|раніцы|дня|вечара/,
                    isPM: function (e) {
                        return /^(дня|вечара)$/.test(e);
                    },
                    meridiem: function (e, t, a) {
                        return e < 4 ? 'ночы' : e < 12 ? 'раніцы' : e < 17 ? 'дня' : 'вечара';
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'M':
                        case 'd':
                        case 'DDD':
                        case 'w':
                        case 'W':
                            return e % 10 !== 2 && e % 10 !== 3 || e % 100 === 12 || e % 100 === 13 ? e + '-ы' : e + '-і';
                        case 'D':
                            return e + '-га';
                        default:
                            return e;
                        }
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('bg', {
                    months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
                    monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
                    weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
                    weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
                    weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'D.MM.YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY H:mm',
                        LLLL: 'dddd, D MMMM YYYY H:mm'
                    },
                    calendar: {
                        sameDay: '[Днес в] LT',
                        nextDay: '[Утре в] LT',
                        nextWeek: 'dddd [в] LT',
                        lastDay: '[Вчера в] LT',
                        lastWeek: function () {
                            switch (this.day()) {
                            case 0:
                            case 3:
                            case 6:
                                return '[Миналата] dddd [в] LT';
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                                return '[Миналия] dddd [в] LT';
                            }
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'след %s',
                        past: 'преди %s',
                        s: 'няколко секунди',
                        ss: '%d секунди',
                        m: 'минута',
                        mm: '%d минути',
                        h: 'час',
                        hh: '%d часа',
                        d: 'ден',
                        dd: '%d дена',
                        w: 'седмица',
                        ww: '%d седмици',
                        M: 'месец',
                        MM: '%d месеца',
                        y: 'година',
                        yy: '%d години'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
                    ordinal: function (e) {
                        var t = e % 10, a = e % 100;
                        return 0 === e ? e + '-ев' : 0 === a ? e + '-ен' : a > 10 && a < 20 ? e + '-ти' : 1 === t ? e + '-ви' : 2 === t ? e + '-ри' : 7 === t || 8 === t ? e + '-ми' : e + '-ти';
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('bm', {
                    months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
                    monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
                    weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
                    weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
                    weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'MMMM [tile] D [san] YYYY',
                        LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
                        LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
                    },
                    calendar: {
                        sameDay: '[Bi lɛrɛ] LT',
                        nextDay: '[Sini lɛrɛ] LT',
                        nextWeek: 'dddd [don lɛrɛ] LT',
                        lastDay: '[Kunu lɛrɛ] LT',
                        lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s kɔnɔ',
                        past: 'a bɛ %s bɔ',
                        s: 'sanga dama dama',
                        ss: 'sekondi %d',
                        m: 'miniti kelen',
                        mm: 'miniti %d',
                        h: 'lɛrɛ kelen',
                        hh: 'lɛrɛ %d',
                        d: 'tile kelen',
                        dd: 'tile %d',
                        M: 'kalo kelen',
                        MM: 'kalo %d',
                        y: 'san kelen',
                        yy: 'san %d'
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '১',
                        2: '২',
                        3: '৩',
                        4: '৪',
                        5: '৫',
                        6: '৬',
                        7: '৭',
                        8: '৮',
                        9: '৯',
                        0: '০'
                    }, a = {
                        '১': '1',
                        '২': '2',
                        '৩': '3',
                        '৪': '4',
                        '৫': '5',
                        '৬': '6',
                        '৭': '7',
                        '৮': '8',
                        '৯': '9',
                        '০': '0'
                    }, n = e.defineLocale('bn', {
                        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
                        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
                        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
                        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
                        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm সময়',
                            LTS: 'A h:mm:ss সময়',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm সময়',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
                        },
                        calendar: {
                            sameDay: '[আজ] LT',
                            nextDay: '[আগামীকাল] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[গতকাল] LT',
                            lastWeek: '[গত] dddd, LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s পরে',
                            past: '%s আগে',
                            s: 'কয়েক সেকেন্ড',
                            ss: '%d সেকেন্ড',
                            m: 'এক মিনিট',
                            mm: '%d মিনিট',
                            h: 'এক ঘন্টা',
                            hh: '%d ঘন্টা',
                            d: 'এক দিন',
                            dd: '%d দিন',
                            M: 'এক মাস',
                            MM: '%d মাস',
                            y: 'এক বছর',
                            yy: '%d বছর'
                        },
                        preparse: function (e) {
                            return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'রাত' === t && e >= 4 || 'দুপুর' === t && e < 5 || 'বিকাল' === t ? e + 12 : e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 4 ? 'রাত' : e < 10 ? 'সকাল' : e < 17 ? 'দুপুর' : e < 20 ? 'বিকাল' : 'রাত';
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '১',
                        2: '২',
                        3: '৩',
                        4: '৪',
                        5: '৫',
                        6: '৬',
                        7: '৭',
                        8: '৮',
                        9: '৯',
                        0: '০'
                    }, a = {
                        '১': '1',
                        '২': '2',
                        '৩': '3',
                        '৪': '4',
                        '৫': '5',
                        '৬': '6',
                        '৭': '7',
                        '৮': '8',
                        '৯': '9',
                        '০': '0'
                    }, n = e.defineLocale('bn-bd', {
                        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
                        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
                        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
                        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
                        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm সময়',
                            LTS: 'A h:mm:ss সময়',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm সময়',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
                        },
                        calendar: {
                            sameDay: '[আজ] LT',
                            nextDay: '[আগামীকাল] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[গতকাল] LT',
                            lastWeek: '[গত] dddd, LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s পরে',
                            past: '%s আগে',
                            s: 'কয়েক সেকেন্ড',
                            ss: '%d সেকেন্ড',
                            m: 'এক মিনিট',
                            mm: '%d মিনিট',
                            h: 'এক ঘন্টা',
                            hh: '%d ঘন্টা',
                            d: 'এক দিন',
                            dd: '%d দিন',
                            M: 'এক মাস',
                            MM: '%d মাস',
                            y: 'এক বছর',
                            yy: '%d বছর'
                        },
                        preparse: function (e) {
                            return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'রাত' === t ? e < 4 ? e : e + 12 : 'ভোর' === t ? e : 'সকাল' === t ? e : 'দুপুর' === t ? e >= 3 ? e : e + 12 : 'বিকাল' === t ? e + 12 : 'সন্ধ্যা' === t ? e + 12 : void 0;
                        },
                        meridiem: function (e, t, a) {
                            return e < 4 ? 'রাত' : e < 6 ? 'ভোর' : e < 12 ? 'সকাল' : e < 15 ? 'দুপুর' : e < 18 ? 'বিকাল' : e < 20 ? 'সন্ধ্যা' : 'রাত';
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '༡',
                        2: '༢',
                        3: '༣',
                        4: '༤',
                        5: '༥',
                        6: '༦',
                        7: '༧',
                        8: '༨',
                        9: '༩',
                        0: '༠'
                    }, a = {
                        '༡': '1',
                        '༢': '2',
                        '༣': '3',
                        '༤': '4',
                        '༥': '5',
                        '༦': '6',
                        '༧': '7',
                        '༨': '8',
                        '༩': '9',
                        '༠': '0'
                    }, n = e.defineLocale('bo', {
                        months: 'ཟླ\u0F0Bབ\u0F0Bདང\u0F0Bཔོ_ཟླ\u0F0Bབ\u0F0Bགཉིས\u0F0Bཔ_ཟླ\u0F0Bབ\u0F0Bགསུམ\u0F0Bཔ_ཟླ\u0F0Bབ\u0F0Bབཞི\u0F0Bཔ_ཟླ\u0F0Bབ\u0F0Bལྔ\u0F0Bཔ_ཟླ\u0F0Bབ\u0F0Bདྲུག\u0F0Bཔ_ཟླ\u0F0Bབ\u0F0Bབདུན\u0F0Bཔ_ཟླ\u0F0Bབ\u0F0Bབརྒྱད\u0F0Bཔ_ཟླ\u0F0Bབ\u0F0Bདགུ\u0F0Bཔ_ཟླ\u0F0Bབ\u0F0Bབཅུ\u0F0Bཔ_ཟླ\u0F0Bབ\u0F0Bབཅུ\u0F0Bགཅིག\u0F0Bཔ_ཟླ\u0F0Bབ\u0F0Bབཅུ\u0F0Bགཉིས\u0F0Bཔ'.split('_'),
                        monthsShort: 'ཟླ\u0F0B1_ཟླ\u0F0B2_ཟླ\u0F0B3_ཟླ\u0F0B4_ཟླ\u0F0B5_ཟླ\u0F0B6_ཟླ\u0F0B7_ཟླ\u0F0B8_ཟླ\u0F0B9_ཟླ\u0F0B10_ཟླ\u0F0B11_ཟླ\u0F0B12'.split('_'),
                        monthsShortRegex: /^(ཟླ་\d{1,2})/,
                        monthsParseExact: !0,
                        weekdays: 'གཟའ\u0F0Bཉི\u0F0Bམ\u0F0B_གཟའ\u0F0Bཟླ\u0F0Bབ\u0F0B_གཟའ\u0F0Bམིག\u0F0Bདམར\u0F0B_གཟའ\u0F0Bལྷག\u0F0Bཔ\u0F0B_གཟའ\u0F0Bཕུར\u0F0Bབུ_གཟའ\u0F0Bཔ\u0F0Bསངས\u0F0B_གཟའ\u0F0Bསྤེན\u0F0Bཔ\u0F0B'.split('_'),
                        weekdaysShort: 'ཉི\u0F0Bམ\u0F0B_ཟླ\u0F0Bབ\u0F0B_མིག\u0F0Bདམར\u0F0B_ལྷག\u0F0Bཔ\u0F0B_ཕུར\u0F0Bབུ_པ\u0F0Bསངས\u0F0B_སྤེན\u0F0Bཔ\u0F0B'.split('_'),
                        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm',
                            LTS: 'A h:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm'
                        },
                        calendar: {
                            sameDay: '[དི\u0F0Bརིང] LT',
                            nextDay: '[སང\u0F0Bཉིན] LT',
                            nextWeek: '[བདུན\u0F0Bཕྲག\u0F0Bརྗེས\u0F0Bམ], LT',
                            lastDay: '[ཁ\u0F0Bསང] LT',
                            lastWeek: '[བདུན\u0F0Bཕྲག\u0F0Bམཐའ\u0F0Bམ] dddd, LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s ལ\u0F0B',
                            past: '%s སྔན\u0F0Bལ',
                            s: 'ལམ\u0F0Bསང',
                            ss: '%d སྐར\u0F0Bཆ\u0F0D',
                            m: 'སྐར\u0F0Bམ\u0F0Bགཅིག',
                            mm: '%d སྐར\u0F0Bམ',
                            h: 'ཆུ\u0F0Bཚོད\u0F0Bགཅིག',
                            hh: '%d ཆུ\u0F0Bཚོད',
                            d: 'ཉིན\u0F0Bགཅིག',
                            dd: '%d ཉིན\u0F0B',
                            M: 'ཟླ\u0F0Bབ\u0F0Bགཅིག',
                            MM: '%d ཟླ\u0F0Bབ',
                            y: 'ལོ\u0F0Bགཅིག',
                            yy: '%d ལོ'
                        },
                        preparse: function (e) {
                            return e.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'མཚན\u0F0Bམོ' === t && e >= 4 || 'ཉིན\u0F0Bགུང' === t && e < 5 || 'དགོང\u0F0Bདག' === t ? e + 12 : e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 4 ? 'མཚན\u0F0Bམོ' : e < 10 ? 'ཞོགས\u0F0Bཀས' : e < 17 ? 'ཉིན\u0F0Bགུང' : e < 20 ? 'དགོང\u0F0Bདག' : 'མཚན\u0F0Bམོ';
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a) {
                    var n = {
                        mm: 'munutenn',
                        MM: 'miz',
                        dd: 'devezh'
                    };
                    return e + ' ' + s(n[a], e);
                }
                function a(e) {
                    switch (n(e)) {
                    case 1:
                    case 3:
                    case 4:
                    case 5:
                    case 9:
                        return e + ' bloaz';
                    default:
                        return e + ' vloaz';
                    }
                }
                function n(e) {
                    return e > 9 ? n(e % 10) : e;
                }
                function s(e, t) {
                    return 2 === t ? r(e) : e;
                }
                function r(e) {
                    var t = {
                        m: 'v',
                        b: 'v',
                        d: 'z'
                    };
                    return void 0 === t[e.charAt(0)] ? e : t[e.charAt(0)] + e.substring(1);
                }
                var i = [
                        /^gen/i,
                        /^c[ʼ\']hwe/i,
                        /^meu/i,
                        /^ebr/i,
                        /^mae/i,
                        /^(mez|eve)/i,
                        /^gou/i,
                        /^eos/i,
                        /^gwe/i,
                        /^her/i,
                        /^du/i,
                        /^ker/i
                    ], d = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i, _ = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i, o = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i, u = [
                        /^sul/i,
                        /^lun/i,
                        /^meurzh/i,
                        /^merc[ʼ\']her/i,
                        /^yaou/i,
                        /^gwener/i,
                        /^sadorn/i
                    ], m = [
                        /^Sul/i,
                        /^Lun/i,
                        /^Meu/i,
                        /^Mer/i,
                        /^Yao/i,
                        /^Gwe/i,
                        /^Sad/i
                    ], l = [
                        /^Su/i,
                        /^Lu/i,
                        /^Me([^r]|$)/i,
                        /^Mer/i,
                        /^Ya/i,
                        /^Gw/i,
                        /^Sa/i
                    ], h = e.defineLocale('br', {
                        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
                        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
                        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
                        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
                        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
                        weekdaysParse: l,
                        fullWeekdaysParse: u,
                        shortWeekdaysParse: m,
                        minWeekdaysParse: l,
                        monthsRegex: d,
                        monthsShortRegex: d,
                        monthsStrictRegex: _,
                        monthsShortStrictRegex: o,
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: i,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D [a viz] MMMM YYYY',
                            LLL: 'D [a viz] MMMM YYYY HH:mm',
                            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[Hiziv da] LT',
                            nextDay: '[Warcʼhoazh da] LT',
                            nextWeek: 'dddd [da] LT',
                            lastDay: '[Decʼh da] LT',
                            lastWeek: 'dddd [paset da] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'a-benn %s',
                            past: '%s ʼzo',
                            s: 'un nebeud segondennoù',
                            ss: '%d eilenn',
                            m: 'ur vunutenn',
                            mm: t,
                            h: 'un eur',
                            hh: '%d eur',
                            d: 'un devezh',
                            dd: t,
                            M: 'ur miz',
                            MM: t,
                            y: 'ur bloaz',
                            yy: a
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
                        ordinal: function (e) {
                            var t = 1 === e ? 'añ' : 'vet';
                            return e + t;
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        },
                        meridiemParse: /a.m.|g.m./,
                        isPM: function (e) {
                            return 'g.m.' === e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'a.m.' : 'g.m.';
                        }
                    });
                return h;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a) {
                    var n = e + ' ';
                    switch (a) {
                    case 'ss':
                        return n += 1 === e ? 'sekunda' : 2 === e || 3 === e || 4 === e ? 'sekunde' : 'sekundi';
                    case 'm':
                        return t ? 'jedna minuta' : 'jedne minute';
                    case 'mm':
                        return n += 1 === e ? 'minuta' : 2 === e || 3 === e || 4 === e ? 'minute' : 'minuta';
                    case 'h':
                        return t ? 'jedan sat' : 'jednog sata';
                    case 'hh':
                        return n += 1 === e ? 'sat' : 2 === e || 3 === e || 4 === e ? 'sata' : 'sati';
                    case 'dd':
                        return n += 1 === e ? 'dan' : 'dana';
                    case 'MM':
                        return n += 1 === e ? 'mjesec' : 2 === e || 3 === e || 4 === e ? 'mjeseca' : 'mjeseci';
                    case 'yy':
                        return n += 1 === e ? 'godina' : 2 === e || 3 === e || 4 === e ? 'godine' : 'godina';
                    }
                }
                var a = e.defineLocale('bs', {
                    months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
                    monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
                    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
                    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY H:mm',
                        LLLL: 'dddd, D. MMMM YYYY H:mm'
                    },
                    calendar: {
                        sameDay: '[danas u] LT',
                        nextDay: '[sutra u] LT',
                        nextWeek: function () {
                            switch (this.day()) {
                            case 0:
                                return '[u] [nedjelju] [u] LT';
                            case 3:
                                return '[u] [srijedu] [u] LT';
                            case 6:
                                return '[u] [subotu] [u] LT';
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                                return '[u] dddd [u] LT';
                            }
                        },
                        lastDay: '[jučer u] LT',
                        lastWeek: function () {
                            switch (this.day()) {
                            case 0:
                            case 3:
                                return '[prošlu] dddd [u] LT';
                            case 6:
                                return '[prošle] [subote] [u] LT';
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                                return '[prošli] dddd [u] LT';
                            }
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'za %s',
                        past: 'prije %s',
                        s: 'par sekundi',
                        ss: t,
                        m: t,
                        mm: t,
                        h: t,
                        hh: t,
                        d: 'dan',
                        dd: t,
                        M: 'mjesec',
                        MM: t,
                        y: 'godinu',
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ca', {
                    months: {
                        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
                        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
                        isFormat: /D[oD]?(\s)+MMMM/
                    },
                    monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
                    weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
                    weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM [de] YYYY',
                        ll: 'D MMM YYYY',
                        LLL: 'D MMMM [de] YYYY [a les] H:mm',
                        lll: 'D MMM YYYY, H:mm',
                        LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
                        llll: 'ddd D MMM YYYY, H:mm'
                    },
                    calendar: {
                        sameDay: function () {
                            return '[avui a ' + (1 !== this.hours() ? 'les' : 'la') + '] LT';
                        },
                        nextDay: function () {
                            return '[demà a ' + (1 !== this.hours() ? 'les' : 'la') + '] LT';
                        },
                        nextWeek: function () {
                            return 'dddd [a ' + (1 !== this.hours() ? 'les' : 'la') + '] LT';
                        },
                        lastDay: function () {
                            return '[ahir a ' + (1 !== this.hours() ? 'les' : 'la') + '] LT';
                        },
                        lastWeek: function () {
                            return '[el] dddd [passat a ' + (1 !== this.hours() ? 'les' : 'la') + '] LT';
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'd\'aquí %s',
                        past: 'fa %s',
                        s: 'uns segons',
                        ss: '%d segons',
                        m: 'un minut',
                        mm: '%d minuts',
                        h: 'una hora',
                        hh: '%d hores',
                        d: 'un dia',
                        dd: '%d dies',
                        M: 'un mes',
                        MM: '%d mesos',
                        y: 'un any',
                        yy: '%d anys'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
                    ordinal: function (e, t) {
                        var a = 1 === e ? 'r' : 2 === e ? 'n' : 3 === e ? 'r' : 4 === e ? 't' : 'è';
                        return 'w' !== t && 'W' !== t || (a = 'a'), e + a;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e) {
                    return e > 1 && e < 5 && 1 !== ~~(e / 10);
                }
                function a(e, a, n, s) {
                    var r = e + ' ';
                    switch (n) {
                    case 's':
                        return a || s ? 'pár sekund' : 'pár sekundami';
                    case 'ss':
                        return a || s ? r + (t(e) ? 'sekundy' : 'sekund') : r + 'sekundami';
                    case 'm':
                        return a ? 'minuta' : s ? 'minutu' : 'minutou';
                    case 'mm':
                        return a || s ? r + (t(e) ? 'minuty' : 'minut') : r + 'minutami';
                    case 'h':
                        return a ? 'hodina' : s ? 'hodinu' : 'hodinou';
                    case 'hh':
                        return a || s ? r + (t(e) ? 'hodiny' : 'hodin') : r + 'hodinami';
                    case 'd':
                        return a || s ? 'den' : 'dnem';
                    case 'dd':
                        return a || s ? r + (t(e) ? 'dny' : 'dní') : r + 'dny';
                    case 'M':
                        return a || s ? 'měsíc' : 'měsícem';
                    case 'MM':
                        return a || s ? r + (t(e) ? 'měsíce' : 'měsíců') : r + 'měsíci';
                    case 'y':
                        return a || s ? 'rok' : 'rokem';
                    case 'yy':
                        return a || s ? r + (t(e) ? 'roky' : 'let') : r + 'lety';
                    }
                }
                var n = {
                        format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
                        standalone: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split('_')
                    }, s = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'), r = [
                        /^led/i,
                        /^úno/i,
                        /^bře/i,
                        /^dub/i,
                        /^kvě/i,
                        /^(čvn|červen$|června)/i,
                        /^(čvc|červenec|července)/i,
                        /^srp/i,
                        /^zář/i,
                        /^říj/i,
                        /^lis/i,
                        /^pro/i
                    ], i = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i, d = e.defineLocale('cs', {
                        months: n,
                        monthsShort: s,
                        monthsRegex: i,
                        monthsShortRegex: i,
                        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
                        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
                        monthsParse: r,
                        longMonthsParse: r,
                        shortMonthsParse: r,
                        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
                        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
                        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY H:mm',
                            LLLL: 'dddd D. MMMM YYYY H:mm',
                            l: 'D. M. YYYY'
                        },
                        calendar: {
                            sameDay: '[dnes v] LT',
                            nextDay: '[zítra v] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                case 0:
                                    return '[v neděli v] LT';
                                case 1:
                                case 2:
                                    return '[v] dddd [v] LT';
                                case 3:
                                    return '[ve středu v] LT';
                                case 4:
                                    return '[ve čtvrtek v] LT';
                                case 5:
                                    return '[v pátek v] LT';
                                case 6:
                                    return '[v sobotu v] LT';
                                }
                            },
                            lastDay: '[včera v] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                case 0:
                                    return '[minulou neděli v] LT';
                                case 1:
                                case 2:
                                    return '[minulé] dddd [v] LT';
                                case 3:
                                    return '[minulou středu v] LT';
                                case 4:
                                case 5:
                                    return '[minulý] dddd [v] LT';
                                case 6:
                                    return '[minulou sobotu v] LT';
                                }
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: 'před %s',
                            s: a,
                            ss: a,
                            m: a,
                            mm: a,
                            h: a,
                            hh: a,
                            d: a,
                            dd: a,
                            M: a,
                            MM: a,
                            y: a,
                            yy: a
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return d;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('cv', {
                    months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
                    monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
                    weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
                    weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
                    weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD-MM-YYYY',
                        LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
                        LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
                        LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
                    },
                    calendar: {
                        sameDay: '[Паян] LT [сехетре]',
                        nextDay: '[Ыран] LT [сехетре]',
                        lastDay: '[Ӗнер] LT [сехетре]',
                        nextWeek: '[Ҫитес] dddd LT [сехетре]',
                        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: function (e) {
                            var t = /сехет$/i.exec(e) ? 'рен' : /ҫул$/i.exec(e) ? 'тан' : 'ран';
                            return e + t;
                        },
                        past: '%s каялла',
                        s: 'пӗр-ик ҫеккунт',
                        ss: '%d ҫеккунт',
                        m: 'пӗр минут',
                        mm: '%d минут',
                        h: 'пӗр сехет',
                        hh: '%d сехет',
                        d: 'пӗр кун',
                        dd: '%d кун',
                        M: 'пӗр уйӑх',
                        MM: '%d уйӑх',
                        y: 'пӗр ҫул',
                        yy: '%d ҫул'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
                    ordinal: '%d-мӗш',
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('cy', {
                    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
                    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
                    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
                    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
                    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Heddiw am] LT',
                        nextDay: '[Yfory am] LT',
                        nextWeek: 'dddd [am] LT',
                        lastDay: '[Ddoe am] LT',
                        lastWeek: 'dddd [diwethaf am] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'mewn %s',
                        past: '%s yn ôl',
                        s: 'ychydig eiliadau',
                        ss: '%d eiliad',
                        m: 'munud',
                        mm: '%d munud',
                        h: 'awr',
                        hh: '%d awr',
                        d: 'diwrnod',
                        dd: '%d diwrnod',
                        M: 'mis',
                        MM: '%d mis',
                        y: 'blwyddyn',
                        yy: '%d flynedd'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
                    ordinal: function (e) {
                        var t = e, a = '', n = [
                                '',
                                'af',
                                'il',
                                'ydd',
                                'ydd',
                                'ed',
                                'ed',
                                'ed',
                                'fed',
                                'fed',
                                'fed',
                                'eg',
                                'fed',
                                'eg',
                                'eg',
                                'fed',
                                'eg',
                                'eg',
                                'fed',
                                'eg',
                                'fed'
                            ];
                        return t > 20 ? a = 40 === t || 50 === t || 60 === t || 80 === t || 100 === t ? 'fed' : 'ain' : t > 0 && (a = n[t]), e + a;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('da', {
                    months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
                    monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
                    weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
                    weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
                    weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY HH:mm',
                        LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
                    },
                    calendar: {
                        sameDay: '[i dag kl.] LT',
                        nextDay: '[i morgen kl.] LT',
                        nextWeek: 'på dddd [kl.] LT',
                        lastDay: '[i går kl.] LT',
                        lastWeek: '[i] dddd[s kl.] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'om %s',
                        past: '%s siden',
                        s: 'få sekunder',
                        ss: '%d sekunder',
                        m: 'et minut',
                        mm: '%d minutter',
                        h: 'en time',
                        hh: '%d timer',
                        d: 'en dag',
                        dd: '%d dage',
                        M: 'en måned',
                        MM: '%d måneder',
                        y: 'et år',
                        yy: '%d år'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = {
                        m: [
                            'eine Minute',
                            'einer Minute'
                        ],
                        h: [
                            'eine Stunde',
                            'einer Stunde'
                        ],
                        d: [
                            'ein Tag',
                            'einem Tag'
                        ],
                        dd: [
                            e + ' Tage',
                            e + ' Tagen'
                        ],
                        w: [
                            'eine Woche',
                            'einer Woche'
                        ],
                        M: [
                            'ein Monat',
                            'einem Monat'
                        ],
                        MM: [
                            e + ' Monate',
                            e + ' Monaten'
                        ],
                        y: [
                            'ein Jahr',
                            'einem Jahr'
                        ],
                        yy: [
                            e + ' Jahre',
                            e + ' Jahren'
                        ]
                    };
                    return t ? s[a][0] : s[a][1];
                }
                var a = e.defineLocale('de', {
                    months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
                    monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
                    weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
                    weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY HH:mm',
                        LLLL: 'dddd, D. MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[heute um] LT [Uhr]',
                        sameElse: 'L',
                        nextDay: '[morgen um] LT [Uhr]',
                        nextWeek: 'dddd [um] LT [Uhr]',
                        lastDay: '[gestern um] LT [Uhr]',
                        lastWeek: '[letzten] dddd [um] LT [Uhr]'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: 'vor %s',
                        s: 'ein paar Sekunden',
                        ss: '%d Sekunden',
                        m: t,
                        mm: '%d Minuten',
                        h: t,
                        hh: '%d Stunden',
                        d: t,
                        dd: t,
                        w: t,
                        ww: '%d Wochen',
                        M: t,
                        MM: t,
                        y: t,
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = {
                        m: [
                            'eine Minute',
                            'einer Minute'
                        ],
                        h: [
                            'eine Stunde',
                            'einer Stunde'
                        ],
                        d: [
                            'ein Tag',
                            'einem Tag'
                        ],
                        dd: [
                            e + ' Tage',
                            e + ' Tagen'
                        ],
                        w: [
                            'eine Woche',
                            'einer Woche'
                        ],
                        M: [
                            'ein Monat',
                            'einem Monat'
                        ],
                        MM: [
                            e + ' Monate',
                            e + ' Monaten'
                        ],
                        y: [
                            'ein Jahr',
                            'einem Jahr'
                        ],
                        yy: [
                            e + ' Jahre',
                            e + ' Jahren'
                        ]
                    };
                    return t ? s[a][0] : s[a][1];
                }
                var a = e.defineLocale('de-at', {
                    months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
                    monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
                    weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
                    weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY HH:mm',
                        LLLL: 'dddd, D. MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[heute um] LT [Uhr]',
                        sameElse: 'L',
                        nextDay: '[morgen um] LT [Uhr]',
                        nextWeek: 'dddd [um] LT [Uhr]',
                        lastDay: '[gestern um] LT [Uhr]',
                        lastWeek: '[letzten] dddd [um] LT [Uhr]'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: 'vor %s',
                        s: 'ein paar Sekunden',
                        ss: '%d Sekunden',
                        m: t,
                        mm: '%d Minuten',
                        h: t,
                        hh: '%d Stunden',
                        d: t,
                        dd: t,
                        w: t,
                        ww: '%d Wochen',
                        M: t,
                        MM: t,
                        y: t,
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = {
                        m: [
                            'eine Minute',
                            'einer Minute'
                        ],
                        h: [
                            'eine Stunde',
                            'einer Stunde'
                        ],
                        d: [
                            'ein Tag',
                            'einem Tag'
                        ],
                        dd: [
                            e + ' Tage',
                            e + ' Tagen'
                        ],
                        w: [
                            'eine Woche',
                            'einer Woche'
                        ],
                        M: [
                            'ein Monat',
                            'einem Monat'
                        ],
                        MM: [
                            e + ' Monate',
                            e + ' Monaten'
                        ],
                        y: [
                            'ein Jahr',
                            'einem Jahr'
                        ],
                        yy: [
                            e + ' Jahre',
                            e + ' Jahren'
                        ]
                    };
                    return t ? s[a][0] : s[a][1];
                }
                var a = e.defineLocale('de-ch', {
                    months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
                    monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
                    weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
                    weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY HH:mm',
                        LLLL: 'dddd, D. MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[heute um] LT [Uhr]',
                        sameElse: 'L',
                        nextDay: '[morgen um] LT [Uhr]',
                        nextWeek: 'dddd [um] LT [Uhr]',
                        lastDay: '[gestern um] LT [Uhr]',
                        lastWeek: '[letzten] dddd [um] LT [Uhr]'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: 'vor %s',
                        s: 'ein paar Sekunden',
                        ss: '%d Sekunden',
                        m: t,
                        mm: '%d Minuten',
                        h: t,
                        hh: '%d Stunden',
                        d: t,
                        dd: t,
                        w: t,
                        ww: '%d Wochen',
                        M: t,
                        MM: t,
                        y: t,
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = [
                        'ޖެނުއަރީ',
                        'ފެބްރުއަރީ',
                        'މާރިޗު',
                        'އޭޕްރީލު',
                        'މޭ',
                        'ޖޫން',
                        'ޖުލައި',
                        'އޯގަސްޓު',
                        'ސެޕްޓެމްބަރު',
                        'އޮކްޓޯބަރު',
                        'ނޮވެމްބަރު',
                        'ޑިސެމްބަރު'
                    ], a = [
                        'އާދިއްތަ',
                        'ހޯމަ',
                        'އަންގާރަ',
                        'ބުދަ',
                        'ބުރާސްފަތި',
                        'ހުކުރު',
                        'ހޮނިހިރު'
                    ], n = e.defineLocale('dv', {
                        months: t,
                        monthsShort: t,
                        weekdays: a,
                        weekdaysShort: a,
                        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'D/M/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm'
                        },
                        meridiemParse: /މކ|މފ/,
                        isPM: function (e) {
                            return 'މފ' === e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'މކ' : 'މފ';
                        },
                        calendar: {
                            sameDay: '[މިއަދު] LT',
                            nextDay: '[މާދަމާ] LT',
                            nextWeek: 'dddd LT',
                            lastDay: '[އިއްޔެ] LT',
                            lastWeek: '[ފާއިތުވި] dddd LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'ތެރޭގައި %s',
                            past: 'ކުރިން %s',
                            s: 'ސިކުންތުކޮޅެއް',
                            ss: 'd% ސިކުންތު',
                            m: 'މިނިޓެއް',
                            mm: 'މިނިޓު %d',
                            h: 'ގަޑިއިރެއް',
                            hh: 'ގަޑިއިރު %d',
                            d: 'ދުވަހެއް',
                            dd: 'ދުވަސް %d',
                            M: 'މަހެއް',
                            MM: 'މަސް %d',
                            y: 'އަހަރެއް',
                            yy: 'އަހަރު %d'
                        },
                        preparse: function (e) {
                            return e.replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/,/g, '\u060C');
                        },
                        week: {
                            dow: 7,
                            doy: 12
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e) {
                    return 'undefined' != typeof Function && e instanceof Function || '[object Function]' === Object.prototype.toString.call(e);
                }
                var a = e.defineLocale('el', {
                    monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
                    monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
                    months: function (e, t) {
                        return e ? 'string' == typeof t && /D/.test(t.substring(0, t.indexOf('MMMM'))) ? this._monthsGenitiveEl[e.month()] : this._monthsNominativeEl[e.month()] : this._monthsNominativeEl;
                    },
                    monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
                    weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
                    weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
                    weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
                    meridiem: function (e, t, a) {
                        return e > 11 ? a ? 'μμ' : 'ΜΜ' : a ? 'πμ' : 'ΠΜ';
                    },
                    isPM: function (e) {
                        return 'μ' === (e + '').toLowerCase()[0];
                    },
                    meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
                    longDateFormat: {
                        LT: 'h:mm A',
                        LTS: 'h:mm:ss A',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY h:mm A',
                        LLLL: 'dddd, D MMMM YYYY h:mm A'
                    },
                    calendarEl: {
                        sameDay: '[Σήμερα {}] LT',
                        nextDay: '[Αύριο {}] LT',
                        nextWeek: 'dddd [{}] LT',
                        lastDay: '[Χθες {}] LT',
                        lastWeek: function () {
                            switch (this.day()) {
                            case 6:
                                return '[το προηγούμενο] dddd [{}] LT';
                            default:
                                return '[την προηγούμενη] dddd [{}] LT';
                            }
                        },
                        sameElse: 'L'
                    },
                    calendar: function (e, a) {
                        var n = this._calendarEl[e], s = a && a.hours();
                        return t(n) && (n = n.apply(a)), n.replace('{}', s % 12 === 1 ? 'στη' : 'στις');
                    },
                    relativeTime: {
                        future: 'σε %s',
                        past: '%s πριν',
                        s: 'λίγα δευτερόλεπτα',
                        ss: '%d δευτερόλεπτα',
                        m: 'ένα λεπτό',
                        mm: '%d λεπτά',
                        h: 'μία ώρα',
                        hh: '%d ώρες',
                        d: 'μία μέρα',
                        dd: '%d μέρες',
                        M: 'ένας μήνας',
                        MM: '%d μήνες',
                        y: 'ένας χρόνος',
                        yy: '%d χρόνια'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}η/,
                    ordinal: '%dη',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('en-au', {
                    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
                    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                    longDateFormat: {
                        LT: 'h:mm A',
                        LTS: 'h:mm:ss A',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY h:mm A',
                        LLLL: 'dddd, D MMMM YYYY h:mm A'
                    },
                    calendar: {
                        sameDay: '[Today at] LT',
                        nextDay: '[Tomorrow at] LT',
                        nextWeek: 'dddd [at] LT',
                        lastDay: '[Yesterday at] LT',
                        lastWeek: '[Last] dddd [at] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: '%s ago',
                        s: 'a few seconds',
                        ss: '%d seconds',
                        m: 'a minute',
                        mm: '%d minutes',
                        h: 'an hour',
                        hh: '%d hours',
                        d: 'a day',
                        dd: '%d days',
                        M: 'a month',
                        MM: '%d months',
                        y: 'a year',
                        yy: '%d years'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                        return e + a;
                    },
                    week: {
                        dow: 0,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('en-ca', {
                    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
                    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                    longDateFormat: {
                        LT: 'h:mm A',
                        LTS: 'h:mm:ss A',
                        L: 'YYYY-MM-DD',
                        LL: 'MMMM D, YYYY',
                        LLL: 'MMMM D, YYYY h:mm A',
                        LLLL: 'dddd, MMMM D, YYYY h:mm A'
                    },
                    calendar: {
                        sameDay: '[Today at] LT',
                        nextDay: '[Tomorrow at] LT',
                        nextWeek: 'dddd [at] LT',
                        lastDay: '[Yesterday at] LT',
                        lastWeek: '[Last] dddd [at] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: '%s ago',
                        s: 'a few seconds',
                        ss: '%d seconds',
                        m: 'a minute',
                        mm: '%d minutes',
                        h: 'an hour',
                        hh: '%d hours',
                        d: 'a day',
                        dd: '%d days',
                        M: 'a month',
                        MM: '%d months',
                        y: 'a year',
                        yy: '%d years'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                        return e + a;
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('en-gb', {
                    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
                    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Today at] LT',
                        nextDay: '[Tomorrow at] LT',
                        nextWeek: 'dddd [at] LT',
                        lastDay: '[Yesterday at] LT',
                        lastWeek: '[Last] dddd [at] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: '%s ago',
                        s: 'a few seconds',
                        ss: '%d seconds',
                        m: 'a minute',
                        mm: '%d minutes',
                        h: 'an hour',
                        hh: '%d hours',
                        d: 'a day',
                        dd: '%d days',
                        M: 'a month',
                        MM: '%d months',
                        y: 'a year',
                        yy: '%d years'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                        return e + a;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('en-ie', {
                    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
                    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Today at] LT',
                        nextDay: '[Tomorrow at] LT',
                        nextWeek: 'dddd [at] LT',
                        lastDay: '[Yesterday at] LT',
                        lastWeek: '[Last] dddd [at] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: '%s ago',
                        s: 'a few seconds',
                        ss: '%d seconds',
                        m: 'a minute',
                        mm: '%d minutes',
                        h: 'an hour',
                        hh: '%d hours',
                        d: 'a day',
                        dd: '%d days',
                        M: 'a month',
                        MM: '%d months',
                        y: 'a year',
                        yy: '%d years'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                        return e + a;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('en-il', {
                    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
                    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Today at] LT',
                        nextDay: '[Tomorrow at] LT',
                        nextWeek: 'dddd [at] LT',
                        lastDay: '[Yesterday at] LT',
                        lastWeek: '[Last] dddd [at] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: '%s ago',
                        s: 'a few seconds',
                        ss: '%d seconds',
                        m: 'a minute',
                        mm: '%d minutes',
                        h: 'an hour',
                        hh: '%d hours',
                        d: 'a day',
                        dd: '%d days',
                        M: 'a month',
                        MM: '%d months',
                        y: 'a year',
                        yy: '%d years'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                        return e + a;
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('en-in', {
                    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
                    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                    longDateFormat: {
                        LT: 'h:mm A',
                        LTS: 'h:mm:ss A',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY h:mm A',
                        LLLL: 'dddd, D MMMM YYYY h:mm A'
                    },
                    calendar: {
                        sameDay: '[Today at] LT',
                        nextDay: '[Tomorrow at] LT',
                        nextWeek: 'dddd [at] LT',
                        lastDay: '[Yesterday at] LT',
                        lastWeek: '[Last] dddd [at] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: '%s ago',
                        s: 'a few seconds',
                        ss: '%d seconds',
                        m: 'a minute',
                        mm: '%d minutes',
                        h: 'an hour',
                        hh: '%d hours',
                        d: 'a day',
                        dd: '%d days',
                        M: 'a month',
                        MM: '%d months',
                        y: 'a year',
                        yy: '%d years'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                        return e + a;
                    },
                    week: {
                        dow: 0,
                        doy: 6
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('en-nz', {
                    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
                    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                    longDateFormat: {
                        LT: 'h:mm A',
                        LTS: 'h:mm:ss A',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY h:mm A',
                        LLLL: 'dddd, D MMMM YYYY h:mm A'
                    },
                    calendar: {
                        sameDay: '[Today at] LT',
                        nextDay: '[Tomorrow at] LT',
                        nextWeek: 'dddd [at] LT',
                        lastDay: '[Yesterday at] LT',
                        lastWeek: '[Last] dddd [at] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: '%s ago',
                        s: 'a few seconds',
                        ss: '%d seconds',
                        m: 'a minute',
                        mm: '%d minutes',
                        h: 'an hour',
                        hh: '%d hours',
                        d: 'a day',
                        dd: '%d days',
                        M: 'a month',
                        MM: '%d months',
                        y: 'a year',
                        yy: '%d years'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                        return e + a;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('en-sg', {
                    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
                    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Today at] LT',
                        nextDay: '[Tomorrow at] LT',
                        nextWeek: 'dddd [at] LT',
                        lastDay: '[Yesterday at] LT',
                        lastWeek: '[Last] dddd [at] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'in %s',
                        past: '%s ago',
                        s: 'a few seconds',
                        ss: '%d seconds',
                        m: 'a minute',
                        mm: '%d minutes',
                        h: 'an hour',
                        hh: '%d hours',
                        d: 'a day',
                        dd: '%d days',
                        M: 'a month',
                        MM: '%d months',
                        y: 'a year',
                        yy: '%d years'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                        return e + a;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('eo', {
                    months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
                    monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
                    weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
                    weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
                    weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: '[la] D[-an de] MMMM, YYYY',
                        LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
                        LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
                        llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm'
                    },
                    meridiemParse: /[ap]\.t\.m/i,
                    isPM: function (e) {
                        return 'p' === e.charAt(0).toLowerCase();
                    },
                    meridiem: function (e, t, a) {
                        return e > 11 ? a ? 'p.t.m.' : 'P.T.M.' : a ? 'a.t.m.' : 'A.T.M.';
                    },
                    calendar: {
                        sameDay: '[Hodiaŭ je] LT',
                        nextDay: '[Morgaŭ je] LT',
                        nextWeek: 'dddd[n je] LT',
                        lastDay: '[Hieraŭ je] LT',
                        lastWeek: '[pasintan] dddd[n je] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'post %s',
                        past: 'antaŭ %s',
                        s: 'kelkaj sekundoj',
                        ss: '%d sekundoj',
                        m: 'unu minuto',
                        mm: '%d minutoj',
                        h: 'unu horo',
                        hh: '%d horoj',
                        d: 'unu tago',
                        dd: '%d tagoj',
                        M: 'unu monato',
                        MM: '%d monatoj',
                        y: 'unu jaro',
                        yy: '%d jaroj'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}a/,
                    ordinal: '%da',
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), a = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'), n = [
                        /^ene/i,
                        /^feb/i,
                        /^mar/i,
                        /^abr/i,
                        /^may/i,
                        /^jun/i,
                        /^jul/i,
                        /^ago/i,
                        /^sep/i,
                        /^oct/i,
                        /^nov/i,
                        /^dic/i
                    ], s = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i, r = e.defineLocale('es', {
                        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
                        monthsShort: function (e, n) {
                            return e ? /-MMM-/.test(n) ? a[e.month()] : t[e.month()] : t;
                        },
                        monthsRegex: s,
                        monthsShortRegex: s,
                        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                        monthsParse: n,
                        longMonthsParse: n,
                        shortMonthsParse: n,
                        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
                        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
                        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY H:mm',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
                        },
                        calendar: {
                            sameDay: function () {
                                return '[hoy a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextDay: function () {
                                return '[mañana a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastDay: function () {
                                return '[ayer a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastWeek: function () {
                                return '[el] dddd [pasado a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'en %s',
                            past: 'hace %s',
                            s: 'unos segundos',
                            ss: '%d segundos',
                            m: 'un minuto',
                            mm: '%d minutos',
                            h: 'una hora',
                            hh: '%d horas',
                            d: 'un día',
                            dd: '%d días',
                            w: 'una semana',
                            ww: '%d semanas',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un año',
                            yy: '%d años'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: {
                            dow: 1,
                            doy: 4
                        },
                        invalidDate: 'Fecha inválida'
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), a = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'), n = [
                        /^ene/i,
                        /^feb/i,
                        /^mar/i,
                        /^abr/i,
                        /^may/i,
                        /^jun/i,
                        /^jul/i,
                        /^ago/i,
                        /^sep/i,
                        /^oct/i,
                        /^nov/i,
                        /^dic/i
                    ], s = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i, r = e.defineLocale('es-do', {
                        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
                        monthsShort: function (e, n) {
                            return e ? /-MMM-/.test(n) ? a[e.month()] : t[e.month()] : t;
                        },
                        monthsRegex: s,
                        monthsShortRegex: s,
                        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                        monthsParse: n,
                        longMonthsParse: n,
                        shortMonthsParse: n,
                        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
                        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
                        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'DD/MM/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY h:mm A',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
                        },
                        calendar: {
                            sameDay: function () {
                                return '[hoy a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextDay: function () {
                                return '[mañana a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastDay: function () {
                                return '[ayer a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastWeek: function () {
                                return '[el] dddd [pasado a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'en %s',
                            past: 'hace %s',
                            s: 'unos segundos',
                            ss: '%d segundos',
                            m: 'un minuto',
                            mm: '%d minutos',
                            h: 'una hora',
                            hh: '%d horas',
                            d: 'un día',
                            dd: '%d días',
                            w: 'una semana',
                            ww: '%d semanas',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un año',
                            yy: '%d años'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), a = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'), n = [
                        /^ene/i,
                        /^feb/i,
                        /^mar/i,
                        /^abr/i,
                        /^may/i,
                        /^jun/i,
                        /^jul/i,
                        /^ago/i,
                        /^sep/i,
                        /^oct/i,
                        /^nov/i,
                        /^dic/i
                    ], s = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i, r = e.defineLocale('es-mx', {
                        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
                        monthsShort: function (e, n) {
                            return e ? /-MMM-/.test(n) ? a[e.month()] : t[e.month()] : t;
                        },
                        monthsRegex: s,
                        monthsShortRegex: s,
                        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                        monthsParse: n,
                        longMonthsParse: n,
                        shortMonthsParse: n,
                        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
                        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
                        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY H:mm',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
                        },
                        calendar: {
                            sameDay: function () {
                                return '[hoy a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextDay: function () {
                                return '[mañana a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastDay: function () {
                                return '[ayer a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastWeek: function () {
                                return '[el] dddd [pasado a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'en %s',
                            past: 'hace %s',
                            s: 'unos segundos',
                            ss: '%d segundos',
                            m: 'un minuto',
                            mm: '%d minutos',
                            h: 'una hora',
                            hh: '%d horas',
                            d: 'un día',
                            dd: '%d días',
                            w: 'una semana',
                            ww: '%d semanas',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un año',
                            yy: '%d años'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: {
                            dow: 0,
                            doy: 4
                        },
                        invalidDate: 'Fecha inválida'
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), a = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'), n = [
                        /^ene/i,
                        /^feb/i,
                        /^mar/i,
                        /^abr/i,
                        /^may/i,
                        /^jun/i,
                        /^jul/i,
                        /^ago/i,
                        /^sep/i,
                        /^oct/i,
                        /^nov/i,
                        /^dic/i
                    ], s = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i, r = e.defineLocale('es-us', {
                        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
                        monthsShort: function (e, n) {
                            return e ? /-MMM-/.test(n) ? a[e.month()] : t[e.month()] : t;
                        },
                        monthsRegex: s,
                        monthsShortRegex: s,
                        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                        monthsParse: n,
                        longMonthsParse: n,
                        shortMonthsParse: n,
                        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
                        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
                        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'MM/DD/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY h:mm A',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
                        },
                        calendar: {
                            sameDay: function () {
                                return '[hoy a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextDay: function () {
                                return '[mañana a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastDay: function () {
                                return '[ayer a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastWeek: function () {
                                return '[el] dddd [pasado a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'en %s',
                            past: 'hace %s',
                            s: 'unos segundos',
                            ss: '%d segundos',
                            m: 'un minuto',
                            mm: '%d minutos',
                            h: 'una hora',
                            hh: '%d horas',
                            d: 'un día',
                            dd: '%d días',
                            w: 'una semana',
                            ww: '%d semanas',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un año',
                            yy: '%d años'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = {
                        s: [
                            'mõne sekundi',
                            'mõni sekund',
                            'paar sekundit'
                        ],
                        ss: [
                            e + 'sekundi',
                            e + 'sekundit'
                        ],
                        m: [
                            'ühe minuti',
                            'üks minut'
                        ],
                        mm: [
                            e + ' minuti',
                            e + ' minutit'
                        ],
                        h: [
                            'ühe tunni',
                            'tund aega',
                            'üks tund'
                        ],
                        hh: [
                            e + ' tunni',
                            e + ' tundi'
                        ],
                        d: [
                            'ühe päeva',
                            'üks päev'
                        ],
                        M: [
                            'kuu aja',
                            'kuu aega',
                            'üks kuu'
                        ],
                        MM: [
                            e + ' kuu',
                            e + ' kuud'
                        ],
                        y: [
                            'ühe aasta',
                            'aasta',
                            'üks aasta'
                        ],
                        yy: [
                            e + ' aasta',
                            e + ' aastat'
                        ]
                    };
                    return t ? s[a][2] ? s[a][2] : s[a][1] : n ? s[a][0] : s[a][1];
                }
                var a = e.defineLocale('et', {
                    months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
                    monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
                    weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
                    weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
                    weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY H:mm',
                        LLLL: 'dddd, D. MMMM YYYY H:mm'
                    },
                    calendar: {
                        sameDay: '[Täna,] LT',
                        nextDay: '[Homme,] LT',
                        nextWeek: '[Järgmine] dddd LT',
                        lastDay: '[Eile,] LT',
                        lastWeek: '[Eelmine] dddd LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s pärast',
                        past: '%s tagasi',
                        s: t,
                        ss: t,
                        m: t,
                        mm: t,
                        h: t,
                        hh: t,
                        d: t,
                        dd: '%d päeva',
                        M: t,
                        MM: t,
                        y: t,
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('eu', {
                    months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
                    monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
                    weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
                    weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'YYYY[ko] MMMM[ren] D[a]',
                        LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
                        LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
                        l: 'YYYY-M-D',
                        ll: 'YYYY[ko] MMM D[a]',
                        lll: 'YYYY[ko] MMM D[a] HH:mm',
                        llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
                    },
                    calendar: {
                        sameDay: '[gaur] LT[etan]',
                        nextDay: '[bihar] LT[etan]',
                        nextWeek: 'dddd LT[etan]',
                        lastDay: '[atzo] LT[etan]',
                        lastWeek: '[aurreko] dddd LT[etan]',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s barru',
                        past: 'duela %s',
                        s: 'segundo batzuk',
                        ss: '%d segundo',
                        m: 'minutu bat',
                        mm: '%d minutu',
                        h: 'ordu bat',
                        hh: '%d ordu',
                        d: 'egun bat',
                        dd: '%d egun',
                        M: 'hilabete bat',
                        MM: '%d hilabete',
                        y: 'urte bat',
                        yy: '%d urte'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '۱',
                        2: '۲',
                        3: '۳',
                        4: '۴',
                        5: '۵',
                        6: '۶',
                        7: '۷',
                        8: '۸',
                        9: '۹',
                        0: '۰'
                    }, a = {
                        '۱': '1',
                        '۲': '2',
                        '۳': '3',
                        '۴': '4',
                        '۵': '5',
                        '۶': '6',
                        '۷': '7',
                        '۸': '8',
                        '۹': '9',
                        '۰': '0'
                    }, n = e.defineLocale('fa', {
                        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
                        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
                        weekdays: 'یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه'.split('_'),
                        weekdaysShort: 'یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه'.split('_'),
                        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        meridiemParse: /قبل از ظهر|بعد از ظهر/,
                        isPM: function (e) {
                            return /بعد از ظهر/.test(e);
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'قبل از ظهر' : 'بعد از ظهر';
                        },
                        calendar: {
                            sameDay: '[امروز ساعت] LT',
                            nextDay: '[فردا ساعت] LT',
                            nextWeek: 'dddd [ساعت] LT',
                            lastDay: '[دیروز ساعت] LT',
                            lastWeek: 'dddd [پیش] [ساعت] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'در %s',
                            past: '%s پیش',
                            s: 'چند ثانیه',
                            ss: '%d ثانیه',
                            m: 'یک دقیقه',
                            mm: '%d دقیقه',
                            h: 'یک ساعت',
                            hh: '%d ساعت',
                            d: 'یک روز',
                            dd: '%d روز',
                            M: 'یک ماه',
                            MM: '%d ماه',
                            y: 'یک سال',
                            yy: '%d سال'
                        },
                        preparse: function (e) {
                            return e.replace(/[۰-۹]/g, function (e) {
                                return a[e];
                            }).replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            }).replace(/,/g, '\u060C');
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}م/,
                        ordinal: '%dم',
                        week: {
                            dow: 6,
                            doy: 12
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, n, s) {
                    var r = '';
                    switch (n) {
                    case 's':
                        return s ? 'muutaman sekunnin' : 'muutama sekunti';
                    case 'ss':
                        r = s ? 'sekunnin' : 'sekuntia';
                        break;
                    case 'm':
                        return s ? 'minuutin' : 'minuutti';
                    case 'mm':
                        r = s ? 'minuutin' : 'minuuttia';
                        break;
                    case 'h':
                        return s ? 'tunnin' : 'tunti';
                    case 'hh':
                        r = s ? 'tunnin' : 'tuntia';
                        break;
                    case 'd':
                        return s ? 'päivän' : 'päivä';
                    case 'dd':
                        r = s ? 'päivän' : 'päivää';
                        break;
                    case 'M':
                        return s ? 'kuukauden' : 'kuukausi';
                    case 'MM':
                        r = s ? 'kuukauden' : 'kuukautta';
                        break;
                    case 'y':
                        return s ? 'vuoden' : 'vuosi';
                    case 'yy':
                        r = s ? 'vuoden' : 'vuotta';
                    }
                    return r = a(e, s) + ' ' + r;
                }
                function a(e, t) {
                    return e < 10 ? t ? s[e] : n[e] : e;
                }
                var n = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '), s = [
                        'nolla',
                        'yhden',
                        'kahden',
                        'kolmen',
                        'neljän',
                        'viiden',
                        'kuuden',
                        n[7],
                        n[8],
                        n[9]
                    ], r = e.defineLocale('fi', {
                        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
                        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
                        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
                        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
                        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
                        longDateFormat: {
                            LT: 'HH.mm',
                            LTS: 'HH.mm.ss',
                            L: 'DD.MM.YYYY',
                            LL: 'Do MMMM[ta] YYYY',
                            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
                            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
                            l: 'D.M.YYYY',
                            ll: 'Do MMM YYYY',
                            lll: 'Do MMM YYYY, [klo] HH.mm',
                            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
                        },
                        calendar: {
                            sameDay: '[tänään] [klo] LT',
                            nextDay: '[huomenna] [klo] LT',
                            nextWeek: 'dddd [klo] LT',
                            lastDay: '[eilen] [klo] LT',
                            lastWeek: '[viime] dddd[na] [klo] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s päästä',
                            past: '%s sitten',
                            s: t,
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: t,
                            dd: t,
                            M: t,
                            MM: t,
                            y: t,
                            yy: t
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('fil', {
                    months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
                    monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
                    weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
                    weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
                    weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'MM/D/YYYY',
                        LL: 'MMMM D, YYYY',
                        LLL: 'MMMM D, YYYY HH:mm',
                        LLLL: 'dddd, MMMM DD, YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: 'LT [ngayong araw]',
                        nextDay: '[Bukas ng] LT',
                        nextWeek: 'LT [sa susunod na] dddd',
                        lastDay: 'LT [kahapon]',
                        lastWeek: 'LT [noong nakaraang] dddd',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'sa loob ng %s',
                        past: '%s ang nakalipas',
                        s: 'ilang segundo',
                        ss: '%d segundo',
                        m: 'isang minuto',
                        mm: '%d minuto',
                        h: 'isang oras',
                        hh: '%d oras',
                        d: 'isang araw',
                        dd: '%d araw',
                        M: 'isang buwan',
                        MM: '%d buwan',
                        y: 'isang taon',
                        yy: '%d taon'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}/,
                    ordinal: function (e) {
                        return e;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('fo', {
                    months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
                    monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
                    weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
                    weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
                    weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D. MMMM, YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Í dag kl.] LT',
                        nextDay: '[Í morgin kl.] LT',
                        nextWeek: 'dddd [kl.] LT',
                        lastDay: '[Í gjár kl.] LT',
                        lastWeek: '[síðstu] dddd [kl] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'um %s',
                        past: '%s síðani',
                        s: 'fá sekund',
                        ss: '%d sekundir',
                        m: 'ein minuttur',
                        mm: '%d minuttir',
                        h: 'ein tími',
                        hh: '%d tímar',
                        d: 'ein dagur',
                        dd: '%d dagar',
                        M: 'ein mánaður',
                        MM: '%d mánaðir',
                        y: 'eitt ár',
                        yy: '%d ár'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i, a = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i, n = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i, s = [
                        /^janv/i,
                        /^févr/i,
                        /^mars/i,
                        /^avr/i,
                        /^mai/i,
                        /^juin/i,
                        /^juil/i,
                        /^août/i,
                        /^sept/i,
                        /^oct/i,
                        /^nov/i,
                        /^déc/i
                    ], r = e.defineLocale('fr', {
                        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
                        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
                        monthsRegex: n,
                        monthsShortRegex: n,
                        monthsStrictRegex: t,
                        monthsShortStrictRegex: a,
                        monthsParse: s,
                        longMonthsParse: s,
                        shortMonthsParse: s,
                        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
                        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
                        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[Aujourd\u2019hui à] LT',
                            nextDay: '[Demain à] LT',
                            nextWeek: 'dddd [à] LT',
                            lastDay: '[Hier à] LT',
                            lastWeek: 'dddd [dernier à] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'dans %s',
                            past: 'il y a %s',
                            s: 'quelques secondes',
                            ss: '%d secondes',
                            m: 'une minute',
                            mm: '%d minutes',
                            h: 'une heure',
                            hh: '%d heures',
                            d: 'un jour',
                            dd: '%d jours',
                            w: 'une semaine',
                            ww: '%d semaines',
                            M: 'un mois',
                            MM: '%d mois',
                            y: 'un an',
                            yy: '%d ans'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
                        ordinal: function (e, t) {
                            switch (t) {
                            case 'D':
                                return e + (1 === e ? 'er' : '');
                            default:
                            case 'M':
                            case 'Q':
                            case 'DDD':
                            case 'd':
                                return e + (1 === e ? 'er' : 'e');
                            case 'w':
                            case 'W':
                                return e + (1 === e ? 're' : 'e');
                            }
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('fr-ca', {
                    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
                    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
                    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
                    weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Aujourd\u2019hui à] LT',
                        nextDay: '[Demain à] LT',
                        nextWeek: 'dddd [à] LT',
                        lastDay: '[Hier à] LT',
                        lastWeek: 'dddd [dernier à] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'dans %s',
                        past: 'il y a %s',
                        s: 'quelques secondes',
                        ss: '%d secondes',
                        m: 'une minute',
                        mm: '%d minutes',
                        h: 'une heure',
                        hh: '%d heures',
                        d: 'un jour',
                        dd: '%d jours',
                        M: 'un mois',
                        MM: '%d mois',
                        y: 'un an',
                        yy: '%d ans'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        default:
                        case 'M':
                        case 'Q':
                        case 'D':
                        case 'DDD':
                        case 'd':
                            return e + (1 === e ? 'er' : 'e');
                        case 'w':
                        case 'W':
                            return e + (1 === e ? 're' : 'e');
                        }
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('fr-ch', {
                    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
                    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
                    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
                    weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Aujourd\u2019hui à] LT',
                        nextDay: '[Demain à] LT',
                        nextWeek: 'dddd [à] LT',
                        lastDay: '[Hier à] LT',
                        lastWeek: 'dddd [dernier à] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'dans %s',
                        past: 'il y a %s',
                        s: 'quelques secondes',
                        ss: '%d secondes',
                        m: 'une minute',
                        mm: '%d minutes',
                        h: 'une heure',
                        hh: '%d heures',
                        d: 'un jour',
                        dd: '%d jours',
                        M: 'un mois',
                        MM: '%d mois',
                        y: 'un an',
                        yy: '%d ans'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        default:
                        case 'M':
                        case 'Q':
                        case 'D':
                        case 'DDD':
                        case 'd':
                            return e + (1 === e ? 'er' : 'e');
                        case 'w':
                        case 'W':
                            return e + (1 === e ? 're' : 'e');
                        }
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'), a = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'), n = e.defineLocale('fy', {
                        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
                        monthsShort: function (e, n) {
                            return e ? /-MMM-/.test(n) ? a[e.month()] : t[e.month()] : t;
                        },
                        monthsParseExact: !0,
                        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
                        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
                        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD-MM-YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[hjoed om] LT',
                            nextDay: '[moarn om] LT',
                            nextWeek: 'dddd [om] LT',
                            lastDay: '[juster om] LT',
                            lastWeek: '[ôfrûne] dddd [om] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'oer %s',
                            past: '%s lyn',
                            s: 'in pear sekonden',
                            ss: '%d sekonden',
                            m: 'ien minút',
                            mm: '%d minuten',
                            h: 'ien oere',
                            hh: '%d oeren',
                            d: 'ien dei',
                            dd: '%d dagen',
                            M: 'ien moanne',
                            MM: '%d moannen',
                            y: 'ien jier',
                            yy: '%d jierren'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                        ordinal: function (e) {
                            return e + (1 === e || 8 === e || e >= 20 ? 'ste' : 'de');
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = [
                        'Eanáir',
                        'Feabhra',
                        'Márta',
                        'Aibreán',
                        'Bealtaine',
                        'Meitheamh',
                        'Iúil',
                        'Lúnasa',
                        'Meán Fómhair',
                        'Deireadh Fómhair',
                        'Samhain',
                        'Nollaig'
                    ], a = [
                        'Ean',
                        'Feabh',
                        'Márt',
                        'Aib',
                        'Beal',
                        'Meith',
                        'Iúil',
                        'Lún',
                        'M.F.',
                        'D.F.',
                        'Samh',
                        'Noll'
                    ], n = [
                        'Dé Domhnaigh',
                        'Dé Luain',
                        'Dé Máirt',
                        'Dé Céadaoin',
                        'Déardaoin',
                        'Dé hAoine',
                        'Dé Sathairn'
                    ], s = [
                        'Domh',
                        'Luan',
                        'Máirt',
                        'Céad',
                        'Déar',
                        'Aoine',
                        'Sath'
                    ], r = [
                        'Do',
                        'Lu',
                        'Má',
                        'Cé',
                        'Dé',
                        'A',
                        'Sa'
                    ], i = e.defineLocale('ga', {
                        months: t,
                        monthsShort: a,
                        monthsParseExact: !0,
                        weekdays: n,
                        weekdaysShort: s,
                        weekdaysMin: r,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[Inniu ag] LT',
                            nextDay: '[Amárach ag] LT',
                            nextWeek: 'dddd [ag] LT',
                            lastDay: '[Inné ag] LT',
                            lastWeek: 'dddd [seo caite] [ag] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'i %s',
                            past: '%s ó shin',
                            s: 'cúpla soicind',
                            ss: '%d soicind',
                            m: 'nóiméad',
                            mm: '%d nóiméad',
                            h: 'uair an chloig',
                            hh: '%d uair an chloig',
                            d: 'lá',
                            dd: '%d lá',
                            M: 'mí',
                            MM: '%d míonna',
                            y: 'bliain',
                            yy: '%d bliain'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
                        ordinal: function (e) {
                            var t = 1 === e ? 'd' : e % 10 === 2 ? 'na' : 'mh';
                            return e + t;
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return i;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = [
                        'Am Faoilleach',
                        'An Gearran',
                        'Am Màrt',
                        'An Giblean',
                        'An Cèitean',
                        'An t-Ògmhios',
                        'An t-Iuchar',
                        'An Lùnastal',
                        'An t-Sultain',
                        'An Dàmhair',
                        'An t-Samhain',
                        'An Dùbhlachd'
                    ], a = [
                        'Faoi',
                        'Gear',
                        'Màrt',
                        'Gibl',
                        'Cèit',
                        'Ògmh',
                        'Iuch',
                        'Lùn',
                        'Sult',
                        'Dàmh',
                        'Samh',
                        'Dùbh'
                    ], n = [
                        'Didòmhnaich',
                        'Diluain',
                        'Dimàirt',
                        'Diciadain',
                        'Diardaoin',
                        'Dihaoine',
                        'Disathairne'
                    ], s = [
                        'Did',
                        'Dil',
                        'Dim',
                        'Dic',
                        'Dia',
                        'Dih',
                        'Dis'
                    ], r = [
                        'Dò',
                        'Lu',
                        'Mà',
                        'Ci',
                        'Ar',
                        'Ha',
                        'Sa'
                    ], i = e.defineLocale('gd', {
                        months: t,
                        monthsShort: a,
                        monthsParseExact: !0,
                        weekdays: n,
                        weekdaysShort: s,
                        weekdaysMin: r,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[An-diugh aig] LT',
                            nextDay: '[A-màireach aig] LT',
                            nextWeek: 'dddd [aig] LT',
                            lastDay: '[An-dè aig] LT',
                            lastWeek: 'dddd [seo chaidh] [aig] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'ann an %s',
                            past: 'bho chionn %s',
                            s: 'beagan diogan',
                            ss: '%d diogan',
                            m: 'mionaid',
                            mm: '%d mionaidean',
                            h: 'uair',
                            hh: '%d uairean',
                            d: 'latha',
                            dd: '%d latha',
                            M: 'mìos',
                            MM: '%d mìosan',
                            y: 'bliadhna',
                            yy: '%d bliadhna'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
                        ordinal: function (e) {
                            var t = 1 === e ? 'd' : e % 10 === 2 ? 'na' : 'mh';
                            return e + t;
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return i;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('gl', {
                    months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
                    monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
                    weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
                    weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D [de] MMMM [de] YYYY',
                        LLL: 'D [de] MMMM [de] YYYY H:mm',
                        LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
                    },
                    calendar: {
                        sameDay: function () {
                            return '[hoxe ' + (1 !== this.hours() ? 'ás' : 'á') + '] LT';
                        },
                        nextDay: function () {
                            return '[mañá ' + (1 !== this.hours() ? 'ás' : 'á') + '] LT';
                        },
                        nextWeek: function () {
                            return 'dddd [' + (1 !== this.hours() ? 'ás' : 'a') + '] LT';
                        },
                        lastDay: function () {
                            return '[onte ' + (1 !== this.hours() ? 'á' : 'a') + '] LT';
                        },
                        lastWeek: function () {
                            return '[o] dddd [pasado ' + (1 !== this.hours() ? 'ás' : 'a') + '] LT';
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: function (e) {
                            return 0 === e.indexOf('un') ? 'n' + e : 'en ' + e;
                        },
                        past: 'hai %s',
                        s: 'uns segundos',
                        ss: '%d segundos',
                        m: 'un minuto',
                        mm: '%d minutos',
                        h: 'unha hora',
                        hh: '%d horas',
                        d: 'un día',
                        dd: '%d días',
                        M: 'un mes',
                        MM: '%d meses',
                        y: 'un ano',
                        yy: '%d anos'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}º/,
                    ordinal: '%dº',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = {
                        s: [
                            'थोडया सॅकंडांनी',
                            'थोडे सॅकंड'
                        ],
                        ss: [
                            e + ' सॅकंडांनी',
                            e + ' सॅकंड'
                        ],
                        m: [
                            'एका मिणटान',
                            'एक मिनूट'
                        ],
                        mm: [
                            e + ' मिणटांनी',
                            e + ' मिणटां'
                        ],
                        h: [
                            'एका वरान',
                            'एक वर'
                        ],
                        hh: [
                            e + ' वरांनी',
                            e + ' वरां'
                        ],
                        d: [
                            'एका दिसान',
                            'एक दीस'
                        ],
                        dd: [
                            e + ' दिसांनी',
                            e + ' दीस'
                        ],
                        M: [
                            'एका म्हयन्यान',
                            'एक म्हयनो'
                        ],
                        MM: [
                            e + ' म्हयन्यानी',
                            e + ' म्हयने'
                        ],
                        y: [
                            'एका वर्सान',
                            'एक वर्स'
                        ],
                        yy: [
                            e + ' वर्सांनी',
                            e + ' वर्सां'
                        ]
                    };
                    return n ? s[a][0] : s[a][1];
                }
                var a = e.defineLocale('gom-deva', {
                    months: {
                        standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
                        format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split('_'),
                        isFormat: /MMMM(\s)+D[oD]?/
                    },
                    monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
                    weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
                    weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'A h:mm [वाजतां]',
                        LTS: 'A h:mm:ss [वाजतां]',
                        L: 'DD-MM-YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY A h:mm [वाजतां]',
                        LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
                        llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]'
                    },
                    calendar: {
                        sameDay: '[आयज] LT',
                        nextDay: '[फाल्यां] LT',
                        nextWeek: '[फुडलो] dddd[,] LT',
                        lastDay: '[काल] LT',
                        lastWeek: '[फाटलो] dddd[,] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s',
                        past: '%s आदीं',
                        s: t,
                        ss: t,
                        m: t,
                        mm: t,
                        h: t,
                        hh: t,
                        d: t,
                        dd: t,
                        M: t,
                        MM: t,
                        y: t,
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'D':
                            return e + 'वेर';
                        default:
                        case 'M':
                        case 'Q':
                        case 'DDD':
                        case 'd':
                        case 'w':
                        case 'W':
                            return e;
                        }
                    },
                    week: {
                        dow: 0,
                        doy: 3
                    },
                    meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), 'राती' === t ? e < 4 ? e : e + 12 : 'सकाळीं' === t ? e : 'दनपारां' === t ? e > 12 ? e : e + 12 : 'सांजे' === t ? e + 12 : void 0;
                    },
                    meridiem: function (e, t, a) {
                        return e < 4 ? 'राती' : e < 12 ? 'सकाळीं' : e < 16 ? 'दनपारां' : e < 20 ? 'सांजे' : 'राती';
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = {
                        s: [
                            'thoddea sekondamni',
                            'thodde sekond'
                        ],
                        ss: [
                            e + ' sekondamni',
                            e + ' sekond'
                        ],
                        m: [
                            'eka mintan',
                            'ek minut'
                        ],
                        mm: [
                            e + ' mintamni',
                            e + ' mintam'
                        ],
                        h: [
                            'eka voran',
                            'ek vor'
                        ],
                        hh: [
                            e + ' voramni',
                            e + ' voram'
                        ],
                        d: [
                            'eka disan',
                            'ek dis'
                        ],
                        dd: [
                            e + ' disamni',
                            e + ' dis'
                        ],
                        M: [
                            'eka mhoinean',
                            'ek mhoino'
                        ],
                        MM: [
                            e + ' mhoineamni',
                            e + ' mhoine'
                        ],
                        y: [
                            'eka vorsan',
                            'ek voros'
                        ],
                        yy: [
                            e + ' vorsamni',
                            e + ' vorsam'
                        ]
                    };
                    return n ? s[a][0] : s[a][1];
                }
                var a = e.defineLocale('gom-latn', {
                    months: {
                        standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
                        format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split('_'),
                        isFormat: /MMMM(\s)+D[oD]?/
                    },
                    monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son\'var'.split('_'),
                    weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
                    weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'A h:mm [vazta]',
                        LTS: 'A h:mm:ss [vazta]',
                        L: 'DD-MM-YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY A h:mm [vazta]',
                        LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
                        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
                    },
                    calendar: {
                        sameDay: '[Aiz] LT',
                        nextDay: '[Faleam] LT',
                        nextWeek: '[Fuddlo] dddd[,] LT',
                        lastDay: '[Kal] LT',
                        lastWeek: '[Fattlo] dddd[,] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s',
                        past: '%s adim',
                        s: t,
                        ss: t,
                        m: t,
                        mm: t,
                        h: t,
                        hh: t,
                        d: t,
                        dd: t,
                        M: t,
                        MM: t,
                        y: t,
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(er)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'D':
                            return e + 'er';
                        default:
                        case 'M':
                        case 'Q':
                        case 'DDD':
                        case 'd':
                        case 'w':
                        case 'W':
                            return e;
                        }
                    },
                    week: {
                        dow: 0,
                        doy: 3
                    },
                    meridiemParse: /rati|sokallim|donparam|sanje/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), 'rati' === t ? e < 4 ? e : e + 12 : 'sokallim' === t ? e : 'donparam' === t ? e > 12 ? e : e + 12 : 'sanje' === t ? e + 12 : void 0;
                    },
                    meridiem: function (e, t, a) {
                        return e < 4 ? 'rati' : e < 12 ? 'sokallim' : e < 16 ? 'donparam' : e < 20 ? 'sanje' : 'rati';
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '૧',
                        2: '૨',
                        3: '૩',
                        4: '૪',
                        5: '૫',
                        6: '૬',
                        7: '૭',
                        8: '૮',
                        9: '૯',
                        0: '૦'
                    }, a = {
                        '૧': '1',
                        '૨': '2',
                        '૩': '3',
                        '૪': '4',
                        '૫': '5',
                        '૬': '6',
                        '૭': '7',
                        '૮': '8',
                        '૯': '9',
                        '૦': '0'
                    }, n = e.defineLocale('gu', {
                        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
                        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
                        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
                        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm વાગ્યે',
                            LTS: 'A h:mm:ss વાગ્યે',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
                        },
                        calendar: {
                            sameDay: '[આજ] LT',
                            nextDay: '[કાલે] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[ગઇકાલે] LT',
                            lastWeek: '[પાછલા] dddd, LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s મા',
                            past: '%s પહેલા',
                            s: 'અમુક પળો',
                            ss: '%d સેકંડ',
                            m: 'એક મિનિટ',
                            mm: '%d મિનિટ',
                            h: 'એક કલાક',
                            hh: '%d કલાક',
                            d: 'એક દિવસ',
                            dd: '%d દિવસ',
                            M: 'એક મહિનો',
                            MM: '%d મહિનો',
                            y: 'એક વર્ષ',
                            yy: '%d વર્ષ'
                        },
                        preparse: function (e) {
                            return e.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'રાત' === t ? e < 4 ? e : e + 12 : 'સવાર' === t ? e : 'બપોર' === t ? e >= 10 ? e : e + 12 : 'સાંજ' === t ? e + 12 : void 0;
                        },
                        meridiem: function (e, t, a) {
                            return e < 4 ? 'રાત' : e < 10 ? 'સવાર' : e < 17 ? 'બપોર' : e < 20 ? 'સાંજ' : 'રાત';
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('he', {
                    months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
                    monthsShort: 'ינו\u05F3_פבר\u05F3_מרץ_אפר\u05F3_מאי_יוני_יולי_אוג\u05F3_ספט\u05F3_אוק\u05F3_נוב\u05F3_דצמ\u05F3'.split('_'),
                    weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
                    weekdaysShort: 'א\u05F3_ב\u05F3_ג\u05F3_ד\u05F3_ה\u05F3_ו\u05F3_ש\u05F3'.split('_'),
                    weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D [ב]MMMM YYYY',
                        LLL: 'D [ב]MMMM YYYY HH:mm',
                        LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
                        l: 'D/M/YYYY',
                        ll: 'D MMM YYYY',
                        lll: 'D MMM YYYY HH:mm',
                        llll: 'ddd, D MMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[היום ב\u05BE]LT',
                        nextDay: '[מחר ב\u05BE]LT',
                        nextWeek: 'dddd [בשעה] LT',
                        lastDay: '[אתמול ב\u05BE]LT',
                        lastWeek: '[ביום] dddd [האחרון בשעה] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'בעוד %s',
                        past: 'לפני %s',
                        s: 'מספר שניות',
                        ss: '%d שניות',
                        m: 'דקה',
                        mm: '%d דקות',
                        h: 'שעה',
                        hh: function (e) {
                            return 2 === e ? 'שעתיים' : e + ' שעות';
                        },
                        d: 'יום',
                        dd: function (e) {
                            return 2 === e ? 'יומיים' : e + ' ימים';
                        },
                        M: 'חודש',
                        MM: function (e) {
                            return 2 === e ? 'חודשיים' : e + ' חודשים';
                        },
                        y: 'שנה',
                        yy: function (e) {
                            return 2 === e ? 'שנתיים' : e % 10 === 0 && 10 !== e ? e + ' שנה' : e + ' שנים';
                        }
                    },
                    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
                    isPM: function (e) {
                        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(e);
                    },
                    meridiem: function (e, t, a) {
                        return e < 5 ? 'לפנות בוקר' : e < 10 ? 'בבוקר' : e < 12 ? a ? 'לפנה"צ' : 'לפני הצהריים' : e < 18 ? a ? 'אחה"צ' : 'אחרי הצהריים' : 'בערב';
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '१',
                        2: '२',
                        3: '३',
                        4: '४',
                        5: '५',
                        6: '६',
                        7: '७',
                        8: '८',
                        9: '९',
                        0: '०'
                    }, a = {
                        '१': '1',
                        '२': '2',
                        '३': '3',
                        '४': '4',
                        '५': '5',
                        '६': '6',
                        '७': '7',
                        '८': '8',
                        '९': '9',
                        '०': '0'
                    }, n = [
                        /^जन/i,
                        /^फ़र|फर/i,
                        /^मार्च/i,
                        /^अप्रै/i,
                        /^मई/i,
                        /^जून/i,
                        /^जुल/i,
                        /^अग/i,
                        /^सितं|सित/i,
                        /^अक्टू/i,
                        /^नव|नवं/i,
                        /^दिसं|दिस/i
                    ], s = [
                        /^जन/i,
                        /^फ़र/i,
                        /^मार्च/i,
                        /^अप्रै/i,
                        /^मई/i,
                        /^जून/i,
                        /^जुल/i,
                        /^अग/i,
                        /^सित/i,
                        /^अक्टू/i,
                        /^नव/i,
                        /^दिस/i
                    ], r = e.defineLocale('hi', {
                        months: {
                            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
                            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split('_')
                        },
                        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
                        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
                        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
                        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm बजे',
                            LTS: 'A h:mm:ss बजे',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm बजे',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
                        },
                        monthsParse: n,
                        longMonthsParse: n,
                        shortMonthsParse: s,
                        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
                        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
                        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
                        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
                        calendar: {
                            sameDay: '[आज] LT',
                            nextDay: '[कल] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[कल] LT',
                            lastWeek: '[पिछले] dddd, LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s में',
                            past: '%s पहले',
                            s: 'कुछ ही क्षण',
                            ss: '%d सेकंड',
                            m: 'एक मिनट',
                            mm: '%d मिनट',
                            h: 'एक घंटा',
                            hh: '%d घंटे',
                            d: 'एक दिन',
                            dd: '%d दिन',
                            M: 'एक महीने',
                            MM: '%d महीने',
                            y: 'एक वर्ष',
                            yy: '%d वर्ष'
                        },
                        preparse: function (e) {
                            return e.replace(/[१२३४५६७८९०]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /रात|सुबह|दोपहर|शाम/,
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'रात' === t ? e < 4 ? e : e + 12 : 'सुबह' === t ? e : 'दोपहर' === t ? e >= 10 ? e : e + 12 : 'शाम' === t ? e + 12 : void 0;
                        },
                        meridiem: function (e, t, a) {
                            return e < 4 ? 'रात' : e < 10 ? 'सुबह' : e < 17 ? 'दोपहर' : e < 20 ? 'शाम' : 'रात';
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a) {
                    var n = e + ' ';
                    switch (a) {
                    case 'ss':
                        return n += 1 === e ? 'sekunda' : 2 === e || 3 === e || 4 === e ? 'sekunde' : 'sekundi';
                    case 'm':
                        return t ? 'jedna minuta' : 'jedne minute';
                    case 'mm':
                        return n += 1 === e ? 'minuta' : 2 === e || 3 === e || 4 === e ? 'minute' : 'minuta';
                    case 'h':
                        return t ? 'jedan sat' : 'jednog sata';
                    case 'hh':
                        return n += 1 === e ? 'sat' : 2 === e || 3 === e || 4 === e ? 'sata' : 'sati';
                    case 'dd':
                        return n += 1 === e ? 'dan' : 'dana';
                    case 'MM':
                        return n += 1 === e ? 'mjesec' : 2 === e || 3 === e || 4 === e ? 'mjeseca' : 'mjeseci';
                    case 'yy':
                        return n += 1 === e ? 'godina' : 2 === e || 3 === e || 4 === e ? 'godine' : 'godina';
                    }
                }
                var a = e.defineLocale('hr', {
                    months: {
                        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
                        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
                    },
                    monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
                    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
                    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'Do MMMM YYYY',
                        LLL: 'Do MMMM YYYY H:mm',
                        LLLL: 'dddd, Do MMMM YYYY H:mm'
                    },
                    calendar: {
                        sameDay: '[danas u] LT',
                        nextDay: '[sutra u] LT',
                        nextWeek: function () {
                            switch (this.day()) {
                            case 0:
                                return '[u] [nedjelju] [u] LT';
                            case 3:
                                return '[u] [srijedu] [u] LT';
                            case 6:
                                return '[u] [subotu] [u] LT';
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                                return '[u] dddd [u] LT';
                            }
                        },
                        lastDay: '[jučer u] LT',
                        lastWeek: function () {
                            switch (this.day()) {
                            case 0:
                                return '[prošlu] [nedjelju] [u] LT';
                            case 3:
                                return '[prošlu] [srijedu] [u] LT';
                            case 6:
                                return '[prošle] [subote] [u] LT';
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                                return '[prošli] dddd [u] LT';
                            }
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'za %s',
                        past: 'prije %s',
                        s: 'par sekundi',
                        ss: t,
                        m: t,
                        mm: t,
                        h: t,
                        hh: t,
                        d: 'dan',
                        dd: t,
                        M: 'mjesec',
                        MM: t,
                        y: 'godinu',
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = e;
                    switch (a) {
                    case 's':
                        return n || t ? 'néhány másodperc' : 'néhány másodperce';
                    case 'ss':
                        return s + (n || t) ? ' másodperc' : ' másodperce';
                    case 'm':
                        return 'egy' + (n || t ? ' perc' : ' perce');
                    case 'mm':
                        return s + (n || t ? ' perc' : ' perce');
                    case 'h':
                        return 'egy' + (n || t ? ' óra' : ' órája');
                    case 'hh':
                        return s + (n || t ? ' óra' : ' órája');
                    case 'd':
                        return 'egy' + (n || t ? ' nap' : ' napja');
                    case 'dd':
                        return s + (n || t ? ' nap' : ' napja');
                    case 'M':
                        return 'egy' + (n || t ? ' hónap' : ' hónapja');
                    case 'MM':
                        return s + (n || t ? ' hónap' : ' hónapja');
                    case 'y':
                        return 'egy' + (n || t ? ' év' : ' éve');
                    case 'yy':
                        return s + (n || t ? ' év' : ' éve');
                    }
                    return '';
                }
                function a(e) {
                    return (e ? '' : '[múlt] ') + '[' + n[this.day()] + '] LT[-kor]';
                }
                var n = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' '), s = e.defineLocale('hu', {
                        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
                        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
                        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
                        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'YYYY.MM.DD.',
                            LL: 'YYYY. MMMM D.',
                            LLL: 'YYYY. MMMM D. H:mm',
                            LLLL: 'YYYY. MMMM D., dddd H:mm'
                        },
                        meridiemParse: /de|du/i,
                        isPM: function (e) {
                            return 'u' === e.charAt(1).toLowerCase();
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? a === !0 ? 'de' : 'DE' : a === !0 ? 'du' : 'DU';
                        },
                        calendar: {
                            sameDay: '[ma] LT[-kor]',
                            nextDay: '[holnap] LT[-kor]',
                            nextWeek: function () {
                                return a.call(this, !0);
                            },
                            lastDay: '[tegnap] LT[-kor]',
                            lastWeek: function () {
                                return a.call(this, !1);
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s múlva',
                            past: '%s',
                            s: t,
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: t,
                            dd: t,
                            M: t,
                            MM: t,
                            y: t,
                            yy: t
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return s;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('hy-am', {
                    months: {
                        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
                        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
                    },
                    monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
                    weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
                    weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
                    weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY թ.',
                        LLL: 'D MMMM YYYY թ., HH:mm',
                        LLLL: 'dddd, D MMMM YYYY թ., HH:mm'
                    },
                    calendar: {
                        sameDay: '[այսօր] LT',
                        nextDay: '[վաղը] LT',
                        lastDay: '[երեկ] LT',
                        nextWeek: function () {
                            return 'dddd [օրը ժամը] LT';
                        },
                        lastWeek: function () {
                            return '[անցած] dddd [օրը ժամը] LT';
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s հետո',
                        past: '%s առաջ',
                        s: 'մի քանի վայրկյան',
                        ss: '%d վայրկյան',
                        m: 'րոպե',
                        mm: '%d րոպե',
                        h: 'ժամ',
                        hh: '%d ժամ',
                        d: 'օր',
                        dd: '%d օր',
                        M: 'ամիս',
                        MM: '%d ամիս',
                        y: 'տարի',
                        yy: '%d տարի'
                    },
                    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
                    isPM: function (e) {
                        return /^(ցերեկվա|երեկոյան)$/.test(e);
                    },
                    meridiem: function (e) {
                        return e < 4 ? 'գիշերվա' : e < 12 ? 'առավոտվա' : e < 17 ? 'ցերեկվա' : 'երեկոյան';
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'DDD':
                        case 'w':
                        case 'W':
                        case 'DDDo':
                            return 1 === e ? e + '-ին' : e + '-րդ';
                        default:
                            return e;
                        }
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('id', {
                    months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
                    monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
                    weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
                    weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
                    weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
                    longDateFormat: {
                        LT: 'HH.mm',
                        LTS: 'HH.mm.ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY [pukul] HH.mm',
                        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
                    },
                    meridiemParse: /pagi|siang|sore|malam/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), 'pagi' === t ? e : 'siang' === t ? e >= 11 ? e : e + 12 : 'sore' === t || 'malam' === t ? e + 12 : void 0;
                    },
                    meridiem: function (e, t, a) {
                        return e < 11 ? 'pagi' : e < 15 ? 'siang' : e < 19 ? 'sore' : 'malam';
                    },
                    calendar: {
                        sameDay: '[Hari ini pukul] LT',
                        nextDay: '[Besok pukul] LT',
                        nextWeek: 'dddd [pukul] LT',
                        lastDay: '[Kemarin pukul] LT',
                        lastWeek: 'dddd [lalu pukul] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'dalam %s',
                        past: '%s yang lalu',
                        s: 'beberapa detik',
                        ss: '%d detik',
                        m: 'semenit',
                        mm: '%d menit',
                        h: 'sejam',
                        hh: '%d jam',
                        d: 'sehari',
                        dd: '%d hari',
                        M: 'sebulan',
                        MM: '%d bulan',
                        y: 'setahun',
                        yy: '%d tahun'
                    },
                    week: {
                        dow: 0,
                        doy: 6
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e) {
                    return e % 100 === 11 || e % 10 !== 1;
                }
                function a(e, a, n, s) {
                    var r = e + ' ';
                    switch (n) {
                    case 's':
                        return a || s ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
                    case 'ss':
                        return t(e) ? r + (a || s ? 'sekúndur' : 'sekúndum') : r + 'sekúnda';
                    case 'm':
                        return a ? 'mínúta' : 'mínútu';
                    case 'mm':
                        return t(e) ? r + (a || s ? 'mínútur' : 'mínútum') : a ? r + 'mínúta' : r + 'mínútu';
                    case 'hh':
                        return t(e) ? r + (a || s ? 'klukkustundir' : 'klukkustundum') : r + 'klukkustund';
                    case 'd':
                        return a ? 'dagur' : s ? 'dag' : 'degi';
                    case 'dd':
                        return t(e) ? a ? r + 'dagar' : r + (s ? 'daga' : 'dögum') : a ? r + 'dagur' : r + (s ? 'dag' : 'degi');
                    case 'M':
                        return a ? 'mánuður' : s ? 'mánuð' : 'mánuði';
                    case 'MM':
                        return t(e) ? a ? r + 'mánuðir' : r + (s ? 'mánuði' : 'mánuðum') : a ? r + 'mánuður' : r + (s ? 'mánuð' : 'mánuði');
                    case 'y':
                        return a || s ? 'ár' : 'ári';
                    case 'yy':
                        return t(e) ? r + (a || s ? 'ár' : 'árum') : r + (a || s ? 'ár' : 'ári');
                    }
                }
                var n = e.defineLocale('is', {
                    months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
                    monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
                    weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
                    weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
                    weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY [kl.] H:mm',
                        LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
                    },
                    calendar: {
                        sameDay: '[í dag kl.] LT',
                        nextDay: '[á morgun kl.] LT',
                        nextWeek: 'dddd [kl.] LT',
                        lastDay: '[í gær kl.] LT',
                        lastWeek: '[síðasta] dddd [kl.] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'eftir %s',
                        past: 'fyrir %s síðan',
                        s: a,
                        ss: a,
                        m: a,
                        mm: a,
                        h: 'klukkustund',
                        hh: a,
                        d: a,
                        dd: a,
                        M: a,
                        MM: a,
                        y: a,
                        yy: a
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('it', {
                    months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
                    monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
                    weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
                    weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
                    weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: function () {
                            return '[Oggi a' + (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : 'll\'') + ']LT';
                        },
                        nextDay: function () {
                            return '[Domani a' + (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : 'll\'') + ']LT';
                        },
                        nextWeek: function () {
                            return 'dddd [a' + (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : 'll\'') + ']LT';
                        },
                        lastDay: function () {
                            return '[Ieri a' + (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : 'll\'') + ']LT';
                        },
                        lastWeek: function () {
                            switch (this.day()) {
                            case 0:
                                return '[La scorsa] dddd [a' + (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : 'll\'') + ']LT';
                            default:
                                return '[Lo scorso] dddd [a' + (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : 'll\'') + ']LT';
                            }
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'tra %s',
                        past: '%s fa',
                        s: 'alcuni secondi',
                        ss: '%d secondi',
                        m: 'un minuto',
                        mm: '%d minuti',
                        h: 'un\'ora',
                        hh: '%d ore',
                        d: 'un giorno',
                        dd: '%d giorni',
                        w: 'una settimana',
                        ww: '%d settimane',
                        M: 'un mese',
                        MM: '%d mesi',
                        y: 'un anno',
                        yy: '%d anni'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}º/,
                    ordinal: '%dº',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('it-ch', {
                    months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
                    monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
                    weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
                    weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
                    weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Oggi alle] LT',
                        nextDay: '[Domani alle] LT',
                        nextWeek: 'dddd [alle] LT',
                        lastDay: '[Ieri alle] LT',
                        lastWeek: function () {
                            switch (this.day()) {
                            case 0:
                                return '[la scorsa] dddd [alle] LT';
                            default:
                                return '[lo scorso] dddd [alle] LT';
                            }
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: function (e) {
                            return (/^[0-9].+$/.test(e) ? 'tra' : 'in') + ' ' + e;
                        },
                        past: '%s fa',
                        s: 'alcuni secondi',
                        ss: '%d secondi',
                        m: 'un minuto',
                        mm: '%d minuti',
                        h: 'un\'ora',
                        hh: '%d ore',
                        d: 'un giorno',
                        dd: '%d giorni',
                        M: 'un mese',
                        MM: '%d mesi',
                        y: 'un anno',
                        yy: '%d anni'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}º/,
                    ordinal: '%dº',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ja', {
                    eras: [
                        {
                            since: '2019-05-01',
                            offset: 1,
                            name: '令和',
                            narrow: '\u32FF',
                            abbr: 'R'
                        },
                        {
                            since: '1989-01-08',
                            until: '2019-04-30',
                            offset: 1,
                            name: '平成',
                            narrow: '\u337B',
                            abbr: 'H'
                        },
                        {
                            since: '1926-12-25',
                            until: '1989-01-07',
                            offset: 1,
                            name: '昭和',
                            narrow: '\u337C',
                            abbr: 'S'
                        },
                        {
                            since: '1912-07-30',
                            until: '1926-12-24',
                            offset: 1,
                            name: '大正',
                            narrow: '\u337D',
                            abbr: 'T'
                        },
                        {
                            since: '1873-01-01',
                            until: '1912-07-29',
                            offset: 6,
                            name: '明治',
                            narrow: '\u337E',
                            abbr: 'M'
                        },
                        {
                            since: '0001-01-01',
                            until: '1873-12-31',
                            offset: 1,
                            name: '西暦',
                            narrow: 'AD',
                            abbr: 'AD'
                        },
                        {
                            since: '0000-12-31',
                            until: -(1 / 0),
                            offset: 1,
                            name: '紀元前',
                            narrow: 'BC',
                            abbr: 'BC'
                        }
                    ],
                    eraYearOrdinalRegex: /(元|\d+)年/,
                    eraYearOrdinalParse: function (e, t) {
                        return '元' === t[1] ? 1 : parseInt(t[1] || e, 10);
                    },
                    months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                    weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
                    weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
                    weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY/MM/DD',
                        LL: 'YYYY年M月D日',
                        LLL: 'YYYY年M月D日 HH:mm',
                        LLLL: 'YYYY年M月D日 dddd HH:mm',
                        l: 'YYYY/MM/DD',
                        ll: 'YYYY年M月D日',
                        lll: 'YYYY年M月D日 HH:mm',
                        llll: 'YYYY年M月D日(ddd) HH:mm'
                    },
                    meridiemParse: /午前|午後/i,
                    isPM: function (e) {
                        return '午後' === e;
                    },
                    meridiem: function (e, t, a) {
                        return e < 12 ? '午前' : '午後';
                    },
                    calendar: {
                        sameDay: '[今日] LT',
                        nextDay: '[明日] LT',
                        nextWeek: function (e) {
                            return e.week() !== this.week() ? '[来週]dddd LT' : 'dddd LT';
                        },
                        lastDay: '[昨日] LT',
                        lastWeek: function (e) {
                            return this.week() !== e.week() ? '[先週]dddd LT' : 'dddd LT';
                        },
                        sameElse: 'L'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}日/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'y':
                            return 1 === e ? '元年' : e + '年';
                        case 'd':
                        case 'D':
                        case 'DDD':
                            return e + '日';
                        default:
                            return e;
                        }
                    },
                    relativeTime: {
                        future: '%s後',
                        past: '%s前',
                        s: '数秒',
                        ss: '%d秒',
                        m: '1分',
                        mm: '%d分',
                        h: '1時間',
                        hh: '%d時間',
                        d: '1日',
                        dd: '%d日',
                        M: '1ヶ月',
                        MM: '%dヶ月',
                        y: '1年',
                        yy: '%d年'
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('jv', {
                    months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
                    monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
                    weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
                    weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
                    weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
                    longDateFormat: {
                        LT: 'HH.mm',
                        LTS: 'HH.mm.ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY [pukul] HH.mm',
                        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
                    },
                    meridiemParse: /enjing|siyang|sonten|ndalu/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), 'enjing' === t ? e : 'siyang' === t ? e >= 11 ? e : e + 12 : 'sonten' === t || 'ndalu' === t ? e + 12 : void 0;
                    },
                    meridiem: function (e, t, a) {
                        return e < 11 ? 'enjing' : e < 15 ? 'siyang' : e < 19 ? 'sonten' : 'ndalu';
                    },
                    calendar: {
                        sameDay: '[Dinten puniko pukul] LT',
                        nextDay: '[Mbenjang pukul] LT',
                        nextWeek: 'dddd [pukul] LT',
                        lastDay: '[Kala wingi pukul] LT',
                        lastWeek: 'dddd [kepengker pukul] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'wonten ing %s',
                        past: '%s ingkang kepengker',
                        s: 'sawetawis detik',
                        ss: '%d detik',
                        m: 'setunggal menit',
                        mm: '%d menit',
                        h: 'setunggal jam',
                        hh: '%d jam',
                        d: 'sedinten',
                        dd: '%d dinten',
                        M: 'sewulan',
                        MM: '%d wulan',
                        y: 'setaun',
                        yy: '%d taun'
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ka', {
                    months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
                    monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
                    weekdays: {
                        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
                        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
                        isFormat: /(წინა|შემდეგ)/
                    },
                    weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
                    weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[დღეს] LT[-ზე]',
                        nextDay: '[ხვალ] LT[-ზე]',
                        lastDay: '[გუშინ] LT[-ზე]',
                        nextWeek: '[შემდეგ] dddd LT[-ზე]',
                        lastWeek: '[წინა] dddd LT-ზე',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: function (e) {
                            return e.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (e, t, a) {
                                return 'ი' === a ? t + 'ში' : t + a + 'ში';
                            });
                        },
                        past: function (e) {
                            return /(წამი|წუთი|საათი|დღე|თვე)/.test(e) ? e.replace(/(ი|ე)$/, 'ის წინ') : /წელი/.test(e) ? e.replace(/წელი$/, 'წლის წინ') : e;
                        },
                        s: 'რამდენიმე წამი',
                        ss: '%d წამი',
                        m: 'წუთი',
                        mm: '%d წუთი',
                        h: 'საათი',
                        hh: '%d საათი',
                        d: 'დღე',
                        dd: '%d დღე',
                        M: 'თვე',
                        MM: '%d თვე',
                        y: 'წელი',
                        yy: '%d წელი'
                    },
                    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
                    ordinal: function (e) {
                        return 0 === e ? e : 1 === e ? e + '-ლი' : e < 20 || e <= 100 && e % 20 === 0 || e % 100 === 0 ? 'მე-' + e : e + '-ე';
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        0: '-ші',
                        1: '-ші',
                        2: '-ші',
                        3: '-ші',
                        4: '-ші',
                        5: '-ші',
                        6: '-шы',
                        7: '-ші',
                        8: '-ші',
                        9: '-шы',
                        10: '-шы',
                        20: '-шы',
                        30: '-шы',
                        40: '-шы',
                        50: '-ші',
                        60: '-шы',
                        70: '-ші',
                        80: '-ші',
                        90: '-шы',
                        100: '-ші'
                    }, a = e.defineLocale('kk', {
                        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
                        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
                        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
                        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
                        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[Бүгін сағат] LT',
                            nextDay: '[Ертең сағат] LT',
                            nextWeek: 'dddd [сағат] LT',
                            lastDay: '[Кеше сағат] LT',
                            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s ішінде',
                            past: '%s бұрын',
                            s: 'бірнеше секунд',
                            ss: '%d секунд',
                            m: 'бір минут',
                            mm: '%d минут',
                            h: 'бір сағат',
                            hh: '%d сағат',
                            d: 'бір күн',
                            dd: '%d күн',
                            M: 'бір ай',
                            MM: '%d ай',
                            y: 'бір жыл',
                            yy: '%d жыл'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
                        ordinal: function (e) {
                            var a = e % 10, n = e >= 100 ? 100 : null;
                            return e + (t[e] || t[a] || t[n]);
                        },
                        week: {
                            dow: 1,
                            doy: 7
                        }
                    });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '១',
                        2: '២',
                        3: '៣',
                        4: '៤',
                        5: '៥',
                        6: '៦',
                        7: '៧',
                        8: '៨',
                        9: '៩',
                        0: '០'
                    }, a = {
                        '១': '1',
                        '២': '2',
                        '៣': '3',
                        '៤': '4',
                        '៥': '5',
                        '៦': '6',
                        '៧': '7',
                        '៨': '8',
                        '៩': '9',
                        '០': '0'
                    }, n = e.defineLocale('km', {
                        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
                        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
                        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
                        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
                        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        meridiemParse: /ព្រឹក|ល្ងាច/,
                        isPM: function (e) {
                            return 'ល្ងាច' === e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'ព្រឹក' : 'ល្ងាច';
                        },
                        calendar: {
                            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
                            nextDay: '[ស្អែក ម៉ោង] LT',
                            nextWeek: 'dddd [ម៉ោង] LT',
                            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
                            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%sទៀត',
                            past: '%sមុន',
                            s: 'ប៉ុន្មានវិនាទី',
                            ss: '%d វិនាទី',
                            m: 'មួយនាទី',
                            mm: '%d នាទី',
                            h: 'មួយម៉ោង',
                            hh: '%d ម៉ោង',
                            d: 'មួយថ្ងៃ',
                            dd: '%d ថ្ងៃ',
                            M: 'មួយខែ',
                            MM: '%d ខែ',
                            y: 'មួយឆ្នាំ',
                            yy: '%d ឆ្នាំ'
                        },
                        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
                        ordinal: 'ទី%d',
                        preparse: function (e) {
                            return e.replace(/[១២៣៤៥៦៧៨៩០]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '೧',
                        2: '೨',
                        3: '೩',
                        4: '೪',
                        5: '೫',
                        6: '೬',
                        7: '೭',
                        8: '೮',
                        9: '೯',
                        0: '೦'
                    }, a = {
                        '೧': '1',
                        '೨': '2',
                        '೩': '3',
                        '೪': '4',
                        '೫': '5',
                        '೬': '6',
                        '೭': '7',
                        '೮': '8',
                        '೯': '9',
                        '೦': '0'
                    }, n = e.defineLocale('kn', {
                        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
                        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
                        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
                        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm',
                            LTS: 'A h:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm'
                        },
                        calendar: {
                            sameDay: '[ಇಂದು] LT',
                            nextDay: '[ನಾಳೆ] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[ನಿನ್ನೆ] LT',
                            lastWeek: '[ಕೊನೆಯ] dddd, LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s ನಂತರ',
                            past: '%s ಹಿಂದೆ',
                            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
                            ss: '%d ಸೆಕೆಂಡುಗಳು',
                            m: 'ಒಂದು ನಿಮಿಷ',
                            mm: '%d ನಿಮಿಷ',
                            h: 'ಒಂದು ಗಂಟೆ',
                            hh: '%d ಗಂಟೆ',
                            d: 'ಒಂದು ದಿನ',
                            dd: '%d ದಿನ',
                            M: 'ಒಂದು ತಿಂಗಳು',
                            MM: '%d ತಿಂಗಳು',
                            y: 'ಒಂದು ವರ್ಷ',
                            yy: '%d ವರ್ಷ'
                        },
                        preparse: function (e) {
                            return e.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'ರಾತ್ರಿ' === t ? e < 4 ? e : e + 12 : 'ಬೆಳಿಗ್ಗೆ' === t ? e : 'ಮಧ್ಯಾಹ್ನ' === t ? e >= 10 ? e : e + 12 : 'ಸಂಜೆ' === t ? e + 12 : void 0;
                        },
                        meridiem: function (e, t, a) {
                            return e < 4 ? 'ರಾತ್ರಿ' : e < 10 ? 'ಬೆಳಿಗ್ಗೆ' : e < 17 ? 'ಮಧ್ಯಾಹ್ನ' : e < 20 ? 'ಸಂಜೆ' : 'ರಾತ್ರಿ';
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
                        ordinal: function (e) {
                            return e + 'ನೇ';
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ko', {
                    months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
                    monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
                    weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
                    weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
                    weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
                    longDateFormat: {
                        LT: 'A h:mm',
                        LTS: 'A h:mm:ss',
                        L: 'YYYY.MM.DD.',
                        LL: 'YYYY년 MMMM D일',
                        LLL: 'YYYY년 MMMM D일 A h:mm',
                        LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
                        l: 'YYYY.MM.DD.',
                        ll: 'YYYY년 MMMM D일',
                        lll: 'YYYY년 MMMM D일 A h:mm',
                        llll: 'YYYY년 MMMM D일 dddd A h:mm'
                    },
                    calendar: {
                        sameDay: '오늘 LT',
                        nextDay: '내일 LT',
                        nextWeek: 'dddd LT',
                        lastDay: '어제 LT',
                        lastWeek: '지난주 dddd LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s 후',
                        past: '%s 전',
                        s: '몇 초',
                        ss: '%d초',
                        m: '1분',
                        mm: '%d분',
                        h: '한 시간',
                        hh: '%d시간',
                        d: '하루',
                        dd: '%d일',
                        M: '한 달',
                        MM: '%d달',
                        y: '일 년',
                        yy: '%d년'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'd':
                        case 'D':
                        case 'DDD':
                            return e + '일';
                        case 'M':
                            return e + '월';
                        case 'w':
                        case 'W':
                            return e + '주';
                        default:
                            return e;
                        }
                    },
                    meridiemParse: /오전|오후/,
                    isPM: function (e) {
                        return '오후' === e;
                    },
                    meridiem: function (e, t, a) {
                        return e < 12 ? '오전' : '오후';
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '١',
                        2: '٢',
                        3: '٣',
                        4: '٤',
                        5: '٥',
                        6: '٦',
                        7: '٧',
                        8: '٨',
                        9: '٩',
                        0: '٠'
                    }, a = {
                        '١': '1',
                        '٢': '2',
                        '٣': '3',
                        '٤': '4',
                        '٥': '5',
                        '٦': '6',
                        '٧': '7',
                        '٨': '8',
                        '٩': '9',
                        '٠': '0'
                    }, n = [
                        'کانونی دووەم',
                        'شوبات',
                        'ئازار',
                        'نیسان',
                        'ئایار',
                        'حوزەیران',
                        'تەمموز',
                        'ئاب',
                        'ئەیلوول',
                        'تشرینی یەكەم',
                        'تشرینی دووەم',
                        'كانونی یەکەم'
                    ], s = e.defineLocale('ku', {
                        months: n,
                        monthsShort: n,
                        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
                        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
                        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        meridiemParse: /ئێواره‌|به‌یانی/,
                        isPM: function (e) {
                            return /ئێواره‌/.test(e);
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'به‌یانی' : 'ئێواره‌';
                        },
                        calendar: {
                            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
                            nextDay: '[به‌یانی كاتژمێر] LT',
                            nextWeek: 'dddd [كاتژمێر] LT',
                            lastDay: '[دوێنێ كاتژمێر] LT',
                            lastWeek: 'dddd [كاتژمێر] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'له‌ %s',
                            past: '%s',
                            s: 'چه‌ند چركه‌یه‌ك',
                            ss: 'چركه‌ %d',
                            m: 'یه‌ك خوله‌ك',
                            mm: '%d خوله‌ك',
                            h: 'یه‌ك كاتژمێر',
                            hh: '%d كاتژمێر',
                            d: 'یه‌ك ڕۆژ',
                            dd: '%d ڕۆژ',
                            M: 'یه‌ك مانگ',
                            MM: '%d مانگ',
                            y: 'یه‌ك ساڵ',
                            yy: '%d ساڵ'
                        },
                        preparse: function (e) {
                            return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
                                return a[e];
                            }).replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            }).replace(/,/g, '\u060C');
                        },
                        week: {
                            dow: 6,
                            doy: 12
                        }
                    });
                return s;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        0: '-чү',
                        1: '-чи',
                        2: '-чи',
                        3: '-чү',
                        4: '-чү',
                        5: '-чи',
                        6: '-чы',
                        7: '-чи',
                        8: '-чи',
                        9: '-чу',
                        10: '-чу',
                        20: '-чы',
                        30: '-чу',
                        40: '-чы',
                        50: '-чү',
                        60: '-чы',
                        70: '-чи',
                        80: '-чи',
                        90: '-чу',
                        100: '-чү'
                    }, a = e.defineLocale('ky', {
                        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
                        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
                        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
                        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
                        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[Бүгүн саат] LT',
                            nextDay: '[Эртең саат] LT',
                            nextWeek: 'dddd [саат] LT',
                            lastDay: '[Кечээ саат] LT',
                            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s ичинде',
                            past: '%s мурун',
                            s: 'бирнече секунд',
                            ss: '%d секунд',
                            m: 'бир мүнөт',
                            mm: '%d мүнөт',
                            h: 'бир саат',
                            hh: '%d саат',
                            d: 'бир күн',
                            dd: '%d күн',
                            M: 'бир ай',
                            MM: '%d ай',
                            y: 'бир жыл',
                            yy: '%d жыл'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
                        ordinal: function (e) {
                            var a = e % 10, n = e >= 100 ? 100 : null;
                            return e + (t[e] || t[a] || t[n]);
                        },
                        week: {
                            dow: 1,
                            doy: 7
                        }
                    });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = {
                        m: [
                            'eng Minutt',
                            'enger Minutt'
                        ],
                        h: [
                            'eng Stonn',
                            'enger Stonn'
                        ],
                        d: [
                            'een Dag',
                            'engem Dag'
                        ],
                        M: [
                            'ee Mount',
                            'engem Mount'
                        ],
                        y: [
                            'ee Joer',
                            'engem Joer'
                        ]
                    };
                    return t ? s[a][0] : s[a][1];
                }
                function a(e) {
                    var t = e.substr(0, e.indexOf(' '));
                    return s(t) ? 'a ' + e : 'an ' + e;
                }
                function n(e) {
                    var t = e.substr(0, e.indexOf(' '));
                    return s(t) ? 'viru ' + e : 'virun ' + e;
                }
                function s(e) {
                    if (e = parseInt(e, 10), isNaN(e))
                        return !1;
                    if (e < 0)
                        return !0;
                    if (e < 10)
                        return 4 <= e && e <= 7;
                    if (e < 100) {
                        var t = e % 10, a = e / 10;
                        return s(0 === t ? a : t);
                    }
                    if (e < 10000) {
                        for (; e >= 10;)
                            e /= 10;
                        return s(e);
                    }
                    return e /= 1000, s(e);
                }
                var r = e.defineLocale('lb', {
                    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
                    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
                    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
                    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'H:mm [Auer]',
                        LTS: 'H:mm:ss [Auer]',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY H:mm [Auer]',
                        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
                    },
                    calendar: {
                        sameDay: '[Haut um] LT',
                        sameElse: 'L',
                        nextDay: '[Muer um] LT',
                        nextWeek: 'dddd [um] LT',
                        lastDay: '[Gëschter um] LT',
                        lastWeek: function () {
                            switch (this.day()) {
                            case 2:
                            case 4:
                                return '[Leschten] dddd [um] LT';
                            default:
                                return '[Leschte] dddd [um] LT';
                            }
                        }
                    },
                    relativeTime: {
                        future: a,
                        past: n,
                        s: 'e puer Sekonnen',
                        ss: '%d Sekonnen',
                        m: t,
                        mm: '%d Minutten',
                        h: t,
                        hh: '%d Stonnen',
                        d: t,
                        dd: '%d Deeg',
                        M: t,
                        MM: '%d Méint',
                        y: t,
                        yy: '%d Joer'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('lo', {
                    months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
                    monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
                    weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
                    weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
                    weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'ວັນdddd D MMMM YYYY HH:mm'
                    },
                    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
                    isPM: function (e) {
                        return 'ຕອນແລງ' === e;
                    },
                    meridiem: function (e, t, a) {
                        return e < 12 ? 'ຕອນເຊົ້າ' : 'ຕອນແລງ';
                    },
                    calendar: {
                        sameDay: '[ມື້ນີ້ເວລາ] LT',
                        nextDay: '[ມື້ອື່ນເວລາ] LT',
                        nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
                        lastDay: '[ມື້ວານນີ້ເວລາ] LT',
                        lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'ອີກ %s',
                        past: '%sຜ່ານມາ',
                        s: 'ບໍ່ເທົ່າໃດວິນາທີ',
                        ss: '%d ວິນາທີ',
                        m: '1 ນາທີ',
                        mm: '%d ນາທີ',
                        h: '1 ຊົ່ວໂມງ',
                        hh: '%d ຊົ່ວໂມງ',
                        d: '1 ມື້',
                        dd: '%d ມື້',
                        M: '1 ເດືອນ',
                        MM: '%d ເດືອນ',
                        y: '1 ປີ',
                        yy: '%d ປີ'
                    },
                    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
                    ordinal: function (e) {
                        return 'ທີ່' + e;
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    return t ? 'kelios sekundės' : n ? 'kelių sekundžių' : 'kelias sekundes';
                }
                function a(e, t, a, n) {
                    return t ? s(a)[0] : n ? s(a)[1] : s(a)[2];
                }
                function n(e) {
                    return e % 10 === 0 || e > 10 && e < 20;
                }
                function s(e) {
                    return i[e].split('_');
                }
                function r(e, t, r, i) {
                    var d = e + ' ';
                    return 1 === e ? d + a(e, t, r[0], i) : t ? d + (n(e) ? s(r)[1] : s(r)[0]) : i ? d + s(r)[1] : d + (n(e) ? s(r)[1] : s(r)[2]);
                }
                var i = {
                        ss: 'sekundė_sekundžių_sekundes',
                        m: 'minutė_minutės_minutę',
                        mm: 'minutės_minučių_minutes',
                        h: 'valanda_valandos_valandą',
                        hh: 'valandos_valandų_valandas',
                        d: 'diena_dienos_dieną',
                        dd: 'dienos_dienų_dienas',
                        M: 'mėnuo_mėnesio_mėnesį',
                        MM: 'mėnesiai_mėnesių_mėnesius',
                        y: 'metai_metų_metus',
                        yy: 'metai_metų_metus'
                    }, d = e.defineLocale('lt', {
                        months: {
                            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
                            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
                            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
                        },
                        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
                        weekdays: {
                            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
                            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
                            isFormat: /dddd HH:mm/
                        },
                        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
                        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY-MM-DD',
                            LL: 'YYYY [m.] MMMM D [d.]',
                            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
                            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
                            l: 'YYYY-MM-DD',
                            ll: 'YYYY [m.] MMMM D [d.]',
                            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
                            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
                        },
                        calendar: {
                            sameDay: '[Šiandien] LT',
                            nextDay: '[Rytoj] LT',
                            nextWeek: 'dddd LT',
                            lastDay: '[Vakar] LT',
                            lastWeek: '[Praėjusį] dddd LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'po %s',
                            past: 'prieš %s',
                            s: t,
                            ss: r,
                            m: a,
                            mm: r,
                            h: a,
                            hh: r,
                            d: a,
                            dd: r,
                            M: a,
                            MM: r,
                            y: a,
                            yy: r
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
                        ordinal: function (e) {
                            return e + '-oji';
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return d;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a) {
                    return a ? t % 10 === 1 && t % 100 !== 11 ? e[2] : e[3] : t % 10 === 1 && t % 100 !== 11 ? e[0] : e[1];
                }
                function a(e, a, n) {
                    return e + ' ' + t(r[n], e, a);
                }
                function n(e, a, n) {
                    return t(r[n], e, a);
                }
                function s(e, t) {
                    return t ? 'dažas sekundes' : 'dažām sekundēm';
                }
                var r = {
                        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
                        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
                        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
                        h: 'stundas_stundām_stunda_stundas'.split('_'),
                        hh: 'stundas_stundām_stunda_stundas'.split('_'),
                        d: 'dienas_dienām_diena_dienas'.split('_'),
                        dd: 'dienas_dienām_diena_dienas'.split('_'),
                        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
                        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
                        y: 'gada_gadiem_gads_gadi'.split('_'),
                        yy: 'gada_gadiem_gads_gadi'.split('_')
                    }, i = e.defineLocale('lv', {
                        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
                        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
                        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
                        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
                        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY.',
                            LL: 'YYYY. [gada] D. MMMM',
                            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
                            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
                        },
                        calendar: {
                            sameDay: '[Šodien pulksten] LT',
                            nextDay: '[Rīt pulksten] LT',
                            nextWeek: 'dddd [pulksten] LT',
                            lastDay: '[Vakar pulksten] LT',
                            lastWeek: '[Pagājušā] dddd [pulksten] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'pēc %s',
                            past: 'pirms %s',
                            s: s,
                            ss: a,
                            m: n,
                            mm: a,
                            h: n,
                            hh: a,
                            d: n,
                            dd: a,
                            M: n,
                            MM: a,
                            y: n,
                            yy: a
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return i;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        words: {
                            ss: [
                                'sekund',
                                'sekunda',
                                'sekundi'
                            ],
                            m: [
                                'jedan minut',
                                'jednog minuta'
                            ],
                            mm: [
                                'minut',
                                'minuta',
                                'minuta'
                            ],
                            h: [
                                'jedan sat',
                                'jednog sata'
                            ],
                            hh: [
                                'sat',
                                'sata',
                                'sati'
                            ],
                            dd: [
                                'dan',
                                'dana',
                                'dana'
                            ],
                            MM: [
                                'mjesec',
                                'mjeseca',
                                'mjeseci'
                            ],
                            yy: [
                                'godina',
                                'godine',
                                'godina'
                            ]
                        },
                        correctGrammaticalCase: function (e, t) {
                            return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2];
                        },
                        translate: function (e, a, n) {
                            var s = t.words[n];
                            return 1 === n.length ? a ? s[0] : s[1] : e + ' ' + t.correctGrammaticalCase(e, s);
                        }
                    }, a = e.defineLocale('me', {
                        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
                        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
                        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
                        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY H:mm',
                            LLLL: 'dddd, D. MMMM YYYY H:mm'
                        },
                        calendar: {
                            sameDay: '[danas u] LT',
                            nextDay: '[sjutra u] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                case 0:
                                    return '[u] [nedjelju] [u] LT';
                                case 3:
                                    return '[u] [srijedu] [u] LT';
                                case 6:
                                    return '[u] [subotu] [u] LT';
                                case 1:
                                case 2:
                                case 4:
                                case 5:
                                    return '[u] dddd [u] LT';
                                }
                            },
                            lastDay: '[juče u] LT',
                            lastWeek: function () {
                                var e = [
                                    '[prošle] [nedjelje] [u] LT',
                                    '[prošlog] [ponedjeljka] [u] LT',
                                    '[prošlog] [utorka] [u] LT',
                                    '[prošle] [srijede] [u] LT',
                                    '[prošlog] [četvrtka] [u] LT',
                                    '[prošlog] [petka] [u] LT',
                                    '[prošle] [subote] [u] LT'
                                ];
                                return e[this.day()];
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: 'prije %s',
                            s: 'nekoliko sekundi',
                            ss: t.translate,
                            m: t.translate,
                            mm: t.translate,
                            h: t.translate,
                            hh: t.translate,
                            d: 'dan',
                            dd: t.translate,
                            M: 'mjesec',
                            MM: t.translate,
                            y: 'godinu',
                            yy: t.translate
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: {
                            dow: 1,
                            doy: 7
                        }
                    });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('mi', {
                    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
                    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
                    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
                    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
                    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
                    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
                    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
                    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
                    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY [i] HH:mm',
                        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
                    },
                    calendar: {
                        sameDay: '[i teie mahana, i] LT',
                        nextDay: '[apopo i] LT',
                        nextWeek: 'dddd [i] LT',
                        lastDay: '[inanahi i] LT',
                        lastWeek: 'dddd [whakamutunga i] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'i roto i %s',
                        past: '%s i mua',
                        s: 'te hēkona ruarua',
                        ss: '%d hēkona',
                        m: 'he meneti',
                        mm: '%d meneti',
                        h: 'te haora',
                        hh: '%d haora',
                        d: 'he ra',
                        dd: '%d ra',
                        M: 'he marama',
                        MM: '%d marama',
                        y: 'he tau',
                        yy: '%d tau'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}º/,
                    ordinal: '%dº',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('mk', {
                    months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
                    monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
                    weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
                    weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
                    weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'D.MM.YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY H:mm',
                        LLLL: 'dddd, D MMMM YYYY H:mm'
                    },
                    calendar: {
                        sameDay: '[Денес во] LT',
                        nextDay: '[Утре во] LT',
                        nextWeek: '[Во] dddd [во] LT',
                        lastDay: '[Вчера во] LT',
                        lastWeek: function () {
                            switch (this.day()) {
                            case 0:
                            case 3:
                            case 6:
                                return '[Изминатата] dddd [во] LT';
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                                return '[Изминатиот] dddd [во] LT';
                            }
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'за %s',
                        past: 'пред %s',
                        s: 'неколку секунди',
                        ss: '%d секунди',
                        m: 'една минута',
                        mm: '%d минути',
                        h: 'еден час',
                        hh: '%d часа',
                        d: 'еден ден',
                        dd: '%d дена',
                        M: 'еден месец',
                        MM: '%d месеци',
                        y: 'една година',
                        yy: '%d години'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
                    ordinal: function (e) {
                        var t = e % 10, a = e % 100;
                        return 0 === e ? e + '-ев' : 0 === a ? e + '-ен' : a > 10 && a < 20 ? e + '-ти' : 1 === t ? e + '-ви' : 2 === t ? e + '-ри' : 7 === t || 8 === t ? e + '-ми' : e + '-ти';
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ml', {
                    months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
                    monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
                    weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
                    weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
                    longDateFormat: {
                        LT: 'A h:mm -നു',
                        LTS: 'A h:mm:ss -നു',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, A h:mm -നു',
                        LLLL: 'dddd, D MMMM YYYY, A h:mm -നു'
                    },
                    calendar: {
                        sameDay: '[ഇന്ന്] LT',
                        nextDay: '[നാളെ] LT',
                        nextWeek: 'dddd, LT',
                        lastDay: '[ഇന്നലെ] LT',
                        lastWeek: '[കഴിഞ്ഞ] dddd, LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s കഴിഞ്ഞ്',
                        past: '%s മുൻപ്',
                        s: 'അൽപ നിമിഷങ്ങൾ',
                        ss: '%d സെക്കൻഡ്',
                        m: 'ഒരു മിനിറ്റ്',
                        mm: '%d മിനിറ്റ്',
                        h: 'ഒരു മണിക്കൂർ',
                        hh: '%d മണിക്കൂർ',
                        d: 'ഒരു ദിവസം',
                        dd: '%d ദിവസം',
                        M: 'ഒരു മാസം',
                        MM: '%d മാസം',
                        y: 'ഒരു വർഷം',
                        yy: '%d വർഷം'
                    },
                    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), 'രാത്രി' === t && e >= 4 || 'ഉച്ച കഴിഞ്ഞ്' === t || 'വൈകുന്നേരം' === t ? e + 12 : e;
                    },
                    meridiem: function (e, t, a) {
                        return e < 4 ? 'രാത്രി' : e < 12 ? 'രാവിലെ' : e < 17 ? 'ഉച്ച കഴിഞ്ഞ്' : e < 20 ? 'വൈകുന്നേരം' : 'രാത്രി';
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    switch (a) {
                    case 's':
                        return t ? 'хэдхэн секунд' : 'хэдхэн секундын';
                    case 'ss':
                        return e + (t ? ' секунд' : ' секундын');
                    case 'm':
                    case 'mm':
                        return e + (t ? ' минут' : ' минутын');
                    case 'h':
                    case 'hh':
                        return e + (t ? ' цаг' : ' цагийн');
                    case 'd':
                    case 'dd':
                        return e + (t ? ' өдөр' : ' өдрийн');
                    case 'M':
                    case 'MM':
                        return e + (t ? ' сар' : ' сарын');
                    case 'y':
                    case 'yy':
                        return e + (t ? ' жил' : ' жилийн');
                    default:
                        return e;
                    }
                }
                var a = e.defineLocale('mn', {
                    months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
                    monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
                    weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
                    weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'YYYY оны MMMMын D',
                        LLL: 'YYYY оны MMMMын D HH:mm',
                        LLLL: 'dddd, YYYY оны MMMMын D HH:mm'
                    },
                    meridiemParse: /ҮӨ|ҮХ/i,
                    isPM: function (e) {
                        return 'ҮХ' === e;
                    },
                    meridiem: function (e, t, a) {
                        return e < 12 ? 'ҮӨ' : 'ҮХ';
                    },
                    calendar: {
                        sameDay: '[Өнөөдөр] LT',
                        nextDay: '[Маргааш] LT',
                        nextWeek: '[Ирэх] dddd LT',
                        lastDay: '[Өчигдөр] LT',
                        lastWeek: '[Өнгөрсөн] dddd LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s дараа',
                        past: '%s өмнө',
                        s: t,
                        ss: t,
                        m: t,
                        mm: t,
                        h: t,
                        hh: t,
                        d: t,
                        dd: t,
                        M: t,
                        MM: t,
                        y: t,
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'd':
                        case 'D':
                        case 'DDD':
                            return e + ' өдөр';
                        default:
                            return e;
                        }
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = '';
                    if (t)
                        switch (a) {
                        case 's':
                            s = 'काही सेकंद';
                            break;
                        case 'ss':
                            s = '%d सेकंद';
                            break;
                        case 'm':
                            s = 'एक मिनिट';
                            break;
                        case 'mm':
                            s = '%d मिनिटे';
                            break;
                        case 'h':
                            s = 'एक तास';
                            break;
                        case 'hh':
                            s = '%d तास';
                            break;
                        case 'd':
                            s = 'एक दिवस';
                            break;
                        case 'dd':
                            s = '%d दिवस';
                            break;
                        case 'M':
                            s = 'एक महिना';
                            break;
                        case 'MM':
                            s = '%d महिने';
                            break;
                        case 'y':
                            s = 'एक वर्ष';
                            break;
                        case 'yy':
                            s = '%d वर्षे';
                        }
                    else
                        switch (a) {
                        case 's':
                            s = 'काही सेकंदां';
                            break;
                        case 'ss':
                            s = '%d सेकंदां';
                            break;
                        case 'm':
                            s = 'एका मिनिटा';
                            break;
                        case 'mm':
                            s = '%d मिनिटां';
                            break;
                        case 'h':
                            s = 'एका तासा';
                            break;
                        case 'hh':
                            s = '%d तासां';
                            break;
                        case 'd':
                            s = 'एका दिवसा';
                            break;
                        case 'dd':
                            s = '%d दिवसां';
                            break;
                        case 'M':
                            s = 'एका महिन्या';
                            break;
                        case 'MM':
                            s = '%d महिन्यां';
                            break;
                        case 'y':
                            s = 'एका वर्षा';
                            break;
                        case 'yy':
                            s = '%d वर्षां';
                        }
                    return s.replace(/%d/i, e);
                }
                var a = {
                        1: '१',
                        2: '२',
                        3: '३',
                        4: '४',
                        5: '५',
                        6: '६',
                        7: '७',
                        8: '८',
                        9: '९',
                        0: '०'
                    }, n = {
                        '१': '1',
                        '२': '2',
                        '३': '3',
                        '४': '4',
                        '५': '5',
                        '६': '6',
                        '७': '7',
                        '८': '8',
                        '९': '9',
                        '०': '0'
                    }, s = e.defineLocale('mr', {
                        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
                        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
                        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
                        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm वाजता',
                            LTS: 'A h:mm:ss वाजता',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm वाजता',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता'
                        },
                        calendar: {
                            sameDay: '[आज] LT',
                            nextDay: '[उद्या] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[काल] LT',
                            lastWeek: '[मागील] dddd, LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%sमध्ये',
                            past: '%sपूर्वी',
                            s: t,
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: t,
                            dd: t,
                            M: t,
                            MM: t,
                            y: t,
                            yy: t
                        },
                        preparse: function (e) {
                            return e.replace(/[१२३४५६७८९०]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return a[e];
                            });
                        },
                        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'पहाटे' === t || 'सकाळी' === t ? e : 'दुपारी' === t || 'सायंकाळी' === t || 'रात्री' === t ? e >= 12 ? e : e + 12 : void 0;
                        },
                        meridiem: function (e, t, a) {
                            return e >= 0 && e < 6 ? 'पहाटे' : e < 12 ? 'सकाळी' : e < 17 ? 'दुपारी' : e < 20 ? 'सायंकाळी' : 'रात्री';
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return s;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ms', {
                    months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
                    monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
                    weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
                    weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
                    weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
                    longDateFormat: {
                        LT: 'HH.mm',
                        LTS: 'HH.mm.ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY [pukul] HH.mm',
                        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
                    },
                    meridiemParse: /pagi|tengahari|petang|malam/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), 'pagi' === t ? e : 'tengahari' === t ? e >= 11 ? e : e + 12 : 'petang' === t || 'malam' === t ? e + 12 : void 0;
                    },
                    meridiem: function (e, t, a) {
                        return e < 11 ? 'pagi' : e < 15 ? 'tengahari' : e < 19 ? 'petang' : 'malam';
                    },
                    calendar: {
                        sameDay: '[Hari ini pukul] LT',
                        nextDay: '[Esok pukul] LT',
                        nextWeek: 'dddd [pukul] LT',
                        lastDay: '[Kelmarin pukul] LT',
                        lastWeek: 'dddd [lepas pukul] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'dalam %s',
                        past: '%s yang lepas',
                        s: 'beberapa saat',
                        ss: '%d saat',
                        m: 'seminit',
                        mm: '%d minit',
                        h: 'sejam',
                        hh: '%d jam',
                        d: 'sehari',
                        dd: '%d hari',
                        M: 'sebulan',
                        MM: '%d bulan',
                        y: 'setahun',
                        yy: '%d tahun'
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ms-my', {
                    months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
                    monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
                    weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
                    weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
                    weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
                    longDateFormat: {
                        LT: 'HH.mm',
                        LTS: 'HH.mm.ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY [pukul] HH.mm',
                        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
                    },
                    meridiemParse: /pagi|tengahari|petang|malam/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), 'pagi' === t ? e : 'tengahari' === t ? e >= 11 ? e : e + 12 : 'petang' === t || 'malam' === t ? e + 12 : void 0;
                    },
                    meridiem: function (e, t, a) {
                        return e < 11 ? 'pagi' : e < 15 ? 'tengahari' : e < 19 ? 'petang' : 'malam';
                    },
                    calendar: {
                        sameDay: '[Hari ini pukul] LT',
                        nextDay: '[Esok pukul] LT',
                        nextWeek: 'dddd [pukul] LT',
                        lastDay: '[Kelmarin pukul] LT',
                        lastWeek: 'dddd [lepas pukul] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'dalam %s',
                        past: '%s yang lepas',
                        s: 'beberapa saat',
                        ss: '%d saat',
                        m: 'seminit',
                        mm: '%d minit',
                        h: 'sejam',
                        hh: '%d jam',
                        d: 'sehari',
                        dd: '%d hari',
                        M: 'sebulan',
                        MM: '%d bulan',
                        y: 'setahun',
                        yy: '%d tahun'
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('mt', {
                    months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
                    monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
                    weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
                    weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
                    weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Illum fil-]LT',
                        nextDay: '[Għada fil-]LT',
                        nextWeek: 'dddd [fil-]LT',
                        lastDay: '[Il-bieraħ fil-]LT',
                        lastWeek: 'dddd [li għadda] [fil-]LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'f\u2019 %s',
                        past: '%s ilu',
                        s: 'ftit sekondi',
                        ss: '%d sekondi',
                        m: 'minuta',
                        mm: '%d minuti',
                        h: 'siegħa',
                        hh: '%d siegħat',
                        d: 'ġurnata',
                        dd: '%d ġranet',
                        M: 'xahar',
                        MM: '%d xhur',
                        y: 'sena',
                        yy: '%d sni'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}º/,
                    ordinal: '%dº',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '၁',
                        2: '၂',
                        3: '၃',
                        4: '၄',
                        5: '၅',
                        6: '၆',
                        7: '၇',
                        8: '၈',
                        9: '၉',
                        0: '၀'
                    }, a = {
                        '၁': '1',
                        '၂': '2',
                        '၃': '3',
                        '၄': '4',
                        '၅': '5',
                        '၆': '6',
                        '၇': '7',
                        '၈': '8',
                        '၉': '9',
                        '၀': '0'
                    }, n = e.defineLocale('my', {
                        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
                        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
                        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
                        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
                        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[ယနေ.] LT [မှာ]',
                            nextDay: '[မနက်ဖြန်] LT [မှာ]',
                            nextWeek: 'dddd LT [မှာ]',
                            lastDay: '[မနေ.က] LT [မှာ]',
                            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'လာမည့် %s မှာ',
                            past: 'လွန်ခဲ့သော %s က',
                            s: 'စက္ကန်.အနည်းငယ်',
                            ss: '%d စက္ကန့်',
                            m: 'တစ်မိနစ်',
                            mm: '%d မိနစ်',
                            h: 'တစ်နာရီ',
                            hh: '%d နာရီ',
                            d: 'တစ်ရက်',
                            dd: '%d ရက်',
                            M: 'တစ်လ',
                            MM: '%d လ',
                            y: 'တစ်နှစ်',
                            yy: '%d နှစ်'
                        },
                        preparse: function (e) {
                            return e.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('nb', {
                    months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
                    monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
                    weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
                    weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY [kl.] HH:mm',
                        LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
                    },
                    calendar: {
                        sameDay: '[i dag kl.] LT',
                        nextDay: '[i morgen kl.] LT',
                        nextWeek: 'dddd [kl.] LT',
                        lastDay: '[i går kl.] LT',
                        lastWeek: '[forrige] dddd [kl.] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'om %s',
                        past: '%s siden',
                        s: 'noen sekunder',
                        ss: '%d sekunder',
                        m: 'ett minutt',
                        mm: '%d minutter',
                        h: 'en time',
                        hh: '%d timer',
                        d: 'en dag',
                        dd: '%d dager',
                        w: 'en uke',
                        ww: '%d uker',
                        M: 'en måned',
                        MM: '%d måneder',
                        y: 'ett år',
                        yy: '%d år'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '१',
                        2: '२',
                        3: '३',
                        4: '४',
                        5: '५',
                        6: '६',
                        7: '७',
                        8: '८',
                        9: '९',
                        0: '०'
                    }, a = {
                        '१': '1',
                        '२': '2',
                        '३': '3',
                        '४': '4',
                        '५': '5',
                        '६': '6',
                        '७': '7',
                        '८': '8',
                        '९': '9',
                        '०': '0'
                    }, n = e.defineLocale('ne', {
                        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
                        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
                        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
                        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'Aको h:mm बजे',
                            LTS: 'Aको h:mm:ss बजे',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, Aको h:mm बजे',
                            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे'
                        },
                        preparse: function (e) {
                            return e.replace(/[१२३४५६७८९०]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'राति' === t ? e < 4 ? e : e + 12 : 'बिहान' === t ? e : 'दिउँसो' === t ? e >= 10 ? e : e + 12 : 'साँझ' === t ? e + 12 : void 0;
                        },
                        meridiem: function (e, t, a) {
                            return e < 3 ? 'राति' : e < 12 ? 'बिहान' : e < 16 ? 'दिउँसो' : e < 20 ? 'साँझ' : 'राति';
                        },
                        calendar: {
                            sameDay: '[आज] LT',
                            nextDay: '[भोलि] LT',
                            nextWeek: '[आउँदो] dddd[,] LT',
                            lastDay: '[हिजो] LT',
                            lastWeek: '[गएको] dddd[,] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%sमा',
                            past: '%s अगाडि',
                            s: 'केही क्षण',
                            ss: '%d सेकेण्ड',
                            m: 'एक मिनेट',
                            mm: '%d मिनेट',
                            h: 'एक घण्टा',
                            hh: '%d घण्टा',
                            d: 'एक दिन',
                            dd: '%d दिन',
                            M: 'एक महिना',
                            MM: '%d महिना',
                            y: 'एक बर्ष',
                            yy: '%d बर्ष'
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'), a = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'), n = [
                        /^jan/i,
                        /^feb/i,
                        /^maart|mrt.?$/i,
                        /^apr/i,
                        /^mei$/i,
                        /^jun[i.]?$/i,
                        /^jul[i.]?$/i,
                        /^aug/i,
                        /^sep/i,
                        /^okt/i,
                        /^nov/i,
                        /^dec/i
                    ], s = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i, r = e.defineLocale('nl', {
                        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
                        monthsShort: function (e, n) {
                            return e ? /-MMM-/.test(n) ? a[e.month()] : t[e.month()] : t;
                        },
                        monthsRegex: s,
                        monthsShortRegex: s,
                        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
                        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
                        monthsParse: n,
                        longMonthsParse: n,
                        shortMonthsParse: n,
                        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
                        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
                        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD-MM-YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[vandaag om] LT',
                            nextDay: '[morgen om] LT',
                            nextWeek: 'dddd [om] LT',
                            lastDay: '[gisteren om] LT',
                            lastWeek: '[afgelopen] dddd [om] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'over %s',
                            past: '%s geleden',
                            s: 'een paar seconden',
                            ss: '%d seconden',
                            m: 'één minuut',
                            mm: '%d minuten',
                            h: 'één uur',
                            hh: '%d uur',
                            d: 'één dag',
                            dd: '%d dagen',
                            w: 'één week',
                            ww: '%d weken',
                            M: 'één maand',
                            MM: '%d maanden',
                            y: 'één jaar',
                            yy: '%d jaar'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                        ordinal: function (e) {
                            return e + (1 === e || 8 === e || e >= 20 ? 'ste' : 'de');
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'), a = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'), n = [
                        /^jan/i,
                        /^feb/i,
                        /^maart|mrt.?$/i,
                        /^apr/i,
                        /^mei$/i,
                        /^jun[i.]?$/i,
                        /^jul[i.]?$/i,
                        /^aug/i,
                        /^sep/i,
                        /^okt/i,
                        /^nov/i,
                        /^dec/i
                    ], s = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i, r = e.defineLocale('nl-be', {
                        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
                        monthsShort: function (e, n) {
                            return e ? /-MMM-/.test(n) ? a[e.month()] : t[e.month()] : t;
                        },
                        monthsRegex: s,
                        monthsShortRegex: s,
                        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
                        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
                        monthsParse: n,
                        longMonthsParse: n,
                        shortMonthsParse: n,
                        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
                        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
                        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[vandaag om] LT',
                            nextDay: '[morgen om] LT',
                            nextWeek: 'dddd [om] LT',
                            lastDay: '[gisteren om] LT',
                            lastWeek: '[afgelopen] dddd [om] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'over %s',
                            past: '%s geleden',
                            s: 'een paar seconden',
                            ss: '%d seconden',
                            m: 'één minuut',
                            mm: '%d minuten',
                            h: 'één uur',
                            hh: '%d uur',
                            d: 'één dag',
                            dd: '%d dagen',
                            M: 'één maand',
                            MM: '%d maanden',
                            y: 'één jaar',
                            yy: '%d jaar'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                        ordinal: function (e) {
                            return e + (1 === e || 8 === e || e >= 20 ? 'ste' : 'de');
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('nn', {
                    months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
                    monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
                    weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
                    weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY [kl.] H:mm',
                        LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
                    },
                    calendar: {
                        sameDay: '[I dag klokka] LT',
                        nextDay: '[I morgon klokka] LT',
                        nextWeek: 'dddd [klokka] LT',
                        lastDay: '[I går klokka] LT',
                        lastWeek: '[Føregåande] dddd [klokka] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'om %s',
                        past: '%s sidan',
                        s: 'nokre sekund',
                        ss: '%d sekund',
                        m: 'eit minutt',
                        mm: '%d minutt',
                        h: 'ein time',
                        hh: '%d timar',
                        d: 'ein dag',
                        dd: '%d dagar',
                        w: 'ei veke',
                        ww: '%d veker',
                        M: 'ein månad',
                        MM: '%d månader',
                        y: 'eit år',
                        yy: '%d år'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('oc-lnc', {
                    months: {
                        standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split('_'),
                        format: 'de genièr_de febrièr_de març_d\'abril_de mai_de junh_de julhet_d\'agost_de setembre_d\'octòbre_de novembre_de decembre'.split('_'),
                        isFormat: /D[oD]?(\s)+MMMM/
                    },
                    monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split('_'),
                    weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
                    weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM [de] YYYY',
                        ll: 'D MMM YYYY',
                        LLL: 'D MMMM [de] YYYY [a] H:mm',
                        lll: 'D MMM YYYY, H:mm',
                        LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
                        llll: 'ddd D MMM YYYY, H:mm'
                    },
                    calendar: {
                        sameDay: '[uèi a] LT',
                        nextDay: '[deman a] LT',
                        nextWeek: 'dddd [a] LT',
                        lastDay: '[ièr a] LT',
                        lastWeek: 'dddd [passat a] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'd\'aquí %s',
                        past: 'fa %s',
                        s: 'unas segondas',
                        ss: '%d segondas',
                        m: 'una minuta',
                        mm: '%d minutas',
                        h: 'una ora',
                        hh: '%d oras',
                        d: 'un jorn',
                        dd: '%d jorns',
                        M: 'un mes',
                        MM: '%d meses',
                        y: 'un an',
                        yy: '%d ans'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
                    ordinal: function (e, t) {
                        var a = 1 === e ? 'r' : 2 === e ? 'n' : 3 === e ? 'r' : 4 === e ? 't' : 'è';
                        return 'w' !== t && 'W' !== t || (a = 'a'), e + a;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '੧',
                        2: '੨',
                        3: '੩',
                        4: '੪',
                        5: '੫',
                        6: '੬',
                        7: '੭',
                        8: '੮',
                        9: '੯',
                        0: '੦'
                    }, a = {
                        '੧': '1',
                        '੨': '2',
                        '੩': '3',
                        '੪': '4',
                        '੫': '5',
                        '੬': '6',
                        '੭': '7',
                        '੮': '8',
                        '੯': '9',
                        '੦': '0'
                    }, n = e.defineLocale('pa-in', {
                        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
                        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
                        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
                        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
                        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm ਵਜੇ',
                            LTS: 'A h:mm:ss ਵਜੇ',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
                        },
                        calendar: {
                            sameDay: '[ਅਜ] LT',
                            nextDay: '[ਕਲ] LT',
                            nextWeek: '[ਅਗਲਾ] dddd, LT',
                            lastDay: '[ਕਲ] LT',
                            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s ਵਿੱਚ',
                            past: '%s ਪਿਛਲੇ',
                            s: 'ਕੁਝ ਸਕਿੰਟ',
                            ss: '%d ਸਕਿੰਟ',
                            m: 'ਇਕ ਮਿੰਟ',
                            mm: '%d ਮਿੰਟ',
                            h: 'ਇੱਕ ਘੰਟਾ',
                            hh: '%d ਘੰਟੇ',
                            d: 'ਇੱਕ ਦਿਨ',
                            dd: '%d ਦਿਨ',
                            M: 'ਇੱਕ ਮਹੀਨਾ',
                            MM: '%d ਮਹੀਨੇ',
                            y: 'ਇੱਕ ਸਾਲ',
                            yy: '%d ਸਾਲ'
                        },
                        preparse: function (e) {
                            return e.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'ਰਾਤ' === t ? e < 4 ? e : e + 12 : 'ਸਵੇਰ' === t ? e : 'ਦੁਪਹਿਰ' === t ? e >= 10 ? e : e + 12 : 'ਸ਼ਾਮ' === t ? e + 12 : void 0;
                        },
                        meridiem: function (e, t, a) {
                            return e < 4 ? 'ਰਾਤ' : e < 10 ? 'ਸਵੇਰ' : e < 17 ? 'ਦੁਪਹਿਰ' : e < 20 ? 'ਸ਼ਾਮ' : 'ਰਾਤ';
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e) {
                    return e % 10 < 5 && e % 10 > 1 && ~~(e / 10) % 10 !== 1;
                }
                function a(e, a, n) {
                    var s = e + ' ';
                    switch (n) {
                    case 'ss':
                        return s + (t(e) ? 'sekundy' : 'sekund');
                    case 'm':
                        return a ? 'minuta' : 'minutę';
                    case 'mm':
                        return s + (t(e) ? 'minuty' : 'minut');
                    case 'h':
                        return a ? 'godzina' : 'godzinę';
                    case 'hh':
                        return s + (t(e) ? 'godziny' : 'godzin');
                    case 'ww':
                        return s + (t(e) ? 'tygodnie' : 'tygodni');
                    case 'MM':
                        return s + (t(e) ? 'miesiące' : 'miesięcy');
                    case 'yy':
                        return s + (t(e) ? 'lata' : 'lat');
                    }
                }
                var n = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'), s = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_'), r = [
                        /^sty/i,
                        /^lut/i,
                        /^mar/i,
                        /^kwi/i,
                        /^maj/i,
                        /^cze/i,
                        /^lip/i,
                        /^sie/i,
                        /^wrz/i,
                        /^paź/i,
                        /^lis/i,
                        /^gru/i
                    ], i = e.defineLocale('pl', {
                        months: function (e, t) {
                            return e ? /D MMMM/.test(t) ? s[e.month()] : n[e.month()] : n;
                        },
                        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
                        monthsParse: r,
                        longMonthsParse: r,
                        shortMonthsParse: r,
                        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
                        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
                        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[Dziś o] LT',
                            nextDay: '[Jutro o] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                case 0:
                                    return '[W niedzielę o] LT';
                                case 2:
                                    return '[We wtorek o] LT';
                                case 3:
                                    return '[W środę o] LT';
                                case 6:
                                    return '[W sobotę o] LT';
                                default:
                                    return '[W] dddd [o] LT';
                                }
                            },
                            lastDay: '[Wczoraj o] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                case 0:
                                    return '[W zeszłą niedzielę o] LT';
                                case 3:
                                    return '[W zeszłą środę o] LT';
                                case 6:
                                    return '[W zeszłą sobotę o] LT';
                                default:
                                    return '[W zeszły] dddd [o] LT';
                                }
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: '%s temu',
                            s: 'kilka sekund',
                            ss: a,
                            m: a,
                            mm: a,
                            h: a,
                            hh: a,
                            d: '1 dzień',
                            dd: '%d dni',
                            w: 'tydzień',
                            ww: a,
                            M: 'miesiąc',
                            MM: a,
                            y: 'rok',
                            yy: a
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return i;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('pt', {
                    months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
                    monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
                    weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
                    weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
                    weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D [de] MMMM [de] YYYY',
                        LLL: 'D [de] MMMM [de] YYYY HH:mm',
                        LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Hoje às] LT',
                        nextDay: '[Amanhã às] LT',
                        nextWeek: 'dddd [às] LT',
                        lastDay: '[Ontem às] LT',
                        lastWeek: function () {
                            return 0 === this.day() || 6 === this.day() ? '[Último] dddd [às] LT' : '[Última] dddd [às] LT';
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'em %s',
                        past: 'há %s',
                        s: 'segundos',
                        ss: '%d segundos',
                        m: 'um minuto',
                        mm: '%d minutos',
                        h: 'uma hora',
                        hh: '%d horas',
                        d: 'um dia',
                        dd: '%d dias',
                        w: 'uma semana',
                        ww: '%d semanas',
                        M: 'um mês',
                        MM: '%d meses',
                        y: 'um ano',
                        yy: '%d anos'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}º/,
                    ordinal: '%dº',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('pt-br', {
                    months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
                    monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
                    weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
                    weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
                    weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D [de] MMMM [de] YYYY',
                        LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
                        LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
                    },
                    calendar: {
                        sameDay: '[Hoje às] LT',
                        nextDay: '[Amanhã às] LT',
                        nextWeek: 'dddd [às] LT',
                        lastDay: '[Ontem às] LT',
                        lastWeek: function () {
                            return 0 === this.day() || 6 === this.day() ? '[Último] dddd [às] LT' : '[Última] dddd [às] LT';
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'em %s',
                        past: 'há %s',
                        s: 'poucos segundos',
                        ss: '%d segundos',
                        m: 'um minuto',
                        mm: '%d minutos',
                        h: 'uma hora',
                        hh: '%d horas',
                        d: 'um dia',
                        dd: '%d dias',
                        M: 'um mês',
                        MM: '%d meses',
                        y: 'um ano',
                        yy: '%d anos'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}º/,
                    ordinal: '%dº',
                    invalidDate: 'Data inválida'
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a) {
                    var n = {
                            ss: 'secunde',
                            mm: 'minute',
                            hh: 'ore',
                            dd: 'zile',
                            ww: 'săptămâni',
                            MM: 'luni',
                            yy: 'ani'
                        }, s = ' ';
                    return (e % 100 >= 20 || e >= 100 && e % 100 === 0) && (s = ' de '), e + s + n[a];
                }
                var a = e.defineLocale('ro', {
                    months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
                    monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
                    weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
                    weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY H:mm',
                        LLLL: 'dddd, D MMMM YYYY H:mm'
                    },
                    calendar: {
                        sameDay: '[azi la] LT',
                        nextDay: '[mâine la] LT',
                        nextWeek: 'dddd [la] LT',
                        lastDay: '[ieri la] LT',
                        lastWeek: '[fosta] dddd [la] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'peste %s',
                        past: '%s în urmă',
                        s: 'câteva secunde',
                        ss: t,
                        m: 'un minut',
                        mm: t,
                        h: 'o oră',
                        hh: t,
                        d: 'o zi',
                        dd: t,
                        w: 'o săptămână',
                        ww: t,
                        M: 'o lună',
                        MM: t,
                        y: 'un an',
                        yy: t
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t) {
                    var a = e.split('_');
                    return t % 10 === 1 && t % 100 !== 11 ? a[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? a[1] : a[2];
                }
                function a(e, a, n) {
                    var s = {
                        ss: a ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
                        mm: a ? 'минута_минуты_минут' : 'минуту_минуты_минут',
                        hh: 'час_часа_часов',
                        dd: 'день_дня_дней',
                        ww: 'неделя_недели_недель',
                        MM: 'месяц_месяца_месяцев',
                        yy: 'год_года_лет'
                    };
                    return 'm' === n ? a ? 'минута' : 'минуту' : e + ' ' + t(s[n], +e);
                }
                var n = [
                        /^янв/i,
                        /^фев/i,
                        /^мар/i,
                        /^апр/i,
                        /^ма[йя]/i,
                        /^июн/i,
                        /^июл/i,
                        /^авг/i,
                        /^сен/i,
                        /^окт/i,
                        /^ноя/i,
                        /^дек/i
                    ], s = e.defineLocale('ru', {
                        months: {
                            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
                            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
                        },
                        monthsShort: {
                            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
                            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
                        },
                        weekdays: {
                            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
                            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
                            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
                        },
                        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
                        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
                        monthsParse: n,
                        longMonthsParse: n,
                        shortMonthsParse: n,
                        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
                        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
                        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
                        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY г.',
                            LLL: 'D MMMM YYYY г., H:mm',
                            LLLL: 'dddd, D MMMM YYYY г., H:mm'
                        },
                        calendar: {
                            sameDay: '[Сегодня, в] LT',
                            nextDay: '[Завтра, в] LT',
                            lastDay: '[Вчера, в] LT',
                            nextWeek: function (e) {
                                if (e.week() === this.week())
                                    return 2 === this.day() ? '[Во] dddd, [в] LT' : '[В] dddd, [в] LT';
                                switch (this.day()) {
                                case 0:
                                    return '[В следующее] dddd, [в] LT';
                                case 1:
                                case 2:
                                case 4:
                                    return '[В следующий] dddd, [в] LT';
                                case 3:
                                case 5:
                                case 6:
                                    return '[В следующую] dddd, [в] LT';
                                }
                            },
                            lastWeek: function (e) {
                                if (e.week() === this.week())
                                    return 2 === this.day() ? '[Во] dddd, [в] LT' : '[В] dddd, [в] LT';
                                switch (this.day()) {
                                case 0:
                                    return '[В прошлое] dddd, [в] LT';
                                case 1:
                                case 2:
                                case 4:
                                    return '[В прошлый] dddd, [в] LT';
                                case 3:
                                case 5:
                                case 6:
                                    return '[В прошлую] dddd, [в] LT';
                                }
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'через %s',
                            past: '%s назад',
                            s: 'несколько секунд',
                            ss: a,
                            m: a,
                            mm: a,
                            h: 'час',
                            hh: a,
                            d: 'день',
                            dd: a,
                            w: 'неделя',
                            ww: a,
                            M: 'месяц',
                            MM: a,
                            y: 'год',
                            yy: a
                        },
                        meridiemParse: /ночи|утра|дня|вечера/i,
                        isPM: function (e) {
                            return /^(дня|вечера)$/.test(e);
                        },
                        meridiem: function (e, t, a) {
                            return e < 4 ? 'ночи' : e < 12 ? 'утра' : e < 17 ? 'дня' : 'вечера';
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
                        ordinal: function (e, t) {
                            switch (t) {
                            case 'M':
                            case 'd':
                            case 'DDD':
                                return e + '-й';
                            case 'D':
                                return e + '-го';
                            case 'w':
                            case 'W':
                                return e + '-я';
                            default:
                                return e;
                            }
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return s;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = [
                        'جنوري',
                        'فيبروري',
                        'مارچ',
                        'اپريل',
                        'مئي',
                        'جون',
                        'جولاءِ',
                        'آگسٽ',
                        'سيپٽمبر',
                        'آڪٽوبر',
                        'نومبر',
                        'ڊسمبر'
                    ], a = [
                        'آچر',
                        'سومر',
                        'اڱارو',
                        'اربع',
                        'خميس',
                        'جمع',
                        'ڇنڇر'
                    ], n = e.defineLocale('sd', {
                        months: t,
                        monthsShort: t,
                        weekdays: a,
                        weekdaysShort: a,
                        weekdaysMin: a,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd\u060C D MMMM YYYY HH:mm'
                        },
                        meridiemParse: /صبح|شام/,
                        isPM: function (e) {
                            return 'شام' === e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'صبح' : 'شام';
                        },
                        calendar: {
                            sameDay: '[اڄ] LT',
                            nextDay: '[سڀاڻي] LT',
                            nextWeek: 'dddd [اڳين هفتي تي] LT',
                            lastDay: '[ڪالهه] LT',
                            lastWeek: '[گزريل هفتي] dddd [تي] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s پوء',
                            past: '%s اڳ',
                            s: 'چند سيڪنڊ',
                            ss: '%d سيڪنڊ',
                            m: 'هڪ منٽ',
                            mm: '%d منٽ',
                            h: 'هڪ ڪلاڪ',
                            hh: '%d ڪلاڪ',
                            d: 'هڪ ڏينهن',
                            dd: '%d ڏينهن',
                            M: 'هڪ مهينو',
                            MM: '%d مهينا',
                            y: 'هڪ سال',
                            yy: '%d سال'
                        },
                        preparse: function (e) {
                            return e.replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/,/g, '\u060C');
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('se', {
                    months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
                    monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
                    weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
                    weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
                    weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'MMMM D. [b.] YYYY',
                        LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
                        LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
                    },
                    calendar: {
                        sameDay: '[otne ti] LT',
                        nextDay: '[ihttin ti] LT',
                        nextWeek: 'dddd [ti] LT',
                        lastDay: '[ikte ti] LT',
                        lastWeek: '[ovddit] dddd [ti] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s geažes',
                        past: 'maŋit %s',
                        s: 'moadde sekunddat',
                        ss: '%d sekunddat',
                        m: 'okta minuhta',
                        mm: '%d minuhtat',
                        h: 'okta diimmu',
                        hh: '%d diimmut',
                        d: 'okta beaivi',
                        dd: '%d beaivvit',
                        M: 'okta mánnu',
                        MM: '%d mánut',
                        y: 'okta jahki',
                        yy: '%d jagit'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('si', {
                    months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
                    monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
                    weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
                    weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
                    weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'a h:mm',
                        LTS: 'a h:mm:ss',
                        L: 'YYYY/MM/DD',
                        LL: 'YYYY MMMM D',
                        LLL: 'YYYY MMMM D, a h:mm',
                        LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
                    },
                    calendar: {
                        sameDay: '[අද] LT[ට]',
                        nextDay: '[හෙට] LT[ට]',
                        nextWeek: 'dddd LT[ට]',
                        lastDay: '[ඊයේ] LT[ට]',
                        lastWeek: '[පසුගිය] dddd LT[ට]',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%sකින්',
                        past: '%sකට පෙර',
                        s: 'තත්පර කිහිපය',
                        ss: 'තත්පර %d',
                        m: 'මිනිත්තුව',
                        mm: 'මිනිත්තු %d',
                        h: 'පැය',
                        hh: 'පැය %d',
                        d: 'දිනය',
                        dd: 'දින %d',
                        M: 'මාසය',
                        MM: 'මාස %d',
                        y: 'වසර',
                        yy: 'වසර %d'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
                    ordinal: function (e) {
                        return e + ' වැනි';
                    },
                    meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
                    isPM: function (e) {
                        return 'ප.ව.' === e || 'පස් වරු' === e;
                    },
                    meridiem: function (e, t, a) {
                        return e > 11 ? a ? 'ප.ව.' : 'පස් වරු' : a ? 'පෙ.ව.' : 'පෙර වරු';
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e) {
                    return e > 1 && e < 5;
                }
                function a(e, a, n, s) {
                    var r = e + ' ';
                    switch (n) {
                    case 's':
                        return a || s ? 'pár sekúnd' : 'pár sekundami';
                    case 'ss':
                        return a || s ? r + (t(e) ? 'sekundy' : 'sekúnd') : r + 'sekundami';
                    case 'm':
                        return a ? 'minúta' : s ? 'minútu' : 'minútou';
                    case 'mm':
                        return a || s ? r + (t(e) ? 'minúty' : 'minút') : r + 'minútami';
                    case 'h':
                        return a ? 'hodina' : s ? 'hodinu' : 'hodinou';
                    case 'hh':
                        return a || s ? r + (t(e) ? 'hodiny' : 'hodín') : r + 'hodinami';
                    case 'd':
                        return a || s ? 'deň' : 'dňom';
                    case 'dd':
                        return a || s ? r + (t(e) ? 'dni' : 'dní') : r + 'dňami';
                    case 'M':
                        return a || s ? 'mesiac' : 'mesiacom';
                    case 'MM':
                        return a || s ? r + (t(e) ? 'mesiace' : 'mesiacov') : r + 'mesiacmi';
                    case 'y':
                        return a || s ? 'rok' : 'rokom';
                    case 'yy':
                        return a || s ? r + (t(e) ? 'roky' : 'rokov') : r + 'rokmi';
                    }
                }
                var n = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'), s = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_'), r = e.defineLocale('sk', {
                        months: n,
                        monthsShort: s,
                        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
                        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
                        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY H:mm',
                            LLLL: 'dddd D. MMMM YYYY H:mm'
                        },
                        calendar: {
                            sameDay: '[dnes o] LT',
                            nextDay: '[zajtra o] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                case 0:
                                    return '[v nedeľu o] LT';
                                case 1:
                                case 2:
                                    return '[v] dddd [o] LT';
                                case 3:
                                    return '[v stredu o] LT';
                                case 4:
                                    return '[vo štvrtok o] LT';
                                case 5:
                                    return '[v piatok o] LT';
                                case 6:
                                    return '[v sobotu o] LT';
                                }
                            },
                            lastDay: '[včera o] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                case 0:
                                    return '[minulú nedeľu o] LT';
                                case 1:
                                case 2:
                                    return '[minulý] dddd [o] LT';
                                case 3:
                                    return '[minulú stredu o] LT';
                                case 4:
                                case 5:
                                    return '[minulý] dddd [o] LT';
                                case 6:
                                    return '[minulú sobotu o] LT';
                                }
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: 'pred %s',
                            s: a,
                            ss: a,
                            m: a,
                            mm: a,
                            h: a,
                            hh: a,
                            d: a,
                            dd: a,
                            M: a,
                            MM: a,
                            y: a,
                            yy: a
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = e + ' ';
                    switch (a) {
                    case 's':
                        return t || n ? 'nekaj sekund' : 'nekaj sekundami';
                    case 'ss':
                        return s += 1 === e ? t ? 'sekundo' : 'sekundi' : 2 === e ? t || n ? 'sekundi' : 'sekundah' : e < 5 ? t || n ? 'sekunde' : 'sekundah' : 'sekund';
                    case 'm':
                        return t ? 'ena minuta' : 'eno minuto';
                    case 'mm':
                        return s += 1 === e ? t ? 'minuta' : 'minuto' : 2 === e ? t || n ? 'minuti' : 'minutama' : e < 5 ? t || n ? 'minute' : 'minutami' : t || n ? 'minut' : 'minutami';
                    case 'h':
                        return t ? 'ena ura' : 'eno uro';
                    case 'hh':
                        return s += 1 === e ? t ? 'ura' : 'uro' : 2 === e ? t || n ? 'uri' : 'urama' : e < 5 ? t || n ? 'ure' : 'urami' : t || n ? 'ur' : 'urami';
                    case 'd':
                        return t || n ? 'en dan' : 'enim dnem';
                    case 'dd':
                        return s += 1 === e ? t || n ? 'dan' : 'dnem' : 2 === e ? t || n ? 'dni' : 'dnevoma' : t || n ? 'dni' : 'dnevi';
                    case 'M':
                        return t || n ? 'en mesec' : 'enim mesecem';
                    case 'MM':
                        return s += 1 === e ? t || n ? 'mesec' : 'mesecem' : 2 === e ? t || n ? 'meseca' : 'mesecema' : e < 5 ? t || n ? 'mesece' : 'meseci' : t || n ? 'mesecev' : 'meseci';
                    case 'y':
                        return t || n ? 'eno leto' : 'enim letom';
                    case 'yy':
                        return s += 1 === e ? t || n ? 'leto' : 'letom' : 2 === e ? t || n ? 'leti' : 'letoma' : e < 5 ? t || n ? 'leta' : 'leti' : t || n ? 'let' : 'leti';
                    }
                }
                var a = e.defineLocale('sl', {
                    months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
                    monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
                    weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
                    weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD. MM. YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY H:mm',
                        LLLL: 'dddd, D. MMMM YYYY H:mm'
                    },
                    calendar: {
                        sameDay: '[danes ob] LT',
                        nextDay: '[jutri ob] LT',
                        nextWeek: function () {
                            switch (this.day()) {
                            case 0:
                                return '[v] [nedeljo] [ob] LT';
                            case 3:
                                return '[v] [sredo] [ob] LT';
                            case 6:
                                return '[v] [soboto] [ob] LT';
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                                return '[v] dddd [ob] LT';
                            }
                        },
                        lastDay: '[včeraj ob] LT',
                        lastWeek: function () {
                            switch (this.day()) {
                            case 0:
                                return '[prejšnjo] [nedeljo] [ob] LT';
                            case 3:
                                return '[prejšnjo] [sredo] [ob] LT';
                            case 6:
                                return '[prejšnjo] [soboto] [ob] LT';
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                                return '[prejšnji] dddd [ob] LT';
                            }
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'čez %s',
                        past: 'pred %s',
                        s: t,
                        ss: t,
                        m: t,
                        mm: t,
                        h: t,
                        hh: t,
                        d: t,
                        dd: t,
                        M: t,
                        MM: t,
                        y: t,
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('sq', {
                    months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
                    monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
                    weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
                    weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
                    weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
                    weekdaysParseExact: !0,
                    meridiemParse: /PD|MD/,
                    isPM: function (e) {
                        return 'M' === e.charAt(0);
                    },
                    meridiem: function (e, t, a) {
                        return e < 12 ? 'PD' : 'MD';
                    },
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Sot në] LT',
                        nextDay: '[Nesër në] LT',
                        nextWeek: 'dddd [në] LT',
                        lastDay: '[Dje në] LT',
                        lastWeek: 'dddd [e kaluar në] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'në %s',
                        past: '%s më parë',
                        s: 'disa sekonda',
                        ss: '%d sekonda',
                        m: 'një minutë',
                        mm: '%d minuta',
                        h: 'një orë',
                        hh: '%d orë',
                        d: 'një ditë',
                        dd: '%d ditë',
                        M: 'një muaj',
                        MM: '%d muaj',
                        y: 'një vit',
                        yy: '%d vite'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        words: {
                            ss: [
                                'sekunda',
                                'sekunde',
                                'sekundi'
                            ],
                            m: [
                                'jedan minut',
                                'jednog minuta'
                            ],
                            mm: [
                                'minut',
                                'minuta',
                                'minuta'
                            ],
                            h: [
                                'jedan sat',
                                'jednog sata'
                            ],
                            hh: [
                                'sat',
                                'sata',
                                'sati'
                            ],
                            d: [
                                'jedan dan',
                                'jednog dana'
                            ],
                            dd: [
                                'dan',
                                'dana',
                                'dana'
                            ],
                            M: [
                                'jedan mesec',
                                'jednog meseca'
                            ],
                            MM: [
                                'mesec',
                                'meseca',
                                'meseci'
                            ],
                            y: [
                                'jednu godinu',
                                'jedne godine'
                            ],
                            yy: [
                                'godinu',
                                'godine',
                                'godina'
                            ]
                        },
                        correctGrammaticalCase: function (e, t) {
                            return e % 10 >= 1 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? e % 10 === 1 ? t[0] : t[1] : t[2];
                        },
                        translate: function (e, a, n, s) {
                            var r, i = t.words[n];
                            return 1 === n.length ? 'y' === n && a ? 'jedna godina' : s || a ? i[0] : i[1] : (r = t.correctGrammaticalCase(e, i), 'yy' === n && a && 'godinu' === r ? e + ' godina' : e + ' ' + r);
                        }
                    }, a = e.defineLocale('sr', {
                        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
                        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
                        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
                        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'D. M. YYYY.',
                            LL: 'D. MMMM YYYY.',
                            LLL: 'D. MMMM YYYY. H:mm',
                            LLLL: 'dddd, D. MMMM YYYY. H:mm'
                        },
                        calendar: {
                            sameDay: '[danas u] LT',
                            nextDay: '[sutra u] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                case 0:
                                    return '[u] [nedelju] [u] LT';
                                case 3:
                                    return '[u] [sredu] [u] LT';
                                case 6:
                                    return '[u] [subotu] [u] LT';
                                case 1:
                                case 2:
                                case 4:
                                case 5:
                                    return '[u] dddd [u] LT';
                                }
                            },
                            lastDay: '[juče u] LT',
                            lastWeek: function () {
                                var e = [
                                    '[prošle] [nedelje] [u] LT',
                                    '[prošlog] [ponedeljka] [u] LT',
                                    '[prošlog] [utorka] [u] LT',
                                    '[prošle] [srede] [u] LT',
                                    '[prošlog] [četvrtka] [u] LT',
                                    '[prošlog] [petka] [u] LT',
                                    '[prošle] [subote] [u] LT'
                                ];
                                return e[this.day()];
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: 'pre %s',
                            s: 'nekoliko sekundi',
                            ss: t.translate,
                            m: t.translate,
                            mm: t.translate,
                            h: t.translate,
                            hh: t.translate,
                            d: t.translate,
                            dd: t.translate,
                            M: t.translate,
                            MM: t.translate,
                            y: t.translate,
                            yy: t.translate
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: {
                            dow: 1,
                            doy: 7
                        }
                    });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        words: {
                            ss: [
                                'секунда',
                                'секунде',
                                'секунди'
                            ],
                            m: [
                                'један минут',
                                'једног минута'
                            ],
                            mm: [
                                'минут',
                                'минута',
                                'минута'
                            ],
                            h: [
                                'један сат',
                                'једног сата'
                            ],
                            hh: [
                                'сат',
                                'сата',
                                'сати'
                            ],
                            d: [
                                'један дан',
                                'једног дана'
                            ],
                            dd: [
                                'дан',
                                'дана',
                                'дана'
                            ],
                            M: [
                                'један месец',
                                'једног месеца'
                            ],
                            MM: [
                                'месец',
                                'месеца',
                                'месеци'
                            ],
                            y: [
                                'једну годину',
                                'једне године'
                            ],
                            yy: [
                                'годину',
                                'године',
                                'година'
                            ]
                        },
                        correctGrammaticalCase: function (e, t) {
                            return e % 10 >= 1 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? e % 10 === 1 ? t[0] : t[1] : t[2];
                        },
                        translate: function (e, a, n, s) {
                            var r, i = t.words[n];
                            return 1 === n.length ? 'y' === n && a ? 'једна година' : s || a ? i[0] : i[1] : (r = t.correctGrammaticalCase(e, i), 'yy' === n && a && 'годину' === r ? e + ' година' : e + ' ' + r);
                        }
                    }, a = e.defineLocale('sr-cyrl', {
                        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
                        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
                        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
                        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'D. M. YYYY.',
                            LL: 'D. MMMM YYYY.',
                            LLL: 'D. MMMM YYYY. H:mm',
                            LLLL: 'dddd, D. MMMM YYYY. H:mm'
                        },
                        calendar: {
                            sameDay: '[данас у] LT',
                            nextDay: '[сутра у] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                case 0:
                                    return '[у] [недељу] [у] LT';
                                case 3:
                                    return '[у] [среду] [у] LT';
                                case 6:
                                    return '[у] [суботу] [у] LT';
                                case 1:
                                case 2:
                                case 4:
                                case 5:
                                    return '[у] dddd [у] LT';
                                }
                            },
                            lastDay: '[јуче у] LT',
                            lastWeek: function () {
                                var e = [
                                    '[прошле] [недеље] [у] LT',
                                    '[прошлог] [понедељка] [у] LT',
                                    '[прошлог] [уторка] [у] LT',
                                    '[прошле] [среде] [у] LT',
                                    '[прошлог] [четвртка] [у] LT',
                                    '[прошлог] [петка] [у] LT',
                                    '[прошле] [суботе] [у] LT'
                                ];
                                return e[this.day()];
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'за %s',
                            past: 'пре %s',
                            s: 'неколико секунди',
                            ss: t.translate,
                            m: t.translate,
                            mm: t.translate,
                            h: t.translate,
                            hh: t.translate,
                            d: t.translate,
                            dd: t.translate,
                            M: t.translate,
                            MM: t.translate,
                            y: t.translate,
                            yy: t.translate
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: {
                            dow: 1,
                            doy: 7
                        }
                    });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ss', {
                    months: 'Bhimbidvwane_Indlovana_Indlov\'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni'.split('_'),
                    monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
                    weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
                    weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
                    weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'h:mm A',
                        LTS: 'h:mm:ss A',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY h:mm A',
                        LLLL: 'dddd, D MMMM YYYY h:mm A'
                    },
                    calendar: {
                        sameDay: '[Namuhla nga] LT',
                        nextDay: '[Kusasa nga] LT',
                        nextWeek: 'dddd [nga] LT',
                        lastDay: '[Itolo nga] LT',
                        lastWeek: 'dddd [leliphelile] [nga] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'nga %s',
                        past: 'wenteka nga %s',
                        s: 'emizuzwana lomcane',
                        ss: '%d mzuzwana',
                        m: 'umzuzu',
                        mm: '%d emizuzu',
                        h: 'lihora',
                        hh: '%d emahora',
                        d: 'lilanga',
                        dd: '%d emalanga',
                        M: 'inyanga',
                        MM: '%d tinyanga',
                        y: 'umnyaka',
                        yy: '%d iminyaka'
                    },
                    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
                    meridiem: function (e, t, a) {
                        return e < 11 ? 'ekuseni' : e < 15 ? 'emini' : e < 19 ? 'entsambama' : 'ebusuku';
                    },
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), 'ekuseni' === t ? e : 'emini' === t ? e >= 11 ? e : e + 12 : 'entsambama' === t || 'ebusuku' === t ? 0 === e ? 0 : e + 12 : void 0;
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}/,
                    ordinal: '%d',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('sv', {
                    months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
                    monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
                    weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
                    weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
                    weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY [kl.] HH:mm',
                        LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
                        lll: 'D MMM YYYY HH:mm',
                        llll: 'ddd D MMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Idag] LT',
                        nextDay: '[Imorgon] LT',
                        lastDay: '[Igår] LT',
                        nextWeek: '[På] dddd LT',
                        lastWeek: '[I] dddd[s] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'om %s',
                        past: 'för %s sedan',
                        s: 'några sekunder',
                        ss: '%d sekunder',
                        m: 'en minut',
                        mm: '%d minuter',
                        h: 'en timme',
                        hh: '%d timmar',
                        d: 'en dag',
                        dd: '%d dagar',
                        M: 'en månad',
                        MM: '%d månader',
                        y: 'ett år',
                        yy: '%d år'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? ':e' : 1 === t ? ':a' : 2 === t ? ':a' : ':e';
                        return e + a;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('sw', {
                    months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
                    monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
                    weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
                    weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
                    weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'hh:mm A',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[leo saa] LT',
                        nextDay: '[kesho saa] LT',
                        nextWeek: '[wiki ijayo] dddd [saat] LT',
                        lastDay: '[jana] LT',
                        lastWeek: '[wiki iliyopita] dddd [saat] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s baadaye',
                        past: 'tokea %s',
                        s: 'hivi punde',
                        ss: 'sekunde %d',
                        m: 'dakika moja',
                        mm: 'dakika %d',
                        h: 'saa limoja',
                        hh: 'masaa %d',
                        d: 'siku moja',
                        dd: 'siku %d',
                        M: 'mwezi mmoja',
                        MM: 'miezi %d',
                        y: 'mwaka mmoja',
                        yy: 'miaka %d'
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '௧',
                        2: '௨',
                        3: '௩',
                        4: '௪',
                        5: '௫',
                        6: '௬',
                        7: '௭',
                        8: '௮',
                        9: '௯',
                        0: '௦'
                    }, a = {
                        '௧': '1',
                        '௨': '2',
                        '௩': '3',
                        '௪': '4',
                        '௫': '5',
                        '௬': '6',
                        '௭': '7',
                        '௮': '8',
                        '௯': '9',
                        '௦': '0'
                    }, n = e.defineLocale('ta', {
                        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
                        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
                        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
                        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
                        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, HH:mm',
                            LLLL: 'dddd, D MMMM YYYY, HH:mm'
                        },
                        calendar: {
                            sameDay: '[இன்று] LT',
                            nextDay: '[நாளை] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[நேற்று] LT',
                            lastWeek: '[கடந்த வாரம்] dddd, LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s இல்',
                            past: '%s முன்',
                            s: 'ஒரு சில விநாடிகள்',
                            ss: '%d விநாடிகள்',
                            m: 'ஒரு நிமிடம்',
                            mm: '%d நிமிடங்கள்',
                            h: 'ஒரு மணி நேரம்',
                            hh: '%d மணி நேரம்',
                            d: 'ஒரு நாள்',
                            dd: '%d நாட்கள்',
                            M: 'ஒரு மாதம்',
                            MM: '%d மாதங்கள்',
                            y: 'ஒரு வருடம்',
                            yy: '%d ஆண்டுகள்'
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}வது/,
                        ordinal: function (e) {
                            return e + 'வது';
                        },
                        preparse: function (e) {
                            return e.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (e) {
                                return a[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
                        meridiem: function (e, t, a) {
                            return e < 2 ? ' யாமம்' : e < 6 ? ' வைகறை' : e < 10 ? ' காலை' : e < 14 ? ' நண்பகல்' : e < 18 ? ' எற்பாடு' : e < 22 ? ' மாலை' : ' யாமம்';
                        },
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'யாமம்' === t ? e < 2 ? e : e + 12 : 'வைகறை' === t || 'காலை' === t ? e : 'நண்பகல்' === t && e >= 10 ? e : e + 12;
                        },
                        week: {
                            dow: 0,
                            doy: 6
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('te', {
                    months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
                    monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
                    weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
                    weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
                    longDateFormat: {
                        LT: 'A h:mm',
                        LTS: 'A h:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, A h:mm',
                        LLLL: 'dddd, D MMMM YYYY, A h:mm'
                    },
                    calendar: {
                        sameDay: '[నేడు] LT',
                        nextDay: '[రేపు] LT',
                        nextWeek: 'dddd, LT',
                        lastDay: '[నిన్న] LT',
                        lastWeek: '[గత] dddd, LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s లో',
                        past: '%s క్రితం',
                        s: 'కొన్ని క్షణాలు',
                        ss: '%d సెకన్లు',
                        m: 'ఒక నిమిషం',
                        mm: '%d నిమిషాలు',
                        h: 'ఒక గంట',
                        hh: '%d గంటలు',
                        d: 'ఒక రోజు',
                        dd: '%d రోజులు',
                        M: 'ఒక నెల',
                        MM: '%d నెలలు',
                        y: 'ఒక సంవత్సరం',
                        yy: '%d సంవత్సరాలు'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}వ/,
                    ordinal: '%dవ',
                    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), 'రాత్రి' === t ? e < 4 ? e : e + 12 : 'ఉదయం' === t ? e : 'మధ్యాహ్నం' === t ? e >= 10 ? e : e + 12 : 'సాయంత్రం' === t ? e + 12 : void 0;
                    },
                    meridiem: function (e, t, a) {
                        return e < 4 ? 'రాత్రి' : e < 10 ? 'ఉదయం' : e < 17 ? 'మధ్యాహ్నం' : e < 20 ? 'సాయంత్రం' : 'రాత్రి';
                    },
                    week: {
                        dow: 0,
                        doy: 6
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('tet', {
                    months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
                    monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
                    weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
                    weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
                    weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Ohin iha] LT',
                        nextDay: '[Aban iha] LT',
                        nextWeek: 'dddd [iha] LT',
                        lastDay: '[Horiseik iha] LT',
                        lastWeek: 'dddd [semana kotuk] [iha] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'iha %s',
                        past: '%s liuba',
                        s: 'segundu balun',
                        ss: 'segundu %d',
                        m: 'minutu ida',
                        mm: 'minutu %d',
                        h: 'oras ida',
                        hh: 'oras %d',
                        d: 'loron ida',
                        dd: 'loron %d',
                        M: 'fulan ida',
                        MM: 'fulan %d',
                        y: 'tinan ida',
                        yy: 'tinan %d'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                        return e + a;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        0: '-ум',
                        1: '-ум',
                        2: '-юм',
                        3: '-юм',
                        4: '-ум',
                        5: '-ум',
                        6: '-ум',
                        7: '-ум',
                        8: '-ум',
                        9: '-ум',
                        10: '-ум',
                        12: '-ум',
                        13: '-ум',
                        20: '-ум',
                        30: '-юм',
                        40: '-ум',
                        50: '-ум',
                        60: '-ум',
                        70: '-ум',
                        80: '-ум',
                        90: '-ум',
                        100: '-ум'
                    }, a = e.defineLocale('tg', {
                        months: {
                            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split('_'),
                            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_')
                        },
                        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
                        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
                        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
                        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[Имрӯз соати] LT',
                            nextDay: '[Фардо соати] LT',
                            lastDay: '[Дирӯз соати] LT',
                            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
                            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'баъди %s',
                            past: '%s пеш',
                            s: 'якчанд сония',
                            m: 'як дақиқа',
                            mm: '%d дақиқа',
                            h: 'як соат',
                            hh: '%d соат',
                            d: 'як рӯз',
                            dd: '%d рӯз',
                            M: 'як моҳ',
                            MM: '%d моҳ',
                            y: 'як сол',
                            yy: '%d сол'
                        },
                        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
                        meridiemHour: function (e, t) {
                            return 12 === e && (e = 0), 'шаб' === t ? e < 4 ? e : e + 12 : 'субҳ' === t ? e : 'рӯз' === t ? e >= 11 ? e : e + 12 : 'бегоҳ' === t ? e + 12 : void 0;
                        },
                        meridiem: function (e, t, a) {
                            return e < 4 ? 'шаб' : e < 11 ? 'субҳ' : e < 16 ? 'рӯз' : e < 19 ? 'бегоҳ' : 'шаб';
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
                        ordinal: function (e) {
                            var a = e % 10, n = e >= 100 ? 100 : null;
                            return e + (t[e] || t[a] || t[n]);
                        },
                        week: {
                            dow: 1,
                            doy: 7
                        }
                    });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('th', {
                    months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
                    monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
                    weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'),
                    weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY เวลา H:mm',
                        LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm'
                    },
                    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
                    isPM: function (e) {
                        return 'หลังเที่ยง' === e;
                    },
                    meridiem: function (e, t, a) {
                        return e < 12 ? 'ก่อนเที่ยง' : 'หลังเที่ยง';
                    },
                    calendar: {
                        sameDay: '[วันนี้ เวลา] LT',
                        nextDay: '[พรุ่งนี้ เวลา] LT',
                        nextWeek: 'dddd[หน้า เวลา] LT',
                        lastDay: '[เมื่อวานนี้ เวลา] LT',
                        lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'อีก %s',
                        past: '%sที่แล้ว',
                        s: 'ไม่กี่วินาที',
                        ss: '%d วินาที',
                        m: '1 นาที',
                        mm: '%d นาที',
                        h: '1 ชั่วโมง',
                        hh: '%d ชั่วโมง',
                        d: '1 วัน',
                        dd: '%d วัน',
                        w: '1 สัปดาห์',
                        ww: '%d สัปดาห์',
                        M: '1 เดือน',
                        MM: '%d เดือน',
                        y: '1 ปี',
                        yy: '%d ปี'
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '\'inji',
                        5: '\'inji',
                        8: '\'inji',
                        70: '\'inji',
                        80: '\'inji',
                        2: '\'nji',
                        7: '\'nji',
                        20: '\'nji',
                        50: '\'nji',
                        3: '\'ünji',
                        4: '\'ünji',
                        100: '\'ünji',
                        6: '\'njy',
                        9: '\'unjy',
                        10: '\'unjy',
                        30: '\'unjy',
                        60: '\'ynjy',
                        90: '\'ynjy'
                    }, a = e.defineLocale('tk', {
                        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split('_'),
                        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
                        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split('_'),
                        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
                        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[bugün sagat] LT',
                            nextDay: '[ertir sagat] LT',
                            nextWeek: '[indiki] dddd [sagat] LT',
                            lastDay: '[düýn] LT',
                            lastWeek: '[geçen] dddd [sagat] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s soň',
                            past: '%s öň',
                            s: 'birnäçe sekunt',
                            m: 'bir minut',
                            mm: '%d minut',
                            h: 'bir sagat',
                            hh: '%d sagat',
                            d: 'bir gün',
                            dd: '%d gün',
                            M: 'bir aý',
                            MM: '%d aý',
                            y: 'bir ýyl',
                            yy: '%d ýyl'
                        },
                        ordinal: function (e, a) {
                            switch (a) {
                            case 'd':
                            case 'D':
                            case 'Do':
                            case 'DD':
                                return e;
                            default:
                                if (0 === e)
                                    return e + '\'unjy';
                                var n = e % 10, s = e % 100 - n, r = e >= 100 ? 100 : null;
                                return e + (t[n] || t[s] || t[r]);
                            }
                        },
                        week: {
                            dow: 1,
                            doy: 7
                        }
                    });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('tl-ph', {
                    months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
                    monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
                    weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
                    weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
                    weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'MM/D/YYYY',
                        LL: 'MMMM D, YYYY',
                        LLL: 'MMMM D, YYYY HH:mm',
                        LLLL: 'dddd, MMMM DD, YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: 'LT [ngayong araw]',
                        nextDay: '[Bukas ng] LT',
                        nextWeek: 'LT [sa susunod na] dddd',
                        lastDay: 'LT [kahapon]',
                        lastWeek: 'LT [noong nakaraang] dddd',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'sa loob ng %s',
                        past: '%s ang nakalipas',
                        s: 'ilang segundo',
                        ss: '%d segundo',
                        m: 'isang minuto',
                        mm: '%d minuto',
                        h: 'isang oras',
                        hh: '%d oras',
                        d: 'isang araw',
                        dd: '%d araw',
                        M: 'isang buwan',
                        MM: '%d buwan',
                        y: 'isang taon',
                        yy: '%d taon'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}/,
                    ordinal: function (e) {
                        return e;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e) {
                    var t = e;
                    return t = e.indexOf('jaj') !== -1 ? t.slice(0, -3) + 'leS' : e.indexOf('jar') !== -1 ? t.slice(0, -3) + 'waQ' : e.indexOf('DIS') !== -1 ? t.slice(0, -3) + 'nem' : t + ' pIq';
                }
                function a(e) {
                    var t = e;
                    return t = e.indexOf('jaj') !== -1 ? t.slice(0, -3) + 'Hu\u2019' : e.indexOf('jar') !== -1 ? t.slice(0, -3) + 'wen' : e.indexOf('DIS') !== -1 ? t.slice(0, -3) + 'ben' : t + ' ret';
                }
                function n(e, t, a, n) {
                    var r = s(e);
                    switch (a) {
                    case 'ss':
                        return r + ' lup';
                    case 'mm':
                        return r + ' tup';
                    case 'hh':
                        return r + ' rep';
                    case 'dd':
                        return r + ' jaj';
                    case 'MM':
                        return r + ' jar';
                    case 'yy':
                        return r + ' DIS';
                    }
                }
                function s(e) {
                    var t = Math.floor(e % 1000 / 100), a = Math.floor(e % 100 / 10), n = e % 10, s = '';
                    return t > 0 && (s += r[t] + 'vatlh'), a > 0 && (s += ('' !== s ? ' ' : '') + r[a] + 'maH'), n > 0 && (s += ('' !== s ? ' ' : '') + r[n]), '' === s ? 'pagh' : s;
                }
                var r = 'pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_'), i = e.defineLocale('tlh', {
                        months: 'tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019'.split('_'),
                        monthsShort: 'jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
                        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
                        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[DaHjaj] LT',
                            nextDay: '[wa\u2019leS] LT',
                            nextWeek: 'LLL',
                            lastDay: '[wa\u2019Hu\u2019] LT',
                            lastWeek: 'LLL',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: t,
                            past: a,
                            s: 'puS lup',
                            ss: n,
                            m: 'wa\u2019 tup',
                            mm: n,
                            h: 'wa\u2019 rep',
                            hh: n,
                            d: 'wa\u2019 jaj',
                            dd: n,
                            M: 'wa\u2019 jar',
                            MM: n,
                            y: 'wa\u2019 DIS',
                            yy: n
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return i;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = {
                        1: '\'inci',
                        5: '\'inci',
                        8: '\'inci',
                        70: '\'inci',
                        80: '\'inci',
                        2: '\'nci',
                        7: '\'nci',
                        20: '\'nci',
                        50: '\'nci',
                        3: '\'üncü',
                        4: '\'üncü',
                        100: '\'üncü',
                        6: '\'ncı',
                        9: '\'uncu',
                        10: '\'uncu',
                        30: '\'uncu',
                        60: '\'ıncı',
                        90: '\'ıncı'
                    }, a = e.defineLocale('tr', {
                        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
                        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
                        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
                        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
                        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
                        meridiem: function (e, t, a) {
                            return e < 12 ? a ? 'öö' : 'ÖÖ' : a ? 'ös' : 'ÖS';
                        },
                        meridiemParse: /öö|ÖÖ|ös|ÖS/,
                        isPM: function (e) {
                            return 'ös' === e || 'ÖS' === e;
                        },
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm'
                        },
                        calendar: {
                            sameDay: '[bugün saat] LT',
                            nextDay: '[yarın saat] LT',
                            nextWeek: '[gelecek] dddd [saat] LT',
                            lastDay: '[dün] LT',
                            lastWeek: '[geçen] dddd [saat] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s sonra',
                            past: '%s önce',
                            s: 'birkaç saniye',
                            ss: '%d saniye',
                            m: 'bir dakika',
                            mm: '%d dakika',
                            h: 'bir saat',
                            hh: '%d saat',
                            d: 'bir gün',
                            dd: '%d gün',
                            w: 'bir hafta',
                            ww: '%d hafta',
                            M: 'bir ay',
                            MM: '%d ay',
                            y: 'bir yıl',
                            yy: '%d yıl'
                        },
                        ordinal: function (e, a) {
                            switch (a) {
                            case 'd':
                            case 'D':
                            case 'Do':
                            case 'DD':
                                return e;
                            default:
                                if (0 === e)
                                    return e + '\'ıncı';
                                var n = e % 10, s = e % 100 - n, r = e >= 100 ? 100 : null;
                                return e + (t[n] || t[s] || t[r]);
                            }
                        },
                        week: {
                            dow: 1,
                            doy: 7
                        }
                    });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t, a, n) {
                    var s = {
                        s: [
                            'viensas secunds',
                            '\'iensas secunds'
                        ],
                        ss: [
                            e + ' secunds',
                            '' + e + ' secunds'
                        ],
                        m: [
                            '\'n míut',
                            '\'iens míut'
                        ],
                        mm: [
                            e + ' míuts',
                            '' + e + ' míuts'
                        ],
                        h: [
                            '\'n þora',
                            '\'iensa þora'
                        ],
                        hh: [
                            e + ' þoras',
                            '' + e + ' þoras'
                        ],
                        d: [
                            '\'n ziua',
                            '\'iensa ziua'
                        ],
                        dd: [
                            e + ' ziuas',
                            '' + e + ' ziuas'
                        ],
                        M: [
                            '\'n mes',
                            '\'iens mes'
                        ],
                        MM: [
                            e + ' mesen',
                            '' + e + ' mesen'
                        ],
                        y: [
                            '\'n ar',
                            '\'iens ar'
                        ],
                        yy: [
                            e + ' ars',
                            '' + e + ' ars'
                        ]
                    };
                    return n ? s[a][0] : t ? s[a][0] : s[a][1];
                }
                var a = e.defineLocale('tzl', {
                    months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
                    monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
                    weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
                    weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
                    weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
                    longDateFormat: {
                        LT: 'HH.mm',
                        LTS: 'HH.mm.ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM [dallas] YYYY',
                        LLL: 'D. MMMM [dallas] YYYY HH.mm',
                        LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
                    },
                    meridiemParse: /d\'o|d\'a/i,
                    isPM: function (e) {
                        return 'd\'o' === e.toLowerCase();
                    },
                    meridiem: function (e, t, a) {
                        return e > 11 ? a ? 'd\'o' : 'D\'O' : a ? 'd\'a' : 'D\'A';
                    },
                    calendar: {
                        sameDay: '[oxhi à] LT',
                        nextDay: '[demà à] LT',
                        nextWeek: 'dddd [à] LT',
                        lastDay: '[ieiri à] LT',
                        lastWeek: '[sür el] dddd [lasteu à] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'osprei %s',
                        past: 'ja%s',
                        s: t,
                        ss: t,
                        m: t,
                        mm: t,
                        h: t,
                        hh: t,
                        d: t,
                        dd: t,
                        M: t,
                        MM: t,
                        y: t,
                        yy: t
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}\./,
                    ordinal: '%d.',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return a;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('tzm', {
                    months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
                    monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
                    weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
                    weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
                    weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
                        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
                        nextWeek: 'dddd [ⴴ] LT',
                        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
                        lastWeek: 'dddd [ⴴ] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
                        past: 'ⵢⴰⵏ %s',
                        s: 'ⵉⵎⵉⴽ',
                        ss: '%d ⵉⵎⵉⴽ',
                        m: 'ⵎⵉⵏⵓⴺ',
                        mm: '%d ⵎⵉⵏⵓⴺ',
                        h: 'ⵙⴰⵄⴰ',
                        hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
                        d: 'ⴰⵙⵙ',
                        dd: '%d oⵙⵙⴰⵏ',
                        M: 'ⴰⵢoⵓⵔ',
                        MM: '%d ⵉⵢⵢⵉⵔⵏ',
                        y: 'ⴰⵙⴳⴰⵙ',
                        yy: '%d ⵉⵙⴳⴰⵙⵏ'
                    },
                    week: {
                        dow: 6,
                        doy: 12
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('tzm-latn', {
                    months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
                    monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
                    weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
                    weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
                    weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[asdkh g] LT',
                        nextDay: '[aska g] LT',
                        nextWeek: 'dddd [g] LT',
                        lastDay: '[assant g] LT',
                        lastWeek: 'dddd [g] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'dadkh s yan %s',
                        past: 'yan %s',
                        s: 'imik',
                        ss: '%d imik',
                        m: 'minuḍ',
                        mm: '%d minuḍ',
                        h: 'saɛa',
                        hh: '%d tassaɛin',
                        d: 'ass',
                        dd: '%d ossan',
                        M: 'ayowr',
                        MM: '%d iyyirn',
                        y: 'asgas',
                        yy: '%d isgasn'
                    },
                    week: {
                        dow: 6,
                        doy: 12
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('ug-cn', {
                    months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split('_'),
                    monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split('_'),
                    weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split('_'),
                    weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
                    weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
                        LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى\u060C HH:mm',
                        LLLL: 'dddd\u060C YYYY-يىلىM-ئاينىڭD-كۈنى\u060C HH:mm'
                    },
                    meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), 'يېرىم كېچە' === t || 'سەھەر' === t || 'چۈشتىن بۇرۇن' === t ? e : 'چۈشتىن كېيىن' === t || 'كەچ' === t ? e + 12 : e >= 11 ? e : e + 12;
                    },
                    meridiem: function (e, t, a) {
                        var n = 100 * e + t;
                        return n < 600 ? 'يېرىم كېچە' : n < 900 ? 'سەھەر' : n < 1130 ? 'چۈشتىن بۇرۇن' : n < 1230 ? 'چۈش' : n < 1800 ? 'چۈشتىن كېيىن' : 'كەچ';
                    },
                    calendar: {
                        sameDay: '[بۈگۈن سائەت] LT',
                        nextDay: '[ئەتە سائەت] LT',
                        nextWeek: '[كېلەركى] dddd [سائەت] LT',
                        lastDay: '[تۆنۈگۈن] LT',
                        lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s كېيىن',
                        past: '%s بۇرۇن',
                        s: 'نەچچە سېكونت',
                        ss: '%d سېكونت',
                        m: 'بىر مىنۇت',
                        mm: '%d مىنۇت',
                        h: 'بىر سائەت',
                        hh: '%d سائەت',
                        d: 'بىر كۈن',
                        dd: '%d كۈن',
                        M: 'بىر ئاي',
                        MM: '%d ئاي',
                        y: 'بىر يىل',
                        yy: '%d يىل'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'd':
                        case 'D':
                        case 'DDD':
                            return e + '-كۈنى';
                        case 'w':
                        case 'W':
                            return e + '-ھەپتە';
                        default:
                            return e;
                        }
                    },
                    preparse: function (e) {
                        return e.replace(/،/g, ',');
                    },
                    postformat: function (e) {
                        return e.replace(/,/g, '\u060C');
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                function t(e, t) {
                    var a = e.split('_');
                    return t % 10 === 1 && t % 100 !== 11 ? a[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? a[1] : a[2];
                }
                function a(e, a, n) {
                    var s = {
                        ss: a ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
                        mm: a ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
                        hh: a ? 'година_години_годин' : 'годину_години_годин',
                        dd: 'день_дні_днів',
                        MM: 'місяць_місяці_місяців',
                        yy: 'рік_роки_років'
                    };
                    return 'm' === n ? a ? 'хвилина' : 'хвилину' : 'h' === n ? a ? 'година' : 'годину' : e + ' ' + t(s[n], +e);
                }
                function n(e, t) {
                    var a, n = {
                            nominative: 'неділя_понеділок_вівторок_середа_четвер_п\u2019ятниця_субота'.split('_'),
                            accusative: 'неділю_понеділок_вівторок_середу_четвер_п\u2019ятницю_суботу'.split('_'),
                            genitive: 'неділі_понеділка_вівторка_середи_четверга_п\u2019ятниці_суботи'.split('_')
                        };
                    return e === !0 ? n.nominative.slice(1, 7).concat(n.nominative.slice(0, 1)) : e ? (a = /(\[[ВвУу]\]) ?dddd/.test(t) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(t) ? 'genitive' : 'nominative', n[a][e.day()]) : n.nominative;
                }
                function s(e) {
                    return function () {
                        return e + 'о' + (11 === this.hours() ? 'б' : '') + '] LT';
                    };
                }
                var r = e.defineLocale('uk', {
                    months: {
                        format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
                        standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
                    },
                    monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
                    weekdays: n,
                    weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
                    weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY р.',
                        LLL: 'D MMMM YYYY р., HH:mm',
                        LLLL: 'dddd, D MMMM YYYY р., HH:mm'
                    },
                    calendar: {
                        sameDay: s('[Сьогодні '),
                        nextDay: s('[Завтра '),
                        lastDay: s('[Вчора '),
                        nextWeek: s('[У] dddd ['),
                        lastWeek: function () {
                            switch (this.day()) {
                            case 0:
                            case 3:
                            case 5:
                            case 6:
                                return s('[Минулої] dddd [').call(this);
                            case 1:
                            case 2:
                            case 4:
                                return s('[Минулого] dddd [').call(this);
                            }
                        },
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'за %s',
                        past: '%s тому',
                        s: 'декілька секунд',
                        ss: a,
                        m: a,
                        mm: a,
                        h: 'годину',
                        hh: a,
                        d: 'день',
                        dd: a,
                        M: 'місяць',
                        MM: a,
                        y: 'рік',
                        yy: a
                    },
                    meridiemParse: /ночі|ранку|дня|вечора/,
                    isPM: function (e) {
                        return /^(дня|вечора)$/.test(e);
                    },
                    meridiem: function (e, t, a) {
                        return e < 4 ? 'ночі' : e < 12 ? 'ранку' : e < 17 ? 'дня' : 'вечора';
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'M':
                        case 'd':
                        case 'DDD':
                        case 'w':
                        case 'W':
                            return e + '-й';
                        case 'D':
                            return e + '-го';
                        default:
                            return e;
                        }
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return r;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = [
                        'جنوری',
                        'فروری',
                        'مارچ',
                        'اپریل',
                        'مئی',
                        'جون',
                        'جولائی',
                        'اگست',
                        'ستمبر',
                        'اکتوبر',
                        'نومبر',
                        'دسمبر'
                    ], a = [
                        'اتوار',
                        'پیر',
                        'منگل',
                        'بدھ',
                        'جمعرات',
                        'جمعہ',
                        'ہفتہ'
                    ], n = e.defineLocale('ur', {
                        months: t,
                        monthsShort: t,
                        weekdays: a,
                        weekdaysShort: a,
                        weekdaysMin: a,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd\u060C D MMMM YYYY HH:mm'
                        },
                        meridiemParse: /صبح|شام/,
                        isPM: function (e) {
                            return 'شام' === e;
                        },
                        meridiem: function (e, t, a) {
                            return e < 12 ? 'صبح' : 'شام';
                        },
                        calendar: {
                            sameDay: '[آج بوقت] LT',
                            nextDay: '[کل بوقت] LT',
                            nextWeek: 'dddd [بوقت] LT',
                            lastDay: '[گذشتہ روز بوقت] LT',
                            lastWeek: '[گذشتہ] dddd [بوقت] LT',
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: '%s بعد',
                            past: '%s قبل',
                            s: 'چند سیکنڈ',
                            ss: '%d سیکنڈ',
                            m: 'ایک منٹ',
                            mm: '%d منٹ',
                            h: 'ایک گھنٹہ',
                            hh: '%d گھنٹے',
                            d: 'ایک دن',
                            dd: '%d دن',
                            M: 'ایک ماہ',
                            MM: '%d ماہ',
                            y: 'ایک سال',
                            yy: '%d سال'
                        },
                        preparse: function (e) {
                            return e.replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/,/g, '\u060C');
                        },
                        week: {
                            dow: 1,
                            doy: 4
                        }
                    });
                return n;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('uz', {
                    months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
                    monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
                    weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
                    weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
                    weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'D MMMM YYYY, dddd HH:mm'
                    },
                    calendar: {
                        sameDay: '[Бугун соат] LT [да]',
                        nextDay: '[Эртага] LT [да]',
                        nextWeek: 'dddd [куни соат] LT [да]',
                        lastDay: '[Кеча соат] LT [да]',
                        lastWeek: '[Утган] dddd [куни соат] LT [да]',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'Якин %s ичида',
                        past: 'Бир неча %s олдин',
                        s: 'фурсат',
                        ss: '%d фурсат',
                        m: 'бир дакика',
                        mm: '%d дакика',
                        h: 'бир соат',
                        hh: '%d соат',
                        d: 'бир кун',
                        dd: '%d кун',
                        M: 'бир ой',
                        MM: '%d ой',
                        y: 'бир йил',
                        yy: '%d йил'
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('uz-latn', {
                    months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
                    monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
                    weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
                    weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
                    weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'D MMMM YYYY, dddd HH:mm'
                    },
                    calendar: {
                        sameDay: '[Bugun soat] LT [da]',
                        nextDay: '[Ertaga] LT [da]',
                        nextWeek: 'dddd [kuni soat] LT [da]',
                        lastDay: '[Kecha soat] LT [da]',
                        lastWeek: '[O\'tgan] dddd [kuni soat] LT [da]',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'Yaqin %s ichida',
                        past: 'Bir necha %s oldin',
                        s: 'soniya',
                        ss: '%d soniya',
                        m: 'bir daqiqa',
                        mm: '%d daqiqa',
                        h: 'bir soat',
                        hh: '%d soat',
                        d: 'bir kun',
                        dd: '%d kun',
                        M: 'bir oy',
                        MM: '%d oy',
                        y: 'bir yil',
                        yy: '%d yil'
                    },
                    week: {
                        dow: 1,
                        doy: 7
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('vi', {
                    months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
                    monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
                    weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
                    weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
                    weekdaysParseExact: !0,
                    meridiemParse: /sa|ch/i,
                    isPM: function (e) {
                        return /^ch$/i.test(e);
                    },
                    meridiem: function (e, t, a) {
                        return e < 12 ? a ? 'sa' : 'SA' : a ? 'ch' : 'CH';
                    },
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM [năm] YYYY',
                        LLL: 'D MMMM [năm] YYYY HH:mm',
                        LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
                        l: 'DD/M/YYYY',
                        ll: 'D MMM YYYY',
                        lll: 'D MMM YYYY HH:mm',
                        llll: 'ddd, D MMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[Hôm nay lúc] LT',
                        nextDay: '[Ngày mai lúc] LT',
                        nextWeek: 'dddd [tuần tới lúc] LT',
                        lastDay: '[Hôm qua lúc] LT',
                        lastWeek: 'dddd [tuần trước lúc] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: '%s tới',
                        past: '%s trước',
                        s: 'vài giây',
                        ss: '%d giây',
                        m: 'một phút',
                        mm: '%d phút',
                        h: 'một giờ',
                        hh: '%d giờ',
                        d: 'một ngày',
                        dd: '%d ngày',
                        w: 'một tuần',
                        ww: '%d tuần',
                        M: 'một tháng',
                        MM: '%d tháng',
                        y: 'một năm',
                        yy: '%d năm'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}/,
                    ordinal: function (e) {
                        return e;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('x-pseudo', {
                    months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
                    monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
                    monthsParseExact: !0,
                    weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
                    weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
                    weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
                    weekdaysParseExact: !0,
                    longDateFormat: {
                        LT: 'HH:mm',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    calendar: {
                        sameDay: '[T~ódá~ý át] LT',
                        nextDay: '[T~ómó~rró~w át] LT',
                        nextWeek: 'dddd [át] LT',
                        lastDay: '[Ý~ést~érdá~ý át] LT',
                        lastWeek: '[L~ást] dddd [át] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'í~ñ %s',
                        past: '%s á~gó',
                        s: 'á ~féw ~sécó~ñds',
                        ss: '%d s~écóñ~ds',
                        m: 'á ~míñ~úté',
                        mm: '%d m~íñú~tés',
                        h: 'á~ñ hó~úr',
                        hh: '%d h~óúrs',
                        d: 'á ~dáý',
                        dd: '%d d~áýs',
                        M: 'á ~móñ~th',
                        MM: '%d m~óñt~hs',
                        y: 'á ~ýéár',
                        yy: '%d ý~éárs'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                    ordinal: function (e) {
                        var t = e % 10, a = 1 === ~~(e % 100 / 10) ? 'th' : 1 === t ? 'st' : 2 === t ? 'nd' : 3 === t ? 'rd' : 'th';
                        return e + a;
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('yo', {
                    months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
                    monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
                    weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
                    weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
                    weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
                    longDateFormat: {
                        LT: 'h:mm A',
                        LTS: 'h:mm:ss A',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY h:mm A',
                        LLLL: 'dddd, D MMMM YYYY h:mm A'
                    },
                    calendar: {
                        sameDay: '[Ònì ni] LT',
                        nextDay: '[Ọ̀la ni] LT',
                        nextWeek: 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
                        lastDay: '[Àna ni] LT',
                        lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
                        sameElse: 'L'
                    },
                    relativeTime: {
                        future: 'ní %s',
                        past: '%s kọjá',
                        s: 'ìsẹjú aayá die',
                        ss: 'aayá %d',
                        m: 'ìsẹjú kan',
                        mm: 'ìsẹjú %d',
                        h: 'wákati kan',
                        hh: 'wákati %d',
                        d: 'ọjọ́ kan',
                        dd: 'ọjọ́ %d',
                        M: 'osù kan',
                        MM: 'osù %d',
                        y: 'ọdún kan',
                        yy: 'ọdún %d'
                    },
                    dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
                    ordinal: 'ọjọ́ %d',
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('zh-cn', {
                    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
                    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
                    weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
                    weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY/MM/DD',
                        LL: 'YYYY年M月D日',
                        LLL: 'YYYY年M月D日Ah点mm分',
                        LLLL: 'YYYY年M月D日ddddAh点mm分',
                        l: 'YYYY/M/D',
                        ll: 'YYYY年M月D日',
                        lll: 'YYYY年M月D日 HH:mm',
                        llll: 'YYYY年M月D日dddd HH:mm'
                    },
                    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), '凌晨' === t || '早上' === t || '上午' === t ? e : '下午' === t || '晚上' === t ? e + 12 : e >= 11 ? e : e + 12;
                    },
                    meridiem: function (e, t, a) {
                        var n = 100 * e + t;
                        return n < 600 ? '凌晨' : n < 900 ? '早上' : n < 1130 ? '上午' : n < 1230 ? '中午' : n < 1800 ? '下午' : '晚上';
                    },
                    calendar: {
                        sameDay: '[今天]LT',
                        nextDay: '[明天]LT',
                        nextWeek: function (e) {
                            return e.week() !== this.week() ? '[下]dddLT' : '[本]dddLT';
                        },
                        lastDay: '[昨天]LT',
                        lastWeek: function (e) {
                            return this.week() !== e.week() ? '[上]dddLT' : '[本]dddLT';
                        },
                        sameElse: 'L'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'd':
                        case 'D':
                        case 'DDD':
                            return e + '日';
                        case 'M':
                            return e + '月';
                        case 'w':
                        case 'W':
                            return e + '周';
                        default:
                            return e;
                        }
                    },
                    relativeTime: {
                        future: '%s后',
                        past: '%s前',
                        s: '几秒',
                        ss: '%d 秒',
                        m: '1 分钟',
                        mm: '%d 分钟',
                        h: '1 小时',
                        hh: '%d 小时',
                        d: '1 天',
                        dd: '%d 天',
                        w: '1 周',
                        ww: '%d 周',
                        M: '1 个月',
                        MM: '%d 个月',
                        y: '1 年',
                        yy: '%d 年'
                    },
                    week: {
                        dow: 1,
                        doy: 4
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('zh-hk', {
                    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
                    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
                    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
                    weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY/MM/DD',
                        LL: 'YYYY年M月D日',
                        LLL: 'YYYY年M月D日 HH:mm',
                        LLLL: 'YYYY年M月D日dddd HH:mm',
                        l: 'YYYY/M/D',
                        ll: 'YYYY年M月D日',
                        lll: 'YYYY年M月D日 HH:mm',
                        llll: 'YYYY年M月D日dddd HH:mm'
                    },
                    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), '凌晨' === t || '早上' === t || '上午' === t ? e : '中午' === t ? e >= 11 ? e : e + 12 : '下午' === t || '晚上' === t ? e + 12 : void 0;
                    },
                    meridiem: function (e, t, a) {
                        var n = 100 * e + t;
                        return n < 600 ? '凌晨' : n < 900 ? '早上' : n < 1200 ? '上午' : 1200 === n ? '中午' : n < 1800 ? '下午' : '晚上';
                    },
                    calendar: {
                        sameDay: '[今天]LT',
                        nextDay: '[明天]LT',
                        nextWeek: '[下]ddddLT',
                        lastDay: '[昨天]LT',
                        lastWeek: '[上]ddddLT',
                        sameElse: 'L'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'd':
                        case 'D':
                        case 'DDD':
                            return e + '日';
                        case 'M':
                            return e + '月';
                        case 'w':
                        case 'W':
                            return e + '週';
                        default:
                            return e;
                        }
                    },
                    relativeTime: {
                        future: '%s後',
                        past: '%s前',
                        s: '幾秒',
                        ss: '%d 秒',
                        m: '1 分鐘',
                        mm: '%d 分鐘',
                        h: '1 小時',
                        hh: '%d 小時',
                        d: '1 天',
                        dd: '%d 天',
                        M: '1 個月',
                        MM: '%d 個月',
                        y: '1 年',
                        yy: '%d 年'
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('zh-mo', {
                    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
                    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
                    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
                    weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'YYYY年M月D日',
                        LLL: 'YYYY年M月D日 HH:mm',
                        LLLL: 'YYYY年M月D日dddd HH:mm',
                        l: 'D/M/YYYY',
                        ll: 'YYYY年M月D日',
                        lll: 'YYYY年M月D日 HH:mm',
                        llll: 'YYYY年M月D日dddd HH:mm'
                    },
                    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), '凌晨' === t || '早上' === t || '上午' === t ? e : '中午' === t ? e >= 11 ? e : e + 12 : '下午' === t || '晚上' === t ? e + 12 : void 0;
                    },
                    meridiem: function (e, t, a) {
                        var n = 100 * e + t;
                        return n < 600 ? '凌晨' : n < 900 ? '早上' : n < 1130 ? '上午' : n < 1230 ? '中午' : n < 1800 ? '下午' : '晚上';
                    },
                    calendar: {
                        sameDay: '[今天] LT',
                        nextDay: '[明天] LT',
                        nextWeek: '[下]dddd LT',
                        lastDay: '[昨天] LT',
                        lastWeek: '[上]dddd LT',
                        sameElse: 'L'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'd':
                        case 'D':
                        case 'DDD':
                            return e + '日';
                        case 'M':
                            return e + '月';
                        case 'w':
                        case 'W':
                            return e + '週';
                        default:
                            return e;
                        }
                    },
                    relativeTime: {
                        future: '%s內',
                        past: '%s前',
                        s: '幾秒',
                        ss: '%d 秒',
                        m: '1 分鐘',
                        mm: '%d 分鐘',
                        h: '1 小時',
                        hh: '%d 小時',
                        d: '1 天',
                        dd: '%d 天',
                        M: '1 個月',
                        MM: '%d 個月',
                        y: '1 年',
                        yy: '%d 年'
                    }
                });
                return t;
            });
        },
        function (e, t, a) {
            !function (e, t) {
                t(a(11));
            }(this, function (e) {
                'use strict';
                var t = e.defineLocale('zh-tw', {
                    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
                    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
                    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
                    weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY/MM/DD',
                        LL: 'YYYY年M月D日',
                        LLL: 'YYYY年M月D日 HH:mm',
                        LLLL: 'YYYY年M月D日dddd HH:mm',
                        l: 'YYYY/M/D',
                        ll: 'YYYY年M月D日',
                        lll: 'YYYY年M月D日 HH:mm',
                        llll: 'YYYY年M月D日dddd HH:mm'
                    },
                    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
                    meridiemHour: function (e, t) {
                        return 12 === e && (e = 0), '凌晨' === t || '早上' === t || '上午' === t ? e : '中午' === t ? e >= 11 ? e : e + 12 : '下午' === t || '晚上' === t ? e + 12 : void 0;
                    },
                    meridiem: function (e, t, a) {
                        var n = 100 * e + t;
                        return n < 600 ? '凌晨' : n < 900 ? '早上' : n < 1130 ? '上午' : n < 1230 ? '中午' : n < 1800 ? '下午' : '晚上';
                    },
                    calendar: {
                        sameDay: '[今天] LT',
                        nextDay: '[明天] LT',
                        nextWeek: '[下]dddd LT',
                        lastDay: '[昨天] LT',
                        lastWeek: '[上]dddd LT',
                        sameElse: 'L'
                    },
                    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
                    ordinal: function (e, t) {
                        switch (t) {
                        case 'd':
                        case 'D':
                        case 'DDD':
                            return e + '日';
                        case 'M':
                            return e + '月';
                        case 'w':
                        case 'W':
                            return e + '週';
                        default:
                            return e;
                        }
                    },
                    relativeTime: {
                        future: '%s後',
                        past: '%s前',
                        s: '幾秒',
                        ss: '%d 秒',
                        m: '1 分鐘',
                        mm: '%d 分鐘',
                        h: '1 小時',
                        hh: '%d 小時',
                        d: '1 天',
                        dd: '%d 天',
                        M: '1 個月',
                        MM: '%d 個月',
                        y: '1 年',
                        yy: '%d 年'
                    }
                });
                return t;
            });
        }
    ]);
});
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define('bootstrap-datepicker', ['jquery'], factory);
    } else if (typeof exports === 'object') {
        factory(require('jquery'));
    } else {
        factory(jQuery);
    }
}(function ($, undefined) {
    function UTCDate() {
        return new Date(Date.UTC.apply(Date, arguments));
    }
    function UTCToday() {
        var today = new Date();
        return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
    }
    function isUTCEquals(date1, date2) {
        return date1.getUTCFullYear() === date2.getUTCFullYear() && date1.getUTCMonth() === date2.getUTCMonth() && date1.getUTCDate() === date2.getUTCDate();
    }
    function alias(method) {
        return function () {
            return this[method].apply(this, arguments);
        };
    }
    function isValidDate(d) {
        return d && !isNaN(d.getTime());
    }
    var DateArray = function () {
        var extras = {
            get: function (i) {
                return this.slice(i)[0];
            },
            contains: function (d) {
                var val = d && d.valueOf();
                for (var i = 0, l = this.length; i < l; i++)
                    if (this[i].valueOf() === val)
                        return i;
                return -1;
            },
            remove: function (i) {
                this.splice(i, 1);
            },
            replace: function (new_array) {
                if (!new_array)
                    return;
                if (!$.isArray(new_array))
                    new_array = [new_array];
                this.clear();
                this.push.apply(this, new_array);
            },
            clear: function () {
                this.length = 0;
            },
            copy: function () {
                var a = new DateArray();
                a.replace(this);
                return a;
            }
        };
        return function () {
            var a = [];
            a.push.apply(a, arguments);
            $.extend(a, extras);
            return a;
        };
    }();
    var Datepicker = function (element, options) {
        $(element).data('datepicker', this);
        this._process_options(options);
        this.dates = new DateArray();
        this.viewDate = this.o.defaultViewDate;
        this.focusDate = null;
        this.element = $(element);
        this.isInline = false;
        this.isInput = this.element.is('input');
        this.component = this.element.hasClass('date') ? this.element.find('.add-on, .input-group-addon, .btn') : false;
        this.hasInput = this.component && this.element.find('input').length;
        if (this.component && this.component.length === 0)
            this.component = false;
        this.picker = $(DPGlobal.template);
        this._buildEvents();
        this._attachEvents();
        if (this.isInline) {
            this.picker.addClass('datepicker-inline').appendTo(this.element);
        } else {
            this.picker.addClass('datepicker-dropdown dropdown-menu');
        }
        if (this.o.rtl) {
            this.picker.addClass('datepicker-rtl');
        }
        this.viewMode = this.o.startView;
        if (this.o.calendarWeeks)
            this.picker.find('thead .datepicker-title, tfoot .today, tfoot .clear').attr('colspan', function (i, val) {
                return parseInt(val) + 1;
            });
        this._allow_update = false;
        this.setStartDate(this._o.startDate);
        this.setEndDate(this._o.endDate);
        this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled);
        this.setDaysOfWeekHighlighted(this.o.daysOfWeekHighlighted);
        this.setDatesDisabled(this.o.datesDisabled);
        this.fillDow();
        this.fillMonths();
        this._allow_update = true;
        this.update();
        this.showMode();
        if (this.isInline) {
            this.show();
        }
    };
    Datepicker.prototype = {
        constructor: Datepicker,
        _process_options: function (opts) {
            this._o = $.extend({}, this._o, opts);
            var o = this.o = $.extend({}, this._o);
            var lang = o.language;
            if (!dates[lang]) {
                lang = lang.split('-')[0];
                if (!dates[lang])
                    lang = defaults.language;
            }
            o.language = lang;
            switch (o.startView) {
            case 2:
            case 'decade':
                o.startView = 2;
                break;
            case 1:
            case 'year':
                o.startView = 1;
                break;
            default:
                o.startView = 0;
            }
            switch (o.minViewMode) {
            case 1:
            case 'months':
                o.minViewMode = 1;
                break;
            case 2:
            case 'years':
                o.minViewMode = 2;
                break;
            default:
                o.minViewMode = 0;
            }
            switch (o.maxViewMode) {
            case 0:
            case 'days':
                o.maxViewMode = 0;
                break;
            case 1:
            case 'months':
                o.maxViewMode = 1;
                break;
            default:
                o.maxViewMode = 2;
            }
            o.startView = Math.min(o.startView, o.maxViewMode);
            o.startView = Math.max(o.startView, o.minViewMode);
            if (o.multidate !== true) {
                o.multidate = Number(o.multidate) || false;
                if (o.multidate !== false)
                    o.multidate = Math.max(0, o.multidate);
            }
            o.multidateSeparator = String(o.multidateSeparator);
            o.weekStart %= 7;
            o.weekEnd = (o.weekStart + 6) % 7;
            var format = DPGlobal.parseFormat(o.format);
            if (o.startDate !== -Infinity) {
                if (!!o.startDate) {
                    if (o.startDate instanceof Date)
                        o.startDate = this._local_to_utc(this._zero_time(o.startDate));
                    else
                        o.startDate = DPGlobal.parseDate(o.startDate, format, o.language);
                } else {
                    o.startDate = -Infinity;
                }
            }
            if (o.endDate !== Infinity) {
                if (!!o.endDate) {
                    if (o.endDate instanceof Date)
                        o.endDate = this._local_to_utc(this._zero_time(o.endDate));
                    else
                        o.endDate = DPGlobal.parseDate(o.endDate, format, o.language);
                } else {
                    o.endDate = Infinity;
                }
            }
            o.daysOfWeekDisabled = o.daysOfWeekDisabled || [];
            if (!$.isArray(o.daysOfWeekDisabled))
                o.daysOfWeekDisabled = o.daysOfWeekDisabled.split(/[,\s]*/);
            o.daysOfWeekDisabled = $.map(o.daysOfWeekDisabled, function (d) {
                return parseInt(d, 10);
            });
            o.daysOfWeekHighlighted = o.daysOfWeekHighlighted || [];
            if (!$.isArray(o.daysOfWeekHighlighted))
                o.daysOfWeekHighlighted = o.daysOfWeekHighlighted.split(/[,\s]*/);
            o.daysOfWeekHighlighted = $.map(o.daysOfWeekHighlighted, function (d) {
                return parseInt(d, 10);
            });
            o.datesDisabled = o.datesDisabled || [];
            if (!$.isArray(o.datesDisabled)) {
                var datesDisabled = [];
                datesDisabled.push(DPGlobal.parseDate(o.datesDisabled, format, o.language));
                o.datesDisabled = datesDisabled;
            }
            o.datesDisabled = $.map(o.datesDisabled, function (d) {
                return DPGlobal.parseDate(d, format, o.language);
            });
            var plc = String(o.orientation).toLowerCase().split(/\s+/g), _plc = o.orientation.toLowerCase();
            plc = $.grep(plc, function (word) {
                return /^auto|left|right|top|bottom$/.test(word);
            });
            o.orientation = {
                x: 'auto',
                y: 'auto'
            };
            if (!_plc || _plc === 'auto');
            else if (plc.length === 1) {
                switch (plc[0]) {
                case 'top':
                case 'bottom':
                    o.orientation.y = plc[0];
                    break;
                case 'left':
                case 'right':
                    o.orientation.x = plc[0];
                    break;
                }
            } else {
                _plc = $.grep(plc, function (word) {
                    return /^left|right$/.test(word);
                });
                o.orientation.x = _plc[0] || 'auto';
                _plc = $.grep(plc, function (word) {
                    return /^top|bottom$/.test(word);
                });
                o.orientation.y = _plc[0] || 'auto';
            }
            if (o.defaultViewDate) {
                var year = o.defaultViewDate.year || new Date().getFullYear();
                var month = o.defaultViewDate.month || 0;
                var day = o.defaultViewDate.day || 1;
                o.defaultViewDate = UTCDate(year, month, day);
            } else {
                o.defaultViewDate = UTCToday();
            }
        },
        _events: [],
        _secondaryEvents: [],
        _applyEvents: function (evs) {
            for (var i = 0, el, ch, ev; i < evs.length; i++) {
                el = evs[i][0];
                if (evs[i].length === 2) {
                    ch = undefined;
                    ev = evs[i][1];
                } else if (evs[i].length === 3) {
                    ch = evs[i][1];
                    ev = evs[i][2];
                }
                el.on(ev, ch);
            }
        },
        _unapplyEvents: function (evs) {
            for (var i = 0, el, ev, ch; i < evs.length; i++) {
                el = evs[i][0];
                if (evs[i].length === 2) {
                    ch = undefined;
                    ev = evs[i][1];
                } else if (evs[i].length === 3) {
                    ch = evs[i][1];
                    ev = evs[i][2];
                }
                el.off(ev, ch);
            }
        },
        _buildEvents: function () {
            var events = {
                keyup: $.proxy(function (e) {
                    if ($.inArray(e.keyCode, [
                            27,
                            37,
                            39,
                            38,
                            40,
                            32,
                            13,
                            9
                        ]) === -1)
                        this.update();
                }, this),
                keydown: $.proxy(this.keydown, this),
                paste: $.proxy(this.paste, this)
            };
            if (this.o.showOnFocus === true) {
                events.focus = $.proxy(this.show, this);
            }
            if (this.isInput) {
                this._events = [[
                        this.element,
                        events
                    ]];
            } else if (this.component && this.hasInput) {
                this._events = [
                    [
                        this.element.find('input'),
                        events
                    ],
                    [
                        this.component,
                        { click: $.proxy(this.show, this) }
                    ]
                ];
            } else if (this.element.is('div')) {
                this.isInline = true;
            } else {
                this._events = [[
                        this.element,
                        { click: $.proxy(this.show, this) }
                    ]];
            }
            this._events.push([
                this.element,
                '*',
                {
                    blur: $.proxy(function (e) {
                        this._focused_from = e.target;
                    }, this)
                }
            ], [
                this.element,
                {
                    blur: $.proxy(function (e) {
                        this._focused_from = e.target;
                    }, this)
                }
            ]);
            if (this.o.immediateUpdates) {
                this._events.push([
                    this.element,
                    {
                        'changeYear changeMonth': $.proxy(function (e) {
                            this.update(e.date);
                        }, this)
                    }
                ]);
            }
            this._secondaryEvents = [
                [
                    this.picker,
                    { click: $.proxy(this.click, this) }
                ],
                [
                    $(window),
                    { resize: $.proxy(this.place, this) }
                ],
                [
                    $(document),
                    {
                        mousedown: $.proxy(function (e) {
                            if (!(this.element.is(e.target) || this.element.find(e.target).length || this.picker.is(e.target) || this.picker.find(e.target).length || this.picker.hasClass('datepicker-inline'))) {
                                this.hide();
                            }
                        }, this)
                    }
                ]
            ];
        },
        _attachEvents: function () {
            this._detachEvents();
            this._applyEvents(this._events);
        },
        _detachEvents: function () {
            this._unapplyEvents(this._events);
        },
        _attachSecondaryEvents: function () {
            this._detachSecondaryEvents();
            this._applyEvents(this._secondaryEvents);
        },
        _detachSecondaryEvents: function () {
            this._unapplyEvents(this._secondaryEvents);
        },
        _trigger: function (event, altdate) {
            var date = altdate || this.dates.get(-1), local_date = this._utc_to_local(date);
            this.element.trigger({
                type: event,
                date: local_date,
                dates: $.map(this.dates, this._utc_to_local),
                format: $.proxy(function (ix, format) {
                    if (arguments.length === 0) {
                        ix = this.dates.length - 1;
                        format = this.o.format;
                    } else if (typeof ix === 'string') {
                        format = ix;
                        ix = this.dates.length - 1;
                    }
                    format = format || this.o.format;
                    var date = this.dates.get(ix);
                    return DPGlobal.formatDate(date, format, this.o.language);
                }, this)
            });
        },
        show: function () {
            var element = this.component ? this.element.find('input') : this.element;
            if (element.attr('readonly') && this.o.enableOnReadonly === false)
                return;
            if (!this.isInline)
                this.picker.appendTo(this.o.container);
            this.place();
            this.picker.show();
            this._attachSecondaryEvents();
            this._trigger('show');
            if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document) && this.o.disableTouchKeyboard) {
                $(this.element).blur();
            }
            return this;
        },
        hide: function () {
            if (this.isInline)
                return this;
            if (!this.picker.is(':visible'))
                return this;
            this.focusDate = null;
            this.picker.hide().detach();
            this._detachSecondaryEvents();
            this.viewMode = this.o.startView;
            this.showMode();
            if (this.o.forceParse && (this.isInput && this.element.val() || this.hasInput && this.element.find('input').val()))
                this.setValue();
            this._trigger('hide');
            return this;
        },
        remove: function () {
            this.hide();
            this._detachEvents();
            this._detachSecondaryEvents();
            this.picker.remove();
            delete this.element.data().datepicker;
            if (!this.isInput) {
                delete this.element.data().date;
            }
            return this;
        },
        paste: function (evt) {
            var dateString;
            if (evt.originalEvent.clipboardData && evt.originalEvent.clipboardData.types && $.inArray('text/plain', evt.originalEvent.clipboardData.types) !== -1) {
                dateString = evt.originalEvent.clipboardData.getData('text/plain');
            } else if (window.clipboardData) {
                dateString = window.clipboardData.getData('Text');
            } else {
                return;
            }
            this.setDate(dateString);
            this.update();
            evt.preventDefault();
        },
        _utc_to_local: function (utc) {
            return utc && new Date(utc.getTime() + utc.getTimezoneOffset() * 60000);
        },
        _local_to_utc: function (local) {
            return local && new Date(local.getTime() - local.getTimezoneOffset() * 60000);
        },
        _zero_time: function (local) {
            return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
        },
        _zero_utc_time: function (utc) {
            return utc && new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate()));
        },
        getDates: function () {
            return $.map(this.dates, this._utc_to_local);
        },
        getUTCDates: function () {
            return $.map(this.dates, function (d) {
                return new Date(d);
            });
        },
        getDate: function () {
            return this._utc_to_local(this.getUTCDate());
        },
        getUTCDate: function () {
            var selected_date = this.dates.get(-1);
            if (typeof selected_date !== 'undefined') {
                return new Date(selected_date);
            } else {
                return null;
            }
        },
        clearDates: function () {
            var element;
            if (this.isInput) {
                element = this.element;
            } else if (this.component) {
                element = this.element.find('input');
            }
            if (element) {
                element.val('');
            }
            this.update();
            this._trigger('changeDate');
            if (this.o.autoclose) {
                this.hide();
            }
        },
        setDates: function () {
            var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
            this.update.apply(this, args);
            this._trigger('changeDate');
            this.setValue();
            return this;
        },
        setUTCDates: function () {
            var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
            this.update.apply(this, $.map(args, this._utc_to_local));
            this._trigger('changeDate');
            this.setValue();
            return this;
        },
        setDate: alias('setDates'),
        setUTCDate: alias('setUTCDates'),
        setValue: function () {
            var formatted = this.getFormattedDate();
            if (!this.isInput) {
                if (this.component) {
                    this.element.find('input').val(formatted);
                }
            } else {
                this.element.val(formatted);
            }
            return this;
        },
        getFormattedDate: function (format) {
            if (format === undefined)
                format = this.o.format;
            var lang = this.o.language;
            return $.map(this.dates, function (d) {
                return DPGlobal.formatDate(d, format, lang);
            }).join(this.o.multidateSeparator);
        },
        setStartDate: function (startDate) {
            this._process_options({ startDate: startDate });
            this.update();
            this.updateNavArrows();
            return this;
        },
        setEndDate: function (endDate) {
            this._process_options({ endDate: endDate });
            this.update();
            this.updateNavArrows();
            return this;
        },
        setDaysOfWeekDisabled: function (daysOfWeekDisabled) {
            this._process_options({ daysOfWeekDisabled: daysOfWeekDisabled });
            this.update();
            this.updateNavArrows();
            return this;
        },
        setDaysOfWeekHighlighted: function (daysOfWeekHighlighted) {
            this._process_options({ daysOfWeekHighlighted: daysOfWeekHighlighted });
            this.update();
            return this;
        },
        setDatesDisabled: function (datesDisabled) {
            this._process_options({ datesDisabled: datesDisabled });
            this.update();
            this.updateNavArrows();
        },
        place: function () {
            if (this.isInline)
                return this;
            var calendarWidth = this.picker.outerWidth(), calendarHeight = this.picker.outerHeight(), visualPadding = 10, container = $(this.o.container), windowWidth = container.width(), scrollTop = this.o.container === 'body' ? $(document).scrollTop() : container.scrollTop(), appendOffset = container.offset();
            var parentsZindex = [];
            this.element.parents().each(function () {
                var itemZIndex = $(this).css('z-index');
                if (itemZIndex !== 'auto' && itemZIndex !== 0)
                    parentsZindex.push(parseInt(itemZIndex));
            });
            var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;
            var offset = this.component ? this.component.parent().offset() : this.element.offset();
            var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
            var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
            var left = offset.left - appendOffset.left, top = offset.top - appendOffset.top;
            if (this.o.container !== 'body') {
                top += scrollTop;
            }
            this.picker.removeClass('datepicker-orient-top datepicker-orient-bottom ' + 'datepicker-orient-right datepicker-orient-left');
            if (this.o.orientation.x !== 'auto') {
                this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
                if (this.o.orientation.x === 'right')
                    left -= calendarWidth - width;
            } else {
                if (offset.left < 0) {
                    this.picker.addClass('datepicker-orient-left');
                    left -= offset.left - visualPadding;
                } else if (left + calendarWidth > windowWidth) {
                    this.picker.addClass('datepicker-orient-right');
                    left += width - calendarWidth;
                } else {
                    this.picker.addClass('datepicker-orient-left');
                }
            }
            var yorient = this.o.orientation.y, top_overflow;
            if (yorient === 'auto') {
                top_overflow = -scrollTop + top - calendarHeight;
                yorient = top_overflow < 0 ? 'bottom' : 'top';
            }
            this.picker.addClass('datepicker-orient-' + yorient);
            if (yorient === 'top')
                top -= calendarHeight + parseInt(this.picker.css('padding-top'));
            else
                top += height;
            if (this.o.rtl) {
                var right = windowWidth - (left + width);
                this.picker.css({
                    top: top,
                    right: right,
                    zIndex: zIndex
                });
            } else {
                this.picker.css({
                    top: top,
                    left: left,
                    zIndex: zIndex
                });
            }
            return this;
        },
        _allow_update: true,
        update: function () {
            if (!this._allow_update)
                return this;
            var oldDates = this.dates.copy(), dates = [], fromArgs = false;
            if (arguments.length) {
                $.each(arguments, $.proxy(function (i, date) {
                    if (date instanceof Date)
                        date = this._local_to_utc(date);
                    dates.push(date);
                }, this));
                fromArgs = true;
            } else {
                dates = this.isInput ? this.element.val() : this.element.data('date') || this.element.find('input').val();
                if (dates && this.o.multidate)
                    dates = dates.split(this.o.multidateSeparator);
                else
                    dates = [dates];
                delete this.element.data().date;
            }
            dates = $.map(dates, $.proxy(function (date) {
                return DPGlobal.parseDate(date, this.o.format, this.o.language);
            }, this));
            dates = $.grep(dates, $.proxy(function (date) {
                return !this.dateWithinRange(date) || !date;
            }, this), true);
            this.dates.replace(dates);
            if (this.dates.length)
                this.viewDate = new Date(this.dates.get(-1));
            else if (this.viewDate < this.o.startDate)
                this.viewDate = new Date(this.o.startDate);
            else if (this.viewDate > this.o.endDate)
                this.viewDate = new Date(this.o.endDate);
            else
                this.viewDate = this.o.defaultViewDate;
            if (fromArgs) {
                this.setValue();
            } else if (dates.length) {
                if (String(oldDates) !== String(this.dates))
                    this._trigger('changeDate');
            }
            if (!this.dates.length && oldDates.length)
                this._trigger('clearDate');
            this.fill();
            this.element.change();
            return this;
        },
        fillDow: function () {
            var dowCnt = this.o.weekStart, html = '<tr>';
            if (this.o.calendarWeeks) {
                this.picker.find('.datepicker-days .datepicker-switch').attr('colspan', function (i, val) {
                    return parseInt(val) + 1;
                });
                html += '<th class="cw">&#160;</th>';
            }
            while (dowCnt < this.o.weekStart + 7) {
                html += '<th class="dow">' + dates[this.o.language].daysMin[dowCnt++ % 7] + '</th>';
            }
            html += '</tr>';
            this.picker.find('.datepicker-days thead').append(html);
        },
        fillMonths: function () {
            var html = '', i = 0;
            while (i < 12) {
                html += '<span class="month">' + dates[this.o.language].monthsShort[i++] + '</span>';
            }
            this.picker.find('.datepicker-months td').html(html);
        },
        setRange: function (range) {
            if (!range || !range.length)
                delete this.range;
            else
                this.range = $.map(range, function (d) {
                    return d.valueOf();
                });
            this.fill();
        },
        getClassNames: function (date) {
            var cls = [], year = this.viewDate.getUTCFullYear(), month = this.viewDate.getUTCMonth(), today = new Date();
            if (date.getUTCFullYear() < year || date.getUTCFullYear() === year && date.getUTCMonth() < month) {
                cls.push('old');
            } else if (date.getUTCFullYear() > year || date.getUTCFullYear() === year && date.getUTCMonth() > month) {
                cls.push('new');
            }
            if (this.focusDate && date.valueOf() === this.focusDate.valueOf())
                cls.push('focused');
            if (this.o.todayHighlight && date.getUTCFullYear() === today.getFullYear() && date.getUTCMonth() === today.getMonth() && date.getUTCDate() === today.getDate()) {
                cls.push('today');
            }
            if (this.dates.contains(date) !== -1)
                cls.push('active');
            if (!this.dateWithinRange(date) || this.dateIsDisabled(date)) {
                cls.push('disabled');
            }
            if ($.inArray(date.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1) {
                cls.push('highlighted');
            }
            if (this.range) {
                if (date > this.range[0] && date < this.range[this.range.length - 1]) {
                    cls.push('range');
                }
                if ($.inArray(date.valueOf(), this.range) !== -1) {
                    cls.push('selected');
                }
                if (date.valueOf() === this.range[0]) {
                    cls.push('range-start');
                }
                if (date.valueOf() === this.range[this.range.length - 1]) {
                    cls.push('range-end');
                }
            }
            return cls;
        },
        fill: function () {
            var d = new Date(this.viewDate), year = d.getUTCFullYear(), month = d.getUTCMonth(), startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity, startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity, endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity, endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity, todaytxt = dates[this.o.language].today || dates['en'].today || '', cleartxt = dates[this.o.language].clear || dates['en'].clear || '', titleFormat = dates[this.o.language].titleFormat || dates['en'].titleFormat, tooltip;
            if (isNaN(year) || isNaN(month))
                return;
            this.picker.find('.datepicker-days thead .datepicker-switch').text(DPGlobal.formatDate(new UTCDate(year, month), titleFormat, this.o.language));
            this.picker.find('tfoot .today').text(todaytxt).toggle(this.o.todayBtn !== false);
            this.picker.find('tfoot .clear').text(cleartxt).toggle(this.o.clearBtn !== false);
            this.picker.find('thead .datepicker-title').text(this.o.title).toggle(this.o.title !== '');
            this.updateNavArrows();
            this.fillMonths();
            var prevMonth = UTCDate(year, month - 1, 28), day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
            prevMonth.setUTCDate(day);
            prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7) % 7);
            var nextMonth = new Date(prevMonth);
            if (prevMonth.getUTCFullYear() < 100) {
                nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
            }
            nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
            nextMonth = nextMonth.valueOf();
            var html = [];
            var clsName;
            while (prevMonth.valueOf() < nextMonth) {
                if (prevMonth.getUTCDay() === this.o.weekStart) {
                    html.push('<tr>');
                    if (this.o.calendarWeeks) {
                        var ws = new Date(+prevMonth + (this.o.weekStart - prevMonth.getUTCDay() - 7) % 7 * 86400000), th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 86400000), yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay()) % 7 * 86400000), calWeek = (th - yth) / 86400000 / 7 + 1;
                        html.push('<td class="cw">' + calWeek + '</td>');
                    }
                }
                clsName = this.getClassNames(prevMonth);
                clsName.push('day');
                if (this.o.beforeShowDay !== $.noop) {
                    var before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
                    if (before === undefined)
                        before = {};
                    else if (typeof before === 'boolean')
                        before = { enabled: before };
                    else if (typeof before === 'string')
                        before = { classes: before };
                    if (before.enabled === false)
                        clsName.push('disabled');
                    if (before.classes)
                        clsName = clsName.concat(before.classes.split(/\s+/));
                    if (before.tooltip)
                        tooltip = before.tooltip;
                }
                clsName = $.unique(clsName);
                html.push('<td class="' + clsName.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + prevMonth.getUTCDate() + '</td>');
                tooltip = null;
                if (prevMonth.getUTCDay() === this.o.weekEnd) {
                    html.push('</tr>');
                }
                prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
            }
            this.picker.find('.datepicker-days tbody').empty().append(html.join(''));
            var monthsTitle = dates[this.o.language].monthsTitle || dates['en'].monthsTitle || 'Months';
            var months = this.picker.find('.datepicker-months').find('.datepicker-switch').text(this.o.maxViewMode < 2 ? monthsTitle : year).end().find('span').removeClass('active');
            $.each(this.dates, function (i, d) {
                if (d.getUTCFullYear() === year)
                    months.eq(d.getUTCMonth()).addClass('active');
            });
            if (year < startYear || year > endYear) {
                months.addClass('disabled');
            }
            if (year === startYear) {
                months.slice(0, startMonth).addClass('disabled');
            }
            if (year === endYear) {
                months.slice(endMonth + 1).addClass('disabled');
            }
            if (this.o.beforeShowMonth !== $.noop) {
                var that = this;
                $.each(months, function (i, month) {
                    if (!$(month).hasClass('disabled')) {
                        var moDate = new Date(year, i, 1);
                        var before = that.o.beforeShowMonth(moDate);
                        if (before === false)
                            $(month).addClass('disabled');
                    }
                });
            }
            html = '';
            year = parseInt(year / 10, 10) * 10;
            var yearCont = this.picker.find('.datepicker-years').find('.datepicker-switch').text(year + '-' + (year + 9)).end().find('td');
            year -= 1;
            var years = $.map(this.dates, function (d) {
                    return d.getUTCFullYear();
                }), classes;
            for (var i = -1; i < 11; i++) {
                classes = ['year'];
                tooltip = null;
                if (i === -1)
                    classes.push('old');
                else if (i === 10)
                    classes.push('new');
                if ($.inArray(year, years) !== -1)
                    classes.push('active');
                if (year < startYear || year > endYear)
                    classes.push('disabled');
                if (this.o.beforeShowYear !== $.noop) {
                    var yrBefore = this.o.beforeShowYear(new Date(year, 0, 1));
                    if (yrBefore === undefined)
                        yrBefore = {};
                    else if (typeof yrBefore === 'boolean')
                        yrBefore = { enabled: yrBefore };
                    else if (typeof yrBefore === 'string')
                        yrBefore = { classes: yrBefore };
                    if (yrBefore.enabled === false)
                        classes.push('disabled');
                    if (yrBefore.classes)
                        classes = classes.concat(yrBefore.classes.split(/\s+/));
                    if (yrBefore.tooltip)
                        tooltip = yrBefore.tooltip;
                }
                html += '<span class="' + classes.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + year + '</span>';
                year += 1;
            }
            yearCont.html(html);
        },
        updateNavArrows: function () {
            if (!this._allow_update)
                return;
            var d = new Date(this.viewDate), year = d.getUTCFullYear(), month = d.getUTCMonth();
            switch (this.viewMode) {
            case 0:
                if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() && month <= this.o.startDate.getUTCMonth()) {
                    this.picker.find('.prev').css({ visibility: 'hidden' });
                } else {
                    this.picker.find('.prev').css({ visibility: 'visible' });
                }
                if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() && month >= this.o.endDate.getUTCMonth()) {
                    this.picker.find('.next').css({ visibility: 'hidden' });
                } else {
                    this.picker.find('.next').css({ visibility: 'visible' });
                }
                break;
            case 1:
            case 2:
                if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() || this.o.maxViewMode < 2) {
                    this.picker.find('.prev').css({ visibility: 'hidden' });
                } else {
                    this.picker.find('.prev').css({ visibility: 'visible' });
                }
                if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() || this.o.maxViewMode < 2) {
                    this.picker.find('.next').css({ visibility: 'hidden' });
                } else {
                    this.picker.find('.next').css({ visibility: 'visible' });
                }
                break;
            }
        },
        click: function (e) {
            e.preventDefault();
            e.stopPropagation();
            var target = $(e.target).closest('span, td, th'), year, month, day;
            if (target.length === 1) {
                switch (target[0].nodeName.toLowerCase()) {
                case 'th':
                    switch (target[0].className) {
                    case 'datepicker-switch':
                        this.showMode(1);
                        break;
                    case 'prev':
                    case 'next':
                        var dir = DPGlobal.modes[this.viewMode].navStep * (target[0].className === 'prev' ? -1 : 1);
                        switch (this.viewMode) {
                        case 0:
                            this.viewDate = this.moveMonth(this.viewDate, dir);
                            this._trigger('changeMonth', this.viewDate);
                            break;
                        case 1:
                        case 2:
                            this.viewDate = this.moveYear(this.viewDate, dir);
                            if (this.viewMode === 1)
                                this._trigger('changeYear', this.viewDate);
                            break;
                        }
                        this.fill();
                        break;
                    case 'today':
                        this.showMode(-2);
                        var which = this.o.todayBtn === 'linked' ? null : 'view';
                        this._setDate(UTCToday(), which);
                        break;
                    case 'clear':
                        this.clearDates();
                        break;
                    }
                    break;
                case 'span':
                    if (!target.hasClass('disabled')) {
                        this.viewDate.setUTCDate(1);
                        if (target.hasClass('month')) {
                            day = 1;
                            month = target.parent().find('span').index(target);
                            year = this.viewDate.getUTCFullYear();
                            this.viewDate.setUTCMonth(month);
                            this._trigger('changeMonth', this.viewDate);
                            if (this.o.minViewMode === 1) {
                                this._setDate(UTCDate(year, month, day));
                                this.showMode();
                            } else {
                                this.showMode(-1);
                            }
                        } else {
                            day = 1;
                            month = 0;
                            year = parseInt(target.text(), 10) || 0;
                            this.viewDate.setUTCFullYear(year);
                            this._trigger('changeYear', this.viewDate);
                            if (this.o.minViewMode === 2) {
                                this._setDate(UTCDate(year, month, day));
                            }
                            this.showMode(-1);
                        }
                        this.fill();
                    }
                    break;
                case 'td':
                    if (target.hasClass('day') && !target.hasClass('disabled')) {
                        day = parseInt(target.text(), 10) || 1;
                        year = this.viewDate.getUTCFullYear();
                        month = this.viewDate.getUTCMonth();
                        if (target.hasClass('old')) {
                            if (month === 0) {
                                month = 11;
                                year -= 1;
                            } else {
                                month -= 1;
                            }
                        } else if (target.hasClass('new')) {
                            if (month === 11) {
                                month = 0;
                                year += 1;
                            } else {
                                month += 1;
                            }
                        }
                        this._setDate(UTCDate(year, month, day));
                    }
                    break;
                }
            }
            if (this.picker.is(':visible') && this._focused_from) {
                $(this._focused_from).focus();
            }
            delete this._focused_from;
        },
        _toggle_multidate: function (date) {
            var ix = this.dates.contains(date);
            if (!date) {
                this.dates.clear();
            }
            if (ix !== -1) {
                if (this.o.multidate === true || this.o.multidate > 1 || this.o.toggleActive) {
                    this.dates.remove(ix);
                }
            } else if (this.o.multidate === false) {
                this.dates.clear();
                this.dates.push(date);
            } else {
                this.dates.push(date);
            }
            if (typeof this.o.multidate === 'number')
                while (this.dates.length > this.o.multidate)
                    this.dates.remove(0);
        },
        _setDate: function (date, which) {
            if (!which || which === 'date')
                this._toggle_multidate(date && new Date(date));
            if (!which || which === 'view')
                this.viewDate = date && new Date(date);
            this.fill();
            this.setValue();
            if (!which || which !== 'view') {
                this._trigger('changeDate');
            }
            var element;
            if (this.isInput) {
                element = this.element;
            } else if (this.component) {
                element = this.element.find('input');
            }
            if (element) {
                element.change();
            }
            if (this.o.autoclose && (!which || which === 'date')) {
                this.hide();
            }
        },
        moveDay: function (date, dir) {
            var newDate = new Date(date);
            newDate.setUTCDate(date.getUTCDate() + dir);
            return newDate;
        },
        moveWeek: function (date, dir) {
            return this.moveDay(date, dir * 7);
        },
        moveMonth: function (date, dir) {
            if (!isValidDate(date))
                return this.o.defaultViewDate;
            if (!dir)
                return date;
            var new_date = new Date(date.valueOf()), day = new_date.getUTCDate(), month = new_date.getUTCMonth(), mag = Math.abs(dir), new_month, test;
            dir = dir > 0 ? 1 : -1;
            if (mag === 1) {
                test = dir === -1 ? function () {
                    return new_date.getUTCMonth() === month;
                } : function () {
                    return new_date.getUTCMonth() !== new_month;
                };
                new_month = month + dir;
                new_date.setUTCMonth(new_month);
                if (new_month < 0 || new_month > 11)
                    new_month = (new_month + 12) % 12;
            } else {
                for (var i = 0; i < mag; i++)
                    new_date = this.moveMonth(new_date, dir);
                new_month = new_date.getUTCMonth();
                new_date.setUTCDate(day);
                test = function () {
                    return new_month !== new_date.getUTCMonth();
                };
            }
            while (test()) {
                new_date.setUTCDate(--day);
                new_date.setUTCMonth(new_month);
            }
            return new_date;
        },
        moveYear: function (date, dir) {
            return this.moveMonth(date, dir * 12);
        },
        moveAvailableDate: function (date, dir, fn) {
            do {
                date = this[fn](date, dir);
                if (!this.dateWithinRange(date))
                    return false;
                fn = 'moveDay';
            } while (this.dateIsDisabled(date));
            return date;
        },
        weekOfDateIsDisabled: function (date) {
            return $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
        },
        dateIsDisabled: function (date) {
            return this.weekOfDateIsDisabled(date) || $.grep(this.o.datesDisabled, function (d) {
                return isUTCEquals(date, d);
            }).length > 0;
        },
        dateWithinRange: function (date) {
            return date >= this.o.startDate && date <= this.o.endDate;
        },
        keydown: function (e) {
            if (!this.picker.is(':visible')) {
                if (e.keyCode === 40 || e.keyCode === 27) {
                    this.show();
                    e.stopPropagation();
                }
                return;
            }
            var dateChanged = false, dir, newViewDate, focusDate = this.focusDate || this.viewDate;
            switch (e.keyCode) {
            case 27:
                if (this.focusDate) {
                    this.focusDate = null;
                    this.viewDate = this.dates.get(-1) || this.viewDate;
                    this.fill();
                } else
                    this.hide();
                e.preventDefault();
                e.stopPropagation();
                break;
            case 37:
            case 38:
            case 39:
            case 40:
                if (!this.o.keyboardNavigation || this.o.daysOfWeekDisabled.length === 7)
                    break;
                dir = e.keyCode === 37 || e.keyCode === 38 ? -1 : 1;
                if (e.ctrlKey) {
                    newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
                    if (newViewDate)
                        this._trigger('changeYear', this.viewDate);
                } else if (e.shiftKey) {
                    newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
                    if (newViewDate)
                        this._trigger('changeMonth', this.viewDate);
                } else if (e.keyCode === 37 || e.keyCode === 39) {
                    newViewDate = this.moveAvailableDate(focusDate, dir, 'moveDay');
                } else if (!this.weekOfDateIsDisabled(focusDate)) {
                    newViewDate = this.moveAvailableDate(focusDate, dir, 'moveWeek');
                }
                if (newViewDate) {
                    this.focusDate = this.viewDate = newViewDate;
                    this.setValue();
                    this.fill();
                    e.preventDefault();
                }
                break;
            case 13:
                if (!this.o.forceParse)
                    break;
                focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
                if (this.o.keyboardNavigation) {
                    this._toggle_multidate(focusDate);
                    dateChanged = true;
                }
                this.focusDate = null;
                this.viewDate = this.dates.get(-1) || this.viewDate;
                this.setValue();
                this.fill();
                if (this.picker.is(':visible')) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.o.autoclose)
                        this.hide();
                }
                break;
            case 9:
                this.focusDate = null;
                this.viewDate = this.dates.get(-1) || this.viewDate;
                this.fill();
                this.hide();
                break;
            }
            if (dateChanged) {
                if (this.dates.length)
                    this._trigger('changeDate');
                else
                    this._trigger('clearDate');
                var element;
                if (this.isInput) {
                    element = this.element;
                } else if (this.component) {
                    element = this.element.find('input');
                }
                if (element) {
                    element.change();
                }
            }
        },
        showMode: function (dir) {
            if (dir) {
                this.viewMode = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, this.viewMode + dir));
            }
            this.picker.children('div').hide().filter('.datepicker-' + DPGlobal.modes[this.viewMode].clsName).show();
            this.updateNavArrows();
        }
    };
    var DateRangePicker = function (element, options) {
        $(element).data('datepicker', this);
        this.element = $(element);
        this.inputs = $.map(options.inputs, function (i) {
            return i.jquery ? i[0] : i;
        });
        delete options.inputs;
        datepickerPlugin.call($(this.inputs), options).on('changeDate', $.proxy(this.dateUpdated, this));
        this.pickers = $.map(this.inputs, function (i) {
            return $(i).data('datepicker');
        });
        this.updateDates();
    };
    DateRangePicker.prototype = {
        updateDates: function () {
            this.dates = $.map(this.pickers, function (i) {
                return i.getUTCDate();
            });
            this.updateRanges();
        },
        updateRanges: function () {
            var range = $.map(this.dates, function (d) {
                return d.valueOf();
            });
            $.each(this.pickers, function (i, p) {
                p.setRange(range);
            });
        },
        dateUpdated: function (e) {
            if (this.updating)
                return;
            this.updating = true;
            var dp = $(e.target).data('datepicker');
            if (typeof dp === 'undefined') {
                return;
            }
            var new_date = dp.getUTCDate(), i = $.inArray(e.target, this.inputs), j = i - 1, k = i + 1, l = this.inputs.length;
            if (i === -1)
                return;
            $.each(this.pickers, function (i, p) {
                if (!p.getUTCDate())
                    p.setUTCDate(new_date);
            });
            if (new_date < this.dates[j]) {
                while (j >= 0 && new_date < this.dates[j]) {
                    this.pickers[j--].setUTCDate(new_date);
                }
            } else if (new_date > this.dates[k]) {
                while (k < l && new_date > this.dates[k]) {
                    this.pickers[k++].setUTCDate(new_date);
                }
            }
            this.updateDates();
            delete this.updating;
        },
        remove: function () {
            $.map(this.pickers, function (p) {
                p.remove();
            });
            delete this.element.data().datepicker;
        }
    };
    function opts_from_el(el, prefix) {
        var data = $(el).data(), out = {}, inkey, replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
        prefix = new RegExp('^' + prefix.toLowerCase());
        function re_lower(_, a) {
            return a.toLowerCase();
        }
        for (var key in data)
            if (prefix.test(key)) {
                inkey = key.replace(replace, re_lower);
                out[inkey] = data[key];
            }
        return out;
    }
    function opts_from_locale(lang) {
        var out = {};
        if (!dates[lang]) {
            lang = lang.split('-')[0];
            if (!dates[lang])
                return;
        }
        var d = dates[lang];
        $.each(locale_opts, function (i, k) {
            if (k in d)
                out[k] = d[k];
        });
        return out;
    }
    var old = $.fn.datepicker;
    var datepickerPlugin = function (option) {
        var args = Array.apply(null, arguments);
        args.shift();
        var internal_return;
        this.each(function () {
            var $this = $(this), data = $this.data('datepicker'), options = typeof option === 'object' && option;
            if (!data) {
                var elopts = opts_from_el(this, 'date'), xopts = $.extend({}, defaults, elopts, options), locopts = opts_from_locale(xopts.language), opts = $.extend({}, defaults, locopts, elopts, options);
                if ($this.hasClass('input-daterange') || opts.inputs) {
                    $.extend(opts, { inputs: opts.inputs || $this.find('input').toArray() });
                    data = new DateRangePicker(this, opts);
                } else {
                    data = new Datepicker(this, opts);
                }
                $this.data('datepicker', data);
            }
            if (typeof option === 'string' && typeof data[option] === 'function') {
                internal_return = data[option].apply(data, args);
            }
        });
        if (internal_return === undefined || internal_return instanceof Datepicker || internal_return instanceof DateRangePicker)
            return this;
        if (this.length > 1)
            throw new Error('Using only allowed for the collection of a single element (' + option + ' function)');
        else
            return internal_return;
    };
    $.fn.datepicker = datepickerPlugin;
    var defaults = $.fn.datepicker.defaults = {
        autoclose: false,
        beforeShowDay: $.noop,
        beforeShowMonth: $.noop,
        beforeShowYear: $.noop,
        calendarWeeks: false,
        clearBtn: false,
        toggleActive: false,
        daysOfWeekDisabled: [],
        daysOfWeekHighlighted: [],
        datesDisabled: [],
        endDate: Infinity,
        forceParse: true,
        format: 'mm/dd/yyyy',
        keyboardNavigation: true,
        language: 'en',
        minViewMode: 0,
        maxViewMode: 2,
        multidate: false,
        multidateSeparator: ',',
        orientation: 'auto',
        rtl: false,
        startDate: -Infinity,
        startView: 0,
        todayBtn: false,
        todayHighlight: false,
        weekStart: 0,
        disableTouchKeyboard: false,
        enableOnReadonly: true,
        showOnFocus: true,
        zIndexOffset: 10,
        container: 'body',
        immediateUpdates: false,
        title: ''
    };
    var locale_opts = $.fn.datepicker.locale_opts = [
        'format',
        'rtl',
        'weekStart'
    ];
    $.fn.datepicker.Constructor = Datepicker;
    var dates = $.fn.datepicker.dates = {
        en: {
            days: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ],
            daysShort: [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat'
            ],
            daysMin: [
                'Su',
                'Mo',
                'Tu',
                'We',
                'Th',
                'Fr',
                'Sa'
            ],
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            monthsShort: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            today: 'Today',
            clear: 'Clear',
            titleFormat: 'MM yyyy'
        }
    };
    var DPGlobal = {
        modes: [
            {
                clsName: 'days',
                navFnc: 'Month',
                navStep: 1
            },
            {
                clsName: 'months',
                navFnc: 'FullYear',
                navStep: 1
            },
            {
                clsName: 'years',
                navFnc: 'FullYear',
                navStep: 10
            }
        ],
        isLeapYear: function (year) {
            return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
        },
        getDaysInMonth: function (year, month) {
            return [
                31,
                DPGlobal.isLeapYear(year) ? 29 : 28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ][month];
        },
        validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
        nonpunctuation: /[^ -\/:-@\[\u3400-\u9fff-`{-~\t\n\r]+/g,
        parseFormat: function (format) {
            if (typeof format.toValue === 'function' && typeof format.toDisplay === 'function')
                return format;
            var separators = format.replace(this.validParts, '\0').split('\0'), parts = format.match(this.validParts);
            if (!separators || !separators.length || !parts || parts.length === 0) {
                throw new Error('Invalid date format.');
            }
            return {
                separators: separators,
                parts: parts
            };
        },
        parseDate: function (date, format, language) {
            if (!date)
                return undefined;
            if (date instanceof Date)
                return date;
            if (typeof format === 'string')
                format = DPGlobal.parseFormat(format);
            if (format.toValue)
                return format.toValue(date, format, language);
            var part_re = /([\-+]\d+)([dmwy])/, parts = date.match(/([\-+]\d+)([dmwy])/g), fn_map = {
                    d: 'moveDay',
                    m: 'moveMonth',
                    w: 'moveWeek',
                    y: 'moveYear'
                }, part, dir, i, fn;
            if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)) {
                date = new Date();
                for (i = 0; i < parts.length; i++) {
                    part = part_re.exec(parts[i]);
                    dir = parseInt(part[1]);
                    fn = fn_map[part[2]];
                    date = Datepicker.prototype[fn](date, dir);
                }
                return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
            }
            parts = date && date.match(this.nonpunctuation) || [];
            date = new Date();
            var parsed = {}, setters_order = [
                    'yyyy',
                    'yy',
                    'M',
                    'MM',
                    'm',
                    'mm',
                    'd',
                    'dd'
                ], setters_map = {
                    yyyy: function (d, v) {
                        return d.setUTCFullYear(v);
                    },
                    yy: function (d, v) {
                        return d.setUTCFullYear(2000 + v);
                    },
                    m: function (d, v) {
                        if (isNaN(d))
                            return d;
                        v -= 1;
                        while (v < 0)
                            v += 12;
                        v %= 12;
                        d.setUTCMonth(v);
                        while (d.getUTCMonth() !== v)
                            d.setUTCDate(d.getUTCDate() - 1);
                        return d;
                    },
                    d: function (d, v) {
                        return d.setUTCDate(v);
                    }
                }, val, filtered;
            setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
            setters_map['dd'] = setters_map['d'];
            date = UTCToday();
            var fparts = format.parts.slice();
            if (parts.length !== fparts.length) {
                fparts = $(fparts).filter(function (i, p) {
                    return $.inArray(p, setters_order) !== -1;
                }).toArray();
            }
            function match_part() {
                var m = this.slice(0, parts[i].length), p = parts[i].slice(0, m.length);
                return m.toLowerCase() === p.toLowerCase();
            }
            if (parts.length === fparts.length) {
                var cnt;
                for (i = 0, cnt = fparts.length; i < cnt; i++) {
                    val = parseInt(parts[i], 10);
                    part = fparts[i];
                    if (isNaN(val)) {
                        switch (part) {
                        case 'MM':
                            filtered = $(dates[language].months).filter(match_part);
                            val = $.inArray(filtered[0], dates[language].months) + 1;
                            break;
                        case 'M':
                            filtered = $(dates[language].monthsShort).filter(match_part);
                            val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
                            break;
                        }
                    }
                    parsed[part] = val;
                }
                var _date, s;
                for (i = 0; i < setters_order.length; i++) {
                    s = setters_order[i];
                    if (s in parsed && !isNaN(parsed[s])) {
                        _date = new Date(date);
                        setters_map[s](_date, parsed[s]);
                        if (!isNaN(_date))
                            date = _date;
                    }
                }
            }
            return date;
        },
        formatDate: function (date, format, language) {
            if (!date)
                return '';
            if (typeof format === 'string')
                format = DPGlobal.parseFormat(format);
            if (format.toDisplay)
                return format.toDisplay(date, format, language);
            var val = {
                d: date.getUTCDate(),
                D: dates[language].daysShort[date.getUTCDay()],
                DD: dates[language].days[date.getUTCDay()],
                m: date.getUTCMonth() + 1,
                M: dates[language].monthsShort[date.getUTCMonth()],
                MM: dates[language].months[date.getUTCMonth()],
                yy: date.getUTCFullYear().toString().substring(2),
                yyyy: date.getUTCFullYear()
            };
            val.dd = (val.d < 10 ? '0' : '') + val.d;
            val.mm = (val.m < 10 ? '0' : '') + val.m;
            date = [];
            var seps = $.extend([], format.separators);
            for (var i = 0, cnt = format.parts.length; i <= cnt; i++) {
                if (seps.length)
                    date.push(seps.shift());
                date.push(val[format.parts[i]]);
            }
            return date.join('');
        },
        headTemplate: '<thead>' + '<tr>' + '<th colspan="7" class="datepicker-title"></th>' + '</tr>' + '<tr>' + '<th class="prev">&#171;</th>' + '<th colspan="5" class="datepicker-switch"></th>' + '<th class="next">&#187;</th>' + '</tr>' + '</thead>',
        contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
        footTemplate: '<tfoot>' + '<tr>' + '<th colspan="7" class="today"></th>' + '</tr>' + '<tr>' + '<th colspan="7" class="clear"></th>' + '</tr>' + '</tfoot>'
    };
    DPGlobal.template = '<div class="datepicker">' + '<div class="datepicker-days">' + '<table class=" table-condensed">' + DPGlobal.headTemplate + '<tbody></tbody>' + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datepicker-months">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datepicker-years">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '</div>';
    $.fn.datepicker.DPGlobal = DPGlobal;
    $.fn.datepicker.noConflict = function () {
        $.fn.datepicker = old;
        return this;
    };
    $.fn.datepicker.version = '1.5.1';
    $(document).on('focus.datepicker.data-api click.datepicker.data-api', '[data-provide="datepicker"]', function (e) {
        var $this = $(this);
        if ($this.data('datepicker'))
            return;
        e.preventDefault();
        datepickerPlugin.call($this, 'show');
    });
    $(function () {
        datepickerPlugin.call($('[data-provide="datepicker-inline"]'));
    });
}));
define('common-modules/ui/date-picker', ['bootstrap-datepicker'], function () {
    'use strict';
    var LOCALES = {};
    var LOCALE_NAME = 'all';
    LOCALES[LOCALE_NAME] = {
        days: [
            l('datepicker.sunday'),
            l('datepicker.monday'),
            l('datepicker.tuesday'),
            l('datepicker.wednesday'),
            l('datepicker.thursday'),
            l('datepicker.friday'),
            l('datepicker.saturday')
        ],
        daysShort: [
            l('datepicker.sunday.short'),
            l('datepicker.monday.short'),
            l('datepicker.tuesday.short'),
            l('datepicker.wednesday.short'),
            l('datepicker.thursday.short'),
            l('datepicker.friday.short'),
            l('datepicker.saturday.short')
        ],
        daysMin: [
            l('datepicker.sunday.min'),
            l('datepicker.monday.min'),
            l('datepicker.tuesday.min'),
            l('datepicker.wednesday.min'),
            l('datepicker.thursday.min'),
            l('datepicker.friday.min'),
            l('datepicker.saturday.min')
        ],
        months: [
            l('datepicker.january'),
            l('datepicker.february'),
            l('datepicker.march'),
            l('datepicker.april'),
            l('datepicker.may'),
            l('datepicker.june'),
            l('datepicker.july'),
            l('datepicker.august'),
            l('datepicker.september'),
            l('datepicker.october'),
            l('datepicker.november'),
            l('datepicker.december')
        ],
        monthsShort: [
            l('datepicker.january.short'),
            l('datepicker.february.short'),
            l('datepicker.march.short'),
            l('datepicker.april.short'),
            l('datepicker.may.short'),
            l('datepicker.june.short'),
            l('datepicker.july.short'),
            l('datepicker.august.short'),
            l('datepicker.september.short'),
            l('datepicker.october.short'),
            l('datepicker.november.short'),
            l('datepicker.december.short')
        ],
        today: l('datepicker.today'),
        clear: l('datepicker.clear'),
        weekStart: function () {
            var firstDay = parseInt(l('datepicker.weekStart'), 10);
            return _.isNaN(firstDay) ? 0 : firstDay;
        }(),
        format: l('datepicker.format'),
        titleFormat: l('datepicker.titleFormat')
    };
    $.fn.datepicker.defaults.language = LOCALE_NAME;
    $.fn.datepicker.dates[LOCALE_NAME] = LOCALES[LOCALE_NAME];
    return $;
});
define('common-modules/forms/views/date-input', [
    'moment',
    'common-modules/ui/date-picker'
], function (moment) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template(''),
        tagName: 'span',
        events: { changeDate: 'onChange' },
        triggers: {
            focus: 'focus',
            blur: 'blur'
        },
        getEl: function () {
            var $el = this.$el;
            return $el.prop('tagName') !== 'INPUT' ? $el.find('input') : $el;
        },
        initialize: function (options) {
            if (this.$el.prop('tagName') === 'SPAN') {
                this.template = _.template('<input type="text" readonly="true" class="adb-date"></div><i class="adb-date--icon adb-icon__calendar"></i>');
            }
            options = options || {};
            this.isSmall = !!options.isSmall;
            this.orientation = options.orientation || this.constructor.DEFAULT_ORIENTATION;
            this.initialValue = options.initialValue;
            this.dateFormat = options.dateFormat || this.constructor.DEFAULT_DATE_FORMAT;
            this.minimumDate = options.minimumDate;
            this.maximumDate = options.maximumDate;
            this.useEndOfDay = !!options.useEndOfDay;
            this.zIndexOffset = options.zIndexOffset;
        },
        onRender: function () {
            var $el = this.getEl();
            $el.toggleClass('adb-date__small', this.isSmall);
            this.$el.toggleClass('adb-date--container', this.$el.prop('tagName') === 'SPAN');
            $el.datepicker({
                clearBtn: true,
                startDate: this.minimumDate ? moment(this.minimumDate).toDate() : null,
                endDate: this.maximumDate ? moment(this.maximumDate).toDate() : null,
                format: this.dateFormat,
                forceParse: false,
                orientation: this.orientation,
                zIndexOffset: this.zIndexOffset
            });
            if (this.initialValue) {
                $el.datepicker('setDate', this.initialValue);
            }
            this.getDatepicker().hide();
        },
        getOrientation: function () {
            return this.orientation;
        },
        getValue: function () {
            var date = this.getDatepicker().getDate();
            var mom = date ? moment(date) : null;
            if (mom && this.useEndOfDay) {
                return +mom.endOf('day');
            } else if (mom) {
                return +mom.startOf('day');
            }
            return null;
        },
        setValue: function (milli) {
            this.getDatepicker().setDate(milli ? moment(milli).toDate() : null);
        },
        isAfterMinimumDate: function (milli) {
            return milli && this.minimumDate ? +moment(this.minimumDate).startOf('day') <= milli : true;
        },
        isBeforeMaximumDate: function (milli) {
            return milli && this.maximumDate ? +moment(this.maximumDate).endOf('day') >= milli : true;
        },
        canBeSet: function (milli) {
            return this.isAfterMinimumDate(milli) && this.isBeforeMaximumDate(milli);
        },
        setMinimumDate: function (milli) {
            this.minimumDate = milli || null;
            this.getDatepicker().setStartDate(this.minimumDate ? moment(this.minimumDate).toDate() : null);
            this.getDatepicker().setValue();
        },
        setMaximumDate: function (milli) {
            this.maximumDate = milli || null;
            this.getDatepicker().setEndDate(this.maximumDate ? moment(this.maximumDate).toDate() : null);
            this.getDatepicker().setValue();
        },
        onChange: function () {
            var datepicker = this.getDatepicker();
            if (!datepicker) {
                return;
            }
            datepicker.hide();
            var value = this.getValue();
            this.trigger('change', value);
            this.getEl().trigger('changedate');
        },
        getDatepicker: function () {
            return this.getEl().data('datepicker');
        }
    }, {
        DEFAULT_DATE_FORMAT: l('datepicker.format') || 'yyyy-mm-dd',
        DEFAULT_ORIENTATION: 'auto'
    });
});
define('common-modules/forms/views/fields/date-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/date-input'
], function (BaseField, DateInput) {
    'use strict';
    return BaseField.extend({
        initialize: function (options) {
            BaseField.prototype.initialize.call(this, options);
            this.dateInputOptions = this.schema.dateInputOptions;
        },
        initSubView: function () {
            return new DateInput(this.dateInputOptions);
        },
        getValue: function () {
            return this.subView.getValue();
        },
        setValue: function (value) {
            this.subView.setValue(value);
        },
        focus: function () {
            if (this.hasFocus) {
                return;
            }
            this.subView.$el.focus();
        },
        blur: function () {
            if (!this.hasFocus) {
                return;
            }
            this.subView.$el.blur();
        }
    });
});
define('common-modules/forms/templates/toggle.tpl.html', [], function () {
    return '<label for="<%- cid %>" class="js-option-selector <%- labelClass %>">\n\t<input class="adb-toggle--input" id="<%- cid %>" value="<%- value %>" type="<%- inputType %>" name="<%- collectionCid %>">\n\t<span class="adb-toggle--control"></span>\n\t<span class="adb-toggle--value"><%- label %></span>\n</label>\n<div class="js-caption">\n\t<div class="adb-caption adb-form--caption"><%- help %></div>\n</div>\n';
});
define('common-modules/forms/views/toggle', [
    'common-modules/forms/views/option-selector-base',
    'common-modules/forms/templates/toggle.tpl.html'
], function (OptionSelector, template) {
    'use strict';
    var ToggleItem = OptionSelector.OptionSelectorItem.extend({
        inputType: 'checkbox',
        labelClass: 'adb-toggle',
        template: _.template(template)
    });
    var ToggleGroup = OptionSelector.OptionSelectorGroup.extend({ itemView: ToggleItem });
    return {
        ToggleItem: ToggleItem,
        ToggleGroup: ToggleGroup
    };
});
define('common-modules/forms/views/fields/toggles-field', [
    'common-modules/forms/views/fields/checkboxes-field',
    'common-modules/forms/views/toggle'
], function (CheckboxesField, Toggle) {
    'use strict';
    return CheckboxesField.extend({
        getSubView: function () {
            return Toggle.ToggleGroup;
        }
    });
});
define('common-modules/forms/views/fields/number-field', ['backbone-forms'], function (Form) {
    'use strict';
    return Form.editors.Number.extend({ defaultValue: null });
});
define('common-modules/forms/views/rating-input', ['common-modules/status/views/rating'], function (Rating) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template('<div class="js-rating-container"></div><div class="js-rating-text"></div>'),
        regions: { ratingContainer: '.js-rating-container' },
        ui: { ratingText: '.js-rating-text' },
        events: { changeDate: 'onChange' },
        initialize: function (options) {
            options = options || {};
        },
        onRender: function () {
            this.rating = new Rating({
                editable: true,
                rating: 0
            });
            this.ratingContainer.show(this.rating);
            this.rating.$el.addClass('adb-rating__edit');
            this.listenTo(this.rating, 'change', _.bind(this.renderText, this));
            this.renderText();
        },
        renderText: function (rating) {
            if (rating > 0) {
                var text = rating > 1 ? l('stars', rating) : l('star', rating);
                this.ui.ratingText.text(text);
            } else {
                this.ui.ratingText.empty();
            }
        },
        getValue: function () {
            return this.rating.getValue();
        },
        setValue: function (value) {
            this.rating.setValue(value || 0);
        },
        onChange: function () {
            this.getDatepicker().hide();
            var value = this.getValue();
            this.trigger('change', value);
        }
    });
});
define('common-modules/forms/views/fields/rating-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/rating-input'
], function (BaseField, RatingInput) {
    'use strict';
    return BaseField.extend({
        initialize: function (options) {
            BaseField.prototype.initialize.call(this, options);
            this.ratingOptions = options.schema;
        },
        initSubView: function () {
            return new RatingInput(this.ratingOptions);
        },
        getValue: function () {
            return this.subView.getValue();
        },
        setValue: function (value) {
            this.subView.setValue(value);
        }
    });
});
define('common-modules/forms/views/fields/url-field', ['backbone-forms'], function (Form) {
    'use strict';
    return Form.editors.Text.extend({
        attributes: { type: 'url' },
        render: function (options) {
            Form.editors.Text.prototype.render.call(this, options);
            this.$el.attr('type', 'url');
            return this;
        }
    });
});
define('common-modules/forms/views/textarea-input', ['common-modules/behaviors/char-countdown'], function (CharCountdown) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template('<textarea></textarea>'),
        behaviors: function () {
            if (this.options.count) {
                return {
                    CharCountdown: {
                        behaviorClass: CharCountdown,
                        count: this.options.count
                    }
                };
            }
            return {};
        },
        triggers: {
            'focus @ui.textarea': 'focus',
            'blur @ui.textarea': 'blur'
        },
        ui: { textarea: 'textarea' },
        initialize: function (options) {
            options = options || {};
            this.count = options.count;
            this.placeholder = options.placeholder;
        },
        onRender: function () {
            if (this.placeholder) {
                this.ui.textarea.attr('placeholder', this.placeholder);
            }
        },
        setError: function () {
            this.ui.textarea.attr('data-error', '');
        },
        clearError: function () {
            this.ui.textarea.removeAttr('data-error');
        },
        getValue: function () {
            return this.ui.textarea.val();
        },
        setValue: function (text) {
            this.ui.textarea.val(text);
        }
    });
});
define('common-modules/forms/views/fields/textarea-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/textarea-input'
], function (BaseField, TextAreaInput) {
    'use strict';
    return BaseField.extend({
        initialize: function (options) {
            BaseField.prototype.initialize.call(this, options);
            this.textareaOptions = options.schema;
        },
        initSubView: function () {
            this.subview = new TextAreaInput(this.textareaOptions);
            return this.subview;
        },
        getValue: function () {
            return this.subView.getValue();
        },
        setValue: function (value) {
            this.subView.setValue(value);
        },
        validate: function () {
            var error = BaseField.prototype.validate.apply(this, arguments);
            if (error) {
                this.subview.setError();
            } else {
                this.subview.clearError();
            }
            return error;
        },
        focus: function () {
            if (this.hasFocus) {
                return;
            }
            this.subView.ui.textarea.focus();
        },
        blur: function () {
            if (!this.hasFocus) {
                return;
            }
            this.subView.ui.textarea.blur();
        }
    });
});
define('common-modules/utils/countries/zip-code-validation', ['common-modules/utils/countries/countries'], function (countries) {
    'use strict';
    return {
        validate: function (countryCode, zipcode) {
            var r = this.getCountryRegExp(countryCode);
            return r ? r.test(zipcode) : false;
        },
        getCountryRegExp: function (countryCode) {
            var cleanedCountryCode = this._getCleanedCountryCode(countryCode);
            var zipcodeRegex = {
                GB: /^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}$/,
                JE: /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
                GG: /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
                IM: /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
                US: /^\d{5}([ \-]\d{4})?$/,
                CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$$/,
                DE: /^\d{5}$/,
                JP: /^\d{3}-\d{4}$/,
                FR: /^\d{2}[ ]?\d{3}$/,
                AU: /^\d{4}$/,
                IT: /^\d{5}$/,
                CH: /^\d{4}$/,
                AT: /^\d{4}$/,
                ES: /^\d{5}$/,
                NL: /^\d{4}[ ]?[A-Z]{2}$/,
                BE: /^\d{4}$/,
                DK: /^[1-9]{1}[0-9]{3}$/,
                SE: /^\d{3}[ ]?\d{2}$/,
                NO: /^\d{4}$/,
                BR: /^\d{5}[\-]?\d{3}$/,
                PT: /^\d{4}([\-]\d{3})?$/,
                FI: /^\d{5}$/,
                AX: /^22\d{3}$/,
                KR: /^\d{5}$/,
                CN: /^\d{6}$/,
                TW: /^\d{3}(\d{2})?$/,
                SG: /^\d{6}$/,
                DZ: /^\d{5}$/,
                AD: /^AD\d{3}$/,
                AR: /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/,
                AM: /^(37)?\d{4}$/,
                AZ: /^\d{4}$/,
                BH: /^((1[0-2]|[2-9])\d{2})?$/,
                BD: /^\d{4}$/,
                BB: /^(BB\d{5})?$/,
                BY: /^\d{6}$/,
                BM: /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/,
                BA: /^\d{5}$/,
                IO: /^BBND 1ZZ$/,
                BN: /^[A-Z]{2}[ ]?\d{4}$/,
                BG: /^\d{4}$/,
                KH: /^\d{5}$/,
                CV: /^\d{4}$/,
                CL: /^\d{7}$/,
                CR: /^\d{4,5}|\d{3}-\d{4}$/,
                HR: /^\d{5}$/,
                CY: /^\d{4}$/,
                CZ: /^\d{3}[ ]\d{2}$/,
                DO: /^\d{5}$/,
                EC: /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/,
                EG: /^\d{5}$/,
                EE: /^\d{5}$/,
                FO: /^\d{3}$/,
                GE: /^\d{4}$/,
                GR: /(^[0-8][0-9]{4,4}$)|(^90000$)/,
                GL: /^39\d{2}$/,
                GT: /^\d{5}$/,
                HT: /^\d{4}$/,
                HN: /^(?:\d{5})?$/,
                HU: /^\d{4}$/,
                IS: /^\d{3}$/,
                IN: /^\d{6}$/,
                ID: /^\d{5}$/,
                IL: /^\d{5}$/,
                JO: /^\d{5}$/,
                KZ: /^\d{6}$/,
                KE: /^\d{5}$/,
                KW: /^\d{5}$/,
                LA: /^\d{5}$/,
                LV: /^\d{4}$/,
                LB: /^(\d{4}([ ]?\d{4})?)?$/,
                LI: /^(948[5-9])|(949[0-7])$/,
                LT: /^\d{5}$/,
                LU: /^\d{4}$/,
                MK: /^\d{4}$/,
                MY: /^\d{5}$/,
                MV: /^\d{5}$/,
                MT: /^[A-Z]{3}[ ]?\d{2,4}$/,
                MU: /^(\d{3}[A-Z]{2}\d{3})?$/,
                MX: /^\d{5}$/,
                MD: /^\d{4}$/,
                MC: /^980\d{2}$/,
                MA: /^\d{5}$/,
                NP: /^\d{5}$/,
                NZ: /^\d{4}$/,
                NI: /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/,
                NG: /^(\d{6})?$/,
                OM: /^(PC )?\d{3}$/,
                PK: /^\d{5}$/,
                PY: /^\d{4}$/,
                PH: /^\d{4}$/,
                PL: /^\d{2}-\d{3}$/,
                PR: /^00[679]\d{2}([ \-]\d{4})?$/,
                RO: /^\d{6}$/,
                RU: /^\d{6}$/,
                SM: /^4789\d$/,
                SA: /^\d{5}$/,
                SN: /^\d{5}$/,
                SK: /^\d{3}[ ]?\d{2}$/,
                SI: /^\d{4}$/,
                ZA: /^\d{4}$/,
                LK: /^\d{5}$/,
                TJ: /^\d{6}$/,
                TH: /^\d{5}$/,
                TN: /^\d{4}$/,
                TR: /^\d{5}$/,
                TM: /^\d{6}$/,
                UA: /^\d{5}$/,
                UY: /^\d{5}$/,
                UZ: /^\d{6}$/,
                VA: /^00120$/,
                VE: /^\d{4}$/,
                ZM: /^\d{5}$/,
                AS: /^96799$/,
                CC: /^6799$/,
                CK: /^\d{4}$/,
                RS: /^\d{6}$/,
                ME: /^8\d{4}$/,
                CS: /^\d{5}$/,
                YU: /^\d{5}$/,
                CX: /^6798$/,
                ET: /^\d{4}$/,
                FK: /^FIQQ 1ZZ$/,
                NF: /^2899$/,
                FM: /^(9694[1-4])([ \-]\d{4})?$/,
                GF: /^9[78]3\d{2}$/,
                GN: /^\d{3}$/,
                GP: /^9[78][01]\d{2}$/,
                GS: /^SIQQ 1ZZ$/,
                GU: /^969[123]\d([ \-]\d{4})?$/,
                GW: /^\d{4}$/,
                HM: /^\d{4}$/,
                IQ: /^\d{5}$/,
                KG: /^\d{6}$/,
                LR: /^\d{4}$/,
                LS: /^\d{3}$/,
                MG: /^\d{3}$/,
                MH: /^969[67]\d([ \-]\d{4})?$/,
                MN: /^\d{6}$/,
                MP: /^9695[012]([ \-]\d{4})?$/,
                MQ: /^9[78]2\d{2}$/,
                NC: /^988\d{2}$/,
                NE: /^\d{4}$/,
                VI: /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/,
                PF: /^987\d{2}$/,
                PG: /^\d{3}$/,
                PM: /^9[78]5\d{2}$/,
                PN: /^PCRN 1ZZ$/,
                PW: /^96940$/,
                RE: /^9[78]4\d{2}$/,
                SH: /^(ASCN|STHL) 1ZZ$/,
                SJ: /^\d{4}$/,
                SO: /^\d{5}$/,
                SZ: /^[HLMS]\d{3}$/,
                TC: /^TKCA 1ZZ$/,
                WF: /^986\d{2}$/,
                XK: /^\d{5}$/,
                YT: /^976\d{2}$/,
                CO: /^\d{6}$/,
                PA: /^\d{4}$/,
                SV: /^\d{5}$/,
                BO: /^\d{5}$/,
                IE: /.*/,
                AL: /^\d{4}$/
            };
            return _.has(zipcodeRegex, cleanedCountryCode) ? zipcodeRegex[cleanedCountryCode] : false;
        },
        _getCleanedCountryCode: function (countryCode) {
            if (countryCode.length === 2) {
                return countryCode;
            } else if (countryCode.length === 3) {
                return this._getCountryCodeFromIso3(countryCode);
            }
        },
        _getCountryCodeFromIso3: function (countryCode) {
            var country = _.findWhere(countries, { value_iso3: countryCode });
            return country ? country.value : undefined;
        }
    };
});
define('common-modules/utils/countries/zip-code-formatter', ['common-modules/utils/countries/zip-code-validation'], function (zipCodeValidation) {
    'use strict';
    var ZipCodeFormatter = function (opts) {
        this._countryCodeIso3 = opts.countryCodeIso3;
        this._value = opts.value;
    };
    _.extend(ZipCodeFormatter.prototype, {
        getFormattedValue: function () {
            var formatMethodName = '_format' + this._countryCodeIso3;
            return _.isFunction(this[formatMethodName]) && zipCodeValidation.validate(this._countryCodeIso3, this._value) === true ? this[formatMethodName]() : this._value;
        },
        _formatSWE: function () {
            var value = this._value;
            return _.contains(value, ' ') ? value : value.substring(0, 3) + ' ' + value.substring(3, 5);
        },
        _formatUSA: function () {
            var v = this._value.trim();
            return v.length > 5 ? v.replace(' ', '-') : v;
        }
    });
    return ZipCodeFormatter;
});
define('common-modules/forms/views/fields/zipcode-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/text-input',
    'common-modules/forms/views/fields/validation-messages',
    'common-modules/utils/countries/zip-code-validation',
    'common-modules/utils/countries/zip-code-formatter'
], function (BaseField, TextView, validationMessages, zipCodeValidation, ZipCodeFormatter) {
    'use strict';
    return BaseField.extend({
        initialize: function (options) {
            BaseField.prototype.initialize.call(this, options);
        },
        events: { change: '_format' },
        initSubView: function () {
            return new TextView();
        },
        getValue: function () {
            return this.subView.val();
        },
        setValue: function (value) {
            this.subView.val(value);
        },
        _getCountryValidation: function () {
            return _.has(this.form.fields, this.schema.countryCodeValidationField) ? this.form.fields[this.schema.countryCodeValidationField].getValue() : undefined;
        },
        validate: function () {
            var errors = BaseField.prototype.validate.call(this);
            if (errors) {
                return errors;
            }
            var countryCodeIso3 = this._getCountryValidation();
            if (!countryCodeIso3) {
                return;
            }
            if (!zipCodeValidation.validate(countryCodeIso3, this.getValue())) {
                return this._getErrorMsg();
            }
        },
        _format: function () {
            if (this.schema.autoFormat) {
                this.setValue(new ZipCodeFormatter({
                    value: this.getValue(),
                    countryCodeIso3: this._getCountryValidation()
                }).getFormattedValue());
            }
        },
        _getErrorMsg: function () {
            return {
                type: 'zipCode',
                value: this.getValue(),
                message: validationMessages.zipCode
            };
        }
    });
});
define('common-modules/forms/templates/color-input.tpl.html', [], function () {
    return '<div style="display: table">\n    <input class="js-ui-text" type="text" style="display: table-cell;\n    border-right: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius:0;">\n    <span class="js-ui-toggle" style="\n        padding: 6px 12px;\n        display: table-cell;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 1;\n        text-align: center;\n        background-color: whitesmoke;\n        border: 1px solid #cbcbcb;\n        margin-left: -1px;\n        border-top-right-radius: 3px;\n        border-bottom-right-radius: 3px;">\n        <i class="js-ui-color" style="\n            display: inline-block;\n            cursor: pointer;\n            height: 18px;\n            vertical-align: text-top;\n            width: 18px;\n            border: 1px solid #979797;\n            border-radius: 3px">\n        </i>\n    </span>\n</div>\n';
});
define('common-modules/utils/color-utils', [], function () {
    'use strict';
    return {
        innerInput: {
            buildCallback: function ($elm) {
                var colorInstance = this.color;
                var colorPicker = this;
                $elm.append('<div class="cp-panel"><input type="text" class="cp-HEX"></div>').on('input', 'input', function () {
                    var validHex = /^#[a-fA-F0-9]{6}$/;
                    var value = this.value;
                    if (validHex.test(value)) {
                        colorInstance.setColor(value, 'HEX');
                        colorPicker.render();
                        this.blur();
                    }
                });
            },
            cssAddon: '.cp-color-picker{box-sizing:border-box; height:202px;}' + '.cp-color-picker .cp-panel {line-height: 21px; float:left;' + 'padding:0 1px 0 8px; margin-top:-1px; overflow:visible}' + '.cp-panel .cp-HEX {width: 8em; position:relative;' + 'box-shadow: inset 0 1px 3px 0 rgba(45, 45, 45, 0.1); font-size: 14px;' + 'line-height: 1.6em; padding: 7px 12px 5px; height: 18px;' + 'border-radius: 3px; border: 1px solid #cbcbcb;' + 'background-color: #ffffff; color: #575757;}' + '.cp-alpha {width:155px;}'
        }
    };
});
!function (a, b) {
    'object' == typeof exports ? module.exports = b(a) : 'function' == typeof define && define.amd ? define('colors', [], function () {
        return b(a);
    }) : a.Colors = b(a);
}(this, function (a, b) {
    'use strict';
    function c(a, c, d, f, g) {
        if ('string' == typeof c) {
            var c = v.txt2color(c);
            d = c.type, p[d] = c[d], g = g !== b ? g : c.alpha;
        } else if (c)
            for (var h in c)
                a[d][h] = k(c[h] / l[d][h][1], 0, 1);
        return g !== b && (a.alpha = k(+g, 0, 1)), e(d, f ? a : b);
    }
    function d(a, b, c) {
        var d = o.options.grey, e = {};
        return e.RGB = {
            r: a.r,
            g: a.g,
            b: a.b
        }, e.rgb = {
            r: b.r,
            g: b.g,
            b: b.b
        }, e.alpha = c, e.equivalentGrey = n(d.r * a.r + d.g * a.g + d.b * a.b), e.rgbaMixBlack = i(b, {
            r: 0,
            g: 0,
            b: 0
        }, c, 1), e.rgbaMixWhite = i(b, {
            r: 1,
            g: 1,
            b: 1
        }, c, 1), e.rgbaMixBlack.luminance = h(e.rgbaMixBlack, !0), e.rgbaMixWhite.luminance = h(e.rgbaMixWhite, !0), o.options.customBG && (e.rgbaMixCustom = i(b, o.options.customBG, c, 1), e.rgbaMixCustom.luminance = h(e.rgbaMixCustom, !0), o.options.customBG.luminance = h(o.options.customBG, !0)), e;
    }
    function e(a, b) {
        var c, e, k, q = b || p, r = v, s = o.options, t = l, u = q.RND, w = '', x = '', y = {
                hsl: 'hsv',
                rgb: a
            }, z = u.rgb;
        if ('alpha' !== a) {
            for (var A in t)
                if (!t[A][A]) {
                    a !== A && (x = y[A] || 'rgb', q[A] = r[x + '2' + A](q[x])), u[A] || (u[A] = {}), c = q[A];
                    for (w in c)
                        u[A][w] = n(c[w] * t[A][w][1]);
                }
            z = u.rgb, q.HEX = r.RGB2HEX(z), q.equivalentGrey = s.grey.r * q.rgb.r + s.grey.g * q.rgb.g + s.grey.b * q.rgb.b, q.webSave = e = f(z, 51), q.webSmart = k = f(z, 17), q.saveColor = z.r === e.r && z.g === e.g && z.b === e.b ? 'web save' : z.r === k.r && z.g === k.g && z.b === k.b ? 'web smart' : '', q.hueRGB = v.hue2RGB(q.hsv.h), b && (q.background = d(z, q.rgb, q.alpha));
        }
        var B, C, D, E = q.rgb, F = q.alpha, G = 'luminance', H = q.background;
        return B = i(E, {
            r: 0,
            g: 0,
            b: 0
        }, F, 1), B[G] = h(B, !0), q.rgbaMixBlack = B, C = i(E, {
            r: 1,
            g: 1,
            b: 1
        }, F, 1), C[G] = h(C, !0), q.rgbaMixWhite = C, s.customBG && (D = i(E, H.rgbaMixCustom, F, 1), D[G] = h(D, !0), D.WCAG2Ratio = j(D[G], H.rgbaMixCustom[G]), q.rgbaMixBGMixCustom = D, D.luminanceDelta = m.abs(D[G] - H.rgbaMixCustom[G]), D.hueDelta = g(H.rgbaMixCustom, D, !0)), q.RGBLuminance = h(z), q.HUELuminance = h(q.hueRGB), s.convertCallback && s.convertCallback(q, a), q;
    }
    function f(a, b) {
        var c = {}, d = 0, e = b / 2;
        for (var f in a)
            d = a[f] % b, c[f] = a[f] + (d > e ? b - d : -d);
        return c;
    }
    function g(a, b, c) {
        return (m.max(a.r - b.r, b.r - a.r) + m.max(a.g - b.g, b.g - a.g) + m.max(a.b - b.b, b.b - a.b)) * (c ? 255 : 1) / 765;
    }
    function h(a, b) {
        for (var c = b ? 1 : 255, d = [
                    a.r / c,
                    a.g / c,
                    a.b / c
                ], e = o.options.luminance, f = d.length; f--;)
            d[f] = d[f] <= 0.03928 ? d[f] / 12.92 : m.pow((d[f] + 0.055) / 1.055, 2.4);
        return e.r * d[0] + e.g * d[1] + e.b * d[2];
    }
    function i(a, c, d, e) {
        var f = {}, g = d !== b ? d : 1, h = e !== b ? e : 1, i = g + h * (1 - g);
        for (var j in a)
            f[j] = (a[j] * g + c[j] * h * (1 - g)) / i;
        return f.a = i, f;
    }
    function j(a, b) {
        var c = 1;
        return c = a >= b ? (a + 0.05) / (b + 0.05) : (b + 0.05) / (a + 0.05), n(100 * c) / 100;
    }
    function k(a, b, c) {
        return a > c ? c : b > a ? b : a;
    }
    var l = {
            rgb: {
                r: [
                    0,
                    255
                ],
                g: [
                    0,
                    255
                ],
                b: [
                    0,
                    255
                ]
            },
            hsv: {
                h: [
                    0,
                    360
                ],
                s: [
                    0,
                    100
                ],
                v: [
                    0,
                    100
                ]
            },
            hsl: {
                h: [
                    0,
                    360
                ],
                s: [
                    0,
                    100
                ],
                l: [
                    0,
                    100
                ]
            },
            alpha: {
                alpha: [
                    0,
                    1
                ]
            },
            HEX: {
                HEX: [
                    0,
                    16777215
                ]
            }
        }, m = a.Math, n = m.round, o = {}, p = {}, q = {
            r: 0.298954,
            g: 0.586434,
            b: 0.114612
        }, r = {
            r: 0.2126,
            g: 0.7152,
            b: 0.0722
        }, s = function (a) {
            this.colors = { RND: {} }, this.options = {
                color: 'rgba(204, 82, 37, 0.8)',
                grey: q,
                luminance: r,
                valueRanges: l
            }, t(this, a || {});
        }, t = function (a, d) {
            var e, f = a.options;
            u(a);
            for (var g in d)
                d[g] !== b && (f[g] = d[g]);
            e = f.customBG, f.customBG = 'string' == typeof e ? v.txt2color(e).rgb : e, p = c(a.colors, f.color, b, !0);
        }, u = function (a) {
            o !== a && (o = a, p = a.colors);
        };
    s.prototype.setColor = function (a, d, f) {
        return u(this), a ? c(this.colors, a, d, b, f) : (f !== b && (this.colors.alpha = k(f, 0, 1)), e(d));
    }, s.prototype.setCustomBackground = function (a) {
        return u(this), this.options.customBG = 'string' == typeof a ? v.txt2color(a).rgb : a, c(this.colors, b, 'rgb');
    }, s.prototype.saveAsBackground = function () {
        return u(this), c(this.colors, b, 'rgb', !0);
    }, s.prototype.toString = function (a, b) {
        return v.color2text((a || 'rgb').toLowerCase(), this.colors, b);
    };
    var v = {
        txt2color: function (a) {
            var b = {}, c = a.replace(/(?:#|\)|%)/g, '').split('('), d = (c[1] || '').split(/,\s*/), e = c[1] ? c[0].substr(0, 3) : 'rgb', f = '';
            if (b.type = e, b[e] = {}, c[1])
                for (var g = 3; g--;)
                    f = e[g] || e.charAt(g), b[e][f] = +d[g] / l[e][f][1];
            else
                b.rgb = v.HEX2rgb(c[0]);
            return b.alpha = d[3] ? +d[3] : 1, b;
        },
        color2text: function (a, b, c) {
            var d = c !== !1 && n(100 * b.alpha) / 100, e = 'number' == typeof d && c !== !1 && (c || 1 !== d), f = b.RND.rgb, g = b.RND.hsl, h = 'hex' === a && e, i = 'hex' === a && !h, j = 'rgb' === a || h, k = j ? f.r + ', ' + f.g + ', ' + f.b : i ? '#' + b.HEX : g.h + ', ' + g.s + '%, ' + g.l + '%';
            return i ? k : (h ? 'rgb' : a) + (e ? 'a' : '') + '(' + k + (e ? ', ' + d : '') + ')';
        },
        RGB2HEX: function (a) {
            return ((a.r < 16 ? '0' : '') + a.r.toString(16) + (a.g < 16 ? '0' : '') + a.g.toString(16) + (a.b < 16 ? '0' : '') + a.b.toString(16)).toUpperCase();
        },
        HEX2rgb: function (a) {
            return a = a.split(''), {
                r: +('0x' + a[0] + a[a[3] ? 1 : 0]) / 255,
                g: +('0x' + a[a[3] ? 2 : 1] + (a[3] || a[1])) / 255,
                b: +('0x' + (a[4] || a[2]) + (a[5] || a[2])) / 255
            };
        },
        hue2RGB: function (a) {
            var b = 6 * a, c = ~~b % 6, d = 6 === b ? 0 : b - c;
            return {
                r: n(255 * [
                    1,
                    1 - d,
                    0,
                    0,
                    d,
                    1
                ][c]),
                g: n(255 * [
                    d,
                    1,
                    1,
                    1 - d,
                    0,
                    0
                ][c]),
                b: n(255 * [
                    0,
                    0,
                    d,
                    1,
                    1,
                    1 - d
                ][c])
            };
        },
        rgb2hsv: function (a) {
            var b, c, d, e = a.r, f = a.g, g = a.b, h = 0;
            return g > f && (f = g + (g = f, 0), h = -1), c = g, f > e && (e = f + (f = e, 0), h = -2 / 6 - h, c = m.min(f, g)), b = e - c, d = e ? b / e : 0, {
                h: 1e-15 > d ? p && p.hsl && p.hsl.h || 0 : b ? m.abs(h + (f - g) / (6 * b)) : 0,
                s: e ? b / e : p && p.hsv && p.hsv.s || 0,
                v: e
            };
        },
        hsv2rgb: function (a) {
            var b = 6 * a.h, c = a.s, d = a.v, e = ~~b, f = b - e, g = d * (1 - c), h = d * (1 - f * c), i = d * (1 - (1 - f) * c), j = e % 6;
            return {
                r: [
                    d,
                    h,
                    g,
                    g,
                    i,
                    d
                ][j],
                g: [
                    i,
                    d,
                    d,
                    h,
                    g,
                    g
                ][j],
                b: [
                    g,
                    g,
                    i,
                    d,
                    d,
                    h
                ][j]
            };
        },
        hsv2hsl: function (a) {
            var b = (2 - a.s) * a.v, c = a.s * a.v;
            return c = a.s ? 1 > b ? b ? c / b : 0 : c / (2 - b) : 0, {
                h: a.h,
                s: a.v || c ? c : p && p.hsl && p.hsl.s || 0,
                l: b / 2
            };
        },
        rgb2hsl: function (a, b) {
            var c = v.rgb2hsv(a);
            return v.hsv2hsl(b ? c : p.hsv = c);
        },
        hsl2rgb: function (a) {
            var b = 6 * a.h, c = a.s, d = a.l, e = 0.5 > d ? d * (1 + c) : d + c - c * d, f = d + d - e, g = e ? (e - f) / e : 0, h = ~~b, i = b - h, j = e * g * i, k = f + j, l = e - j, m = h % 6;
            return {
                r: [
                    e,
                    l,
                    f,
                    f,
                    k,
                    e
                ][m],
                g: [
                    k,
                    e,
                    e,
                    l,
                    f,
                    f
                ][m],
                b: [
                    f,
                    f,
                    k,
                    e,
                    e,
                    l
                ][m]
            };
        }
    };
    return s;
}), function (a, b) {
    'object' == typeof exports ? module.exports = b(a, require('jquery'), require('colors')) : 'function' == typeof define && define.amd ? define('common-vendor/tinyColorPicker/jqColorPicker.min', [
        'jquery',
        'colors'
    ], function (c, d) {
        return b(a, c, d);
    }) : b(a, a.jQuery, a.Colors);
}(this, function (a, b, c, d) {
    'use strict';
    function e(a) {
        return a.value || a.getAttribute('value') || b(a).css('background-color') || '#FFF';
    }
    function f(a) {
        return a = a.originalEvent && a.originalEvent.touches ? a.originalEvent.touches[0] : a, a.originalEvent ? a.originalEvent : a;
    }
    function g(a) {
        return b(a.find(r.doRender)[0] || a[0]);
    }
    function h(c) {
        var d = b(this), f = d.offset(), h = b(a), k = r.gap;
        c ? (s = g(d), s._colorMode = s.data('colorMode'), p.$trigger = d, (t || i()).css(r.positionCallback.call(p, d) || {
            left: (t._left = f.left) - ((t._left += t._width - (h.scrollLeft() + h.width())) + k > 0 ? t._left + k : 0),
            top: (t._top = f.top + d.outerHeight()) - ((t._top += t._height - (h.scrollTop() + h.height())) + k > 0 ? t._top + k : 0)
        }).show(r.animationSpeed, function () {
            c !== !0 && (y.toggle(!!r.opacity)._width = y.width(), v._width = v.width(), v._height = v.height(), u._height = u.height(), q.setColor(e(s[0])), n(!0));
        }).off('.tcp').on(D, '.cp-xy-slider,.cp-z-slider,.cp-alpha', j)) : p.$trigger && b(t).hide(r.animationSpeed, function () {
            n(!1), p.$trigger = null;
        }).off('.tcp');
    }
    function i() {
        return b('head').append('<style type="text/css" id="tinyColorPickerStyles">' + (r.css || I) + (r.cssAddon || '') + '</style>'), b(H).css({ margin: r.margin }).appendTo('body').show(0, function () {
            p.$UI = t = b(this), F = r.GPU && t.css('perspective') !== d, u = b('.cp-z-slider', this), v = b('.cp-xy-slider', this), w = b('.cp-xy-cursor', this), x = b('.cp-z-cursor', this), y = b('.cp-alpha', this), z = b('.cp-alpha-cursor', this), r.buildCallback.call(p, t), t.prepend('<div>').children().eq(0).css('width', t.children().eq(0).width()), t._width = this.offsetWidth, t._height = this.offsetHeight;
        }).hide();
    }
    function j(a) {
        var c = this.className.replace(/cp-(.*?)(?:\s*|$)/, '$1').replace('-', '_');
        (a.button || a.which) > 1 || (a.preventDefault && a.preventDefault(), a.returnValue = !1, s._offset = b(this).offset(), (c = 'xy_slider' === c ? k : 'z_slider' === c ? l : m)(a), n(), A.on(E, function () {
            A.off('.tcp');
        }).on(C, function (a) {
            c(a), n();
        }));
    }
    function k(a) {
        var b = f(a), c = b.pageX - s._offset.left, d = b.pageY - s._offset.top;
        q.setColor({
            s: c / v._width * 100,
            v: 100 - d / v._height * 100
        }, 'hsv');
    }
    function l(a) {
        var b = f(a).pageY - s._offset.top;
        q.setColor({ h: 360 - b / u._height * 360 }, 'hsv');
    }
    function m(a) {
        var b = f(a).pageX - s._offset.left, c = b / y._width;
        q.setColor({}, 'rgb', c);
    }
    function n(a) {
        var b = q.colors, c = b.hueRGB, e = (b.RND.rgb, b.RND.hsl, r.dark), f = r.light, g = q.toString(s._colorMode, r.forceAlpha), h = b.HUELuminance > 0.22 ? e : f, i = b.rgbaMixBlack.luminance > 0.22 ? e : f, j = (1 - b.hsv.h) * u._height, k = b.hsv.s * v._width, l = (1 - b.hsv.v) * v._height, m = b.alpha * y._width, n = F ? 'translate3d' : '', p = s[0].value, t = s[0].hasAttribute('value') && '' === p && a !== d;
        v._css = { backgroundColor: 'rgb(' + c.r + ',' + c.g + ',' + c.b + ')' }, w._css = {
            transform: n + '(' + k + 'px, ' + l + 'px, 0)',
            left: F ? '' : k,
            top: F ? '' : l,
            borderColor: b.RGBLuminance > 0.22 ? e : f
        }, x._css = {
            transform: n + '(0, ' + j + 'px, 0)',
            top: F ? '' : j,
            borderColor: 'transparent ' + h
        }, y._css = { backgroundColor: '#' + b.HEX }, z._css = {
            transform: n + '(' + m + 'px, 0, 0)',
            left: F ? '' : m,
            borderColor: i + ' transparent'
        }, s._css = {
            backgroundColor: t ? '' : g,
            color: t ? '' : b.rgbaMixBGMixCustom.luminance > 0.22 ? e : f
        }, s.text = t ? '' : p !== g ? g : '', a !== d ? o(a) : G(o);
    }
    function o(a) {
        v.css(v._css), w.css(w._css), x.css(x._css), y.css(y._css), z.css(z._css), r.doRender && s.css(s._css), s.text && s.val(s.text), r.renderCallback.call(p, s, 'boolean' == typeof a ? a : d);
    }
    var p, q, r, s, t, u, v, w, x, y, z, A = b(document), B = b(), C = 'touchmove.tcp mousemove.tcp pointermove.tcp', D = 'touchstart.tcp mousedown.tcp pointerdown.tcp', E = 'touchend.tcp mouseup.tcp pointerup.tcp', F = !1, G = a.requestAnimationFrame || a.webkitRequestAnimationFrame || function (a) {
            a();
        }, H = '<div class="cp-color-picker"><div class="cp-z-slider"><div class="cp-z-cursor"></div></div><div class="cp-xy-slider"><div class="cp-white"></div><div class="cp-xy-cursor"></div></div><div class="cp-alpha"><div class="cp-alpha-cursor"></div></div></div>', I = '.cp-color-picker{position:absolute;overflow:hidden;padding:6px 6px 0;background-color:#444;color:#bbb;font-family:Arial,Helvetica,sans-serif;font-size:12px;font-weight:400;cursor:default;border-radius:5px}.cp-color-picker>div{position:relative;overflow:hidden}.cp-xy-slider{float:left;height:128px;width:128px;margin-bottom:6px;background:linear-gradient(to right,#FFF,rgba(255,255,255,0))}.cp-white{height:100%;width:100%;background:linear-gradient(rgba(0,0,0,0),#000)}.cp-xy-cursor{position:absolute;top:0;width:10px;height:10px;margin:-5px;border:1px solid #fff;border-radius:100%;box-sizing:border-box}.cp-z-slider{float:right;margin-left:6px;height:128px;width:20px;background:linear-gradient(red 0,#f0f 17%,#00f 33%,#0ff 50%,#0f0 67%,#ff0 83%,red 100%)}.cp-z-cursor{position:absolute;margin-top:-4px;width:100%;border:4px solid #fff;border-color:transparent #fff;box-sizing:border-box}.cp-alpha{clear:both;width:100%;height:16px;margin:6px 0;background:linear-gradient(to right,#444,rgba(0,0,0,0))}.cp-alpha-cursor{position:absolute;margin-left:-4px;height:100%;border:4px solid #fff;border-color:#fff transparent;box-sizing:border-box}', J = function (a) {
            q = this.color = new c(a), r = q.options, p = this;
        };
    J.prototype = {
        render: n,
        toggle: h
    }, b.fn.colorPicker = function (c) {
        var d = this, f = function () {
            };
        return c = b.extend({
            animationSpeed: 150,
            GPU: !0,
            doRender: !0,
            customBG: '#FFF',
            opacity: !0,
            renderCallback: f,
            buildCallback: f,
            positionCallback: f,
            body: document.body,
            scrollResize: !0,
            gap: 4,
            dark: '#222',
            light: '#DDD'
        }, c), !p && c.scrollResize && b(a).on('resize.tcp scroll.tcp', function () {
            p.$trigger && p.toggle.call(p.$trigger[0], !0);
        }), B = B.add(this), this.colorPicker = p || new J(c), this.options = c, b(c.body).off('.tcp').on(D, function (a) {
            !B.add(t).find(a.target).add(B.filter(a.target))[0] && h();
        }), this.on('focusin.tcp click.tcp', function (a) {
            p.color.options = b.extend(p.color.options, r = d.options), h.call(this, a);
        }).on('change.tcp', function () {
            q.setColor(this.value || '#FFF'), d.colorPicker.render(!0);
        }).each(function () {
            var a = e(this), d = a.split('('), f = g(b(this));
            f.data('colorMode', d[1] ? d[0].substr(0, 3) : 'HEX').attr('readonly', r.preventFocus), c.doRender && f.css({
                'background-color': a,
                color: function () {
                    return q.setColor(a).rgbaMixBGMixCustom.luminance > 0.22 ? c.dark : c.light;
                }
            });
        });
    }, b.fn.colorPicker.destroy = function () {
        b('*').off('.tcp'), p.toggle(!1), B = b();
    };
});
define('common-modules/forms/views/color-input', [
    'common-modules/forms/templates/color-input.tpl.html',
    'common-modules/utils/color-utils',
    'common-vendor/tinyColorPicker/jqColorPicker.min'
], function (template, ColorUtils) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template(template),
        ui: {
            text: '.js-ui-text',
            color: '.js-ui-color',
            toggle: '.js-ui-toggle'
        },
        events: { 'input .js-ui-text': 'setPickerColor' },
        initialize: function (options) {
            var setPickerValue = this.setPickerValue.bind(this);
            var el = this.$el;
            this.colorPickerOptions = {};
            if (options.innerInput) {
                this.colorPickerOptions = ColorUtils.innerInput;
            }
            this.colorPickerOptions.renderCallback = function ($elm, toggle) {
                if (toggle !== true) {
                    setPickerValue('#' + this.color.colors.HEX);
                    if (toggle === false) {
                        el.trigger('change');
                    }
                }
                $('.cp-HEX').val('#' + this.color.colors.HEX);
            };
            this.innerInput = options.innerInput;
            this.outerInput = options.outerInput;
        },
        setValue: function (value) {
            if (value) {
                this.setPickerValue(value);
                this.setPickerColor(value);
            }
        },
        getValue: function () {
            return this.ui.text.val();
        },
        onRender: function () {
            if (this.outerInput === false) {
                this.ui.text.attr('type', 'hidden');
                this.ui.toggle.css({
                    'border-top-left-radius': '3px',
                    'border-bottom-left-radius': '3px'
                });
            }
            this.ui.color.colorPicker(this.colorPickerOptions);
            this.$el.on('change', this.onChange.bind(this));
        },
        setPickerColor: function () {
            var value = this.ui.text.val();
            this.ui.color.colorPicker.color.colors.HEX = value;
            this.ui.color.colorPicker.color.setColor(value, 'HEX');
            this.ui.color.css({ 'background-color': value });
        },
        setPickerValue: function (value) {
            this.ui.text.val(value);
        },
        setInitialValue: function (value) {
            this.ui.text.val(value);
            this.ui.color.val(value);
            this.ui.color.css({ 'background-color': value });
        },
        onChange: function () {
            this.trigger('change');
        },
        close: function () {
            this.$el.off('change');
            Marionette.ItemView.prototype.close.apply(this, arguments);
        }
    });
});
define('common-modules/forms/views/fields/color-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/color-input'
], function (BaseField, ColorInput) {
    'use strict';
    return BaseField.extend({
        initSubView: function () {
            return new ColorInput(this.options.schema);
        },
        getValue: function () {
            return this.subView.getValue();
        },
        setInitialValue: function (value) {
            this.subView.setInitialValue(value);
        },
        setValue: function (value) {
            this.subView.setValue(value);
        },
        focus: function () {
            if (this.hasFocus) {
                return;
            }
            this.subView.$el.focus();
        },
        blur: function () {
            if (!this.hasFocus) {
                return;
            }
            this.subView.$el.blur();
        }
    });
});
define('common-modules/forms/templates/translations-input.tpl.html', [], function () {
    return '<div class="adb-input_row">\n\t<div class="adb-input_row--item adb-input_row--primary">\n\t\t<input class="adb-input_row--item_content" type="text">\n\t</div>\n\t<div class="adb-input_row--item">\n\t\t<button class="adb-input_row--item_content" type="submit"></button>\n\t</div>\n</div>\n';
});
define('common-modules/forms/views/translations-input', ['common-modules/forms/templates/translations-input.tpl.html'], function (template) {
    'use strict';
    return Marionette.Layout.extend({
        ui: {
            input: 'input',
            button: 'button'
        },
        events: { 'click @ui.button': 'toggleLocale' },
        template: _.template(template),
        initialize: function (options) {
            this.locales = options.locales || [];
            this.translations = {};
            this.selectedLocale = options.defaultLocale || 'en';
            this.onLocaleChange = options.onLocaleChange;
            this.placeholder = options.placeholder || '';
            if (options.onBlur) {
                _.extend(this.events, { 'blur input': options.onBlur });
            }
        },
        onRender: function () {
            this.updateDisplay();
        },
        toggleLocale: function () {
            this.updateValue();
            var index = this.locales.indexOf(this.selectedLocale) + 1;
            if (index > this.locales.length - 1) {
                index = 0;
            }
            this.selectedLocale = this.locales[index];
            this.updateDisplay();
            if (this.onLocaleChange) {
                this.onLocaleChange(this.selectedLocale);
            }
        },
        setLocale: function (newLocale) {
            if (newLocale === this.selectedLocale || this.locales.indexOf(newLocale) < 0) {
                return;
            }
            this.updateValue();
            this.selectedLocale = newLocale;
            this.updateDisplay();
        },
        updateValue: function () {
            this.translations[this.selectedLocale] = this.ui.input.val().trim();
        },
        updateDisplay: function () {
            this.ui.button.text(this.selectedLocale);
            this.ui.input.val(this.translations[this.selectedLocale]);
            if (this.placeholder) {
                this.ui.input.attr('placeholder', this.placeholder);
            }
        },
        getValue: function () {
            this.updateValue();
            return this.translations;
        },
        setValue: function (translations) {
            this.translations = _.extend({}, translations);
            this.updateDisplay();
        }
    });
});
define('common-modules/forms/views/fields/translations-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/translations-input'
], function (BaseField, TranslationsInput) {
    'use strict';
    return BaseField.extend({
        initialize: function (options) {
            BaseField.prototype.initialize.call(this, options);
            this.inputOptions = options.schema;
        },
        initSubView: function () {
            return new TranslationsInput(this.inputOptions);
        },
        getValue: function () {
            return this.subView.getValue();
        },
        setValue: function (value) {
            this.subView.setValue(value);
        },
        focus: function () {
            if (this.hasFocus) {
                return;
            }
            this.subView.ui.input.focus();
        },
        blur: function () {
            if (!this.hasFocus) {
                return;
            }
            this.subView.ui.input.blur();
        }
    });
});
define('common-modules/forms/templates/search-input-button-tpl.html', [], function () {
    return '<div class="adb-input_row--item js-dropdown-container">\n</div>\n<div class="adb-input_row--item adb-input_row--primary">\n\t<input aria-label="<%- l(\'search\') %>" class="adb-input_row--item_content adb-search_field--input" placeholder="<%-placeholder%>" type="search">\n</div>\n<div class="adb-input_row--item js-search-button-container">\n\t<button aria-label="<%- l(\'submit\') %>" class="adb-input_row--item_content adb-search_field--button adb-button adb-button__neutral" type="button">\n\t\t<i class="adb-icon__search"></i>\n\t\t<%- buttonText %>\n\t</button>\n</div>\n';
});
define('common-modules/forms/templates/search-input-auto-tpl.html', [], function () {
    return '<span class="adb-search_field--affix adb-search_field--affix__default"></span>\n<span class="adb-search_field--affix adb-search_field--affix__loading">\n\t<span class="adb-loading"></span>\n</span>\n<input aria-label="<%- l(\'search\') %>" class="adb-js-auto_search--input adb-search_field--input" id="name-search" tabindex="<%-tabIndex%>" placeholder="<%-placeholder%>"\n\t   type="search">\n<a class="adb-close adb-search_field--affix adb-search_field--affix__clear adb-js-auto_search--clear" tabindex="<%-tabIndex%>"></a>\n';
});
define('common-modules/forms/views/search-input', [
    'common-modules/forms/templates/search-input-button-tpl.html',
    'common-modules/forms/templates/search-input-auto-tpl.html',
    'common-modules/forms/views/select-input',
    'common-modules/buttons/button'
], function (templateSearchWithButton, templateSearchAuto, SelectInput, Button) {
    'use strict';
    var ENTER = 13;
    var SPACE = 32;
    var SearchInput = Marionette.ItemView.extend({
        className: 'adb-search_field adb-input_row adb-input_row__search',
        ui: {
            input: 'input',
            clear: '.adb-js-auto_search--clear',
            button: 'button',
            icon: 'button i'
        },
        events: {
            'keydown @ui.input': '_onKeyDown',
            'keyup @ui.input': '_onKeyUp',
            'paste @ui.input': '_onPaste',
            'focus @ui.input': '_onFocus',
            'focusout @ui.input': '_onFocusOut',
            'click @ui.clear': 'clear',
            'keydown @ui.clear': '_onClearKeyDown',
            'click @ui.button': 'search'
        },
        initialize: function (options) {
            this.placeholder = options.placeholder;
            this.searchFunc = options.searchFunc;
            this.clearFunc = options.clearFunc;
            this.auto = !!options.auto;
            this.autoDebounce = options.autoDebounce || 0;
            this.isSmall = !!options.small;
            this.isPrimary = !!options.isPrimary;
            this.buttonText = options.buttonText || '';
            this.searchText = options.searchText || '';
            this.fullWidth = !!options.fullWidth;
            this.categories = options.categories;
            this.focusOnKeypress = options.focusOnKeypress;
            this.tabIndex = options.tabIndex || 0;
            if (this.auto) {
                this.debouncedSearch = _.debounce(this.search.bind(this), this.autoDebounce);
            }
            _.bind(this.search, this);
            _.bind(this.clear, this);
        },
        onRender: function () {
            this.setVal(this.searchText);
            this._toggleClearBtn();
            if (this.auto) {
                this.$el.addClass('adb-search_field__auto');
            }
            if (this.isSmall) {
                this.$('input').addClass('adb-text__small');
                this.$('button').addClass('adb-button__small');
            }
            if (this.isPrimary) {
                this.$('button').addClass('adb-button__primary');
            }
            if (this.fullWidth) {
                this.$el.addClass('adb-input_row__full_width');
            }
            if (this.categories) {
                this.renderCategories();
            } else {
                this.$('.js-dropdown-container').remove();
            }
            if (this.focusOnKeypress) {
                $(document).on('keydown.' + this.cid, _.bind(function (e) {
                    var key = String.fromCharCode(e.keyCode);
                    if (/[a-zA-Z0-9-_ ]/.test(key) && !this.ui.input.is(':focus')) {
                        this.ui.input.focus();
                    }
                }, this));
            }
            this.ui.icon.toggleClass('adb-button--icon', !!this.buttonText);
        },
        renderCategories: function () {
            var select = new SelectInput(_.extend({
                className: 'adb-dropdown adb-input_row--item_content',
                collection: this._toCollection(this.categories)
            }, this._getCategoriesOptions()));
            this.$('.js-dropdown-container').append(select.render().el);
        },
        getTemplate: function () {
            if (this.auto) {
                return _.template(templateSearchAuto);
            }
            return _.template(templateSearchWithButton);
        },
        toggleLoading: function (loading) {
            this.$el.toggleClass('adb-is-loading', loading);
        },
        setVal: function (val) {
            this.ui.input.val(val);
            this._toggleClearBtn();
        },
        setPlaceholder: function (placeholder) {
            this.placeholder = placeholder;
            this.ui.input.attr('placeholder', placeholder);
        },
        focus: function () {
            this.ui.input.focus();
        },
        blur: function () {
            this.ui.input.blur();
        },
        getVal: function () {
            return this.ui.input.val();
        },
        _isValEmpty: function () {
            return _.isEmpty(this.getVal());
        },
        _onKeyDown: function (e) {
            if (e.keyCode === ENTER) {
                e.preventDefault();
            }
        },
        _onKeyUp: function (e) {
            var isEnterKey = e.keyCode === ENTER;
            var hasText = !this._isValEmpty();
            if (hasText && this.auto) {
                this.debouncedSearch();
            } else if (hasText && !this.auto && isEnterKey) {
                this.search();
            } else if (!hasText) {
                this.clear();
            }
            this._toggleClearBtn();
        },
        _onPaste: function (e) {
            _.defer(this._onKeyUp.bind(this, e));
        },
        _onFocus: function () {
            this.$el.addClass('adb-is-focused');
        },
        _onFocusOut: function () {
            this.$el.removeClass('adb-is-focused');
        },
        _toggleClearBtn: function () {
            if (this._isValEmpty()) {
                this.ui.clear.hide();
                return;
            }
            this.ui.clear.show();
        },
        _toCollection: function (collection) {
            return collection instanceof Backbone.Collection ? collection : new Backbone.Collection(collection);
        },
        _getCategoriesOptions: function () {
            return {
                size: this.isSmall ? Button.SIZES.SMALL : undefined,
                type: Button.TYPES.INSET
            };
        },
        search: function () {
            if (this._isValEmpty()) {
                return;
            }
            var query = this.getVal();
            if (_.isFunction(this.searchFunc)) {
                this.searchFunc(query);
            }
            this.trigger('search', query);
        },
        clear: function () {
            this.ui.input.val('');
            this._toggleClearBtn();
            if (_.isFunction(this.clearFunc)) {
                this.clearFunc();
            }
            this.trigger('clear');
        },
        _onClearKeyDown: function (e) {
            if (e.keyCode === ENTER || e.keyCode === SPACE) {
                e.preventDefault();
                this.clear();
            }
        },
        serializeData: function () {
            return {
                placeholder: this.placeholder || l('Search'),
                buttonText: this.buttonText,
                tabIndex: this.tabIndex,
                auto: this.auto
            };
        },
        onClose: function () {
            if (this.focusOnKeypress) {
                $(document).off('keydown.' + this.cid);
            }
        }
    });
    return SearchInput;
});
define('common-modules/forms/templates/inline-search-input.tpl.html', [], function () {
    return '<div class="adb-search-input_field adb-search-input_field__auto">\t\n\t<span class="js-region-search-input"></span>\n\t<div class="js-region-results"></div>\n</div>\n';
});
define('common-modules/forms/views/inline-search-input', [
    'object-utils',
    'common-modules/forms/views/search-input',
    'common-modules/containers/views/inline-search-results',
    'common-modules/forms/templates/inline-search-input.tpl.html'
], function (ObjectUtils, SearchInput, InlineSearchResults, template) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'adb-search-input adb-context_menu',
        template: _.template(template),
        regions: {
            searchInputRegion: '.js-region-search-input',
            resultsRegion: '.js-region-results'
        },
        defaults: {
            debounce: 500,
            minLength: 3,
            maxResults: 10,
            showSuggestionsOnFocus: false
        },
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'placeholder',
                'debounce',
                'collection',
                'minLength',
                'maxResults',
                'showSuggestionsOnFocus'
            ]);
            if (!this.collection.search) {
                throw new Error('Search input component needs to have a collection with the search method.');
            }
            this.resultItems = new Backbone.Collection(this.collection.toArray());
            if (this.debounce) {
                this.startSearch = _.debounce(this.startSearch, this.debounce);
            }
            if (this.showSuggestionsOnFocus) {
                this.events = _.extend(this.events || {}, { 'focus input': 'onFocus' });
            }
        },
        onRender: function () {
            this.renderInput();
            this.renderResults();
        },
        renderInput: function () {
            this.searchInput = new SearchInput({
                auto: true,
                searchFunc: this.triggerFunc('search'),
                clearFunc: this.triggerFunc('clear'),
                placeholder: this.placeholder
            });
            this.searchInputRegion.show(this.searchInput);
        },
        renderResults: function () {
            this.results = new InlineSearchResults({ collection: this.resultItems });
            this.listenTo(this.results, 'change', this.triggerFunc('select'));
            this.resultsRegion.show(this.results);
        },
        showMessage: function (message, results) {
            var messageItem = {
                label: message,
                linkClasses: 'adb-no-link__option'
            };
            if (results) {
                this.resultItems.reset(results);
                this.resultItems.push(messageItem);
            } else {
                this.resultItems.reset([messageItem]);
            }
            this.toggleResults(true);
            this.toggleLoading(false);
        },
        triggerFunc: function (event) {
            return _.bind(this.triggerMethod, this, event);
        },
        onSearch: function (searchText) {
            this.toggleLoading(true);
            this.toggleResults(false);
            if (searchText.length >= this.minLength) {
                this.startSearch(searchText);
            } else {
                this.showMessage(l('inline.search.below.min.charcount'));
            }
        },
        startSearch: function (searchText) {
            this.collection.search(searchText).then(this.triggerFunc('fetched'));
        },
        onFetched: function () {
            if (this.collection.length === 0) {
                this.showMessage(l('inline.search.no.result'));
            } else if (this.collection.length >= this.maxResults) {
                this.showMessage(l('inline.search.above.max.results'), this.collection.toArray().slice(0, this.maxResults));
            } else {
                this.resultItems.reset(this.collection.toArray());
                this.toggleResults(true);
                this.toggleLoading(false);
            }
        },
        onClear: function () {
            delete this.selection;
            this.resultItems.reset([]);
            this.toggleResults(false);
            this.trigger('change');
        },
        onSelect: function (model) {
            this.selection = model;
            this.searchInput.setVal(model.toJSON().label);
            this.toggleResults(false);
            this.trigger('change');
        },
        getValue: function () {
            return this.selection && Backbone.Model.prototype.toJSON.call(this.selection);
        },
        setValue: function (model) {
            this.triggerMethod('select', model);
        },
        onFocus: function () {
            this.startSearch('');
        },
        focus: function () {
            this.searchInput.focus();
        },
        blur: function () {
            this.searchInput.blur();
        },
        toggleResults: function (active) {
            this.$el.toggleClass('adb-is-active', active);
        },
        toggleLoading: function (loading) {
            this.searchInput.toggleLoading(loading);
        }
    });
});
define('common-modules/forms/views/fields/inline-search-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/inline-search-input'
], function (BaseSubviewField, InlineSearchInput) {
    'use strict';
    return BaseSubviewField.extend({
        initSubView: function () {
            return new InlineSearchInput(this.schema);
        },
        getValue: function () {
            return this.subView.getValue();
        },
        setValue: function (value) {
            var Model = this.schema.Model || Backbone.Model;
            if (value) {
                this.subView.setValue(new Model(value));
            }
        },
        focus: function () {
            if (this.hasFocus) {
                return;
            }
            this.subView.focus();
        },
        blur: function () {
            if (!this.hasFocus) {
                return;
            }
            this.subView.blur();
        }
    });
});
define('common-modules/utils/file-uploader', [], function () {
    'use strict';
    return {
        upload: function (files, url, method, ajaxOptions) {
            var formData = new FormData();
            _(files).each(function (file) {
                formData.append(file.inputName, file.file, file.fileName);
            });
            return $.ajax(_.extend({
                url: url,
                type: method,
                data: formData,
                cache: false,
                dataType: 'json',
                processData: false,
                contentType: false
            }, ajaxOptions || {}));
        },
        domUpload: function (file, url, method) {
            var defer = $.Deferred();
            var bus = 'domUpload_' + _.uniqueId();
            var iframe = $('<iframe>', { name: bus });
            var form = $('<form>', {
                action: url,
                method: method,
                encoding: 'multipart/form-data',
                enctype: 'multipart/form-data',
                target: bus
            });
            file.$el.attr('name', file.inputName || 'file');
            form.append(file.$el[0]);
            var container = $('<div>').append(iframe).append(form).appendTo('body');
            var timeoutId = setTimeout(defer.reject, 30000);
            iframe.load(_.bind(function () {
                clearTimeout(timeoutId);
                defer.resolve();
            }, this));
            form.submit();
            return defer.always(function () {
                container.remove();
            });
        }
    };
});
define('common-modules/forms/templates/file-upload.tpl.html', [], function () {
    return '<input class="adb-upload--text" disabled placeholder="<%-placeholder%>" type="text">\n<a class="adb-upload--clear"></a>\n<a class="adb-button adb-button__medium adb-button__neutral adb-upload--select">\n\t<input type="file">\n\t<span class="adb-upload--button_text">\n\t\t<%-l(\'choose.file\')%>\n\t</span>\n</a>\n';
});
define('common-modules/utils/browser-util', [], function () {
    'use strict';
    return {
        navigator: window.navigator,
        getIEVersion: function () {
            var myNav = this.navigator.userAgent;
            var msie = myNav.indexOf('MSIE ');
            if (msie > 0) {
                return parseInt(myNav.substring(msie + 5, myNav.indexOf('.', msie)), 10);
            }
            var trident = myNav.indexOf('Trident/');
            if (trident > 0) {
                var rv = myNav.indexOf('rv:');
                return parseInt(myNav.substring(rv + 3, myNav.indexOf('.', rv)), 10);
            }
            return false;
        },
        isIE: function () {
            return _.isNumber(this.getIEVersion()) || this.isEdge();
        },
        isEdge: function () {
            var myNav = this.navigator.userAgent;
            return myNav.indexOf('Edge/') > -1;
        },
        isIEBelow10: function () {
            var ieVersion = this.getIEVersion();
            return this.isIE() && _.isNumber(ieVersion) && ieVersion < 10;
        }
    };
});
define('common-modules/forms/views/file-upload', [
    'common-modules/behaviors/loading',
    'common-modules/utils/file-uploader',
    'common-modules/forms/templates/file-upload.tpl.html',
    'common-modules/utils/browser-util'
], function (LoadingBehavior, FileUploader, template, BrowserUtil) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template(template),
        className: 'adb-upload',
        behaviors: {
            Loading: {
                behaviorClass: LoadingBehavior,
                size: LoadingBehavior.SIZE.MEDIUM
            }
        },
        ui: {
            file: 'input[type=file]',
            text: '.adb-upload--text',
            clear: '.adb-upload--clear'
        },
        events: {
            'change @ui.file': 'onFileChange',
            'click @ui.clear': 'onClickClear'
        },
        initialize: function (options) {
            this.model = this.model || new Backbone.Model();
            options = options || {};
            this.placeholder = options.placeholder || this.model.get('placeholder') || l('No.file.chosen');
            this.inputName = options.inputName || this.model.get('inputName');
            this.showLoadingOverlay = options.showLoadingOverlay !== false;
            this.url = options.url;
            this.method = options.method || 'PUT';
            this.ajaxOptions = options.ajaxOptions || {};
        },
        serializeData: function () {
            return _.extend(this.model ? this.model.toJSON() : {}, { placeholder: this.placeholder });
        },
        onRender: function () {
            this.ui.clear.hide();
        },
        onFileChange: function (event) {
            this.file = event.target.files && event.target.files[0];
            this.fileName = this._getSelectedFileName();
            this.ui.text.val(this.fileName);
            this.ui.clear.toggle(!!this.fileName);
            this.trigger('change');
        },
        _getSelectedFileName: function () {
            var val = this.ui.file.val();
            if (this.val) {
                this.val = _.last(this.val.split('\\'));
            }
            return val;
        },
        onClickClear: function () {
            this.clear();
        },
        clear: function () {
            this.ui.file.val('');
            this.ui.file.trigger('change');
        },
        getFile: function () {
            return _.extend(_(this).pick('file', 'fileName', 'inputName'), { $el: this.ui.file });
        },
        readAsDataUrl: function () {
            var deferred = $.Deferred();
            var file = this.getFile();
            if (this.file) {
                var reader = new FileReader();
                reader.onloadend = _.bind(function () {
                    deferred.resolve(_.extend({ dataUrl: reader.result }, file));
                }, this);
                reader.readAsDataURL(this.file);
            } else {
                deferred.resolve({});
            }
            return deferred;
        },
        upload: function () {
            if (this.uploading) {
                return;
            }
            if (BrowserUtil.isIEBelow10()) {
                return this.uploadUsingDOM();
            }
            if (!this.file) {
                return;
            }
            this.uploading = true;
            this._showLoading();
            var file = this.getFile();
            return FileUploader.upload([file], this.url, this.method, this.ajaxOptions).done(_.bind(this.onUploadComplete, this)).fail(_.bind(this.onUploadError, this)).always(_.bind(this.onUploadAlways, this));
        },
        _showLoading: function () {
            if (this.showLoadingOverlay) {
                this.triggerMethod('show:loading');
            }
        },
        onUploadComplete: function () {
            this.trigger.apply(this, _.union(['upload:complete'], arguments));
        },
        onUploadError: function () {
            this.trigger.apply(this, _.union(['upload:error'], arguments));
        },
        onUploadAlways: function () {
            this.uploading = false;
            this.triggerMethod('hide:loading');
        },
        uploadUsingDOM: function (opts) {
            if (!this.fileName) {
                return;
            }
            this.uploading = true;
            var file = {
                options: opts,
                $el: this.ui.file,
                inputName: this.inputName
            };
            return FileUploader.domUpload(file, this.url, this.method).done(_.bind(this.onUploadComplete, this)).fail(_.bind(this.onUploadError, this)).always(_.bind(function () {
                this.uploading = false;
            }, this));
        }
    });
});
define('common-modules/forms/views/fields/file-upload-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/file-upload'
], function (BaseSubviewField, FileUpload) {
    'use strict';
    return BaseSubviewField.extend({
        initSubView: function () {
            return new FileUpload(this.schema);
        },
        getValue: function () {
            return this.subView.getFile();
        },
        setValue: function () {
        }
    });
});
define('common-modules/forms/templates/email-domain-select.tpl.html', [], function () {
    return '<div class="js-username-domain-selector">\n\t<div class="adb-form--field">\n\t\t<div class="adb-input_row adb-js-input_row">\n\t\t\t<div class="adb-input_row--item adb-input_row--primary">\n\t\t\t\t<input class="adb-input_row--item_content js-email-username" name="email-username" placeholder="username" type="text">\n\t\t\t</div>\n\t\t\t<div class="adb-input_row--item adb-input_row--label">\n\t\t\t\t<label class="adb-input_row--item_content">@</label>\n\t\t\t</div>\n\t\t\t<div class="adb-input_row--item js-domain-view">\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n';
});
define('common-modules/forms/views/email-domain-select-view', [
    'backbone-forms',
    'common-modules/forms/views/select-input',
    'common-modules/forms/templates/email-domain-select.tpl.html'
], function (Form, SelectInputView, template) {
    'use strict';
    var SingleDomainLabel = Marionette.Layout.extend({
        template: _.template('<%- domain %>'),
        tagName: 'label',
        className: 'adb-input_row--item_content',
        initialize: function (options) {
            this.domain = options.domain;
        },
        serializeData: function () {
            return { domain: this.domain };
        }
    });
    var UsernameDomainSelector = Marionette.Layout.extend({
        tagName: 'div',
        ui: { usernameInput: '.js-email-username' },
        regions: { domainRegion: '.js-domain-view' },
        events: { 'change @ui.usernameInput': '_onUsernameChange' },
        triggers: {
            'focusout @ui.usernameInput': '_onUsernameFocusOut',
            'blur @ui.usernameInput': 'blur'
        },
        initialize: function (options) {
            options = options || {};
            this.labelField = options.labelField || 'name';
            this.valueField = options.valueField || 'name';
            this.username = options.username;
            this.domain = options.domain || this.collection.at(0).get(this.valueField);
        },
        onRender: function () {
            this.ui.usernameInput.val(this.username);
            if (this.collection.length === 1) {
                this.domainRegion.show(new SingleDomainLabel({ domain: this.domain }));
                this.domainRegion.$el.addClass('adb-input_row--label');
            } else {
                var selectInput = new SelectInputView({
                    labelField: this.labelField,
                    valueField: this.valueField,
                    value: this.domain,
                    collection: this.collection,
                    isGroup: true
                });
                selectInput.on('change', this._onDomainChange, this);
                this.domainRegion.show(selectInput);
                this.domainRegion.$el.addClass('adb-input_row--item_content adb-js-dropdown adb-dropdown adb-dropdown__inset');
            }
        },
        getTemplate: function () {
            return _.template(template);
        },
        val: function (value) {
            return value === undefined ? this._getVal() : this._setVal(value);
        },
        setError: function () {
            this.ui.usernameInput.attr('data-error', '');
        },
        clearError: function () {
            this.ui.usernameInput.removeAttr('data-error');
        },
        decorateEditor: function () {
            if (this.schema.editorAttrs) {
                this.ui.usernameInput.attr(this.schema.editorAttrs);
            }
            if (this.schema.editorClass) {
                this.ui.usernameInput.addClass(this.schema.editorClass);
            }
        },
        disable: function () {
            this.ui.usernameInput.setAttribute('disable');
        },
        _getVal: function () {
            return {
                username: this.username,
                domain: this.domain
            };
        },
        _setVal: function (obj) {
            var model = obj || {};
            if (_.has(model, 'username') && _.has(model, 'domain')) {
                this.username = model.username;
                this.domain = model.domain;
            }
        },
        _onUsernameChange: function () {
            this.username = this.ui.usernameInput.val();
            this.trigger('username:change', this.ui.usernameInput.val());
        },
        _onDomainChange: function (domain) {
            this.domain = domain;
            this.trigger('domain:change', domain);
        }
    });
    return UsernameDomainSelector;
});
define('common-modules/forms/views/fields/email-domain-select-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/email-domain-select-view'
], function (BaseField, EmailDomainSelectView) {
    'use strict';
    return BaseField.extend({
        initialize: function (options) {
            this.options = options;
            BaseField.prototype.initialize.call(this, options);
        },
        subviewEvents: {
            'username:focusout': '_onUsernameChange',
            'username:focus': '_onUsernameChange',
            'username:change': '_onUsernameChange',
            'domain:change': '_onDomainChange'
        },
        initSubView: function () {
            this.subview = new EmailDomainSelectView(this.options.model.get('email'));
            Marionette.bindEntityEvents(this, this.subview, this.subviewEvents);
            return this.subview;
        },
        validate: function () {
            var error = null, getValidator = this.getValidator, subview = this.subview;
            _.every(this.validators, function (validatorString) {
                error = getValidator(validatorString)(subview.username);
                return !error;
            });
            if (error) {
                this.subview.setError(error.message);
            } else {
                this.subview.clearError();
            }
            return error;
        },
        getValue: function () {
            return this.subView.val();
        },
        _onUsernameFocusOut: function () {
            this.trigger('username:onFocusOut', this.username);
            this.trigger('focusout', this);
        },
        _onUsernameChange: function (username) {
            this.trigger('change', this);
            this.trigger('username:change', username);
        },
        _onDomainChange: function (domain) {
            this.trigger('domain:change', domain);
        }
    });
});
define('common-modules/forms/templates/image-upload.tpl.html', [], function () {
    return '<div class="js-region-upload"></div>\n<div class="js-region-preview"></div>\n';
});
define('common-modules/utils/generate-selector-hash', [], function () {
    'use strict';
    var generate = function (type, suffix, names) {
        var hash = {};
        _.each(names, function (name) {
            hash[name + suffix] = '.js-' + type + '-' + name;
        });
        return hash;
    };
    generate.regions = _.partial(generate, 'region', 'Region');
    generate.ui = _.partial(generate, 'ui', '');
    return generate;
});
define('common-modules/forms/templates/image-upload-preview.tpl.html', [], function () {
    return '<div class="adb-uploaded_field">\n\t<div class="adb-uploaded_field--file">\n\t\t<div class="adb-uploaded_field--file_name js-ui-filename"></div>\n\t\t<button class="adb-button__danger adb-button__square_small adb-uploaded_field--file_delete js-ui-delete" type="button">\n\t\t\t<i class="adb-icon__trash"></i>\n\t\t</button>\n\t</div>\n\t<div class="adb-uploaded_field--image js-ui-frame">\n\t\t<img class="adb-uploaded_field--image--content js-ui-img" alt="" />\n\t</div>\n</div>\n';
});
define('common-modules/forms/views/image-upload-preview', [
    'common-modules/forms/templates/image-upload-preview.tpl.html',
    'common-modules/utils/generate-selector-hash'
], function (template, generateSelectorHash) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template(template),
        ui: generateSelectorHash.ui([
            'filename',
            'delete',
            'img',
            'frame'
        ]),
        triggers: { 'click @ui.delete': 'clear' },
        showPreview: function (imageUrl, filename) {
            if (this.options.img) {
                this.ui.img.css(this.options.img);
            }
            if (this.options.frame) {
                this.ui.frame.css(this.options.frame);
            }
            this.ui.filename.text(filename);
            this.ui.img.attr('src', imageUrl);
        }
    });
});
define('common-modules/forms/views/image-upload', [
    'common-modules/forms/templates/image-upload.tpl.html',
    'common-modules/behaviors/loading',
    'common-modules/utils/generate-selector-hash',
    'object-utils',
    'common-modules/forms/views/file-upload',
    'common-modules/forms/views/image-upload-preview'
], function (template, LoadingBehavior, generateSelectorHash, ObjectUtils, FileUpload, ImageUploadPreview) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template(template),
        regions: generateSelectorHash.regions([
            'upload',
            'preview'
        ]),
        attributes: { tabindex: '-1' },
        behaviors: { Loading: { behaviorClass: LoadingBehavior } },
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'imageUrl',
                'uploadOptions',
                'previewOptions'
            ]);
        },
        onRender: function () {
            this.renderUpload();
            this.renderPreview();
            this.updatePreview();
            this.updateVisibility();
        },
        renderUpload: function () {
            this.upload = new FileUpload(this.uploadOptions);
            this.listenTo(this.upload, 'change', this.onFileChange);
            this.uploadRegion.show(this.upload);
        },
        onFileChange: function () {
            this.trigger('change');
            this.upload.readAsDataUrl().then(_.bind(function (result) {
                this.updateImage(result.dataUrl, result.fileName);
            }, this));
        },
        updateImage: function (imageUrl, filename) {
            this.imageUrl = imageUrl;
            this.filename = filename;
            this.updatePreview();
        },
        updatePreview: function () {
            this.preview.showPreview(this.imageUrl, this.filename);
            this.updateVisibility();
        },
        renderPreview: function () {
            this.preview = new ImageUploadPreview(this.previewOptions);
            this.listenTo(this.preview, 'clear', this.onClear);
            this.previewRegion.show(this.preview);
        },
        onClear: function () {
            this.upload.clear();
        },
        updateVisibility: function () {
            var showPreview = !!this.imageUrl;
            this.uploadRegion.$el.toggle(!showPreview);
            this.previewRegion.$el.toggle(showPreview);
        }
    });
});
define('common-modules/forms/views/fields/image-upload-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/image-upload'
], function (BaseSubviewField, ImageUpload) {
    'use strict';
    return BaseSubviewField.extend({
        initSubView: function () {
            return new ImageUpload({
                uploadOptions: this.options.schema.uploadOptions,
                previewOptions: this.options.schema.previewOptions
            });
        },
        getValue: function () {
            return this.subView.imageUrl || '';
        },
        setValue: function (imageUrl) {
            this.subView.updateImage(imageUrl);
        },
        focus: function () {
            this.subView.$el.focus();
        },
        upload: function (success, error) {
            if (this.subView.upload.getFile().file) {
                this.subView.triggerMethod('show:loading');
                this.subView.upload.upload().then(_.bind(function (response) {
                    this.subView.triggerMethod('hide:loading');
                    success(response);
                }, this), _.bind(function (response) {
                    this.subView.triggerMethod('hide:loading');
                    error(response);
                }, this));
            }
        }
    });
});
define('common-modules/patterns/category-select/templates/category-select.tpl.html', [], function () {
    return '<div class="adb-tags_field">\n\t<div class="adb-tags_field--inputs">\n\t\t<div class="js-region-categories"></div>\n\t\t<div class="js-region-options adb-tags_field--subcategories"></div>\n\t</div>\n\t<div class="js-region-tags"></div>\n</div>\n';
});
define('common-modules/patterns/category-select/templates/category-item.tpl.html', [], function () {
    return '<a class="adb-tags_field--category_content">\n\t<%-label%>\n\t<span class="adb-tags_field--badge adb-badge adb-badge__number js-ui-count"></span>\n</a>\n';
});
define('common-modules/patterns/category-select/views/category-item', ['common-modules/patterns/category-select/templates/category-item.tpl.html'], function (template) {
    'use strict';
    return Marionette.ItemView.extend({
        className: 'adb-tags_field--category',
        tagName: 'li',
        template: _.template(template),
        triggers: { click: 'select' },
        ui: { count: '.js-ui-count' },
        onRender: function () {
            this.ui.count.hide();
        },
        toggleActive: function (isActive) {
            this.$el.toggleClass('adb-is-active', isActive);
        },
        updateCount: function (count) {
            this.ui.count.toggle(!!count).text(count);
        }
    });
});
define('common-modules/patterns/category-select/views/categories', ['common-modules/patterns/category-select/views/category-item'], function (CategoryItem) {
    'use strict';
    return Marionette.CollectionView.extend({
        tagName: 'ul',
        className: 'adb-tags_field--categories',
        itemView: CategoryItem
    });
});
define('common-modules/patterns/category-select/views/options', ['common-modules/forms/views/checkbox'], function (Checkbox) {
    'use strict';
    return Checkbox.CheckboxGroup.extend({
        className: Checkbox.CheckboxGroup.prototype.className + ' adb-tags_field--subcategory',
        selectOptions: function (collection, allOptionsSelected) {
            if (allOptionsSelected) {
                this.checkAll();
                return;
            }
            this.children.each(function (view) {
                var isSelected = collection.any(function (model) {
                    return model.get('value') === view.model.get('value');
                });
                view.toggleChecked(isSelected);
            });
        }
    });
});
define('common-modules/patterns/category-select/category-select', [
    'common-modules/patterns/category-select/templates/category-select.tpl.html',
    'common-modules/patterns/category-select/views/categories',
    'common-modules/patterns/category-select/views/options',
    'common-modules/buttons/tags',
    'object-utils'
], function (template, Categories, Options, Tags, ObjectUtils) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template(template),
        regions: {
            categoriesRegion: '.js-region-categories',
            optionsRegion: '.js-region-options',
            tagsRegion: '.js-region-tags'
        },
        defaults: {
            showTags: true,
            includeSelectAll: false
        },
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'showTags',
                'includeSelectAll'
            ]);
            if (this.showTags && this.includeSelectAll) {
                throw new Error('Sorry, tags and select all are mutually exclusive at the moment :(');
            }
            this.selectedTags = new Backbone.Collection();
            this.selectedCategories = new Backbone.Collection();
            this.listenTo(this.selectedCategories, 'add remove', this.onUpdateSelection);
            this.listenTo(this.selectedTags, 'add remove', this.onUpdateSelection);
        },
        onRender: function () {
            this.renderCategories();
            this.renderTags();
        },
        renderCategories: function () {
            this.categories = new Categories({ collection: this.collection });
            this.categoriesRegion.show(this.categories);
            this.listenTo(this.categories, 'itemview:select', this.selectCategory);
            if (this.categories.children.length) {
                this.selectCategory(this.categories.children.findByIndex(0));
            }
        },
        onUpdateSelection: function () {
            this.updateSelectedOptions();
            this.collection.each(function (model) {
                var isCategorySelected = !!this.selectedCategories.findWhere({ value: model.get('value') });
                var selectedCount;
                if (isCategorySelected) {
                    selectedCount = l('All');
                } else {
                    selectedCount = _.filter(model.get('items'), function (option) {
                        return this.selectedTags.any(function (tag) {
                            return tag.get('value') === option.value;
                        });
                    }, this).length;
                }
                this.categories.children.findByModel(model).updateCount(selectedCount);
            }, this);
        },
        selectCategory: function (selectedCategoryView) {
            this.categories.children.each(function (categoryView) {
                var isSelected = selectedCategoryView === categoryView;
                categoryView.toggleActive(isSelected);
                if (isSelected) {
                    this.currentCategory = categoryView.model;
                    this.renderOptions(categoryView.model);
                }
            }, this);
        },
        renderOptions: function (categoryModel) {
            this.categoryOptions = new Options({
                collection: new Backbone.Collection(categoryModel.get('items')),
                includeSelectAll: this.includeSelectAll
            });
            this.optionsRegion.show(this.categoryOptions);
            this.listenTo(this.categoryOptions, 'check', _.bind(this.onOptionCheck, this));
            this.listenTo(this.categoryOptions, 'check:all', _.bind(this.onCategoryCheck, this));
            this.updateSelectedOptions();
        },
        updateSelectedOptions: function () {
            if (!this.categoryOptions || !this.currentCategory) {
                return;
            }
            var allOptionsSelected = !!this.selectedCategories.findWhere({ value: this.currentCategory.get('value') });
            this.categoryOptions.selectOptions(this.selectedTags, allOptionsSelected);
        },
        onOptionCheck: function (optionModel, checked) {
            this.checkOption(optionModel, checked);
            this.trigger('change', this.selectedTags, this.selectedCategories);
        },
        onCategoryCheck: function (checked) {
            this.checkCategory(this.currentCategory, checked);
            this.trigger('change', this.selectedTags, this.selectedCategories);
        },
        checkOption: function (optionModel, checked) {
            var currentOption = this.selectedTags.findWhere({ value: optionModel.get('value') });
            if (currentOption && !checked) {
                this.selectedTags.remove(currentOption);
            } else if (!currentOption && checked) {
                this.selectedTags.add(optionModel);
            }
            this.updateTagsVisibility();
        },
        checkCategory: function (category, checked) {
            var categoryValue = category.get('value');
            var result = this.selectedCategories.findWhere({ value: categoryValue });
            if (result && !checked) {
                this.selectedCategories.remove(result);
            } else if (!result && checked) {
                this.selectedCategories.add({ value: categoryValue });
            }
            var model = this.collection.findWhere({ value: categoryValue });
            if (!model) {
                return;
            }
            _.chain(model.get('items')).map(function (option) {
                return this.selectedTags.findWhere({ value: option.value });
            }, this).each(this.selectedTags.remove, this.selectedTags);
        },
        renderTags: function () {
            if (this.showTags) {
                this.tags = new Tags({ collection: this.selectedTags });
                this.tagsRegion.show(this.tags);
            }
            this.updateTagsVisibility();
        },
        updateTagsVisibility: function () {
            if (!this.showTags) {
                return;
            }
            this.tagsRegion.$el.toggle(!!this.selectedTags.length);
        },
        getSelected: function () {
            return {
                items: this.selectedTags,
                categories: this.selectedCategories
            };
        }
    });
});
define('common-modules/forms/views/fields/category-select-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/patterns/category-select/category-select'
], function (BaseSubviewField, CategorySelect) {
    'use strict';
    return BaseSubviewField.extend({
        initSubView: function () {
            return new CategorySelect({ collection: new Backbone.Collection(this.schema.categories) });
        },
        getValue: function () {
            return this.subView.getSelected().items.pluck('value');
        },
        setValue: function (selectedOptions) {
            var valueEqual = this.schema.valueEqual || function (v1, v2) {
                return v1 === v2;
            };
            this.subView.collection.each(function (category) {
                _.each(category.get('items'), function (option) {
                    var match = _.find(selectedOptions, _.partial(valueEqual, option.value));
                    if (match) {
                        this.subView.checkOption(new Backbone.Model(option), true);
                    }
                }, this);
            }, this);
        }
    });
});
define('common-modules/forms/views/fields/country-field', [
    'common-modules/forms/views/fields/styled-select',
    'common-modules/utils/countries/countries'
], function (StyledSelect, countries) {
    'use strict';
    return StyledSelect.extend({
        createOptions: function (options) {
            options = options || countries;
            if (!!this.schema.iso3) {
                options = _.map(options, function (country) {
                    return _.extend({}, country, { value: country.value_iso3 });
                });
            }
            options = this.prioritizeTopCountry(options);
            return StyledSelect.prototype.createOptions.call(this, options);
        },
        prioritizeTopCountry: function (options) {
            if (!this.getTopCountry())
                return options;
            var topCountry = _.findWhere(options, { value: this.getTopCountry() });
            if (!topCountry)
                return options;
            var index = _.indexOf(options, topCountry);
            options.splice(0, 0, options.splice(index, 1)[0]);
            return options;
        },
        setInitialValue: function (value) {
            if (!value)
                value = this.getDefaultCountry();
            return this.setValue(value);
        },
        getBlankValue: function () {
            return this.getDefaultCountry() || StyledSelect.prototype.getBlankValue.apply(this, arguments);
        },
        getDefaultCountry: function () {
            return _.result(this.schema, 'defaultCountry');
        },
        getTopCountry: function () {
            return _.result(this.schema, 'topCountry');
        }
    });
});
define('common-modules/forms/views/fields/custom-view-field', ['common-modules/forms/views/fields/base-subview-field'], function (BaseSubviewField) {
    'use strict';
    return BaseSubviewField.extend({
        initSubView: function () {
            return new this.schema.customView({ model: this.model });
        },
        getValue: function () {
            return this.subView.getValue();
        },
        setValue: function (value) {
            if (!this.subView.setValue) {
                return;
            }
            this.subView.setValue(value);
        },
        validate: function () {
            if (!this.subView.validate) {
                return;
            }
            return this.subView.validate();
        },
        commit: function () {
            if (!this.subView.commit) {
                return;
            }
            return this.subView.commit();
        }
    });
});
define('common-modules/forms/templates/fields/field-titleless.tpl.html', [], function () {
    return '<div class="adb-form--field field-<%- key %>">\n\t<span data-editor></span>\n\t<div class="adb-caption adb-form--caption js-field-caption"><%- help %></div>\n</div>\n';
});
define('common-modules/forms/templates/fields/input-row-item.tpl.html', [], function () {
    return '<div class="adb-input_row--item adb-input_row--primary"></div>\n';
});
define('common-modules/forms/templates/fields/input-row-affixes.tpl.html', [], function () {
    return '<div class="adb-input_row--item adb-input_row--label">\n\t<label class="adb-input_row--item_content" for="<%-editorId%>"><%-label%></label>\n</div>\n';
});
define('common-modules/forms/templates/fields/input-row-icon-affixes.tpl.html', [], function () {
    return '<div class="adb-input_row--item adb-input_row--label">\n\t<label class="adb-input_row--item_content" for="<%-editorId%>"><i class="adb-icon__<%- iconName %>"></i></label>\n</div>\n';
});
define('common-modules/forms/views/fields/field-width-type', ['object-utils'], function (ObjectUtils) {
    'use strict';
    return ObjectUtils.constants([
        'AUTO',
        'FULL'
    ]);
});
define('common-modules/forms/views/fields/field', [
    'backbone-forms',
    'common-modules/forms/templates/fields/field-titleless.tpl.html',
    'common-modules/forms/templates/fields/input-row-item.tpl.html',
    'common-modules/forms/templates/fields/input-row-affixes.tpl.html',
    'common-modules/forms/templates/fields/input-row-icon-affixes.tpl.html',
    'common-modules/forms/views/help-tooltip',
    'common-modules/forms/views/fields/field-width-type'
], function (Form, FieldTitleless, inputRowItemTemplate, inputRowAffixes, inputRowIconAffixes, HelpTooltip, FieldWidthType) {
    'use strict';
    var originalRender = Form.Field.prototype.render;
    Form.Field.errorClassName = 'adb-is-error';
    return {
        initialize: function (options) {
            options = options || {};
            _.extend(this, _.pick(options, 'form', 'key', 'model', 'value', 'idPrefix'));
            this.schema = this.createSchema(options.schema);
            this.errorClassName = options.errorClassName || this.errorClassName || this.constructor.errorClassName;
            this.template = this.getTemplate(options);
            this.editor = this.createEditor();
        },
        getTemplate: function (options) {
            if (this.schema.hideTitle) {
                return _.template(FieldTitleless);
            }
            return options.template || this.schema.template || this.template || this.constructor.template;
        },
        templateData: function () {
            var schema = this.schema;
            var showRequired = this.schema && this.schema.validators && _.some(this.schema.validators, function (validator) {
                if (_.isString(validator)) {
                    validator = Form.validators[validator];
                } else if (_.isObject(validator) && validator.type) {
                    validator = Form.validators[validator.type];
                } else if (!_.isFunction(validator)) {
                    validator = null;
                }
                return validator ? !!validator.showRequired : false;
            });
            var showRequiredEnabled = this.options.form.options.showRequired;
            var showOptional = !showRequired && this.options.form.options.showOptional;
            var requiredType = this.options.form.options.showRequiredAtRight ? 'adb-label__required reversed' : 'adb-label__required';
            return {
                help: schema.help || '',
                helpHTML: schema.helpHTML || '',
                title: schema.title,
                titleHTML: schema.titleHTML,
                fieldAttrs: schema.fieldAttrs,
                editorAttrs: schema.editorAttrs,
                key: this.key,
                editorId: this.editor.id,
                labelClass: showRequired && showRequiredEnabled ? requiredType : '',
                optionalClass: showOptional ? '' : 'adb-is-hidden'
            };
        },
        render: function () {
            originalRender.apply(this, arguments);
            this.$el.toggleClass('adb-form--inline_field', !!this.schema.inline);
            this.$el.toggleClass('adb-form--inline_fields', !!this.schema.inlineFields);
            this.$el.toggleClass('adb-form--field', !this.schema.inlineFields && !this.editor.constructor.IS_CONTAINER);
            this.renderCaption();
            this.renderHelpToolTip();
            this.renderAffixes();
            this.trigger('render');
            return this;
        },
        renderCaption: function () {
            if (!this.schema.help && !this.schema.helpHTML) {
                this.$('> .js-field-caption').remove();
            }
        },
        renderAffixes: function () {
            var pre = this.schema.prefix, suf = this.schema.suffix, iconSuf = this.schema.iconSuffix, iconPre = this.schema.iconPrefix, editor = this.$('> [data-editor]');
            if (!pre && !suf && !iconPre && !iconSuf) {
                return;
            }
            editor.addClass('adb-input_row');
            if (this.schema.widthType === FieldWidthType.FULL) {
                editor.addClass('adb-input_row__full_width');
            } else if (this.schema.widthType === FieldWidthType.AUTO) {
                editor.addClass('adb-input_row__auto_width');
            }
            editor.append($(inputRowItemTemplate).append(editor.children().addClass('adb-input_row--item_content')));
            if (pre) {
                var $prefix = $(_.template(inputRowAffixes, {
                    label: _.result(this.schema, 'prefix'),
                    editorId: this.editor.id
                }));
                this.$prefix = this.editor.$prefix = $prefix;
                editor.prepend($prefix);
            }
            if (suf) {
                var $suffix = $(_.template(inputRowAffixes, {
                    label: _.result(this.schema, 'suffix'),
                    editorId: this.editor.id
                }));
                this.$suffix = this.editor.$suffix = $suffix;
                editor.append($suffix);
            }
            if (iconPre) {
                var $iconPrefix = $(_.template(inputRowIconAffixes, {
                    iconName: _.result(this.schema, 'iconPrefix'),
                    editorId: this.editor.id
                }));
                this.$iconPrefix = this.editor.$iconPrefix = $iconPrefix;
                editor.prepend($iconPrefix);
            }
            if (iconSuf) {
                var $iconSuffix = $(_.template(inputRowIconAffixes, {
                    iconName: _.result(this.schema, 'iconSuffix'),
                    editorId: this.editor.id
                }));
                this.$iconSuffix = this.editor.$iconSuffix = $iconSuffix;
                editor.append($iconSuffix);
            }
        },
        renderHelpToolTip: function () {
            if (this.schema.helpTooltip) {
                this.helpTooltip = new HelpTooltip({ help: _.result(this.schema, 'helpTooltip') });
                this.$('> label .adb-label--status').before(this.helpTooltip.render().el);
            }
        },
        setError: function (msg) {
            if (this.editor.hasNestedForm) {
                return;
            }
            this.editor.$el.addClass(this.errorClassName);
            this.editor.$el.attr('data-error', '');
            this.$('.js-error-message').html(msg).removeClass('adb-is-hidden');
        },
        clearError: function () {
            this.editor.$el.removeClass(this.errorClassName);
            this.editor.$el.attr('data-error', null);
            this.$('.js-error-message').empty().addClass('adb-is-hidden');
        },
        remove: function () {
            if (this.helpTooltip) {
                this.helpTooltip.close();
            }
            this.constructor.__super__.remove.apply(this, arguments);
        }
    };
});
define('common-modules/forms/templates/fields/fieldset.tpl.html', [], function () {
    return '<fieldset data-fields>\n\t<% if (legend) { %>\n\t\t<h3><%- legend %> <span class="js-help-tooltip"></span></h3>\n\t<% } %>\n</fieldset>\n';
});
define('common-modules/forms/templates/fields/fieldset-container.tpl.html', [], function () {
    return '<fieldset class="adb-container">\n\t<% if (legend) { %>\n\t<div class="adb-container_header">\n\t\t<h3 class="adb-container_header--title adb-container_header--item foobar">\n\t\t\t<span><%- legend %></span>\n\t\t</h3>\n\t\t<div class="js-help-tooltip adb-container_header--title adb-container_header--item"></div>\n\t</div>\n\t<% } %>\n\t<div class="adb-container_content" data-fields></div>\n\t<% if (footer) { %>\n\t<div class="adb-container_footer js-submit-footer"></div>\n\t<% } %>\n</fieldset>\n';
});
define('common-modules/forms/views/fieldset', [
    'backbone-forms',
    'common-modules/forms/templates/fields/fieldset.tpl.html',
    'common-modules/forms/templates/fields/fieldset-container.tpl.html',
    'common-modules/forms/views/help-tooltip',
    'common-modules/buttons/button'
], function (Form, FieldsetTemplate, FieldsetContainerTemplate, HelpTooltip, Button) {
    'use strict';
    var OriginalFieldset = Form.Fieldset;
    return Form.Fieldset.extend({
        render: function () {
            if (!_.keys(this.fields).length) {
                return this;
            }
            OriginalFieldset.prototype.render.apply(this, arguments);
            this.renderHelpToolTip();
            this.renderHelpText();
            this.renderSubmitFooter();
            return this;
        },
        template: function () {
            var tpl = this.options.showContainer ? FieldsetContainerTemplate : FieldsetTemplate;
            return _.template(tpl).apply(this, arguments);
        },
        createSchema: function () {
            var schema = OriginalFieldset.prototype.createSchema.apply(this, arguments);
            return _.extend({}, schema, {
                fields: _.result(schema, 'fields'),
                footer: _.result(schema, 'footer')
            });
        },
        renderHelpToolTip: function () {
            if (this.helpTooltip) {
                this.helpTooltip.close();
            }
            if (this.schema.helpTooltip) {
                this.helpTooltip = new HelpTooltip({ help: _.result(this.schema, 'helpTooltip') });
                this.$('.js-help-tooltip').append(this.helpTooltip.render().el);
            }
        },
        renderHelpText: function () {
            if (this.schema.help) {
                $('<p class="adb-caption">').html(_.result(this.schema, 'help')).prependTo(this.$('> [data-fields]'));
            }
        },
        renderSubmitFooter: function () {
            if (this.schema.footer) {
                var button = new Button({
                    label: this.schema.footer,
                    type: Button.TYPES.PRIMARY
                });
                this.$('.js-submit-footer').append(button.render().el);
                this.listenTo(button, 'click', _.bind(this.trigger, this, 'submit'));
            }
        },
        remove: function () {
            if (this.helpTooltip) {
                this.helpTooltip.close();
            }
            OriginalFieldset.prototype.remove.apply(this, arguments);
        }
    });
});
define('common-modules/forms/templates/key-fingerprint-tpl.html', [], function () {
    return '<div class="js-key_fingerprint ">\n\t<div class="adb-layout-column__14_7">\n\t\t<input class="js-key_fingerprint-input" type="text" disabled>\n\t</div>\n\n\t<label class="adb-layout-column__14_3 js-key_expiration-date-label"><%- l(\'form.field.key.fingerprint.expires\') %> &nbsp;<span class="js-key_fingerprint-expiration"><%-expirationDate%></span></label>\n\t<label class="js-key_fingerprint-edit-toggle adb-layout-column__14_3">\n\t\t<a class="">\n\t\t\t<i class="adb-icon__eye"></i> <%- l(\'form.field.key.fingerprint.viewedit\') %>\n\t\t</a>\n\t</label>\n\t<textarea class="js-key_pem-key"></textarea>\n</div>\n';
});
define('common-modules/forms/views/key-fingerprint', [
    'backbone-forms',
    'common-modules/forms/templates/key-fingerprint-tpl.html'
], function (Form, templateKeyFingerprint) {
    'use strict';
    var PEMFingerprint = Marionette.ItemView.extend({
        tagName: 'div',
        ui: {
            inputFingerprint: '.js-key_fingerprint',
            PEMFingerprint: '.js-key_fingerprint-input',
            expirationDate: '.js-key_fingerprint-expiration',
            pemKey: '.js-key_pem-key',
            editToggle: '.js-key_fingerprint-edit-toggle',
            expirationDateLabel: '.js-key_expiration-date-label'
        },
        events: {
            'keyup @ui.pemKey': '_onChange',
            'focus @ui.pemKey': '_onFocus',
            'focusout @ui.pemKey': '_onFocusOut',
            'blur @ui.pemKey': '_onBlur',
            'click @ui.editToggle': '_toggle'
        },
        initialize: function (options) {
            options = options || {};
            this.model = options.model;
        },
        onRender: function () {
            this._setVal();
        },
        getTemplate: function () {
            return _.template(templateKeyFingerprint);
        },
        serializeData: function () {
            return {
                fingerprint: this.model.get('fingerprint'),
                expirationDate: this.model.get('expireDate'),
                pemkey: this.model.get('pemKey')
            };
        },
        _setVal: function () {
            this.ui.pemKey.css('display', 'none');
            this.ui.pemKey.val(this.model.get('pemKey'));
            this.ui.PEMFingerprint.val(this.model.get('fingerprint'));
            this.ui.expirationDate.val(this.model.get('expireDate'));
            this._updateExpirationDate();
        },
        _onFocusOut: function () {
            if (this.model.get('pemKey') !== this.ui.pemKey.val()) {
                this.model.set('pemKey', this.ui.pemKey.val());
                this.model.set('expireDate', '');
                this.model.set('fingerprint', '');
            }
            this._setVal();
        },
        _onChange: function () {
            this.trigger('change');
        },
        _onFocus: function () {
            this.trigger('focus');
        },
        _onBlur: function () {
            this.trigger('blur');
        },
        _updateExpirationDate: function () {
            this.ui.expirationDateLabel.toggle(this.model.hasExpirationDate());
        },
        _toggle: function () {
            this.ui.pemKey.toggle();
        }
    });
    return PEMFingerprint;
});
define('common-modules/forms/views/fields/key-fingerprint-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/key-fingerprint'
], function (BaseField, KeyFingerprint) {
    'use strict';
    return BaseField.extend({
        initialize: function (options) {
            BaseField.prototype.initialize.call(this, options);
            var KeyFingerprintModel = Backbone.Model.extend({
                hasExpirationDate: function () {
                    this.get('expireDate');
                }
            });
            if (options.key) {
                this.fieldModel = new KeyFingerprintModel(options.model.get(options.key));
            }
        },
        initSubView: function () {
            this.subview = new KeyFingerprint({
                fingerprint: this.fieldModel.get('fingerprint'),
                pemKey: this.fieldModel.getpemKey,
                expireDate: this.fieldModel.expireDate,
                model: this.fieldModel
            });
            return this.subview;
        },
        getValue: function () {
            return this.subview.model.get('pemKey');
        }
    });
});
define('common-modules/forms/views/json-textarea-input', ['common-modules/forms/views/textarea-input'], function (TextAreaInput) {
    'use strict';
    return TextAreaInput.extend({
        getValue: function () {
            var value = this.ui.textarea.val();
            try {
                value = JSON.stringify(JSON.parse(value));
            } catch (error) {
            }
            return value;
        },
        setValue: function (text) {
            var newValue = text;
            try {
                newValue = JSON.stringify(JSON.parse(text), undefined, 2);
            } catch (error) {
            }
            this.ui.textarea.val(newValue);
        }
    });
});
define('common-modules/forms/views/fields/json-textarea-field', [
    'common-modules/forms/views/fields/textarea-field',
    'common-modules/forms/views/json-textarea-input'
], function (TextAreaField, JsonTextAreaInput) {
    'use strict';
    return TextAreaField.extend({
        initSubView: function () {
            return new JsonTextAreaInput(this.textareaOptions);
        }
    });
});
define('common-modules/forms/templates/fields/input-table.tpl.html', [], function () {
    return '<div class="adb-input_table adb-form--field">\n  <table>\n    <tbody class="js-region-inputs"></tbody>\n  </table>\n  <div class="js-region-add-button"></div>\n\n  <button class="adb-button__small adb-button__secondary js-ui-add-button" type="button">\n    <i class="adb-icon__add"></i>\n    <%- addLabel %>\n  </button>\n</div>\n';
});
define('common-modules/forms/templates/fields/input-table-item.tpl.html', [], function () {
    return '<td class="js-hook-insert">\n  <button class="adb-button__square adb-button__secret js-delete-btn" type="button">\n    <i class="adb-icon__trash"></i>\n  </button>\n</td>\n';
});
define('common-modules/forms/templates/fields/input-table-item-default.tpl.html', [], function () {
    return '<td class="adb-input_table--primary" data-auto="input-table-item-default">\n  <input type="text" class="js-ui-input" value="<%=value%>" >\n</td>\n';
});
define('common-modules/forms/views/fields/input-table-item-default', ['common-modules/forms/templates/fields/input-table-item-default.tpl.html'], function (inputTemplate) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template(inputTemplate),
        ui: { input: '.js-ui-input' },
        triggers: { 'change @ui.input': 'change' },
        initialize: function (options) {
            this.valueField = options.valueField;
            this.isDisabled = !!options.isDisabled;
        },
        getValue: function () {
            var val = {};
            val[this.valueField] = this.ui.input.val();
            return val;
        },
        serializeData: function () {
            return { value: this.model.get(this.valueField) || '' };
        },
        onRender: function () {
            if (this.isDisabled) {
                this.disable();
            }
        },
        disable: function () {
            this.$el.addClass('adb-is-disabled');
            this.ui.input.attr('disabled', true);
        }
    });
});
define('common-modules/forms/views/fields/input-table-item-view', [
    'common-modules/forms/templates/fields/input-table-item.tpl.html',
    'common-modules/forms/views/fields/input-table-item-default'
], function (inputTemplate, DefaultItemView) {
    'use strict';
    return Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(inputTemplate),
        ui: {
            deleteBtn: '.js-delete-btn',
            insertHook: '.js-hook-insert'
        },
        triggers: { 'click @ui.deleteBtn': 'delete' },
        initialize: function (options) {
            options = options || {};
            this.valueField = options.valueField;
            this.ItemView = options.customItemView || DefaultItemView;
            this.isDisabled = !!options.isDisabled;
        },
        onRender: function () {
            this.subItemView = new this.ItemView({
                model: this.model,
                valueField: this.valueField,
                isDisabled: this.isDisabled
            });
            this.ui.insertHook.before(this.subItemView.render().el);
            if (this.isDisabled) {
                this.disable();
            }
        },
        getValue: function () {
            return this.subItemView.getValue();
        },
        disable: function () {
            this.$el.addClass('adb-is-disabled');
            this.ui.deleteBtn.attr('disabled', true);
        },
        onClose: function () {
            this.subItemView.close();
        }
    });
});
define('common-modules/forms/views/fields/input-table-view', [
    'common-modules/forms/templates/fields/input-table.tpl.html',
    'common-modules/forms/views/fields/input-table-item-view'
], function (tableTemplate, ItemView) {
    'use strict';
    return Marionette.CompositeView.extend({
        ui: { addBtn: '.js-ui-add-button' },
        events: { 'click @ui.addBtn': 'addItem' },
        itemEvents: {
            delete: 'deleteItem',
            change: 'onItemChange'
        },
        template: _.template(tableTemplate),
        itemView: ItemView,
        itemViewContainer: '.js-region-inputs',
        itemViewOptions: function () {
            return {
                valueField: this.valueField,
                customItemView: this.customItemView,
                isDisabled: this.isDisabled
            };
        },
        initialize: function (options) {
            options = options || {};
            this.collection = options.collection || new Backbone.Collection();
            this.addLabel = options.addLabel;
            this.valueField = options.valueField;
            this.customItemView = options.customItemView;
            this.isDisabled = !!options.isDisabled;
        },
        addItem: function () {
            if (this.isDisabled) {
                return;
            }
            this.collection.add({});
            this.onItemChange();
        },
        deleteItem: function (event, itemview) {
            this.collection.remove(itemview.model);
            this.onItemChange();
        },
        getValue: function () {
            var values = this.children.invoke('getValue');
            if (values.length > 0) {
                return values;
            }
        },
        setValue: function (models) {
            this.collection.reset(models);
            if (this.collection.isEmpty()) {
                this.addItem();
            }
        },
        onItemChange: function () {
            this.trigger('change');
        },
        serializeData: function () {
            return { addLabel: this.addLabel };
        },
        disable: function () {
            this.$el.addClass('adb-is-disabled');
            this.ui.addBtn.attr('disabled', true);
        }
    });
});
define('common-modules/forms/views/fields/input-table-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/fields/input-table-view'
], function (BaseField, InputTable) {
    'use strict';
    return BaseField.extend({
        initialize: function (options) {
            BaseField.prototype.initialize.call(this, options);
            if (!this.schema || !this.schema.valueField && !this.schema.itemView) {
                throw new Error('Missing required "schema.valueField" to populate the inputs');
            }
            if (this.schema.itemView && !_.isFunction(this.schema.itemView.prototype.getValue)) {
                throw new Error('When using a custom itemView, getValue needs to be defined on that view');
            }
            this.valueField = this.schema.valueField;
            this.addLabel = this.schema.addLabel || l('Add');
            this.customItemView = this.schema.itemView;
            this.isDisabled = _.isFunction(this.schema.isDisabled) ? this.schema.isDisabled(this.model) : this.schema.isDisabled;
        },
        initSubView: function () {
            return new InputTable({
                addLabel: this.addLabel,
                valueField: this.valueField,
                customItemView: this.customItemView,
                isDisabled: this.isDisabled
            });
        },
        getValue: function () {
            return this.subView.getValue();
        },
        setValue: function (value) {
            this.subView.setValue(value);
        }
    }, { IS_CONTAINER: true });
});
define('common-modules/forms/templates/clearable-text.tpl.html', [], function () {
    return '<input class="adb-text--clearable_content" type="text">\n<i class="adb-text--clearable_clear adb-icon__delete"></i>\n\n';
});
define('common-modules/forms/views/clearable-text-input', [
    'common-modules/forms/templates/clearable-text.tpl.html',
    'object-utils'
], function (template, ObjectUtils) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template(template),
        className: 'adb-text--clearable',
        ui: {
            text: '.adb-text--clearable_content',
            clear: '.adb-text--clearable_clear'
        },
        triggers: { focus: 'focus' },
        events: {
            'click @ui.clear': 'onClickClear',
            'focus @ui.text': '_onFocus',
            'focusout @ui.text': '_onFocusOut',
            'keyup @ui.text': '_onKeyUp',
            'click @ui.text': '_onKeyUp'
        },
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'title',
                'prefix',
                'suffix',
                'editorAttrs'
            ]);
            this.type = 'text';
        },
        onRender: function () {
            if (this.editorAttrs && this.editorAttrs.readonly) {
                this.ui.text.attr('readonly', true);
            }
        },
        onClickClear: function () {
            this.clear();
        },
        setValue: function (value) {
            this.ui.text.val(value);
            this._onKeyUp();
        },
        getValue: function () {
            return this.ui.text.val();
        },
        focus: function () {
            this.ui.text.focus();
        },
        clear: function () {
            this.ui.text.val('');
            this.$el.removeClass('adb-is-active');
        },
        hasFocus: function () {
            return this.$el.hasClass('adb-is-focused');
        },
        _onFocus: function () {
            this.$el.addClass('adb-is-focused');
            if (!_.isEmpty(this.getValue())) {
                this.$el.addClass('adb-is-active');
            }
        },
        _onFocusOut: function () {
            this.$el.removeClass('adb-is-focused');
        },
        _onKeyUp: function () {
            if (!_.isEmpty(this.getValue())) {
                this.$el.addClass('adb-is-active');
                return;
            }
            this.$el.removeClass('adb-is-active');
        }
    });
});
define('common-modules/forms/views/fields/clearable-text-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/clearable-text-input'
], function (BaseSubviewField, ClearableTextInput) {
    'use strict';
    return BaseSubviewField.extend({
        initSubView: function () {
            return new ClearableTextInput(this.schema);
        },
        getValue: function () {
            return this.subView.getValue();
        },
        setValue: function (value) {
            this.subView.setValue(value);
        },
        focus: function () {
            if (this.hasFocus) {
                return;
            }
            this.subView.focus();
        }
    });
});
define('common-modules/forms/templates/form.tpl.html', [], function () {
    return '<form class="adb-form" role="form">\n\t<div data-fieldsets class="adb-form--fieldset"></div>\n\t<!-- Most browsers require the form to have a submit button for the enter key to trigger a submit event -->\n  <div class="adb-layout-section"></div>\n\t<button type="submit" class="adb-button__primary <%- !!submitButton ? \'\' : \'adb-is-hidden\' %>"><%- submitButton %></button>\n</form>\n';
});
define('common-modules/forms/templates/fields/field.tpl.html', [], function () {
    return '<div class="adb-form--field field-<%- key %>">\n\t<label class="<%- labelClass %>" for="<%- editorId %>">\n\t\t<% if (titleHTML){ %><%= titleHTML %>\n\t\t<% } else { %><%- title %><% } %>\n\t\t<span class="adb-label--status <%- optionalClass %> "><%- l(\'optional\')%></span>\n\t\t<span class="adb-label--error adb-is-hidden js-error-message" data-error></span>\n\t</label>\n\t<span data-editor></span>\n\t<div class="adb-caption adb-form--caption js-field-caption">\n\t\t<% if (helpHTML) { %><%= helpHTML %>\n\t\t<% } else { %><%- help %><% } %>\n\t</div>\n</div>\n';
});
define('common-modules/forms/views/form', [
    'backbone-forms',
    'common-modules/forms/views/fields/nested-form',
    'common-modules/forms/views/fields/nested-model-form',
    'common-modules/forms/views/fields/validation-messages',
    'common-modules/forms/views/fields/validators',
    'common-modules/forms/views/fields/styled-select',
    'common-modules/forms/views/fields/boolean-styled-select',
    'common-modules/forms/views/fields/radios-field',
    'common-modules/forms/views/fields/checkboxes-field',
    'common-modules/forms/views/fields/phone-field',
    'common-modules/forms/views/fields/phone-locale-field',
    'common-modules/forms/views/fields/date-field',
    'common-modules/forms/views/fields/toggles-field',
    'common-modules/forms/views/fields/number-field',
    'common-modules/forms/views/fields/rating-field',
    'common-modules/forms/views/fields/url-field',
    'common-modules/forms/views/fields/textarea-field',
    'common-modules/forms/views/fields/zipcode-field',
    'common-modules/forms/views/fields/color-field',
    'common-modules/forms/views/fields/translations-field',
    'common-modules/forms/views/fields/inline-search-field',
    'common-modules/forms/views/fields/file-upload-field',
    'common-modules/forms/views/fields/email-domain-select-field',
    'common-modules/forms/views/fields/image-upload-field',
    'common-modules/forms/views/fields/category-select-field',
    'common-modules/forms/views/fields/country-field',
    'common-modules/forms/views/fields/custom-view-field',
    'common-modules/forms/views/fields/field',
    'common-modules/forms/views/fieldset',
    'common-modules/forms/views/fields/key-fingerprint-field',
    'common-modules/forms/views/fields/json-textarea-field',
    'common-modules/forms/views/fields/input-table-field',
    'common-modules/forms/views/fields/clearable-text-field',
    'common-modules/forms/templates/form.tpl.html',
    'common-modules/forms/templates/fields/field.tpl.html'
], function (Form, NestedForm, NestedModelForm, validationMessages, validators, StyledSelect, BooleanStyledSelect, RadioField, CheckboxesField, PhoneField, PhoneLocaleField, DateField, TogglesField, NumberField, RatingField, UrlField, TextareaField, ZipCodeField, ColorField, TranslationsField, InlineSearchField, FileUploadField, EmailDomainSelectionField, ImageUploadField, CategorySelectField, CountryField, CustomViewField, Field, Fieldset, KeyFingerprintInput, JsonTextAreaField, InputTableField, ClearableTextField, FormTemplate, FieldTemplate) {
    'use strict';
    Form.template = _.template(FormTemplate);
    Form.Field.template = _.template(FieldTemplate);
    Form.NestedField.prototype.template = _.template(FieldTemplate);
    _.extend(Form.validators.errMessages, validationMessages);
    _.extend(Form.validators, validators(Form.validators));
    Form.validators.required.showRequired = true;
    Form.Fieldset = Fieldset;
    _.extend(Form.Field.prototype, Field);
    _.extend(Form.editors.Text.prototype, {
        setValue: function (value) {
            this.$el.val(value);
            this.previousValue = value;
        }
    });
    var originalFieldInit = Form.Editor.prototype.initialize;
    _.extend(Form.Editor.prototype, {
        initialize: function (options) {
            originalFieldInit.call(this, options);
            if (options && options.form && options.form.options && options.form.options.validateOnBlur) {
                this.listenTo(this, 'blur', function () {
                    this.form.fields[this.options.key].validate();
                });
            }
        }
    });
    _.extend(Form.editors, {
        StyledSelect: StyledSelect,
        BooleanStyledSelect: BooleanStyledSelect,
        Object: NestedForm,
        NestedModel: NestedModelForm,
        Radio: RadioField,
        Checkboxes: CheckboxesField,
        Phone: PhoneField,
        PhoneLocale: PhoneLocaleField,
        Toggles: TogglesField,
        Date: DateField,
        Number: NumberField,
        Rating: RatingField,
        EmailDomainSelection: EmailDomainSelectionField,
        CountTextarea: TextareaField,
        Translations: TranslationsField,
        ZipCode: ZipCodeField,
        Color: ColorField,
        Url: UrlField,
        InlineSearch: InlineSearchField,
        InputTable: InputTableField,
        FileUpload: FileUploadField,
        ImageUpload: ImageUploadField,
        ClearableText: ClearableTextField,
        CategorySelect: CategorySelectField,
        KeyFingerprint: KeyFingerprintInput,
        JsonTextArea: JsonTextAreaField,
        Country: CountryField,
        CustomView: CustomViewField
    });
    return Form.extend({
        initialize: function () {
            Form.prototype.initialize.apply(this, arguments);
            this.removeUndefinedFields();
            this.removeUnusedFields();
        },
        removeUndefinedFields: function () {
            var toRemove = [];
            _(this.fields).each(function (field, key) {
                if (_.isUndefined(field)) {
                    toRemove.push(key);
                    delete this.fields[key];
                    delete this.selectedFields[key];
                }
            }, this);
            _(this.fieldsets).each(function (fieldset) {
                _(toRemove).each(function (key) {
                    delete fieldset.fields[key];
                });
            });
        },
        removeUnusedFields: function () {
            var usedFields = _(this.fieldsets).chain().pluck('schema').pluck('fields').flatten().value();
            _(this.fields).chain().pairs().reject(function (fieldAttribute) {
                var fieldName = fieldAttribute[0];
                return _(usedFields).contains(fieldName);
            }).each(function (fieldAttribute) {
                var fieldName = fieldAttribute[0], field = fieldAttribute[1];
                field.remove();
                delete this.fields[fieldName];
            }, this);
        },
        events: { submit: 'onSubmit' },
        onSubmit: function (e) {
            e.preventDefault();
            this.trigger('submit', e);
        },
        createField: function (key, schema) {
            if (!_.isUndefined(schema.visible)) {
                var visible = _.isFunction(schema.visible) ? schema.visible(this.model) : schema.visible;
                if (!visible) {
                    return;
                }
            }
            var field = Form.prototype.createField.apply(this, arguments);
            var toggleField = schema.toggledBy, visibleOn = schema.visibleOn;
            if (toggleField && !_.isUndefined(visibleOn)) {
                this.listenToOnce(field, 'render', _.bind(this.renderInitialFieldState, this, toggleField, field, visibleOn));
                this.listenTo(this, schema.toggledBy + ':change', _.bind(function (form, editor) {
                    this.renderField(form, editor, toggleField, field, visibleOn);
                }, this));
            }
            return field;
        },
        renderField: function (form, editor, toggleField, field, visibleOn) {
            var editorValue = editor.getValue();
            editorValue = _.isArray(editorValue) ? editorValue : [editorValue];
            visibleOn = _.isArray(visibleOn) ? visibleOn : [visibleOn];
            var show = !!_.intersection(editorValue, visibleOn).length;
            this.toggleField(field, show);
            this.maybeMoveField(form, toggleField, field, visibleOn);
        },
        renderInitialFieldState: function (toggleField, field, visibleOn) {
            var editorValue = null;
            if (this.model) {
                editorValue = this.model.get(toggleField);
            } else if (this.data) {
                editorValue = this.data[toggleField];
            }
            var editor = this.getEditor(toggleField);
            if (_.isUndefined(editorValue) && _.isFunction(editor.getBlankValue)) {
                editorValue = editor.getBlankValue();
            }
            editorValue = _.isArray(editorValue) ? editorValue : [editorValue];
            visibleOn = _.isArray(visibleOn) ? visibleOn : [visibleOn];
            var show = !!_.intersection(editorValue, visibleOn).length;
            if (field.$el.hasClass('adb-form--inline_field') && show) {
                field.$el.css('display', 'inline-block');
            } else {
                this.toggleField(field, show);
            }
            this.maybeMoveField(this, toggleField, field, visibleOn);
        },
        toggleField: function (field, show) {
            if (field.schema.inline && show) {
                field.$el.css('display', 'inline-block');
            } else {
                field.$el.toggle(show);
            }
        },
        maybeMoveField: function (form, toggleField, field, visibleOn) {
            if (field.schema.insertAfterToggler && !field.isMoved) {
                _.defer(function () {
                    field.$el.removeClass('adb-form--field');
                    form.$('.field-' + toggleField + ' [value=' + visibleOn + ']').closest('.adb-form--field, .adb-selector, .adb-toggle').after(field.$el);
                    field.isMoved = true;
                });
            }
        },
        createFieldset: function (schema) {
            var options = {
                showContainer: this.options.showContainer,
                schema: schema,
                fields: this.fields,
                legend: schema.legend || null
            };
            return new this.Fieldset(options);
        },
        getValue: function (key, options) {
            options = options || {};
            if (key)
                return this.fields[key].getValue();
            var values = {};
            _.each(this.fields, function (field) {
                if (options.includeNestedModels === false && field.schema.type === NestedModelForm)
                    return;
                values[field.key] = field.getValue();
            });
            return values;
        },
        commit: function (options) {
            options = options || {};
            var validateOptions = { skipModelValidate: !options.validate };
            var errors = this.validate(validateOptions);
            if (errors) {
                if (options.focusOnFirstError !== false) {
                    this.focusOnFirstError(errors);
                }
                return errors;
            }
            var modelError;
            var setOptions = _.extend({
                error: function (model, e) {
                    modelError = e;
                }
            }, options);
            _.each(this.fields, function (field) {
                if (field.schema.type.prototype.commit) {
                    field.commit();
                }
            });
            var data = this.getValue(null, { includeNestedModels: false });
            if (this.model.parseFormData) {
                data = this.model.parseFormData(data);
            }
            this.model.set(data, setOptions);
            _.each(this.fields, function (field) {
                if (field.schema.type === NestedModelForm) {
                    field.commit();
                }
            });
            if (modelError)
                return modelError;
        },
        render: function () {
            this.isClosed = false;
            var rendered = Form.prototype.render.apply(this, arguments);
            if (_.isArray(this.options.additions)) {
                this.additionViews = [];
                var fieldCursors = {};
                _.each(this.options.additions, function (addition) {
                    var field = fieldCursors[addition.after] || this.fields[addition.after];
                    var view = addition.view || new (Marionette.ItemView.extend({
                        template: addition.template,
                        model: this.model
                    }))();
                    this.additionViews.push(view);
                    field.$el.after(view.render().el);
                    fieldCursors[addition.after] = view;
                }, this);
            }
            return rendered;
        },
        close: function () {
            if (this.isClosed) {
                return;
            }
            this.isClosed = true;
            if (this.additionViews) {
                _.invoke(this.additionViews, 'close');
            }
            this.remove();
        },
        focusOnFirstError: function (errors) {
            var fieldName = _.find(_.keys(this.fields), function (name) {
                return !!errors[name];
            });
            if (fieldName) {
                this.fields[fieldName].focus();
            }
        },
        showFieldError: function (name, message, options) {
            options = options || {};
            var field = this.fields[name];
            field.setError(message);
            if (options.focus !== false) {
                field.editor.$el.focus();
            }
        },
        showFieldErrors: function (errors) {
            _(errors).each(function (message, field) {
                this.showFieldError(field, message, { focus: false });
            }, this);
            this.focusOnFirstError(errors);
        },
        handleEditorEvent: function (event, editor) {
            Form.prototype.handleEditorEvent.apply(this, arguments);
            if (event === 'change') {
                this.trigger('editor:change', editor);
            }
        }
    });
});
define('common-modules/containers/views/threaded-comment-edit-form', [
    'common-modules/forms/views/form',
    'common-modules/buttons/button-toolbar'
], function (Form, Toolbar) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template('<div class="js-form"></div><p class="js-buttons"></p>'),
        regions: {
            formContainer: '.js-form',
            buttonContainer: '.js-buttons'
        },
        initialize: function (options) {
            this.labels = options.labels;
        },
        onRender: function () {
            this.renderForm();
            this.renderButtons();
        },
        renderForm: function () {
            var modelData = this.getModelData();
            var Model = Backbone.Model.extend(modelData);
            var questionsFormModel = new Model();
            this.form = new Form({ model: questionsFormModel });
            this.formContainer.show(this.form);
        },
        getModelData: function () {
            var modelData = {
                schema: {
                    title: {
                        type: 'Text',
                        title: this.labels.editFormTitleLabel,
                        validators: ['required']
                    },
                    comment: {
                        type: 'CountTextarea',
                        title: this.labels.editFormCommentLabel,
                        count: 2048,
                        validators: [
                            'required',
                            {
                                type: 'maxLength',
                                max: 2048
                            }
                        ]
                    }
                },
                defaults: {
                    title: this.model.getTitle(),
                    comment: this.model.getComment()
                }
            };
            if (this.model.getRating()) {
                modelData.schema = _.extend({
                    rating: {
                        type: 'Rating',
                        title: this.labels.editFormRatingLabel,
                        validators: [{
                                type: 'range',
                                min: 1,
                                max: 5
                            }]
                    }
                }, modelData.schema);
                modelData.defaults.rating = this.model.getRating();
            }
            return modelData;
        },
        renderButtons: function () {
            var buttons = [
                {
                    label: l('Submit'),
                    value: 'edit',
                    type: Toolbar.TYPES.PRIMARY
                },
                {
                    label: l('Cancel'),
                    value: 'cancel',
                    type: Toolbar.TYPES.SECRET
                }
            ];
            var toolbar = new Toolbar({ collection: new Backbone.Collection(buttons) });
            this.buttonContainer.show(toolbar);
            this.listenTo(toolbar, 'click:edit', _.bind(this.onEdit, this));
            this.listenTo(toolbar, 'click:cancel', _.bind(this.onCancel, this));
        },
        onEdit: function () {
            this.trigger('edit:saved', this.model);
        },
        onCancel: function () {
            this.trigger('edit:cancel');
        },
        isFormValid: function () {
            var errors = this.form.validate();
            return _.isEmpty(errors);
        }
    });
});
define('common-modules/containers/templates/threaded-comment-reply-form.tpl.html', [], function () {
    return '<h4><%- labels.createFormCommentLabel %></h4>\n<div class="js-form-container"></div>\n<p class="js-menu"></p>\n';
});
define('common-modules/containers/views/threaded-comment-reply-form', [
    'common-modules/containers/templates/threaded-comment-reply-form.tpl.html',
    'common-modules/behaviors/char-countdown',
    'common-modules/forms/views/form',
    'common-modules/buttons/button-toolbar'
], function (template, CharCountdown, Form, Toolbar) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template(template),
        regions: {
            formContainer: '.js-form-container',
            menuContainer: '.js-menu'
        },
        initialize: function (options) {
            this.labels = options.labels;
        },
        onRender: function () {
            this.renderForm();
            this.renderButtons();
        },
        renderForm: function () {
            var modelData = this.getModelData();
            var Model = Backbone.Model.extend(modelData);
            var questionsFormModel = new Model();
            this.form = new Form({ model: questionsFormModel });
            this.formContainer.show(this.form);
        },
        getModelData: function () {
            var modelData = {
                schema: {
                    comment: {
                        type: 'CountTextarea',
                        hideTitle: true,
                        title: this.labels.createFormCommentLabel,
                        placeholder: this.labels.createFormCommentPlaceholder,
                        count: 2048,
                        validators: [
                            'required',
                            {
                                type: 'maxLength',
                                max: 2048
                            }
                        ]
                    }
                }
            };
            return modelData;
        },
        renderButtons: function () {
            var buttons = new Backbone.Collection([
                {
                    label: this.labels.createFormCommentSubmitButton,
                    value: 'reply',
                    buttonClasses: 'adb-button__primary',
                    size: Toolbar.SIZES.MEDIUM
                },
                {
                    label: l('Cancel'),
                    value: 'cancel',
                    buttonClasses: 'adb-button__secret',
                    size: Toolbar.SIZES.MEDIUM
                }
            ]);
            this.menu = new Toolbar({
                collection: buttons,
                size: 'small'
            });
            this.menuContainer.show(this.menu);
            this.listenTo(this.menu, 'click:reply', _.bind(this.onReply, this));
            this.listenTo(this.menu, 'click:cancel', _.bind(this.onCancel, this));
        },
        onReply: function () {
            if (this.isFormValid()) {
                var Reply = this.model.getReplyModel();
                var reply = new Reply({}, this.model.getReplyOptions());
                reply.set(this.form.getValue());
                reply.save().done(_.bind(function () {
                    this.trigger('reply:saved', reply);
                }, this));
            }
        },
        isFormValid: function () {
            var errors = this.form.validate();
            return _.isEmpty(errors);
        },
        onCancel: function () {
            this.trigger('reply:cancel');
        },
        serializeData: function () {
            return _.extend(this.model.toJSON(), { labels: this.labels });
        }
    });
});
define('common-modules/containers/templates/threaded-comment.tpl.html', [], function () {
    return '<div class="js-author adb-slat--column">\n\t<div class="adb-slat--image js-author-image"></div>\n\t<% if(isCurrentAuthor) { %>\n\t<h6 class="adb-slat--image_caption"><%- labels.currentAuthorLabel %></h6>\n\t<% } %>\n</div>\n<div class="adb-slat--content adb-slat--column js-content">\n\t<h3><%- title %><div class="js-tags-container"></div></h3>\n\t<div class="js-rating"></div>\n\t<p><%- comment %></p>\n\t<p class="adb-subtitle">\n\t\tby <%- author %> on <%- date %>\n\t</p>\n\t<p class="adb-caption js-menu-container">\n\t\t<a class="js-menu-more"></a>\n\t\t<a class="js-menu-reply"><%- labels.replyButton %></a>\n\t\t<a class="js-menu-edit"><%- labels.editButton %></a>\n\t\t<a class="js-menu-delete"><%- l(\'Delete\') %></a>\n\t</p>\n\t<div class="js-form"></div>\n\t<div class="js-replies-container"></div>\n</div>\n';
});
define('common-modules/status/views/badge', ['common-modules/buttons/tooltip-trigger'], function (TooltipTrigger) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template('<%= text %>'),
        linkTemplate: _.template('<a href="<%-url%>"><%=text%></a>'),
        iconTemplate: _.template('<i class="adb-icon__<%- type %>"></i>'),
        tagName: 'span',
        className: 'js-badge adb-badge',
        initialize: function (options) {
            options = options || {};
            this.model = this.model || new Backbone.Model();
            this.type = options.type || this.model.get('type');
            this.text = options.text;
            this.url = options.url || this.model.get('url');
            this.labelField = options.labelField;
            this.icon = options.icon || this.model.get('icon');
            this.tooltipOptions = options.tooltipOptions || this.model.get('tooltipOptions');
            if (this.url) {
                this.template = this.linkTemplate;
            }
            if (!this.type) {
                throw new Error('Badge type is required when creating a badge');
            }
        },
        onRender: function () {
            this.$el.addClass(this.getTypeClass());
            this.renderTooltip();
        },
        renderTooltip: function () {
            if (this.tooltipOptions) {
                this.tooltipTrigger = new TooltipTrigger(_.extend({ el: this.$el }, this.tooltipOptions));
                this.tooltipTrigger.triggerMethod('render');
            }
        },
        serializeData: function () {
            var text = _.escape(this.text || this.model.get('text') || this.model.get(this.labelField) || '');
            if (this.icon) {
                text = this.iconTemplate({ type: this.icon }) + text;
            }
            return {
                text: text,
                url: this.url || ''
            };
        },
        onClose: function () {
            if (this.tooltipTrigger) {
                this.tooltipTrigger.close();
            }
        },
        getTypeClass: function () {
            return this.constructor.TYPE_PREFIX + this.type;
        }
    }, {
        TYPE_PREFIX: 'adb-badge__',
        TYPE: {
            ICON: 'icon',
            NUMBER: 'number',
            ERROR: 'error',
            PENDING: 'pending',
            SUCCESS: 'success',
            INFO: 'info',
            EMPHASIS: 'emphasis',
            OUTLINE: 'outline',
            OUTLINE_PENDING: 'outline_pending',
            OUTLINE_SUCCESS: 'outline_success',
            OUTLINE_ERROR: 'outline_error',
            OUTLINE_INFO: 'outline_info'
        }
    });
});
define('common-modules/status/views/badges', ['common-modules/status/views/badge'], function (Badge) {
    'use strict';
    return Marionette.CollectionView.extend({
        itemView: Badge,
        className: 'adb-badges',
        initialize: function (options) {
            this.type = options.type;
            this.labelField = options.labelField;
        },
        itemViewOptions: function () {
            return {
                type: this.type,
                labelField: this.labelField
            };
        }
    }, { TYPE: Badge.TYPE });
});
define('common-modules/modals/templates/modal.tpl.html', [], function () {
    return '<div class="adb-modal modal<%-cid%> modal-dialog adb-modal__<%- size %> active <%-className%>" role="menu">\n\t<h3 class="adb-modal--header" data-truncate>\n\t\t<%-titleText%>\n\t\t<a class="adb-close modal-dismiss" data-dismiss="modal" role="button" tabindex="0"></a>\n\t</h3>\n\t<div class="js-alert-region"></div>\n\t<div class="adb-modal--content modal-content">\n\t</div>\n\t<menu class="adb-modal--footer adb-toolbar adb-toolbar__polar modal-footer">\n\t\t<menu class="adb-toolbar--item modal-footer-left"></menu>\n\t\t<menu class="adb-toolbar--item modal-footer-right"></menu>\n\t</menu>\n</div>\n';
});
define('common-modules/utils/bubble-event', [], function () {
    'use strict';
    return function (eventName, ctx) {
        return function () {
            var args = _.toArray(arguments);
            args.unshift(eventName);
            var context = ctx || this;
            var method = context.triggerMethod ? 'triggerMethod' : 'trigger';
            context[method].apply(context, args);
        };
    };
});
define('common-modules/modals/views/modal', [
    'common-modules/modals/templates/modal.tpl.html',
    'common-modules/buttons/button-toolbar',
    'common-modules/buttons/button',
    'common-modules/behaviors/loading',
    'common-modules/utils/bubble-event'
], function (template, Toolbar, Button, LoadingBehavior, bubbleEvent) {
    'use strict';
    var ESCAPE = 27;
    var SPACE = 32;
    var RETURN = 13;
    var TextContent = Marionette.ItemView.extend({
        tagName: 'p',
        initialize: function (text) {
            this.template = function () {
                return text;
            };
        }
    });
    var FooterGroup = Toolbar.extend({ className: 'adb-toolbar--item' });
    var instances = [];
    return Marionette.Layout.extend({
        template: _.template(template),
        events: {
            'click @ui.dismissButton': 'dismiss',
            'keydown @ui.dismissButton': 'dismissViaKeyboard'
        },
        behaviors: {
            Loading: {
                behaviorClass: LoadingBehavior,
                size: LoadingBehavior.SIZE.MEDIUM,
                container: '.modal-dialog'
            }
        },
        ui: {
            dismissButton: '.modal-dismiss',
            footer: '.modal-footer',
            content: '.modal-content'
        },
        regions: {
            content: '.modal-content',
            footer: '.modal-footer',
            footerLeft: '.modal-footer-left',
            footerRight: '.modal-footer-right',
            container: '.modal-dialog'
        },
        initialize: function (options) {
            this.titleText = options.header;
            this.attributes = options.attributes;
            this.className = options.className;
            if (_.isString(options.content)) {
                this.contentView = new TextContent(options.content);
            } else {
                this.contentView = options.content;
            }
            this.listenTo(this.contentView, 'show:loading', bubbleEvent('show:loading'));
            this.listenTo(this.contentView, 'hide:loading', bubbleEvent('hide:loading'));
            this.dismissible = options.dismissible !== false;
            this.showFooter = options.showFooter !== false;
            this.hasContentPadding = options.hasContentPadding !== false;
            if (this.showFooter) {
                this.footerLeftView = this._initializeFooter(options.footer || options.footerLeft);
                this.footerRightView = this._initializeFooter(options.footerRight);
            }
            this.centerModal = options.centerModal || false;
            this.size = options.size || this.constructor.SIZE.DEFAULT;
            this.overflow = options.overflow || this.constructor.OVERFLOW_TYPE.AUTO;
            this.bodyContainer = _.memoize(this.bodyContainer);
            _.bindAll(this, '_handleKeys');
            this._listenToKeys();
        },
        onRender: function () {
            this._addBackdrop();
            this._toggleBodyOverflow(false);
            this._addToBackdrop(this.$el);
            this.ui.dismissButton.toggle(this.dismissible);
            this.content.show(this.contentView);
            this.renderOverflow();
            this.renderFooter();
            if (!this.hasContentPadding) {
                this.content.$el.removeClass('adb-modal--content');
            }
            this._hidePreviousModal();
        },
        renderOverflow: function () {
            this.content.$el.css({ overflow: this.overflow });
        },
        renderFooter: function () {
            if (this.showFooter) {
                this.footerLeft.show(this.footerLeftView);
                this.footerRight.show(this.footerRightView);
                if (this.bodyContainer().is('.adb-styled')) {
                    this.footerRightView.$el.addClass('fright');
                }
            } else {
                this.ui.footer.remove();
            }
        },
        show: function () {
            this.container.ensureEl();
            this.container.$el.show();
            if (this.centerModal) {
                this._centerModalYAxis();
            }
            this.trigger('modal:show', this);
        },
        dismiss: function (e) {
            if (e) {
                this.trigger('modal:dismiss:manual');
            }
            this.trigger('modal:dismiss', this);
            this.bodyContainer().find('.modal' + this.cid).off('mousedown');
            this.close();
        },
        dismissViaKeyboard: function (e) {
            if (e.keyCode === RETURN || e.keyCode === SPACE || e.keyCode === ESCAPE) {
                e.preventDefault();
                e.stopPropagation();
                this.dismiss();
            }
        },
        onClickFooterButton: function (value) {
            this.trigger('modal:' + value, this);
            this.trigger('modal:click', this, value);
        },
        showLoading: function () {
            this.triggerMethod('show:loading');
        },
        hideLoading: function () {
            this.triggerMethod('hide:loading');
        },
        bodyContainer: function () {
            var container = $('<div class="adb-styled"></div>');
            $('body').append(container);
            return container;
        },
        _hidePreviousModal: function () {
            if (!_.isEmpty(instances)) {
                var previous = _.last(instances);
                previous.bodyContainer().hide();
            }
            instances.push(this);
        },
        _toggleBodyOverflow: function (overflow) {
            $('body').toggleClass('adb-is-modal-open', !overflow);
        },
        _addToBackdrop: function (el) {
            this.bodyContainer().find('.modal' + this.cid).append(el);
        },
        _initializeFooter: function (footer) {
            var collection = new Backbone.Collection(footer || []);
            var view = new FooterGroup({ collection: collection });
            view.on('click', _.bind(this.onClickFooterButton, this));
            collection.each(function (buttonModel) {
                if (buttonModel.get('dismiss')) {
                    this.on('modal:' + buttonModel.get('value'), function (modal) {
                        modal.dismiss();
                    });
                }
            }, this);
            return view;
        },
        _listenToKeys: function () {
            $(document).on('keyup.' + this.cid, this._handleKeys);
        },
        _stopListeningToKeys: function () {
            $(document).off('keyup.' + this.cid);
        },
        _handleKeys: function (e) {
            if (this.dismissible && e.keyCode === ESCAPE) {
                this.dismiss(e);
            }
        },
        _addBackdrop: function () {
            var backdrop = $('<div class="modal-backdrop fade active modal' + this.cid + '"></div>');
            this.bodyContainer().append(backdrop);
            if (this.dismissible) {
                this.bodyContainer().find('.modal' + this.cid).on('mousedown', _.bind(this._onBackdropClick, this));
            }
        },
        _onBackdropClick: function (e) {
            if ($(e.target).parent().is(this.bodyContainer())) {
                this.dismiss(e);
            }
        },
        _removeBodyContainer: function () {
            this.bodyContainer().remove();
        },
        _centerModalYAxis: function () {
            this.$el.parent().addClass('adb-modal-flexbox');
        },
        _restorePreviousModal: function () {
            instances.pop();
            if (!_.isEmpty(instances)) {
                var modal = _.last(instances);
                modal.bodyContainer().show();
            }
        },
        serializeData: function () {
            return {
                cid: this.cid,
                titleText: this.titleText || '',
                className: this.className || '',
                size: this.size
            };
        },
        onClose: function () {
            this._removeBodyContainer();
            this._stopListeningToKeys();
            this._restorePreviousModal();
            if (_.isEmpty(instances)) {
                this._toggleBodyOverflow(true);
            }
        }
    }, {
        instances: instances,
        open: function (options) {
            var modal = new this(options);
            modal.render();
            modal.show();
            return modal;
        },
        confirm: function (options) {
            options.header = options.header || l('Confirm');
            options.dismissible = options.dismissible !== false;
            options.footer = [
                {
                    label: options.confirmText || l('Confirm'),
                    value: 'confirm',
                    type: Button.TYPES.PRIMARY,
                    buttonAttributes: { 'data-auto': 'confirm' }
                },
                {
                    label: options.cancelText || l('Cancel'),
                    value: 'cancel',
                    dismiss: true,
                    type: Button.TYPES.SECRET,
                    buttonAttributes: { 'data-auto': 'reject' }
                }
            ];
            options.footerRight = [];
            return this.open(options);
        },
        save: function (options) {
            options.dismissible = options.dismissible !== false;
            options.footer = [
                {
                    label: options.confirmText || l('save'),
                    value: 'save',
                    type: Button.TYPES.PRIMARY,
                    buttonAttributes: { 'data-auto': 'save' }
                },
                {
                    label: l('close'),
                    value: 'cancel',
                    dismiss: true,
                    type: Button.TYPES.SECRET,
                    buttonAttributes: { 'data-auto': 'close' }
                }
            ];
            options.footerRight = [];
            return this.open(options);
        },
        alert: function (options) {
            options.dismissible = false;
            options.footerLeft = [{
                    label: l('ok'),
                    value: 'ok',
                    dismiss: true,
                    type: Button.TYPES.PRIMARY,
                    buttonAttributes: { 'data-auto': 'ok' }
                }];
            options.footerRight = [];
            return this.open(options);
        },
        info: function (options) {
            options.footer = options.footer || [{
                    label: l('close'),
                    value: 'close',
                    dismiss: true,
                    type: Button.TYPES.SECRET,
                    buttonAttributes: { 'data-auto': 'close' }
                }];
            return this.open(options);
        },
        yesNo: function (options) {
            options.footerLeft = [{
                    label: l('Yes'),
                    value: 'yes',
                    type: Button.TYPES.PRIMARY,
                    buttonAttributes: { 'data-auto': 'yes' }
                }];
            options.footerRight = [{
                    label: l('No'),
                    value: 'no',
                    dismiss: options.dismissOnNo,
                    buttonAttributes: { 'data-auto': 'no' }
                }];
            return this.open(options);
        },
        SIZE: {
            PROMPT: 'prompt',
            DEFAULT: 'default',
            LARGE: 'large',
            X_LARGE: 'xlarge'
        },
        OVERFLOW_TYPE: {
            AUTO: 'auto',
            VISIBLE: 'visible'
        }
    });
});
define('common-modules/containers/views/threaded-comment', [
    'common-modules/containers/templates/threaded-comment.tpl.html',
    'common-modules/containers/views/threaded-comment-reply-form',
    'common-modules/containers/views/threaded-comment-edit-form',
    'common-modules/containers/views/logo',
    'common-modules/status/views/rating',
    'common-modules/buttons/button-toolbar',
    'common-modules/status/views/badges',
    'common-modules/modals/views/modal',
    'moment'
], function (template, ReplyForm, EditForm, Logo, Rating, Toolbar, Badges, Modal, moment) {
    'use strict';
    return Marionette.CompositeView.extend({
        indentedClass: 'adb-slat__indented',
        attributes: { 'data-component': 'threaded-comment' },
        className: 'adb-slat',
        template: _.template(template),
        itemViewContainer: 'div.js-replies-container',
        itemViewOptions: function () {
            return {
                needApproval: this.needApproval,
                eventBus: this.eventBus,
                isChild: true,
                parent: this,
                replyEnable: false,
                viewOnly: false,
                editEnable: false,
                deleteEnable: true,
                labels: this.labels,
                isCurrentAuthor: this.isCurrentAuthor,
                currentAuthorLabel: this.currentAuthorLabel
            };
        },
        events: {
            'click @ui.showMoreButton': 'showMore',
            'click @ui.replyButton': 'showForm',
            'click @ui.menuReplyButton': 'toggleReplyForm',
            'click @ui.menuEditButton': 'toggleEditForm',
            'click @ui.menuMoreButton': 'showMore',
            'click @ui.menuDeleteButton': 'onDelete'
        },
        ui: {
            form: '> .js-content > .js-form',
            repliesContainer: '> .js-content > .js-replies-container',
            ratingContainer: '> .js-content > .js-rating',
            authorImageContainer: '> .js-author > .js-author-image',
            tagsContainer: '> .js-content .js-tags-container',
            menuReplyButton: '> .js-content > .js-menu-container > .js-menu-reply',
            menuEditButton: '> .js-content > .js-menu-container > .js-menu-edit',
            menuMoreButton: '> .js-content > .js-menu-container > .js-menu-more',
            menuDeleteButton: '> .js-content > .js-menu-container > .js-menu-delete'
        },
        options: {
            needApproval: false,
            isChild: false,
            replyEnable: true,
            editEnable: true,
            deleteEnable: true,
            viewOnly: false,
            isCurrentAuthor: undefined
        },
        isEditable: function () {
            return this.model.isEditable();
        },
        initialize: function (options) {
            _.extend(this, _.defaults(options, this.options));
            this.setup();
            this.model.on('sync', _.bind(function () {
                this.setup();
                this.render();
            }, this));
        },
        setup: function () {
            var children = this.model.getReplies();
            if (children) {
                this.collection = children;
            }
            this.repliesButtonVisible = this.model.getReplyCount() > 0;
        },
        onRender: function () {
            this.renderAuthorImage();
            this.renderRating();
            this.renderTags();
            this.ui.repliesContainer.hide();
            this.renderButtons();
            if (this.isChild) {
                this.$el.addClass(this.indentedClass);
            }
        },
        renderRating: function () {
            var rating = this.model.get('rating');
            if (this.model.get('rating')) {
                this.rating = new Rating({ rating: rating > 0 ? rating : 0 });
                this.ui.ratingContainer.append(this.rating.render().el);
            }
        },
        renderAuthorImage: function () {
            this.authorImage = new Logo({
                size: Logo.SIZES.MEDIUM,
                url: this.model.getAuthorImageUrl() || null,
                fallback: Logo.FALLBACK.USER
            });
            this.ui.authorImageContainer.append(this.authorImage.render().el);
        },
        renderButtons: function () {
            if (!this.replyEnable || this.viewOnly) {
                this.ui.menuReplyButton.remove();
            }
            if (!this.isEditable() || !this.editEnable || this.viewOnly) {
                this.ui.menuEditButton.remove();
            }
            if (this.repliesButtonVisible) {
                this.updateShowHideButtonText();
            } else {
                this.ui.menuMoreButton.remove();
            }
            if (!this.isEditable() || !this.deleteEnable || this.viewOnly || this.repliesButtonVisible) {
                this.ui.menuDeleteButton.remove();
            }
            this.$('.js-menu-container a:not(:last)').after(' \xB7');
        },
        updateShowHideButtonText: function () {
            var numberOfReply = this.model.getReplyCount(), buttonText;
            if (this.ui.repliesContainer.is(':visible')) {
                buttonText = numberOfReply > 1 ? this.labels.hideCommentsButton(numberOfReply) : this.labels.hideCommentButton;
            } else {
                buttonText = numberOfReply > 1 ? this.labels.showCommentsButton(numberOfReply) : this.labels.showCommentButton;
            }
            this.ui.menuMoreButton.text(buttonText);
        },
        renderTags: function () {
            if (this.model.getTags()) {
                var items = new Backbone.Collection(this.model.getTags());
                this.badges = new Badges({ collection: items });
                this.ui.tagsContainer.append(this.badges.render().el);
            }
        },
        toggleReplyForm: function () {
            if (this.replyForm) {
                this.closeForms();
            } else {
                this.renderReplyForm();
            }
        },
        renderReplyForm: function () {
            this.closeForms();
            this.replyForm = new ReplyForm({
                model: this.model,
                labels: this.labels
            });
            this.ui.form.append(this.replyForm.render().el);
            this.replyForm.$el.addClass('adb-form__nested');
            this.listenTo(this.replyForm, 'reply:saved', _.bind(this.onReplySave, this));
            this.listenTo(this.replyForm, 'reply:cancel', _.bind(this.toggleReplyForm, this));
        },
        toggleEditForm: function () {
            if (this.editForm) {
                this.closeForms();
            } else {
                this.renderEditForm();
            }
        },
        renderEditForm: function () {
            this.closeForms();
            this.editForm = new EditForm({
                model: this.model,
                labels: this.labels
            });
            this.ui.form.append(this.editForm.render().el);
            this.editForm.$el.addClass('adb-form__nested');
            this.listenTo(this.editForm, 'edit:saved', _.bind(this.onEditSave, this));
            this.listenTo(this.editForm, 'edit:cancel', _.bind(this.toggleEditForm, this));
        },
        closeForms: function () {
            if (this.editForm) {
                this.editForm.close();
                delete this.editForm;
            }
            if (this.replyForm) {
                this.replyForm.close();
                delete this.replyForm;
            }
        },
        showMore: function () {
            if (!this.toggled) {
                this.collection.fetch();
            }
            this.toggled = !this.toggled;
            this.ui.repliesContainer.toggle();
            this.updateShowHideButtonText();
        },
        onReplySave: function (model) {
            this.toggleReplyForm();
            if (!this.approvesUserContent) {
                this.model.fetch();
            }
            this.eventBus.trigger('replied', this, model);
        },
        onEditSave: function () {
            if (this.editForm.isFormValid()) {
                var model = this.needApproval ? this.model.clone() : this.model;
                model.set(this.editForm.form.getValue());
                model.save(null, {
                    success: _.bind(function () {
                        this.toggleEditForm();
                        this.eventBus.trigger('edited', this, model);
                    }, this),
                    error: _.bind(function (error) {
                        this.toggleEditForm();
                        this.eventBus.trigger('edit:failed', this, model, error);
                    }, this)
                });
            }
        },
        onDelete: function () {
            Modal.confirm({ content: this.isChild ? this.labels.confirmDeleteReplyLabel : this.labels.confirmDeleteLabel }).on('modal:confirm', _.bind(this.onDeleteConfirm, this));
        },
        onDeleteConfirm: function (modal) {
            modal.dismiss();
            this.eventBus.trigger('deleted', this, this.model, _.bind(function () {
                if (this.isChild) {
                    this.parent.toggled = false;
                    this.parent.model.fetch().then(_.bind(this.parent.updateShowHideButtonText, this.parent));
                }
            }, this));
        },
        serializeData: function () {
            return {
                id: this.model.id,
                title: this.model.getTitle(),
                comment: this.model.getComment(),
                author: this.model.getAuthor(),
                date: this.formatDate(this.model.getDate()),
                rating: this.model.getRating(),
                labels: this.labels,
                isCurrentAuthor: this.isCurrentAuthor && this.isCurrentAuthor(this.model.getAuthorId()) && this.labels.currentAuthorLabel
            };
        },
        formatDate: function (date) {
            if (!date) {
                return;
            }
            var DATE_FORMAT = 'MMMM D, YYYY';
            return moment(date).format(DATE_FORMAT);
        },
        onClose: function () {
            this.authorImage.close();
            if (this.rating) {
                this.rating.close();
            }
            if (this.replyForm) {
                this.replyForm.close();
            }
            if (this.editForm) {
                this.editForm.close();
            }
            if (this.badges) {
                this.badges.close();
            }
        }
    });
});
define('common-modules/containers/views/threaded-comments', ['common-modules/containers/views/threaded-comment'], function (ThreadedComment) {
    'use strict';
    return Marionette.CollectionView.extend({
        itemView: ThreadedComment,
        itemViewOptions: function () {
            return {
                needApproval: this.needApproval,
                eventBus: this.eventBus,
                viewOnly: this.viewOnly,
                labels: this.labels,
                isCurrentAuthor: this.isCurrentAuthor
            };
        },
        busEvents: {
            replied: 'onCommentReplied',
            edited: 'onCommentEdited',
            'edit:failed': 'onCommentEditedFailed',
            deleted: 'onCommentDeleted'
        },
        defaults: {
            viewOnly: false,
            needApproval: false,
            isCurrentAuthor: undefined,
            labels: {
                replyButton: l('Comment'),
                editButton: l('Edit'),
                showCommentButton: l('Show.Comment', 1),
                showCommentsButton: function (nb) {
                    return l('Show.Comments', nb);
                },
                hideCommentButton: l('Hide.Comment', 1),
                hideCommentsButton: function (nb) {
                    return l('Hide.Comments', nb);
                },
                createFormCommentLabel: l('Comment'),
                createFormCommentPlaceholder: l('Write.your.comments.here'),
                createFormCommentSubmitButton: l('Submit.Comment'),
                editFormRatingLabel: l('My.Rating'),
                editFormTitleLabel: l('Title'),
                editFormCommentLabel: l('Description'),
                confirmDeleteLabel: l('please.confirm.delete.comment'),
                confirmDeleteReplyLabel: l('please.confirm.delete.comment'),
                currentAuthorLabel: undefined
            }
        },
        initialize: function (options) {
            _.extend(this, _.defaults(options, this.defaults));
            _.extend(this.labels, _.defaults(options.labels, this.defaults.labels));
            this.eventBus = new Backbone.Model();
            Marionette.bindEntityEvents(this, this.eventBus, this.busEvents);
        },
        onCommentReplied: function (view, model) {
            this.trigger('replied', view, model);
        },
        onCommentEdited: function (view, model) {
            this.trigger('edited', view, model);
        },
        onCommentEditedFailed: function (view, model, error) {
            this.trigger('edit:failed', view, model, error);
        },
        onCommentDeleted: function (view, model, callback) {
            model.destroy().done(_.bind(function () {
                this.trigger('deleted', view, model);
                if (_.isFunction(callback)) {
                    callback();
                }
            }, this));
        }
    });
});
define('common-modules/forms/views/fields/inline-form', ['backbone-forms'], function (Form) {
    'use strict';
    var originalObserveFormEvents = Form.editors.Object.prototype._observeFormEvents;
    return Form.editors.Object.extend({
        render: function () {
            var NestedForm = this.form.constructor;
            this.nestedForm = new NestedForm({
                className: this.schema.showNested !== false ? 'adb-form--nested_fields' : '',
                schema: this.schema.subSchema,
                showRequired: this.options.form.options.showRequired,
                showOptional: this.options.form.options.showOptional,
                showContainer: this.schema.showContainer,
                data: this.value,
                idPrefix: this.id + '_',
                Field: NestedForm.NestedField
            });
            this._observeFormEvents();
            this.$el.html(this.nestedForm.render().el);
            if (this.hasFocus) {
                this.trigger('blur', this);
            }
            return this;
        },
        _observeFormEvents: function () {
            originalObserveFormEvents.apply(this, arguments);
            var form = this.options.form;
            this.listenTo(this.nestedForm, 'submit', _.bind(form.trigger, form, 'submit'));
        }
    });
});
define('common-modules/forms/templates/multi-subforms.tpl.html', [], function () {
    return '<p><%=description%></p>\n<div class="js-entries-container"></div>\n<button class="adb-button__small adb-button__secondary js-ui-add" type="button">\n\t<i class="adb-icon__add"></i>\n\t<%-addLabel%>\n</button>\n';
});
define('common-modules/forms/templates/multi-subforms-entry.tpl.html', [], function () {
    return '<div class="adb-form--container_field">\n\t<div class="adb-container adb-container__nested">\n\t\t<div class="adb-container_header adb-container_header__actionable">\n\t\t\t<h4 class="adb-container_header--item">\n\t\t\t\t<%-title%>\n\t\t\t</h4>\n\t\t\t<menu class="adb-container_header--item js-region-delete"></menu>\n\t\t</div>\n\t\t<div class="adb-container_content js-region-form"></div>\n\t</div>\n</div>\n';
});
define('common-modules/forms/views/multi-subforms-entry', [
    'common-modules/forms/templates/multi-subforms-entry.tpl.html',
    'object-utils',
    'common-modules/utils/generate-selector-hash',
    'common-modules/buttons/button',
    'common-modules/forms/views/form'
], function (template, ObjectUtils, generateSelectorHash, Button, Form) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template(template),
        regions: generateSelectorHash.regions([
            'delete',
            'form'
        ]),
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'schema',
                'title'
            ]);
        },
        onRender: function () {
            var deleteButton = new Button({
                icon: 'trash',
                type: Button.TYPES.DANGER,
                shape: Button.SHAPES.SQUARE
            });
            this.deleteRegion.show(deleteButton);
            this.listenTo(deleteButton, 'click', this.deleteEntry);
            this.form = new Form({
                schema: this.schema,
                model: this.model
            });
            this.formRegion.show(this.form);
        },
        deleteEntry: function () {
            this.trigger('delete');
        },
        serializeData: function () {
            return { title: this.title };
        }
    });
});
define('common-modules/forms/views/multi-subforms', [
    'common-modules/forms/templates/multi-subforms.tpl.html',
    'object-utils',
    'common-modules/utils/generate-selector-hash',
    'common-modules/forms/views/multi-subforms-entry'
], function (template, ObjectUtils, generateSelectorHash, MultiSubformsEntry) {
    'use strict';
    return Marionette.CompositeView.extend({
        tagName: 'fieldset',
        template: _.template(template),
        ui: { add: '> .js-ui-add' },
        itemViewContainer: '.js-entries-container',
        itemView: MultiSubformsEntry,
        events: { 'click @ui.add': 'addEntry' },
        itemViewOptions: function () {
            return {
                schema: this.schema,
                title: this.title
            };
        },
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'description',
                'schema',
                'title',
                'addLabel',
                'limit'
            ]);
            this.on('itemview:delete', this.deleteEntry);
            this.listenTo(this.collection, 'reset add remove', this.checkLimit);
        },
        deleteEntry: function (entryView) {
            this.collection.remove(entryView.model);
        },
        addEntry: function () {
            this.collection.add({});
        },
        checkLimit: function () {
            this.ui.add.toggle(!(this.limit && this.collection.size() >= this.limit));
        },
        serializeData: function () {
            return {
                description: this.description || '',
                addLabel: this.addLabel || l('Add') + ' ' + this.title
            };
        },
        validate: function () {
            return this.executeActionOnForms(function (view) {
                return view.form.validate();
            });
        },
        commit: function () {
            return this.executeActionOnForms(function (view) {
                return view.form.commit();
            });
        },
        executeActionOnForms: function (action) {
            var errors = _.chain(this.children._views).map(action).flatten().filter(_.identity).value();
            return _.isEmpty(errors) ? false : errors;
        }
    });
});
define('common-modules/forms/views/fields/multi-subforms-field', [
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/multi-subforms'
], function (BaseSubviewField, MultiSubforms) {
    'use strict';
    return BaseSubviewField.extend({
        initSubView: function () {
            this.subformsCollection = new Backbone.Collection([{}]);
            return new MultiSubforms(_.extend({ collection: this.subformsCollection }, this.schema));
        },
        getValue: function () {
            return this.subformsCollection.toJSON();
        },
        setValue: function (value) {
            this.subformsCollection.reset(value);
        },
        validate: function () {
            return this.subView.validate();
        },
        commit: function () {
            return this.subView.commit();
        }
    }, { IS_CONTAINER: true });
});
define('common-modules/forms/views/fields/toggle-field', ['common-modules/forms/views/fields/toggles-field'], function (TogglesField) {
    'use strict';
    var _super = TogglesField.prototype;
    return TogglesField.extend({
        initialize: function (options) {
            options = _.extend({}, options, {
                schema: _.extend({}, options.schema, {
                    options: [{
                            label: options.label || l('enabled'),
                            value: true
                        }]
                })
            });
            _super.initialize.call(this, options);
        },
        getValue: function () {
            return !!_super.getValue.call(this)[0];
        },
        setValue: function (value) {
            _super.setValue.call(this, value ? [true] : []);
        }
    });
});
define('backgrid', [], function () {
    (function (factory) {
        if (typeof exports == 'object') {
            module.exports = factory(module.exports, require('underscore'), require('backbone'));
        } else
            factory(this, this._, this.Backbone);
    }(function (root, _, Backbone) {
        'use strict';
        var ws = '\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' + '\u2029\uFEFF';
        if (!String.prototype.trim || ws.trim()) {
            ws = '[' + ws + ']';
            var trimBeginRegexp = new RegExp('^' + ws + ws + '*'), trimEndRegexp = new RegExp(ws + ws + '*$');
            String.prototype.trim = function trim() {
                if (this === undefined || this === null) {
                    throw new TypeError('can\'t convert ' + this + ' to object');
                }
                return String(this).replace(trimBeginRegexp, '').replace(trimEndRegexp, '');
            };
        }
        function lpad(str, length, padstr) {
            var paddingLen = length - (str + '').length;
            paddingLen = paddingLen < 0 ? 0 : paddingLen;
            var padding = '';
            for (var i = 0; i < paddingLen; i++) {
                padding = padding + padstr;
            }
            return padding + str;
        }
        var $ = Backbone.$;
        var Backgrid = root.Backgrid = {
            Extension: {},
            resolveNameToClass: function (name, suffix) {
                if (_.isString(name)) {
                    var key = _.map(name.split('-'), function (e) {
                        return e.slice(0, 1).toUpperCase() + e.slice(1);
                    }).join('') + suffix;
                    var klass = Backgrid[key] || Backgrid.Extension[key];
                    if (_.isUndefined(klass)) {
                        throw new ReferenceError('Class \'' + key + '\' not found');
                    }
                    return klass;
                }
                return name;
            },
            callByNeed: function () {
                var value = arguments[0];
                if (!_.isFunction(value))
                    return value;
                var context = arguments[1];
                var args = [].slice.call(arguments, 2);
                return value.apply(context, !!(args + '') ? args : []);
            }
        };
        _.extend(Backgrid, Backbone.Events);
        var Command = Backgrid.Command = function (evt) {
            _.extend(this, {
                altKey: !!evt.altKey,
                'char': evt['char'],
                charCode: evt.charCode,
                ctrlKey: !!evt.ctrlKey,
                key: evt.key,
                keyCode: evt.keyCode,
                locale: evt.locale,
                location: evt.location,
                metaKey: !!evt.metaKey,
                repeat: !!evt.repeat,
                shiftKey: !!evt.shiftKey,
                which: evt.which
            });
        };
        _.extend(Command.prototype, {
            moveUp: function () {
                return this.keyCode == 38;
            },
            moveDown: function () {
                return this.keyCode === 40;
            },
            moveLeft: function () {
                return this.shiftKey && this.keyCode === 9;
            },
            moveRight: function () {
                return !this.shiftKey && this.keyCode === 9;
            },
            save: function () {
                return this.keyCode === 13;
            },
            cancel: function () {
                return this.keyCode === 27;
            },
            passThru: function () {
                return !(this.moveUp() || this.moveDown() || this.moveLeft() || this.moveRight() || this.save() || this.cancel());
            }
        });
        var CellFormatter = Backgrid.CellFormatter = function () {
        };
        _.extend(CellFormatter.prototype, {
            fromRaw: function (rawData, model) {
                return rawData;
            },
            toRaw: function (formattedData, model) {
                return formattedData;
            }
        });
        var NumberFormatter = Backgrid.NumberFormatter = function (options) {
            _.extend(this, this.defaults, options || {});
            if (this.decimals < 0 || this.decimals > 20) {
                throw new RangeError('decimals must be between 0 and 20');
            }
        };
        NumberFormatter.prototype = new CellFormatter();
        _.extend(NumberFormatter.prototype, {
            defaults: {
                decimals: 2,
                decimalSeparator: '.',
                orderSeparator: ','
            },
            HUMANIZED_NUM_RE: /(\d)(?=(?:\d{3})+$)/g,
            fromRaw: function (number, model) {
                if (_.isNull(number) || _.isUndefined(number))
                    return '';
                number = number.toFixed(~~this.decimals);
                var parts = number.split('.');
                var integerPart = parts[0];
                var decimalPart = parts[1] ? (this.decimalSeparator || '.') + parts[1] : '';
                return integerPart.replace(this.HUMANIZED_NUM_RE, '$1' + this.orderSeparator) + decimalPart;
            },
            toRaw: function (formattedData, model) {
                formattedData = formattedData.trim();
                if (formattedData === '')
                    return null;
                var rawData = '';
                var thousands = formattedData.split(this.orderSeparator);
                for (var i = 0; i < thousands.length; i++) {
                    rawData += thousands[i];
                }
                var decimalParts = rawData.split(this.decimalSeparator);
                rawData = '';
                for (var i = 0; i < decimalParts.length; i++) {
                    rawData = rawData + decimalParts[i] + '.';
                }
                if (rawData[rawData.length - 1] === '.') {
                    rawData = rawData.slice(0, rawData.length - 1);
                }
                var result = (rawData * 1).toFixed(~~this.decimals) * 1;
                if (_.isNumber(result) && !_.isNaN(result))
                    return result;
            }
        });
        var PercentFormatter = Backgrid.PercentFormatter = function () {
            Backgrid.NumberFormatter.apply(this, arguments);
        };
        PercentFormatter.prototype = new Backgrid.NumberFormatter(), _.extend(PercentFormatter.prototype, {
            defaults: _.extend({}, NumberFormatter.prototype.defaults, {
                multiplier: 1,
                symbol: '%'
            }),
            fromRaw: function (number, model) {
                var args = [].slice.call(arguments, 1);
                args.unshift(number * this.multiplier);
                return (NumberFormatter.prototype.fromRaw.apply(this, args) || '0') + this.symbol;
            },
            toRaw: function (formattedValue, model) {
                var tokens = formattedValue.split(this.symbol);
                if (tokens && tokens[0] && tokens[1] === '' || tokens[1] == null) {
                    var rawValue = NumberFormatter.prototype.toRaw.call(this, tokens[0]);
                    if (_.isUndefined(rawValue))
                        return rawValue;
                    return rawValue / this.multiplier;
                }
            }
        });
        var DatetimeFormatter = Backgrid.DatetimeFormatter = function (options) {
            _.extend(this, this.defaults, options || {});
            if (!this.includeDate && !this.includeTime) {
                throw new Error('Either includeDate or includeTime must be true');
            }
        };
        DatetimeFormatter.prototype = new CellFormatter();
        _.extend(DatetimeFormatter.prototype, {
            defaults: {
                includeDate: true,
                includeTime: true,
                includeMilli: false
            },
            DATE_RE: /^([+\-]?\d{4})-(\d{2})-(\d{2})$/,
            TIME_RE: /^(\d{2}):(\d{2}):(\d{2})(\.(\d{3}))?$/,
            ISO_SPLITTER_RE: /T|Z| +/,
            _convert: function (data, validate) {
                if ((data + '').trim() === '')
                    return null;
                var date, time = null;
                if (_.isNumber(data)) {
                    var jsDate = new Date(data);
                    date = lpad(jsDate.getUTCFullYear(), 4, 0) + '-' + lpad(jsDate.getUTCMonth() + 1, 2, 0) + '-' + lpad(jsDate.getUTCDate(), 2, 0);
                    time = lpad(jsDate.getUTCHours(), 2, 0) + ':' + lpad(jsDate.getUTCMinutes(), 2, 0) + ':' + lpad(jsDate.getUTCSeconds(), 2, 0);
                } else {
                    data = data.trim();
                    var parts = data.split(this.ISO_SPLITTER_RE) || [];
                    date = this.DATE_RE.test(parts[0]) ? parts[0] : '';
                    time = date && parts[1] ? parts[1] : this.TIME_RE.test(parts[0]) ? parts[0] : '';
                }
                var YYYYMMDD = this.DATE_RE.exec(date) || [];
                var HHmmssSSS = this.TIME_RE.exec(time) || [];
                if (validate) {
                    if (this.includeDate && _.isUndefined(YYYYMMDD[0]))
                        return;
                    if (this.includeTime && _.isUndefined(HHmmssSSS[0]))
                        return;
                    if (!this.includeDate && date)
                        return;
                    if (!this.includeTime && time)
                        return;
                }
                var jsDate = new Date(Date.UTC(YYYYMMDD[1] * 1 || 0, YYYYMMDD[2] * 1 - 1 || 0, YYYYMMDD[3] * 1 || 0, HHmmssSSS[1] * 1 || null, HHmmssSSS[2] * 1 || null, HHmmssSSS[3] * 1 || null, HHmmssSSS[5] * 1 || null));
                var result = '';
                if (this.includeDate) {
                    result = lpad(jsDate.getUTCFullYear(), 4, 0) + '-' + lpad(jsDate.getUTCMonth() + 1, 2, 0) + '-' + lpad(jsDate.getUTCDate(), 2, 0);
                }
                if (this.includeTime) {
                    result = result + (this.includeDate ? 'T' : '') + lpad(jsDate.getUTCHours(), 2, 0) + ':' + lpad(jsDate.getUTCMinutes(), 2, 0) + ':' + lpad(jsDate.getUTCSeconds(), 2, 0);
                    if (this.includeMilli) {
                        result = result + '.' + lpad(jsDate.getUTCMilliseconds(), 3, 0);
                    }
                }
                if (this.includeDate && this.includeTime) {
                    result += 'Z';
                }
                return result;
            },
            fromRaw: function (rawData, model) {
                if (_.isNull(rawData) || _.isUndefined(rawData))
                    return '';
                return this._convert(rawData);
            },
            toRaw: function (formattedData, model) {
                return this._convert(formattedData, true);
            }
        });
        var StringFormatter = Backgrid.StringFormatter = function () {
        };
        StringFormatter.prototype = new CellFormatter();
        _.extend(StringFormatter.prototype, {
            fromRaw: function (rawValue, model) {
                if (_.isUndefined(rawValue) || _.isNull(rawValue))
                    return '';
                return rawValue + '';
            }
        });
        var EmailFormatter = Backgrid.EmailFormatter = function () {
        };
        EmailFormatter.prototype = new CellFormatter();
        _.extend(EmailFormatter.prototype, {
            toRaw: function (formattedData, model) {
                var parts = formattedData.trim().split('@');
                if (parts.length === 2 && _.all(parts)) {
                    return formattedData;
                }
            }
        });
        var SelectFormatter = Backgrid.SelectFormatter = function () {
        };
        SelectFormatter.prototype = new CellFormatter();
        _.extend(SelectFormatter.prototype, {
            fromRaw: function (rawValue, model) {
                return _.isArray(rawValue) ? rawValue : rawValue != null ? [rawValue] : [];
            }
        });
        var CellEditor = Backgrid.CellEditor = Backbone.View.extend({
            initialize: function (options) {
                this.formatter = options.formatter;
                this.column = options.column;
                if (!(this.column instanceof Column)) {
                    this.column = new Column(this.column);
                }
                this.listenTo(this.model, 'backgrid:editing', this.postRender);
            },
            postRender: function (model, column) {
                if (column == null || column.get('name') == this.column.get('name')) {
                    this.$el.focus();
                }
                return this;
            }
        });
        var InputCellEditor = Backgrid.InputCellEditor = CellEditor.extend({
            tagName: 'input',
            attributes: { type: 'text' },
            events: {
                'blur': 'saveOrCancel',
                'keydown': 'saveOrCancel'
            },
            initialize: function (options) {
                InputCellEditor.__super__.initialize.apply(this, arguments);
                if (options.placeholder) {
                    this.$el.attr('placeholder', options.placeholder);
                }
            },
            render: function () {
                var model = this.model;
                this.$el.val(this.formatter.fromRaw(model.get(this.column.get('name')), model));
                return this;
            },
            saveOrCancel: function (e) {
                var formatter = this.formatter;
                var model = this.model;
                var column = this.column;
                var command = new Command(e);
                var blurred = e.type === 'blur';
                if (command.moveUp() || command.moveDown() || command.moveLeft() || command.moveRight() || command.save() || blurred) {
                    e.preventDefault();
                    e.stopPropagation();
                    var val = this.$el.val();
                    var newValue = formatter.toRaw(val, model);
                    if (_.isUndefined(newValue)) {
                        model.trigger('backgrid:error', model, column, val);
                    } else {
                        model.set(column.get('name'), newValue);
                        model.trigger('backgrid:edited', model, column, command);
                    }
                } else if (command.cancel()) {
                    e.stopPropagation();
                    model.trigger('backgrid:edited', model, column, command);
                }
            },
            postRender: function (model, column) {
                if (column == null || column.get('name') == this.column.get('name')) {
                    if (this.$el.css('text-align') === 'right') {
                        var val = this.$el.val();
                        this.$el.focus().val(null).val(val);
                    } else
                        this.$el.focus();
                }
                return this;
            }
        });
        var Cell = Backgrid.Cell = Backbone.View.extend({
            tagName: 'td',
            formatter: CellFormatter,
            editor: InputCellEditor,
            events: { 'click': 'enterEditMode' },
            initialize: function (options) {
                this.column = options.column;
                if (!(this.column instanceof Column)) {
                    this.column = new Column(this.column);
                }
                var column = this.column, model = this.model, $el = this.$el;
                var formatter = Backgrid.resolveNameToClass(column.get('formatter') || this.formatter, 'Formatter');
                if (!_.isFunction(formatter.fromRaw) && !_.isFunction(formatter.toRaw)) {
                    formatter = new formatter();
                }
                this.formatter = formatter;
                this.editor = Backgrid.resolveNameToClass(this.editor, 'CellEditor');
                this.listenTo(model, 'change:' + column.get('name'), function () {
                    if (!$el.hasClass('editor'))
                        this.render();
                });
                this.listenTo(model, 'backgrid:error', this.renderError);
                this.listenTo(column, 'change:editable change:sortable change:renderable', function (column) {
                    var changed = column.changedAttributes();
                    for (var key in changed) {
                        if (changed.hasOwnProperty(key)) {
                            $el.toggleClass(key, changed[key]);
                        }
                    }
                });
                if (Backgrid.callByNeed(column.editable(), column, model))
                    $el.addClass('editable');
                if (Backgrid.callByNeed(column.sortable(), column, model))
                    $el.addClass('sortable');
                if (Backgrid.callByNeed(column.renderable(), column, model))
                    $el.addClass('renderable');
            },
            render: function () {
                this.$el.empty();
                var model = this.model;
                this.$el.text(this.formatter.fromRaw(model.get(this.column.get('name')), model));
                this.delegateEvents();
                return this;
            },
            enterEditMode: function () {
                var model = this.model;
                var column = this.column;
                var editable = Backgrid.callByNeed(column.editable(), column, model);
                if (editable) {
                    this.currentEditor = new this.editor({
                        column: this.column,
                        model: this.model,
                        formatter: this.formatter
                    });
                    model.trigger('backgrid:edit', model, column, this, this.currentEditor);
                    this.undelegateEvents();
                    this.$el.empty();
                    this.$el.append(this.currentEditor.$el);
                    this.currentEditor.render();
                    this.$el.addClass('editor');
                    model.trigger('backgrid:editing', model, column, this, this.currentEditor);
                }
            },
            renderError: function (model, column) {
                if (column == null || column.get('name') == this.column.get('name')) {
                    this.$el.addClass('error');
                }
            },
            exitEditMode: function () {
                this.$el.removeClass('error');
                this.currentEditor.remove();
                this.stopListening(this.currentEditor);
                delete this.currentEditor;
                this.$el.removeClass('editor');
                this.render();
            },
            remove: function () {
                if (this.currentEditor) {
                    this.currentEditor.remove.apply(this.currentEditor, arguments);
                    delete this.currentEditor;
                }
                return Cell.__super__.remove.apply(this, arguments);
            }
        });
        var StringCell = Backgrid.StringCell = Cell.extend({
            className: 'string-cell',
            formatter: StringFormatter
        });
        var UriCell = Backgrid.UriCell = Cell.extend({
            className: 'uri-cell',
            title: null,
            target: '_blank',
            initialize: function (options) {
                UriCell.__super__.initialize.apply(this, arguments);
                this.title = options.title || this.title;
                this.target = options.target || this.target;
            },
            render: function () {
                this.$el.empty();
                var rawValue = this.model.get(this.column.get('name'));
                var formattedValue = this.formatter.fromRaw(rawValue, this.model);
                this.$el.append($('<a>', {
                    tabIndex: -1,
                    href: rawValue,
                    title: this.title || formattedValue,
                    target: this.target
                }).text(formattedValue));
                this.delegateEvents();
                return this;
            }
        });
        var EmailCell = Backgrid.EmailCell = StringCell.extend({
            className: 'email-cell',
            formatter: EmailFormatter,
            render: function () {
                this.$el.empty();
                var model = this.model;
                var formattedValue = this.formatter.fromRaw(model.get(this.column.get('name')), model);
                this.$el.append($('<a>', {
                    tabIndex: -1,
                    href: 'mailto:' + formattedValue,
                    title: formattedValue
                }).text(formattedValue));
                this.delegateEvents();
                return this;
            }
        });
        var NumberCell = Backgrid.NumberCell = Cell.extend({
            className: 'number-cell',
            decimals: NumberFormatter.prototype.defaults.decimals,
            decimalSeparator: NumberFormatter.prototype.defaults.decimalSeparator,
            orderSeparator: NumberFormatter.prototype.defaults.orderSeparator,
            formatter: NumberFormatter,
            initialize: function (options) {
                NumberCell.__super__.initialize.apply(this, arguments);
                var formatter = this.formatter;
                formatter.decimals = this.decimals;
                formatter.decimalSeparator = this.decimalSeparator;
                formatter.orderSeparator = this.orderSeparator;
            }
        });
        var IntegerCell = Backgrid.IntegerCell = NumberCell.extend({
            className: 'integer-cell',
            decimals: 0
        });
        var PercentCell = Backgrid.PercentCell = NumberCell.extend({
            className: 'percent-cell',
            multiplier: PercentFormatter.prototype.defaults.multiplier,
            symbol: PercentFormatter.prototype.defaults.symbol,
            formatter: PercentFormatter,
            initialize: function () {
                PercentCell.__super__.initialize.apply(this, arguments);
                var formatter = this.formatter;
                formatter.multiplier = this.multiplier;
                formatter.symbol = this.symbol;
            }
        });
        var DatetimeCell = Backgrid.DatetimeCell = Cell.extend({
            className: 'datetime-cell',
            includeDate: DatetimeFormatter.prototype.defaults.includeDate,
            includeTime: DatetimeFormatter.prototype.defaults.includeTime,
            includeMilli: DatetimeFormatter.prototype.defaults.includeMilli,
            formatter: DatetimeFormatter,
            initialize: function (options) {
                DatetimeCell.__super__.initialize.apply(this, arguments);
                var formatter = this.formatter;
                formatter.includeDate = this.includeDate;
                formatter.includeTime = this.includeTime;
                formatter.includeMilli = this.includeMilli;
                var placeholder = this.includeDate ? 'YYYY-MM-DD' : '';
                placeholder += this.includeDate && this.includeTime ? 'T' : '';
                placeholder += this.includeTime ? 'HH:mm:ss' : '';
                placeholder += this.includeTime && this.includeMilli ? '.SSS' : '';
                this.editor = this.editor.extend({ attributes: _.extend({}, this.editor.prototype.attributes, this.editor.attributes, { placeholder: placeholder }) });
            }
        });
        var DateCell = Backgrid.DateCell = DatetimeCell.extend({
            className: 'date-cell',
            includeTime: false
        });
        var TimeCell = Backgrid.TimeCell = DatetimeCell.extend({
            className: 'time-cell',
            includeDate: false
        });
        var BooleanCellEditor = Backgrid.BooleanCellEditor = CellEditor.extend({
            tagName: 'input',
            attributes: {
                tabIndex: -1,
                type: 'checkbox'
            },
            events: {
                'mousedown': function () {
                    this.mouseDown = true;
                },
                'blur': 'enterOrExitEditMode',
                'mouseup': function () {
                    this.mouseDown = false;
                },
                'change': 'saveOrCancel',
                'keydown': 'saveOrCancel'
            },
            render: function () {
                var model = this.model;
                var val = this.formatter.fromRaw(model.get(this.column.get('name')), model);
                this.$el.prop('checked', val);
                return this;
            },
            enterOrExitEditMode: function (e) {
                if (!this.mouseDown) {
                    var model = this.model;
                    model.trigger('backgrid:edited', model, this.column, new Command(e));
                }
            },
            saveOrCancel: function (e) {
                var model = this.model;
                var column = this.column;
                var formatter = this.formatter;
                var command = new Command(e);
                if (command.passThru() && e.type != 'change')
                    return true;
                if (command.cancel()) {
                    e.stopPropagation();
                    model.trigger('backgrid:edited', model, column, command);
                }
                var $el = this.$el;
                if (command.save() || command.moveLeft() || command.moveRight() || command.moveUp() || command.moveDown()) {
                    e.preventDefault();
                    e.stopPropagation();
                    var val = formatter.toRaw($el.prop('checked'), model);
                    model.set(column.get('name'), val);
                    model.trigger('backgrid:edited', model, column, command);
                } else if (e.type == 'change') {
                    var val = formatter.toRaw($el.prop('checked'), model);
                    model.set(column.get('name'), val);
                    $el.focus();
                }
            }
        });
        var BooleanCell = Backgrid.BooleanCell = Cell.extend({
            className: 'boolean-cell',
            editor: BooleanCellEditor,
            events: { 'click': 'enterEditMode' },
            render: function () {
                this.$el.empty();
                var model = this.model, column = this.column;
                var editable = Backgrid.callByNeed(column.editable(), column, model);
                this.$el.append($('<input>', {
                    tabIndex: -1,
                    type: 'checkbox',
                    checked: this.formatter.fromRaw(model.get(column.get('name')), model),
                    disabled: !editable
                }));
                this.delegateEvents();
                return this;
            }
        });
        var SelectCellEditor = Backgrid.SelectCellEditor = CellEditor.extend({
            tagName: 'select',
            events: {
                'change': 'save',
                'blur': 'close',
                'keydown': 'close'
            },
            template: _.template('<option value="<%- value %>" <%= selected ? \'selected="selected"\' : "" %>><%- text %></option>', null, { variable: null }),
            setOptionValues: function (optionValues) {
                this.optionValues = optionValues;
                this.optionValues = _.result(this, 'optionValues');
            },
            setMultiple: function (multiple) {
                this.multiple = multiple;
                this.$el.prop('multiple', multiple);
            },
            _renderOptions: function (nvps, selectedValues) {
                var options = '';
                for (var i = 0; i < nvps.length; i++) {
                    options = options + this.template({
                        text: nvps[i][0],
                        value: nvps[i][1],
                        selected: _.indexOf(selectedValues, nvps[i][1]) > -1
                    });
                }
                return options;
            },
            render: function () {
                this.$el.empty();
                var optionValues = _.result(this, 'optionValues');
                var model = this.model;
                var selectedValues = this.formatter.fromRaw(model.get(this.column.get('name')), model);
                if (!_.isArray(optionValues))
                    throw new TypeError('optionValues must be an array');
                var optionValue = null;
                var optionText = null;
                var optionValue = null;
                var optgroupName = null;
                var optgroup = null;
                for (var i = 0; i < optionValues.length; i++) {
                    var optionValue = optionValues[i];
                    if (_.isArray(optionValue)) {
                        optionText = optionValue[0];
                        optionValue = optionValue[1];
                        this.$el.append(this.template({
                            text: optionText,
                            value: optionValue,
                            selected: _.indexOf(selectedValues, optionValue) > -1
                        }));
                    } else if (_.isObject(optionValue)) {
                        optgroupName = optionValue.name;
                        optgroup = $('<optgroup></optgroup>', { label: optgroupName });
                        optgroup.append(this._renderOptions.call(this, optionValue.values, selectedValues));
                        this.$el.append(optgroup);
                    } else {
                        throw new TypeError('optionValues elements must be a name-value pair or an object hash of { name: \'optgroup label\', value: [option name-value pairs] }');
                    }
                }
                this.delegateEvents();
                return this;
            },
            save: function (e) {
                var model = this.model;
                var column = this.column;
                model.set(column.get('name'), this.formatter.toRaw(this.$el.val(), model));
            },
            close: function (e) {
                var model = this.model;
                var column = this.column;
                var command = new Command(e);
                if (command.cancel()) {
                    e.stopPropagation();
                    model.trigger('backgrid:edited', model, column, new Command(e));
                } else if (command.save() || command.moveLeft() || command.moveRight() || command.moveUp() || command.moveDown() || e.type == 'blur') {
                    e.preventDefault();
                    e.stopPropagation();
                    this.save(e);
                    model.trigger('backgrid:edited', model, column, new Command(e));
                }
            }
        });
        var SelectCell = Backgrid.SelectCell = Cell.extend({
            className: 'select-cell',
            editor: SelectCellEditor,
            multiple: false,
            formatter: SelectFormatter,
            optionValues: undefined,
            delimiter: ', ',
            initialize: function (options) {
                SelectCell.__super__.initialize.apply(this, arguments);
                this.listenTo(this.model, 'backgrid:edit', function (model, column, cell, editor) {
                    if (column.get('name') == this.column.get('name')) {
                        editor.setOptionValues(this.optionValues);
                        editor.setMultiple(this.multiple);
                    }
                });
            },
            render: function () {
                this.$el.empty();
                var optionValues = _.result(this, 'optionValues');
                var model = this.model;
                var rawData = this.formatter.fromRaw(model.get(this.column.get('name')), model);
                var selectedText = [];
                try {
                    if (!_.isArray(optionValues) || _.isEmpty(optionValues))
                        throw new TypeError();
                    for (var k = 0; k < rawData.length; k++) {
                        var rawDatum = rawData[k];
                        for (var i = 0; i < optionValues.length; i++) {
                            var optionValue = optionValues[i];
                            if (_.isArray(optionValue)) {
                                var optionText = optionValue[0];
                                var optionValue = optionValue[1];
                                if (optionValue == rawDatum)
                                    selectedText.push(optionText);
                            } else if (_.isObject(optionValue)) {
                                var optionGroupValues = optionValue.values;
                                for (var j = 0; j < optionGroupValues.length; j++) {
                                    var optionGroupValue = optionGroupValues[j];
                                    if (optionGroupValue[1] == rawDatum) {
                                        selectedText.push(optionGroupValue[0]);
                                    }
                                }
                            } else {
                                throw new TypeError();
                            }
                        }
                    }
                    this.$el.append(selectedText.join(this.delimiter));
                } catch (ex) {
                    if (ex instanceof TypeError) {
                        throw new TypeError('\'optionValues\' must be of type {Array.<Array>|Array.<{name: string, values: Array.<Array>}>}');
                    }
                    throw ex;
                }
                this.delegateEvents();
                return this;
            }
        });
        var Column = Backgrid.Column = Backbone.Model.extend({
            defaults: {
                name: undefined,
                label: undefined,
                sortable: true,
                editable: true,
                renderable: true,
                formatter: undefined,
                sortType: 'cycle',
                sortValue: undefined,
                direction: null,
                cell: undefined,
                headerCell: undefined
            },
            initialize: function () {
                if (!this.has('label')) {
                    this.set({ label: this.get('name') }, { silent: true });
                }
                var headerCell = Backgrid.resolveNameToClass(this.get('headerCell'), 'HeaderCell');
                var cell = Backgrid.resolveNameToClass(this.get('cell'), 'Cell');
                this.set({
                    cell: cell,
                    headerCell: headerCell
                }, { silent: true });
            },
            sortValue: function () {
                var sortValue = this.get('sortValue');
                if (_.isString(sortValue))
                    return this[sortValue];
                else if (_.isFunction(sortValue))
                    return sortValue;
                return function (model, colName) {
                    return model.get(colName);
                };
            }
        });
        _.each([
            'sortable',
            'renderable',
            'editable'
        ], function (key) {
            Column.prototype[key] = function () {
                var value = this.get(key);
                if (_.isString(value))
                    return this[value];
                else if (_.isFunction(value))
                    return value;
                return !!value;
            };
        });
        var Columns = Backgrid.Columns = Backbone.Collection.extend({ model: Column });
        var Row = Backgrid.Row = Backbone.View.extend({
            tagName: 'tr',
            initialize: function (options) {
                var columns = this.columns = options.columns;
                if (!(columns instanceof Backbone.Collection)) {
                    columns = this.columns = new Columns(columns);
                }
                var cells = this.cells = [];
                for (var i = 0; i < columns.length; i++) {
                    cells.push(this.makeCell(columns.at(i), options));
                }
                this.listenTo(columns, 'add', function (column, columns) {
                    var i = columns.indexOf(column);
                    var cell = this.makeCell(column, options);
                    cells.splice(i, 0, cell);
                    var $el = this.$el;
                    if (i === 0) {
                        $el.prepend(cell.render().$el);
                    } else if (i === columns.length - 1) {
                        $el.append(cell.render().$el);
                    } else {
                        $el.children().eq(i).before(cell.render().$el);
                    }
                });
                this.listenTo(columns, 'remove', function (column, columns, opts) {
                    cells[opts.index].remove();
                    cells.splice(opts.index, 1);
                });
            },
            makeCell: function (column) {
                return new (column.get('cell'))({
                    column: column,
                    model: this.model
                });
            },
            render: function () {
                this.$el.empty();
                var fragment = document.createDocumentFragment();
                for (var i = 0; i < this.cells.length; i++) {
                    fragment.appendChild(this.cells[i].render().el);
                }
                this.el.appendChild(fragment);
                this.delegateEvents();
                return this;
            },
            remove: function () {
                for (var i = 0; i < this.cells.length; i++) {
                    var cell = this.cells[i];
                    cell.remove.apply(cell, arguments);
                }
                return Backbone.View.prototype.remove.apply(this, arguments);
            }
        });
        var EmptyRow = Backgrid.EmptyRow = Backbone.View.extend({
            tagName: 'tr',
            emptyText: null,
            initialize: function (options) {
                this.emptyText = options.emptyText;
                this.columns = options.columns;
            },
            render: function () {
                this.$el.empty();
                var td = document.createElement('td');
                td.setAttribute('colspan', this.columns.length);
                td.appendChild(document.createTextNode(_.result(this, 'emptyText')));
                this.el.className = 'empty';
                this.el.appendChild(td);
                return this;
            }
        });
        var HeaderCell = Backgrid.HeaderCell = Backbone.View.extend({
            tagName: 'th',
            events: { 'click a': 'onClick' },
            initialize: function (options) {
                this.column = options.column;
                if (!(this.column instanceof Column)) {
                    this.column = new Column(this.column);
                }
                var column = this.column, collection = this.collection, $el = this.$el;
                this.listenTo(column, 'change:editable change:sortable change:renderable', function (column) {
                    var changed = column.changedAttributes();
                    for (var key in changed) {
                        if (changed.hasOwnProperty(key)) {
                            $el.toggleClass(key, changed[key]);
                        }
                    }
                });
                this.listenTo(column, 'change:direction', this.setCellDirection);
                this.listenTo(column, 'change:name change:label', this.render);
                if (Backgrid.callByNeed(column.editable(), column, collection))
                    $el.addClass('editable');
                if (Backgrid.callByNeed(column.sortable(), column, collection))
                    $el.addClass('sortable');
                if (Backgrid.callByNeed(column.renderable(), column, collection))
                    $el.addClass('renderable');
                this.listenTo(collection.fullCollection || collection, 'sort', this.removeCellDirection);
            },
            removeCellDirection: function () {
                this.$el.removeClass('ascending').removeClass('descending');
                this.column.set('direction', null);
            },
            setCellDirection: function (column, direction) {
                this.$el.removeClass('ascending').removeClass('descending');
                if (column.cid == this.column.cid)
                    this.$el.addClass(direction);
            },
            onClick: function (e) {
                e.preventDefault();
                var column = this.column;
                var collection = this.collection;
                var event = 'backgrid:sort';
                function cycleSort(header, col) {
                    if (column.get('direction') === 'ascending')
                        collection.trigger(event, col, 'descending');
                    else if (column.get('direction') === 'descending')
                        collection.trigger(event, col, null);
                    else
                        collection.trigger(event, col, 'ascending');
                }
                function toggleSort(header, col) {
                    if (column.get('direction') === 'ascending')
                        collection.trigger(event, col, 'descending');
                    else
                        collection.trigger(event, col, 'ascending');
                }
                var sortable = Backgrid.callByNeed(column.sortable(), column, this.collection);
                if (sortable) {
                    var sortType = column.get('sortType');
                    if (sortType === 'toggle')
                        toggleSort(this, column);
                    else
                        cycleSort(this, column);
                }
            },
            render: function () {
                this.$el.empty();
                var column = this.column;
                var sortable = Backgrid.callByNeed(column.sortable(), column, this.collection);
                var label;
                if (sortable) {
                    label = $('<a>').text(column.get('label')).append('<b class=\'sort-caret\'></b>');
                } else {
                    label = document.createTextNode(column.get('label'));
                }
                this.$el.append(label);
                this.$el.addClass(column.get('name'));
                this.$el.addClass(column.get('direction'));
                this.delegateEvents();
                return this;
            }
        });
        var HeaderRow = Backgrid.HeaderRow = Backgrid.Row.extend({
            requiredOptions: [
                'columns',
                'collection'
            ],
            initialize: function () {
                Backgrid.Row.prototype.initialize.apply(this, arguments);
            },
            makeCell: function (column, options) {
                var headerCell = column.get('headerCell') || options.headerCell || HeaderCell;
                headerCell = new headerCell({
                    column: column,
                    collection: this.collection
                });
                return headerCell;
            }
        });
        var Header = Backgrid.Header = Backbone.View.extend({
            tagName: 'thead',
            initialize: function (options) {
                this.columns = options.columns;
                if (!(this.columns instanceof Backbone.Collection)) {
                    this.columns = new Columns(this.columns);
                }
                this.row = new Backgrid.HeaderRow({
                    columns: this.columns,
                    collection: this.collection
                });
            },
            render: function () {
                this.$el.append(this.row.render().$el);
                this.delegateEvents();
                return this;
            },
            remove: function () {
                this.row.remove.apply(this.row, arguments);
                return Backbone.View.prototype.remove.apply(this, arguments);
            }
        });
        var Body = Backgrid.Body = Backbone.View.extend({
            tagName: 'tbody',
            initialize: function (options) {
                this.columns = options.columns;
                if (!(this.columns instanceof Backbone.Collection)) {
                    this.columns = new Columns(this.columns);
                }
                this.row = options.row || Row;
                this.rows = this.collection.map(function (model) {
                    var row = new this.row({
                        columns: this.columns,
                        model: model
                    });
                    return row;
                }, this);
                this.emptyText = options.emptyText;
                this._unshiftEmptyRowMayBe();
                var collection = this.collection;
                this.listenTo(collection, 'add', this.insertRow);
                this.listenTo(collection, 'remove', this.removeRow);
                this.listenTo(collection, 'sort', this.refresh);
                this.listenTo(collection, 'reset', this.refresh);
                this.listenTo(collection, 'backgrid:sort', this.sort);
                this.listenTo(collection, 'backgrid:edited', this.moveToNextCell);
            },
            _unshiftEmptyRowMayBe: function () {
                if (this.rows.length === 0 && this.emptyText != null) {
                    this.rows.unshift(new EmptyRow({
                        emptyText: this.emptyText,
                        columns: this.columns
                    }));
                }
            },
            insertRow: function (model, collection, options) {
                if (this.rows[0] instanceof EmptyRow)
                    this.rows.pop().remove();
                if (!(collection instanceof Backbone.Collection) && !options) {
                    this.collection.add(model, options = collection);
                    return;
                }
                var row = new this.row({
                    columns: this.columns,
                    model: model
                });
                var index = collection.indexOf(model);
                this.rows.splice(index, 0, row);
                var $el = this.$el;
                var $children = $el.children();
                var $rowEl = row.render().$el;
                if (index >= $children.length) {
                    $el.append($rowEl);
                } else {
                    $children.eq(index).before($rowEl);
                }
                return this;
            },
            removeRow: function (model, collection, options) {
                if (!options) {
                    this.collection.remove(model, options = collection);
                    this._unshiftEmptyRowMayBe();
                    return;
                }
                if (_.isUndefined(options.render) || options.render) {
                    this.rows[options.index].remove();
                }
                this.rows.splice(options.index, 1);
                this._unshiftEmptyRowMayBe();
                return this;
            },
            refresh: function () {
                for (var i = 0; i < this.rows.length; i++) {
                    this.rows[i].remove();
                }
                this.rows = this.collection.map(function (model) {
                    var row = new this.row({
                        columns: this.columns,
                        model: model
                    });
                    return row;
                }, this);
                this._unshiftEmptyRowMayBe();
                this.render();
                this.collection.trigger('backgrid:refresh', this);
                return this;
            },
            render: function () {
                this.$el.empty();
                var fragment = document.createDocumentFragment();
                for (var i = 0; i < this.rows.length; i++) {
                    var row = this.rows[i];
                    fragment.appendChild(row.render().el);
                }
                this.el.appendChild(fragment);
                this.delegateEvents();
                return this;
            },
            remove: function () {
                for (var i = 0; i < this.rows.length; i++) {
                    var row = this.rows[i];
                    row.remove.apply(row, arguments);
                }
                return Backbone.View.prototype.remove.apply(this, arguments);
            },
            sort: function (column, direction) {
                if (!_.contains([
                        'ascending',
                        'descending',
                        null
                    ], direction)) {
                    throw new RangeError('direction must be one of "ascending", "descending" or `null`');
                }
                if (_.isString(column))
                    column = this.columns.findWhere({ name: column });
                var collection = this.collection;
                var order;
                if (direction === 'ascending')
                    order = -1;
                else if (direction === 'descending')
                    order = 1;
                else
                    order = null;
                var comparator = this.makeComparator(column.get('name'), order, order ? column.sortValue() : function (model) {
                    return model.cid.replace('c', '') * 1;
                });
                if (Backbone.PageableCollection && collection instanceof Backbone.PageableCollection) {
                    collection.setSorting(order && column.get('name'), order, { sortValue: column.sortValue() });
                    if (collection.fullCollection) {
                        if (collection.fullCollection.comparator == null) {
                            collection.fullCollection.comparator = comparator;
                        }
                        collection.fullCollection.sort();
                        collection.trigger('backgrid:sorted', column, direction, collection);
                    } else
                        collection.fetch({
                            reset: true,
                            success: function () {
                                collection.trigger('backgrid:sorted', column, direction, collection);
                            }
                        });
                } else {
                    collection.comparator = comparator;
                    collection.sort();
                    collection.trigger('backgrid:sorted', column, direction, collection);
                }
                column.set('direction', direction);
                return this;
            },
            makeComparator: function (attr, order, func) {
                return function (left, right) {
                    var l = func(left, attr), r = func(right, attr), t;
                    if (order === 1)
                        t = l, l = r, r = t;
                    if (l === r)
                        return 0;
                    else if (l < r)
                        return -1;
                    return 1;
                };
            },
            moveToNextCell: function (model, column, command) {
                var i = this.collection.indexOf(model);
                var j = this.columns.indexOf(column);
                var cell, renderable, editable, m, n;
                this.rows[i].cells[j].exitEditMode();
                if (command.moveUp() || command.moveDown() || command.moveLeft() || command.moveRight() || command.save()) {
                    var l = this.columns.length;
                    var maxOffset = l * this.collection.length;
                    if (command.moveUp() || command.moveDown()) {
                        m = i + (command.moveUp() ? -1 : 1);
                        var row = this.rows[m];
                        if (row) {
                            cell = row.cells[j];
                            if (Backgrid.callByNeed(cell.column.editable(), cell.column, model)) {
                                cell.enterEditMode();
                                model.trigger('backgrid:next', m, j, false);
                            }
                        } else
                            model.trigger('backgrid:next', m, j, true);
                    } else if (command.moveLeft() || command.moveRight()) {
                        var right = command.moveRight();
                        for (var offset = i * l + j + (right ? 1 : -1); offset >= 0 && offset < maxOffset; right ? offset++ : offset--) {
                            m = ~~(offset / l);
                            n = offset - m * l;
                            cell = this.rows[m].cells[n];
                            renderable = Backgrid.callByNeed(cell.column.renderable(), cell.column, cell.model);
                            editable = Backgrid.callByNeed(cell.column.editable(), cell.column, model);
                            if (renderable && editable) {
                                cell.enterEditMode();
                                model.trigger('backgrid:next', m, n, false);
                                break;
                            }
                        }
                        if (offset == maxOffset) {
                            model.trigger('backgrid:next', ~~(offset / l), offset - m * l, true);
                        }
                    }
                }
                return this;
            }
        });
        var Footer = Backgrid.Footer = Backbone.View.extend({
            tagName: 'tfoot',
            initialize: function (options) {
                this.columns = options.columns;
                if (!(this.columns instanceof Backbone.Collection)) {
                    this.columns = new Backgrid.Columns(this.columns);
                }
            }
        });
        var Grid = Backgrid.Grid = Backbone.View.extend({
            tagName: 'table',
            className: 'backgrid',
            header: Header,
            body: Body,
            footer: null,
            initialize: function (options) {
                if (!(options.columns instanceof Backbone.Collection)) {
                    options.columns = new Columns(options.columns);
                }
                this.columns = options.columns;
                var filteredOptions = _.omit(options, [
                    'el',
                    'id',
                    'attributes',
                    'className',
                    'tagName',
                    'events'
                ]);
                this.body = options.body || this.body;
                this.body = new this.body(filteredOptions);
                this.header = options.header || this.header;
                if (this.header) {
                    this.header = new this.header(filteredOptions);
                }
                this.footer = options.footer || this.footer;
                if (this.footer) {
                    this.footer = new this.footer(filteredOptions);
                }
                this.listenTo(this.columns, 'reset', function () {
                    if (this.header) {
                        this.header = new (this.header.remove()).constructor(filteredOptions);
                    }
                    this.body = new (this.body.remove()).constructor(filteredOptions);
                    if (this.footer) {
                        this.footer = new (this.footer.remove()).constructor(filteredOptions);
                    }
                    this.render();
                });
            },
            insertRow: function () {
                this.body.insertRow.apply(this.body, arguments);
                return this;
            },
            removeRow: function () {
                this.body.removeRow.apply(this.body, arguments);
                return this;
            },
            insertColumn: function () {
                this.columns.add.apply(this.columns, arguments);
                return this;
            },
            removeColumn: function () {
                this.columns.remove.apply(this.columns, arguments);
                return this;
            },
            sort: function () {
                this.body.sort.apply(this.body, arguments);
                return this;
            },
            render: function () {
                this.$el.empty();
                if (this.header) {
                    this.$el.append(this.header.render().$el);
                }
                if (this.footer) {
                    this.$el.append(this.footer.render().$el);
                }
                this.$el.append(this.body.render().$el);
                this.delegateEvents();
                this.trigger('backgrid:rendered', this);
                return this;
            },
            remove: function () {
                this.header && this.header.remove.apply(this.header, arguments);
                this.body.remove.apply(this.body, arguments);
                this.footer && this.footer.remove.apply(this.footer, arguments);
                return Backbone.View.prototype.remove.apply(this, arguments);
            }
        });
        return Backgrid;
    }));
    return Backgrid;
});
define('common-modules/grid/grid', [
    'backgrid',
    'common-modules/containers/views/placeholder',
    'common-modules/buttons/tooltip-trigger'
], function (Backgrid, Placeholder, TooltipTrigger) {
    'use strict';
    _.extend(Backgrid.HeaderCell.prototype, {
        events: { click: 'onClick' },
        removeCellDirection: function () {
            this.$el.removeClass('ascending').removeClass('descending');
            this.column.set('direction', null);
            this.$el.attr('data-sort-order', null);
        },
        setCellDirection: function (column, direction) {
            this.$el.removeClass('ascending').removeClass('descending');
            if (column.cid === this.column.cid)
                this.$el.addClass(direction);
            this.$el.attr('data-sort-order', direction);
        },
        render: function () {
            this.$el.empty();
            var column = this.column;
            var sortable = Backgrid.callByNeed(column.sortable(), column, this.collection);
            var label = column.get('label') instanceof Backbone.View ? column.get('label').render().$el : document.createTextNode(column.get('label'));
            if (sortable) {
                this.$el.addClass('adb-is-active');
                this.$el.attr('data-sort', '');
                this.$el.attr('data-sort-order', column.get('direction'));
            } else {
                this.$el.removeClass('adb-is-active');
                this.$el.attr('data-sort', null);
            }
            this.$el.append(label);
            this.$el.addClass(column.get('name'));
            this.$el.addClass(column.get('direction'));
            this.delegateEvents();
            return this;
        }
    });
    var originalSort = Backgrid.Body.prototype.sort, originalBodyInitialize = Backgrid.Body.prototype.initialize;
    _.extend(Backgrid.Body.prototype, {
        initialize: function (options) {
            options = options || {};
            this.emptyView = options.emptyView;
            originalBodyInitialize.apply(this, arguments);
        },
        _unshiftEmptyRowMayBe: function () {
            if (this.rows.length === 0 && (this.emptyText || this.emptyView)) {
                this.rows.unshift(new Backgrid.EmptyRow({
                    emptyText: this.emptyText,
                    emptyView: this.emptyView,
                    columns: this.columns
                }));
                this.render();
            }
        },
        sort: function () {
            if (this.options.clientSortable) {
                originalSort.apply(this, arguments);
            }
        },
        getRowByModel: function (model) {
            return _(this.rows).findWhere({ model: model });
        }
    });
    _.extend(Backgrid.Column.prototype, {
        defaults: _.extend({}, Backgrid.Column.prototype.defaults, {
            editable: false,
            sortable: false
        })
    });
    var originalRowInitialize = Backgrid.Row.prototype.initialize;
    _.extend(Backgrid.Row.prototype, {
        disabledClass: 'adb-is-disabled',
        initialize: function () {
            originalRowInitialize.apply(this, arguments);
            if (this.model) {
                this.listenTo(this.model, 'backgrid:enable', this.onEnable);
            }
        },
        onEnable: function (model, enabled, options) {
            options = options || {};
            this.$el.toggleClass(this.disabledClass, !enabled && options.disableRow !== false);
        },
        isEnabled: function () {
            return !this.$el.hasClass(this.disabledClass);
        },
        remove: function () {
            for (var i = 0; i < this.cells.length; i++) {
                var cell = this.cells[i], method = cell.close ? 'close' : 'remove';
                cell[method].apply(cell, arguments);
            }
            if (this.tooltipTrigger) {
                this.tooltipTrigger.close();
            }
            return Backbone.View.prototype.remove.apply(this, arguments);
        },
        renderTooltip: function (options) {
            this.tooltipTrigger = new TooltipTrigger(_.extend({
                tooltipType: TooltipTrigger.TYPE.SIMPLETOOLTIPTYPE,
                tooltipPlacement: TooltipTrigger.PLACEMENTS.TOP,
                tooltipEvent: TooltipTrigger.EVENTS.HOVER,
                el: this.$el
            }, options));
            this.tooltipTrigger.triggerMethod('render');
        }
    });
    var originalCellRender = Backgrid.Cell.prototype.render;
    _.extend(Backgrid.Cell.prototype, {
        render: function () {
            originalCellRender.apply(this, arguments);
            if (this.column.get('forceWrap')) {
                this.$el.attr('style', 'word-break: break-all;');
            }
            return this;
        }
    });
    var originalEmptyRowInitialize = Backgrid.EmptyRow.prototype.initialize;
    Backgrid.EmptyRow = Backgrid.EmptyRow.extend({
        initialize: function (options) {
            options = options || {};
            originalEmptyRowInitialize.apply(this, arguments);
            this.emptyView = options.emptyView;
        },
        getDefaultEmptyView: function () {
            var emptyText = _.result(this, 'emptyText');
            if (!emptyText) {
                return null;
            }
            return new Placeholder({
                content: new Marionette.ItemView({
                    template: _.template(emptyText),
                    tagName: 'p'
                }),
                type: Placeholder.TYPES.CONDENSED
            });
        },
        render: function () {
            this.$el.empty();
            var td = $('<td></td>');
            td.attr('colspan', this.columns.length);
            var emptyView = this.getDefaultEmptyView() || this.emptyView;
            if (emptyView) {
                td.html(emptyView.render().el).addClass('adb-table--placeholder');
                emptyView.delegateEvents();
            }
            this.$el.append(td);
            return this;
        }
    });
    return Backgrid.Grid.extend({
        className: 'adb-table',
        isActionable: false,
        constructor: function (options) {
            Backgrid.Grid.apply(this, arguments);
            if (!_.isUndefined(options.isActionable)) {
                this.isActionable = !!options.isActionable;
            }
            this.emptyView = options.emptyView;
            this.clientSortable = options.clientSortable !== false;
            this.colgroup = options.colgroup;
            this.listenTo(this.collection, 'count:total', _.bind(this._toggleActionableTable, this));
        },
        _toggleActionableTable: function () {
            this.$el.toggleClass('adb-table__actionable', !!this.collection.length && this.isActionable);
        },
        render: function () {
            this.isClosed = false;
            Backgrid.Grid.prototype.render.apply(this, arguments);
            this._toggleActionableTable();
            this._renderColgroup();
            return this;
        },
        _renderColgroup: function () {
            if (this.colgroup) {
                var colgroup = $('<colgroup />').append(_.map(this.colgroup, function (percent) {
                    return $('<col />').attr('width', percent + '%');
                }));
                this.$el.prepend(colgroup);
            }
        },
        close: function () {
            if (this.isClosed) {
                return;
            }
            var args = Array.prototype.slice.call(arguments);
            var shouldClose = this.triggerMethod.apply(this, ['before:close'].concat(args));
            if (shouldClose === false) {
                return;
            }
            this.isClosed = true;
            this.triggerMethod.apply(this, ['close'].concat(args));
            this.remove();
        },
        triggerMethod: function () {
            Marionette.triggerMethod.apply(this, arguments);
        },
        getRowByModel: function (model) {
            return this.body.getRowByModel(model);
        },
        toggleEnabled: function (models, enable, options) {
            if (!models) {
                return;
            } else if (!_.isArray(models)) {
                models = [models];
            }
            _(models).each(function (model) {
                model.trigger('backgrid:enable', model, enable, options);
            });
        },
        enable: function (models) {
            this.toggleEnabled(models, true);
        },
        disable: function (models) {
            this.toggleEnabled(models, false);
        }
    });
});
define('common-modules/grid/rows/option-selector-row', ['backgrid'], function (Backgrid) {
    'use strict';
    return Backgrid.Row.extend({
        className: 'adb-js-radio',
        selectedClass: 'adb-is-selected',
        events: { click: 'onClick' },
        initialize: function () {
            Backgrid.Row.prototype.initialize.apply(this, arguments);
            this.listenTo(this.model.collection, 'backgrid:select', this.onSelect);
        },
        onSelect: function (model, selected) {
            if (model !== this.model) {
                return;
            }
            this.$el.toggleClass(this.selectedClass, selected);
        },
        onClick: function () {
            if (this.isEnabled()) {
                this.model.trigger('backgrid:select', this.model, !this.isSelected());
            }
        },
        isSelected: function () {
            return this.$el.hasClass(this.selectedClass);
        }
    });
});
define('common-modules/forms/views/option-selector-grid', [
    'common-modules/grid/grid',
    'common-modules/grid/rows/option-selector-row'
], function (Grid, OptionSelectorRow) {
    'use strict';
    return Grid.extend({
        optionSelectorCell: null,
        optionSelectorHeaderCell: null,
        optionSelectorRow: OptionSelectorRow,
        isActionable: true,
        initialize: function (options) {
            options.columns = [{
                    name: '',
                    inputName: this.cid,
                    cell: this.optionSelectorCell,
                    headerCell: options.optionSelectorHeaderCell || this.optionSelectorHeaderCell
                }].concat(options.columns);
            options.row = this.optionSelectorRow;
            if (!_.isUndefined(options.header)) {
                this.header = options.header;
            }
            this.listenTo(this.collection, 'backgrid:select', this.onSelect);
            this.listenTo(this.collection, 'backgrid:header:select', this.onSelectHeader);
            Grid.prototype.initialize.apply(this, arguments);
        },
        getSelected: function () {
            return _(this.body.rows).chain().filter(function (row) {
                return row.isSelected();
            }).pluck('model').value();
        },
        onSelect: function (model, selected, options) {
            options = options || {};
            if (!options.silent) {
                this.trigger('select', model, selected);
            }
        },
        onSelectHeader: function (selected, options) {
            options = options || {};
            if (!options.silent) {
                this.trigger('select:header', selected);
            }
        },
        toggleHeaderSelected: function (selected) {
            this.collection.trigger('backgrid:header:select', selected, { silent: true });
        },
        selectHeader: function () {
            this.toggleHeaderSelected(true);
        },
        unselectHeader: function () {
            this.toggleHeaderSelected(false);
        },
        select: function (models) {
            if (!models) {
                return;
            }
            if (!_.isArray(models)) {
                models = [models];
            }
            _(models).each(function (model) {
                model.trigger('backgrid:select', model, true, { silent: true });
            });
        },
        deselect: function (models) {
            models = models || this.getSelected();
            if (!models) {
                return;
            }
            if (!_.isArray(models)) {
                models = [models];
            }
            _(models).each(function (model) {
                model.trigger('backgrid:select', model, false, { silent: true });
            });
        },
        toggleSelected: function (models, selected) {
            this[selected ? 'select' : 'deselect'](models);
        }
    });
});
define('common-modules/grid/cells/checkbox-cell', ['backgrid'], function (Backgrid) {
    'use strict';
    return Backgrid.Cell.extend({
        className: 'checkbox-cell',
        template: _.template('<input type="checkbox" name="<%- name %>" value="<%- value %>">'),
        events: { 'click input': 'onClick' },
        initialize: function () {
            Backgrid.Cell.prototype.initialize.apply(this, arguments);
            this.listenTo(this.model, 'backgrid:enable', this.onEnable);
            this.listenTo(this.model, 'backgrid:select', this.onSelect);
        },
        checkbox: function () {
            return this.$('input');
        },
        onEnable: function (model, enabled) {
            this.checkbox().prop('disabled', !enabled);
        },
        onSelect: function (model, selected) {
            this.check(selected);
        },
        check: function (checked) {
            this.checkbox().prop('checked', checked);
        },
        isEnabled: function () {
            return !this.checkbox().prop('disabled');
        },
        isChecked: function () {
            return this.checkbox().prop('checked');
        },
        onClick: function (e) {
            e.stopPropagation();
            if (this.isEnabled()) {
                this.model.trigger('backgrid:select', this.model, this.isChecked());
            }
        },
        serializeData: function () {
            var modelId = this.model.id || this.model.cid;
            return {
                name: this.column.get('name') + '-' + modelId,
                value: this.model.get(this.column.get('value')) || modelId
            };
        },
        render: function () {
            this.$el.html(this.template(this.serializeData()));
            this.delegateEvents();
            var value = this.model.get(this.column.get('name'));
            if (_.isBoolean(value)) {
                this.check(value);
            }
            return this;
        }
    });
});
define('common-modules/forms/views/checkbox-grid', [
    'common-modules/forms/views/option-selector-grid',
    'common-modules/grid/cells/checkbox-cell'
], function (OptionSelectorGrid, CheckboxCell) {
    'use strict';
    return OptionSelectorGrid.extend({ optionSelectorCell: CheckboxCell });
});
define('common-modules/forms/views/error-handler', [], function () {
    'use strict';
    function ErrorHandler(form, alertModel, options) {
        this.form = form;
        this.alertModel = alertModel;
        _.extend(this, _.defaults(options, this.defaults));
    }
    _.extend(ErrorHandler.prototype, {
        defaults: {
            errors: [],
            fieldMap: {},
            localizationPrefix: null,
            unknownErrorLabel: null
        },
        handle: function (errors) {
            if (this.alertModel) {
                this.alertModel.clear();
            }
            var fieldErrors = {};
            _(errors).each(function (error) {
                var errorDefinition = this.extractErrorFromError(error) || this.extractErrorFromProperty(error);
                if (!errorDefinition) {
                    return;
                }
                var message;
                if (errorDefinition.message) {
                    message = errorDefinition.message;
                } else if (errorDefinition.code) {
                    var prefix = this.localizationPrefix ? this.localizationPrefix + '.' : '';
                    message = l(prefix + errorDefinition.code);
                } else {
                    message = '';
                }
                if (errorDefinition.field) {
                    fieldErrors[errorDefinition.field] = _.isFunction(message) ? message(error) : message;
                }
            }, this);
            if (!_.isEmpty(fieldErrors)) {
                this.form.showFieldErrors(fieldErrors);
            } else if (!!this.unknownErrorLabel && this.alertModel) {
                this.alertModel.set({
                    type: 'error',
                    content: this.unknownErrorLabel
                });
            }
        },
        extractErrorFromProperty: function (error) {
            var field = this.fieldMap[error.code];
            if (!field) {
                return;
            }
            return {
                message: error.message,
                field: field
            };
        },
        extractErrorFromError: function (error) {
            return _(this.errors).findWhere({ code: error.code }) || _(this.errors).findWhere({ message: error.message });
        }
    });
    return ErrorHandler;
});
define('common-modules/forms/views/file-uploads', [
    'common-modules/forms/views/file-upload',
    'common-modules/utils/file-uploader',
    'common-modules/utils/browser-util'
], function (FileUpload, FileUploader, BrowserUtil) {
    'use strict';
    return Marionette.CollectionView.extend({
        itemView: FileUpload,
        initialize: function (options) {
            this.url = options.url;
            this.method = options.method;
            this.ajaxOptions = options.ajaxOptions || {};
        },
        itemViewOptions: function () {
            return _(this).pick('url', 'method');
        },
        setUrl: function (url) {
            this.url = url;
            this.children.each(function (child) {
                child.url = url;
            });
        },
        hasFiles: function () {
            return _.some(this.$('input:file'), function (input) {
                return !!$(input).val();
            });
        },
        getFiles: function () {
            return _(this.children._views).chain().invoke('getFile').filter(function (file) {
                return !!file.file;
            }).value();
        },
        upload: function () {
            if (this.uploading) {
                return;
            }
            var promise;
            if (BrowserUtil.isIEBelow10() && this.collection.length > 1) {
                throw new Error('Multi file upload is not supported in <IE10');
            } else if (BrowserUtil.isIEBelow10()) {
                promise = this.children.first().upload();
            } else if (this.hasFiles()) {
                promise = FileUploader.upload(this.getFiles(), this.url, this.method, this.ajaxOptions);
            } else {
                return;
            }
            this.uploading = true;
            return promise.always(_.bind(this.onUploadAlways, this));
        },
        onUploadAlways: function () {
            this.uploading = false;
        }
    });
});
define('common-modules/grid/cells/radio-cell', ['backgrid'], function (Backgrid) {
    'use strict';
    return Backgrid.Cell.extend({
        className: 'radio-cell',
        template: _.template('<input type="radio" name="<%- name %>" value="<%- id %>">'),
        events: { click: 'onClick' },
        initialize: function () {
            Backgrid.Cell.prototype.initialize.apply(this, arguments);
            this.listenTo(this.model, 'backgrid:enable', this.onEnable);
            this.listenTo(this.model, 'backgrid:select', this.onSelect);
        },
        radio: function () {
            return this.$('input');
        },
        onEnable: function (model, enabled) {
            this.radio().prop('disabled', !enabled);
        },
        onSelect: function (model, selected) {
            this.radio().prop('checked', selected);
        },
        isEnabled: function () {
            return !this.$('input').prop('disabled');
        },
        onClick: function (e) {
            e.stopPropagation();
            if (this.isEnabled()) {
                this.model.trigger('backgrid:select', this.model, true);
            }
        },
        render: function () {
            this.$el.empty().append(this.template({
                name: this.column.cid,
                id: this.model.id
            }));
            this.delegateEvents();
            return this;
        }
    });
});
define('common-modules/grid/rows/radio-row', ['common-modules/grid/rows/option-selector-row'], function (OptionSelectorRow) {
    'use strict';
    return OptionSelectorRow.extend({
        onClick: function () {
            if (this.isEnabled()) {
                this.model.trigger('backgrid:select', this.model, true);
            }
        },
        onSelect: function (model, selected) {
            if (model !== this.model) {
                selected = false;
            }
            this.$el.toggleClass(this.selectedClass, selected);
        }
    });
});
define('common-modules/forms/views/radio-grid', [
    'common-modules/forms/views/option-selector-grid',
    'common-modules/grid/cells/radio-cell',
    'common-modules/grid/rows/radio-row'
], function (OptionSelectorGrid, RadioCell, RadioRow) {
    'use strict';
    return OptionSelectorGrid.extend({
        optionSelectorCell: RadioCell,
        optionSelectorRow: RadioRow,
        select: function (models) {
            if (!models) {
                return;
            }
            this.deselect();
            OptionSelectorGrid.prototype.select.apply(this, arguments);
        }
    });
});
define('common-modules/grid/rows/toggle-row', ['common-modules/grid/rows/option-selector-row'], function (OptionSelectorRow) {
    'use strict';
    return OptionSelectorRow.extend({
        className: 'toggle-row',
        selectedClass: 'adb-is-enabled',
        events: null
    });
});
define('common-modules/forms/views/toggle-grid', [
    'common-modules/forms/views/option-selector-grid',
    'common-modules/grid/grid',
    'common-modules/grid/rows/toggle-row'
], function (OptionSelectorGrid, Grid, ToggleRow) {
    'use strict';
    return OptionSelectorGrid.extend({
        header: null,
        initialize: function (options) {
            _.defaults(options, {
                row: ToggleRow,
                colgroup: [
                    85,
                    15
                ],
                isActionable: false
            });
            this.listenTo(this.collection, 'backgrid:select', this.onSelect);
            this.listenTo(this.collection, 'backgrid:header:select', this.onSelectHeader);
            Grid.prototype.initialize.apply(this, arguments);
        }
    });
});
define('common-modules/grid/cells/forms/select-cell', [
    'backgrid',
    'common-modules/forms/views/select-input'
], function (Backgrid, SelectInput) {
    'use strict';
    return Backgrid.Cell.extend({
        labelTemplate: _.template('<label id="<%- cid %>-label" style="border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;" for="<%- cid %>"' + ' class="adb-input_table--label"><%- label %>' + '</label>'),
        render: function () {
            var options = this.getOptions();
            if (options.length) {
                this.$el.empty();
                this.$el.append(this.renderLabel());
                this.$el.append(this.renderSelectInput(options));
                this.bindEvents();
            }
            this.bindData();
            return this;
        },
        renderLabel: function () {
            return this.labelTemplate({
                cid: this.cid,
                label: l('grid.row.number.with.type', this.getRowNumber(), this.getColumnLabel())
            });
        },
        getColumnLabel: function () {
            var label = this.column.get('label');
            if (_.isUndefined(label)) {
                label = this.column.get('name');
            }
            if (typeof label === 'string') {
                return label;
            }
            return $(label.el).text();
        },
        getRowNumber: function () {
            if (this.model.collection) {
                return this.model.collection.indexOf(this.model) + 1;
            }
            return '';
        },
        renderSelectInput: function () {
            var options = this.getOptions();
            var rawValue = this.model.get(this.column.get('name'));
            var value = this.formatter.fromRaw(rawValue, this.model);
            var selectInput = this.selectInput = new SelectInput({
                collection: new Backbone.Collection(options),
                isTableContent: true,
                value: value || this.column.get('value') || options[0].value,
                isSmall: this.column.get('isSmall'),
                size: this.column.get('size'),
                ariaLabelledBy: this.cid + '-label'
            });
            selectInput.render();
            return selectInput.el;
        },
        getOptions: function () {
            return _(this.column.get('options')).filter(function (option) {
                if (_.isUndefined(option.visible)) {
                    return true;
                }
                return option.visible.call(this, this.model);
            }, this);
        },
        bindEvents: function () {
            this.listenTo(this.selectInput, 'change', this.bindData);
        },
        bindData: function () {
            this.model.set(this.column.get('name'), this.selectInput.val(), { silent: true });
        }
    });
});
define('common-modules/grid/cells/forms/text-input-cell', [
    'backgrid',
    'common-modules/forms/views/text-input'
], function (Backgrid, TextInput) {
    'use strict';
    return Backgrid.Cell.extend({
        className: 'adb-input_table--primary',
        labelTemplate: _.template('<label id="<%- cid %>-label" style="border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;" for="<%- cid %>"' + ' class="adb-input_table--label"><%- label %>' + '</label>'),
        render: function () {
            this.$el.empty();
            this.$el.append(this.renderLabel());
            this.$el.append(this.renderTextInput());
            this.bindEvents();
            return this;
        },
        renderLabel: function () {
            return this.labelTemplate({
                cid: this.cid,
                label: l('grid.row.number.with.type', this.getRowNumber(), this.getColumnLabel())
            });
        },
        getColumnLabel: function () {
            var label = this.column.get('label');
            if (_.isUndefined(label)) {
                label = this.column.get('name');
            }
            if (typeof label === 'string') {
                return label;
            }
            return $(label.el).text();
        },
        getRowNumber: function () {
            if (this.model.collection) {
                return this.model.collection.indexOf(this.model) + 1;
            }
            return '';
        },
        renderTextInput: function () {
            var opts = _.pick(this.column.toJSON(), 'name', 'placeholder', 'className', 'pattern', 'isSmall');
            opts.attributes = {
                id: this.cid,
                'aria-labelledby': this.cid + '-label'
            };
            var textInput = this.textInput = new TextInput(opts);
            var rawValue = this.model.get(this.column.get('name'));
            var value = this.formatter.fromRaw(rawValue, this.model);
            textInput.render().val(value);
            return textInput.el;
        },
        bindEvents: function () {
            this.listenTo(this.textInput, 'input', function () {
                var inputValue = this.textInput.val();
                var rawValue = this.formatter.toRaw(inputValue, this.model);
                this.model.set(this.column.get('name'), rawValue, { silent: true });
            });
        }
    });
});
define('common-modules/grid/cells/action-cell', [
    'backgrid',
    'common-modules/buttons/button-toolbar'
], function (Backgrid, Toolbar) {
    'use strict';
    return Backgrid.Cell.extend({
        className: 'action-cell adb-table--menu',
        render: function () {
            this.renderToolbar();
            return this;
        },
        getActions: function () {
            return _(this.column.get('actions')).filter(function (action) {
                return _.isFunction(action.visible) ? action.visible(this.model) : true;
            }, this).map(function (action) {
                if (_.isFunction(action.enable)) {
                    return _.extend({}, action, { isDisabled: !action.enable(this.model) });
                }
                return action;
            }, this);
        },
        renderToolbar: function () {
            var actions = new Backbone.Collection(this.getActions());
            var toolbar = this.toolbar = new Toolbar({
                collection: actions,
                isSmall: !!this.column.get('isSmall')
            });
            this.$el.html(toolbar.render().el);
            this.listenTo(toolbar, 'click', this.bubbleEvents);
        },
        bubbleEvents: function (event) {
            this.model.collection.trigger(event, this.model);
        },
        remove: function () {
            if (this.toolbar) {
                this.toolbar.close();
            }
            Backgrid.Cell.prototype.remove.apply(this, arguments);
        }
    });
});
define('common-modules/navigations/models/base-model', [], function () {
    'use strict';
    var BaseNavModel = Backbone.Model.extend({
        defaults: {
            label: 'Label',
            value: 'value'
        }
    });
    var BaseNavCollection = Backbone.Collection.extend({ model: BaseNavModel });
    return {
        BaseNavModel: BaseNavModel,
        BaseNavCollection: BaseNavCollection
    };
});
define('common-modules/grid/cells/action-dropdown-cell', [
    'backgrid',
    'common-modules/buttons/dropdown-button',
    'common-modules/navigations/models/base-model'
], function (Backgrid, DropdownButton, BaseNav) {
    'use strict';
    return Backgrid.Cell.extend({
        className: 'action-dropdown-cell adb-table--menu',
        render: function () {
            var actions = this.getActions(), prop = _.bind(this.column.get, this.column);
            if (actions.length) {
                this.$el.html(this.renderDropdown(actions));
                this.bindMenuEvents();
            } else {
                this.$el.empty();
                if (prop('hasSpacer')) {
                    var isSmall = prop('isSmall');
                    this.addSpacerClass(isSmall);
                }
            }
            return this;
        },
        addSpacerClass: function (isSmall) {
            var spacerClass = 'action-dropdown-cell--';
            spacerClass += isSmall ? 'small-spacer' : 'spacer';
            this.$el.addClass(spacerClass);
        },
        renderDropdown: function (actions) {
            var prop = _.bind(this.column.get, this.column);
            var dropdown = this.dropdown = new DropdownButton({
                collection: new BaseNav.BaseNavCollection(actions),
                placement: prop('placement'),
                label: prop('btnLabel'),
                icon: prop('btnIcon'),
                isSmall: !!prop('isSmall'),
                isSecret: !!prop('isSecret'),
                isFixed: true
            });
            return dropdown.render().el;
        },
        getActions: function () {
            return _(this.column.get('actions')).filter(function (action) {
                if (_.isUndefined(action.visible)) {
                    return true;
                }
                return action.visible.call(this, this.model);
            }, this);
        },
        bindMenuEvents: function () {
            var that = this, dropdown = this.dropdown.getDropdown();
            this.listenTo(dropdown, 'change', function (navItem) {
                that.model.collection.trigger(navItem.get('value'), that.model);
            });
        },
        remove: function () {
            if (this.dropdown) {
                this.dropdown.close();
            }
            Backgrid.Cell.prototype.remove.apply(this, arguments);
        }
    });
});
define('common-modules/patterns/card/templates/application-card.tpl.html', [], function () {
    return '<div class="js-region-logo adb-card--image"></div>\n<div class="adb-card--content adb-summary">\n    <%\n    //  The title is not escaped as we might wanna render the title as a link thus the need to not escape the content\n    //  This shoudd be refactored though.\n    %>\n\t<<%=titleTag%> class="adb-summary--title"><%=title%></<%=titleTag%>>\n<div class="adb-summary--details"><%-details%></div>\n</div>\n';
});
define('common-modules/patterns/card/views/application-card', [
    'common-modules/containers/views/logo',
    'common-modules/containers/views/bundle',
    'common-modules/patterns/card/templates/application-card.tpl.html'
], function (Logo, Bundle, template) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'adb-card',
        attributes: { 'data-component': 'application-card' },
        template: _.template(template),
        regions: { logo: '.js-region-logo' },
        initialize: function (options) {
            options = options || {};
            this.model = this.model || new Backbone.Model();
            this.size = options.size || this.constructor.SIZES.MEDIUM;
            this.logoSize = options.logoSize || this.size.logoSize;
            this.titleTag = options.titleTag || this.size.titleTag;
            this.url = options.url || this.model.get('url');
            this.title = options.title || this.model.get('title');
            this.details = options.details || this.model.get('details');
            this.urlField = options.urlField;
            this.titleField = options.titleField;
            this.detailsField = options.detailsField;
            this.icon = options.icon;
            this.useImgTag = options.useImgTag;
        },
        onRender: function () {
            if (this.collection && !this.collection.isEmpty()) {
                this._mapCollection();
                this.renderBundle();
                return;
            }
            this.renderLogo();
        },
        _mapCollection: function () {
            this.collection.reset(this.collection.map(_.bind(function (item) {
                return _.extend(item.toJSON(), { url: item.get('url') || item.get(this.urlField) || '' });
            }, this)));
        },
        renderBundle: function () {
            this.logo.show(new Bundle({
                collection: this.collection,
                size: this.logoSize,
                overlapping: true
            }));
        },
        renderLogo: function () {
            this.logo.show(new Logo({
                url: this.url || this.model.get(this.urlField),
                size: this.logoSize,
                fallback: Logo.FALLBACK.STAR,
                useBackgroundImage: this.useImgTag ? false : !!this.icon
            }));
        },
        serializeData: function () {
            return _.extend(this.model.toJSON(), {
                title: this.title || this.model.get(this.titleField) || '',
                details: this.details || this.model.get(this.detailsField) || '',
                titleTag: this.titleTag
            });
        }
    }, {
        SIZES: {
            SMALL: {
                logoSize: Bundle.SIZES.SMALL,
                titleTag: 'h4'
            },
            MEDIUM: {
                logoSize: Bundle.SIZES.MEDIUM,
                titleTag: 'h2'
            },
            LARGE: {
                logoSize: Bundle.SIZES.LARGE,
                titleTag: 'h1'
            }
        }
    });
});
define('common-modules/grid/cells/application-cell', [
    'backgrid',
    'common-modules/patterns/card/views/application-card'
], function (Backgrid, ApplicationCard) {
    'use strict';
    return Backgrid.Cell.extend({
        className: 'application-cell adb-table--card',
        nameTemplate: _.template('<%-name%>'),
        linkTemplate: _.template('<a data-truncate="line" href="<%-url%>""><%-name%></a>'),
        render: function () {
            var card = new ApplicationCard({
                model: this.model,
                title: this.getNameHTML(),
                detailsField: this.column.get('description'),
                size: ApplicationCard.SIZES.SMALL,
                logoSize: this.column.get('logoSize'),
                titleTag: this.column.get('titleTagName'),
                icon: this.column.get('icon') || 'app',
                urlField: this.column.get('imageUrl'),
                useImgTag: this.column.get('useImgTag')
            });
            this.$el.html(card.render().el);
            return this;
        },
        getUrl: function () {
            var urlSetting = this.column.get('url');
            if (_.isFunction(urlSetting)) {
                return urlSetting(this.model);
            }
            return this.model.get(urlSetting);
        },
        getNameHTML: function () {
            var name = this.model.get(this.column.get('name'));
            var url = this.getUrl();
            var data = {
                name: name,
                url: url
            };
            var template = url ? this.linkTemplate : this.nameTemplate;
            return template(data);
        }
    });
});
define('common-modules/grid/cells/badge-cell', [
    'backgrid',
    'common-modules/status/views/badge'
], function (Backgrid, Badge) {
    'use strict';
    return Backgrid.Cell.extend({
        _getValueMap: function () {
            var map = this.column.get('valueMap');
            if (!map) {
                throw new Error('Badge column should have a valueMap defined');
            }
            return map;
        },
        render: function () {
            var value = this.formatter.fromRaw(this.model.get(this.column.get('name')), this.model), valueMap = this._getValueMap();
            this._closeBadge();
            var badge = this.badge = new Badge({
                type: valueMap[value].type,
                text: valueMap[value].label
            });
            this.$el.html(badge.render().el);
            return this;
        },
        _closeBadge: function () {
            if (this.badge) {
                this.badge.close();
            }
        },
        remove: function () {
            Backgrid.Cell.prototype.remove.apply(this, arguments);
            this._closeBadge();
        }
    });
});
define('common-modules/grid/cells/badges-cell', [
    'backgrid',
    'common-modules/status/views/badges'
], function (Backgrid, Badges) {
    'use strict';
    return Backgrid.Cell.extend({
        _getValueMap: function () {
            var map = this.column.get('valueMap');
            if (!map) {
                throw new Error('Badge column should have a valueMap defined');
            }
            return map;
        },
        render: function () {
            var values = this.formatter.fromRaw(this.model.get(this.column.get('name')), this.model), valueMap = this._getValueMap();
            this._closeBadges();
            this.badges = new Badges(_.extend({
                collection: new Backbone.Collection(_.map(values, function (value) {
                    var mapped = valueMap[value];
                    return _.extend({ text: mapped.label }, mapped);
                }))
            }, this.column.get('badgesOptions')));
            this.$el.html(this.badges.render().el);
            return this;
        },
        _closeBadges: function () {
            if (this.badges) {
                this.badges.close();
            }
        },
        remove: function () {
            Backgrid.Cell.prototype.remove.apply(this, arguments);
            this._closeBadges();
        }
    });
});
define('common-modules/grid/cells/bold-cell', ['backgrid'], function (Backgrid) {
    'use strict';
    return Backgrid.StringCell.extend({
        render: function () {
            this.$el.empty();
            var model = this.model;
            $('<b>').text(this.formatter.fromRaw(model.get(this.column.get('name')), model)).appendTo(this.$el);
            this.delegateEvents();
            return this;
        }
    });
});
define('common-modules/grid/cells/checkbox-header-cell', ['backgrid'], function (Backgrid) {
    'use strict';
    return Backgrid.HeaderCell.extend({
        className: 'checkbox-header-cell',
        template: _.template('<input type="checkbox" class="js-header-checkbox" name="<%- name %>" value="<%- value %>">'),
        events: { 'click input': 'onClick' },
        initialize: function () {
            Backgrid.HeaderCell.prototype.initialize.apply(this, arguments);
            this.listenTo(this.collection, 'backgrid:header:enable', this.onEnable);
            this.listenTo(this.collection, 'backgrid:header:select', this.onSelect);
        },
        checkbox: function () {
            return this.$('input');
        },
        onEnable: function (enabled) {
            this.checkbox().prop('disabled', !enabled);
        },
        onSelect: function (selected) {
            this.checkbox().prop('checked', selected);
        },
        isEnabled: function () {
            return !this.checkbox().prop('disabled');
        },
        isChecked: function () {
            return this.checkbox().prop('checked');
        },
        onClick: function () {
            if (this.isEnabled()) {
                this.collection.trigger('backgrid:header:select', this.isChecked());
            }
        },
        render: function () {
            this.$el.html(this.template({
                name: this.collection.cid,
                value: this.collection.cid
            }));
            this.delegateEvents();
            return this;
        }
    });
});
define('common-modules/grid/formatters/date-formatter', [
    'backgrid',
    'moment',
    'object-utils'
], function (Backgrid, moment, ObjectUtils) {
    'use strict';
    var DateFormatter = function (options) {
        ObjectUtils.mergeOptions(this, options, [
            'format',
            'defaultLabel'
        ]);
    };
    DateFormatter.prototype = new Backgrid.CellFormatter();
    _.extend(DateFormatter.prototype, {
        defaults: {
            format: 'L',
            defaultLabel: ''
        },
        fromRaw: function (value) {
            if (!value) {
                return this.defaultLabel;
            }
            return moment(value).format(this.format);
        }
    });
    return DateFormatter;
});
define('common-modules/grid/cells/date-cell', [
    'common-modules/grid/formatters/date-formatter',
    'object-utils',
    'backgrid'
], function (DateFormatter, ObjectUtils, Backgrid) {
    'use strict';
    return Backgrid.Cell.extend({
        formatter: DateFormatter,
        initialize: function () {
            Backgrid.Cell.prototype.initialize.apply(this, arguments);
            ObjectUtils.mergeOptions(this.formatter, this.column.toJSON(), [
                'format',
                'locale',
                'defaultLabel'
            ]);
        }
    });
});
define('common-modules/grid/cells/footnote-cell', ['backgrid'], function (Backgrid) {
    'use strict';
    return Backgrid.Cell.extend({
        footnoteTemplate: _.template('<div class="adb-footnote"><%-footnote%></div>'),
        initialize: function () {
            Backgrid.Cell.prototype.initialize.apply(this, arguments);
            this.footnote = this.column.get('footnote');
        },
        render: function () {
            Backgrid.Cell.prototype.render.apply(this, arguments);
            this.$el.append(this.footnoteTemplate({ footnote: _.result(this, 'footnote') }));
            return this;
        }
    });
});
define('common-modules/grid/cells/image-cell', ['backgrid'], function () {
    'use strict';
    var Backgrid = window.Backgrid;
    return Backgrid.Cell.extend({
        className: 'image-cell',
        template: _.template('<img src="<%-url%>" alt="" />'),
        render: function () {
            var url = this.model.get(this.column.get('name'));
            this.$el.empty();
            this.$el.html(this.template({ url: url }));
            this.delegateEvents();
            return this;
        }
    });
});
define('common-modules/grid/cells/logo-cell', [
    'backgrid',
    'common-modules/containers/views/logo'
], function (Backgrid, LogoView) {
    'use strict';
    var LogoCell = Backgrid.Cell.extend({
        className: 'logo-cell',
        render: function () {
            var url = this.model.get(this.column.get('name'));
            var form = this.column.get('form');
            var size = this.column.get('size');
            var logoView = this.logoView = new LogoView({
                url: url,
                form: form,
                size: size
            });
            this.$el.empty();
            this.$el.append(logoView.render().el);
            this.delegateEvents();
            return this;
        },
        remove: function () {
            if (this.logoView)
                this.logoView.close();
            Backgrid.Cell.prototype.remove.apply(this, arguments);
        }
    });
    LogoCell.FORMS = LogoView.FORMS;
    LogoCell.SIZES = LogoView.SIZES;
    return LogoCell;
});
define('common-modules/grid/cells/link-cell', ['backgrid'], function () {
    'use strict';
    var Backgrid = window.Backgrid;
    return Backgrid.Cell.extend({
        className: 'link-cell',
        template: _.template('<a href="<%- url %>" target="<%- target %>"><%- linkLabel %></a>'),
        render: function () {
            var data = this.serializeData();
            this.$el.html(data.url ? this.template(data) : '');
            return this;
        },
        serializeData: function () {
            return {
                url: this.column.get('url') || this.model.get(this.column.get('urlField')),
                linkLabel: this.column.get('linkLabel') || this.model.get(this.column.get('name')),
                target: this.column.get('target') || this.model.get(this.column.get('target'))
            };
        }
    });
});
define('common-modules/grid/cells/status-cell', ['backgrid'], function () {
    'use strict';
    var Backgrid = window.Backgrid;
    return Backgrid.Cell.extend({
        className: 'status-cell',
        template: _.template('<span class="adb-status <%-statusClass%>">' + '<span class="adb-status--gem"></span>' + ' <%-label%>' + '</span>'),
        gemColors: {
            green: 'adb-status__active',
            yellow: 'adb-status__pending',
            red: 'adb-status__error',
            grey: 'adb-status__disabled'
        },
        gemLabels: {
            green: l('Active'),
            yellow: l('Pending'),
            red: l('Failed'),
            grey: l('Canceled')
        },
        render: function () {
            var content = this.template(this.serializeData());
            this.$el.html(content);
            return this;
        },
        _getStatusMap: function () {
            var map = this.column.get('statusMap') || this.statusMap;
            if (!map) {
                throw new Error('Undefined statusMap on StatusCell column');
            }
            return map;
        },
        _getLabelMap: function () {
            var map = this.column.get('labelMap') || (this.labelMap || {});
            return _.defaults(map, this.gemLabels);
        },
        getLabel: function (value, column) {
            if (column.get('showLabel') === false) {
                return '';
            }
            var labelMap = this._getLabelMap(), statusMap = this._getStatusMap();
            return labelMap[statusMap[value]];
        },
        getStatusClass: function (value) {
            var statusMap = this._getStatusMap();
            return this.gemColors[statusMap[value]];
        },
        serializeData: function () {
            var model = this.model, value = this.formatter.fromRaw(model.get(this.column.get('name')), model).toString(), statusClass = this.getStatusClass(value), label = this.getLabel(value, this.column);
            return {
                statusClass: statusClass,
                label: label
            };
        }
    });
});
define('common-modules/grid/cells/status-enabled-cell', ['common-modules/grid/cells/status-cell'], function (StatusCell) {
    'use strict';
    return StatusCell.extend({
        className: 'status-enabled-cell',
        labelMap: {
            green: l('Enabled'),
            grey: l('Disabled')
        },
        initialize: function (options) {
            StatusCell.prototype.initialize.apply(this, arguments);
            var compact = options.column.get('compact') === true;
            this.labelMap.green = compact ? '' : this.labelMap.green;
            this.labelMap.grey = compact ? '' : this.labelMap.grey;
        },
        statusMap: {
            true: 'green',
            false: 'grey'
        }
    });
});
define('common-modules/grid/cells/templates/summary-cell.tpl.html', [], function () {
    return '<h4 class="adb-summary--title summary--title"><%- title %></h4>\n<div class="adb-summary--details"><%- details %></div>\n';
});
define('common-modules/grid/cells/summary-cell', [
    'backgrid',
    'common-modules/grid/cells/templates/summary-cell.tpl.html'
], function (Backgrid, template) {
    'use strict';
    return Backgrid.Cell.extend({
        className: 'adb-summary',
        template: _.template(template),
        render: function () {
            var summary = this.formatter.fromRaw(this.model.get(this.column.get('name')), this.model);
            this.$el.html(this.template({
                title: summary.title,
                details: summary.details
            }));
            return this;
        }
    });
});
define('common-modules/grid/cells/templates/toggle-cell.tpl.html', [], function () {
    return '<label for="<%- cid %>" class="adb-toggle">\n\t<input class="adb-toggle--input js-toggle-input" id="<%- cid %>" value="<%- value %>" type="checkbox" name="<%- name %>">\n\t<span class="adb-toggle--control"></span>\n\t<span class="adb-toggle--value"><%- label %></span>\n</label>\n';
});
define('common-modules/grid/cells/toggle-cell', [
    'common-modules/grid/cells/checkbox-cell',
    'common-modules/grid/cells/templates/toggle-cell.tpl.html'
], function (CheckboxCell, template) {
    'use strict';
    return CheckboxCell.extend({
        className: 'toggle-cell',
        template: _.template(template),
        serializeData: function () {
            return _.extend(CheckboxCell.prototype.serializeData.apply(this, arguments), {
                label: this.column.get('toggleLabel') || l('Enable'),
                cid: _.uniqueId()
            });
        }
    });
});
define('common-modules/grid/rows/clickable-row', ['backgrid'], function (Backgrid) {
    'use strict';
    return Backgrid.Row.extend({
        events: { click: 'onClick' },
        onClick: function () {
            this.model.trigger('backgrid:row:click', this.model);
        }
    });
});
define('common-modules/grid/no-header-grid', ['common-modules/grid/grid'], function (Grid) {
    'use strict';
    return Grid.extend({ header: null });
});
define('common-modules/layouts/templates/sidebar-left.tpl.html', [], function () {
    return '<div class="js-layout-sidebar adb-layout-sidebar adb-layout-column__first"></div>\n<div class="js-layout-content adb-layout-content"></div>\n';
});
define('common-modules/layouts/sidebar-left', ['common-modules/layouts/templates/sidebar-left.tpl.html'], function (template) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template(template),
        regions: {
            content: '.js-layout-content',
            sidebar: '.js-layout-sidebar'
        }
    });
});
define('common-modules/layouts/templates/sidebar-content.tpl.html', [], function () {
    return '<div class="js-layout-sidebar adb-layout-sidebar"></div>\n<div class="js-layout-content adb-layout-content"></div>\n\n';
});
define('common-modules/layouts/sidebar-content', ['common-modules/layouts/templates/sidebar-content.tpl.html'], function (template) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template(template),
        className: 'adb-layout-row adb-layout-default',
        regions: {
            sidebar: '.js-layout-sidebar',
            content: '.js-layout-content'
        }
    });
});
define('common-modules/layouts/templates/sidebar-right.tpl.html', [], function () {
    return '<div class="js-layout-content adb-layout-content adb-layout-column__first"></div>\n<div class="js-layout-sidebar adb-layout-sidebar"></div>\n';
});
define('common-modules/layouts/sidebar-right', ['common-modules/layouts/templates/sidebar-right.tpl.html'], function (template) {
    'use strict';
    return Marionette.Layout.extend({
        template: _.template(template),
        regions: {
            content: '.js-layout-content',
            sidebar: '.js-layout-sidebar'
        }
    });
});
define('common-modules/loading/PageSpinner', ['common-modules/behaviors/loading'], function (LoadingBehavior) {
    'use strict';
    return Marionette.ItemView.extend({
        className: 'adb-styled',
        template: _.template(''),
        behaviors: {
            LoadingBehavior: {
                behaviorClass: LoadingBehavior,
                size: LoadingBehavior.SIZE.LARGE
            }
        },
        dataEvents: {
            request: '_onRequest',
            sync: '_onResponse',
            error: '_onResponse'
        },
        initialize: function (options) {
            if (this.model) {
                Marionette.bindEntityEvents(this, this.model, this.dataEvents);
            }
            if (options.collection) {
                this.collection = options.collection;
                Marionette.bindEntityEvents(this, this.collection, this.dataEvents);
            }
        },
        onRender: function () {
            $('body').append(this.$el);
        },
        _onRequest: function () {
            this.triggerMethod('show:loading');
        },
        _onResponse: function () {
            this.triggerMethod('hide:loading');
        }
    }, {
        loadingOn: function (options) {
            var view = new this(options);
            return view.render();
        }
    });
});
define('common-modules/models/relational-model', [], function () {
    'use strict';
    return function (model, attrs, options) {
        model._initRelations = function (opts) {
            if (!this.relations) {
                throw new Error('Your relational model should have relations.');
            }
            this.relations = _.result(this, 'relations');
            opts = opts || {};
            _(this._getRelations()).each(function (relation) {
                this[relation.relationName] = opts[relation.relationName] || new relation.Class(null, opts);
            }, this);
        };
        model._getRelation = function (value, key) {
            var defaultRelation = {
                relationName: key,
                attributeName: key,
                includeWhenEmpty: false
            };
            if (!_.isFunction(value) && _.isObject(value)) {
                return _.extend(defaultRelation, value);
            }
            return _.extend(defaultRelation, { Class: value });
        };
        model._getRelations = function () {
            return _(this.relations).map(this._getRelation, this);
        };
        model._parseRelations = function (response) {
            if (!response) {
                return null;
            }
            var relations = this._getRelations();
            _(relations).each(function (relation) {
                if (response[relation.attributeName]) {
                    var object = this[relation.relationName];
                    if (object instanceof Backbone.Collection) {
                        object.reset(response[relation.attributeName], { parse: true });
                    } else {
                        object.set(object.parse(response[relation.attributeName]));
                    }
                }
            }, this);
            var relationNames = _.pluck(relations, 'attributeName');
            return _.omit.apply(_, [response].concat(relationNames));
        };
        model.hasNonEmptyRelation = function (relation) {
            return !!_.keys(this[relation].toJSON()).length;
        };
        var originalToJSON = model.toJSON;
        model.toJSON = function () {
            var data = originalToJSON.apply(this, arguments);
            _(this._getRelations()).each(function (relation) {
                var json = this[relation.relationName].toJSON();
                if (!_.isEmpty(json) || !!relation.includeWhenEmpty) {
                    data[relation.attributeName] = json;
                }
            }, this);
            return data;
        };
        if (options && options.parse) {
            attrs = model.parse(attrs, options);
        }
        var originalParse = model.parse;
        model.parse = function (response) {
            response = originalParse.call(this, response);
            return this._parseRelations(response);
        };
        model._initRelations(options);
        attrs = model._parseRelations(attrs || {});
        model.set(attrs, options);
    };
});
define('common-modules/navigation/templates/navigation.tpl.html', [], function () {
    return '<div class="adb-sidebar">\n\t<div class="adb-container">\n\t\t<nav class="adb-stack">\n\t\t\t<% _.each(navItems, function(navItem, index, list) { %>\n\t\t\t<div class="adb-stack--item <%- extraClassName(navItem.className) %>">\n\t\t\t\t<a class="adb-link__nav adb-stack--item_content <%- isSelected(navItem.selected) %> <%- extraClassName(navItem.className) %>" href="<%- navItem.link %>"><%- navItem.listItem %></a>\n\t\t\t</div>\n\t\t\t<% }) %>\n\t\t</nav>\n\t</div>\n</div>\n';
});
define('common-baseObjects/BaseView', [], function () {
    'use strict';
    return Marionette.View.extend({
        initialize: function (options) {
            options = options || {};
            _.extend(this, options);
            this.events = _.extend(this.originalEvents, this.additionalEvents, this.events);
        },
        originalEvents: {},
        additionalEvents: {},
        events: {},
        extraData: {},
        model: {},
        collection: [],
        onClose: function () {
            this.undelegateEvents();
            $(this.el).clear();
        }
    });
});
define('common-modules/navigation/views/navigationView', [
    'common-modules/navigation/templates/navigation.tpl.html',
    'common-baseObjects/BaseView'
], function (template, BaseView) {
    'use strict';
    var navView = BaseView.extend({
        initialize: function (config) {
            config = config || {};
            _.extend(this, config);
        },
        template: _.template(template),
        templateHelpers: {
            isSelected: function (isSelectedItem) {
                return isSelectedItem ? 'adb-is-selected' : '';
            },
            extraClassName: function (className) {
                return className || '';
            }
        },
        render: function () {
            this.$el.html(this.template(this.model.toJSON()));
            return this;
        }
    }, Marionette.ItemView);
    return navView;
});
define('common-baseObjects/BaseModel', [], function () {
    'use strict';
    return Backbone.Model.extend({
        initialize: function (config) {
            config = config || {};
            _.extend(this, config);
        }
    });
});
define('common-baseObjects/BaseController', ['common-baseObjects/BaseModel'], function (BaseModel) {
    'use strict';
    return Marionette.Controller.extend({
        initialize: function (options) {
            options = options || {};
            _.extend(this, options);
        },
        view: {},
        model: new BaseModel(),
        collection: []
    });
});
define('common-modules/navigation/navigation', [
    'common-baseObjects/BaseController',
    'common-modules/navigation/views/navigationView'
], function (BaseController, NavigationView) {
    'use strict';
    return function (Module, App, Backbone, Marionette, $, _, region, data) {
        Module.on('start', function () {
            region.show(Module.controller.view);
        });
        Module.addInitializer(function (options) {
            options = options || {};
            _.extend(this, options);
            Module.controller = data.controller ? data.controller : new BaseController({
                view: new NavigationView(data.view ? data.view : {}),
                region: region
            });
        });
    };
});
define('common-modules/navigations/editor/templates/editor.tpl.html', [], function () {
    return '<div class="adb-editor_nav--content adb-layout-default">\n\t<div class="adb-editor_nav--items">\n\t\t<div class="adb-editor_nav--item js-left-buttons"></div>\n\t\t<div class="adb-editor_nav--item js-middle-buttons"></div>\n\t\t<div class="adb-editor_nav--item js-right-buttons"></div>\n\t</div>\n</div>\n';
});
define('common-modules/navigations/editor/editor', ['common-modules/navigations/editor/templates/editor.tpl.html'], function (template) {
    'use strict';
    return Marionette.Layout.extend({
        tagName: 'nav',
        className: 'adb-editor_nav',
        attributes: { 'data-component': 'layout-editor-toolbar' },
        template: _.template(template),
        regions: {
            leftContainer: '.js-left-buttons',
            middleContainer: '.js-middle-buttons',
            rightContainer: '.js-right-buttons'
        },
        initialize: function (options) {
            options = options || {};
            this.leftToolbar = options.leftToolbar;
            this.middleToolbar = options.middleToolbar;
            this.rightToolbar = options.rightToolbar;
        },
        onRender: function () {
            this.renderToolbar(this.leftToolbar, this.leftContainer);
            this.renderToolbar(this.middleToolbar, this.middleContainer);
            this.renderToolbar(this.rightToolbar, this.rightContainer);
        },
        renderToolbar: function (toolbar, container) {
            if (toolbar) {
                container.show(toolbar);
                this.listenTo(toolbar, 'click', _.bind(this.onButtonClick, this));
            }
        },
        onButtonClick: function (value) {
            this.trigger('click', value);
            this.trigger('click:' + value);
        }
    });
});
define('common-modules/navigations/footer/views/footer-dropdown', [
    'common-modules/forms/views/select-input',
    'common-modules/buttons/button',
    'common-modules/utils/bubble-event'
], function (SelectInput, Button, bubbleEvent) {
    'use strict';
    return Marionette.Layout.extend({
        className: 'adb-page_footer--content_item',
        template: _.template(''),
        initialize: function (options) {
            this.value = options.value;
        },
        onRender: function () {
            if (!this.collection) {
                throw new Error('A "collection" property must be defined on a footer model with DROPDOWN type');
            }
            this.selectInput = new SelectInput({
                collection: this.collection,
                value: this.value,
                type: Button.TYPES.SECRET,
                size: Button.SIZES.SMALL
            });
            this.$el.append(this.selectInput.render().el);
            this.$el.addClass(this.model.get('linkClasses'));
            this.listenTo(this.selectInput, 'change', bubbleEvent('change'));
        },
        onClose: function () {
            this.selectInput.close();
        }
    });
});
define('common-modules/navigations/footer/views/footer-nav-item', ['common-modules/navigations/views/base-navigation'], function (Base) {
    'use strict';
    var BaseProto = Base.BaseNavItem.prototype;
    return Base.BaseNavItem.extend({
        className: 'adb-footer_nav--item',
        template: _.template('<a class="adb-footer_nav--link"><%=label%></a>'),
        initialize: function (options) {
            BaseProto.initialize.apply(this, arguments);
            this.target = options.target;
        },
        getTarget: function () {
            return this.target || BaseProto.getTarget.apply(this, arguments);
        },
        getLink: function () {
            return this.$('> a');
        }
    });
});
define('common-modules/navigations/footer/views/footer-text', [], function () {
    'use strict';
    return Marionette.ItemView.extend({
        tagName: 'span',
        className: 'adb-page_footer--content_item',
        template: _.template('<%=label%>'),
        onRender: function () {
            this.$el.addClass(this.model.get('linkClasses'));
        }
    });
});
define('common-modules/navigations/footer/views/footer-nav', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/footer/views/footer-nav-item'
], function (Base, FooterNavItemView) {
    'use strict';
    return Base.BaseNavigation.extend({
        className: 'adb-footer_nav adb-page_footer--content_item',
        template: _.template('<ul classname="adb-footer_nav--items"></ul>'),
        activeClass: null,
        itemView: FooterNavItemView,
        itemViewOptions: function () {
            var options = {};
            options.target = this.model.get('openInNewTabs') ? '_blank' : '';
            return options;
        },
        selectNavItem: function (event, itemView, options) {
            if (!itemView)
                return;
            if (!options.silent) {
                this.trigger('change', itemView.model);
            }
        },
        onRender: function () {
            this.$el.addClass(this.model.get('linkClasses'));
        }
    });
});
define('common-modules/navigations/footer/footer', [
    'common-modules/navigations/footer/views/footer-text',
    'common-modules/navigations/footer/views/footer-dropdown',
    'common-modules/navigations/footer/views/footer-nav'
], function (FooterTextItem, FooterDropdownItem, FooterNavItem) {
    'use strict';
    return Marionette.CollectionView.extend({
        className: 'adb-page_footer--content adb-layout-default',
        template: _.template(''),
        itemViewOptions: function (model) {
            var options = {};
            if (model.get('collection')) {
                options.collection = model.get('collection');
            }
            options.value = model.get('value');
            options.openInNewTabs = !!model.get('openInNewTabs');
            return options;
        },
        getItemView: function (model) {
            switch (model.get('type')) {
            case this.constructor.TYPES.TEXT:
                return FooterTextItem;
            case this.constructor.TYPES.DROPDOWN:
                return FooterDropdownItem;
            default:
                return FooterNavItem;
            }
        },
        itemEvents: { change: 'onItemSelected' },
        onItemSelected: function (event, itemView, model) {
            var value = model;
            if (model instanceof Backbone.Model && model.get('value')) {
                value = model.get('value');
            }
            this.trigger('change', value);
        },
        onShow: function () {
            this.$('.adb-page_footer--content_item:not(:last-child)').after(' ');
        }
    }, {
        TYPES: {
            TEXT: 'text',
            NAVIGATION: 'navigation',
            DROPDOWN: 'dropdown'
        }
    });
});
define('common-modules/navigations/header/primary/views/link-item', ['common-modules/navigations/views/base-navigation'], function (Base) {
    'use strict';
    return Base.BaseNavItem.extend({
        className: 'adb-primary_nav--item',
        template: _.template('<a class="adb-primary_nav--link"><%- label %></a>'),
        getLink: function () {
            return this.$('> a');
        }
    });
});
define('common-modules/navigations/header/masthead/templates/link-item.tpl.html', [], function () {
    return '<a class="masthead-nav-link masthead-nav-content"><%- label %></a>\n';
});
define('common-modules/navigations/header/masthead/views/link-item', [
    'common-modules/navigations/header/primary/views/link-item',
    'common-modules/navigations/header/masthead/templates/link-item.tpl.html'
], function (PrimaryLinkItem, template) {
    'use strict';
    return PrimaryLinkItem.extend({
        className: 'masthead-nav-item',
        template: _.template(template)
    });
});
define('common-modules/navigations/header/primary/templates/logo-item.tpl.html', [], function () {
    return '<a class="adb-primary_nav--link">\n\t<span class="adb-primary_nav--logo"><%- label %></span>\n</a>\n';
});
define('common-modules/navigations/header/primary/templates/custom-logo-item.tpl.html', [], function () {
    return '<a class="adb-primary_nav--link">\n\t<img class="adb-primary_nav--image" src="<%-logoUrl%>" alt="<%- label %>">\n</a>\n';
});
define('common-modules/navigations/header/primary/views/logo-item', [
    'common-modules/navigations/header/primary/views/link-item',
    'common-modules/navigations/header/primary/templates/logo-item.tpl.html',
    'common-modules/navigations/header/primary/templates/custom-logo-item.tpl.html'
], function (LinkItem, defaultTemplate, customLogoTemplate) {
    'use strict';
    return LinkItem.extend({
        initialize: function () {
            var template = this.model.get('logoUrl') ? customLogoTemplate : defaultTemplate;
            this.template = _.template(template);
        }
    });
});
define('common-modules/navigations/header/masthead/templates/logo-item.tpl.html', [], function () {
    return '<a class="masthead-nav-link">\n\t<span class="masthead-nav-logo"><%- label %></span>\n</a>\n';
});
define('common-modules/navigations/header/masthead/views/logo-item', [
    'common-modules/navigations/header/primary/views/logo-item',
    'common-modules/navigations/header/masthead/templates/logo-item.tpl.html'
], function (PrimaryLogoItem, template) {
    'use strict';
    return PrimaryLogoItem.extend({
        className: 'masthead-nav-item',
        template: _.template(template),
        initialize: function () {
        }
    });
});
define('common-modules/navigations/header/masthead/header-masthead', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/header/masthead/views/link-item',
    'common-modules/navigations/header/masthead/views/logo-item'
], function (Base, LinkItem, LogoItem) {
    'use strict';
    return Base.BaseNavigation.extend({
        className: 'masthead-nav',
        getItemView: function (model) {
            if (model.get('type') === 'logo') {
                return LogoItem;
            }
            return LinkItem;
        }
    });
});
define('common-modules/navigations/header/primary/views/dropdown-item', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/header/primary/views/link-item',
    'common-modules/buttons/dropdown-button',
    'common-modules/utils/bubble-event'
], function (Base, LinkItem, DropdownButton, bubbleEvent) {
    'use strict';
    return LinkItem.extend({
        template: _.template(''),
        dropDownTemplate: _.template('<a class="adb-primary_nav--link js-menu-trigger adb-context_menu--trigger" href="javascript:;"><%-label%></a>' + '<div class="js-dropdown-container"></div>'),
        initialize: function (options) {
            this.options = options;
        },
        getLink: function () {
            return this.$('> menu > a');
        },
        onRender: function () {
            Base.BaseNavItem.prototype.onRender.apply(this, arguments);
            var dropdown = this.dropdown = new DropdownButton(_.extend({ template: this.dropDownTemplate }, this.options));
            this.$el.html(dropdown.render().el);
            this.listenTo(dropdown, 'change', bubbleEvent('dropdown:change', this));
        },
        onClose: function () {
            this.dropdown.close();
        }
    });
});
define('common-modules/navigations/header/primary/templates/text-item.tpl.html', [], function () {
    return '<span class="adb-primary_nav--link"><%- label %></span>\n';
});
define('common-modules/navigations/header/primary/views/text-item', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/header/primary/templates/text-item.tpl.html'
], function (Base, template) {
    'use strict';
    return Base.BaseNavItem.extend({
        className: 'adb-primary_nav--item adb-primary_nav--text',
        template: _.template(template)
    });
});
define('common-modules/navigations/header/primary/header-navigation-primary', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/header/primary/views/link-item',
    'common-modules/navigations/header/primary/views/text-item',
    'common-modules/navigations/header/primary/views/logo-item',
    'common-modules/navigations/header/primary/views/dropdown-item',
    'common-modules/buttons/dropdown-button',
    'common-modules/utils/bubble-event'
], function (Base, LinkItem, TextItem, LogoItem, DropdownItem, DropdownButton, bubbleEvent) {
    'use strict';
    var InnerNav;
    var Navigation = Base.BaseNavigation.extend({
        className: 'adb-primary_nav',
        template: _.template('<ul class="adb-primary_nav--items adb-layout-default"></ul>'),
        activeClass: 'adb-is-selected',
        dropdownOpenClass: 'adb-is-active',
        navItemTypes: {
            logo: function (options) {
                return new LogoItem(options);
            },
            dropdown: function (options, placement) {
                var view = new DropdownItem(_.extend({ placement: placement }, options.model.pick('collection', 'label'), options));
                this.listenTo(view, 'dropdown:change', bubbleEvent('dropdown:change', this));
                this.listenTo(view, 'dropdown:change', _.bind(this.selectDropdown, this, view));
                return view;
            },
            text: function (options) {
                return new TextItem(options);
            },
            basic: function (options) {
                return new LinkItem(options);
            },
            navigation: function (options) {
                return new InnerNav({
                    className: options.model.get('linkClasses') || '',
                    collection: options.model.get('collection')
                });
            },
            view: function (options) {
                var View = options.model.get('viewClass');
                return new View(options);
            }
        },
        buildItemView: function (model, ItemViewType, itemViewOptions) {
            var options = _.extend({ model: model }, itemViewOptions), placement = DropdownButton.PLACEMENTS.BOTTOM_LEFT;
            if (model.get('position') === this.constructor.POSITION.RIGHT) {
                var linkClasses = model.get('linkClasses') || '';
                linkClasses = _(linkClasses.split(' ')).union(['adb-primary_nav--item__right']);
                linkClasses = linkClasses.join(' ');
                model.set('linkClasses', linkClasses, { silent: true });
                placement = DropdownButton.PLACEMENTS.BOTTOM_RIGHT;
            }
            return this.navItemTypes[model.get('type') || 'basic'].call(this, options, placement);
        },
        selectNavItem: function (event, itemView, options) {
            options = options || {};
            options.changeOnActive = true;
            if (itemView instanceof DropdownItem) {
                itemView.getLink().addClass(this.dropdownOpenClass);
                return;
            }
            Base.BaseNavigation.prototype.selectNavItem.apply(this, arguments);
        },
        selectDropdown: function (itemView) {
            this.clearSelection();
            itemView.getLink().addClass(this.activeClass);
        }
    }, { POSITION: { RIGHT: 'right' } });
    InnerNav = Navigation.extend({
        tagName: 'li',
        template: _.template('<ul></ul>')
    });
    return Navigation;
});
define('common-modules/navigations/header/secondary/views/link-item', ['common-modules/navigations/views/base-navigation'], function (Base) {
    'use strict';
    return Base.BaseNavItem.extend({
        className: 'adb-secondary_nav--item',
        template: _.template('<a class="adb-secondary_nav--link"><%- label %></a>'),
        events: { 'click a': 'onClick' },
        initialize: function (options) {
            this.activeClass = options.activeClass;
            this.followActiveUrl = this.model.get('followActiveUrl') !== false;
        },
        onRender: function () {
            this.getLink().addClass(this.model.get('anchorClasses'));
            Base.BaseNavItem.prototype.onRender.apply(this, arguments);
        },
        getLink: function () {
            return this.$('> a');
        },
        onClick: function (e) {
            if (this.getLink().hasClass(this.activeClass) && !this.followActiveUrl) {
                e.preventDefault();
            }
        }
    });
});
define('common-modules/navigations/header/secondary/views/dropdown-item', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/header/secondary/views/link-item',
    'common-modules/buttons/dropdown-button',
    'common-modules/utils/bubble-event'
], function (Base, LinkItem, DropdownButton, bubbleEvent) {
    'use strict';
    return LinkItem.extend({
        template: _.template(''),
        dropDownTemplate: _.template('<a class="adb-secondary_nav--link js-menu-trigger adb-context_menu--trigger" href="javascript:;"><%-label%></a>' + '<div class="js-dropdown-container"></div>'),
        initialize: function (options) {
            this.options = options;
        },
        getLink: function () {
            return this.$('> menu > a');
        },
        onRender: function () {
            Base.BaseNavItem.prototype.onRender.apply(this, arguments);
            var dropdown = this.dropdown = new DropdownButton(_.extend({ template: this.dropDownTemplate }, this.options));
            this.$el.html(dropdown.render().el);
            this.listenTo(dropdown, 'change', bubbleEvent('dropdown:change', this));
        },
        onClose: function () {
            this.dropdown.close();
        }
    });
});
define('common-modules/navigations/header/secondary/views/header-item', ['common-modules/navigations/header/secondary/views/link-item'], function (LinkItem) {
    'use strict';
    return LinkItem.extend({
        className: 'adb-secondary_nav--item adb-secondary_nav--item__heading',
        template: _.template('<span class="adb-secondary_nav--content"><%- label %></span>')
    });
});
define('common-modules/navigations/header/secondary/views/search-item', [
    'common-modules/navigations/header/secondary/views/link-item',
    'common-modules/forms/views/search-input'
], function (LinkItem, SearchInput) {
    'use strict';
    return LinkItem.extend({
        className: 'adb-secondary_nav--item adb-secondary_nav--search',
        template: _.template(''),
        triggers: {},
        onRender: function () {
            LinkItem.prototype.onRender.apply(this, arguments);
            this.search = new SearchInput(this.model.get('searchOptions') || {});
            this.$el.html(this.search.render().el);
        },
        setVal: function (val) {
            this.search.setVal(val);
        },
        setPlaceholder: function (placeholder) {
            this.search.setPlaceholder(placeholder);
        },
        onClose: function () {
            this.search.close();
        }
    });
});
define('common-modules/navigations/header/secondary/templates/header-navigation-secondary.tpl.html', [], function () {
    return '<ul class="adb-secondary_nav--items adb-layout-default js-navigation-container"></ul>\n';
});
define('common-modules/navigations/header/secondary/header-navigation-secondary', [
    'common-modules/navigations/header/secondary/templates/header-navigation-secondary.tpl.html',
    'common-modules/navigations/header/secondary/views/link-item',
    'common-modules/navigations/header/secondary/views/header-item',
    'common-modules/navigations/header/secondary/views/search-item',
    'common-modules/navigations/header/secondary/views/dropdown-item',
    'common-modules/buttons/dropdown-button',
    'common-modules/navigations/views/base-navigation'
], function (template, LinkItem, HeaderItem, SearchItem, DropdownItem, DropdownButton, Base) {
    'use strict';
    return Base.BaseNavigation.extend({
        className: 'adb-secondary_nav',
        activeClass: 'adb-is-selected',
        template: _.template(template),
        itemViewOptions: function () {
            return { activeClass: this.activeClass };
        },
        ui: {
            searchContainer: '.js-search-container',
            navigationContainer: '.js-navigation-container'
        },
        getItemView: function (model) {
            switch (model.get('type')) {
            case this.constructor.TYPES.HEADER:
                return HeaderItem;
            case this.constructor.TYPES.SEARCH:
                return SearchItem;
            case this.constructor.TYPES.DROPDOWN:
                return DropdownItem;
            default:
                return LinkItem;
            }
        },
        buildItemView: function (model, ItemViewType, itemViewOptions) {
            var options = _.extend({ model: model }, itemViewOptions);
            return model.get('type') === this.constructor.TYPES.DROPDOWN ? this.buildDropdown(model, options) : new ItemViewType(options);
        },
        buildDropdown: function (model, options) {
            if (model.get('position') === this.constructor.POSITIONS.RIGHT) {
                var linkClasses = model.get('linkClasses') || '';
                linkClasses = _(linkClasses.split(' ')).union(['adb-primary_nav--item__right']);
                linkClasses = linkClasses.join(' ');
                model.set('linkClasses', linkClasses, { silent: true });
            }
            var view = new DropdownItem(_.extend(options, model.pick('collection', 'label', 'placement')));
            this.listenTo(view, 'dropdown:change', _.bind(this.trigger, this, 'dropdown:change'));
            this.listenTo(view, 'dropdown:change', _.bind(this.selectDropdown, this, view));
            return view;
        },
        selectDropdown: function (itemView) {
            this.clearSelection();
            itemView.getLink().addClass(this.activeClass);
        },
        selectNavItem: function (event, itemView, options) {
            if (itemView instanceof HeaderItem) {
                return;
            }
            options = options || {};
            options.changeOnActive = true;
            if (itemView instanceof DropdownItem) {
                return;
            }
            Base.BaseNavigation.prototype.selectNavItem.apply(this, arguments);
        },
        selectFirst: function (options) {
            var view = this.children.first();
            if (view instanceof HeaderItem) {
                view = _(this.children.rest()).first();
            }
            this.selectNavItem(null, view, options);
        }
    }, {
        TYPES: {
            SEARCH: 'search',
            HEADER: 'header',
            LINK: 'link',
            DROPDOWN: 'dropdown'
        },
        POSITIONS: { RIGHT: 'right' }
    });
});
define('common-modules/navigations/header/tertiary/views/link-item', ['common-modules/navigations/header/secondary/views/link-item'], function (LinkItem) {
    'use strict';
    return LinkItem.extend({
        className: 'adb-tertiary_nav--item',
        template: _.template('<a class="adb-tertiary_nav--link"><%- label %></a>'),
        getLink: function () {
            return this.$el;
        }
    });
});
define('common-modules/navigations/header/tertiary/templates/header-navigation-tertiary.tpl.html', [], function () {
    return '<ul class="adb-tertiary_nav--items adb-layout-default js-navigation-container"></ul>\n';
});
define('common-modules/navigations/header/tertiary/header-navigation-tertiary', [
    'common-modules/navigations/header/secondary/header-navigation-secondary',
    'common-modules/navigations/header/tertiary/views/link-item',
    'common-modules/navigations/header/tertiary/templates/header-navigation-tertiary.tpl.html'
], function (SecondaryNav, LinkItem, template) {
    'use strict';
    return SecondaryNav.extend({
        className: 'adb-tertiary_nav',
        template: _.template(template),
        getItemView: function () {
            return LinkItem;
        }
    });
});
define('common-modules/utils/hateoas-parse', [], function () {
    'use strict';
    return {
        forCollection: function (response) {
            this.isHATEOS = !!response && _.isArray(response.content);
            if (this.isHATEOS) {
                this.properties = _.omit(response, 'content');
                return response.content;
            }
            return response;
        },
        forModel: function (response) {
            this.isHATEOAS = !!response && _.isArray(response.links);
            if (this.isHATEOAS) {
                this.links = response.links;
                return _.omit(response, 'links');
            }
            return response;
        }
    };
});
define('common-modules/navigations/models/paged-collection', ['common-modules/utils/hateoas-parse'], function (parseHATEOAS) {
    'use strict';
    return Backbone.Collection.extend({
        fetchOptions: {},
        initialize: function (models, options) {
            options = options || {};
            this.isPaged = options.isPaged !== false;
            this.pageSize = options.pageSize || this.constructor.DEFAULT_PAGE_SIZE;
            this.currentIndex = options.currentIndex || 1;
            this.params = options.params || {};
            this.fetchOptions = options.fetchOptions || this.fetchOptions;
            this.listenTo(this, 'sync', this.onSync);
        },
        onLoadComplete: function () {
            return this.onSync.apply(this, arguments);
        },
        onSync: function (collection, response, options) {
            if (!(collection instanceof Backbone.Collection)) {
                return;
            }
            var totalCount = this.parseTotalCount(response, options);
            if (!_.isUndefined(totalCount)) {
                this.totalCount = totalCount;
                this.updatePage();
            }
            this.trigger('count:total', totalCount || this.getTotalCount());
        },
        parse: parseHATEOAS.forCollection,
        updatePage: function () {
            var totalPages = this.getTotalPages();
            if (this.currentIndex > totalPages) {
                this.currentIndex = totalPages;
                this.refreshPage();
            }
            this.trigger('change:index', this.currentIndex);
        },
        getTotalCount: function () {
            return this.totalCount || 0;
        },
        setPageSize: function (size) {
            this.pageSize = size;
            return this.getFirstPage();
        },
        getTotalPages: function () {
            if (this.isPaged) {
                var pages = Math.ceil(this.getTotalCount() / this.pageSize);
                return pages > 0 ? pages : 1;
            }
            return 1;
        },
        hasMultiplePages: function () {
            return this.getTotalPages() > 1;
        },
        setPageIndex: function (index, options) {
            options = options || { force: false };
            if (!options.force && (index > this.getTotalPages() || index < 0) && index !== 1) {
                throw new Error('Requested page index is out of bounds');
            }
            this.currentIndex = index;
        },
        setParam: function (param, value) {
            if (_.isNull(value)) {
                delete this.params[param];
            } else {
                this.params[param] = value;
            }
        },
        getParam: function (param) {
            return this.params[param];
        },
        hasNextPage: function () {
            return this.currentIndex < this.getTotalPages();
        },
        hasPreviousPage: function () {
            return this.currentIndex > 1;
        },
        getFirstPage: function (options) {
            return this.getPage(1, options);
        },
        getLastPage: function (options) {
            return this.getPage(this.getTotalPages(), options);
        },
        getNextPage: function (options) {
            if (this.hasNextPage()) {
                return this.getPage(this.currentIndex + 1, options);
            }
        },
        getPreviousPage: function (options) {
            if (this.hasPreviousPage()) {
                return this.getPage(this.currentIndex - 1, options);
            }
        },
        refreshPage: function (options) {
            return this.getPage(this.currentIndex, options);
        },
        getPage: function (index, options) {
            var fetchOptions = _.result(this, 'fetchOptions');
            var pendingRequest = this.currentFetch && _.contains([
                1,
                2,
                3
            ], this.currentFetch.readyState);
            options = _.extend({}, fetchOptions, options);
            if (pendingRequest) {
                this.currentFetch.abort();
            }
            if (!this.isPaged) {
                this.currentFetch = this.fetch();
                return this.currentFetch;
            }
            this.setPageIndex(index, options);
            options.data = _.extend(this.getPagingData(), fetchOptions.data, options.data, this.params);
            options.reset = true;
            this.currentFetch = this.fetch(options);
            return this.currentFetch;
        },
        hasFilters: function () {
            var params = _(this.params).chain().keys().difference(this.defaultParams || []).value();
            return !_.isEmpty(params);
        },
        getDownloadCSVUrl: function () {
            var fetchOptions = _.result(this, 'fetchOptions');
            var params = _.extend({
                page: 0,
                size: this.getTotalCount()
            }, fetchOptions.data, this.params);
            var url = _.result(this, 'url');
            if (url.indexOf('?') >= 0) {
                url = url.replace('?', '.csv?');
            }
            var separator = url.indexOf('?') >= 0 ? '&' : '.csv?';
            return url + separator + $.param(params, true);
        },
        getPagingData: function () {
            return {
                page: this.currentIndex - 1,
                size: this.pageSize
            };
        },
        parseTotalCount: function (response) {
            if (!response || !response.page || _.isUndefined(response.page.totalElements)) {
                return;
            }
            return response.page.totalElements;
        }
    }, { DEFAULT_PAGE_SIZE: 6 });
});
define('common-modules/navigations/models/client-paged-collection', ['common-modules/navigations/models/paged-collection'], function (PagedCollection) {
    'use strict';
    var DEFAULT_PAGE_SIZE = 6;
    return PagedCollection.extend({
        initialize: function (models, options) {
            options = options || {};
            this.pageSize = options.pageSize || DEFAULT_PAGE_SIZE;
            this.currentIndex = options.currentIndex || 1;
            this.params = options.params || {};
            this.loaded = options.loaded || false;
            this.listenTo(this, 'sync', this.onSync);
            this.filters = {};
            this.resetModels(models);
        },
        onLoadComplete: function () {
        },
        onSync: function (collection) {
            if (!(collection instanceof Backbone.Collection)) {
                return;
            }
            this.resetModels(this.models);
            this.resetCollection();
        },
        resetCollection: function () {
            this.currentIndex = 1;
            this.applyFilters();
            this.updateCollection(1);
            this.updatePagination();
        },
        updatePagination: function () {
            this.trigger('count:total', this.getTotalCount());
            this.currentIndex = 1;
            this.trigger('change:index', this.currentIndex);
        },
        resetModels: function (models) {
            this.originalCollection = new Backbone.Collection(models);
            this.filteredCollection = new Backbone.Collection(models);
        },
        addFilter: function (filterName, filterObj) {
            this.filters[filterName] = filterObj;
        },
        removeFilter: function (filterName) {
            delete this.filters[filterName];
        },
        getTotalCount: function () {
            return this.getFilteredModels().length || 0;
        },
        getFilteredModels: function () {
            return this.filteredCollection.models;
        },
        getTotalPages: function () {
            var pages = Math.ceil(this.getTotalCount() / this.pageSize);
            return pages > 0 ? pages : 1;
        },
        getPage: function (index, options) {
            options = options || {};
            if (!this.loaded && this.isEmpty()) {
                this.loaded = true;
                options.data = this.params;
                return this.fetch(options);
            }
            if ((index > this.getTotalPages() || index < 0) && index !== 1) {
                throw new Error('Requested page index is out of bounds');
            }
            this.currentIndex = index;
            this.trigger('change:index', this.currentIndex);
            return this.updateCollection(index);
        },
        setParam: function () {
            PagedCollection.prototype.setParam.apply(this, arguments);
            this.applyFilters();
        },
        updateCollection: function (index) {
            var begin = (index - 1) * this.pageSize;
            var end = (index - 1) * this.pageSize + this.pageSize;
            if (end > this.getFilteredModels().length) {
                end = this.getFilteredModels().length;
            }
            this.reset(this.getFilteredModels().slice(begin, end));
        },
        applyFilters: function () {
            var models = this.originalCollection.models;
            _.each(this.params, _.bind(function (value, param) {
                if (this.filters.hasOwnProperty(param)) {
                    var filtersFn = this.filters[param];
                    models = _.filter(models, function (model) {
                        return filtersFn(model, value);
                    });
                }
            }, this));
            this.filteredCollection.reset(models);
            this.updatePagination();
        },
        addItem: function (model) {
            this.originalCollection.add(model);
            this.resetCollection();
        },
        removeItem: function (model) {
            this.originalCollection.remove(model);
            this.resetCollection();
        }
    });
});
define('common-modules/navigations/models/header-paged-collection', ['common-modules/navigations/models/paged-collection'], function (PagedCollection) {
    'use strict';
    return PagedCollection.extend({
        getPagingData: function () {
            return {
                start: (this.currentIndex - 1) * this.pageSize,
                count: this.pageSize
            };
        },
        parseTotalCount: function (response, options) {
            if (!options.xhr || _.isNull(options.xhr.getResponseHeader('X-Total-Count'))) {
                return;
            }
            return parseInt(options.xhr.getResponseHeader('X-Total-Count'), 10) || 0;
        }
    });
});
define('common-modules/navigations/views/breadcrumbs', ['common-modules/navigations/views/base-navigation'], function (Base) {
    'use strict';
    var BreadCrumbLink = Base.BaseNavItem.extend({
        className: 'adb-breadcrumbs--item',
        template: _.template('<a class="adb-breadcrumbs--link"><%- label %></a>')
    });
    var BreadCrumbLocation = BreadCrumbLink.extend({
        className: 'adb-breadcrumbs--item',
        template: _.template('<span class="adb-breadcrumbs--content"><%- label %></span>')
    });
    var BreadCrumbs = Base.BaseNavigation.extend({
        className: 'adb-breadcrumbs',
        template: _.template('<ul class="adb-breadcrumbs--items"></ul>'),
        getItemView: function (model) {
            if (model.collection.last() === model) {
                return BreadCrumbLocation;
            }
            return BreadCrumbLink;
        },
        selectNavItem: function (event, itemView) {
            if (itemView instanceof BreadCrumbLocation) {
                return;
            }
            Base.BaseNavigation.prototype.selectNavItem.apply(this, arguments);
        }
    });
    return BreadCrumbs;
});
define('common-modules/navigations/templates/header-vertical-navigation-item.tpl.html', [], function () {
    return '<a class="adb-link__nav adb-stack--item_content js-count" href="javascript:;"><span class="adb-stack--affix adb-link__nav--affix adb-count"><%-count%></span><%- label %></a>\n<ul class="adb-stack"></ul>\n';
});
define('common-modules/navigations/views/header-vertical-navigation-item', [
    'common-modules/navigations/templates/header-vertical-navigation-item.tpl.html',
    'common-modules/navigations/templates/vertical/icon.tpl.html'
], function (template, iconTemplate) {
    'use strict';
    return Marionette.CompositeView.extend({
        tagName: 'li',
        className: 'adb-stack--item',
        template: _.template(template),
        iconTemplate: _.template(iconTemplate),
        itemViewContainer: 'ul',
        itemViewOptions: function () {
            return {
                parent: this,
                eventBus: this.eventBus,
                displayArrow: this.displayArrow,
                viewOnly: this.viewOnly
            };
        },
        events: { 'click > a': 'onSelected' },
        itemEvents: { select: 'hideOtherChildren showChildren' },
        busEvents: {
            'highlight:selection': 'highlightSelection',
            unSelectOthers: 'deSelect'
        },
        ui: {
            list: '> ul',
            link: '> a',
            affix: '> a .adb-stack--affix'
        },
        initialize: function (options) {
            this.eventBus = options.eventBus;
            this.parent = options.parent;
            this.viewOnly = !!options.viewOnly;
            this.childrenVisible = false;
            var childNodes = this.model.get('children');
            if (childNodes && childNodes.length > 0) {
                this.collection = new Backbone.Collection(childNodes);
                this.displayArrow = !!options.displayArrow;
            }
            Marionette.bindEntityEvents(this, this.eventBus, this.busEvents);
        },
        onRender: function () {
            var icon = this.model.get('icon');
            if (!this.collection) {
                this.ui.list.remove();
            } else {
                this.hideChildren();
                this.toggleChildren(false);
            }
            if (icon) {
                this.ui.link.prepend(this.iconTemplate({
                    icon: icon,
                    styleClass: ''
                }));
            }
            if (this.displayArrow) {
                this.ui.link.attr('data-toggle', 'collapse');
            }
            if (this.model.get('displaySortable')) {
                this.ui.affix.addClass('adb-sortable--reorder');
            }
            if (this.model.get('html')) {
                this.ui.link.append(this.model.get('html'));
            }
            this.addHref();
            this.$el.addClass(this.model.get('linkClasses'));
            this.$el.attr('data-auto', this.model.get('value'));
        },
        addHref: function () {
            var url = this.model.get('url');
            if (url) {
                this.ui.link.attr('href', url);
            }
        },
        hideChildren: function () {
            this.toggleChildren(false);
        },
        hideOtherChildren: function (event, itemView) {
            _.chain(this.children._views).without(itemView).invoke('hideChildren');
        },
        showChildren: function () {
            this.toggleChildren(true);
        },
        toggleChildren: function (display) {
            this.ui.list.toggle(display);
            this.childrenVisible = display;
            this.$el.toggleClass('adb-stack--item__nesting', display);
            this.ui.link.addClass('adb-stack--item_content__nesting');
            if (this.displayArrow) {
                this.ui.link.toggleClass('open', display);
                this.ui.link.toggleClass('collapsed', !display);
            }
        },
        deSelect: function (itemView) {
            if (this !== itemView) {
                this.toggleLink(false);
            }
        },
        select: function () {
            this.toggleLink(true);
        },
        toggleLink: function (display) {
            this.ui.link.toggleClass('adb-is-selected', display);
        },
        highlightSelection: function (selected) {
            var val = this.model.get('value');
            if (this.parent) {
                if (selected.parentValue === this.parent.model.get('value') && selected.value === val) {
                    this.onSelected({ silent: true });
                    this.openParents();
                }
            } else {
                if (!selected.parentValue && selected.value === val) {
                    this.onSelected({ silent: true });
                }
            }
        },
        onSelected: function (options) {
            if (this.collection) {
                this.toggleChildren(!this.childrenVisible);
            }
            if (!this.model.get('openOnly') && !this.viewOnly) {
                this.select();
                if (!options.silent) {
                    this.eventBus.trigger('unSelectOthers', this);
                    this.eventBus.trigger('select', this);
                    this.trigger('select');
                }
            }
        },
        openParents: function () {
            this.parent.showChildren();
            if (this.parent.hasParent()) {
                this.parent.openParents();
            }
        },
        hasParent: function () {
            return !!this.parent;
        },
        getFirst: function () {
            return this.children.first() || this;
        },
        serializeData: function () {
            return _.extend(this.model.toJSON(), { count: this.model.get('count') || '' });
        }
    });
});
define('common-modules/navigations/templates/header-vertical-navigation.tpl.html', [], function () {
    return '<div class="adb-container_header">\n\t<h5 class="adb-container_header--title adb-container_header--item"><%= headerText %></h5>\n</div>\n<ul class="adb-stack"></ul>\n<div class="adb-container_footer adb-container_footer__actionable js-footer adb-container_footer--wrap"></div>\n';
});
define('common-modules/navigations/views/header-vertical-navigation', [
    'common-modules/navigations/views/header-vertical-navigation-item',
    'common-modules/navigations/templates/header-vertical-navigation.tpl.html',
    'common-modules/buttons/button-toolbar',
    'object-utils'
], function (ItemView, template, ButtonToolbar, ObjectUtils) {
    'use strict';
    return Marionette.CompositeView.extend({
        className: 'adb-multiple-navigation',
        template: _.template(template),
        itemViewContainer: '> ul',
        itemView: ItemView,
        busEvents: { select: 'onSelect' },
        ui: { list: '> ul' },
        itemViewOptions: function () {
            return {
                eventBus: this.eventBus,
                displayArrow: this.displayArrow,
                viewOnly: this.viewOnly
            };
        },
        initialize: function (options) {
            this.isSmall = !!options.isSmall;
            this.displayArrow = !!options.displayArrow;
            this.viewOnly = !!options.viewOnly;
            this.eventBus = new Backbone.Model();
            this.selectedOnRender = options.selected;
            this.footerButtons = options.footerButtons;
            var collection = this.model.get('collection');
            if (collection) {
                this.collection = ObjectUtils.toCollection(collection);
            }
            Marionette.bindEntityEvents(this, this.eventBus, this.busEvents);
        },
        onRender: function () {
            if (this.isSmall) {
                this.$('> nav').addClass('adb-stack__small');
            }
            if (this.selectedOnRender) {
                this.setSelected(this.selectedOnRender);
                this.selectedOnRender = null;
            }
            this.renderFooter(this.footerButtons);
        },
        renderFooter: function (footerButtons) {
            if (this.footerToolbar) {
                this.footerToolbar.close();
            }
            var $footer = this.$('.js-footer');
            if (footerButtons && footerButtons.length) {
                this.footerToolbar = new ButtonToolbar({ collection: new Backbone.Collection(footerButtons) });
                $footer.append(this.footerToolbar.render().el);
                this.listenTo(this.footerToolbar, 'click', _.bind(this.trigger, this, 'footer:click'));
            } else {
                $footer.hide();
            }
        },
        onClose: function () {
            if (this.footerToolbar) {
                this.footerToolbar.close();
            }
        },
        setSelected: function (selected) {
            this.eventBus.trigger('highlight:selection', selected);
        },
        onSelect: function (itemView) {
            this.trigger('select:header:navigation', itemView);
            this.trigger('change', itemView.model);
        },
        deselectAll: function () {
            this.eventBus.trigger('unSelectOthers');
        },
        closeAll: function () {
            _.chain(this.children._views).invoke('hideChildren');
        },
        getFirst: function () {
            var first = this.children.first();
            if (first) {
                return first.getFirst();
            }
        },
        serializeData: function () {
            var headerText = this.model.get('headerText');
            return { headerText: _.isFunction(headerText) ? headerText() : _.escape(headerText) };
        }
    });
});
define('common-modules/navigations/views/multiple-header-vertical-navigation', ['common-modules/navigations/views/header-vertical-navigation'], function (HeaderVerticalNavigation) {
    'use strict';
    return Marionette.CollectionView.extend({
        className: 'adb-container',
        itemView: HeaderVerticalNavigation,
        attributes: { 'data-component': 'multiple-header-vertical-navigation' },
        itemEvents: {
            'select:header:navigation': 'onSelect',
            change: 'onChange'
        },
        itemViewOptions: function () {
            return {
                isSmall: this.isSmall,
                displayArrow: this.displayArrow,
                viewOnly: this.viewOnly
            };
        },
        initialize: function (options) {
            this.isSmall = !!options.isSmall;
            this.displayArrow = !!options.displayArrow;
            this.viewOnly = !!options.viewOnly;
        },
        onChange: function (event, headerView, subItemModel) {
            this.trigger('change', subItemModel);
        },
        onSelect: function (event, itemView) {
            _.chain(this.children._views).without(itemView).invoke('deselectAll');
        },
        setSelected: function (selected) {
            var navigationValue = selected.navigationValue;
            _.chain(this.children._views).filter(function (navigation) {
                return navigationValue === navigation.model.get('value');
            }).invoke('setSelected', selected);
        },
        deselectAll: function () {
            _.chain(this.children._views).invoke('deselectAll');
        },
        closeAll: function () {
            _.chain(this.children._views).invoke('closeAll');
        }
    });
});
define('common-modules/navigations/templates/step.tpl.html', [], function () {
    return '<span class="adb-steps--content"><%-label%>\n<% if (helpIcon) { %>\n<a class="adb-toolbar--item adb-icon_alert js-help-icon">\n\t<i class="adb-icon__question"></i>\n</a>\n<% } %>\n</span>\n';
});
define('common-modules/navigations/views/step', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/templates/step.tpl.html'
], function (Base, template) {
    'use strict';
    return Base.BaseNavItem.extend({
        className: 'adb-steps--item',
        template: _.template(template),
        triggers: {},
        events: { 'click .js-help-icon': 'onHelpIconClick' },
        serializeData: function () {
            return _.extend(this.model.toJSON(), { helpIcon: this.model.get('helpIcon') || false });
        },
        onHelpIconClick: function () {
            this.trigger('help', this.model);
        }
    });
});
define('common-modules/navigations/views/numbered-step', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/views/step'
], function (Base, Step) {
    'use strict';
    return Step.extend({
        initialize: function (options) {
            this.index = options.itemIndex;
        },
        serializeData: function () {
            return _.extend(this.model.toJSON(), {
                helpIcon: this.model.get('helpIcon') || false,
                label: this.index + 1 + '. ' + this.model.get('label')
            });
        }
    });
});
define('common-modules/navigations/views/old-breadcrumbs', ['common-modules/navigations/views/base-navigation'], function (Base) {
    'use strict';
    var BreadCrumbLink = Base.BaseNavItem.extend({
        className: '',
        tagName: 'span',
        template: _.template('<a><%- label %></a> \u203A ')
    });
    var BreadCrumbLocation = BreadCrumbLink.extend({
        className: '',
        tagName: 'span',
        template: _.template('<span><%- label %></span>')
    });
    var BreadCrumbs = Base.BaseNavigation.extend({
        tagName: 'div',
        itemViewContainer: '.breadcrumbs',
        template: _.template('<div class="breadcrumbs"></div>'),
        getItemView: function (model) {
            if (model.collection.last() === model) {
                return BreadCrumbLocation;
            }
            return BreadCrumbLink;
        },
        selectNavItem: function (event, itemView) {
            if (itemView instanceof BreadCrumbLocation) {
                return;
            }
            Base.BaseNavigation.prototype.selectNavItem.apply(this, arguments);
        }
    });
    return BreadCrumbs;
});
define('common-modules/navigations/templates/page-navigation.tpl.html', [], function () {
    return '<a class="adb-icon__angle_left paginationLink adb-pagination--button adb-pagination--button__prev <%-canMovePrevious%>"></a>\n<a class="adb-pagination--button adb-pagination--button__first"><span>1</span></a>\n\n<span class="adb-pagination--ellipsis <%-showLess%>"></span>\n\n<span class="pagination-links"></span>\n\n<span class="adb-pagination--ellipsis <%-showMore%>"></span>\n\n<a class="adb-pagination--button btn-last"><span><%- totalPages %></span></a>\n<a class="adb-icon__angle_right adb-pagination--button adb-pagination--button__next <%-canMoveNext%>"></a>\n';
});
define('common-modules/navigations/views/page-navigation', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/templates/page-navigation.tpl.html'
], function (Base, Template) {
    'use strict';
    var DEFAULT_PAGE_LIST_SIZE = 4;
    var PageNavItem = Base.BaseNavItem.extend({
        tagName: 'a',
        className: 'adb-pagination--button',
        template: _.template('<%=label%>')
    });
    return Base.BaseNavigation.extend({
        className: 'adb-pagination',
        template: _.template(Template),
        itemView: PageNavItem,
        itemViewContainer: '.pagination-links',
        activeClass: 'adb-pagination--current',
        ui: {
            previous: '.adb-pagination--button__prev',
            first: '.adb-pagination--button__first',
            last: '.btn-last',
            next: '.adb-pagination--button__next'
        },
        events: {
            'click @ui.previous': 'previous',
            'click @ui.first': 'firstPage',
            'click @ui.last': 'lastPage',
            'click @ui.next': 'next'
        },
        initialize: function (options) {
            this.pagedCollection = options.pagedCollection;
            this.pageListSize = typeof options.pageListSize === 'number' ? options.pageListSize : DEFAULT_PAGE_LIST_SIZE;
            this.listenTo(this.pagedCollection, 'change:index', this.onCollectionChange);
        },
        onCollectionChange: function (index) {
            this.render();
            this.trigger('change', index);
        },
        highlightPage: function () {
            if (!this.$el.is(':parent')) {
                return;
            }
            var index = this.pagedCollection.currentIndex;
            if (index === 1) {
                this.ui.first.addClass(this.activeClass);
                return;
            } else if (index === this.pagedCollection.getTotalPages()) {
                this.ui.last.addClass(this.activeClass);
                return;
            }
            var page = this.children.find(function (child) {
                return child.model.get('value') === index;
            });
            if (page) {
                page.model.trigger('select', true, this.activeClass);
            }
        },
        _getPageRange: function () {
            var currentIndex = this.pagedCollection.currentIndex, totalPages = this.pagedCollection.getTotalPages(), pageListSize = this.pageListSize;
            return _.filter(_.range(1, totalPages + 1), function (num) {
                var withinLeft = num >= currentIndex - Math.floor((pageListSize - 1) / 2), withinRight = num <= currentIndex + Math.floor(pageListSize / 2);
                if (num === 1 || num === totalPages) {
                    return false;
                }
                if (withinLeft && withinRight || currentIndex < pageListSize && num <= pageListSize + 1 && withinLeft || currentIndex > totalPages - pageListSize && num >= totalPages - pageListSize && withinRight) {
                    return true;
                }
                return false;
            });
        },
        render: function () {
            if (!this.pagedCollection.hasMultiplePages()) {
                this.$el.empty();
                return this;
            }
            this.createPages();
            Base.BaseNavigation.prototype.render.apply(this, arguments);
            this.highlightPage();
            return this;
        },
        createPages: function () {
            var data = _.map(this._getPageRange(), function (i) {
                return {
                    label: i,
                    value: i
                };
            });
            this.collection = new Backbone.Collection(data);
        },
        selectNavItem: function (event, itemView) {
            var index = itemView.model.get('value');
            if (!itemView.$el.hasClass(this.activeClass) && !_.isNull(this.activeClass)) {
                this.pagedCollection.getPage(index);
                this.triggerChangePage();
            }
        },
        previous: function () {
            if (this.pagedCollection.hasPreviousPage()) {
                this.pagedCollection.getPreviousPage();
                this.triggerChangePage();
            }
        },
        next: function () {
            if (this.pagedCollection.hasNextPage()) {
                this.pagedCollection.getNextPage();
                this.triggerChangePage();
            }
        },
        firstPage: function () {
            this.pagedCollection.getFirstPage();
            this.triggerChangePage();
        },
        lastPage: function () {
            this.pagedCollection.getLastPage();
            this.triggerChangePage();
        },
        triggerChangePage: function () {
            this.trigger('change:page');
        },
        serializeData: function () {
            var pages = this.pagedCollection.getTotalPages(), hasPages = this.collection.size() > 0, firstValue, lastValue;
            if (hasPages) {
                firstValue = this.collection.first().get('value') > 2;
                lastValue = this.collection.last().get('value') < pages - 1;
            }
            return {
                showLess: firstValue ? '' : 'adb-is-hidden',
                showMore: lastValue ? '' : 'adb-is-hidden',
                totalPages: pages,
                canMovePrevious: this.pagedCollection.currentIndex > 1 ? '' : 'adb-is-disabled',
                canMoveNext: this.pagedCollection.currentIndex < pages ? '' : 'adb-is-disabled'
            };
        }
    });
});
define('common-modules/navigations/templates/steps.tpl.html', [], function () {
    return '<ol class="adb-steps--items"></ol>\n';
});
define('common-modules/navigations/views/steps', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/templates/steps.tpl.html',
    'common-modules/navigations/views/step',
    'common-modules/navigations/views/numbered-step'
], function (Base, template, Step, NumberedStep) {
    'use strict';
    return Base.BaseNavigation.extend({
        className: 'adb-steps',
        template: _.template(template),
        itemEvents: function () {
            return _.extend(Base.BaseNavigation.prototype.itemEvents, { help: 'onItemHelpEvent' });
        },
        initialize: function (options) {
            this.numberSteps = options.numberSteps;
        },
        getItemView: function () {
            if (this.numberSteps) {
                return NumberedStep;
            }
            return Step;
        },
        itemViewContainer: 'ol',
        itemViewOptions: function (model, index) {
            return { itemIndex: index };
        },
        onItemHelpEvent: function (event, view, model) {
            this.trigger('help', model);
            this.trigger('help:' + model.get('value'), model);
        },
        activeClass: 'adb-steps--item__current'
    });
});
define('common-modules/navigations/views/tabs', [
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/views/dropdown-navigation',
    'object-utils'
], function (Base, DropdownNavigation, objectUtils) {
    'use strict';
    var Tab = Base.BaseNavItem.extend({
        className: 'adb-tabs--item',
        template: _.template('<a class="adb-tabs--link" tabindex="0"><%- label %></a>')
    });
    var TabDropdown = Tab.extend({
        className: 'adb-tabs--item adb-context_menu',
        ui: {
            dropdownContainer: '.js-dropdown-container',
            trigger: '.js-menu-trigger'
        },
        events: { 'click @ui.trigger': 'toggleDropdown' },
        template: _.template('<span class="adb-tabs--link adb-context_menu--trigger js-menu-trigger"><%=label%></span><div class="js-dropdown-container"></div>'),
        onRender: function () {
            Tab.prototype.onRender.apply(this, arguments);
            this.renderDropdown();
        },
        renderDropdown: function () {
            var dropdown = this.dropdown = new DropdownNavigation({
                collection: this.collection,
                isSmall: this.isSmall
            });
            this.listenTo(dropdown, 'change', this.closeDropdown);
            this.ui.dropdownContainer.append(dropdown.render().el);
        },
        toggleDropdown: function () {
            this.ui.trigger.toggleClass('adb-is-active');
            this.$el.toggleClass('adb-is-active');
            this.handleClickOutside();
        },
        handleClickOutside: function () {
            if (this.$el.hasClass('adb-is-active')) {
                _.defer(_.bind(function () {
                    $('html').one('click.dropdownbtn' + this.cid, _.bind(this.closeDropdown, this));
                }, this));
            }
        },
        closeDropdown: function (model) {
            if (model instanceof Backbone.Model) {
                this.trigger('change', model);
            }
            this.ui.trigger.removeClass('adb-is-active');
            this.$el.removeClass('adb-is-active');
        },
        onClose: function () {
            this.dropdown.close();
        }
    });
    return Base.BaseNavigation.extend({
        className: 'adb-tabs',
        template: _.template('<ul class="adb-tabs--items"></ul>'),
        getItemView: function (model) {
            if (model.get('type') === this.constructor.TYPES.DROPDOWN) {
                return TabDropdown;
            }
            return Tab;
        },
        itemViewOptions: function (model) {
            var options = {};
            if (model.get('type') === this.constructor.TYPES.DROPDOWN) {
                options.collection = objectUtils.toCollection(model.get('collection'));
                options.label = model.get('label');
            }
            return options;
        },
        initialize: function (options) {
            this.isLarge = !!options.large;
        },
        onRender: function () {
            if (this.isLarge) {
                this.$el.addClass('adb-tabs__large');
            }
        }
    }, {
        Tab: Tab,
        TYPES: { DROPDOWN: 'dropdown' }
    });
});
define('common-modules/navigations/views/vertical-content-nav-item', ['common-modules/navigations/views/base-navigation'], function (Base) {
    'use strict';
    return Base.BaseNavItem.extend({
        className: 'adb-container_content adb-container_content__nav',
        tagName: 'div',
        template: _.template(''),
        initialize: function (options) {
            this.viewConstructor = options.viewConstructor;
            this.viewOptions = options.viewOptions || {};
            this.viewModel = options.viewModel || {};
        },
        onRender: function () {
            this.innerView = new this.viewConstructor(_.extend({ model: this.viewModel }, this.viewOptions));
            this.$el.html(this.innerView.render().el);
        },
        onClose: function () {
            this.innerView.close();
        }
    });
});
define('common-modules/navigations/views/vertical-content-nav', [
    'common-modules/navigations/views/vertical-navigation',
    'common-modules/navigations/views/vertical-content-nav-item'
], function (VerticalNav, ContentItem) {
    'use strict';
    return VerticalNav.extend({
        template: _.template(''),
        attributes: { 'data-component': 'VerticalContentNav' },
        itemView: ContentItem,
        itemViewContainer: null,
        itemViewOptions: function (model) {
            var viewModel = model.get('viewModel');
            return {
                viewModel: viewModel instanceof Backbone.Model ? viewModel : new Backbone.Model(viewModel),
                viewOptions: this.viewOptions,
                viewConstructor: this.contentView
            };
        },
        initialize: function (options) {
            this.contentView = options.contentView;
            this.viewOptions = options.viewOptions;
        }
    });
});
define('common-modules/patterns/pagedgrid/views/grid-filters', [
    'common-modules/forms/views/select-input',
    'common-modules/forms/views/date-input',
    'moment'
], function (SelectInput, DateInput, moment) {
    'use strict';
    var NO_FILTER_VALUE = 'SHOW_ALL';
    var SelectFilter = Marionette.Layout.extend({
        className: 'adb-filters--filter',
        template: _.template('<label class="adb-label__small adb-label__inline" for=""><%-label%></label><div class="select-input-container"></div>'),
        regions: { selectRegion: '.select-input-container' },
        initialize: function () {
            this.selectOptions = this.model.get('options');
            this.collection = this.selectOptions.collection;
            this.labelField = this.selectOptions.labelField || 'label';
            this.valueField = this.selectOptions.valueField || 'value';
            var findFilter = {};
            findFilter[this.valueField] = NO_FILTER_VALUE;
            var hasAllOption = !!this.collection.findWhere(findFilter);
            if (this.collection.size() === 0) {
                this.listenToOnce(this.collection, 'sync', this.addAllOption);
            } else if (this.collection.size() > 0 && !hasAllOption) {
                this.addAllOption();
            }
        },
        addAllOption: function () {
            var allOption = {};
            allOption[this.labelField] = l('Show.All');
            allOption[this.valueField] = NO_FILTER_VALUE;
            this.collection = new Backbone.Collection([allOption].concat(this.collection.models));
            this.onRender();
        },
        onRender: function () {
            var select = new SelectInput({
                labelField: this.labelField,
                valueField: this.valueField,
                collection: this.collection,
                label: this.model.get('label'),
                value: this.model.get('value'),
                additionalClasses: 'js-grid-filters',
                isSmall: true
            });
            this.selectRegion.show(select);
            this.listenTo(select, 'change', this.onChange);
        },
        onChange: function (value) {
            this.model.set('value', value);
            var optionModel = this.collection.find(function (model) {
                return model.get(this.valueField) === value;
            }, this);
            var paramValue = optionModel ? optionModel.get('paramValue') || value : value;
            this.trigger('change', this.model.get('param'), paramValue);
        }
    });
    var CheckboxFilter = Marionette.Layout.extend({
        inputType: 'checkbox',
        className: 'adb-filters--filter',
        ui: { input: 'input' },
        template: _.template([
            '<label class="adb-label__small adb-label__inline" for="<%- cid %>">',
            '<span class="adb-selector--input"><input id="<%- cid %>" value="<%- value %>" type="<%- inputType %>" name=""></span>',
            '<span class="adb-selector--value"><%= label %></span>',
            '</label>'
        ].join('\n')),
        initialize: function (options) {
            this.labelField = options.labelField || this.constructor.LABEL_FIELD;
            this.valueField = options.valueField || this.constructor.VALUE_FIELD;
        },
        onRender: function () {
            this.ui.input.on('change', _.bind(this.onChange, this));
        },
        serializeData: function () {
            var label = this.model.get(this.labelField);
            return {
                inputType: this.inputType,
                cid: this.cid,
                collectionCid: this.collectionCid,
                label: label,
                value: this.model.get(this.valueField)
            };
        },
        onChange: function () {
            var value = this.ui.input.prop('checked');
            this.model.set('value', value);
            this.trigger('change', this.model.get('param'), value);
        }
    }, {
        LABEL_FIELD: 'label',
        VALUE_FIELD: 'id'
    });
    var DateRangeFilter = Marionette.Layout.extend({
        className: 'adb-filters--filter',
        template: _.template('<div class="adb-date--container"><label class="adb-label__small adb-label__inline"><%- startLabel %></label><span class="js-start-date-container"></span></div><div class="adb-date--container"><label class="adb-label__small adb-label__inline"><%- endLabel %></label><span class="js-end-date-container"></span></div>'),
        regions: {
            startDateRegion: '.js-start-date-container',
            endDateRegion: '.js-end-date-container'
        },
        onRender: function () {
            var maximumDate = +moment();
            var dateFormatParam = this.model.get('dateFormat');
            var startDateInputParams = {
                isSmall: true,
                maximumDate: maximumDate
            };
            var endDateInputParams = {
                isSmall: true,
                maximumDate: maximumDate,
                useEndOfDay: true
            };
            if (dateFormatParam) {
                startDateInputParams.dateFormat = endDateInputParams.dateFormat = dateFormatParam;
            }
            var startDateInput = this.startDateInput = new DateInput(startDateInputParams);
            var endDateInput = this.endDateInput = new DateInput(endDateInputParams);
            this.startDateRegion.show(startDateInput);
            this.endDateRegion.show(endDateInput);
            this.listenTo(startDateInput, 'change', this.onStartChange);
            this.listenTo(endDateInput, 'change', this.onEndChange);
        },
        getParams: function () {
            var params = {};
            params[this.model.get('startParam')] = this.startDateInput.getValue();
            params[this.model.get('endParam')] = this.endDateInput.getValue();
            return params;
        },
        onStartChange: function (date) {
            this.endDateInput.setMinimumDate(date ? +moment(date).startOf('day') : null);
            this.trigger('change', this.getParams());
        },
        onEndChange: function () {
            this.trigger('change', this.getParams());
        }
    });
    return Marionette.CollectionView.extend({
        tagName: 'menu',
        className: 'adb-filters--content',
        itemEvents: { change: 'onChange' },
        getItemView: function (model) {
            switch (model.get('type')) {
            case 'select':
                return SelectFilter;
            case 'dateRange':
                return DateRangeFilter;
            case 'checkbox':
                return CheckboxFilter;
            default:
                return SelectFilter;
            }
        },
        onChange: function (events, itemView, param, value) {
            if (value === NO_FILTER_VALUE || value === 'null') {
                value = null;
            }
            this.trigger('change', param, value);
        }
    });
});
define('common-modules/patterns/pagedgrid/views/total-count', [], function () {
    'use strict';
    return Marionette.ItemView.extend({
        tagName: 'span',
        className: 'adb-subtitle',
        template: _.template('<%-count%> <%-totalLabel%>'),
        collectionEvents: { 'count:total': 'onCount' },
        initialize: function (options) {
            this.totalLabel = options.totalLabel || l('Results');
            this.count = this.collection.getTotalCount();
        },
        onCount: function (count) {
            this.count = count;
            this.render();
        },
        serializeData: function () {
            return {
                count: this.count || '0',
                totalLabel: this.totalLabel
            };
        }
    });
});
define('common-modules/patterns/pagedgrid/templates/searchable-paged-grid.tpl.html', [], function () {
    return '<div class="adb-container_header <%-headerVisible%>">\n\t<h3 class="adb-container_header--title adb-container_header--item"><%-headerLabel%></h3>\n</div>\n<div class="adb-filters grid-header" data-filters="">\n\t<menu class="adb-filters--header filters-header">\n\t\t<button class="adb-button adb-button__inset adb-button__small adb-filters--filter_button filter-toggle-btn" type="button" style="display: none;">\n\t\t\t<%-l(\'Show.Filters\')%>\n\t\t</button>\n\t\t<button class="adb-button adb-button__inset adb-button__small adb-filters--download_button download-cvs-btn" type="button" style="display: none;" data-auto="csvDownload">\n\t\t\t<%-l(\'Download.CSV\')%>\n\t\t</button>\n\t\t<div class="adb-filters--header_item search-container adb-container_header--item__last"></div>\n\t</menu>\n\t<div class="filter-container" style="display: none;"></div>\n\t<div class="tags-container"></div>\n</div>\n\n<div class="grid-container adb-table<%- scrollable %>"></div>\n\n<div class="adb-container_footer js-footer-container">\n\t<div class="adb-container_footer--item count-container"></div>\n\t<div class="adb-container_footer--item__last pager-container">\n\t</div>\n</div>\n';
});
define('common-modules/patterns/pagedgrid/templates/loading-paged-grid.tpl.html', [], function () {
    return '<div class="adb-table-loader adb-container">\n\t<div class="adb-filters" data-filters="">\n\t\t<menu class="adb-filters--header">\n\t\t\t<div class="adb-filters--header_item">\n\t\t\t\t<div class="adb-search_field adb-text__small"></div>\n\t\t\t</div>\n\t\t</menu>\n\t</div>\n\t<div class="adb-placeholder adb-placeholder__condensed adb-js-placeholder">\n\t\t<figure class="adb-placeholder--image"><span class="adb-loading"><span class="adb-loading--text"></span> </span></figure>\n\t</div>\n\t<div class="adb-container_footer"><span class="adb-subtitle adb-container_footer--item">0 Items</span></div>\n</div>\n';
});
define('common-modules/utils/dom-utils', ['string-utils'], function (StringUtils) {
    'use strict';
    return {
        scrollToTop: function () {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        insertAtCursor: function ($input, text) {
            if (!$input || !$input.length) {
                return;
            }
            var input = $input[0];
            var inputValue = $input.val();
            var caretIndex = input.selectionStart || inputValue.length;
            var newValue = StringUtils.insertAtIndex(inputValue, caretIndex, text);
            $input.val(newValue).focus();
            if (input.setSelectionRange) {
                var newCaretIndex = caretIndex + text.length;
                input.setSelectionRange(newCaretIndex, newCaretIndex);
            }
        }
    };
});
define('common-modules/patterns/pagedgrid/paged-grid', [
    'common-modules/patterns/pagedgrid/templates/searchable-paged-grid.tpl.html',
    'common-modules/patterns/pagedgrid/templates/loading-paged-grid.tpl.html',
    'backgrid',
    'common-modules/forms/views/search-input',
    'common-modules/grid/grid',
    'common-modules/navigations/views/page-navigation',
    'common-modules/navigations/models/paged-collection',
    'common-modules/patterns/pagedgrid/views/total-count',
    'common-modules/patterns/pagedgrid/views/grid-filters',
    'common-modules/buttons/tags',
    'common-modules/behaviors/loading',
    'common-modules/modals/views/modal',
    'common-modules/utils/dom-utils'
], function (Template, LoadingTemplate, Backgrid, SearchInput, Grid, PageNavigation, PagedCollection, TotalCount, GridFilters, Tags, LoadingBehavior, Modal, DomUtils) {
    'use strict';
    var MAX_CSV_ROW = 10000;
    var TableLoading = LoadingBehavior.extend({
        onShowLoading: function () {
            this.view.$el.removeClass('adb-container').children().hide();
            LoadingBehavior.prototype.onShowLoading.apply(this, arguments);
        },
        onHideLoading: function () {
            this.view.$el.addClass('adb-container').children().show();
            this.view.ui.footerContainer.css({ display: 'table' });
            LoadingBehavior.prototype.onHideLoading.apply(this, arguments);
            this.view.renderAllRegions();
            this.view.collection.onLoadComplete(this.view.collection, null, { xhr: this.view.collection.deferred });
        },
        template: LoadingTemplate,
        removeLoadingElement: function () {
            this.$el.children('.adb-table-loader').remove();
        }
    });
    return Marionette.Layout.extend({
        tagName: 'section',
        className: 'adb-container',
        template: _.template(Template),
        regions: {
            searchContainer: '.search-container',
            filterContainer: '.filter-container',
            gridContainer: '.grid-container',
            pagerContainer: '.pager-container',
            countContainer: '.count-container',
            tagsContainer: '.tags-container'
        },
        ui: {
            filterToggleBtn: '.filter-toggle-btn',
            filterMenu: 'menu.adb-filters--header_item',
            filtersHeader: '.filters-header',
            filterContainer: '.filter-container',
            searchContainer: '.search-container',
            downloadCSVBtn: '.download-cvs-btn',
            header: '.grid-header',
            footerContainer: '.js-footer-container'
        },
        events: {
            'click @ui.filterToggleBtn': 'toggleFilters',
            'click @ui.downloadCSVBtn': 'onDownloadCSV'
        },
        collectionEvents: {
            'backgrid:sort': 'onBackgridSort',
            'change:index': 'maybeHideFooter decorateCsvButton'
        },
        defaultSearchOptions: function () {
            return {
                searchFunc: _.bind(this.onSearch, this),
                clearFunc: _.bind(this.onClear, this),
                small: true
            };
        },
        behaviors: { Loading: { behaviorClass: TableLoading } },
        initialize: function (options) {
            this.columns = options.columns;
            this.filters = options.filters;
            this.showCSVDownload = options.showCSVDownload || false;
            this.maxCSVDownload = options.maxCSVDownload || MAX_CSV_ROW;
            this.hasSearch = options.hasSearch !== false;
            this.alwaysShowFilters = !!options.alwaysShowFilters;
            this.searchOptions = _.defaults(options.searchOptions || {}, this.defaultSearchOptions());
            this.emptyText = options.emptyView ? null : options.emptyText || l('No.items.to.display');
            this.emptyView = options.emptyView;
            this.forceEmptyText = options.forceEmptyText;
            this.headerLabel = options.headerLabel;
            this.totalLabel = options.totalLabel;
            this.loading = options.loading;
            this.rowOptions = options.rowOptions || {};
            this.tableOptions = options.tableOptions || {};
            this.searchParamName = options.searchParamName || 'searchText';
            this.listView = options.listView || null;
            this.tags = options.tags || null;
            this.tagsOptions = options.tagsOptions || null;
            this.showCount = options.showCount !== false;
            this.scrollToTopOnPageChange = options.scrollToTopOnPageChange;
            this.isScrollable = options.isScrollable || false;
            if (this.alwaysShowFilters) {
                this.hasSearch = false;
            }
            if (!(this.collection instanceof PagedCollection)) {
                throw new Error('Currently not using a PagedCollection, paging, filters and search will fail');
            }
            if (this.loading) {
                this.listenTo(this.collection, 'request', _.partial(this.triggerMethod, 'show:loading'));
                this.listenTo(this.collection, 'sync', _.partial(this.triggerMethod, 'hide:loading'));
            }
            this.updateFilterValues();
        },
        onRender: function () {
            this.renderAllRegions();
            if (this.loading) {
                this.triggerMethod('show:loading');
            }
        },
        renderAllRegions: function () {
            this.renderHeader();
            this.renderGrid();
            this.renderPager();
            this.renderCount();
            this.maybeHideFooter();
            this.decorateCsvButton();
        },
        renderHeader: function () {
            if (this.hasSearch || this.filters || this.tags) {
                this.renderSearch();
                this.renderTags();
                this.renderFilters();
                this.renderDownloadCSV();
            } else {
                this.$('.adb-filters').remove();
            }
        },
        renderSearch: function () {
            if (this.hasSearch) {
                if (this.searchOptions.fullWidth) {
                    this.ui.searchContainer.addClass('adb-input_row__full_width');
                }
                var search = new SearchInput(_.extend(this.searchOptions, { searchText: this.collection.params[this.searchParamName] }));
                this.searchContainer.show(search);
            }
        },
        renderGrid: function () {
            if (this.listView) {
                this.renderCustomListView();
                return;
            }
            this.grid = new Grid(_.extend(this.tableOptions, {
                columns: this.columns,
                collection: this.collection,
                emptyText: _.bind(this.getEmptyText, this),
                emptyView: this.emptyView,
                row: this.tableOptions.row || Backgrid.Row.extend(this.rowOptions)
            }));
            this.gridContainer.show(this.grid);
        },
        renderCustomListView: function () {
            this.grid = new this.listView(_.extend(this.tableOptions, {
                collection: this.collection,
                emptyText: _.bind(this.getEmptyText, this),
                emptyView: this.emptyView
            }));
            this.gridContainer.show(this.grid);
        },
        renderPager: function () {
            var pageNavigation = new PageNavigation({ pagedCollection: this.collection });
            this.pagerContainer.show(pageNavigation);
            if (this.scrollToTopOnPageChange) {
                this.listenTo(pageNavigation, 'change:page', _.bind(this.scrollToTop, this));
            }
        },
        renderCount: function () {
            if (!this.showCount) {
                return;
            }
            var view = new TotalCount({
                collection: this.collection,
                totalLabel: this.totalLabel
            });
            this.countContainer.show(view);
        },
        renderFilters: function () {
            if (!this.filters) {
                this.ui.filterMenu.remove();
                return;
            }
            if (this.alwaysShowFilters) {
                this.ui.filtersHeader.remove();
                this.ui.header.addClass('adb-filters__opened');
                this.ui.filterContainer.show();
            } else {
                this.ui.filterToggleBtn.show();
            }
            var filters = new GridFilters({ collection: this.filters });
            this.filterContainer.show(filters);
            this.listenTo(filters, 'change', this.onFilterChange);
        },
        renderDownloadCSV: function () {
            if (!this.showCSVDownload || !this.collection.getDownloadCSVUrl) {
                this.ui.downloadCSVBtn.remove();
                return;
            }
            this.ui.downloadCSVBtn.show();
        },
        renderTags: function () {
            if (!this.tags) {
                return;
            }
            var tags = new Tags(_.extend({}, this.tagsOptions, {
                className: 'adb-filters--tags',
                collection: this.tags
            }));
            this.tagsContainer.show(tags);
        },
        maybeHideFooter: function () {
            var show = this.showCount || this.collection.hasMultiplePages();
            if (show) {
                this.ui.footerContainer.removeAttr('hidden');
            } else {
                this.ui.footerContainer.attr('hidden', true);
            }
        },
        decorateCsvButton: function () {
            if (this.showCSVDownload) {
                this.ui.downloadCSVBtn.attr('data-url', this.collection.getDownloadCSVUrl());
                this.ui.downloadCSVBtn.prop('disabled', this.collection.getTotalCount() <= 0);
            }
        },
        toggleFilters: function () {
            if (this.filterContainer.$el) {
                this.filterContainer.$el.slideToggle();
            }
            this.ui.filterToggleBtn.toggleClass('adb-is-active');
            this.ui.filterToggleBtn.text(this.ui.filterToggleBtn.hasClass('adb-is-active') ? l('Hide.Filters') : l('Show.Filters'));
        },
        onDownloadCSV: function () {
            if (this.collection.getTotalCount() >= this.maxCSVDownload) {
                this.showDownloadCvsTooBigAlert();
            } else {
                var a = document.createElement('a');
                a.href = this.collection.getDownloadCSVUrl();
                a.target = '_blank';
                document.body.appendChild(a);
                a.click();
            }
        },
        showDownloadCvsTooBigAlert: function () {
            Modal.alert({
                header: l('Export.to.CSV'),
                content: l('Export.to.CSV.threshold.warning.title')
            });
        },
        onFilterChange: function (param, value) {
            var params;
            if (_.isObject(param)) {
                params = param;
            } else {
                params = {};
                params[param] = value;
            }
            _(params).each(function (val, key) {
                this.collection.setParam(key, val);
            }, this);
            this.collection.getFirstPage();
        },
        getEmptyText: function () {
            if (this.collection.params[this.searchParamName] && !this.forceEmptyText) {
                return l('Search.returned.0.results');
            }
            if (this.collection.hasFilters() && !this.forceEmptyText) {
                return l('Filter.returned.0.results');
            }
            return this.emptyText;
        },
        onBackgridSort: function (column, direction) {
            var sortField = column.get('sortParam') || column.get('name');
            var sortOrder;
            if (column.get('apiV3')) {
                sortOrder = direction ? direction === 'ascending' ? '+' : '-' : null;
                this.collection.setParam('sort', sortOrder ? sortOrder + sortField : null);
            } else {
                sortOrder = direction ? direction === 'ascending' ? 'ASC' : 'DESC' : null;
                this.collection.setParam('sortField', sortOrder ? sortField : null);
                this.collection.setParam('sortOrder', sortOrder);
            }
            this.grid.columns.invoke('set', 'direction', null);
            column.set('direction', direction);
            this.collection.getFirstPage();
        },
        getGrid: function () {
            return this.grid;
        },
        onSearch: function (query) {
            this.onFilterChange(this.searchParamName, query);
        },
        onClear: function () {
            this.onFilterChange(this.searchParamName, null);
        },
        updateFilterValues: function () {
            if (!this.filters) {
                return;
            }
            this.filters.each(function (filter) {
                var paramValue = this.collection.getParam(filter.get('param'));
                if (paramValue) {
                    filter.set('value', paramValue);
                }
            }, this);
        },
        scrollToTop: function () {
            DomUtils.scrollToTop();
        },
        serializeData: function () {
            return {
                headerVisible: this.headerLabel ? '' : 'adb-is-hidden',
                headerLabel: this.headerLabel || '',
                scrollable: this.isScrollable ? ' adb-table__scrollable' : ''
            };
        }
    });
});
define('common-modules/patterns/category-select/views/tags', ['common-modules/buttons/tags'], function (Tags) {
    'use strict';
    return Tags.extend({ className: Tags.prototype.className + ' adb-tags_field--tags adb-js-tags_field--tags' });
});
define('common-modules/status/templates/progress.tpl.html', [], function () {
    return '<span class="adb-meter--percent" style="width: <%-percent%>%;"><%-percent%>%</span>\n';
});
define('common-modules/status/views/progress', [
    'common-modules/status/templates/progress.tpl.html',
    'common-modules/behaviors/simple-tooltip',
    'common-modules/behaviors/sized'
], function (template, SimpleTooltip, Sized) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template(template),
        className: 'adb-meter',
        attributes: { tabindex: '0' },
        behaviors: {
            SimpleTooltip: {
                behaviorClass: SimpleTooltip,
                message: function () {
                    return this.model.get('tooltip') || this.model.get('percent') + '%';
                },
                placement: SimpleTooltip.PLACEMENTS.TOP
            },
            Sized: {
                behaviorClass: Sized,
                prefix: 'adb-meter__'
            }
        },
        modelEvents: { 'change:percent': 'updateProgress' },
        ui: { meter: '.adb-meter--percent' },
        initialize: function (options) {
            this.size = options.size;
        },
        updateProgress: function () {
            var percent = this.model.get('percent'), formattedPercent = percent + '%';
            this.ui.meter.text(formattedPercent).css('width', formattedPercent);
            this.$el.attr('data-percent', percent);
        },
        onRender: function () {
            if (this.size) {
                this.$el.addClass(this.size);
            }
            var state = this.model.get('state');
            if (state) {
                this.$el.attr('data-state', state);
            }
            this.updateProgress();
        }
    });
});
define('common-modules/status/templates/status.tpl.html', [], function () {
    return '<span class="adb-status adb-status__<%-statusClass%>">\n\t<span class="adb-status--gem"></span>\n\t <%-label%>\n</span>\n';
});
define('common-modules/status/views/status', [
    'common-modules/status/templates/status.tpl.html',
    'object-utils'
], function (template, ObjectUtils) {
    'use strict';
    return Marionette.ItemView.extend({
        template: _.template(template),
        defaults: {
            model: new Backbone.Model(),
            valueMap: {},
            value: null
        },
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'model',
                'valueMap',
                'value'
            ]);
            this.value = this.value || this.model.get('value');
        },
        serializeData: function () {
            return {
                statusClass: this.valueMap[this.value].status,
                label: this.valueMap[this.value].label
            };
        }
    }, {
        STATUS: {
            ACTIVE: 'active',
            PENDING: 'pending',
            ERROR: 'error',
            DISABLED: 'disabled'
        }
    });
});
define('common-modules/table/controllers/tableController', [], function () {
    'use strict';
    return Marionette.Controller.extend({
        initialize: function (config) {
            config = config || {};
            _.extend(this, config);
            var view = this.view, region = this.region;
            this.collection.on('sync', function (collection, response, options) {
                var totalCount = options.xhr.getResponseHeader('X-Total-Count');
                view.totalNumber = totalCount || view.totalNumber;
                view.totalPages = Math.ceil(view.totalNumber / view.pageSize);
                if (options.pageLoad) {
                    region.show(view);
                } else {
                    view.render();
                }
            });
        },
        show: function () {
            if (this.collection.length) {
                this.collection.fetch({
                    data: {
                        count: this.view.pageSize,
                        start: this.view.pageNumber * this.view.pageSize
                    },
                    pageLoad: true
                });
            } else {
                this.region.show(this.view);
            }
        }
    });
});
define('common-modules/table/templates/table.tpl.html', [], function () {
    return '<% if (!skipContainer) { %>\n\t<div class="adb-container table-module-container">\n<% } %>\n\n\t<table class="adb-table adb-table__data adb-table__centered \n\t\t<% if (!notActionable) { %> adb-table__actionable <% } %> table-module">\n\n\t\t<% if (tableViewColGroup) { %>\n\t\t<colgroup>\n\t\t\t<% tableViewColGroup %>\n\t\t</colgroup>\n\t\t<% } %>\n\n\t\t<thead>\n\t\t<% tableViewHead %>\n\t\t</thead>\n\t\t<tbody class="table-body">\n\t\t<% tableViewBody %>\n\t\t</tbody>\n\t</table>\n\n\t<div class="adb-container_footer paging">\n\t\t<div class="adb-container_footer--item">\n\t\t\t<%- resultTotals %>\n\t\t</div>\n\n\t\t<% if (showPaging) { %>\n\t\t<div class="adb-container_footer--item__last">\n\t\t\t<nav class="adb-pagination">\n\t\t\t\t<a class="adb-icon__angle_left paginationLink adb-pagination--button adb-pagination--button__prev"\n\t\t\t\t\t data-page="previous"></a>\n\t\t\t\t<a class="{{firstLastCurrentClass pageNumber}} adb-pagination--button button_first paginationLink"\n\t\t\t\t\t data-page="first"><span>1</span></a>\n\t\t\n\t\t\t\t<% if (showMoreEllipsis) { %>\n\t\t\t\t<span class="adb-pagination adb-pagination--ellipsis adb-icon__ellipsis"></span>\n\t\t\t\t<% } %>\n\t\t\n\t\t\t\t<% _.each(pageRange, function(page) { %>\n\t\t\t\t<a class="<% paginationClass(page.pageNumber) %> paginationLink" data-page="<% this %>"><span><% page.displayedPage %></span></a>\n\t\t\t\t<% }) %>\n\t\t\n\t\t\t\t<% if (showMoreEllipsis) { %>\n\t\t\t\t<span class="adb-pagination adb-pagination--ellipsis adb-icon__ellipsis"></span>\n\t\t\t\t<% } %>\n\t\t\n\t\t\t\t<a class="{{firstLastCurrentClass pageNumber totalPages}} adb-pagination--button button_last paginationLink"\n\t\t\t\t\t data-page="last"><span><%- totalPages %></span></a>\n\t\t\t\t<a class="adb-icon__angle_right paginationLink adb-pagination--button adb-pagination--button__next"\n\t\t\t\t\t data-page="next"></a>\n\t\t\t</nav>\n\t\t</div>\n\t\t<% } %>\n\t</div>\n\n<% if (!skipContainer) { %>\n</div>\n<% } %>\n';
});
define('common-modules/table/templates/tableBodyDefault.tpl.html', [], function () {
    return '<% if (data) { %>\n\n\t<% _.each(data, function() { %>\n\t<tr class="table-row">\n\t\t<% td(this) %>\n\t</tr>\n\t<% }) %>\n\n<% } else { %>\n<tr class="table-row empty-tr">\n\t<td>\n\t\t<div class="adb-placeholder">\n\t\t\t<div class="adb-placeholder--text">\n\t\t\t\t<div class="adb-title__large">\n\t\t\t\t\t<%- emptyMessage %>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</td>\n</tr>\n<% } %>\n';
});
define('common-modules/table/templates/tableHeadDefault.tpl.html', [], function () {
    return '<tr>\n\t<%- _.each(headers, function(header) { %>\n\t<th>header</th>\n\t<% }) %>\n</tr>\n';
});
define('common-modules/table/views/tableView', [
    'common-modules/table/templates/table.tpl.html',
    'common-modules/table/templates/tableBodyDefault.tpl.html',
    'common-modules/table/templates/tableHeadDefault.tpl.html',
    'common-baseObjects/BaseView'
], function (template, tableBodyDefault, tableHeadDefault, BaseView) {
    'use strict';
    var TableView = BaseView.extend({
        initialize: function (config) {
            config = config || {};
            _.extend(this, config);
            this.events = _.extend(this.originalEvents, this.additionalEvents);
            this.collection.on('table:update', function () {
                this.pageCollection();
            }, this);
        },
        originalEvents: { 'click .paginationLink': 'changePages' },
        extraData: { totalsText: l('total.results') },
        template: _.template(template),
        templateHelpers: {
            td: function (data, headers) {
                var out = '';
                $.each(headers, function (index, header) {
                    out += '<td>' + data[header] + '</td>';
                });
                return out;
            },
            paginationClass: function (selectedPage, pageNumber) {
                var baseClass = 'adb-pagination', selectedPages = {
                        first: baseClass + '--button__first',
                        last: baseClass + '--button__last',
                        previous: baseClass + '--button__prev',
                        next: baseClass + '--button__next'
                    };
                var returnMe = selectedPages[selectedPage];
                if (returnMe) {
                    return returnMe;
                }
                if (selectedPage === pageNumber) {
                    return baseClass + '--current';
                }
                return baseClass + '--button';
            },
            displayedPage: function () {
                return this + 1;
            },
            firstLastCurrentClass: function (pageNumber, totalPages) {
                if (pageNumber === 0 && !_.isNumber(totalPages)) {
                    return 'adb-pagination--current';
                }
                if (pageNumber + 1 === totalPages) {
                    return 'adb-pagination--current';
                }
                return 'adb-pagination--button';
            },
            truncateText: function (truncateString, length) {
                if (!truncateString || !length) {
                    return '';
                }
                return truncateString.length > length ? APPDIRECT.abbreviate(truncateString, length) : truncateString;
            },
            checkString: function (str, value, options) {
                if (str.toUpperCase() === value.toUpperCase()) {
                    return options.fn(this);
                }
                return options.inverse(this);
            }
        },
        render: function () {
            var that = this, nextRange = _.filter(_.range(this.totalPages), function (num) {
                    var currentPage = that.pageNumber === 0 ? 1 : that.pageNumber;
                    if (num === 0) {
                        return false;
                    }
                    if (num + 1 === that.totalPages) {
                        return false;
                    }
                    if (num + 1 <= that.pagingListSize + currentPage && num >= currentPage - 1) {
                        return true;
                    }
                    if (currentPage + that.pagingListSize >= that.totalPages) {
                        if (num + 1 <= currentPage + that.pagingListSize && num + 1 >= that.totalPages - that.pagingListSize) {
                            return true;
                        }
                    }
                    return false;
                });
            var context = {
                headers: [],
                data: this.collection.toJSON(),
                pageRange: nextRange,
                pageNumber: this.pageNumber,
                totalPages: this.totalPages,
                resultTotals: this.totalNumber + ' ' + this.extraData.totalText,
                currentPageNumber: this.totalPages === 0 ? 0 : this.pageNumber + 1,
                showPaging: this.totalPages > 1,
                emptyMessage: l('empty'),
                showMoreEllipsis: this.totalPages > this.pagingListSize && this.pageNumber + 1 !== this.totalPages && this.pageNumber + 1 + this.pagingListSize < this.totalPages,
                showLessEllipsis: this.pageNumber + 1 >= this.pagingListSize - 1 && this.pageNumber !== 1 && this.pageNumber !== 2
            };
            context.headers = this.collection.getHeaders ? this.collection.getHeaders() : this.getHeaders(context.data);
            var tableHead, tableBody;
            _.extend(context, this.extraData);
            context.tableViewColGroup = this.tableViewColGroup ? this.tableViewColGroup : '';
            tableHead = this.tableViewHead ? this.tableViewHead(context) : _.template(tableHeadDefault)(context);
            tableBody = this.tableViewBody ? this.tableViewBody(context) : _.template(tableBodyDefault)(context);
            context.tableViewHead = tableHead;
            context.tableViewBody = tableBody;
            this.$el.html(this.template(context));
            return this;
        },
        getHeaders: function (data) {
            var headers = [];
            if (data.length > 0) {
                _.each(_.keys(data[0]), function (key) {
                    headers.push(key);
                });
            }
            return headers;
        },
        totalNumber: 0,
        totalPages: 0,
        pageSize: 6,
        pageNumber: 0,
        pagingListSize: 4,
        pageList: 0,
        changePages: function (e) {
            var $currentTarget = $(e.currentTarget);
            var pageNumber = $currentTarget.data('page');
            if ($currentTarget.hasClass('adb-pagination--current')) {
                return false;
            }
            this.pageCollection(pageNumber);
        },
        pageCollection: function (pageNum, successCallBack) {
            var that = this;
            if (pageNum === null || _.isUndefined(pageNum)) {
                var currentPage = $('.adb-pagination--current', this.$el);
                if (currentPage.length === 0) {
                    pageNum = 0;
                } else if (this.collection.length === 0) {
                    pageNum = currentPage.data('page') - 1;
                } else {
                    pageNum = currentPage.data('page');
                }
            }
            var pageNumber = pageNum, pageNumbers = {
                    first: function () {
                        that.pageNumber = 0;
                    },
                    last: function () {
                        that.pageNumber = that.totalPages - 1;
                    },
                    previous: function () {
                        if (that.pageNumber !== 0) {
                            that.pageNumber--;
                        }
                    },
                    next: function () {
                        if (that.pageNumber !== that.totalPages - 1) {
                            that.pageNumber++;
                        }
                    },
                    showMore: function () {
                        if (that.pageList + 1 === Math.floor(that.totalPages / that.pagingListSize)) {
                            that.pageNumber = that.totalPages - 1;
                        } else {
                            that.pageNumber = (that.pageList + 1) * that.pagingListSize;
                        }
                    },
                    showLess: function () {
                        if (that.pageList === 0) {
                            that.pageNumber = 0;
                        } else {
                            that.pageNumber = (that.pageList - 1) * that.pagingListSize;
                        }
                    }
                };
            pageNum = pageNumbers[pageNumber];
            if (!pageNum) {
                if (this.pageNumber !== pageNumber) {
                    this.pageNumber = pageNumber;
                }
            } else {
                pageNum();
            }
            this.pageList = Math.floor(this.pageNumber / this.pagingListSize);
            var pagingData = {
                count: this.pageSize,
                start: this.pageNumber * this.pageSize
            };
            var fetchOptions = {
                data: pagingData,
                reset: true
            };
            if (successCallBack) {
                fetchOptions.success = successCallBack;
            }
            this.collection.fetch(fetchOptions);
        }
    }, Marionette.CompositeView);
    return TableView;
});
define('common-modules/table/table', [
    'common-modules/table/controllers/tableController',
    'common-modules/table/views/tableView'
], function (TableController, TableView) {
    'use strict';
    return function (Module, App, Backbone, Marionette, $, _, region, data) {
        Module.on('start', function () {
            Module.controller.show();
        });
        Module.addInitializer(function (options) {
            options = options || {};
            _.extend(this, options);
            Module.controller = new TableController({
                collection: data.view ? data.view.collection ? data.view.collection : {} : {},
                view: new TableView(data.view ? data.view : {}),
                region: region
            });
        });
    };
});
define('common-modules/utils/countries/australianStates', [], function () {
    'use strict';
    return [
        {
            value: 'NSW',
            label: 'New South Wales'
        },
        {
            value: 'QLD',
            label: 'Queensland'
        },
        {
            value: 'SA',
            label: 'South Australia'
        },
        {
            value: 'TAS',
            label: 'Tasmania'
        },
        {
            value: 'VIC',
            label: 'Victoria'
        },
        {
            value: 'WA',
            label: 'Western Australia'
        },
        {
            value: 'ACT',
            label: 'Australian Capital Territory'
        },
        {
            value: 'NT',
            label: 'Northern Territory'
        }
    ];
});
define('common-modules/utils/countries/germanStates', [], function () {
    'use strict';
    return [
        {
            value: 'DE-BW',
            label: 'Baden-Württemberg'
        },
        {
            value: 'DE-BY',
            label: 'Bayern'
        },
        {
            value: 'DE-BE',
            label: 'Berlin'
        },
        {
            value: 'DE-BB',
            label: 'Brandenburg'
        },
        {
            value: 'DE-HB',
            label: 'Bremen'
        },
        {
            value: 'DE-HH',
            label: 'Hamburg'
        },
        {
            value: 'DE-HE',
            label: 'Hessen'
        },
        {
            value: 'DE-MV',
            label: 'Mecklenburg-Vorpommern'
        },
        {
            value: 'DE-NI',
            label: 'Niedersachsen'
        },
        {
            value: 'DE-NW',
            label: 'Nordrhein-Westfalen'
        },
        {
            value: 'DE-RP',
            label: 'Rheinland-Pfalz'
        },
        {
            value: 'DE-SL',
            label: 'Saarland'
        },
        {
            value: 'DE-SN',
            label: 'Sachsen'
        },
        {
            value: 'DE-ST',
            label: 'Sachsen-Anhalt'
        },
        {
            value: 'DE-SH',
            label: 'Schleswig-Holstein'
        },
        {
            value: 'DE-TH',
            label: 'Thüringen'
        }
    ];
});
define('common-modules/utils/countries/mexicanStates', [], function () {
    'use strict';
    return [
        {
            value: 'AG',
            label: 'Aguascalientes'
        },
        {
            value: 'BC',
            label: 'Baja California'
        },
        {
            value: 'BS',
            label: 'Baja California Sur'
        },
        {
            value: 'CH',
            label: 'Chihuahua'
        },
        {
            value: 'CL',
            label: 'Colima'
        },
        {
            value: 'CM',
            label: 'Campeche'
        },
        {
            value: 'CO',
            label: 'Coahuila'
        },
        {
            value: 'CS',
            label: 'Chiapas'
        },
        {
            value: 'DF',
            label: 'Ciudad de México'
        },
        {
            value: 'DG',
            label: 'Durango'
        },
        {
            value: 'GR',
            label: 'Guerrero'
        },
        {
            value: 'GT',
            label: 'Guanajuato'
        },
        {
            value: 'HG',
            label: 'Hidalgo'
        },
        {
            value: 'JA',
            label: 'Jalisco'
        },
        {
            value: 'MI',
            label: 'Michoacán'
        },
        {
            value: 'MO',
            label: 'Morelos'
        },
        {
            value: 'MX',
            label: 'Estado de México'
        },
        {
            value: 'NA',
            label: 'Nayarit'
        },
        {
            value: 'NL',
            label: 'Nuevo León'
        },
        {
            value: 'OA',
            label: 'Oaxaca'
        },
        {
            value: 'PU',
            label: 'Puebla'
        },
        {
            value: 'QR',
            label: 'Quintana Roo'
        },
        {
            value: 'QT',
            label: 'Querétaro'
        },
        {
            value: 'SI',
            label: 'Sinaloa'
        },
        {
            value: 'SL',
            label: 'San Luis Potosí'
        },
        {
            value: 'SO',
            label: 'Sonora'
        },
        {
            value: 'TB',
            label: 'Tabasco'
        },
        {
            value: 'TL',
            label: 'Tlaxcala'
        },
        {
            value: 'TM',
            label: 'Tamaulipas'
        },
        {
            value: 'VE',
            label: 'Veracruz'
        },
        {
            value: 'YU',
            label: 'Yucatán'
        },
        {
            value: 'ZA',
            label: 'Zacatecas'
        }
    ];
});
define('common-modules/utils/countries/provinces', [], function () {
    'use strict';
    return [
        {
            value: 'AB',
            label: 'Alberta'
        },
        {
            value: 'BC',
            label: 'British Columbia'
        },
        {
            value: 'MB',
            label: 'Manitoba'
        },
        {
            value: 'NB',
            label: 'New Brunswick'
        },
        {
            value: 'NL',
            label: 'Newfoundland'
        },
        {
            value: 'NS',
            label: 'Nova Scotia'
        },
        {
            value: 'ON',
            label: 'Ontario'
        },
        {
            value: 'PE',
            label: 'Prince Edward Island'
        },
        {
            value: 'QC',
            label: 'Quebec'
        },
        {
            value: 'SK',
            label: 'Saskatchewan'
        },
        {
            value: 'NT',
            label: 'Northwest'
        },
        {
            value: 'NU',
            label: 'Nunavut'
        },
        {
            value: 'YT',
            label: 'Yukon'
        }
    ];
});
define('common-modules/utils/countries/states', [], function () {
    'use strict';
    return [
        {
            name: 'Alabama',
            abbreviation: 'AL'
        },
        {
            name: 'Alaska',
            abbreviation: 'AK'
        },
        {
            name: 'American Samoa',
            abbreviation: 'AS'
        },
        {
            name: 'Arizona',
            abbreviation: 'AZ'
        },
        {
            name: 'Arkansas',
            abbreviation: 'AR'
        },
        {
            name: 'Armed Forces Europe',
            abbreviation: 'AE'
        },
        {
            name: 'Armed Forces Pacific',
            abbreviation: 'AP'
        },
        {
            name: 'Armed Forces the Americas',
            abbreviation: 'AA'
        },
        {
            name: 'California',
            abbreviation: 'CA'
        },
        {
            name: 'Colorado',
            abbreviation: 'CO'
        },
        {
            name: 'Connecticut',
            abbreviation: 'CT'
        },
        {
            name: 'Delaware',
            abbreviation: 'DE'
        },
        {
            name: 'District of Columbia',
            abbreviation: 'DC'
        },
        {
            name: 'Federated States of Micronesia',
            abbreviation: 'FM'
        },
        {
            name: 'Florida',
            abbreviation: 'FL'
        },
        {
            name: 'Georgia',
            abbreviation: 'GA'
        },
        {
            name: 'Guam',
            abbreviation: 'GU'
        },
        {
            name: 'Hawaii',
            abbreviation: 'HI'
        },
        {
            name: 'Idaho',
            abbreviation: 'ID'
        },
        {
            name: 'Illinois',
            abbreviation: 'IL'
        },
        {
            name: 'Indiana',
            abbreviation: 'IN'
        },
        {
            name: 'Iowa',
            abbreviation: 'IA'
        },
        {
            name: 'Kansas',
            abbreviation: 'KS'
        },
        {
            name: 'Kentucky',
            abbreviation: 'KY'
        },
        {
            name: 'Louisiana',
            abbreviation: 'LA'
        },
        {
            name: 'Maine',
            abbreviation: 'ME'
        },
        {
            name: 'Marshall Islands',
            abbreviation: 'MH'
        },
        {
            name: 'Maryland',
            abbreviation: 'MD'
        },
        {
            name: 'Massachusetts',
            abbreviation: 'MA'
        },
        {
            name: 'Michigan',
            abbreviation: 'MI'
        },
        {
            name: 'Minnesota',
            abbreviation: 'MN'
        },
        {
            name: 'Mississippi',
            abbreviation: 'MS'
        },
        {
            name: 'Missouri',
            abbreviation: 'MO'
        },
        {
            name: 'Montana',
            abbreviation: 'MT'
        },
        {
            name: 'Nebraska',
            abbreviation: 'NE'
        },
        {
            name: 'Nevada',
            abbreviation: 'NV'
        },
        {
            name: 'New Hampshire',
            abbreviation: 'NH'
        },
        {
            name: 'New Jersey',
            abbreviation: 'NJ'
        },
        {
            name: 'New Mexico',
            abbreviation: 'NM'
        },
        {
            name: 'New York',
            abbreviation: 'NY'
        },
        {
            name: 'North Carolina',
            abbreviation: 'NC'
        },
        {
            name: 'North Dakota',
            abbreviation: 'ND'
        },
        {
            name: 'Northern Mariana Islands',
            abbreviation: 'MP'
        },
        {
            name: 'Ohio',
            abbreviation: 'OH'
        },
        {
            name: 'Oklahoma',
            abbreviation: 'OK'
        },
        {
            name: 'Oregon',
            abbreviation: 'OR'
        },
        {
            name: 'Pennsylvania',
            abbreviation: 'PA'
        },
        {
            name: 'Puerto Rico',
            abbreviation: 'PR'
        },
        {
            name: 'Rhode Island',
            abbreviation: 'RI'
        },
        {
            name: 'South Carolina',
            abbreviation: 'SC'
        },
        {
            name: 'South Dakota',
            abbreviation: 'SD'
        },
        {
            name: 'Tennessee',
            abbreviation: 'TN'
        },
        {
            name: 'Texas',
            abbreviation: 'TX'
        },
        {
            name: 'Utah',
            abbreviation: 'UT'
        },
        {
            name: 'Vermont',
            abbreviation: 'VT'
        },
        {
            name: 'Virgin Islands, U.S.',
            abbreviation: 'VI'
        },
        {
            name: 'Virginia',
            abbreviation: 'VA'
        },
        {
            name: 'Washington',
            abbreviation: 'WA'
        },
        {
            name: 'West Virginia',
            abbreviation: 'WV'
        },
        {
            name: 'Wisconsin',
            abbreviation: 'WI'
        },
        {
            name: 'Wyoming',
            abbreviation: 'WY'
        }
    ];
});
define('common-modules/utils/countries/switzerlandCantons', [], function () {
    'use strict';
    return [
        {
            value: 'AG',
            label: 'Aargau'
        },
        {
            value: 'AR',
            label: 'Appenzell Ausserrhoden'
        },
        {
            value: 'AI',
            label: 'Appenzell Innerrhoden'
        },
        {
            value: 'BL',
            label: 'Basel-Landschaft'
        },
        {
            value: 'BS',
            label: 'Basel-Stadt'
        },
        {
            value: 'BE',
            label: 'Bern'
        },
        {
            value: 'FR',
            label: 'Fribourg'
        },
        {
            value: 'GE',
            label: 'Geneva'
        },
        {
            value: 'GL',
            label: 'Glarus'
        },
        {
            value: 'GR',
            label: 'Grisons'
        },
        {
            value: 'JU',
            label: 'Jura'
        },
        {
            value: 'LU',
            label: 'Luzern'
        },
        {
            value: 'NE',
            label: 'Neuchâtel'
        },
        {
            value: 'NW',
            label: 'Nidwalden'
        },
        {
            value: 'OW',
            label: 'Obwalden'
        },
        {
            value: 'SH',
            label: 'Schaffhausen'
        },
        {
            value: 'SZ',
            label: 'Schwyz'
        },
        {
            value: 'SO',
            label: 'Solothurn'
        },
        {
            value: 'SG',
            label: 'St. Gallen'
        },
        {
            value: 'TG',
            label: 'Thurgau'
        },
        {
            value: 'TI',
            label: 'Ticino'
        },
        {
            value: 'UR',
            label: 'Uri'
        },
        {
            value: 'VS',
            label: 'Valais'
        },
        {
            value: 'VD',
            label: 'Vaud'
        },
        {
            value: 'ZG',
            label: 'Zug'
        },
        {
            value: 'ZH',
            label: 'Zürich'
        }
    ];
});
define('common-modules/utils/bind-all-entity-events', [], function () {
    'use strict';
    var BINDINGS_SUFFIX = 'Events';
    return function (target, entityNames) {
        if (!entityNames) {
            return;
        }
        _(entityNames).each(function (entityName) {
            var entity = target[entityName], bindings = target[entityName + BINDINGS_SUFFIX];
            if (!entity || !bindings) {
                return;
            }
            Marionette.bindEntityEvents(target, entity, bindings);
        });
    };
});
define('common-modules/utils/collection-util', ['common-modules/utils/bubble-event'], function (bubbleEvent) {
    'use strict';
    return {
        save: function (options) {
            return Backbone.sync('create', this, options).then(bubbleEvent('sync', this), bubbleEvent('error', this));
        }
    };
});
define('common-modules/utils/file-download', ['common-modules/utils/browser-util'], function (BrowserUtil) {
    'use strict';
    return {
        csv: function (fileName, content) {
            return this.download(fileName, 'csv', content);
        },
        download: function (fileName, fileType, content) {
            if (BrowserUtil.isIEBelow10()) {
                var $iframe = $('<iframe></iframe>').appendTo('body'), iframe = $iframe[0].contentWindow || $iframe[0].contentDocument;
                iframe.document.open('text/html', 'replace');
                iframe.document.write('sep=,\r\n' + content);
                iframe.document.close();
                iframe.focus();
                iframe.document.execCommand('SaveAs', true, fileName);
                $iframe.remove();
                return;
            }
            if (!window.Blob) {
                return;
            }
            var blob = new Blob([content], { type: 'text/' + fileType + ';charset=utf-8;' });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, fileName);
                return;
            }
            var $anchor = $('<a></a>').appendTo('body'), anchor = $anchor[0];
            if (!_.isUndefined($anchor[0].download)) {
                var url = URL.createObjectURL(blob);
                $anchor.attr('href', url).attr('download', fileName);
                anchor.click();
                $anchor.remove();
            }
        }
    };
});
define('common-modules/utils/find-translation', [], function () {
    'use strict';
    var DEFAULT_LOCALE = 'en';
    return function (translations, locale) {
        if (!locale) {
            return;
        }
        if (translations[locale]) {
            return translations[locale];
        }
        var parts = locale.split('-');
        if (translations[parts[0]]) {
            return translations[parts[0]];
        }
        return translations[DEFAULT_LOCALE];
    };
});
define('common-modules/utils/scroll-to', [], function () {
    'use strict';
    $.fn.scrollTo = function (elem, options) {
        options = _.defaults(options || {}, {
            animate: true,
            speed: 1000
        });
        var $container = $(this), $elem = $(elem);
        var position = $container.scrollTop() - $container.offset().top + $elem.offset().top;
        if (options.animate) {
            $container.animate({ scrollTop: position }, options.speed);
        } else {
            $container.scrollTop(position);
        }
        return this;
    };
    return function (container, elem, options) {
        return $(container).scrollTo(elem, options);
    };
});
define('common-modules/utils/set-reqres-handlers', [], function () {
    'use strict';
    return function (context, handlers, reqres) {
        handlers = handlers || context.reqresHandlers;
        reqres = reqres || App.reqres;
        _.each(handlers, function (handlerName, command) {
            reqres.setHandler(command, _.bind(context[handlerName], context));
        }, this);
    };
});
define('common-modules/utils/videoServiceType', [], function () {
    'use strict';
    return {
        YOUTUBE: {
            VIDEO_ID_EXTRACTOR_REGEX: /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/,
            EMBEDDED_URL_TEMPLATE: _.template('//youtube.com/embed/<%- id %>')
        },
        VIMEO: {
            VIDEO_ID_EXTRACTOR_REGEX: /(?:https?:\/{2})?(?:w{3}\.)?vimeo?\.(?:com|be)(?:\/watch\?v=|\/video\/|\/)([^\s&]+)/,
            EMBEDDED_URL_TEMPLATE: _.template('//player.vimeo.com/video/<%- id %>')
        }
    };
});
define('common-modules/utils/videoUtils', [], function () {
    'use strict';
    return {
        extractVideoId: function (url, videoServiceType) {
            if (!url || !videoServiceType)
                return null;
            var parts = url.match(videoServiceType.VIDEO_ID_EXTRACTOR_REGEX);
            if (!parts)
                return null;
            return parts[1];
        },
        generateEmbeddedUrl: function (id, videoServiceType) {
            return videoServiceType.EMBEDDED_URL_TEMPLATE({ id: id || '' });
        }
    };
});
define('common-modules/utils/xhr-error-parser', [], function () {
    'use strict';
    return function (xhr, isArray) {
        xhr = xhr || {};
        var response;
        try {
            response = JSON.parse(xhr.responseText);
        } catch (e) {
            response = null;
        }
        if (isArray !== false) {
            return response ? _.isArray(response) ? response : [response] : [];
        }
        return response || {};
    };
});
define('common-modules/video/templates/youtube.tpl.html', [], function () {
    return '<iframe width="<%-width%>" height="<%-height%>" src="https://www.youtube.com/embed/<%-videoId%>" frameborder="0" allowfullscreen></iframe>\n';
});
define('common-modules/video/templates/vimeo.tpl.html', [], function () {
    return '<iframe src="https://player.vimeo.com/video/<%-videoId%>" width="<%-width%>" height="<%-height%>" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n';
});
define('common-modules/video/views/player', [
    'common-modules/video/templates/youtube.tpl.html',
    'common-modules/video/templates/vimeo.tpl.html',
    'common-modules/containers/views/alert'
], function (youtubeTpl, vimeoTpl, Alert) {
    'use strict';
    return Marionette.ItemView.extend({
        defaults: {
            width: '500px',
            height: '281px',
            autoplay: false
        },
        sites: [
            {
                getId: function () {
                    var expression = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)(.*).*/;
                    var match = this.url.match(expression);
                    if (match && match[2]) {
                        return match[2];
                    }
                },
                template: youtubeTpl
            },
            {
                getId: function () {
                    var expression = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
                    var match = this.url.match(expression);
                    if (match && match[3]) {
                        return match[3];
                    }
                },
                template: vimeoTpl
            }
        ],
        initialize: function (options) {
            this.url = options.url;
            this.width = options.width || this.defaults.width;
            this.height = options.height || this.defaults.height;
            this.autoplay = options.autoplay || this.defaults.autoplay;
            this.site = this._getSite();
            if (!this.url)
                throw Error('Player needs a url');
        },
        getTemplate: function () {
            if (this.site) {
                return _.template(this.site.template);
            }
        },
        render: function () {
            this.isClosed = false;
            var template = this.getTemplate();
            if (template) {
                var data = this.serializeData();
                this.$el.html(template(data));
            } else {
                this.$el.html(this._getAlert().render().el);
            }
            return this;
        },
        _getSite: function () {
            return _.find(this.sites, function (site) {
                return !!site.getId.apply(this);
            }, this);
        },
        _getAlert: function () {
            return new Alert({
                type: 'warning',
                content: l('Video.link.is.invalid'),
                actionRequired: true
            });
        },
        serializeData: function () {
            var videoId = this.site.getId.apply(this);
            if (videoId.indexOf('?') !== -1 && this.autoplay) {
                videoId += '&autoplay=1';
            } else if (this.autoplay) {
                videoId += '?autoplay=1';
            }
            return {
                width: this.width,
                height: this.height,
                videoId: videoId
            };
        }
    });
});
define('common-modules/guided-tooltip/templates/guided-tooltip.tpl.html', [], function () {
    return '<div class="adb-guided_tooltip adb-js-dialog adb-is-active">\n    <h3 class="adb-guided_tooltip--header">\n        <%- header %>\n        <a class="adb-close dismiss" title="<%- l(\'Close\') %>"></a>\n    </h3>\n\n    <div class="adb-guided_tooltip--content"><%= content %></div>\n    <div class="adb-guided_tooltip--footer">\n        <nav class="adb-pager">\n            <button aria-label="<%- prev %>" class="adb-button__square_small adb-button__inset adb-pager--item adb-pager--button__prev">\n                <i class="adb-icon__arrow_left"></i>\n            </button>\n            <div class="adb-pager--caption adb-pager--item"><%- pagerCaption %></div>\n            <button aria-label="<%- next %>" class="adb-button__square_small adb-button__inset adb-pager--item adb-pager--button__next">\n                <i class="adb-icon__arrow_right"></i>\n            </button>\n        </nav>\n    </div>\n</div>\n';
});
define('common-modules/guided-tooltip/guided-tooltip', [
    'common-modules/guided-tooltip/templates/guided-tooltip.tpl.html',
    'common-modules/utils/tooltip-util'
], function (template, TooltipUtil) {
    'use strict';
    return Marionette.ItemView.extend({
        className: 'adb-styled',
        template: _.template(template),
        ui: {
            tooltip: '.adb-guided_tooltip',
            prevButton: '.adb-pager--button__prev',
            nextButton: '.adb-pager--button__next',
            dismissButton: '.dismiss'
        },
        events: {
            'click @ui.prevButton': '_showPrevious',
            'click @ui.nextButton': '_showNext',
            'click @ui.dismissButton': '_close'
        },
        initialize: function (options) {
            this.tooltips = options.tooltips;
            this.position = 0;
            this.theme = options.theme || this.constructor.THEMES.LIGHT;
            $('body').append(this.$el);
        },
        serializeData: function () {
            return {
                header: this._getHeader() || '',
                content: this._getContent() || '',
                pagerCaption: this._getPagerCaption() || '',
                prev: l('prev'),
                next: l('next')
            };
        },
        onRender: function () {
            var $container = this._getContainer(), placement = this._calculatePlacement();
            if (this.position === 0) {
                this.ui.prevButton.prop('disabled', 'disabled');
            }
            if (this.position + 1 === this.tooltips.length) {
                this.ui.nextButton.prop('disabled', 'disabled');
            }
            this.ui.tooltip.css({
                display: 'block',
                top: TooltipUtil.calculateTopPosition(placement, $container, this.ui.tooltip),
                left: TooltipUtil.calculateLeftPosition(placement, $container, this.ui.tooltip)
            });
            this.ui.tooltip.attr('data-placement', placement);
            this.ui.tooltip.addClass(this.theme.containerClass);
            this.ui.prevButton.addClass(this.theme.buttonClass);
            this.ui.nextButton.addClass(this.theme.buttonClass);
        },
        _getContent: function () {
            var currentTooltip = this._getCurrentTooltip();
            if (currentTooltip.content instanceof Backbone.View) {
                return currentTooltip.content.render().$el.html();
            }
            return currentTooltip.content;
        },
        _getHeader: function () {
            return this._getCurrentTooltip().header;
        },
        _getPagerCaption: function () {
            return l('current.num.of.total', this.position + 1, this.tooltips.length);
        },
        _getContainer: function () {
            return $(this.tooltips[this.position].container);
        },
        _getCurrentTooltip: function () {
            return this.tooltips[this.position];
        },
        _showFirst: function () {
            this.position = 0;
            this.render();
        },
        _showNext: function () {
            this.position++;
            this.render();
        },
        _showPrevious: function () {
            this.position--;
            this.render();
        },
        _close: function () {
            this.trigger('close');
            this.close();
        },
        _calculatePlacement: function () {
            var $container = this._getContainer(), $tooltip = this.ui.tooltip, $window = $(window), placements = [];
            if ($container.offset().top > $window.height()) {
                $window.scrollTop($container.offset().top);
            }
            if ($container.offset().top + $container.outerHeight() + TooltipUtil.MARGIN_SIZE + $tooltip.outerHeight() < $window.height()) {
                placements.push(TooltipUtil.PLACEMENTS.BOTTOM);
            } else {
                placements.push(TooltipUtil.PLACEMENTS.TOP);
            }
            if (TooltipUtil.calculateTriggerLeft($container) + $container.outerWidth() + TooltipUtil.MARGIN_SIZE + $tooltip.outerWidth() < $window.width()) {
                placements.push(TooltipUtil.PLACEMENTS.LEFT);
            } else {
                placements.push(TooltipUtil.PLACEMENTS.RIGHT);
            }
            return placements.join('-');
        }
    }, {
        start: function (options) {
            var guidedTooltip = new this(options);
            guidedTooltip._showFirst();
            return guidedTooltip;
        },
        THEMES: {
            LIGHT: {
                containerClass: '',
                buttonClass: ''
            },
            DARK: {
                containerClass: 'adb-guided_tooltip__dark',
                buttonClass: 'adb-button__inset_dark'
            }
        }
    });
});
define('common-modules/layout-manager/managed-region', ['object-utils'], function (ObjectUtils) {
    'use strict';
    return Marionette.Region.extend({
        ventEvents: { 'layout-manager:update': 'reorderSubregions' },
        defaults: {
            subregionTag: 'div',
            channelName: 'global'
        },
        initialize: function (options) {
            ObjectUtils.mergeOptions(this, options, [
                'subregionTag',
                'subregionClass',
                'layoutName',
                'channelName'
            ]);
            this.regionManager = new Marionette.RegionManager();
            this.viewCreators = {};
            this.channel = Backbone.Wreqr.radio.channel(this.channelName);
            this.channel.reqres.request('layout-manager:register', options.layoutName, options.layoutOptions);
            this.vent = this.channel.vent;
            Marionette.bindEntityEvents(this, this.vent, this.ventEvents);
            this.areSubRegionsCreated = false;
        },
        ensureEl: function () {
            Marionette.Region.prototype.ensureEl.apply(this, arguments);
            this.$el.addClass('managed-region');
        },
        createSubRegions: function () {
            this.ensureEl();
            var layout = this.getLayout();
            _.each(layout, this.createSubregion, this);
        },
        reorderSubregions: function (name) {
            if (name !== this.layoutName) {
                return;
            }
            this.ensureEl();
            this.$el.children().detach();
            var layout = this.getLayout();
            _.each(layout, this.createSubregion, this);
            this.regionManager.each(function (subregion) {
                if (!_.findWhere(layout, { id: subregion.id })) {
                    this.regionManager.removeRegion(subregion.id);
                }
            }, this);
            this.trigger('reorder');
        },
        getLayout: function () {
            return this.channel.reqres.request('layout-manager:get', this.layoutName);
        },
        show: function (name, viewCreator) {
            if (!this.areSubRegionsCreated) {
                this.createSubRegions();
                this.areSubRegionsCreated = true;
            }
            this.viewCreators[name] = viewCreator;
            var subregions = this.getSubregions(name);
            var layout = this.getLayout();
            _.each(subregions, function (subregion, id) {
                var layoutEntry = _.findWhere(layout, { id: id });
                this.showView(subregion, layoutEntry, viewCreator);
            }, this);
            this.trigger('show');
        },
        showView: function (subregion, layoutEntry, viewCreator) {
            $(subregion.el).show();
            var options = _.extend({}, layoutEntry.options, layoutEntry.editOptions);
            var view = viewCreator(options, _.bind(this.showViewAsync, this, subregion));
            if (view) {
                subregion.show(view);
            }
        },
        showViewAsync: function (subregion, view) {
            subregion.show(view);
            this.trigger('show');
        },
        getSubregions: function (name) {
            var layoutEntries = _.where(this.getLayout(), { name: name });
            var subregions = {};
            _.each(layoutEntries, function (entry) {
                subregions[entry.id] = this.regionManager.get(entry.id);
            }, this);
            return subregions;
        },
        createSubregion: function (layoutEntry) {
            var id = layoutEntry.id;
            var $el = $(document.createElement(this.subregionTag));
            if (this.subregionClass) {
                $el.addClass(this.subregionClass);
            }
            $el.hide();
            this.$el.append($el);
            var subregion = new Marionette.Region({ el: $el[0] });
            subregion.id = id;
            this.regionManager.addRegion(id, subregion);
            var viewCreator = this.viewCreators[layoutEntry.name];
            if (viewCreator) {
                this.showView(subregion, layoutEntry, viewCreator);
            }
        },
        close: function () {
            this.regionManager.removeRegions();
            this.$el.empty();
            this.off();
            Marionette.triggerMethod.call(this, 'close');
        },
        reorderLayout: function () {
            var originalLayout = this.getLayout();
            var layout = [];
            _.each(this.$el.children(), function (subregionEl) {
                var subregion = this.regionManager.find(function (region) {
                    return region.el === subregionEl;
                });
                if (subregion) {
                    layout.push(_.findWhere(originalLayout, { id: subregion.id }));
                }
            }, this);
            return layout;
        }
    });
});
define('common-modules/layout-manager/layout-manager', [
    'node-modules/baobab',
    'object-utils'
], function (Baobab, ObjectUtils) {
    'use strict';
    var LayoutManager = function (options) {
        ObjectUtils.mergeOptions(this, options, [
            'model',
            'channelName'
        ]);
        this.initialize();
    };
    _.extend(LayoutManager.prototype, Backbone.Events, {
        defaults: { channelName: 'global' },
        modelEvents: { sync: 'onStorageSync' },
        reqresHandlers: {
            'layout-manager:register': 'registerLayout',
            'layout-manager:get': 'getLayout'
        },
        initialize: function () {
            this.layouts = new Baobab({}, {
                asynchronous: false,
                syncwrite: true,
                validate: _.bind(this.validateLayouts, this)
            });
            this.cursors = {};
            this.entryDefinitions = {};
            this.defaultLayouts = {};
            this.channel = Backbone.Wreqr.radio.channel(this.channelName);
            this.setHandlers();
            if (this.model) {
                Marionette.bindEntityEvents(this, this.model, this.modelEvents);
            }
        },
        validateLayouts: function (previousState, nextState) {
            var invalidLayoutNames = _.compact(_.map(nextState, function (layout, name) {
                var ids = _.pluck(layout, 'id');
                if (_.uniq(ids).length !== ids.length) {
                    return name;
                }
            }));
            if (invalidLayoutNames.length) {
                return new Error('Invalid layouts: ' + invalidLayoutNames.join(', '));
            }
        },
        normalizeLayout: function (layoutRaw, entryDefinitions) {
            return _.map(layoutRaw, _.partial(this.normalizeEntry, entryDefinitions), this);
        },
        normalizeEntry: function (entryDefinitions, entry) {
            if (_.isString(entry)) {
                entry = { name: entry };
            }
            var instanceConfig = _.extend({}, entry);
            var entryDefinition = entryDefinitions[instanceConfig.name];
            var options = instanceConfig.options = instanceConfig.options || {};
            if (entryDefinition && entryDefinition.defaults) {
                _.defaults(options, entryDefinition.defaults);
            }
            if (!instanceConfig.id) {
                instanceConfig.id = entryDefinition && entryDefinition.fixed ? entry.name : _.uniqueId(entry.name);
            }
            return instanceConfig;
        },
        getLayout: function (name) {
            return this.layouts.get(name);
        },
        addToLayout: function (name, entry) {
            this.cursors[name].push(this.normalizeEntry(this.entryDefinitions[name], entry));
        },
        replaceInLayout: function (name, replacement) {
            var entryCursor = this.cursors[name].select(function (entry) {
                return entry.id === replacement.id;
            });
            var normalizedReplacement = this.normalizeEntry(this.entryDefinitions[name], _.omit(replacement, 'id'));
            entryCursor.set(normalizedReplacement);
        },
        undo: function (name) {
            if (this.canUndo(name)) {
                var cursor = this.cursors[name];
                cursor.redoHistory = cursor.redoHistory || [];
                cursor.redoHistory.unshift(cursor.get());
                cursor.keepRedo = true;
                cursor.undo();
            }
        },
        canUndo: function (name) {
            var cursor = this.cursors[name];
            return !!(cursor && cursor.hasHistory());
        },
        redo: function (name) {
            if (this.canRedo(name)) {
                var cursor = this.cursors[name];
                var layout = cursor.redoHistory[0];
                cursor.redoHistory = cursor.redoHistory.slice(1);
                cursor.keepRedo = true;
                cursor.set(layout);
            }
        },
        canRedo: function (name) {
            var cursor = this.cursors[name];
            return !!(cursor && cursor.redoHistory && !!cursor.redoHistory.length);
        },
        isSynced: function (name) {
            var cursor = this.cursors[name];
            return !!(cursor && cursor.syncedState === cursor.get());
        },
        onLayoutUpdate: function (name) {
            var cursor = this.cursors[name];
            if (!cursor.keepRedo) {
                cursor.redoHistory = [];
            }
            cursor.keepRedo = false;
            if (this.model) {
                this.model.set('layouts', this.serializeLayouts());
            }
            this.triggerUpdate(name);
        },
        serializeLayouts: function () {
            var layouts = this.layouts.get();
            var serialized = {};
            _.each(layouts, function (layout, name) {
                var definitions = this.entryDefinitions[name];
                serialized[name] = _.map(layout, function (entry) {
                    var definition = definitions[entry.name];
                    var serializedEntry = _.omit(entry, 'id', 'editOptions');
                    var pickArgs = [serializedEntry.options];
                    if (definition && definition.defaults) {
                        pickArgs = pickArgs.concat(_.chain(serializedEntry.options).keys().filter(function (optionName) {
                            return definition.defaults[optionName] !== serializedEntry.options[optionName];
                        }).value());
                    }
                    serializedEntry.options = _.pick.apply(_, pickArgs);
                    return serializedEntry;
                });
            }, this);
            return serialized;
        },
        triggerUpdate: function (name) {
            this.trigger('update', name);
            this.channel.vent.trigger('layout-manager:update', name);
        },
        onStorageSync: function (model, resp, options) {
            this.importFromModel(!options.save);
        },
        importFromModel: function (resetHistory) {
            var layoutsRaw = _.extend({}, this.defaultLayouts, this.model.get('layouts'));
            _.each(layoutsRaw, function (rawLayout, name) {
                var cursor = this.cursors[name];
                if (cursor) {
                    cursor.recording = false;
                    cursor.disable();
                }
                var updated = this.updateLayout(name, rawLayout);
                if (!updated) {
                    return;
                }
                if (cursor) {
                    cursor.enable();
                } else {
                    cursor = this.cursors[name];
                }
                cursor.syncedState = cursor.get();
                if (resetHistory) {
                    cursor.clearHistory();
                    cursor.redoHistory = [];
                    cursor.startRecording(this.constructor.UNDO_HISTORY_SIZE);
                } else {
                    cursor.recording = true;
                }
                this.triggerUpdate(name);
            }, this);
        },
        getDefinitions: function (name) {
            return this.entryDefinitions[name];
        },
        registerLayout: function (name, options) {
            this.entryDefinitions[name] = options.entryDefinitions;
            this.defaultLayouts[name] = options.defaultLayout;
            if (!this.model) {
                this.updateLayout(name, options.defaultLayout);
            } else {
                this.importFromModel(true);
            }
        },
        updateLayout: function (name, rawLayout) {
            if (!this.entryDefinitions[name]) {
                return false;
            }
            this.layouts.set(name, this.normalizeLayout(rawLayout, this.entryDefinitions[name]));
            if (!this.cursors[name]) {
                var cursor = this.cursors[name] = this.layouts.select(name);
                cursor.startRecording(this.constructor.UNDO_HISTORY_SIZE);
                cursor.on('update', _.bind(this.onLayoutUpdate, this, name));
            }
            return true;
        },
        setHandlers: function () {
            _.each(this.reqresHandlers, function (handlerName, command) {
                this.channel.reqres.setHandler(command, _.bind(this[handlerName], this));
            }, this);
        },
        removeHandlers: function () {
            _.each(_.keys(this.reqresHandlers), function (command) {
                this.channel.reqres.removeHandler(command);
            }, this);
        },
        unbindCursors: function () {
            _.invoke(this.cursors, 'unbindAll');
        },
        close: function () {
            this.removeHandlers();
            this.unbindCursors();
        }
    }, { UNDO_HISTORY_SIZE: 100 });
    return LayoutManager;
});
define('kraken', [
    'common-modules/behaviors/char-countdown',
    'common-modules/behaviors/complex-tooltip',
    'common-modules/behaviors/infinite-scroll',
    'common-modules/behaviors/alert',
    'common-modules/behaviors/loading',
    'common-modules/behaviors/simple-tooltip',
    'common-modules/behaviors/sized',
    'common-modules/buttons/views/button-spacer',
    'common-modules/buttons/button-toolbar',
    'common-modules/buttons/button',
    'common-modules/buttons/combined-toolbar',
    'common-modules/buttons/dropdown-button',
    'common-modules/buttons/pager-toolbar',
    'common-modules/buttons/tag',
    'common-modules/buttons/tags',
    'common-modules/buttons/toggle-button',
    'common-modules/buttons/toggle-toolbar',
    'common-modules/buttons/tooltip-trigger',
    'common-modules/containers/models/alert',
    'common-modules/containers/models/comments',
    'common-modules/containers/views/accordion',
    'common-modules/containers/views/advanced-container',
    'common-modules/containers/views/alert',
    'common-modules/containers/views/bundle-slider-content',
    'common-modules/containers/views/bundle-slider-v2',
    'common-modules/containers/views/bundle-slider',
    'common-modules/containers/views/bundle',
    'common-modules/containers/views/carousel-app-content',
    'common-modules/containers/views/carousel',
    'common-modules/containers/views/collapser',
    'common-modules/containers/views/container',
    'common-modules/containers/views/description-list',
    'common-modules/containers/views/feature-slider-app-content-tooltip',
    'common-modules/containers/views/feature-slider-app-content',
    'common-modules/containers/views/feature-slider',
    'common-modules/containers/views/feature-slider-v2',
    'common-modules/containers/views/flat-region',
    'common-modules/containers/views/header',
    'common-modules/containers/views/html-content',
    'common-modules/containers/views/inline-search-results',
    'common-modules/containers/views/logo',
    'common-modules/containers/views/slider-dummy-view-all-url-item',
    'common-modules/containers/views/slider-page',
    'common-modules/containers/views/slider-v2',
    'common-modules/containers/views/placeholder',
    'common-modules/containers/views/slider',
    'common-modules/containers/views/threaded-comment-edit-form',
    'common-modules/containers/views/threaded-comment-reply-form',
    'common-modules/containers/views/threaded-comments',
    'common-modules/containers/views/threaded-comment',
    'common-modules/forms/views/fields/base-subview-field',
    'common-modules/forms/views/fields/boolean-styled-select',
    'common-modules/forms/views/fields/category-select-field',
    'common-modules/forms/views/fields/checkboxes-field',
    'common-modules/forms/views/fields/clearable-text-field',
    'common-modules/forms/views/fields/color-field',
    'common-modules/forms/views/fields/custom-view-field',
    'common-modules/forms/views/fields/country-field',
    'common-modules/forms/views/fields/date-field',
    'common-modules/forms/views/fields/email-domain-select-field',
    'common-modules/forms/views/fields/field-width-type',
    'common-modules/forms/views/fields/field',
    'common-modules/forms/views/fields/file-upload-field',
    'common-modules/forms/views/fields/image-upload-field',
    'common-modules/forms/views/fields/inline-form',
    'common-modules/forms/views/fields/inline-search-field',
    'common-modules/forms/views/fields/input-table-field',
    'common-modules/forms/views/fields/input-table-item-default',
    'common-modules/forms/views/fields/input-table-item-view',
    'common-modules/forms/views/fields/input-table-view',
    'common-modules/forms/views/fields/json-textarea-field',
    'common-modules/forms/views/fields/key-fingerprint-field',
    'common-modules/forms/views/fields/multi-subforms-field',
    'common-modules/forms/views/fields/nested-form',
    'common-modules/forms/views/fields/nested-model-form',
    'common-modules/forms/views/fields/number-field',
    'common-modules/forms/views/fields/option-selector-base-field',
    'common-modules/forms/views/fields/phone-field',
    'common-modules/forms/views/fields/phone-locale-field',
    'common-modules/forms/views/fields/radios-field',
    'common-modules/forms/views/fields/rating-field',
    'common-modules/forms/views/fields/styled-select',
    'common-modules/forms/views/fields/textarea-field',
    'common-modules/forms/views/fields/toggle-field',
    'common-modules/forms/views/fields/toggles-field',
    'common-modules/forms/views/fields/translations-field',
    'common-modules/forms/views/fields/url-field',
    'common-modules/forms/views/fields/validation-messages',
    'common-modules/forms/views/fields/validators',
    'common-modules/forms/views/fields/zipcode-field',
    'common-modules/forms/views/checkbox-bar',
    'common-modules/forms/views/checkbox-grid',
    'common-modules/forms/views/checkbox',
    'common-modules/forms/views/email-domain-select-view',
    'common-modules/forms/views/error-handler',
    'common-modules/forms/views/fieldset',
    'common-modules/forms/views/file-upload',
    'common-modules/forms/views/file-uploads',
    'common-modules/forms/views/help-tooltip',
    'common-modules/forms/views/image-upload-preview',
    'common-modules/forms/views/form',
    'common-modules/forms/views/image-upload',
    'common-modules/forms/views/inline-search-input',
    'common-modules/forms/views/json-textarea-input',
    'common-modules/forms/views/key-fingerprint',
    'common-modules/forms/views/multi-subforms-entry',
    'common-modules/forms/views/multi-subforms',
    'common-modules/forms/views/option-selector-base',
    'common-modules/forms/views/option-selector-grid',
    'common-modules/forms/views/radio-bar',
    'common-modules/forms/views/radio-grid',
    'common-modules/forms/views/radio',
    'common-modules/forms/views/rating-input',
    'common-modules/forms/views/search-input',
    'common-modules/forms/views/select-input',
    'common-modules/forms/views/text-input',
    'common-modules/forms/views/textarea-input',
    'common-modules/forms/views/toggle-grid',
    'common-modules/forms/views/toggle',
    'common-modules/forms/views/translations-input',
    'common-modules/forms/views/date-input',
    'common-modules/forms/views/color-input',
    'common-modules/forms/views/clearable-text-input',
    'common-modules/grid/cells/forms/select-cell',
    'common-modules/grid/cells/forms/text-input-cell',
    'common-modules/grid/cells/action-cell',
    'common-modules/grid/cells/action-dropdown-cell',
    'common-modules/grid/cells/application-cell',
    'common-modules/grid/cells/badge-cell',
    'common-modules/grid/cells/badges-cell',
    'common-modules/grid/cells/bold-cell',
    'common-modules/grid/cells/checkbox-cell',
    'common-modules/grid/cells/checkbox-header-cell',
    'common-modules/grid/cells/date-cell',
    'common-modules/grid/cells/footnote-cell',
    'common-modules/grid/cells/image-cell',
    'common-modules/grid/cells/logo-cell',
    'common-modules/grid/cells/link-cell',
    'common-modules/grid/cells/status-cell',
    'common-modules/grid/cells/radio-cell',
    'common-modules/grid/cells/status-enabled-cell',
    'common-modules/grid/cells/summary-cell',
    'common-modules/grid/cells/toggle-cell',
    'common-modules/grid/formatters/date-formatter',
    'common-modules/grid/rows/clickable-row',
    'common-modules/grid/rows/option-selector-row',
    'common-modules/grid/rows/radio-row',
    'common-modules/grid/rows/toggle-row',
    'common-modules/grid/grid',
    'common-modules/grid/no-header-grid',
    'common-modules/icons/views/tag-icons',
    'common-modules/layouts/sidebar-left',
    'common-modules/layouts/sidebar-content',
    'common-modules/layouts/sidebar-right',
    'common-modules/loading/PageSpinner',
    'common-modules/modals/views/modal',
    'common-modules/models/relational-model',
    'common-modules/navigation/views/navigationView',
    'common-modules/navigation/navigation',
    'common-modules/navigations/editor/editor',
    'common-modules/navigations/footer/views/footer-dropdown',
    'common-modules/navigations/footer/views/footer-nav-item',
    'common-modules/navigations/footer/views/footer-text',
    'common-modules/navigations/footer/views/footer-nav',
    'common-modules/navigations/footer/footer',
    'common-modules/navigations/header/masthead/views/link-item',
    'common-modules/navigations/header/masthead/views/logo-item',
    'common-modules/navigations/header/masthead/header-masthead',
    'common-modules/navigations/header/primary/views/dropdown-item',
    'common-modules/navigations/header/primary/views/link-item',
    'common-modules/navigations/header/primary/views/logo-item',
    'common-modules/navigations/header/primary/views/text-item',
    'common-modules/navigations/header/primary/header-navigation-primary',
    'common-modules/navigations/header/secondary/views/dropdown-item',
    'common-modules/navigations/header/secondary/views/header-item',
    'common-modules/navigations/header/secondary/views/link-item',
    'common-modules/navigations/header/secondary/views/search-item',
    'common-modules/navigations/header/secondary/header-navigation-secondary',
    'common-modules/navigations/header/tertiary/views/link-item',
    'common-modules/navigations/header/tertiary/header-navigation-tertiary',
    'common-modules/navigations/models/base-model',
    'common-modules/navigations/models/client-paged-collection',
    'common-modules/navigations/models/paged-collection',
    'common-modules/navigations/models/header-paged-collection',
    'common-modules/navigations/views/base-navigation',
    'common-modules/navigations/views/breadcrumbs',
    'common-modules/navigations/views/dropdown-navigation-item',
    'common-modules/navigations/views/dropdown-navigation',
    'common-modules/navigations/views/header-vertical-navigation',
    'common-modules/navigations/views/header-vertical-navigation-item',
    'common-modules/navigations/views/multiple-header-vertical-navigation',
    'common-modules/navigations/views/numbered-step',
    'common-modules/navigations/views/old-breadcrumbs',
    'common-modules/navigations/views/page-navigation',
    'common-modules/navigations/views/step',
    'common-modules/navigations/views/steps',
    'common-modules/navigations/views/tabs',
    'common-modules/navigations/views/vertical-content-nav-item',
    'common-modules/navigations/views/vertical-content-nav',
    'common-modules/navigations/views/vertical-navigation-item',
    'common-modules/navigations/views/vertical-navigation',
    'common-modules/patterns/card/views/application-card',
    'common-modules/patterns/pagedgrid/views/grid-filters',
    'common-modules/patterns/pagedgrid/views/total-count',
    'common-modules/patterns/pagedgrid/paged-grid',
    'common-modules/patterns/category-select/views/categories',
    'common-modules/patterns/category-select/views/category-item',
    'common-modules/patterns/category-select/views/options',
    'common-modules/patterns/category-select/views/tags',
    'common-modules/patterns/category-select/category-select',
    'common-modules/status/views/badge',
    'common-modules/status/views/badges',
    'common-modules/status/views/progress',
    'common-modules/status/views/rating',
    'common-modules/status/views/status',
    'common-modules/table/controllers/tableController',
    'common-modules/table/views/tableView',
    'common-modules/table/table',
    'common-modules/ui/date-picker',
    'common-modules/ui/ribbon',
    'common-modules/utils/countries/australianStates',
    'common-modules/utils/countries/countries',
    'common-modules/utils/countries/germanStates',
    'common-modules/utils/countries/mexicanStates',
    'common-modules/utils/countries/provinces',
    'common-modules/utils/countries/states',
    'common-modules/utils/countries/switzerlandCantons',
    'common-modules/utils/countries/zip-code-validation',
    'common-modules/utils/countries/zip-code-formatter',
    'common-modules/utils/bind-all-entity-events',
    'common-modules/utils/browser-util',
    'common-modules/utils/bubble-event',
    'common-modules/utils/color-utils',
    'common-modules/utils/collection-util',
    'common-modules/utils/dom-utils',
    'common-modules/utils/file-download',
    'common-modules/utils/file-uploader',
    'common-modules/utils/find-translation',
    'common-modules/utils/generate-selector-hash',
    'common-modules/utils/hateoas-parse',
    'common-modules/utils/scroll-to',
    'common-modules/utils/set-reqres-handlers',
    'common-modules/utils/videoServiceType',
    'common-modules/utils/videoUtils',
    'common-modules/utils/xhr-error-parser',
    'common-modules/utils/tooltip-util',
    'common-modules/video/views/player',
    'common-modules/guided-tooltip/guided-tooltip',
    'common-modules/layout-manager/managed-region',
    'common-modules/layout-manager/layout-manager',
    'common-modules/merchandising-badges/badge',
    'common-modules/merchandising-badges/badges'
], function (behaviorsCharCountdown, behaviorsComplexTooltip, behaviorsInfiniteScroll, behaviorsAlert, behaviorsLoading, behaviorsSimpleTooltip, behaviorsSized, buttonsViewsButtonSpacer, buttonsButtonToolbar, buttonsButton, buttonsCombinedToolbar, buttonsDropdownButton, buttonsPagerToolbar, buttonsTag, buttonsTags, buttonsToggleButton, buttonsToggleToolbar, buttonsTooltipTrigger, containersModelsAlert, containersModelsComments, containersViewsAccordion, containersViewsAdvancedContainer, containersViewsAlert, containersViewsBundleSliderContent, containersViewsBundleSliderV2, containersViewsBundleSlider, containersViewsBundle, containersViewsCarouselAppContent, containersViewsCarousel, containersViewsCollapser, containersViewsContainer, containersViewsDescriptionList, containersViewsFeatureSliderAppContentTooltip, containersViewsFeatureSliderAppContent, containersViewsFeatureSlider, containersViewsFeatureSliderV2, containersViewsFlatRegion, containersViewsHeader, containersViewsHtmlContent, containersViewsInlineSearchResults, containersViewsLogo, containersViewsSliderDummyViewAllUrlItem, containersViewsSliderPage, containersViewsSliderV2, containersViewsPlaceholder, containersViewsSlider, containersViewsThreadedCommentEditForm, containersViewsThreadedCommentReplyForm, containersViewsThreadedComments, containersViewsThreadedComment, formsViewsFieldsBaseSubviewField, formsViewsFieldsBooleanStyledSelect, formsViewsFieldsCategorySelectField, formsViewsFieldsCheckboxesField, formsViewsFieldsClearableTextField, formsViewsFieldsColorField, formsViewsFieldsCustomViewField, formsViewsFieldsCountryField, formsViewsFieldsDateField, formsViewsFieldsEmailDomainSelectField, formsViewsFieldsFieldWidthType, formsViewsFieldsField, formsViewsFieldsFileUploadField, formsViewsFieldsImageUploadField, formsViewsFieldsInlineForm, formsViewsFieldsInlineSearchField, formsViewsFieldsInputTableField, formsViewsFieldsInputTableItemDefault, formsViewsFieldsInputTableItemView, formsViewsFieldsInputTableView, formsViewsFieldsJsonTextareaField, formsViewsFieldsKeyFingerprintField, formsViewsFieldsMultiSubformsField, formsViewsFieldsNestedForm, formsViewsFieldsNestedModelForm, formsViewsFieldsNumberField, formsViewsFieldsOptionSelectorBaseField, formsViewsFieldsPhoneField, formsViewsFieldsPhoneLocaleField, formsViewsFieldsRadiosField, formsViewsFieldsRatingField, formsViewsFieldsStyledSelect, formsViewsFieldsTextareaField, formsViewsFieldsToggleField, formsViewsFieldsTogglesField, formsViewsFieldsTranslationsField, formsViewsFieldsUrlField, formsViewsFieldsValidationMessages, formsViewsFieldsValidators, formsViewsFieldsZipcodeField, formsViewsCheckboxBar, formsViewsCheckboxGrid, formsViewsCheckbox, formsViewsEmailDomainSelectView, formsViewsErrorHandler, formsViewsFieldset, formsViewsFileUpload, formsViewsFileUploads, formsViewsHelpTooltip, formsViewsImageUploadPreview, formsViewsForm, formsViewsImageUpload, formsViewsInlineSearchInput, formsViewsJsonTextareaInput, formsViewsKeyFingerprint, formsViewsMultiSubformsEntry, formsViewsMultiSubforms, formsViewsOptionSelectorBase, formsViewsOptionSelectorGrid, formsViewsRadioBar, formsViewsRadioGrid, formsViewsRadio, formsViewsRatingInput, formsViewsSearchInput, formsViewsSelectInput, formsViewsTextInput, formsViewsTextareaInput, formsViewsToggleGrid, formsViewsToggle, formsViewsTranslationsInput, formsViewsDateInput, formsViewsColorInput, formsViewsClearableTextInput, gridCellsFormsSelectCell, gridCellsFormsTextInputCell, gridCellsActionCell, gridCellsActionDropdownCell, gridCellsApplicationCell, gridCellsBadgeCell, gridCellsBadgesCell, gridCellsBoldCell, gridCellsCheckboxCell, gridCellsCheckboxHeaderCell, gridCellsDateCell, gridCellsFootnoteCell, gridCellsImageCell, gridCellsLogoCell, gridCellsLinkCell, gridCellsStatusCell, gridCellsRadioCell, gridCellsStatusEnabledCell, gridCellsSummaryCell, gridCellsToggleCell, gridFormattersDateFormatter, gridRowsClickableRow, gridRowsOptionSelectorRow, gridRowsRadioRow, gridRowsToggleRow, gridGrid, gridNoHeaderGrid, iconsViewsTagIcons, layoutsSidebarLeft, layoutsSidebarContent, layoutsSidebarRight, loadingPagespinner, modalsViewsModal, modelsRelationalModel, navigationViewsNavigationview, navigationNavigation, navigationsEditorEditor, navigationsFooterViewsFooterDropdown, navigationsFooterViewsFooterNavItem, navigationsFooterViewsFooterText, navigationsFooterViewsFooterNav, navigationsFooterFooter, navigationsHeaderMastheadViewsLinkItem, navigationsHeaderMastheadViewsLogoItem, navigationsHeaderMastheadHeaderMasthead, navigationsHeaderPrimaryViewsDropdownItem, navigationsHeaderPrimaryViewsLinkItem, navigationsHeaderPrimaryViewsLogoItem, navigationsHeaderPrimaryViewsTextItem, navigationsHeaderPrimaryHeaderNavigationPrimary, navigationsHeaderSecondaryViewsDropdownItem, navigationsHeaderSecondaryViewsHeaderItem, navigationsHeaderSecondaryViewsLinkItem, navigationsHeaderSecondaryViewsSearchItem, navigationsHeaderSecondaryHeaderNavigationSecondary, navigationsHeaderTertiaryViewsLinkItem, navigationsHeaderTertiaryHeaderNavigationTertiary, navigationsModelsBaseModel, navigationsModelsClientPagedCollection, navigationsModelsPagedCollection, navigationsModelsHeaderPagedCollection, navigationsViewsBaseNavigation, navigationsViewsBreadcrumbs, navigationsViewsDropdownNavigationItem, navigationsViewsDropdownNavigation, navigationsViewsHeaderVerticalNavigation, navigationsViewsHeaderVerticalNavigationItem, navigationsViewsMultipleHeaderVerticalNavigation, navigationsViewsNumberedStep, navigationsViewsOldBreadcrumbs, navigationsViewsPageNavigation, navigationsViewsStep, navigationsViewsSteps, navigationsViewsTabs, navigationsViewsVerticalContentNavItem, navigationsViewsVerticalContentNav, navigationsViewsVerticalNavigationItem, navigationsViewsVerticalNavigation, patternsCardViewsApplicationCard, patternsPagedgridViewsGridFilters, patternsPagedgridViewsTotalCount, patternsPagedgridPagedGrid, patternsCategorySelectViewsCategories, patternsCategorySelectViewsCategoryItem, patternsCategorySelectViewsOptions, patternsCategorySelectViewsTags, patternsCategorySelectCategorySelect, statusViewsBadge, statusViewsBadges, statusViewsProgress, statusViewsRating, statusViewsStatus, tableControllersTablecontroller, tableViewsTableview, tableTable, uiDatePicker, uiRibbon, utilsCountriesAustralianstates, utilsCountriesCountries, utilsCountriesGermanstates, utilsCountriesMexicanstates, utilsCountriesProvinces, utilsCountriesStates, utilsCountriesSwitzerlandcantons, utilsCountriesZipCodeValidation, utilsCountriesZipCodeFormatter, utilsBindAllEntityEvents, utilsBrowserUtil, utilsBubbleEvent, utilsColorUtils, utilsCollectionUtil, utilsDomUtils, utilsFileDownload, utilsFileUploader, utilsFindTranslation, utilsGenerateSelectorHash, utilsHateoasParse, utilsScrollTo, utilsSetReqresHandlers, utilsVideoservicetype, utilsVideoutils, utilsXhrErrorParser, utilsTooltipUtil, videoViewsPlayer, guidedTooltipGuidedTooltip, layoutManagerManagedRegion, layoutManagerLayoutManager, merchandisingBadgesBadge, merchandisingBadgesBadges) {
    'use strict';
    return {
        behaviors: {
            CharCountdown: behaviorsCharCountdown,
            ComplexTooltip: behaviorsComplexTooltip,
            InfiniteScroll: behaviorsInfiniteScroll,
            Alert: behaviorsAlert,
            Loading: behaviorsLoading,
            SimpleTooltip: behaviorsSimpleTooltip,
            Sized: behaviorsSized
        },
        buttons: {
            views: { ButtonSpacer: buttonsViewsButtonSpacer },
            ButtonToolbar: buttonsButtonToolbar,
            Button: buttonsButton,
            CombinedToolbar: buttonsCombinedToolbar,
            DropdownButton: buttonsDropdownButton,
            PagerToolbar: buttonsPagerToolbar,
            Tag: buttonsTag,
            Tags: buttonsTags,
            ToggleButton: buttonsToggleButton,
            ToggleToolbar: buttonsToggleToolbar,
            TooltipTrigger: buttonsTooltipTrigger
        },
        containers: {
            models: {
                Alert: containersModelsAlert,
                Comments: containersModelsComments
            },
            views: {
                Accordion: containersViewsAccordion,
                AdvancedContainer: containersViewsAdvancedContainer,
                Alert: containersViewsAlert,
                BundleSliderContent: containersViewsBundleSliderContent,
                BundleSliderV2: containersViewsBundleSliderV2,
                BundleSlider: containersViewsBundleSlider,
                Bundle: containersViewsBundle,
                CarouselAppContent: containersViewsCarouselAppContent,
                Carousel: containersViewsCarousel,
                Collapser: containersViewsCollapser,
                Container: containersViewsContainer,
                DescriptionList: containersViewsDescriptionList,
                FeatureSliderAppContentTooltip: containersViewsFeatureSliderAppContentTooltip,
                FeatureSliderAppContent: containersViewsFeatureSliderAppContent,
                FeatureSlider: containersViewsFeatureSlider,
                FeatureSliderV2: containersViewsFeatureSliderV2,
                FlatRegion: containersViewsFlatRegion,
                Header: containersViewsHeader,
                HtmlContent: containersViewsHtmlContent,
                InlineSearchResults: containersViewsInlineSearchResults,
                Logo: containersViewsLogo,
                SliderDummyViewAllUrlItem: containersViewsSliderDummyViewAllUrlItem,
                SliderPage: containersViewsSliderPage,
                SliderV2: containersViewsSliderV2,
                Placeholder: containersViewsPlaceholder,
                Slider: containersViewsSlider,
                ThreadedCommentEditForm: containersViewsThreadedCommentEditForm,
                ThreadedCommentReplyForm: containersViewsThreadedCommentReplyForm,
                ThreadedComments: containersViewsThreadedComments,
                ThreadedComment: containersViewsThreadedComment
            }
        },
        forms: {
            views: {
                fields: {
                    BaseSubviewField: formsViewsFieldsBaseSubviewField,
                    BooleanStyledSelect: formsViewsFieldsBooleanStyledSelect,
                    CategorySelectField: formsViewsFieldsCategorySelectField,
                    CheckboxesField: formsViewsFieldsCheckboxesField,
                    ClearableTextField: formsViewsFieldsClearableTextField,
                    ColorField: formsViewsFieldsColorField,
                    CustomViewField: formsViewsFieldsCustomViewField,
                    CountryField: formsViewsFieldsCountryField,
                    DateField: formsViewsFieldsDateField,
                    EmailDomainSelectField: formsViewsFieldsEmailDomainSelectField,
                    FieldWidthType: formsViewsFieldsFieldWidthType,
                    Field: formsViewsFieldsField,
                    FileUploadField: formsViewsFieldsFileUploadField,
                    ImageUploadField: formsViewsFieldsImageUploadField,
                    InlineForm: formsViewsFieldsInlineForm,
                    InlineSearchField: formsViewsFieldsInlineSearchField,
                    InputTableField: formsViewsFieldsInputTableField,
                    InputTableItemDefault: formsViewsFieldsInputTableItemDefault,
                    InputTableItemView: formsViewsFieldsInputTableItemView,
                    InputTableView: formsViewsFieldsInputTableView,
                    JsonTextareaField: formsViewsFieldsJsonTextareaField,
                    KeyFingerprintField: formsViewsFieldsKeyFingerprintField,
                    MultiSubformsField: formsViewsFieldsMultiSubformsField,
                    NestedForm: formsViewsFieldsNestedForm,
                    NestedModelForm: formsViewsFieldsNestedModelForm,
                    NumberField: formsViewsFieldsNumberField,
                    OptionSelectorBaseField: formsViewsFieldsOptionSelectorBaseField,
                    PhoneField: formsViewsFieldsPhoneField,
                    PhoneLocaleField: formsViewsFieldsPhoneLocaleField,
                    RadiosField: formsViewsFieldsRadiosField,
                    RatingField: formsViewsFieldsRatingField,
                    StyledSelect: formsViewsFieldsStyledSelect,
                    TextareaField: formsViewsFieldsTextareaField,
                    ToggleField: formsViewsFieldsToggleField,
                    TogglesField: formsViewsFieldsTogglesField,
                    TranslationsField: formsViewsFieldsTranslationsField,
                    UrlField: formsViewsFieldsUrlField,
                    ValidationMessages: formsViewsFieldsValidationMessages,
                    Validators: formsViewsFieldsValidators,
                    ZipcodeField: formsViewsFieldsZipcodeField
                },
                CheckboxBar: formsViewsCheckboxBar,
                CheckboxGrid: formsViewsCheckboxGrid,
                Checkbox: formsViewsCheckbox,
                EmailDomainSelectView: formsViewsEmailDomainSelectView,
                ErrorHandler: formsViewsErrorHandler,
                Fieldset: formsViewsFieldset,
                FileUpload: formsViewsFileUpload,
                FileUploads: formsViewsFileUploads,
                HelpTooltip: formsViewsHelpTooltip,
                ImageUploadPreview: formsViewsImageUploadPreview,
                Form: formsViewsForm,
                ImageUpload: formsViewsImageUpload,
                InlineSearchInput: formsViewsInlineSearchInput,
                JsonTextareaInput: formsViewsJsonTextareaInput,
                KeyFingerprint: formsViewsKeyFingerprint,
                MultiSubformsEntry: formsViewsMultiSubformsEntry,
                MultiSubforms: formsViewsMultiSubforms,
                OptionSelectorBase: formsViewsOptionSelectorBase,
                OptionSelectorGrid: formsViewsOptionSelectorGrid,
                RadioBar: formsViewsRadioBar,
                RadioGrid: formsViewsRadioGrid,
                Radio: formsViewsRadio,
                RatingInput: formsViewsRatingInput,
                SearchInput: formsViewsSearchInput,
                SelectInput: formsViewsSelectInput,
                TextInput: formsViewsTextInput,
                TextareaInput: formsViewsTextareaInput,
                ToggleGrid: formsViewsToggleGrid,
                Toggle: formsViewsToggle,
                TranslationsInput: formsViewsTranslationsInput,
                DateInput: formsViewsDateInput,
                ColorInput: formsViewsColorInput,
                ClearableTextInput: formsViewsClearableTextInput
            }
        },
        grid: {
            cells: {
                forms: {
                    SelectCell: gridCellsFormsSelectCell,
                    TextInputCell: gridCellsFormsTextInputCell
                },
                ActionCell: gridCellsActionCell,
                ActionDropdownCell: gridCellsActionDropdownCell,
                ApplicationCell: gridCellsApplicationCell,
                BadgeCell: gridCellsBadgeCell,
                BadgesCell: gridCellsBadgesCell,
                BoldCell: gridCellsBoldCell,
                CheckboxCell: gridCellsCheckboxCell,
                CheckboxHeaderCell: gridCellsCheckboxHeaderCell,
                DateCell: gridCellsDateCell,
                FootnoteCell: gridCellsFootnoteCell,
                ImageCell: gridCellsImageCell,
                LogoCell: gridCellsLogoCell,
                LinkCell: gridCellsLinkCell,
                StatusCell: gridCellsStatusCell,
                RadioCell: gridCellsRadioCell,
                StatusEnabledCell: gridCellsStatusEnabledCell,
                SummaryCell: gridCellsSummaryCell,
                ToggleCell: gridCellsToggleCell
            },
            formatters: { DateFormatter: gridFormattersDateFormatter },
            rows: {
                ClickableRow: gridRowsClickableRow,
                OptionSelectorRow: gridRowsOptionSelectorRow,
                RadioRow: gridRowsRadioRow,
                ToggleRow: gridRowsToggleRow
            },
            Grid: gridGrid,
            NoHeaderGrid: gridNoHeaderGrid
        },
        icons: { views: { TagIcons: iconsViewsTagIcons } },
        layouts: {
            SidebarLeft: layoutsSidebarLeft,
            SidebarContent: layoutsSidebarContent,
            SidebarRight: layoutsSidebarRight
        },
        loading: { PageSpinner: loadingPagespinner },
        modals: { views: { Modal: modalsViewsModal } },
        models: { RelationalModel: modelsRelationalModel },
        navigation: {
            views: { NavigationView: navigationViewsNavigationview },
            Navigation: navigationNavigation
        },
        navigations: {
            editor: { Editor: navigationsEditorEditor },
            footer: {
                views: {
                    FooterDropdown: navigationsFooterViewsFooterDropdown,
                    FooterNavItem: navigationsFooterViewsFooterNavItem,
                    FooterText: navigationsFooterViewsFooterText,
                    FooterNav: navigationsFooterViewsFooterNav
                },
                Footer: navigationsFooterFooter
            },
            header: {
                masthead: {
                    views: {
                        LinkItem: navigationsHeaderMastheadViewsLinkItem,
                        LogoItem: navigationsHeaderMastheadViewsLogoItem
                    },
                    HeaderMasthead: navigationsHeaderMastheadHeaderMasthead
                },
                primary: {
                    views: {
                        DropdownItem: navigationsHeaderPrimaryViewsDropdownItem,
                        LinkItem: navigationsHeaderPrimaryViewsLinkItem,
                        LogoItem: navigationsHeaderPrimaryViewsLogoItem,
                        TextItem: navigationsHeaderPrimaryViewsTextItem
                    },
                    HeaderNavigationPrimary: navigationsHeaderPrimaryHeaderNavigationPrimary
                },
                secondary: {
                    views: {
                        DropdownItem: navigationsHeaderSecondaryViewsDropdownItem,
                        HeaderItem: navigationsHeaderSecondaryViewsHeaderItem,
                        LinkItem: navigationsHeaderSecondaryViewsLinkItem,
                        SearchItem: navigationsHeaderSecondaryViewsSearchItem
                    },
                    HeaderNavigationSecondary: navigationsHeaderSecondaryHeaderNavigationSecondary
                },
                tertiary: {
                    views: { LinkItem: navigationsHeaderTertiaryViewsLinkItem },
                    HeaderNavigationTertiary: navigationsHeaderTertiaryHeaderNavigationTertiary
                }
            },
            models: {
                BaseModel: navigationsModelsBaseModel,
                ClientPagedCollection: navigationsModelsClientPagedCollection,
                PagedCollection: navigationsModelsPagedCollection,
                HeaderPagedCollection: navigationsModelsHeaderPagedCollection
            },
            views: {
                BaseNavigation: navigationsViewsBaseNavigation,
                Breadcrumbs: navigationsViewsBreadcrumbs,
                DropdownNavigationItem: navigationsViewsDropdownNavigationItem,
                DropdownNavigation: navigationsViewsDropdownNavigation,
                HeaderVerticalNavigation: navigationsViewsHeaderVerticalNavigation,
                HeaderVerticalNavigationItem: navigationsViewsHeaderVerticalNavigationItem,
                MultipleHeaderVerticalNavigation: navigationsViewsMultipleHeaderVerticalNavigation,
                NumberedStep: navigationsViewsNumberedStep,
                OldBreadcrumbs: navigationsViewsOldBreadcrumbs,
                PageNavigation: navigationsViewsPageNavigation,
                Step: navigationsViewsStep,
                Steps: navigationsViewsSteps,
                Tabs: navigationsViewsTabs,
                VerticalContentNavItem: navigationsViewsVerticalContentNavItem,
                VerticalContentNav: navigationsViewsVerticalContentNav,
                VerticalNavigationItem: navigationsViewsVerticalNavigationItem,
                VerticalNavigation: navigationsViewsVerticalNavigation
            }
        },
        patterns: {
            card: { views: { ApplicationCard: patternsCardViewsApplicationCard } },
            pagedgrid: {
                views: {
                    GridFilters: patternsPagedgridViewsGridFilters,
                    TotalCount: patternsPagedgridViewsTotalCount
                },
                PagedGrid: patternsPagedgridPagedGrid
            },
            categorySelect: {
                views: {
                    Categories: patternsCategorySelectViewsCategories,
                    CategoryItem: patternsCategorySelectViewsCategoryItem,
                    Options: patternsCategorySelectViewsOptions,
                    Tags: patternsCategorySelectViewsTags
                },
                CategorySelect: patternsCategorySelectCategorySelect
            }
        },
        status: {
            views: {
                Badge: statusViewsBadge,
                Badges: statusViewsBadges,
                Progress: statusViewsProgress,
                Rating: statusViewsRating,
                Status: statusViewsStatus
            }
        },
        table: {
            controllers: { TableController: tableControllersTablecontroller },
            views: { TableView: tableViewsTableview },
            Table: tableTable
        },
        ui: {
            DatePicker: uiDatePicker,
            Ribbon: uiRibbon
        },
        utils: {
            countries: {
                AustralianStates: utilsCountriesAustralianstates,
                Countries: utilsCountriesCountries,
                GermanStates: utilsCountriesGermanstates,
                MexicanStates: utilsCountriesMexicanstates,
                Provinces: utilsCountriesProvinces,
                States: utilsCountriesStates,
                SwitzerlandCantons: utilsCountriesSwitzerlandcantons,
                ZipCodeValidation: utilsCountriesZipCodeValidation,
                ZipCodeFormatter: utilsCountriesZipCodeFormatter
            },
            BindAllEntityEvents: utilsBindAllEntityEvents,
            BrowserUtil: utilsBrowserUtil,
            BubbleEvent: utilsBubbleEvent,
            ColorUtils: utilsColorUtils,
            CollectionUtil: utilsCollectionUtil,
            DomUtils: utilsDomUtils,
            FileDownload: utilsFileDownload,
            FileUploader: utilsFileUploader,
            FindTranslation: utilsFindTranslation,
            GenerateSelectorHash: utilsGenerateSelectorHash,
            HateoasParse: utilsHateoasParse,
            ScrollTo: utilsScrollTo,
            SetReqresHandlers: utilsSetReqresHandlers,
            VideoServiceType: utilsVideoservicetype,
            VideoUtils: utilsVideoutils,
            XhrErrorParser: utilsXhrErrorParser,
            TooltipUtil: utilsTooltipUtil
        },
        video: { views: { Player: videoViewsPlayer } },
        guidedTooltip: { GuidedTooltip: guidedTooltipGuidedTooltip },
        layoutManager: {
            ManagedRegion: layoutManagerManagedRegion,
            LayoutManager: layoutManagerLayoutManager
        },
        merchandisingBadges: {
            Badge: merchandisingBadgesBadge,
            Badges: merchandisingBadgesBadges
        }
    };
});